import { AddObjectCommand as e, BatchedGeometry as t, BatchedLineContainer as n, BatchedLineGeometry as r, BatchedLineProxy as i, BatchedMeshContainer as a, BatchedMeshProxy as o, BooleanController as s, ClearSelectionCommand as c, ColorController as l, Command as u, Debug as d, DeleteObjectCommand as f, DeveloperTool as p, GroupCommand as m, InstancedBasicMaterial as h, InstancedMeshContainer as g, InstancedMeshProxy as _, InstancedWideLineContainer as v, KeyboardShortcut as y, LoadCommand as b, LoadFilesCommand as ee, MaterialLayer as x, MaterialPropertyTexture as S, MaterialType as C, NotUndoableCommandError as te, NotificationCenter as ne, NumberController as w, ObjectImportController as re, ObjectSelection as ie, ObjectStateController as ae, RaycastSelectOperator as oe, RaycastableSceneObject as se, SceneMesh as ce, SceneMeshController as le, SceneMeshGroup as ue, SceneMeshProxy as de, SceneObject as fe, SceneObjectController as pe, SceneObjectFilters as me, SceneSpriteLegacy as he, SelectController as ge, SetObjectTransformCommand as _e, SnapMode as ve, StopLoadingCommand as ye, StringController as be, ViewerPlugin as xe, ViewerSignal as T, ViewportOperator as Se, WorkerController as Ce, __UnusedParams__ as we, assert as Te, assertNotNull as E, getCenter as Ee, getDirectionFromVectors as De, getQuaternionFromVectors as Oe, isAppleLike as ke } from "@stereograph/teiaviewer";
import { Box2 as Ae, Box3 as je, BoxGeometry as Me, BufferGeometry as Ne, CanvasTexture as Pe, Clock as Fe, Color as Ie, ConeGeometry as Le, CylinderGeometry as Re, DoubleSide as ze, EdgesGeometry as Be, Float32BufferAttribute as Ve, Group as He, InstancedBufferAttribute as Ue, InstancedBufferGeometry as We, LineBasicMaterial as D, LineCurve3 as Ge, LineSegments as Ke, LinearFilter as qe, LinearMipMapLinearFilter as Je, MathUtils as Ye, Matrix4 as O, Mesh as Xe, MeshBasicMaterial as Ze, PlaneGeometry as Qe, Points as $e, PointsMaterial as et, QuadraticBezierCurve3 as tt, Quaternion as nt, Raycaster as rt, SRGBColorSpace as it, ShaderMaterial as at, Shape as ot, ShapeGeometry as st, ShapeUtils as ct, Sphere as k, SphereGeometry as lt, Sprite as ut, SpriteMaterial as dt, TubeGeometry as ft, Vector2 as pt, Vector3 as A } from "three";
import { MeshoptDecoder as mt } from "three/examples/jsm/libs/meshopt_decoder.module.js";
import { GLTFLoader as ht } from "three/examples/jsm/loaders/GLTFLoader.js";
import j, { t as gt } from "i18next";
import { MeshBVH as _t } from "three-mesh-bvh";
import vt from "tinycolor2";
import { LatLng as yt, Map as bt, Point as xt, TileLayer as St } from "leaflet";
import { Line2 as Ct } from "three/examples/jsm/lines/Line2.js";
import { LineGeometry as wt } from "three/examples/jsm/lines/LineGeometry.js";
import { LineMaterial as Tt } from "three/examples/jsm/lines/LineMaterial.js";
import { fileTypeFromBlob as Et } from "file-type";
import { UserManager as Dt, WebStorageStateStore as Ot } from "oidc-client-ts";
import { QueryClient as kt } from "@tanstack/react-query";
//#region \0rolldown/runtime.js
var At = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), jt = (e) => ({ getSearchFilterHash(t = {}, n = [], r, i = "asc") {
	let a = e.URL("/api/search-criteria/twin/hash"), o = JSON.stringify({
		rule: t,
		fieldSelectionRules: n,
		orderBy: r,
		orderDirection: i
	}), s = new Request(a, {
		method: "POST",
		body: o,
		headers: { "Content-type": "application/json" }
	});
	return e.sendRequest(s);
} }), Mt = /* @__PURE__ */ function(e) {
	return e.Dash = "dashed", e.Solid = "solid", e;
}({}), Nt = "#FFFFFF00", Pt = [
	"Pdf",
	"Svg",
	"Dxf"
], Ft = [
	"ToDo",
	"InProgressProjection",
	"ProjectionCompleted",
	"ProjectionFailed",
	"ProjectionDegraded",
	"Expired"
], It = [
	"ToDo",
	"InProgress",
	"Completed",
	"Failed",
	"Degraded"
], Lt = [
	"top",
	"center",
	"bottom",
	"left",
	"right",
	"topleft",
	"topright",
	"bottomleft",
	"bottomright"
], Rt = (e) => ({
	getTwinPlans(t, n, r, i, a, o, s) {
		let { projectId: c, type: l } = t, u = e.URL(`${e.baseUrl}projects/${c}/floorplans`);
		if (u.searchParams.set("pageNumber", String(n)), u.searchParams.set("pageSize", String(r)), u.searchParams.set("twinProjectType", l), i && u.searchParams.set("name", i), a) for (let e of a) u.searchParams.append("status", e);
		o && u.searchParams.set("orderBy", o), s && u.searchParams.set("orderDirection", s);
		let d = new Request(u, { method: "GET" });
		return e.sendRequest(d);
	},
	addPlan(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`${e.baseUrl}projects/${r}/floorplans`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, {
			method: "POST",
			body: JSON.stringify(n),
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(o);
	},
	deletePlan(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/floorplans/${n}`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, { method: "DELETE" });
		return e.sendRequest(o);
	},
	updatePlan(t, n, r) {
		let { projectId: i, type: a } = t, o = e.URL(`${e.baseUrl}projects/${i}/floorplans/${n}`);
		o.searchParams.set("twinProjectType", a);
		let s = new Request(o, {
			method: "PUT",
			body: JSON.stringify(r),
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(s);
	},
	restartExport(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/floorplans/${n}/restart`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, { method: "POST" });
		return e.sendRequest(o);
	},
	addExport(t, n, r) {
		let { projectId: i, type: a } = t, o = e.URL(`${e.baseUrl}projects/${i}/floorplans/${n}/export`);
		o.searchParams.set("twinProjectType", a), o.searchParams.set("fileType", r);
		let s = new Request(o, { method: "POST" });
		return e.sendRequest(s);
	},
	async downloadExport(t, n, r) {
		let { projectId: i, type: a } = t, o = e.URL(`projects/${i}/floorplans/${n}/download`);
		o.searchParams.set("twinProjectType", a), o.searchParams.set("fileType", r);
		let s = new Request(o, {
			method: "GET",
			headers: { "Content-Type": "application/octet-stream" }
		}), c = await (await e.sendRequest(s)).blob();
		return URL.createObjectURL(c);
	},
	async generateAnalyze(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`${e.baseUrl}projects/${r}/floorplans/${n}/analyse`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, { method: "POST" });
		return e.sendRequest(o);
	},
	async downloadAnalyze(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/floorplans/${n}/analyse/download`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, {
			method: "GET",
			headers: { "Content-Type": "application/octet-stream" }
		}), s = await (await e.sendRequest(o)).blob();
		return URL.createObjectURL(s);
	},
	async importConfiguration(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`${e.baseUrl}projects/${r}/floorplans/configuration/import`);
		a.searchParams.set("twinProjectType", i);
		let o = new FormData();
		for (let e of n) o.append("files", e);
		let s = new Request(a, {
			method: "POST",
			body: o
		});
		await e.sendRequest(s);
	},
	async downloadConfiguration(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/floorplans/${n}/configuration/export`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, { method: "GET" }), s = await (await e.sendRequest(o)).blob();
		return URL.createObjectURL(s);
	}
}), zt = [
	"Primitive",
	"TwinBimData",
	"TwinOpenData",
	"TwinUserData",
	"TwinEquipment",
	"TwinStereographData",
	"TwinMaintenanceRequest"
], Bt = (e) => ({
	getGeometryRequest(t, n, r, i, a, o) {
		let s = e.URL(`twin/${t}/geometries`);
		if (s.searchParams.set("geometryType", a), s.searchParams.set("hash", n), s.searchParams.set("pageNumber", String(r)), s.searchParams.set("pageSize", String(i)), o) for (let e of o.toArray()) s.searchParams.append("axis", String(e));
		return {
			url: s.toString(),
			method: "GET",
			headers: { Authorization: `Bearer ${e.token}` }
		};
	},
	getGeometryInfo(t, n, r, i) {
		let a = e.URL(`twin/${t}/geometries/informations`);
		if (a.searchParams.set("geometryType", r), a.searchParams.set("hash", n), i) for (let e of i.toArray()) a.searchParams.append("axis", String(e));
		let o = new Request(a, { method: "GET" });
		return e.sendRequest(o);
	},
	getTwinObject(t, n, r = []) {
		let { id: i } = t, a = e.URL(`twin/objects/${n}`);
		a.searchParams.set("twinProjectId", String(i));
		for (let e of r) a.searchParams.set("dataFamilies", e);
		let o = new Request(a, { method: "GET" });
		return e.sendRequest(o);
	},
	getTwinObjectValues(t, n, r, i) {
		let a = e.URL("twin/objects/values");
		a.searchParams.set("twinProjectType", t.type), a.searchParams.set("hash", n), r && a.searchParams.set("pageSize", String(r)), i && a.searchParams.set("afterKey", i);
		let o = new Request(a, { method: "GET" });
		return e.sendRequest(o);
	},
	getTwinObjectFields(t, n, r, i) {
		let a = e.URL("twin/objects/fields");
		a.searchParams.set("twinProjectIds", String(t.id)), a.searchParams.set("twinProjectTypes", t.type), a.searchParams.set("dataFamilies", n), a.searchParams.set("pageSize", String(i)), a.searchParams.set("pageNumber", String(r));
		let o = new Request(a, { method: "GET" });
		return e.sendRequest(o);
	},
	async getTwinTreeView(t, n) {
		let r = e.URL("twin/objects/treeview");
		r.searchParams.set("twinProjectId", t.toString());
		let i = new Request(r, {
			method: "GET",
			signal: n
		});
		return (await e.sendRequest(i)).json();
	},
	search(t, n, r) {
		let i = e.URL("twin/objects/search/");
		i.searchParams.set("hash", t), i.searchParams.set("pageNumber", String(n)), i.searchParams.set("pageSize", String(r));
		let a = new Request(i, { method: "GET" });
		return e.sendRequest(a);
	},
	flattenedObjectProperties_deprecated(t) {
		let { projectId: n, type: r } = t, i = e.URL(`projects/${n}/twin/objects/flattened-object-properties`);
		i.searchParams.set("twinProjectType", r);
		let a = new Request(i, { method: "GET" });
		return e.sendRequest(a);
	}
}), Vt = class {
	constructor(e) {
		if (this._projectionPoint = new A(), this._projectedPoint = new pt(), e.lengthSq() === 0) throw Error("Floor-plan direction must not be zero");
		this.normal = e.clone().normalize().negate();
		let t = new A(0, 1, 0);
		Math.abs(this.normal.dot(t)) > .99 && t.set(1, 0, 0), this.u = t.clone().addScaledVector(this.normal, -t.dot(this.normal)).normalize(), this.v = new A().crossVectors(this.normal, this.u).normalize(), this.u.crossVectors(this.v, this.normal).normalize();
	}
	_projectPoint(e) {
		return this._projectedPoint.set(e.dot(this.u), e.dot(this.v));
	}
	expandBounds(e, t = new Ae()) {
		for (let n = 0; n <= 1; n++) for (let r = 0; r <= 1; r++) for (let i = 0; i <= 1; i++) this._projectionPoint.set(n ? e.max.x : e.min.x, r ? e.max.y : e.min.y, i ? e.max.z : e.min.z), t.expandByPoint(this._projectPoint(this._projectionPoint));
		return t;
	}
}, Ht = /* @__PURE__ */ new pt(), Ut = /* @__PURE__ */ new je(), Wt = /* @__PURE__ */ new Ae(), Gt = .4;
function M(e) {
	return "geometry" in e && e.geometry instanceof Ne;
}
function Kt(e, t, n) {
	Ut.setFromObject(e), Wt.makeEmpty(), n.expandBounds(Ut, Wt);
	let { min: r, max: i } = Wt, a = (r.x + i.x) / 2, o = (r.y + i.y) / 2;
	switch (t) {
		case "topleft": return Ht.set(i.x, r.y);
		case "topright": return Ht.set(i.x, i.y);
		case "bottomleft": return Ht.set(r.x, r.y);
		case "bottomright": return Ht.set(r.x, i.y);
		case "top": return Ht.set(i.x, o);
		case "bottom": return Ht.set(r.x, o);
		case "left": return Ht.set(a, r.y);
		case "right": return Ht.set(a, i.y);
		case "center": return Ht.set(a, o);
		default: return Ht.set(a, o);
	}
}
function qt(e, t) {
	return t.propertyName === e.propertyName && t.name === e.name ? t.value : "";
}
function N(e, t) {
	return t.key === e.key ? t.value : "";
}
function P(e, t) {
	return t.applicationName !== e.applicationName || !t.value ? "" : t.value.find((t) => t.key === e.key)?.value ?? "";
}
function F(e, t) {
	switch (e.family) {
		case "TwinBimData": return qt(e, t);
		case "TwinOpenData": return N(e, t);
		case "TwinUserData": return P(e, t);
		default: return "";
	}
}
function Jt(e, t) {
	let n = "";
	if (t) {
		for (let r of t) if (n = F(e.field, r), n !== "") break;
	}
	return `${e.prefix}${n}${e.suffix}`;
}
async function Yt(e, t, n) {
	let r = new Vt(n), i = new ht();
	i.setMeshoptDecoder(mt);
	let a = await e.arrayBuffer(), o = await i.parseAsync(a, ""), s = [], c = [], l = [];
	return o.scene?.traverse((e) => {
		M(e) && (c.push(e.geometry), l.push(e.matrixWorld));
		let n = e.userData.stereograph;
		if (!n || (Ut.setFromObject(e), Ut.isEmpty())) return;
		let i = /* @__PURE__ */ new Map();
		for (let a of t.annotations) {
			let t = n[a.field.family[0].toLowerCase() + a.field.family.slice(1)], o = Jt(a, t), s = Kt(e, a.position, r), c = i.get(a.position);
			c ??= [], c.push({
				fontColor: a.fontColor,
				fontSize: a.fontSize,
				x: s.x,
				y: s.y,
				text: o
			}), i.set(a.position, c);
		}
		for (let [, e] of i) e.forEach((e, t) => {
			let n = e.x - t * Gt, r = e.y;
			s.push({
				fontColor: e.fontColor,
				fontSize: e.fontSize,
				x: n,
				y: r,
				text: e.text
			});
		});
	}), {
		annotations: s,
		geometries: c,
		matrices: l
	};
}
//#endregion
//#region src/FloorPlanPlugin/command/AddFloorPlanCommand.ts
var Xt = /* @__PURE__ */ new A(), Zt = class extends e {
	constructor(e, t, n, r = {}) {
		super(e, r), this._twin = t, this._floorPlanConfig = n, this.name = "AddFloorPlanCommand";
	}
	async getBlob(e, t, n) {
		let r = Bt(this.viewer.getPlugin("Teia").twinApiClient).getGeometryRequest("objects", e, t, n, "2D", Xt.fromArray(this._floorPlanConfig.direction)), i = new Request(r.url, { ...r }), a = await fetch(i);
		return a.ok ? await a.blob() : (console.warn("FloorPlan: Unable to load geometry page", {
			pageNumber: t,
			status: a.status,
			statusText: a.statusText
		}), null);
	}
	async getHash(e) {
		let t = jt(this.viewer.getPlugin("Teia").twinApiClient), n = this._twin.id, r = e.rule, i = [];
		for (let t of e.annotations) i.push(t.field);
		return await t.getSearchFilterHash({
			condition: "And",
			rules: [{
				type: "TwinProject",
				operator: "EqualTo",
				value: n
			}, r]
		}, i);
	}
	async _createObject() {
		let e = this.viewer.getPlugin("Teia"), t = this.viewer.getPlugin("FloorPlan"), n = e.settings.objectsPerRequest.value, r = [];
		for (let e of this._floorPlanConfig.floorPlanLayers) {
			let t = await this.getHash(e), i = {
				id: this._twin.id,
				geometries: [],
				matrices: [],
				annotations: [],
				config: {
					lineColor: e.lineColor,
					lineWidth: e.lineWidth,
					lineType: e.lineType,
					fillColor: e.fillColor ?? "#FFFFFF00",
					order: e.order
				}
			}, a = 0;
			for (let r = 0; r < this._floorPlanConfig.totalObjectCount; r += n) {
				a += 1;
				let r = await this.getBlob(t, a, n);
				if (!r) continue;
				let { annotations: o, geometries: s, matrices: c } = await Yt(r, e, Xt.fromArray(this._floorPlanConfig.direction));
				i.geometries.push(...s), i.matrices.push(...c), i.annotations.push(...o);
			}
			r.push(i);
		}
		return t.floorPlanController.createFloorPlan(this._floorPlanConfig.direction, this._floorPlanConfig.id, this._floorPlanConfig.name, r);
	}
	async _clean() {
		this._object &&= (this._object.dispose(), null);
	}
}, Qt = class extends ue {
	constructor(e) {
		super(), this.id = e, this.isSceneFloorPlan = !0, this.transformConfig = {
			...this.transformConfig,
			scale: {
				x: !1,
				y: !1,
				z: !1
			}
		};
	}
	get opacity() {
		return 1;
	}
	set opacity(e) {
		super.opacity = e;
	}
	raycast(e, t) {
		let n = this.meshes, r = [];
		for (let t of n) t.raycast(e, r);
		for (let e of r) t.push({
			object: this,
			distance: e.distance,
			point: e.point,
			rayDistance: 0
		});
	}
}, $t = (e) => {
	let { hitObject: t, viewer: n } = e, r = [];
	return t && t.isSceneFloorPlan && r.push({
		type: "group",
		text: "Export Plan",
		items: [{
			type: "action",
			text: gt("teia.context_menu.remove_projection.text", { ns: "teiaviewer" }),
			action: () => {
				new f(n, t).execute();
			}
		}]
	}), r;
}, en = .04, I = 1.1, tn = 50;
function nn(e) {
	return I * e;
}
function rn(e) {
	return tn * e;
}
function an(e, t) {
	let n = document.createElement("canvas").getContext("2d");
	if (!n) throw Error("Unable to measure floor-plan annotations: 2D canvas is unavailable");
	let r = nn(t), i = rn(t);
	return e.map((e) => {
		n.font = `${e.fontSize * r}px serif`;
		let t = n.measureText(e.text), a = e.fontSize * r;
		return {
			annotation: e,
			halfWidth: ((t.actualBoundingBoxAscent ?? a) + (t.actualBoundingBoxDescent ?? 0)) / (i * 2),
			halfHeight: t.width / (i * 2)
		};
	});
}
function L(e, t, n, r, i) {
	let a = 0, o = 0;
	for (let t of e) a = Math.max(a, t.halfWidth), o = Math.max(o, t.halfHeight);
	let s = en + a, c = en + o, l = (r - 1) / i, u = l - s * 2, d = l - c * 2;
	if (u <= 0 || d <= 0) throw Error("An annotation is too large to fit in the maximum texture size");
	return {
		columnCount: Math.max(1, Math.ceil((n.x - t.x) / u)),
		rowCount: Math.max(1, Math.ceil((n.y - t.y) / d)),
		tileWidth: u,
		tileHeight: d
	};
}
function on(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let i of e) {
		let e = Math.min(n.columnCount - 1, Math.max(0, Math.floor((i.annotation.x - t.x) / n.tileWidth))), a = Math.min(n.rowCount - 1, Math.max(0, Math.floor((i.annotation.y - t.y) / n.tileHeight))) * n.columnCount + e, o = r.get(a) ?? [];
		o.push(i), r.set(a, o);
	}
	return r;
}
function sn(e, t, n) {
	let r = Infinity, i = Infinity, a = -Infinity, o = -Infinity;
	for (let t of e) r = Math.min(r, t.annotation.x - t.halfWidth), i = Math.min(i, t.annotation.y - t.halfHeight), a = Math.max(a, t.annotation.x + t.halfWidth), o = Math.max(o, t.annotation.y + t.halfHeight);
	let s = new Ae(new pt(r - en, i - en), new pt(a + en, o + en)), c = Math.ceil((s.max.x - s.min.x) * n), l = Math.ceil((s.max.y - s.min.y) * n);
	if (c > t || l > t) throw Error("An annotation tile is too large to fit in the maximum texture size");
	return {
		bounds: s,
		annotations: e.map((e) => e.annotation)
	};
}
function cn(e, t, n, r, i) {
	let a = rn(i), o = an(e, i), s = on(o, t, L(o, t, n, r, a)), c = [];
	for (let e of s.values()) c.push(sn(e, r, a));
	return c;
}
//#endregion
//#region src/FloorPlanPlugin/core/annotationTextureUtils.ts
function ln(e, t, n) {
	let r = document.createElement("canvas");
	return r.width = Math.min(Math.ceil(e.x * t), Math.floor(n)), r.height = Math.min(Math.ceil(e.y * t), Math.floor(n)), r;
}
function un(e, t, n, r, i) {
	for (let a of t.annotations) {
		e.font = `${a.fontSize * i}px serif`, e.fillStyle = a.fontColor;
		let o = (a.x - t.bounds.min.x) * n, s = (a.y - t.bounds.min.y) * r, c = e.measureText(a.text), l = a.fontSize * i, u = (c.actualBoundingBoxAscent ?? l) + (c.actualBoundingBoxDescent ?? 0), d = o - c.width / 2, f = s + u / 2;
		e.save(), e.translate(o, s), e.scale(-1, -1), e.rotate(-Math.PI / 2), e.fillText(a.text, d - o, f - s), e.restore();
	}
}
function dn(e, t, n, r, i) {
	let a = ln(t, n, r), o = a.getContext("2d");
	if (!o) throw Error("Unable to render floor-plan annotations: 2D canvas is unavailable");
	un(o, e, a.width / t.x, a.height / t.y, nn(i));
	let s = new Pe(a);
	return s.flipY = !1, s.generateMipmaps = !0, s.magFilter = qe, s.minFilter = Je, s.needsUpdate = !0, s;
}
//#endregion
//#region src/FloorPlanPlugin/core/SceneFloorPlanAnnotationTile.ts
var fn = -.02, pn = /* @__PURE__ */ new A(), mn = /* @__PURE__ */ new pt(), hn = class {
	constructor(e, t, n, r, i) {
		let a = e.bounds.getSize(mn), o = new Qe(a.x, a.y), s = dn(e, a, n, r, i), c = new Ze({
			color: 16777215,
			alphaTest: .01,
			depthWrite: !0,
			map: s,
			side: ze,
			transparent: !0
		});
		c.forceSinglePass = !0, this.mesh = new Xe(o, c);
		let { u: l, v: u, normal: d } = t, f = (e.bounds.min.x + e.bounds.max.x) / 2, p = (e.bounds.min.y + e.bounds.max.y) / 2;
		pn.copy(l).multiplyScalar(f).addScaledVector(u, p).addScaledVector(d, fn), this.mesh.matrix.makeBasis(l, u, d), this.mesh.matrix.setPosition(pn), this.mesh.matrixAutoUpdate = !1;
	}
	setMaterialLayer(e) {
		this.mesh.layers.set(e);
	}
	dispose() {
		this.mesh.geometry.dispose(), this.mesh.material.map?.dispose(), this.mesh.material.dispose(), this.mesh.removeFromParent();
	}
}, gn = class {
	constructor(e, t, n, r, i, a) {
		this.plane = new He(), this.tiles = [];
		let o = cn(e, t, n, i, a), s = rn(a);
		for (let e of o) {
			let t = new hn(e, r, s, i, a);
			this.tiles.push(t), this.plane.add(t.mesh);
		}
		this.plane.matrixAutoUpdate = !1;
	}
	setMatrix(e) {
		this.plane.matrix.copy(e), this.plane.matrixWorldNeedsUpdate = !0;
	}
	setMaterialLayer(e) {
		for (let t of this.tiles) t.setMaterialLayer(e);
	}
	dispose() {
		for (let e of this.tiles) e.dispose();
		this.tiles.length = 0;
	}
}, _n = /* @__PURE__ */ new O(), vn = /* @__PURE__ */ new O(), yn = /* @__PURE__ */ new A(), R = /* @__PURE__ */ new nt(), bn = /* @__PURE__ */ new A(), xn = /* @__PURE__ */ new A(), Sn = .04, Cn = class extends ue {
	constructor(e, t, n, r, i, a, o) {
		super(), this.lineContainer = t, this.direction = n, this.config = r, this.index = i, this.maxAnnotationTextureSize = a, this.annotationQualityScale = o, this.sceneAnnotations = null, this.layerMatrix = new O(), this.isOverlayActive = !1, this.meshContainer = e, this.projectionFrame = new Vt(this.direction), this.layerMatrix.identity();
	}
	setMatrix(e) {
		return e.decompose(yn, R, bn), yn.add(this.getTranslationVector(xn)), vn.compose(yn, R, bn), this.layerMatrix.copy(vn), this.sceneAnnotations?.setMatrix(this.layerMatrix), super.setMatrix(this.layerMatrix);
	}
	get annotationsMesh() {
		return this.sceneAnnotations?.plane;
	}
	set visible(e) {
		super.visible = e, this.annotationsMesh && (this.annotationsMesh.visible = e);
	}
	get visible() {
		return super.visible;
	}
	set selected(e) {
		super.selected = e, this.setAnnotationsLayer();
	}
	get selected() {
		return super.selected;
	}
	getTranslationVector(e) {
		return e.set(-this.direction.x * Sn * this.index, -this.direction.y * Sn * this.index, -this.direction.z * Sn * this.index);
	}
	setAnnotationsLayer() {
		this.selected && this.isOverlayActive ? this.sceneAnnotations?.setMaterialLayer(x.SelectedObject) : this.sceneAnnotations?.setMaterialLayer(x.Base);
	}
	setupLayer(e, t, n, r) {
		let i = 0;
		for (let r of e) this.addGeometry(r, t[i], n[i]), i++;
		if (r.length > 0) {
			let t = this.getLayerProjectionBounds(e);
			this.sceneAnnotations = new gn(r, t.min, t.max, this.projectionFrame, this.maxAnnotationTextureSize, this.annotationQualityScale), this.sceneAnnotations.plane.traverse((e) => {
				e.renderOrder = 1;
			}), this.sceneAnnotations.setMatrix(this.layerMatrix);
		}
		this.setMatrix(vn.identity());
	}
	addGeometry(e, t, n) {
		e.applyMatrix4(n), e.computeBoundingBox();
		let r = this.meshContainer.geometry.addGeometry(e), i = new o(this.meshContainer, r, e.uuid);
		t.applyMatrix4(n), t.computeBoundingBox();
		let a = t.getAttribute("position"), s = null;
		if (a?.count) {
			let e = vt(this.config.lineColor);
			s = this.lineContainer.createProxy(t, e.toHexString(), e.getAlpha());
		}
		let c = new _t(e, { useSharedArrayBuffer: !0 });
		this.meshContainer.registerBVH(e.uuid, c);
		let l = new de(i, s);
		l.setMatrix(_n), this.setupProxy(l), this.addSubMesh(l), l.active = !0;
	}
	setupProxy(e) {
		let t = vt(this.config.fillColor);
		e.diffuseColor = t.toHexString(), e.opacity = t.getAlpha();
	}
	getLayerProjectionBounds(e) {
		let t = new Ae();
		for (let n of e) {
			n.boundingBox || n.computeBoundingBox();
			let e = n.boundingBox;
			e && this.projectionFrame.expandBounds(e, t);
		}
		return t;
	}
	dispose() {
		super.dispose(), this.meshes.forEach((e) => e.dispose()), this.lineContainer.dispose(), this.sceneAnnotations?.dispose(), this.sceneAnnotations = null;
	}
}, wn = class extends le {
	constructor(e, t, n) {
		super(e), this.getMaxAnnotationTextureSize = t, this.getAnnotationQualityScale = n, this.isSceneFloorPlanController = !0;
	}
	onSceneSetup(e) {
		for (let t of this._objects.values()) for (let n of t.meshes) e.addInternalObject(n.meshContainer.root), e.addInternalObject(n.lineContainer.root), n.annotationsMesh && e.addInternalObject(n.annotationsMesh);
	}
	onSceneClear(e) {
		for (let t of this._objects.values()) for (let n of t.meshes) e.removeInternalObject(n.meshContainer.root), e.removeInternalObject(n.lineContainer.root), n.annotationsMesh && e.removeInternalObject(n.annotationsMesh);
	}
	accepts(e) {
		return e.isSceneFloorPlan;
	}
	*meshContainers() {
		for (let e of this._objects.values()) for (let t of e.meshes) yield t.meshContainer;
	}
	*lineContainers() {}
	*edgesContainers() {}
	addObject(e, t) {
		for (let t of e.meshes) this._viewer.scene.addInternalObject(t.meshContainer.root), this._viewer.scene.addInternalObject(t.lineContainer.root), t.annotationsMesh && this._viewer.scene.addInternalObject(t.annotationsMesh);
		this._viewer.scene.addObjectIntoBoxTree(e), super.addObject(e, t);
	}
	removeObject(e) {
		for (let t of e.meshes) this._viewer.scene.removeInternalObject(t.meshContainer.root), this._viewer.scene.removeInternalObject(t.lineContainer.root), t.annotationsMesh && this._viewer.scene.removeInternalObject(t.annotationsMesh);
		this._viewer.scene.removeObjectFromBoxTree(e), super.removeObject(e);
	}
	_createLayer(e, n, r) {
		let { geometries: i, matrices: o } = e;
		if (i.length === 0) return null;
		let s = [], c = [], l = 0, u = 0, d = 0;
		for (let e of i) {
			let t = new Be(e, 70);
			s.push(e.clone()), c.push(t), l += e.attributes.position.count, e.index && (u += e.index.count), d += t.attributes.position.count / 2;
		}
		let f = new t({
			useIndex: !0,
			maxGeometryCount: s.length,
			maxVertexCount: l,
			maxIndexCount: u
		}), p = new S(s.length, {
			opacity: "float",
			diffuse: "vec3"
		}), m = new a(s.length, f, this._getMeshMaterials(p)), h = new v({
			maxProxyCount: s.length,
			maxSegmentCount: d,
			width: Math.max(0, e.config.lineWidth) * .04,
			normal: r,
			dashSize: .3,
			gapSize: e.config.lineType === Mt.Solid ? 0 : .2,
			depthWrite: !0,
			highlightColor: this._viewer.settings.objects.highlightColor.value
		}), g = this.getMaxAnnotationTextureSize(), _ = Math.min(this._viewer.viewport?.renderer.maxTextureSize ?? g, g), y = new Cn(m, h, r, e.config, n, _, this.getAnnotationQualityScale());
		return y.setupLayer(s, c, o, e.annotations), y;
	}
	createFloorPlan(e, t, n, r) {
		let i = new A().fromArray(e), a = new Qt(t);
		a.name = n, r.sort((e, t) => e.config.order > t.config.order ? -1 : +(e.config.order < t.config.order));
		let o = 0;
		for (let e of r) {
			let t = this._createLayer(e, o, i);
			t && (a.addSubMesh(t), o++);
		}
		return this._viewer.viewport?.renderModeController.applyCurrentRenderModeOnController(this), a;
	}
	getSceneFloorPlanWithConfigurationId(e) {
		for (let t of this._objects.values()) if (t.id === e) return t;
		return null;
	}
	_getMeshMaterials(e) {
		let t = this._viewer.materialFactory;
		return [
			t.getBatchedMeshOpaqueMaterial(e),
			t.getBatchedMeshOpaqueMaterial_Selected(e),
			t.getBatchedMeshTransparentMaterial(e),
			t.getBatchedMeshTransparentMaterial_Selected(e),
			t.getBatchedMeshXRayMaterial(e),
			t.getBatchedMeshXRayMaterial_Selected(e)
		];
	}
}, Tn = [
	2048,
	4096,
	8192
], En = xe.Create("FloorPlan", () => ({
	annotationQualityScale: new w(1.7, {
		max: 2,
		min: 1,
		step: .1
	}),
	maxAnnotationTextureSize: new ge(4096, Tn),
	objectCountWarningLevel: new w(5e4, {
		max: 1e5,
		min: 1e4,
		step: 1
	})
})), Dn = class extends En {
	constructor(e, t) {
		super(e, t), this._setupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.add($t);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.delete($t);
		}, this.floorPlanController = new wn(e, () => this.settings.maxAnnotationTextureSize.value, () => this.settings.annotationQualityScale.value);
	}
	dependencies() {
		return ["Teia"];
	}
	onRegister() {
		this.viewer.scene.addController(this.floorPlanController), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this._setupViewport();
	}
	onUnregister() {
		this.viewer.scene.removeController(this.floorPlanController), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this._unsetupViewport();
	}
}, On = (e) => ({
	getTwinProjectInfo(t) {
		let n = e.URL(`twins/${t.id}`), r = new Request(n, { method: "GET" });
		return e.sendRequest(r);
	},
	downloadExport(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/twin/download-search-export`);
		a.searchParams.set("twinProjectType", i);
		let o = JSON.stringify(n), s = new Request(a, {
			method: "POST",
			body: o,
			headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
		});
		return e.sendRequest(s);
	},
	putTwinProjectInfo(t, n) {
		let r = e.URL(`projects/${t}/twin`), i = JSON.stringify({ ...n }), a = new Request(r, {
			method: "PUT",
			body: i,
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(a);
	},
	getTwinProjectList(t = 1, n = 1e3, r) {
		let i = e.URL("twins");
		r && i.searchParams.set("twinProjectType", r), i.searchParams.set("pageNumber", String(t)), i.searchParams.set("pageSize", String(n));
		let a = new Request(i, { method: "GET" });
		return e.sendRequest(a);
	}
}), kn = /* @__PURE__ */ new A(0, 0, 0), An = class extends u {
	constructor(e, t, n) {
		super(e), this.twin = t, this.isVisible = n, this.name = "InitMapCommand", this.isUndoable = !1;
	}
	async _do() {
		let e = this.viewer.getPlugin("Map"), t = this.viewer.getPlugin("Teia");
		if (!e.mapContainer) return;
		let n = e.mapContainer;
		if (n.isInit) n.resetToInitialLatLng();
		else {
			let e = await On(t.twinApiClient).getTwinProjectInfo(this.twin), r = new yt(e.refLatitude, e.refLongitude), i = 0;
			e.mapDeltaCoordinates && (i = e.mapDeltaCoordinates[1]), kn.setY(i);
			let a = this.viewer.getPlugin("Map");
			n.init(e.mapDeltaCoordinates ?? [
				0,
				0,
				0
			], r, e.azimuth, kn, a.settings.opacity.value, a.settings.shape.value, a.settings.size.value, this.isVisible, a.settings.nbOfPlanesPerLine.value, a.settings.planeSize.value, a.settings.type.value);
		}
	}
	async _undo() {
		throw new te(this);
	}
}, jn = /* @__PURE__ */ function(e) {
	return e[e.Twin = 0] = "Twin", e[e.File = 1] = "File", e;
}({}), Mn = /* @__PURE__ */ new A(0, 0, 0), Nn = class extends u {
	constructor(e, t) {
		super(e), this._center = t, this.name = "SetupInitialMapCenterCommand", this.isUndoable = !1;
	}
	async _do() {
		let e = this.viewer.getPlugin("Map"), t = this.viewer.getPlugin("Teia");
		if (!t.currentSource || !e.mapContainer) return;
		let n = e.mapContainer;
		if (t.currentSource?.sourceType === jn.Twin) {
			Mn.set(this._center.x, n.mapDeltaCoordinates.y, this._center.z), n.mapDeltaCoordinates = Mn;
			let e = await On(t.twinApiClient).getTwinProjectInfo(t.currentSource);
			await On(t.twinApiClient).putTwinProjectInfo(t.currentSource.projectId, {
				...e,
				mapDeltaCoordinates: [
					Mn.x,
					Mn.y,
					Mn.z
				]
			});
		} else Mn.set(this._center.x, 0, this._center.z), n.centerMap(Mn);
	}
	async _undo() {
		throw new te(this);
	}
}, Pn = 19, Fn = new xt(0, 0);
Fn.z = Pn;
var In = /* @__PURE__ */ new pt(), Ln = /* @__PURE__ */ new pt(), Rn = /* @__PURE__ */ new A(), zn = /* @__PURE__ */ new A(), Bn = /* @__PURE__ */ new pt(), z = /* @__PURE__ */ new je(), Vn = /* @__PURE__ */ function(e) {
	return e[e.circle = 0] = "circle", e[e.square = 1] = "square", e;
}({}), Hn = /* @__PURE__ */ function(e) {
	return e[e.default = 0] = "default", e[e.simple = 1] = "simple", e[e.satellite = 2] = "satellite", e[e.cadastral = 3] = "cadastral", e;
}({}), Un = [
	"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	"https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
	"https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/jpeg&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}",
	"https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=PCI%20vecteur&TILEMATRIXSET=PM&FORMAT=image/png&LAYER=CADASTRALPARCELS.PARCELLAIRE_EXPRESS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}"
], Wn = class extends se {
	constructor(e) {
		super(), this._viewer = e, this.isMapContainer = !0, this.signals = {
			onSelectedChanged: new T(),
			onVisibilityChanged: new T(),
			onLatLngChanged: new T(),
			onTransformChanged: new T(),
			onRotationChanged: new T(),
			onOpacityChanged: new T(),
			onSizeChanged: new T(),
			onShapeChanged: new T(),
			onTypeChanged: new T()
		}, this.size = 0, this.shape = 1, this.mapType = 0, this.isInit = !1, this._userOpacity = 0, this._mapDeltaCoordinates = new A(), this._initLatLng = new yt(0, 0), this._tileLayers = [], this._leafletTiles = /* @__PURE__ */ new Map(), this._meshTiles = [], this._pixelsPerMeter = 0, this._currentLatLng = new yt(0, 0), this._nbOfPlanesPerLine = 10, this._planeSize = 100, this._maxDrawnSize = 0, this._offsetX = 0, this._offsetY = 0, this._map = this._createMap(), this._map.setView(new yt(50.633, 3.0586), Pn);
		for (let e of Un) this._tileLayers.push(this._createTileLayer(e));
		this._currentTileLayer = this._tileLayer, this._currentTileLayer.addTo(this._map), this.container = new He(), this.container.rotation.x = Ye.degToRad(-90), this.container.updateMatrix();
	}
	async init(e, t, n, r, i, a, o, s, c, l, u) {
		this._offsetX = 0, this._offsetY = 0, this._nbOfPlanesPerLine = c, this._planeSize = l, this._maxDrawnSize = o, this._mapDeltaCoordinates.set(e[0], e[1], e[2]), this._initLatLng.lat = t.lat, this._initLatLng.lng = t.lng, this._currentLatLng.lat = t.lat, this._currentLatLng.lng = t.lng, this._userOpacity = i, this._pixelsPerMeter = qn(t.lat), this.setType(u), this.setPosition(r), this.setShape(a), this.setRotation(n), this._setMapEvents(), this._createPlanes(), this.setSize(o), this.setLatLng(t), this.visible = s, this.isInit = !0;
	}
	getMatrix(e) {
		return e.copy(this.container.matrix);
	}
	setMatrix(e) {
		this.container.matrixAutoUpdate = !1, this.container.matrix.copy(e), this.container.matrix.decompose(this.container.position, this.container.quaternion, this.container.scale), this.signals.onTransformChanged.emit(), this.container.matrixWorldNeedsUpdate = !0;
	}
	get visible() {
		return this.container.visible;
	}
	set visible(e) {
		e ? this.container.visible = !0 : this.container.visible = !1, this.signals.onVisibilityChanged.emit();
	}
	get opacity() {
		return this._meshTiles.length === 0 ? 0 : this._meshTiles[0].mesh.material.opacity;
	}
	get center() {
		return this._currentLatLng;
	}
	get azimuth() {
		return Ye.radToDeg(this.container.rotation.z);
	}
	get maxSizeMeters() {
		return this._planeSize * this._nbOfPlanesPerLine;
	}
	get elevation() {
		return this.container.position.y;
	}
	get initLat() {
		return this._initLatLng.lat;
	}
	get initLng() {
		return this._initLatLng.lng;
	}
	get mapDeltaCoordinates() {
		return this._mapDeltaCoordinates;
	}
	set mapDeltaCoordinates(e) {
		this._mapDeltaCoordinates.set(e.x, e.y, e.z);
	}
	get _tileLayer() {
		return this._tileLayers[this.mapType];
	}
	centerMap(e) {
		let t = this._map.latLngToLayerPoint(this._currentLatLng);
		this._offsetX = (e.x - this._mapDeltaCoordinates.x) * this._pixelsPerMeter, this._offsetY = (e.z - this._mapDeltaCoordinates.z) * this._pixelsPerMeter, this._getOffsetWithRotation(Bn);
		let n = Bn.x + t.x, r = Bn.y + t.y, i = this._map.layerPointToLatLng(new xt(n, r));
		this.setLatLng(i);
	}
	getLatLngToSave() {
		let e = this._map.latLngToLayerPoint(this._currentLatLng);
		this._getOffsetWithRotation(Bn);
		let t = e.x - Bn.x, n = e.y - Bn.y, r = this._map.layerPointToLatLng(new xt(t, n));
		return this._initLatLng.lat = r.lat, this._initLatLng.lng = r.lng, r;
	}
	_getOffsetWithRotation(e) {
		let t = this.container.rotation.z;
		return e.set(this._offsetX * Math.cos(t) - this._offsetY * Math.sin(t), this._offsetX * Math.sin(t) + this._offsetY * Math.cos(t));
	}
	resetToInitialLatLng() {
		this.setLatLng(this._initLatLng), this._offsetX = 0, this._offsetY = 0;
	}
	setLatLng(e) {
		this._map.panTo(e), this._currentLatLng.lat = e.lat, this._currentLatLng.lng = e.lng, this._drawTextures(), this.signals.onLatLngChanged.emit(e);
	}
	setRotation(e) {
		this.container.rotation.z = Ye.degToRad(e), this.container.updateMatrix(), this._traverseMaterials((e) => {
			e.userData.shader && (e.userData.shader.uniforms.mapRotation.value = this.container.rotation.z);
		}), this.signals.onRotationChanged.emit(e);
	}
	setOpacity(e) {
		this._userOpacity = e, this._setPlaneOpacity(e), this.signals.onOpacityChanged.emit(e);
	}
	setSize(e) {
		this.size = e, this._setPlaneSize(), this._maxDrawnSize < this.size && (this._drawTextures(), this._maxDrawnSize = this.size), this.signals.onSizeChanged.emit(e);
	}
	setType(e) {
		this.mapType = e, this._map.removeLayer(this._currentTileLayer), this._currentTileLayer = this._tileLayer, this._currentTileLayer.addTo(this._map), this._drawTextures(), this.signals.onTypeChanged.emit(e);
	}
	setShape(e) {
		this.shape = e, this._traverseMaterials((t) => {
			t.userData.shader && (t.userData.shader.uniforms.shape.value = e);
		}), this.signals.onShapeChanged.emit(e);
	}
	setNbOfPlanesPerLine(e) {
		this.isInit && (this._maxDrawnSize = this.size, this._nbOfPlanesPerLine = e, this._meshTiles.clear(), this.container.clear(), this._createPlanes(), this._drawTextures());
	}
	setPlaneSize(e) {
		this.isInit && (this._maxDrawnSize = this.size, this._planeSize = e, this._meshTiles.clear(), this.container.clear(), this._createPlanes(), this._drawTextures());
	}
	raycast(e, t) {
		we(e, t);
	}
	projectPointOnEdges(e, t, n) {
		return we(e, t, n), !1;
	}
	getBoundingBox(e) {
		z.setFromObject(this.container);
		let t = this.size / this.maxSizeMeters;
		return z.getSize(zn), e.setFromCenterAndSize(z.getCenter(Rn), zn.set(zn.x * t, zn.y, zn.z * t)), e;
	}
	getBoundingSphere(e) {
		return this.getBoundingBox(z), z.getBoundingSphere(e), e;
	}
	_traverseMaterials(e) {
		for (let t of this._meshTiles) if (t.mesh.material.isMeshBasicMaterial) {
			let n = t.mesh.material;
			e(n);
		}
	}
	_latLngToCoords(e) {
		let t = this._tileLayer.getTileSize(), n = this._map.getZoom();
		return this._map.project(e, n).divideBy(t.x);
	}
	_setMapEvents() {
		this._map.on("resize", async () => {
			this._map.getContainer().style.display = "block", this._map.invalidateSize(), this._map.getContainer().style.display = "none";
		});
	}
	_setPlaneOpacity(e) {
		this._traverseMaterials((t) => {
			e >= .95 ? (t.transparent = !1, t.depthWrite = !0) : (t.transparent = !0, t.depthWrite = !1), t.opacity = e;
		});
	}
	_setPlaneSize() {
		this._traverseMaterials((e) => {
			e.userData.shader && (e.userData.shader.uniforms.mapCenter.value = new pt(this.container.position.x, this.container.position.z), e.userData.shader.uniforms.mapRadius.value = this.size / 2);
		});
	}
	_createMap() {
		let e = document.getElementById("map-div");
		e && e.remove(), e = document.createElement("div"), e.id = "map-div", e.style.height = "0px", e.style.width = "0px", e.style.opacity = "0", e.style.pointerEvents = "none", document.body.appendChild(e);
		let t = new bt("map-div", {});
		return t.whenReady(() => {
			e && (e.style.display = "none");
		}), t;
	}
	_createTileLayer(e) {
		return new Gn(e, {
			maxZoom: Pn,
			crossOrigin: !0
		});
	}
	_createCanvas(e) {
		let t = document.createElement("canvas");
		t.width = e, t.height = e;
		let n = t.getContext("2d", { alpha: !1 });
		return n && (n.fillStyle = "#8088a7", n.fillRect(0, 0, t.width, t.height)), {
			canvas: t,
			ctx: n
		};
	}
	_createTextureFromCanvas(e) {
		let t = new Pe(e);
		return t.flipY = !0, t.minFilter = Je, t.magFilter = qe, t.colorSpace = it, t;
	}
	_createPlanes() {
		for (let e = 0; e < this._nbOfPlanesPerLine; e++) for (let t = 0; t < this._nbOfPlanesPerLine; t++) {
			let { plane: n, ctx: r } = this._createPlane(), i = (this._nbOfPlanesPerLine - 1) / 2 * this._planeSize;
			n.position.set(e * this._planeSize - i, t * this._planeSize - i, 0), this.container.add(n), this._meshTiles.push({
				mesh: n,
				ctx: r,
				positions: {
					x: e,
					y: this._nbOfPlanesPerLine - 1 - t
				}
			});
		}
	}
	_createPlane() {
		let e = new Qe(1, 1), { canvas: t, ctx: n } = this._createCanvas(this._pixelsPerMeter * this._planeSize), r = this._createTextureFromCanvas(t), i = new Ze({
			side: ze,
			map: r,
			opacity: this._userOpacity,
			transparent: !0,
			depthWrite: !1
		});
		this._setShader(i);
		let a = new Xe(e, i);
		return a.renderOrder = -1, a.scale.set(this._planeSize, this._planeSize, 1), {
			plane: a,
			ctx: n
		};
	}
	_setShader(e) {
		e.onBeforeCompile = (t) => {
			t.uniforms.mapCenter = { value: new pt(this.container.position.x, this.container.position.z) }, t.uniforms.mapRadius = { value: this.size / 2 }, t.uniforms.shape = { value: this.shape }, t.uniforms.mapRotation = { value: this.container.rotation.z }, t.vertexShader = t.vertexShader.replace("void main() {", "\n          varying vec3 vWorldPos;\n          void main() {\n            vec4 worldPosition = modelMatrix * vec4(position, 1.0);\n            vWorldPos = worldPosition.xyz;\n        "), t.fragmentShader = t.fragmentShader.replace("void main() {", "\n          varying vec3 vWorldPos;\n          uniform vec2 mapCenter;\n          uniform float mapRotation;\n          uniform float mapRadius;\n          uniform int shape;\n\n          vec2 rotate(vec2 v, float angle) {\n            float cosA = cos(angle);\n            float sinA = sin(angle);\n            return mat2(cosA, -sinA, sinA, cosA) * v;\n          }\n          void main() {\n        "), t.fragmentShader = t.fragmentShader.replace("vec4 diffuseColor = vec4( diffuse, opacity );", "\n          vec2 localPos = vWorldPos.xz - mapCenter;\n          float cosA = cos(-mapRotation);\n          float sinA = sin(-mapRotation);\n          mat2 rot = mat2(cosA, -sinA, sinA, cosA);\n          vec2 rotatedPos = rot * localPos;\n\n          if (shape == 0) {\n            if (length(rotatedPos) > mapRadius) discard;\n          } else {\n            if (abs(rotatedPos.x) > mapRadius || abs(rotatedPos.y) > mapRadius) discard;\n          }\n          vec4 diffuseColor = vec4( diffuse, opacity );\n        "), e.userData.shader = t;
		};
	}
	_drawOneTile(e, t, n, r) {
		let i = this._tileLayer.getTileSize();
		return new Promise((a) => {
			r && r.complete ? (e && (e.fillStyle = "white", e.fillRect(t, n, i.x, i.y), e.drawImage(r, t, n)), a()) : r && (r.onload = () => {
				e && (e.fillStyle = "white", e.fillRect(t, n, i.x, i.y), e.drawImage(r, t, n)), a();
			});
		});
	}
	async _drawAndSaveTile(e, t, n, r) {
		let i = `${r.x}-${r.y}-${this.mapType}`, a = this._leafletTiles.get(i);
		if (a || (a = await this._tileLayer.asyncCreateTile(r), a && this._leafletTiles.set(i, a)), await this._drawOneTile(n.ctx, e, t, a), n.mesh.material.isMeshBasicMaterial) {
			let e = n.mesh.material;
			e.map && (e.map.needsUpdate = !0);
		}
		this._viewer.requestRender();
	}
	_drawTextures() {
		let e = this._tileLayer.getTileSize(), t = this._pixelsPerMeter * this._planeSize;
		In.set(-this.size / 2, -this.size / 2), Ln.set(this.size / 2, this.size / 2);
		let n = Math.sqrt(this._meshTiles.length) * this._planeSize / 2, r = this._latLngToCoords(this._currentLatLng);
		this._meshTiles.forEach(async (i) => {
			let a = i.positions.x * this._planeSize - n, o = i.positions.y * this._planeSize - n;
			if (a > In.x - this._planeSize && a < Ln.x + this._planeSize && o > In.y - this._planeSize && o < Ln.y + this._planeSize) {
				let n = a * this._pixelsPerMeter, s = o * this._pixelsPerMeter, c = n / e.x, l = s / e.y, u = r.x + c, d = r.y + l, f = Math.trunc(u), p = Math.trunc(d);
				Fn.x = f, Fn.y = p;
				let m = -(u - f) * e.x, h = -(d - p) * e.y, g = m, _ = h;
				this._drawAndSaveTile(g, _, i, Fn);
				let v = 1;
				for (; m < t || h < t;) {
					m += e.x, h += e.y;
					let t = f + v, n = p + v;
					Fn.x = t, Fn.y = n;
					let r = f + v - 1, a = p + v - 1, o = m, s = h;
					this._drawAndSaveTile(o, s, i, Fn);
					let c = h, l = 0;
					for (; c > _;) c -= e.y, Fn.x = t, Fn.y = a - l, l++, this._drawAndSaveTile(m, c, i, Fn);
					let u = m, d = 0;
					for (; u > g;) u -= e.x, Fn.x = r - d, Fn.y = n, d++, this._drawAndSaveTile(u, h, i, Fn);
					v++;
				}
			}
		});
	}
	dispose() {
		this._map.removeEventListener("resize"), this._traverseMaterials((e) => {
			e.map?.dispose();
		}), this._meshTiles.clear(), this.container.clear(), this.isInit = !1;
	}
}, Gn = class extends St {
	get tiles() {
		return Object.values(this._tiles);
	}
	asyncCreateTile(e) {
		return new Promise((t) => this.createTile(e, (e, n) => {
			t(n);
		}));
	}
};
function Kn(e, t = Pn) {
	let n = e * Math.PI / 180;
	return 40075016.686 * Math.cos(n) / (2 ** t * 256);
}
function qn(e, t = Pn) {
	return 1 / Kn(e, t);
}
//#endregion
//#region src/MapPlugin/command/SetMapVisibilityCommand.ts
var Jn = class extends u {
	constructor(e, t) {
		super(e), this.visibility = t, this.name = "SetMapVisibilityCommand", this.isUndoable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.mapContainer = n.mapContainer, this.oldVisibility = n.mapContainer.visible;
	}
	async _do() {
		this.mapContainer.visible = this.visibility;
	}
	async _undo() {
		this.mapContainer.visible = this.oldVisibility;
	}
	equals(e) {
		return e.visibility === this.visibility;
	}
}, Yn = class extends y {
	constructor(...e) {
		super(...e), this.action = "plugin.map.show";
	}
	get label() {
		return gt("teiaviewer:teia.widgets.shortcuts_widget.shortcuts.show_map.text");
	}
	async execute(e) {
		let t = e.getPlugin("Map");
		t.mapContainer && new Jn(e, !t.mapContainer.visible).execute({ addToUndoHistory: !1 });
	}
}, Xn = /* @__PURE__ */ new k(), Zn = /* @__PURE__ */ new A(), Qn = xe.Create("MapPlugin", () => ({
	showMap: new s(!0),
	opacity: new w(.7, {
		min: 0,
		max: 1,
		step: .1
	}),
	size: new w(100, {
		min: 0,
		max: 1e3
	}),
	shape: new ge(Vn.square, [Vn.square, Vn.circle]),
	type: new ge(Hn.default, [
		Hn.default,
		Hn.simple,
		Hn.satellite,
		Hn.cadastral
	]),
	planeSize: new w(100, {
		min: 10,
		max: 200,
		step: 1
	}),
	nbOfPlanesPerLine: new w(10, {
		min: 1,
		max: 20,
		step: 1
	})
})), $n = new Yn({ key: "m" }), er = class extends Qn {
	constructor(...e) {
		super(...e), this.mapContainer = null, this.signals = {
			onMapInSceneChanged: new T(),
			onSettingsMapSaved: new T()
		}, this._isActivated = !1, this._setupViewport = () => {
			this.viewer.viewport?.shortcutController.addShortcut($n);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.shortcutController.removeShortcut($n);
		}, this.onShowMapChange = async (e) => {
			e ? (this._activate(), await this._onLoadingStarted(), this._onLoadingFinished()) : (this._desactivate(), this.viewer.requestRender());
		}, this.onChangeMapOpacity = (e) => {
			this.mapContainer && (this.mapContainer.setOpacity(e), this.viewer.requestRender());
		}, this.onChangeMapSize = (e) => {
			this.mapContainer && (this.mapContainer.setSize(e), this.viewer.requestRender());
		}, this.onChangeMapShape = (e) => {
			this.mapContainer && (this.mapContainer.setShape(e), this.viewer.requestRender());
		}, this.onChangeMapType = (e) => {
			this.mapContainer && (this.mapContainer.setType(e), this.viewer.requestRender());
		}, this.onChangeMapNbOfPlanes = (e) => {
			this.mapContainer && this.mapContainer.setNbOfPlanesPerLine(e);
		}, this.onChangeMapPlaneSize = (e) => {
			this.mapContainer && this.mapContainer.setPlaneSize(e);
		}, this._onLoadingStarted = async () => {
			this._addMapContainer();
			let e = this.viewer.getPlugin("Teia").currentSource;
			e && "type" in e && await new An(this.viewer, e, !1).execute();
		}, this._onLoadingFinished = () => {
			if (!this.mapContainer) return;
			let e = this.mapContainer;
			this.viewer.scene.getBoxTreeBoundingSphere(Xn), Xn.radius <= 0 && (Xn.radius = 1);
			let t = this.settings.size.value;
			t = t === 0 ? Xn.radius * 2 : t, Zn.set(Xn.center.x, e.elevation, Xn.center.z), e.setPosition(Zn), e.setSize(t), e.visible = !0, new Nn(this.viewer, Xn.center).execute();
		}, this._addMapContainer = () => {
			this.mapContainer ??= new Wn(this.viewer), this.mapContainer.visible = !1, this.viewer.scene.addObjectToBoundingBox(this.mapContainer), this.viewer.scene.addInternalObject(this.mapContainer.container), this.signals.onMapInSceneChanged.emit(!0);
		}, this._removeMapContainer = () => {
			this.mapContainer && (this.viewer.scene.removeObjectFromBoundingBox(this.mapContainer), this.viewer.scene.removeInternalObject(this.mapContainer.container), this.mapContainer.dispose(), this.signals.onMapInSceneChanged.emit(!1));
		};
	}
	dependencies() {
		return ["Teia"];
	}
	onRegister() {
		this.settings.showMap.onChange.connect(this.onShowMapChange), this.viewer.signals.onSceneClear.connect(this._removeMapContainer), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this._activate(), this._setupViewport();
	}
	onUnregister() {
		this.settings.showMap.onChange.disconnect(this.onShowMapChange), this.viewer.signals.onSceneClear.disconnect(this._removeMapContainer), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this._desactivate(), this._unsetupViewport();
	}
	_activate() {
		this.settings.showMap.value && !this._isActivated && ($n.enabled = !0, this._isActivated = !0, this.viewer.signals.onLoadingStarted.connect(this._onLoadingStarted), this.viewer.signals.onLoadingFinished.connect(this._onLoadingFinished), this.settings.opacity.onChange.connect(this.onChangeMapOpacity), this.settings.size.onChange.connect(this.onChangeMapSize), this.settings.shape.onChange.connect(this.onChangeMapShape), this.settings.planeSize.onChange.connect(this.onChangeMapPlaneSize), this.settings.type.onChange.connect(this.onChangeMapType), this.settings.nbOfPlanesPerLine.onChange.connect(this.onChangeMapNbOfPlanes));
	}
	_desactivate() {
		this._isActivated && (this._isActivated = !1, $n.enabled = !1, this._removeMapContainer(), this.viewer.signals.onLoadingStarted.disconnect(this._onLoadingStarted), this.viewer.signals.onLoadingFinished.disconnect(this._onLoadingFinished), this.settings.opacity.onChange.disconnect(this.onChangeMapOpacity), this.settings.size.onChange.disconnect(this.onChangeMapSize), this.settings.shape.onChange.disconnect(this.onChangeMapShape), this.settings.planeSize.onChange.disconnect(this.onChangeMapPlaneSize), this.settings.type.onChange.disconnect(this.onChangeMapType), this.settings.nbOfPlanesPerLine.onChange.disconnect(this.onChangeMapNbOfPlanes));
	}
}, tr = class extends u {
	constructor(e, t, n, r, i, a) {
		super(e), this.projectId = t, this.azimuth = n, this.refLatitude = r, this.refLongitude = i, this.elevation = a, this.name = "SaveInfoMapCommand", this.isUndoable = !1, this.isError = !1;
	}
	async _do() {
		let e = this.viewer.getPlugin("Map"), t = this.viewer.getPlugin("Teia");
		try {
			if (t.currentSource?.sourceType === jn.Twin && e.mapContainer) {
				let n = e.mapContainer.getLatLngToSave(), r = e.mapContainer.mapDeltaCoordinates, i = await On(t.twinApiClient).getTwinProjectInfo(t.currentSource);
				await On(t.twinApiClient).putTwinProjectInfo(this.projectId, {
					...i,
					azimuth: this.azimuth,
					refLatitude: n?.lat ?? this.refLatitude,
					refLongitude: n?.lng ?? this.refLongitude,
					mapDeltaCoordinates: [
						r.x,
						this.elevation,
						r.z
					]
				});
			}
		} catch {
			this.isError = !0;
		}
	}
	async _undo() {
		throw new te(this);
	}
}, nr = class extends u {
	constructor(e, t) {
		super(e), this.latLng = t, this.name = "SetMapcenterCommand", this.isUndoable = !0, this.isUpdatable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldLatLng = n.mapContainer.center;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setLatLng(this.latLng);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setLatLng(this.oldLatLng);
	}
	async update(e) {
		let t = this.viewer.getPlugin("Map");
		this.latLng = e, t.mapContainer?.setLatLng(e), super.update(e);
	}
}, rr = /* @__PURE__ */ new A(0, 0, 0), ir = class extends u {
	constructor(e, t) {
		super(e), this.elevation = t, this.name = "SetMapElevationCommand", this.isUndoable = !0, this.isUpdatable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldElevation = n.mapContainer.elevation, this.mapContainer = n.mapContainer;
	}
	async _do() {
		rr.set(this.mapContainer.container.position.x, this.elevation, this.mapContainer.container.position.z), this.mapContainer.setPosition(rr);
	}
	async _undo() {
		rr.set(this.mapContainer.container.position.x, this.oldElevation, this.mapContainer.container.position.z), this.mapContainer.setPosition(rr);
	}
	async update(e) {
		rr.set(this.mapContainer.container.position.x, e, this.mapContainer.container.position.z), this.mapContainer.setPosition(rr), super.update();
	}
}, ar = class extends u {
	constructor(e, t) {
		super(e), this.opacity = t, this.name = "SetMapOpacityCommand", this.isUndoable = !0, this.isUpdatable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldOpacity = n.mapContainer.opacity;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setOpacity(this.opacity);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setOpacity(this.oldOpacity);
	}
	async update(e) {
		let t = this.viewer.getPlugin("Map");
		this.opacity = e, t.mapContainer?.setOpacity(e), super.update();
	}
}, or = class extends u {
	constructor(e, t) {
		super(e), this.rotation = t, this.name = "SetMapRotationCommand", this.isUndoable = !0, this.isUpdatable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldRotation = n.mapContainer.azimuth;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setRotation(this.rotation);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setRotation(this.oldRotation);
	}
	async update(e) {
		let t = this.viewer.getPlugin("Map");
		this.rotation = e, t.mapContainer?.setRotation(e), super.update();
	}
}, sr = class extends u {
	constructor(e, t) {
		super(e), this.shape = t, this.name = "SetMapShapeCommand", this.isUndoable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldShape = n.mapContainer.shape;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setShape(this.shape);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setShape(this.oldShape);
	}
}, cr = class extends u {
	constructor(e, t) {
		super(e), this.size = t, this.name = "SetMapSizeCommand", this.isUndoable = !0, this.isUpdatable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldSize = n.mapContainer.size;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setSize(this.size);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setSize(this.oldSize);
	}
	async update(e) {
		let t = this.viewer.getPlugin("Map");
		this.size = e, t.mapContainer?.setSize(e), super.update();
	}
}, lr = class extends u {
	constructor(e, t) {
		super(e), this.type = t, this.name = "SetMapTypeCommand", this.isUndoable = !0;
		let n = this.viewer.getPlugin("Map");
		if (!n.mapContainer) throw Error("No map attached to the viewer");
		this.oldType = n.mapContainer.mapType;
	}
	async _do() {
		this.viewer.getPlugin("Map").mapContainer?.setType(this.type);
	}
	async _undo() {
		this.viewer.getPlugin("Map").mapContainer?.setType(this.oldType);
	}
}, ur = class extends e {
	constructor(e, t, n, r) {
		super(e, { selected: !1 }), this.name = "AddMeasureLineAnchorCommand", this.isUpdatable = !0, this.matrix = new O(), this.matrix.copy(t), this.measureLine = n, this.index = r;
	}
	async _do() {
		let e = await super._do();
		return e.setMatrix(this.matrix), this.viewer.scene.updateObjectInBoxTree(e), e;
	}
	async _createObject() {
		return this.viewer.getPlugin("MeasureLine").measureLineController.createAnchor(this.measureLine, this.index);
	}
	async update(e) {
		this._object && (this.matrix.copy(e), this._object.setMatrix(e), this.viewer.scene.updateObjectInBoxTree(this._object), await super.update());
	}
}, dr = class extends u {
	constructor(e, t, n) {
		super(e), this.name = "AddMeasureLineCommand", this.isUpdatable = !0, this.isUndoable = !0, this._matrixStart = new O(), this._matrixEnd = new O(), this._measureLine = null, this._cmd = null, this._startCmd = null, this._endCmd = null, this._matrixStart.copy(t), this._matrixEnd.copy(n);
	}
	async _do() {
		let e = this.viewer.getPlugin("MeasureLine");
		return (!this._measureLine || !this._startCmd || !this._endCmd) && (this._measureLine = e.measureLineController.createMeasureLine(), E(this._measureLine), this._startCmd = new ur(this.viewer, this._matrixStart, this._measureLine), this._endCmd = new ur(this.viewer, this._matrixEnd, this._measureLine)), this._cmd = new m(this.viewer, [this._startCmd, this._endCmd]), this._cmd.isUndoable = !0, this._cmd.execute({ addToUndoHistory: !1 }), this._measureLine;
	}
	async _undo() {
		this._cmd && this._cmd.undo();
	}
	async update(e, t) {
		this._endCmd && (this._matrixEnd.copy(e), this._endCmd.update(e), this._startCmd && t.isFirst && (this._matrixStart.copy(e), this._startCmd.update(e)));
	}
}, fr = class extends u {
	constructor(e, t) {
		super(e), this.name = "DeleteMeasureLineCommand", this.isUndoable = !0, this._measureLine = t;
	}
	async _do() {
		return this.viewer.getPlugin("MeasureLine").measureLineController.removeMeasureLine(this._measureLine), this._measureLine;
	}
	async _undo() {
		this.viewer.getPlugin("MeasureLine").measureLineController.addMeasureLine(this._measureLine);
	}
}, pr = (e) => {
	let { hitObject: t, viewer: n } = e, r = n.getPlugin("MeasureLine"), i = [], a = t && t.isMeasureLineAnchor, o = t && t.isMeasureLineSprite;
	return (n.viewport?.operator).isMeasureLinesOperator && i.push({
		type: "group",
		text: "Measure Lines",
		items: [
			{
				type: "action",
				text: gt("teiaviewer:context_menu.remove_measure_line_anchor.text"),
				disabled: !a,
				action: () => {
					new f(n, t).execute();
				}
			},
			{
				type: "action",
				text: gt("teiaviewer:context_menu.remove_measure_line.text"),
				disabled: !(a ?? o),
				action: () => {
					new fr(n, t.measureLine).execute();
				}
			},
			{
				type: "action",
				text: gt("teiaviewer:context_menu.remove_all_measure_lines.text"),
				disabled: r.measureLineController.count === 0,
				action: () => {
					let e = /* @__PURE__ */ new Set();
					for (let t of r.measureLineController.getAllObjects()) e.add(t.measureLine);
					let t = [];
					for (let r of e) t.push(new fr(n, r));
					let i = new m(n, t);
					i.isUndoable = !0, i.execute();
				}
			}
		]
	}), i;
}, mr = "#fabd38", hr = "#5d7dff", gr = "#0029d3", _r = .15, vr = "#5D7DFF", B = "#0029d3", yr = "#FF0A00", br = "#1AB53E", V = /* @__PURE__ */ function(e) {
	return e.Dot = "dot", e.Full = "full", e.Hover = "hover", e;
}({}), H = /* @__PURE__ */ new A(), xr = /* @__PURE__ */ new O(), Sr = /* @__PURE__ */ new A(), Cr = /* @__PURE__ */ new A(), wr = class extends fe {
	constructor(e) {
		super(), this.isMeasureLine = !0, this._anchors = [], this._hover = !1, this.sprite = e;
	}
	get hover() {
		return this._hover;
	}
	set hover(e) {
		this._hover = e;
		for (let t of this.getAnchors()) t.hover = e, t.line.hover = e, e ? t.sprite.sprite.layers.set(x.ObjectOverlayHover) : t.sprite.sprite.layers.set(x.ObjectOverlay);
		e ? this.sprite.sprite.layers.set(x.ObjectOverlayHover) : this.sprite.sprite.layers.set(x.ObjectOverlay), this.sprite.overrideColor = e ? B : null;
	}
	set selected(e) {
		super.selected = e;
		for (let t of this.getAnchors()) t.selected = e, t.line.selected = e, e ? t.sprite.sprite.layers.set(x.ObjectOverlayHover) : t.sprite.sprite.layers.set(x.ObjectOverlay);
		e ? this.sprite.sprite.layers.set(x.ObjectOverlayHover) : this.sprite.sprite.layers.set(x.ObjectOverlay), this.sprite.overrideColor = null;
	}
	get selected() {
		return super.selected;
	}
	get anchorsLength() {
		return this._anchors.length;
	}
	hideSprite(e) {
		this.sprite.material.opacity = +!e;
	}
	*getAnchors() {
		for (let e of this._anchors) yield e;
	}
	pushAnchor(e) {
		this._anchors.push(e);
	}
	unshiftAnchor(e) {
		this._anchors.unshift(e);
	}
	insertAnchor(e, t) {
		this._anchors.splice(t, 0, e);
	}
	removeAnchor(e) {
		this._anchors.remove(e);
	}
	getAnchorAt(e) {
		return this._anchors.at(e);
	}
	getMatrix(e) {
		return this.getPosition(H), e.setPosition(H.x, H.y, H.z);
	}
	setMatrix(e) {
		for (let t of this.getAnchors()) t.applyMatrix(e);
		for (let e of this.getAnchors()) e.update();
	}
	getPosition(e) {
		return Ee(this._anchors.map((e) => e.getPosition(new A())), e);
	}
	setPosition(e) {
		xr.identity().setPosition(e);
		for (let e of this.getAnchors()) e.setMatrix(xr);
	}
	set visible(e) {
		for (let t of this.getAnchors()) t.visible = e, t.line.visible = e, t.sprite && (t.sprite.visible = e);
		this.sprite.visible = e, super.visible = e;
	}
	get visible() {
		return super.visible;
	}
	updateSpritePosition() {
		let e = this.getAnchorAt(-1), t = this.getAnchorAt(-2);
		e && t && (e.getPosition(Sr), t.getPosition(Cr), this.sprite.updateDistance(Sr, Cr));
	}
}, Tr = [], Er = /* @__PURE__ */ new O(), Dr = /* @__PURE__ */ new O(), Or = /* @__PURE__ */ new O(), kr = /* @__PURE__ */ new A(), U = /* @__PURE__ */ new A(), Ar = /* @__PURE__ */ new A(), jr = /* @__PURE__ */ new nt(), Mr = /* @__PURE__ */ new A(), Nr = /* @__PURE__ */ new A(), Pr = /* @__PURE__ */ new A(), Fr = /* @__PURE__ */ new A(1, 0, 0), Ir = /* @__PURE__ */ new A(0, -1, 0), Lr = /* @__PURE__ */ new A(0, 1, 0), Rr = class extends de {
	constructor(e, t, n, r, i) {
		super(e), this.isMeasureLineAnchor = !0, this.matrix = new O(), this.savedIndex = null, this.meshProxy = e, this.arrowProxy = t, this.sprite = n, this.line = r, this._anchorType = i;
	}
	get selected() {
		return super.selected;
	}
	set selected(e) {
		super.selected = e, this._updateArrowMaterial();
	}
	get hover() {
		return super.hover;
	}
	set hover(e) {
		super.hover = e, this._updateArrowMaterial();
	}
	set visible(e) {
		super.visible = e, this.meshProxy.setVisible(!1), this._anchorType === "box" ? this.meshProxy.setVisible(e) : this.edgesProxy?.setVisible(e);
	}
	get visible() {
		return super.visible;
	}
	get active() {
		return super.active;
	}
	set active(e) {
		super.active = e, this.meshProxy.setActive(!1), this._anchorType === "box" ? this.meshProxy.setActive(e) : this.arrowProxy.setActive(e);
	}
	set diffuseColor(e) {
		this.meshProxy.setDiffuseColor(e), this.arrowProxy.setDiffuseColor(e);
	}
	get diffuseColor() {
		return this.meshProxy.getDiffuseColor();
	}
	get anchorType() {
		return this._anchorType;
	}
	set anchorType(e) {
		this._anchorType = e, e === "box" ? (this.meshProxy.setActive(!0), this.arrowProxy.setActive(!1)) : (this.meshProxy.setActive(!1), this.arrowProxy.setActive(!0));
	}
	get isFirst() {
		return this.measureLine.getAnchorAt(0) === this;
	}
	get isLast() {
		return this.measureLine.getAnchorAt(-1) === this;
	}
	get index() {
		return Array.from(this.measureLine.getAnchors()).findIndex((e) => e === this);
	}
	get previousAnchor() {
		return this.index - 1 < 0 ? null : this.measureLine.getAnchorAt(this.index - 1) ?? null;
	}
	get nextAnchor() {
		return this.index + 1 > this.measureLine.anchorsLength ? null : this.measureLine.getAnchorAt(this.index + 1) ?? null;
	}
	raycast(e, t) {
		Tr.clear(), this._anchorType === "box" ? this.meshProxy.raycast(e, Tr) : this.arrowProxy.raycast(e, Tr);
		for (let e of Tr) t.push({
			...e,
			object: this
		});
	}
	showNormalsHelper(e, t) {
		this._anchorType === "box" ? this.meshProxy.showNormalsHelper(e, t) : this.arrowProxy.showNormalsHelper(e, t);
	}
	showBoundingBoxHelper(e, t) {
		this._anchorType === "box" ? this.meshProxy.showBoundingBoxHelper(e, t) : this.arrowProxy.showBoundingBoxHelper(e, t);
	}
	getBoundingBox(e) {
		return this._anchorType === "box" ? this.meshProxy.getBoundingBox(e) : this.arrowProxy.getBoundingBox(e);
	}
	getBoundingSphere(e) {
		return this._anchorType === "box" ? this.meshProxy.getBoundingSphere(e) : this.arrowProxy.getBoundingSphere(e);
	}
	getStateController() {
		return new ae(this);
	}
	setMatrix(e, t = !0) {
		super.setMatrix(e), this.arrowProxy.setMatrix(e), this.matrix.copy(e), t && this.update();
	}
	setPosition(e) {
		super.setPosition(e), this.update();
	}
	_updateArrowMaterial() {
		let e = this.selected, t;
		t = this.xRay ? e ? C.SelectedXRay : C.XRay : this.isTransparent ? e ? C.SelectedTransparent : C.Transparent : this.hover ? e ? C.SelectedOpaque : C.Hover : e ? C.SelectedOpaque : C.Opaque, this.arrowProxy.setMaterial(t);
	}
	update() {
		this.updatePreviousSegment(), this.updateNextSegment(), this.measureLine.updateSpritePosition();
	}
	updatePreviousSegment() {
		this.previousAnchor?.active && this._updateSegment(this, this.previousAnchor);
	}
	updateNextSegment() {
		this.nextAnchor?.active && this._updateSegment(this.nextAnchor, this);
	}
	_updateSegment(e, t) {
		e.getPosition(kr), t.getPosition(U), Br(kr, U, Er, t.anchorType === "arrow", e.anchorType === "arrow"), e.line.setMatrix(Er), e.anchorType === "arrow" ? Vr(kr, U, Ir, kr, Er) : Er.makeTranslation(kr), e.setMatrix(Er, !1), t.anchorType === "arrow" ? Vr(kr, U, Lr, U, Er) : Er.makeTranslation(U), t.setMatrix(Er, !1), zr(kr, U, kr, Nr, t.anchorType === "arrow" ? -1 : 0), zr(kr, U, U, Pr, +(e.anchorType === "arrow")), e.sprite.updateDistance(Nr, Pr, kr, U);
	}
};
function zr(e, t, n, r, i) {
	De(e, t, Ar), Ar.normalize(), Ar.multiplyScalar(i === 1 || i === -1 ? _r : 0), r.set(n.x + Ar.x * i, n.y + Ar.y * i, n.z + Ar.z * i);
}
function Br(e, t, n, r, i) {
	let a = e.distanceTo(t);
	Oe(e, t, Fr, jr), De(e, t, Ar), Ar.normalize(), Ar.multiplyScalar(i ? _r : 0), Mr.set(e.x + Ar.x, e.y + Ar.y, e.z + Ar.z), n.makeTranslation(Mr), n.multiply(Dr.makeRotationFromQuaternion(jr));
	let o = 0;
	return i && r ? o = _r * 2 : (i || r) && (o = _r), n.multiply(Or.makeScale(Math.max(0, a - o), 1, 1)), n;
}
function Vr(e, t, n, r, i) {
	return Oe(e, t, n, jr), i.makeRotationFromQuaternion(jr), i.setPosition(r.x, r.y, r.z), i;
}
//#endregion
//#region src/MeasureLinePlugin/objects/MeasureLineAnchorLine.ts
var Hr = class extends de {
	constructor(e) {
		super(e), this.meshProxy = e, this.isMeasureLineAnchorLine = !0;
	}
	get anchorIndex() {
		let e = 0;
		for (let t of this.measureLine.getAnchors()) if (t.line === this) {
			e = t.index;
			break;
		}
		return e;
	}
}, Ur = 300, Wr = 100, Gr = 20, Kr = /* @__PURE__ */ new A(), qr = /* @__PURE__ */ new A(), Jr = /* @__PURE__ */ new A(), Yr = document.createElement("canvas"), Xr = Zr();
function Zr() {
	let e = Yr.getContext("2d"), t = new Pe(Yr);
	return Yr.width = Gr, Yr.height = Gr, e && (e.fillStyle = "white", e.strokeStyle = vr, e.lineWidth = 3, e.roundRect?.(3, 3, Yr.width - 6, Yr.height - 6, 100), e.fill(), e.stroke()), t.needsUpdate = !0, t;
}
var Qr = class extends he {
	constructor(e, t) {
		super(e, t), this.isMeasureLineSprite = !0, this.distance = 0, this._lastComputedDistance = 0, this._canvas = document.createElement("canvas"), this._type = V.Full, this._distanceTexture = null, this.spriteScaleDot = 1, this.spriteScale = 1, this.lastDistanceOrZoomCamera = 1, this.sprite.layers.set(x.AlwaysVisible), this.sprite.material.sizeAttenuation = !1, this.sprite.material.depthTest = !1;
	}
	get spriteType() {
		return this._type;
	}
	get anchorIndex() {
		let e = 0;
		for (let t of this.measureLine.getAnchors()) if (t.sprite === this) {
			e = t.index;
			break;
		}
		return e;
	}
	setScale(e, t, n) {
		this.sprite.scale.set(e, t, n);
	}
	updateDistance(e, t, n, r) {
		Ee([e, t], this.sprite.position), this.distance = n.distanceTo(r), this.updateSpriteTypeWithCamera(), this._computeTexture(!0);
	}
	updateSpriteTypeWithCamera() {
		this.lastDistanceOrZoomCamera > this.distance / this.spriteScaleDot ? this.updateType(V.Dot) : this.updateType(V.Full), this.updateSpriteScale();
	}
	updateSpriteScale() {
		this._type === V.Dot ? this.setScale(this.spriteScaleDot, this.spriteScaleDot, this.spriteScaleDot) : this.setScale(this.spriteScale, 100 / 300 * this.spriteScale, this.spriteScale);
	}
	updateType(e) {
		e !== this._type && (this._type = e, e === V.Dot ? this.sprite.material.sizeAttenuation = !0 : this.sprite.material.sizeAttenuation = !1, this._computeTexture(this._lastComputedDistance !== this.distance));
	}
	_computeTexture(e) {
		let t;
		this._type === V.Dot ? t = Xr : ((e || this._distanceTexture === null) && (this._distanceTexture = this.getTexture(this.distance)), t = this._distanceTexture), t.colorSpace = it, this.sprite.material.map = t, this.visible = this.distance > .001, this.sprite.material.needsUpdate = !0;
	}
	getTexture(e) {
		let t = "m", n = e;
		e < 1 && (n = e * 100, t = "cm");
		let r = 0;
		return n > 9999.99 && (r = Math.floor(n / 1e3).toString().length), this._lastComputedDistance = this.distance, this._computeCanvasTexture(`${n.toFixed(2)}${t}`, r);
	}
	_computeColor() {
		let e = vr, t = this.measureLine.getAnchorAt(this.anchorIndex);
		if (t?.previousAnchor) {
			t.previousAnchor.getPosition(Kr), t.getPosition(qr), De(Kr, qr, Jr), Jr.normalize();
			let n = Math.abs(Jr.x), r = Math.abs(Jr.y), i = Math.abs(Jr.z);
			n > r && n > i ? e = yr : r > n && r > i && (e = br);
		}
		return {
			lineColor: e,
			textColor: "black",
			bgColor: "white"
		};
	}
	_computeCanvasTexture(e, t) {
		let n = this._canvas.getContext("2d"), r = new Pe(this._canvas);
		this._canvas.width = 300, this._canvas.height = 100;
		let { lineColor: i, textColor: a, bgColor: o } = this._computeColor();
		return n && (n.fillStyle = o, n.strokeStyle = i, n.lineWidth = 6, n.roundRect?.(6, 6, this._canvas.width - 12, this._canvas.height - 12, 20), n.fill(), n.stroke(), n.font = `${(6 - t * .5) * 10}px sans-serif`, n.fillStyle = a, n.textAlign = "center", n.textBaseline = "middle", n.fillText(e, 150, 55)), r.needsUpdate = !0, r;
	}
}, $r = /* @__PURE__ */ new A(), ei = /* @__PURE__ */ new A(), ti = class extends Qr {
	constructor(...e) {
		super(...e), this.isMeasureLineGlobalSprite = !0, this._overrideColor = null;
	}
	set overrideColor(e) {
		this._overrideColor = e, this._computeTexture(!0);
	}
	updateDistance(e, t) {
		De(e, t, $r), $r.normalize(), $r.multiplyScalar(.35), ei.set(e.x - $r.x, e.y - $r.y, e.z - $r.z), this.sprite.position.copy(ei);
		let n = 0;
		for (let e of this.measureLine.getAnchors()) n += e.sprite.distance;
		this.distance = n, this._computeTexture(!0);
	}
	updateSpriteTypeWithCamera() {
		this.setScale(this.spriteScale, 100 / 300 * this.spriteScale, this.spriteScale);
	}
	_computeColor() {
		return {
			lineColor: this._overrideColor ?? "#5D7DFF",
			textColor: "white",
			bgColor: this._overrideColor ?? "#5D7DFF"
		};
	}
}, ni = 200, ri = /* @__PURE__ */ new Le(.05, _r, 12, 1).translate(0, -_r / 2, 0), ii = /* @__PURE__ */ new Me(.05, .05, .05), ai = /* @__PURE__ */ new Ge(new A(0, 0, 0), new A(1, 0, 0)), oi = /* @__PURE__ */ new ft(ai, 2, .015, 6, !1), si = /* @__PURE__ */ new A(), ci = /* @__PURE__ */ new k(), li = class extends pe {
	constructor(e) {
		super(e), this.isMeasureLineController = !0, this._sprites = [], this._instancedIds = /* @__PURE__ */ new Map(), this.updateSpritesScale = () => {
			let { distanceOrZoom: e, sizeFactor: t, scaleValue: n } = this._getScaleInfos();
			for (let r of this._sprites) r.lastDistanceOrZoomCamera = e, r.spriteScaleDot = t, r.spriteScale = n, r.updateSpriteTypeWithCamera();
		}, this._arrowContainer = new g(ri, ui(400), 400), this._lineContainer = new g(oi, ui(ni), ni), this._boxContainer = new g(ii, ui(400), 400), this._spritesGroup = new He();
	}
	createMeasureLine() {
		let e = new dt({ depthWrite: !1 }), t = new ti(new ut(e)), { distanceOrZoom: n, sizeFactor: r, scaleValue: i } = this._getScaleInfos();
		t.lastDistanceOrZoomCamera = n, t.spriteScaleDot = r, t.spriteScale = i, t.updateSpriteTypeWithCamera(), this._sprites.push(t);
		let a = new wr(t);
		return t.measureLine = a, a;
	}
	addMeasureLine(e) {
		for (let t of e.getAnchors()) this._addAnchor(t), super.addObject(t, null);
		this._spritesGroup.add(e.sprite.sprite), this._switchTypes(e);
	}
	removeMeasureLine(e) {
		for (let t of e.getAnchors()) this._removeAnchor(t), super.removeObject(t);
		e.sprite.sprite.removeFromParent();
	}
	createAnchor(e, t) {
		let n = new Hr(new _(this._lineContainer, -1, oi.uuid));
		n.measureLine = e;
		let r = new dt({ depthWrite: !1 }), i = new Qr(new ut(r)), { distanceOrZoom: a, sizeFactor: o, scaleValue: s } = this._getScaleInfos();
		i.lastDistanceOrZoomCamera = a, i.spriteScaleDot = o, i.spriteScale = s, i.updateSpriteTypeWithCamera(), i.measureLine = e, this._sprites.push(i);
		let c = new Rr(this._createAnchorInstanceProxy("box"), this._createAnchorInstanceProxy("arrow"), i, n, "box");
		return c.measureLine = e, t !== void 0 && (c.savedIndex = t), c;
	}
	onSceneSetup(e) {
		e.addInternalObject(this._arrowContainer.root), e.addInternalObject(this._boxContainer.root), e.addInternalObject(this._lineContainer.root), e.addInternalObject(this._spritesGroup), this._viewer.signals.onCameraMove.connect(this.updateSpritesScale), this._viewer.signals.onLoadingFinished.connect(this.updateSpritesScale);
	}
	onSceneClear(e) {
		e.removeInternalObject(this._arrowContainer.root), e.removeInternalObject(this._boxContainer.root), e.removeInternalObject(this._lineContainer.root), e.removeInternalObject(this._spritesGroup), this._viewer.signals.onCameraMove.disconnect(this.updateSpritesScale), this._viewer.signals.onLoadingFinished.disconnect(this.updateSpritesScale);
	}
	accepts(e) {
		return e.isMeasureLine || e.isMeasureLineAnchor;
	}
	_getScaleInfos() {
		let e = this._viewer.getPlugin("MeasureLine"), t, n = e.settings.measureLineSpriteSize.value * .07 + .03, r = this._viewer.viewport?.camera, i = n;
		return this._viewer.viewport?.camera?.isOrthographicCamera && r ? (t = 1 / r.zoom + 5, i = 1 / r.zoom * n) : (this._viewer.scene.getBoxTreeBoundingSphere(ci), this._viewer.viewport?.cameraControls.getPosition(si), t = ci.center.sub(si).length()), {
			distanceOrZoom: t,
			sizeFactor: n,
			scaleValue: i
		};
	}
	clear() {
		this._arrowContainer.clear(), this._boxContainer.clear(), this._lineContainer.clear(), this._spritesGroup.clear(), this._viewer.signals.onCameraMove.disconnect(this.updateSpritesScale), this._viewer.signals.onLoadingFinished.disconnect(this.updateSpritesScale), this._instancedIds.clear(), this._sprites.clear(), super.clear();
	}
	_setVisibility(e) {
		this._lineContainer.visible = e, this._arrowContainer.visible = e, this._boxContainer.visible = e, this._spritesGroup.visible = e;
	}
	_createAnchorInstanceProxy(e) {
		let t;
		return t = e === "box" ? new _(this._boxContainer, -1, ii.uuid) : new _(this._arrowContainer, -1, ri.uuid), t;
	}
	_addAnchorInstance(e) {
		this._arrowContainer.addInstance(e.arrowProxy), this._boxContainer.addInstance(e.meshProxy);
	}
	_addLineInstance(e) {
		this._lineContainer.addInstance(e.meshProxy);
	}
	_removeAnchorInstance(e) {
		this._arrowContainer.removeInstance(e.arrowProxy), this._boxContainer.removeInstance(e.meshProxy);
	}
	addObject(e) {
		if (!e.active) {
			for (let t of e.measureLine.getAnchors()) this._removeAnchor(t);
			e.savedIndex === null ? e.measureLine.pushAnchor(e) : e.measureLine.insertAnchor(e, e.savedIndex);
			for (let t of e.measureLine.getAnchors()) this._addAnchor(t);
			this._switchTypes(e.measureLine), e.measureLine.sprite.parent == null && e.measureLine.anchorsLength > 1 && this._spritesGroup.add(e.measureLine.sprite.sprite);
		}
		super.addObject(e, null);
	}
	removeObject(e) {
		if (!this._objects.has(e.uuid)) throw Error("Anchor does not belong to the container");
		if (e.active) {
			e.savedIndex = e.index;
			for (let t of e.measureLine.getAnchors()) this._removeAnchor(t);
			e.measureLine.removeAnchor(e);
			for (let t of e.measureLine.getAnchors()) this._addAnchor(t);
			this._switchTypes(e.measureLine), e.measureLine.anchorsLength === 1 && e.measureLine.sprite.sprite.removeFromParent();
		}
		super.removeObject(e);
	}
	_addAnchor(e) {
		this._instancedIds.get(e.uuid) === void 0 && (this._addAnchorInstance(e), e.isFirst || (this._addLineInstance(e.line), this._spritesGroup.add(e.sprite.sprite)), e.setMatrix(e.matrix), this._viewer.scene.addObjectIntoBoxTree(e), e.isFirst || (this._viewer.scene.addObjectIntoBoxTree(e.sprite), this._viewer.scene.addObjectIntoBoxTree(e.line)), this._instancedIds.set(e.uuid, !e.isFirst), e.active = !0);
	}
	_removeAnchor(e) {
		let t = this._instancedIds.get(e.uuid);
		t !== void 0 && (e.selected = !1, e.line.selected = !1, e.hover = !1, e.line.hover = !1, this._removeAnchorInstance(e), this._viewer.scene.removeObjectFromBoxTree(e), t === !0 && (this._lineContainer.removeInstance(e.line.meshProxy), e.sprite.sprite.removeFromParent(), this._viewer.scene.removeObjectFromBoxTree(e.sprite), this._viewer.scene.removeObjectFromBoxTree(e.line)), this._instancedIds.delete(e.uuid), e.active = !1);
	}
	_switchTypes(e) {
		let t = 0, n;
		n = e.anchorsLength > 2 ? Array(e.anchorsLength - 2).fill("box") : [], n.unshift("arrow"), n.push("arrow");
		for (let r of e.getAnchors()) r.anchorType = n[t], this._viewer.scene.updateObjectInBoxTree(r), t++;
		e.getAnchorAt(-2)?.update(), e.getAnchorAt(1)?.update();
	}
};
function ui(e) {
	return [
		{
			material: new h(new S(e, { active: "float" }), { color: hr }),
			type: C.Opaque,
			layer: x.ObjectOverlay
		},
		{
			material: new h(new S(e, { active: "float" }), { color: mr }),
			type: C.SelectedOpaque,
			layer: x.ObjectOverlayHover
		},
		{
			material: new h(new S(e, { active: "float" }), { color: gr }),
			type: C.Hover,
			layer: x.ObjectOverlayHover
		}
	];
}
//#endregion
//#region src/MeasureLinePlugin/utils/MeasureLineFilters.ts
function di(e) {
	return !fi(e);
}
function fi(e) {
	return e.isMeasureLineAnchorLine || e.isMeasureLineAnchor || e.isMeasureLineSprite;
}
function pi(e) {
	return e.isMeasureLineAnchor;
}
function mi(e) {
	return e.isMeasureLineSprite;
}
var hi = {
	MeasureLineAnchorFilter: pi,
	NoMeasureLineFilter: di,
	MeasureLineSpriteFilter: mi,
	MeasureLineFilter: fi
}, gi = xe.Create("MeasureLinePlugin", () => ({ measureLineSpriteSize: new w(.5, {
	min: .1,
	max: 1,
	step: .01
}) })), _i = class extends gi {
	constructor(e) {
		super(e), this._setupViewport = () => {
			this.viewer.viewport && (this.viewer.viewport.contextMenuController.builders.add(pr), this.viewer.viewport.interactionController.addRaycastFilter(hi.NoMeasureLineFilter));
		}, this._unsetupViewport = () => {
			this.viewer.viewport && (this.viewer.viewport?.contextMenuController.builders.delete(pr), this.viewer.viewport.interactionController.removeRaycastFilter(hi.NoMeasureLineFilter));
		}, this._onMeasureLineSpriteSizeChanged = () => {
			this.measureLineController.updateSpritesScale(), this.viewer.requestRender();
		}, this.measureLineController = new li(this.viewer);
	}
	onRegister() {
		this.viewer.scene.addController(this.measureLineController), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this.settings.measureLineSpriteSize.onChange.connect(this._onMeasureLineSpriteSizeChanged), this._setupViewport();
	}
	onUnregister() {
		this.viewer.scene.removeController(this.measureLineController), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this.settings.measureLineSpriteSize.onChange.disconnect(this._onMeasureLineSpriteSizeChanged), this._unsetupViewport();
	}
}, vi = class extends oe {
	constructor(...e) {
		super(...e), this._hoverSprite = null;
	}
	onPointerMove(e) {
		if (this._viewport.viewer.getPlugin("MeasureLine").measureLineController.count === 0) return;
		this._hoverSprite &&= (this._hoverSprite.updateType(V.Dot), this._hoverSprite.updateSpriteScale(), null);
		let t = this._viewport.raycaster.raycastEvent(e, {
			filterFunc: hi.MeasureLineSpriteFilter,
			raycastTransparentMeshes: !1
		});
		if (t.length > 0) {
			let e = t[0].object;
			e?.isMeasureLineSprite && e.spriteType == V.Dot && (e.updateType(V.Hover), e.updateSpriteScale(), this._hoverSprite = e);
		}
		this._viewport.viewer.requestRender();
	}
};
//#endregion
//#region src/MeasureLinePlugin/utils/sortingRaycastFn.ts
function yi(e, t) {
	let n = e.object.isSceneSprite, r = t.object.isSceneSprite;
	return n && !r ? -1 : r && !n ? 1 : e.distance - t.distance;
}
function W(e, t) {
	let n = e.object.isMeasureLineSprite, r = t.object.isMeasureLineSprite;
	return n && !r ? -1 : r && !n ? 1 : e.distance - t.distance;
}
function bi(e, t) {
	let n = e.object.isMeasureLineAnchor, r = t.object.isMeasureLineAnchor;
	return n && !r ? -1 : r && !n ? 1 : e.distance - t.distance;
}
function xi(e, t) {
	let n = e.object.isMeasureLineAnchorLine, r = t.object.isMeasureLineAnchorLine;
	return n && !r ? -1 : r && !n ? 1 : e.distance - t.distance;
}
function Si(e, t) {
	let n = e.object.isMeasureLineSprite, r = t.object.isMeasureLineSprite, i = e.object.isMeasureLineAnchor, a = t.object.isMeasureLineAnchor, o = e.object.isMeasureLineAnchorLine, s = t.object.isMeasureLineAnchorLine;
	return n || r ? W(e, t) : i || a ? bi(e, t) : o || s ? xi(e, t) : e.distance - t.distance;
}
function Ci(e, t) {
	let n = e.object.isSceneSprite && !e.object.sprite.material.depthTest, r = t.object.isSceneSprite && !t.object.sprite.material.depthTest, i = e.object.isMeasureLineSprite, a = t.object.isMeasureLineSprite, o = e.object.isMeasureLineAnchor, s = t.object.isMeasureLineAnchor, c = e.object.isMeasureLineAnchorLine, l = t.object.isMeasureLineAnchorLine;
	return i || a || o || s || c || l ? Si(e, t) : n || r ? yi(e, t) : e.distance - t.distance;
}
//#endregion
//#region src/MeasureLinePlugin/operators/MeasureLinesOperator.ts
var G = /* @__PURE__ */ new O(), wi = /* @__PURE__ */ new O(), Ti = /* @__PURE__ */ new A(), Ei = /* @__PURE__ */ new A(), Di = class extends Se {
	constructor(...e) {
		super(...e), this.name = "MeasureLinesOperator", this.isMeasureLinesOperator = !0, this._anchor = null, this._previousAnchor = null, this._command = null, this._snapModeOrigin = new A(), this._edgeSnappingIsActive = !1, this._lastPointerEvent = null, this._isAddingPointToTheStart = !1, this._selectedMeasureLine = null, this._hoverMeasureLine = null, this._doubleClick = !1, this._hoverSprite = null;
	}
	get _isCreatingFirstAnchor() {
		return this._command?.name === "AddMeasureLineCommand" && this._anchor?.measureLine.anchorsLength === 2 && this._anchor.isFirst;
	}
	onKeyDown(e) {
		switch (e.key) {
			case "x":
			case "X":
				this._viewport.snapModeController.setSnapMode(ve.x), e.stopPropagation(), e.preventDefault();
				break;
			case "y":
			case "Y":
				this._viewport.snapModeController.setSnapMode(ve.y), e.stopPropagation(), e.preventDefault();
				break;
			case "z":
			case "Z":
				if (ke && e.metaKey || !ke && e.ctrlKey) break;
				this._viewport.snapModeController.setSnapMode(ve.z), e.stopPropagation(), e.preventDefault();
				break;
			case "Alt":
				this._edgeSnappingIsActive = !0, this._lastPointerEvent && this._onPressAlt(this._lastPointerEvent), e.stopPropagation(), e.preventDefault();
				break;
			case "Escape":
				this.cancel(), e.stopPropagation(), e.preventDefault();
				break;
			case "Delete":
			case "Backspace": this._deleteMeasureLine(), e.stopPropagation(), e.preventDefault();
		}
	}
	_deleteMeasureLine() {
		this._anchor ? (this.cancel(), new f(this._viewport.viewer, this._anchor).execute()) : this._selectedMeasureLine &&= (new fr(this._viewport.viewer, this._selectedMeasureLine).execute(), null);
	}
	onKeyUp(e) {
		e.key === "Alt" ? (this._edgeSnappingIsActive = !1, this._isCreatingFirstAnchor && this.cancel(), e.stopPropagation(), e.preventDefault()) : (e.key === "z" || e.key === "x" || e.key === "y") && (this._viewport.snapModeController.setSnapMode(ve.none), e.stopPropagation(), e.preventDefault());
	}
	onPointerMove(e) {
		this._lastPointerEvent = e, this._anchor && this._command ? this._updateAnchorWithSnapping(e, this._anchor, this._command) : this._checkHoverMeasureLine(e), this._viewport.viewer.requestRender();
	}
	_updateAnchorWithSnapping(e, t, n) {
		let r = this._viewport.raycaster.raycastEvent(e, {
			filterFunc: me.BimMeshFilter,
			raycastTransparentMeshes: e.shiftKey
		});
		r.length > 0 && Ti.copy(r[0].point), this._isCreatingFirstAnchor && this._viewport.snapModeController.snapMode === ve.none && this._snapModeOrigin.copy(Ti), this._edgeSnappingIsActive && r.length > 0 && this._getClosestEdgePointWithSnapping(r[0].object, r[0].point, Ei) && Ti.copy(Ei), G.setPosition(Ti), this._viewport.snapModeController.getNewMatrixWithSnapMode(this._snapModeOrigin, G, wi), n.name === "SetObjectTransformCommand" && (t.selected = !0), n.name === "AddMeasureLineCommand" ? n.update(wi, t) : n.update(wi), t.isFirst || (this._viewport.viewer.scene.updateObjectInBoxTree(t.sprite), this._viewport.viewer.scene.updateObjectInBoxTree(t.line), t.previousAnchor?.sprite && !t.previousAnchor.isFirst && (this._viewport.viewer.scene.updateObjectInBoxTree(t.previousAnchor.sprite), this._viewport.viewer.scene.updateObjectInBoxTree(t.previousAnchor.line))), t.nextAnchor?.sprite && (this._viewport.viewer.scene.updateObjectInBoxTree(t.nextAnchor.sprite), this._viewport.viewer.scene.updateObjectInBoxTree(t.nextAnchor.line));
	}
	_checkHoverMeasureLine(e) {
		this._hoverMeasureLine &&= (this._hoverMeasureLine.hover = !1, this._hoverMeasureLine.selected = !1, null), this._hoverSprite &&= (this._hoverSprite.updateType(V.Dot), this._hoverSprite.updateSpriteScale(), null);
		let t = this._viewport.raycaster.raycastEvent(e, {
			filterFunc: hi.MeasureLineFilter,
			raycastTransparentMeshes: !1
		});
		if (t.length > 0) {
			let e = t[0].object, n = this._getPriorityAnchor(t), r = t.find((e) => {
				let t = e.object;
				return t.isMeasureLineSprite && t.spriteType === V.Dot;
			})?.object;
			r?.isMeasureLineSprite && r.spriteType == V.Dot ? (r.updateType(V.Hover), r.updateSpriteScale(), this._hoverSprite = r) : n?.isMeasureLineAnchor && n.measureLine !== this._selectedMeasureLine ? (n.measureLine.hover = !0, n.selected = !0, this._hoverMeasureLine = n.measureLine) : e.isMeasureLineAnchorLine && e.measureLine !== this._selectedMeasureLine && (e.measureLine.hover = !0, this._hoverMeasureLine = e.measureLine);
		}
	}
	onPointerClick(e) {
		if (e.button === 0) this._onLeftClick(e);
		else if (e.button === 2) {
			if (this._anchor) this.cancel();
			else {
				let t = this._viewport.raycaster.raycastEvent(e, { filterFunc: hi.MeasureLineFilter });
				this.showContextMenu(e, t[0]?.object ?? null);
			}
		}
	}
	onPointerDoubleClick(e) {
		this.cancel(), this._selectedMeasureLine &&= (this._selectedMeasureLine.selected = !1, null), this._hoverMeasureLine &&= (this._hoverMeasureLine.hover = !1, this._hoverMeasureLine.selected = !1, null), this._doubleClick = !0;
		let t = {
			filterFunc: me.MeshFilter,
			raycastTransparentMeshes: e.shiftKey
		}, n = this._viewport.raycaster.raycastEvent(e, t);
		if (n.sort(Ci), n.length > 0 && !this._anchor) {
			let e = n[0], t = this._getPriorityAnchor(n), r = e.object;
			t?.isMeasureLineAnchor && (t.isFirst || t.isLast) ? (t.measureLine.hideSprite(!0), this._addAnchorAtStartOrEnd(e.point, t)) : r.isMeasureLineAnchorLine && (r.measureLine.hideSprite(!0), this._addAnchorOnSegment(e.point, r));
		}
	}
	async _addAnchorAtStartOrEnd(e, t) {
		let n;
		t.isFirst && (n = 0, this._isAddingPointToTheStart = !0), this._previousAnchor = t, await this._addMeasureLineAnchor(e, t.measureLine, n);
	}
	async _addAnchorOnSegment(e, t) {
		G.setPosition(e);
		let n = new ur(this._viewport.viewer, G, t.measureLine, t.anchorIndex);
		this._anchor = await n.execute(), this._command = new _e(this._viewport.viewer, this._anchor.uuid, G), this._command.execute(), this._anchor.selected = !0;
	}
	async _onPressAlt(e) {
		let t = {
			filterFunc: me.BimMeshFilter,
			raycastTransparentMeshes: e.shiftKey
		}, n = this._viewport.raycaster.raycastEvent(e, t);
		if (n.length > 0 && !this._anchor) {
			let e = n[0];
			this._snapModeOrigin.copy(e.point), G.setPosition(e.point), this._command = new dr(this._viewport.viewer, G, G);
			let t = (await this._command.execute()).getAnchorAt(0);
			t && (this._anchor = t);
		}
	}
	_selectMeasureLine(e) {
		this._selectedMeasureLine && (this._selectedMeasureLine.selected = !1), e.measureLine.hover = !1, e.measureLine.selected = !0, this._hoverMeasureLine = null, this._selectedMeasureLine = e.measureLine, this._viewport.viewer.requestRender();
	}
	_getPriorityAnchor(e) {
		if (e.length === 0) return null;
		let t;
		if (this._selectedMeasureLine) for (let n of e) {
			let e = n.object;
			if (e.isMeasureLineAnchor && e.measureLine === this._selectedMeasureLine) {
				t = e;
				break;
			}
		}
		return t ??= e[0].object, t;
	}
	async _onLeftClick(e) {
		if (this._doubleClick) {
			this._doubleClick = !1;
			return;
		}
		let t = {
			filterFunc: me.MeshFilter,
			raycastTransparentMeshes: e.shiftKey
		}, n = this._viewport.raycaster.raycastEvent(e, t);
		n.sort(Ci);
		let r, i, a;
		if (n.length > 0 && (a = n[0], r = a.object, i = this._getPriorityAnchor(n)), !r?.isMeasureLineAnchorLine && !i?.isMeasureLineAnchor && this._selectedMeasureLine) {
			this._selectedMeasureLine.selected = !1, this._selectedMeasureLine = null, this._viewport.viewer.requestRender();
			return;
		}
		if ((r || i) && !this._anchor && a) {
			if (r?.isMeasureLineAnchorLine) {
				this._selectMeasureLine(r);
				return;
			}
			i?.isMeasureLineAnchor ? (i.getPosition(Ti), this._snapModeOrigin.copy(Ti), i.selected = !0, this._moveMeasureLine(i, a.point)) : (this._snapModeOrigin.copy(a.point), await this._addNewMeasureLine(a.point));
		} else if (this._anchor) {
			if (this._isCreatingFirstAnchor) this._previousAnchor = this._anchor, this._anchor = this._anchor.nextAnchor;
			else if (n.length > 0 && this._command && this._command.name !== "SetObjectTransformCommand") {
				this._previousAnchor = this._anchor, this._previousAnchor.getPosition(Ti), this._snapModeOrigin.copy(Ti);
				let e;
				this._isAddingPointToTheStart && (e = 0), this._addMeasureLineAnchor(n[0].point, this._anchor.measureLine, e), this._anchor.measureLine.hideSprite(!0);
			} else this._anchor.measureLine !== this._selectedMeasureLine && (this._anchor.selected = !1), this._anchor.measureLine.hideSprite(!1), this._anchor = null, this._command = null;
		}
		this._viewport.viewer.requestRender();
	}
	async _addMeasureLineAnchor(e, t, n) {
		G.setPosition(e), this._command = new ur(this._viewport.viewer, G, t, n), this._anchor = await this._command.execute();
	}
	_moveMeasureLine(e, t) {
		G.setPosition(t), this._anchor = e, this._command = new _e(this._viewport.viewer, e.uuid, G), this._command.execute(), e.measureLine.hideSprite(!0);
	}
	async _addNewMeasureLine(e) {
		G.identity(), G.setPosition(e), this._command = new dr(this._viewport.viewer, G, G);
		let t = await this._command.execute();
		t.hideSprite(!0);
		let n = t.getAnchorAt(-1);
		n && (this._anchor = n);
	}
	_getClosestEdgePointWithSnapping(e, t, n) {
		return e.projectPointOnEdges(t, n, .3);
	}
	cancel() {
		this._anchor && (this._command?.undo({ addToRedoHistory: !1 }), this._viewport.viewer.requestRender(), this._anchor.measureLine.hideSprite(!1), this._anchor = null, this._previousAnchor = null, this._command = null, this._isAddingPointToTheStart = !1);
	}
	dispose() {
		this.cancel();
	}
}, Oi = class extends u {
	constructor(e, t, n) {
		super(e), this.options = n, this.name = "AddGuidePathCommand", this.isUndoable = !0, this.path = null, this.points = t.map((e) => e.clone());
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").pathController;
		return this.path ??= e.createPath(this.points, this.options), e.addObject(this.path), this.path;
	}
	async _undo() {
		this.path && this.viewer.getPlugin("Path").pathController.removeObject(this.path);
	}
}, ki = class extends u {
	constructor(e, t) {
		super(e), this.name = "AddFloodFillSeedCommand", this.isUndoable = !0, this.seed = null, this.position = t.clone();
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").floodFillController;
		return this.seed === null ? this.seed = e.addManualSeed(this.position) : e.restoreManualSeed(this.seed), this.seed;
	}
	async _undo() {
		this.seed !== null && this.viewer.getPlugin("Path").floodFillController.removeManualSeed(this.seed.id);
	}
}, Ai = class extends u {
	constructor(e, t) {
		super(e), this.seedId = t, this.name = "DeleteFloodFillSeedCommand", this.isUndoable = !0, this.seed = null;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").floodFillController.removeManualSeed(this.seedId);
		this.seed === null && e !== null && (this.seed = {
			...e,
			position: new Float64Array(e.position)
		});
	}
	async _undo() {
		this.seed !== null && this.viewer.getPlugin("Path").floodFillController.restoreManualSeed(this.seed);
	}
}, ji = class extends u {
	constructor(...e) {
		super(...e), this.isUndoable = !0, this.before = null;
	}
	get controller() {
		return this.viewer.getPlugin("Path").navigationGraphController;
	}
	async _do() {
		return this.before ??= this.controller.snapshot(), this.mutate();
	}
	async _undo() {
		this.before && this.controller.restore(this.before);
	}
}, Mi = class extends ji {
	constructor(e, t, n) {
		super(e), this.from = t, this.to = n, this.name = "AddNavigationEdgeCommand", this.edgeId = Ye.generateUUID();
	}
	mutate() {
		return this.controller.addEdge(this.from, this.to, { id: this.edgeId }).id;
	}
}, Ni = class extends ji {
	constructor(e, t, n) {
		super(e), this.previousNodeId = n, this.name = "AddSequentialNavigationNodeCommand", this.nodeId = Ye.generateUUID(), this.edgeId = Ye.generateUUID(), this.position = t.clone();
	}
	mutate() {
		this.controller.addNode(this.position, { id: this.nodeId });
		let e = this.controller.activeGraph, t = this.previousNodeId !== null && e?.nodes.has(this.previousNodeId);
		return t && this.controller.addEdge(this.previousNodeId, this.nodeId, { id: this.edgeId }), {
			nodeId: this.nodeId,
			edgeId: t ? this.edgeId : null
		};
	}
}, Pi = class extends u {
	get isUndoable() {
		return this.route !== null;
	}
	constructor(e) {
		super(e), this.name = "CalculateNavigationRouteCommand", this.route = null, this.pathCommand = null;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path"), t = e.navigationRoutingController;
		if (this.route) t.restoreRoute(this.route);
		else {
			if (this.route = t.calculateRoute(), !this.route) return null;
			this.pathCommand = new Oi(this.viewer, this.route.positions);
		}
		let n = this.pathCommand;
		if (!n) return null;
		let r = await n.execute({ addToUndoHistory: !1 });
		return t.setDisplayedPath(r), e.setNavigationToolsVisible(!1), this.viewer.viewport?.resetDefaultOperator(), this.route;
	}
	async _undo() {
		let e = this.viewer.getPlugin("Path");
		await this.pathCommand?.undo({ addToRedoHistory: !1 }), e.navigationRoutingController.clearRoute(), e.setNavigationToolsVisible(!0);
	}
}, Fi = class extends u {
	constructor(e) {
		super(e), this.name = "ClearNavigationRoutePointsCommand", this.isUndoable = !0, this.previousPositions = null;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").navigationRoutingController;
		this.previousPositions ??= {
			start: e.startPoint?.position.clone() ?? null,
			end: e.endPoint?.position.clone() ?? null
		}, e.clearPoints();
	}
	async _undo() {
		if (!this.previousPositions) return;
		let e = this.viewer.getPlugin("Path").navigationRoutingController;
		for (let t of ["start", "end"]) {
			let n = this.previousPositions[t];
			n && e.setPoint(t, n);
		}
	}
}, Ii = class extends u {
	constructor(e, t) {
		super(e), this.id = t, this.name = "CreateNavigationGraphCommand", this.isUndoable = !1;
	}
	async _do() {
		return this.viewer.getPlugin("Path").navigationGraphController.createGraph(this.id);
	}
	async _undo() {
		throw new te(this);
	}
}, Li = class extends ji {
	constructor(e, t) {
		super(e), this.elementId = t, this.name = "DeleteConnectedNavigationGraphCommand";
	}
	mutate() {
		this.controller.deleteConnectedComponent(this.elementId);
	}
}, Ri = class extends ji {
	constructor(e, t) {
		super(e), this.edgeId = t, this.name = "DeleteNavigationEdgeCommand";
	}
	mutate() {
		this.controller.deleteEdge(this.edgeId);
	}
}, zi = class extends u {
	constructor(e) {
		super(e), this.name = "DeleteNavigationGraphCommand", this.isUndoable = !0, this.graph = null;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").navigationGraphController;
		this.graph ??= e.snapshot(), e.clear();
	}
	async _undo() {
		this.graph && this.viewer.getPlugin("Path").navigationGraphController.setGraph(this.graph.clone(), !0);
	}
}, Bi = class extends ji {
	constructor(e, t) {
		super(e), this.nodeId = t, this.name = "DeleteNavigationNodeCommand";
	}
	mutate() {
		this.controller.deleteNode(this.nodeId);
	}
}, Vi = class extends u {
	constructor(e, t) {
		super(e), this.pointType = t, this.name = "DeleteNavigationRoutePointCommand", this.isUndoable = !0, this.previousPosition = null;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").navigationRoutingController, t = this.pointType === "start" ? e.startPoint : e.endPoint;
		this.previousPosition = t?.position.clone() ?? null, e.removePoint(this.pointType);
	}
	async _undo() {
		this.previousPosition && this.viewer.getPlugin("Path").navigationRoutingController.setPoint(this.pointType, this.previousPosition);
	}
}, Hi = class extends ji {
	constructor(e, t, n) {
		super(e), this.nodeIds = t, this.position = n, this.name = "MergeNavigationNodesCommand";
	}
	mutate() {
		return this.controller.mergeNodes(this.nodeIds, this.position).id;
	}
}, Ui = class extends ji {
	constructor(e, t, n) {
		super(e), this.nodeId = t, this.name = "MoveNavigationNodeCommand", this.isUpdatable = !0, this.geometryValidated = !1, this.position = n.clone();
	}
	mutate() {
		this.controller.moveNode(this.nodeId, this.position, !1), this.geometryValidated && this.controller.validateNodeGeometry(this.nodeId);
	}
	async update(e) {
		this.position.copy(e), this.controller.moveNode(this.nodeId, this.position, !1), await super.update();
	}
	validateGeometry() {
		this.controller.validateNodeGeometry(this.nodeId), this.geometryValidated = !0;
	}
}, Wi = class extends ji {
	constructor(e, t) {
		super(e), this.edgeId = t, this.name = "ReverseNavigationEdgeCommand";
	}
	mutate() {
		this.controller.reverseEdge(this.edgeId);
	}
}, Gi = class extends u {
	constructor(e) {
		super(e), this.name = "RevertNavigationGraphCommand", this.isUndoable = !1;
	}
	async _do() {
		this.viewer.getPlugin("Path").navigationGraphController.revert();
	}
	async _undo() {
		throw new te(this);
	}
}, Ki = class extends ji {
	constructor(e, t, n) {
		super(e), this.edgeId = t, this.direction = n, this.name = "SetNavigationEdgeDirectionCommand";
	}
	mutate() {
		this.controller.setEdgeDirection(this.edgeId, this.direction);
	}
}, qi = class extends ji {
	constructor(e, t, n, r) {
		super(e), this.type = t, this.id = n, this.accessible = r, this.name = "SetNavigationElementAccessibilityCommand";
	}
	mutate() {
		this.type === "node" ? this.controller.setNodeAccessible(this.id, this.accessible) : this.controller.setEdgeAccessible(this.id, this.accessible);
	}
}, Ji = /* @__PURE__ */ new A(), Yi = class e {
	static {
		this.formatVersion = 1;
	}
	constructor(e = Ye.generateUUID()) {
		this.id = e, this.nodes = /* @__PURE__ */ new Map(), this.edges = /* @__PURE__ */ new Map();
	}
	addNode(e, t = {}) {
		let n = t.id ?? Ye.generateUUID();
		if (this.nodes.has(n)) throw Error(`Navigation node "${n}" already exists.`);
		let r = {
			id: n,
			position: e.clone(),
			accessible: t.accessible ?? !0,
			source: t.source ?? "manual",
			edgeIds: /* @__PURE__ */ new Set(),
			positionValid: t.positionValid ?? !0,
			componentId: t.componentId ?? null
		};
		return this.nodes.set(n, r), r;
	}
	moveNode(e, t, n = !0) {
		let r = this.requireNode(e);
		r.position.copy(t), r.positionValid = n;
	}
	deleteNode(e) {
		let t = this.requireNode(e), n = Array.from(t.edgeIds);
		for (let e of n) this.deleteEdge(e);
		return this.nodes.delete(e), t;
	}
	addEdge(e, t, n = {}) {
		if (this.requireNode(e), this.requireNode(t), e === t) throw Error("A navigation edge cannot connect a node to itself.");
		if (this.findEdge(e, t)) throw Error("An edge already exists between these navigation nodes.");
		let r = n.id ?? Ye.generateUUID();
		if (this.edges.has(r)) throw Error(`Navigation edge "${r}" already exists.`);
		let i = {
			id: r,
			fromNodeId: e,
			toNodeId: t,
			direction: n.direction ?? "both",
			accessible: n.accessible ?? !0,
			geometryValid: n.geometryValid ?? !0,
			kind: n.kind ?? "horizontal"
		};
		return this.edges.set(r, i), this.nodes.get(e).edgeIds.add(r), this.nodes.get(t).edgeIds.add(r), i;
	}
	deleteEdge(e) {
		let t = this.requireEdge(e);
		return this.nodes.get(t.fromNodeId)?.edgeIds.delete(e), this.nodes.get(t.toNodeId)?.edgeIds.delete(e), this.edges.delete(e), t;
	}
	getConnectedNodeIds(e) {
		let t = [], n = this.nodes.get(e), r = this.edges.get(e);
		if (n) t.push(n.id);
		else if (r) t.push(r.fromNodeId, r.toNodeId);
		else throw Error(`Navigation element "${e}" does not exist.`);
		let i = /* @__PURE__ */ new Set(), a = Array.from(t);
		for (; a.length > 0;) {
			let e = a.pop();
			if (!i.has(e)) {
				i.add(e);
				for (let t of this.requireNode(e).edgeIds) {
					let n = this.requireEdge(t), r = n.fromNodeId === e ? n.toNodeId : n.fromNodeId;
					i.has(r) || a.push(r);
				}
			}
		}
		return i;
	}
	deleteConnectedComponent(e) {
		let t = this.getConnectedNodeIds(e);
		for (let e of t) this.deleteNode(e);
		return t;
	}
	reverseEdge(e) {
		let t = this.requireEdge(e);
		[t.fromNodeId, t.toNodeId] = [t.toNodeId, t.fromNodeId];
	}
	mergeNodes(e, t) {
		let n = Array.from(new Set(e));
		if (n.length < 2) throw Error("At least two nodes are required for a merge.");
		let r = n.map((e) => this.requireNode(e)), i = r[0], a = this.getMergedPosition(r, t), o = r.every((e) => e.accessible), s = this.getMergedEdgeData(r, new Set(n), i.id);
		for (let e of n.slice(1)) this.deleteNode(e);
		let c = Array.from(i.edgeIds);
		for (let e of c) this.deleteEdge(e);
		return i.position.copy(a), i.accessible = o, this.addMergedEdges(s), i;
	}
	getMergedEdgeData(e, t, n) {
		let r = [];
		for (let i of e) for (let e of i.edgeIds) {
			let i = this.edges.get(e);
			i && r.push({
				...i,
				fromNodeId: t.has(i.fromNodeId) ? n : i.fromNodeId,
				toNodeId: t.has(i.toNodeId) ? n : i.toNodeId
			});
		}
		return r;
	}
	getMergedPosition(e, t) {
		if (t === "first") return Ji.copy(e[0].position);
		if (t === "last") return Ji.copy(e.at(-1).position);
		Ji.set(0, 0, 0);
		for (let t of e) Ji.add(t.position);
		return Ji.multiplyScalar(1 / e.length);
	}
	addMergedEdges(e) {
		let t = /* @__PURE__ */ new Set();
		for (let n of e) {
			if (n.fromNodeId === n.toNodeId) continue;
			let e = [n.fromNodeId, n.toNodeId].sort(Xi).join(":");
			t.has(e) || this.findEdge(n.fromNodeId, n.toNodeId) || (t.add(e), this.addEdge(n.fromNodeId, n.toNodeId, n));
		}
	}
	findEdge(e, t) {
		let n = this.nodes.get(e);
		if (n) for (let r of n.edgeIds) {
			let n = this.edges.get(r);
			if (n && (n.fromNodeId === e && n.toNodeId === t || n.fromNodeId === t && n.toNodeId === e)) return n;
		}
	}
	validate() {
		let e = [], t = /* @__PURE__ */ new Set();
		for (let t of this.nodes.values()) t.positionValid || e.push({
			code: "invalid-position",
			elementId: t.id
		});
		for (let n of this.edges.values()) {
			(!this.nodes.has(n.fromNodeId) || !this.nodes.has(n.toNodeId)) && e.push({
				code: "missing-node",
				elementId: n.id
			}), n.fromNodeId === n.toNodeId && e.push({
				code: "self-edge",
				elementId: n.id
			});
			let r = [n.fromNodeId, n.toNodeId].sort(Xi).join(":");
			t.has(r) && e.push({
				code: "duplicate-edge",
				elementId: n.id
			}), t.add(r), n.geometryValid || e.push({
				code: "invalid-edge",
				elementId: n.id
			});
		}
		return e;
	}
	clone() {
		let t = new e(this.id);
		for (let e of this.nodes.values()) t.addNode(e.position, e);
		for (let e of this.edges.values()) t.addEdge(e.fromNodeId, e.toNodeId, e);
		return t;
	}
	requireNode(e) {
		let t = this.nodes.get(e);
		if (!t) throw Error(`Navigation node "${e}" does not exist.`);
		return t;
	}
	requireEdge(e) {
		let t = this.edges.get(e);
		if (!t) throw Error(`Navigation edge "${e}" does not exist.`);
		return t;
	}
};
function Xi(e, t) {
	return e.localeCompare(t);
}
//#endregion
//#region src/PathPlugin/navmesh/worker/NavigationMeshWorker.ts?worker&inline
var Zi = "(function(){var e=class{constructor(e){this.parents=new Int32Array(e);for(let t=0;t<e;t++)this.parents[t]=t}find(e){let t=e;for(;this.parents[t]!==t;)t=this.parents[t];for(;this.parents[e]!==e;){let n=this.parents[e];this.parents[e]=t,e=n}return t}merge(e,t){let n=this.find(e),r=this.find(t);n!==r&&(this.parents[r]=n)}};let t=65536;var n=class{constructor(){this.pages=[],this.count=0}get length(){return this.count}push(e,t){this.set(this.count++,e),this.set(this.count++,t)}pushPath(e,t,n){this.set(this.count++,e),this.set(this.count++,t),this.set(this.count++,t),this.set(this.count++,n)}get(e){return this.pages[Math.floor(e/t)][e%t]}toUint32Array(){let e=new Uint32Array(this.count),t=0;for(let n of this.pages){let r=Math.min(n.length,this.count-t);e.set(n.subarray(0,r),t),t+=r}return e}set(e,n){let r=Math.floor(e/t);r===this.pages.length&&this.pages.push(new Uint32Array(t)),this.pages[r][e%t]=n}};let r=1e-6,i=.1;function a(e,t){return e.positions[t*3]}function o(e,t){return e.positions[t*3+1]}function s(e,t){return e.positions[t*3+2]}function c(e,t,n){return e<t?e*n+t:t*n+e}let l=/* @__PURE__ */ function(e){return e[e.Unclassified=0]=`Unclassified`,e[e.Solid=1]=`Solid`,e[e.Navigable=2]=`Navigable`,e}({});function u(e,t,n,r){n.sourceComponentIds[r]=e.sourceComponentIds[t],n.verticalAllowed[r]=e.verticalAllowed[t],n.horizontalAllowed[r]=e.horizontalAllowed[t],n.supportIds[r]=e.supportIds[t]}function d(e,t,n){let r=Math.max(Math.abs(t),Math.abs(n));return r<=1e-6?0:e/2/r}function f(e,t,r,i=/* @__PURE__ */ new Set){let a=new n;for(let n=0;n<e.length;n+=2){let o=t[e.get(n)],s=t[e.get(n+1)];if(o===s)continue;let l=c(o,s,r);i.has(l)||(i.add(l),a.push(o,s))}return a}function p(t,n){let r=new e(t.count);for(let e=0;e<n.length;e+=2){let i=n.get(e),a=n.get(e+1);t.verticalAllowed[i]===1&&t.verticalAllowed[a]===1&&t.supportIds[i]>=0&&t.supportIds[i]===t.supportIds[a]&&Math.abs(o(t,i)-o(t,a))<=1e-6&&r.merge(i,a)}return r}function m(e,t){let n=/* @__PURE__ */ new Map;for(let r=0;r<e.count;r++){if(e.verticalAllowed[r]!==1)continue;let i=t.find(r),a=n.get(i)??[];a.push(r),n.set(i,a)}return n}function h(e,t,n){let r=new Float64Array(e.count),i=new Float64Array(e.count);for(let c=0;c<t.length;c+=2){let l=t.get(c),u=t.get(c+1),d=o(e,u)-o(e,l);if(Math.abs(d)<=1e-6)continue;let f=d>0?l:u,p=d>0?u:l,m=a(e,p)-a(e,f),h=s(e,p)-s(e,f),g=Math.hypot(m,h);if(!(g<=1e-6))for(let t of[f,p]){if(e.verticalAllowed[t]!==1)continue;let a=n.find(t);r[a]+=m/g,i[a]+=h/g}}return{x:r,z:i}}function g(e,t){let n=new Uint32Array(e.count),r=/* @__PURE__ */ new Map,i=0;for(let a=0;a<e.count;a++){if(e.verticalAllowed[a]!==1){n[a]=i++;continue}let o=t.find(a),s=r.get(o);s===void 0&&(s=i++,r.set(o,s)),n[a]=s}return{indices:n,outputIndexByTread:r,count:i}}function _(e){return{count:e,positions:new Float64Array(e*3),sizes:new Float32Array(e),sourceComponentIds:new Int32Array(e),verticalAllowed:new Uint8Array(e),horizontalAllowed:new Uint8Array(e),supportIds:new Int32Array(e).fill(-1)}}function v(e,t,n){for(let r=0;r<e.count;r++){if(e.verticalAllowed[r]===1)continue;let i=t[r];n.positions.set(e.positions.subarray(r*3,r*3+3),i*3),n.sizes[i]=e.sizes[r],u(e,r,n,i)}}function y(e,t,n,r,i,c){for(let[l,f]of t){let t=n.get(l);if(t===void 0)continue;let p=Math.hypot(r[l],i[l]),m=p>1e-6?r[l]/p:0,h=p>1e-6?i[l]/p:0,g=-h,_=m,v=1/0,y=1/0,b=-1/0,x=0,S=0,C=0;for(let n of f){let r=a(e,n),i=o(e,n),l=s(e,n);if(x+=r,S+=i,C+=l,c.sizes[t]=Math.max(c.sizes[t],e.sizes[n]),p<=1e-6)continue;v=Math.min(v,r*m+l*h-d(e.sizes[n],m,h));let u=r*g+l*_,f=d(e.sizes[n],g,_);y=Math.min(y,u-f),b=Math.max(b,u+f)}let w=t*3;if(p>1e-6){let e=(y+b)/2;c.positions[w]=m*v+g*e,c.positions[w+2]=h*v+_*e}else c.positions[w]=x/f.length,c.positions[w+2]=C/f.length;c.positions[w+1]=S/f.length,u(e,f[0],c,t)}}function b(e,t,n,r){let i=p(e,t),a=m(e,i),o=h(e,n,i),s=g(e,i),c=_(s.count);v(e,s.indices,c),y(e,a,s.outputIndexByTread,o.x,o.z,c);let l=/* @__PURE__ */ new Set,u=f(n,s.indices,s.count,l);return{cells:c,horizontalEdges:f(t,s.indices,s.count,l),verticalEdges:u,landingConnections:f(r,s.indices,s.count)}}function x(e,t,n,r){let i=a(e,n)-a(e,t),c=s(e,n)-s(e,t),l=Math.hypot(i,c);if(l<=1e-6)return!1;let u=i/l,f=c/l,p=d(e.sizes[t],u,f),m=d(e.sizes[n],u,f);if(p+m>l){let e=l/(p+m);p*=e,m*=e}return r[0]=a(e,t)+u*p,r[1]=o(e,t),r[2]=s(e,t)+f*p,r[3]=a(e,n)-u*m,r[4]=o(e,n),r[5]=s(e,n)-f*m,!0}function S(e,t){let n=/* @__PURE__ */ new Set;for(let r=0;r<t.length;r+=2){let i=t.get(r),o=t.get(r+1);Math.hypot(a(e,o)-a(e,i),s(e,o)-s(e,i))<=1e-6||n.add(c(i,o,e.count))}return n}function C(e,t){let n=_(e.count+t);return n.positions.set(e.positions),n.sizes.set(e.sizes),n.sourceComponentIds.set(e.sourceComponentIds),n.verticalAllowed.set(e.verticalAllowed),n.horizontalAllowed.set(e.horizontalAllowed),n.supportIds.set(e.supportIds),n}function w(e,t,n,r,i,c){let l=e.verticalAllowed[r]===1,f=l?r:i,p=l?i:r,m=a(e,p)-a(e,f),h=s(e,p)-s(e,f),g=Math.hypot(m,h);if(g<=1e-6)return!1;let _=m/g,v=h/g,y=Math.min(g,d(e.sizes[p],_,v));return t.positions[c*3]=a(e,p)-_*y,t.positions[c*3+1]=o(e,p),t.positions[c*3+2]=s(e,p)-v*y,u(e,p,t,c),n.pushPath(f,c,p),!0}function T(e,t,r,i){let a=new n,o=e.count;for(let n=0;n<r.length;n+=2){let s=r.get(n),l=r.get(n+1);if(!i.has(c(s,l,e.count))){a.push(s,l);continue}w(e,t,a,s,l,o)?o++:a.push(s,l)}return a}function E(e,t,n){if(n.length===0)return{cells:e,verticalEdges:t};let r=S(e,n);if(r.size===0)return{cells:e,verticalEdges:t};let i=C(e,r.size);return{cells:i,verticalEdges:T(e,i,t,r)}}function D(e,t){return Math.floor(e/t)}function O(e,t){return Math.floor((e-r)/t)}function k(e,t,n,r,i,a){let o=D(n,t),s=O(i,t),c=D(r,t),l=O(a,t);for(let t=o;t<=s;t++)for(let n=c;n<=l;n++)if(e.has(`${t}:${n}`))return!0;return!1}function A(e,t,n,r,i){let a=D(i[0],n),o=O(i[3],n),s=D(i[2],n),c=O(i[5],n);for(let n=a;n<=o;n++)for(let i=s;i<=c;i++){let a=`${n}:${i}`;if(!t.has(a))continue;let o=e.get(a)??[];o.push(r),e.set(a,o)}}function j(e,t,n){let r=n*3,i=e.granularities[t.levels[n]],a=e.origin[0]+t.coordinates[r]*i,o=e.origin[1]+t.coordinates[r+1]*i,s=e.origin[2]+t.coordinates[r+2]*i,c=t.supportHeights?.[n]??NaN,l=Number.isFinite(c)?Math.min(o+i,Math.max(o,c)):o+i;return[a,o,s,a+i,l,s+i]}function ee(e,t,n){let r=[],i=[],a=[],o=/* @__PURE__ */ new Map;for(let s of e.chunks)if(k(t,n,s.bounds[0],s.bounds[2],s.bounds[3],s.bounds[5]))for(let c=0;c<s.states.length;c++){if(s.states[c]!==l.Solid)continue;let u=j(e,s,c);if(!k(t,n,u[0],u[2],u[3],u[5]))continue;let d=r.length/6;r.push(...u),i.push(s.supportIds?.[c]??-1),a.push(s.verticalConnections?.[c]??0),A(o,t,n,d,u)}return{bounds:Float64Array.from(r),supportIds:Int32Array.from(i),verticalConnections:Uint8Array.from(a),idsByBucket:o}}function te(e,t,n){let r=e.supportIds[t];return r>=0&&r===e.supportIds[n]?r:-1}function ne(e,t,n,r,i){if(Math.abs(n)<=1e-6)return t>=r&&t<=i;let a=(r-t)/n,o=(i-t)/n;return e[0]=Math.max(e[0],Math.min(a,o)),e[1]=Math.min(e[1],Math.max(a,o)),e[0]<=e[1]}function re(e,t,n,i){let{bounds:a,intersectionRange:o}=e,s=t*6;return o[0]=i.startRatio,o[1]=i.endRatio,!ne(o,n.firstX,n.deltaX,a[s]-1e-6,a[s+3]+1e-6)||!ne(o,n.firstZ,n.deltaZ,a[s+2]-1e-6,a[s+5]+1e-6)?!1:ne(o,n.firstY,n.deltaY,a[s+1]-2+r,a[s+4]-r)}function ie(e,t,n,r){let i=Math.max(Math.abs(t)/r,Math.abs(n)/r);return e/2/i}function ae(e,t,n){let{bounds:r,cells:i}=e,o=t*6,c=i.sizes[n]/2,l=a(i,n),u=s(i,n);return r[o]<=l+c+1e-6&&r[o+3]>=l-c-1e-6&&r[o+2]<=u+c+1e-6&&r[o+5]>=u-c-1e-6}function oe(e,t,n,a){if(e.verticalConnections[t]!==1)return!1;let s=e.supportIds[t],c=e.cells.supportIds[n];if(s!==-1&&s!==c||!ae(e,t,n)||!ae(e,t,a))return!1;let l=t*6,u=e.bounds[l+4]-e.bounds[l+1],d=o(e.cells,a),f=Math.min(i,u/2);return e.bounds[l+4]<=d+f+r}function se(e){e.visitId=e.visitId+1>>>0,e.visitId===0&&(e.visited.fill(0),e.visitId=1)}function ce(e,t,n,r,i,a){se(e);for(let o=t;o<=n;o++)for(let t=r;t<=i;t++)for(let n of e.idsByBucket.get(`${o}:${t}`)??[])if(e.visited[n]!==e.visitId&&(e.visited[n]=e.visitId,a(n)))return!0;return!1}function le(e,t){let{bounds:n,bucketSize:i}=e,a=te(e.cells,t.firstIndex,t.secondIndex),o=Math.min(t.firstY,t.secondY)+r,s=Math.max(t.firstY,t.secondY)-r;return o>=s||!ce(e,D(t.x-r,i),O(t.x+r,i),D(t.z-r,i),O(t.z+r,i),r=>{if(a>=0&&e.supportIds[r]===a)return!1;let i=r*6,c=t.x>=n[i]-1e-6&&t.x<=n[i+3]+1e-6&&t.z>=n[i+2]-1e-6&&t.z<=n[i+5]+1e-6,l=n[i+1]<s&&n[i+4]>o;return c&&l})}function ue(e,t,n){let{cells:i}=e,c=i.verticalAllowed[t]!==i.verticalAllowed[n]&&i.sourceComponentIds[t]===i.sourceComponentIds[n]&&i.supportIds[t]>=0&&i.supportIds[n]>=0,l=c&&x(i,t,n,e.anchorPositions),u=l?e.anchorPositions[0]:a(i,t),d=l?e.anchorPositions[1]:o(i,t),f=l?e.anchorPositions[2]:s(i,t),p=l?e.anchorPositions[3]:a(i,n),m=l?e.anchorPositions[4]:o(i,n),h=l?e.anchorPositions[5]:s(i,n),g={firstX:u,firstY:d,firstZ:f,deltaX:p-u,deltaY:m-d,deltaZ:h-f},_=Math.hypot(g.deltaX,g.deltaZ),v=0,y=_;return!l&&_>1e-6&&(v=ie(i.sizes[t],g.deltaX,g.deltaZ,_),y-=ie(i.sizes[n],g.deltaX,g.deltaZ,_)),{segment:g,gap:{startRatio:_>1e-6?(v+r*2)/_:0,endRatio:_>1e-6?(y-r*2)/_:1},joinsLanding:c,landingHeight:Math.max(d,m),stairIndex:i.verticalAllowed[t]===1?t:n,landingIndex:i.verticalAllowed[t]===1?n:t}}function de(e,t,n,r,i,a){let o=e.supportIds[n];if(a>=0&&(o===a||e.verticalConnections[n]===1))return!0;let s=e.bounds[n*6+4];return t.joinsLanding&&(o===r||o===i)&&s<=t.landingHeight+1e-6?!0:t.joinsLanding&&oe(e,n,t.stairIndex,t.landingIndex)}function fe(e,t,n){let{cells:i,bucketSize:a}=e,o=i.supportIds[t],s=i.supportIds[n],c=te(i,t,n),l=ue(e,t,n),{segment:u,gap:d}=l;if(Math.hypot(u.deltaX,u.deltaZ)<=1e-6)return le(e,{x:u.firstX,firstY:u.firstY,z:u.firstZ,secondY:u.firstY+u.deltaY,firstIndex:t,secondIndex:n});if(d.startRatio>=d.endRatio)return!0;let f=u.firstX+u.deltaX*d.startRatio,p=u.firstZ+u.deltaZ*d.startRatio,m=u.firstX+u.deltaX*d.endRatio,h=u.firstZ+u.deltaZ*d.endRatio;return!ce(e,D(Math.min(f,m)-r,a),O(Math.max(f,m)+r,a),D(Math.min(p,h)-r,a),O(Math.max(p,h)+r,a),t=>!de(e,l,t,o,s,c)&&re(e,t,u,d))}function pe(e,t,n,r){let i=ee(e,n,r),a={...i,cells:t,bucketSize:r,visited:new Uint32Array(i.bounds.length/6),visitId:0,intersectionRange:/* @__PURE__ */ new Float64Array(2),anchorPositions:/* @__PURE__ */ new Float64Array(6)};return(e,t)=>fe(a,e,t)}let me=Math.cos(45*Math.PI/180);function he(e){let t=0,n=0;for(let r=0;r<e.count;r++)e.verticalAllowed[r]===1&&(t++,n=Math.max(n,e.sizes[r]));return{count:t,largestSize:n}}function ge(e,t){let n=/* @__PURE__ */ new Set;for(let r=0;r<e.count;r++){if(e.verticalAllowed[r]!==1)continue;let i=Math.floor(a(e,r)/t),o=Math.floor(s(e,r)/t);for(let e=i-1;e<=i+1;e++)for(let t=o-1;t<=o+1;t++)n.add(`${e}:${t}`)}return n}function _e(e,t,n){let r=/* @__PURE__ */ new Set;for(let i of[t,n])for(let t=0;t<i.length;t+=2){let n=i.get(t),a=i.get(t+1);(e.verticalAllowed[n]===1||e.verticalAllowed[a]===1)&&r.add(c(n,a,e.count))}return r}function ve(e,t,n){let r=/* @__PURE__ */ new Map;for(let i=0;i<e.count;i++){let o=`${Math.floor(a(e,i)/n)}:${Math.floor(s(e,i)/n)}`;if(!t.has(o))continue;let c=r.get(o)??[];c.push(i),r.set(o,c)}return r}function ye(e,t,n,r){let i=he(e);if(i.count===0)return null;let a=i.largestSize*2,o=a*6,s=t.maximumHeightDifference*2,c=Math.tan(t.maximumSlopeAngle*Math.PI/180),l=ge(e,o);return{buckets:ve(e,l,o),requiredBuckets:l,existingEdges:_e(e,n,r),localBridgeDistance:a,bridgeDistance:o,localMaximumHeight:s,maximumSlopeTangent:c}}function be(e,t,n,r,i){if(r===n)return;let c=e.sourceComponentIds[r]===e.sourceComponentIds[n],l=e.supportIds[n]>=0&&e.supportIds[n]===e.supportIds[r];if(!c&&e.verticalAllowed[r]!==1&&!l)return;let u=Math.hypot(a(e,n)-a(e,r),s(e,n)-s(e,r)),d=o(e,r)-o(e,n),f=l?Math.max(t.localMaximumHeight,u*t.maximumSlopeTangent):t.localMaximumHeight;if(u>t.bridgeDistance+1e-6||Math.abs(d)>f+1e-6||u>t.localBridgeDistance+1e-6&&!l)return;let p=Math.hypot(u,d);e.verticalAllowed[r]===0&&Math.abs(d)<=.1&&p<i.levelDistance&&(i.level=r,i.levelDistance=p),d>1e-6&&p<i.higherDistance&&(i.higher=r,i.higherDistance=p),d<-1e-6&&p<i.lowerDistance&&(i.lower=r,i.lowerDistance=p)}function xe(e,t,n){let r={higher:null,lower:null,level:null,higherDistance:1/0,lowerDistance:1/0,levelDistance:1/0},i=Math.floor(a(e,n)/t.bridgeDistance),o=Math.floor(s(e,n)/t.bridgeDistance);for(let a=i-1;a<=i+1;a++)for(let i=o-1;i<=o+1;i++)for(let o of t.buckets.get(`${a}:${i}`)??[])be(e,t,n,o,r);return r}function Se(e,t,n){for(let r=0;r<e.count;r++){if(e.verticalAllowed[r]!==1)continue;let i=xe(e,t,r);n(r,i.higher),n(r,i.lower),n(r,i.level)}}function Ce(e,t){let n=new Uint8Array(e.count),r=new Float64Array(e.count),i=new Float64Array(e.count);for(let c=0;c<t.length;c+=2){let l=t.get(c),u=t.get(c+1);if(e.verticalAllowed[l]!==1||e.verticalAllowed[u]!==1)continue;let d=o(e,u)-o(e,l);if(Math.abs(d)<=1e-6)continue;let f=d>0?l:u,p=d>0?u:l;n[p]=1;let m=a(e,p)-a(e,f),h=s(e,p)-s(e,f),g=Math.hypot(m,h);g<=1e-6||(r[f]+=m/g,i[f]+=h/g)}return{hasLowerStair:n,uphillX:r,uphillZ:i}}function we(e,t,n,r,i,c){if(e.verticalAllowed[r]===1||e.sourceComponentIds[r]!==e.sourceComponentIds[n])return null;let l=a(e,r)-a(e,n),u=s(e,r)-s(e,n),d=Math.hypot(l,u),f=o(e,r)-o(e,n);return d<=1e-6||d>t.localBridgeDistance+1e-6||Math.abs(f)>t.localMaximumHeight+1e-6||f>.100001||(l*i+u*c)/d<me?null:Math.hypot(d,f)}function Te(e,t,n,r,i){let o=Math.floor(a(e,n)/t.bridgeDistance),c=Math.floor(s(e,n)/t.bridgeDistance),l=null,u=1/0;for(let a=o-1;a<=o+1;a++)for(let o=c-1;o<=c+1;o++)for(let s of t.buckets.get(`${a}:${o}`)??[]){let a=we(e,t,n,s,r,i);a===null||a>=u||(l=s,u=a)}return l}function Ee(e,t,n,r){let i=Ce(e,n);for(let n=0;n<e.count;n++){let a=Math.hypot(i.uphillX[n],i.uphillZ[n]);if(e.verticalAllowed[n]!==1||i.hasLowerStair[n]===1||a<=1e-6)continue;let o=Te(e,t,n,-i.uphillX[n]/a,-i.uphillZ[n]/a);r(n,o,!0)}}function De(e,t,n){let r=new Float64Array(e.count),i=new Float64Array(e.count),c=new Uint32Array(e.count),l=(t,n)=>{if(e.verticalAllowed[t]!==1&&e.verticalAllowed[n]!==1||Math.abs(o(e,t)-o(e,n))<=1e-6)return;let l=a(e,n)-a(e,t),u=s(e,n)-s(e,t),d=Math.hypot(l,u);if(!(d<=1e-6)){l/=d,u/=d,(l<-1e-6||Math.abs(l)<=1e-6&&u<0)&&(l=-l,u=-u);for(let a of[t,n])e.verticalAllowed[a]===1&&(r[a]+=l,i[a]+=u,c[a]++)}};for(let e of[t,n])for(let t=0;t<e.length;t+=2)l(e.get(t),e.get(t+1));for(let t=0;t<e.count;t++){let e=Math.hypot(r[t],i[t]);e<=1e-6||(r[t]/=e,i[t]/=e)}return{directionX:r,directionZ:i,directionCount:c}}function Oe(e,t,n,r,i,c,l){if(c<=i||e.verticalAllowed[c]!==1||r.directionCount[c]===0||t.find(i)===t.find(c)||e.supportIds[i]===e.supportIds[c])return null;let u=a(e,c)-a(e,i),d=s(e,c)-s(e,i),f=Math.hypot(u,d);if(f<=n.localBridgeDistance+1e-6||f>n.bridgeDistance+1e-6)return null;let p=Math.abs(o(e,c)-o(e,i)),m=Math.max(n.localMaximumHeight,f*n.maximumSlopeTangent);if(p<=1e-6||p>m+1e-6)return null;let h=u/f,g=d/f,_=Math.abs(h*r.directionX[i]+g*r.directionZ[i]),v=Math.abs(h*r.directionX[c]+g*r.directionZ[c]),y=Math.abs(r.directionX[i]*r.directionX[c]+r.directionZ[i]*r.directionZ[c]);return Math.min(_,v,y)<l?null:{first:i,second:c,distance:Math.hypot(f,p)}}function ke(e,t,n,r){let i=[],o=Math.cos(30*Math.PI/180);for(let c=0;c<e.count;c++){if(e.verticalAllowed[c]!==1||r.directionCount[c]===0)continue;let l=Math.floor(a(e,c)/n.bridgeDistance),u=Math.floor(s(e,c)/n.bridgeDistance);for(let a=l-1;a<=l+1;a++)for(let s=u-1;s<=u+1;s++)for(let l of n.buckets.get(`${a}:${s}`)??[]){let a=Oe(e,t,n,r,c,l,o);a&&i.push(a)}}return i.sort((e,t)=>e.distance-t.distance),i}function Ae(e,t,r,i,a,o){let s=new n,l=ye(t,r,i,a);if(!l)return s;let u=pe(e,t,l.requiredBuckets,l.bridgeDistance),d=(e,n,r=!1)=>{if(n===null||!r&&o.find(e)===o.find(n))return;let i=c(e,n,t.count);l.existingEdges.has(i)||u(e,n)&&(l.existingEdges.add(i),a.push(e,n),t.verticalAllowed[e]!==t.verticalAllowed[n]&&s.push(e,n),o.merge(e,n))};Se(t,l,(e,t)=>{d(e,t,!0)}),Ee(t,l,a,d);let f=ke(t,o,l,De(t,i,a));for(let e of f)d(e.first,e.second);return s}function je(e,t,n,i){return Math.min(t,i)-Math.max(e,n)>r}function Me(e,t,n,r){return Math.min(t,r)-Math.max(e,n)>=-1e-6}function Ne(e,t,n,r){let i=e.sizes[t],c=e.sizes[n];if(r===`z`){let r=a(e,t),o=a(e,n);return je(r-i/2,r+i/2,o-c/2,o+c/2)}let l=s(e,t),u=s(e,n),d=je(l-i/2,l+i/2,u-c/2,u+c/2);return Me(l-i/2,l+i/2,u-c/2,u+c/2)&&(d||Math.abs(o(e,t)-o(e,n))>1e-6)}function Pe(e,t,n,i){let c=Math.abs(o(e,t)-o(e,n)),l=c>r,u=e.verticalAllowed[t]===1||e.verticalAllowed[n]===1,d=e.horizontalAllowed[t]===1||e.horizontalAllowed[n]===1,f=e.supportIds[t],p=e.supportIds[n];if(f>=0&&p>=0&&f!==p&&c>.1&&!u&&!d)return null;if(l){let r=Math.hypot(a(e,t)-a(e,n),s(e,t)-s(e,n)),o=Math.atan2(c,r)*180/Math.PI;if(u||d?c>i.maximumHeightDifference+1e-6:o>i.maximumSlopeAngle)return null}return l&&u?`vertical`:`horizontal`}function Fe(e,t,n){let{cells:r,axis:i,options:a}=e;if(t===n||!Ne(r,t,n,i))return;let o=Pe(r,t,n,a);o&&((o===`vertical`?e.verticalEdges:e.horizontalEdges).push(t,n),e.components.merge(t,n))}function Ie(e,t,n){let{cells:r,axis:i}=e,o=i===`x`?s:a,c=i===`x`,l=Uint32Array.from(t),u=Uint32Array.from(n),d=(e,t)=>o(r,e)-r.sizes[e]/2-(o(r,t)-r.sizes[t]/2);l.sort(d),u.sort(d);let f=0;for(let t of l){let n=r.sizes[t],i=o(r,t)-n/2,a=o(r,t)+n/2;for(;f<u.length;){let e=u[f],t=o(r,e)+r.sizes[e]/2;if(c?t>=i-1e-6:t>i+1e-6)break;f++}for(let n=f;n<u.length;n++){let i=u[n],s=r.sizes[i],l=o(r,i)-s/2;if(c?l>a+1e-6:l>=a-1e-6)break;Fe(e,t,i)}}}function Le(e,t){let n=new Float64Array(e.count),r=new Float64Array(e.count);for(let i=0;i<e.count;i++){let o=t===`x`?a(e,i):s(e,i),c=e.sizes[i]/2;n[i]=o-c,r[i]=o+c}return{minimum:n,maximum:r}}function Re(e,t,n){let r=n[e[t]],i=t+1;for(;i<e.length&&!(Math.abs(n[e[i]]-r)>1e-6);)i++;return i}function ze(e,t,n,r,i,a){let o=Le(e,t),s=new Uint32Array(e.count),c=new Uint32Array(e.count);for(let t=0;t<e.count;t++)s[t]=t,c[t]=t;s.sort((e,t)=>o.minimum[e]-o.minimum[t]),c.sort((e,t)=>o.maximum[e]-o.maximum[t]);let l=0,u=0;for(;l<e.count&&u<e.count;){let d=o.minimum[s[l]],f=o.maximum[c[u]];if(f<d-1e-6){u=Re(c,u,o.maximum);continue}if(d<f-1e-6){l=Re(s,l,o.minimum);continue}let p=Re(s,l,o.minimum),m=Re(c,u,o.maximum);Ie({cells:e,axis:t,options:n,horizontalEdges:r,verticalEdges:i,components:a},c.subarray(u,m),s.subarray(l,p)),l=p,u=m}}function Be(e,t,n,r,i,a){return ze(t,`x`,n,r,i,a),ze(t,`z`,n,r,i,a),Ae(e,t,n,r,i,a)}function Ve(e,t,n,r){return(Math.imul(e,73856093)^Math.imul(t,19349663)^Math.imul(n,83492791)^Math.imul(r,2654435761))>>>0}function He(e,t,n){return`${e}:${t}:${n}`}function Ue(e){let t=0;for(let n of e.chunks)for(let e of n.states)e===l.Navigable&&t++;return t}var We=class{constructor(e){this.heads=/* @__PURE__ */ new Map,this.count=0,this.next=new Int32Array(e),this.next.fill(-1),this.coordinates=new Int32Array(e*2),this.levels=new Uint8Array(e),this.previousTops=new Float64Array(e)}isContinuous(e,t,n,i,a){let o=Ve(e,0,t,n),s=this.heads.get(o)??-1;for(;s>=0;){let o=s*2;if(this.coordinates[o]===e&&this.coordinates[o+1]===t&&this.levels[s]===n){let e=i<=this.previousTops[s]+r;return this.previousTops[s]=Math.max(this.previousTops[s],a),e}s=this.next[s]}let c=this.count++,l=c*2;return this.coordinates[l]=e,this.coordinates[l+1]=t,this.levels[c]=n,this.previousTops[c]=a,this.next[c]=this.heads.get(o)??-1,this.heads.set(o,c),!1}},Ge=class{constructor(e,t){this.grid=e,this.heads=/* @__PURE__ */ new Map,this.count=0;let n=0;for(let e of t)for(let t of e.states)t===l.Solid&&n++;this.next=new Int32Array(n),this.next.fill(-1),this.coordinates=new Int32Array(n*3),this.levels=new Uint8Array(n),this.verticalAllowed=new Uint8Array(n),this.heights=new Float32Array(n),this.supportIds=new Int32Array(n),this.supportIds.fill(-1);for(let e of t)this.addChunk(e)}find(e,t,n,r=0){let i=!1,a=!1,o=-1/0,s=-1;for(let c=0;c<this.grid.granularities.length;c++){let l=this.grid.granularities[c],u=Math.floor((e-this.grid.origin[0])/l),d=Math.floor((n-this.grid.origin[2])/l),f=Math.round((t-this.grid.origin[1])/l)-1,p=Math.floor((t-r-this.grid.origin[1])/l)-1;for(let e=f;e>=p;e--){let n=this.heads.get(Ve(u,e,d,c))??-1;for(;n>=0;){let r=n*3,l=this.heights[n];this.coordinates[r]===u&&this.coordinates[r+1]===e&&this.coordinates[r+2]===d&&this.levels[n]===c&&Number.isFinite(l)&&l<=t+1e-6&&(i=!0,a||=this.verticalAllowed[n]===1,l>o&&(o=l,s=this.supportIds[n])),n=this.next[n]}}}return{found:i,verticalAllowed:a,height:o,supportId:s}}addChunk(e){for(let t=0;t<e.states.length;t++){if(e.states[t]!==l.Solid)continue;let n=this.count++,r=t*3,i=n*3,a=e.coordinates[r],o=e.coordinates[r+1],s=e.coordinates[r+2],c=e.levels[t],u=Ve(a,o,s,c);this.coordinates[i]=a,this.coordinates[i+1]=o,this.coordinates[i+2]=s,this.levels[n]=c,this.verticalAllowed[n]=e.verticalConnections?.[t]??0,this.heights[n]=e.supportHeights?.[t]??this.grid.origin[1]+(o+1)*this.grid.granularities[c],this.supportIds[n]=e.supportIds?.[t]??-1,this.next[n]=this.heads.get(u)??-1,this.heads.set(u,n)}}};function Ke(e){let t=/* @__PURE__ */ new Map,n=/* @__PURE__ */ new Map,r=0;for(let i of e)t.set(He(i.rootCoordinates[0],i.rootCoordinates[1],i.rootCoordinates[2]),i),n.set(i,r),r+=i.states.length;return{chunkByRoot:t,globalOffsets:n}}function qe(e,t){let n=0;for(let t of e.states)t===l.Navigable&&n++;let r=new Uint32Array(n),i=0;for(let t=0;t<e.states.length;t++)e.states[t]===l.Navigable&&(r[i++]=t);return r.sort((n,r)=>{let i=e.levels[n],a=e.levels[r];return e.coordinates[n*3+1]*t[i]-e.coordinates[r*3+1]*t[a]}),r}function Je(e,t,n,r,i,a,o){let s=n*3,c=t.coordinates[s],l=t.coordinates[s+1],u=t.coordinates[s+2],d=t.levels[n],f=e.granularities[d],p=e.origin[1]+l*f;if(a.isContinuous(c,u,d,p,p+f))return!1;let m=e.origin[0]+(c+.5)*f,h=e.origin[2]+(u+.5)*f,g=t.horizontalConnections?.[n]===1,_=i.find(m,p,h,g?f:0);if(!_.found&&!g)return!1;let v=o.count,y=v*3;return o.positions[y]=m,o.positions[y+1]=_.found?_.height:p,o.positions[y+2]=h,o.sizes[v]=f,o.sourceComponentIds[v]=e.classification.componentIds[r+n],o.verticalAllowed[v]=+!!_.verticalAllowed,o.horizontalAllowed[v]=t.horizontalConnections?.[n]??0,o.supportIds[v]=_.supportId,o.count++,!0}function Ye(e){let t=Ue(e),n=new Float64Array(t*3),r=new Float32Array(t),i=new Int32Array(t),a=new Uint8Array(t),o=new Uint8Array(t),s=new Int32Array(t);s.fill(-1);let c=new We(t),{chunkByRoot:l,globalOffsets:u}=Ke(e.chunks),d=[...e.chunks].sort((e,t)=>e.rootCoordinates[1]-t.rootCoordinates[1]),f={count:0,positions:n,sizes:r,sourceComponentIds:i,verticalAllowed:a,horizontalAllowed:o,supportIds:s};for(let t of d){let[n,r,i]=t.rootCoordinates,a=l.get(He(n,r-1,i)),o=new Ge(e,a?[t,a]:[t]),s=u.get(t),d=qe(t,e.granularities);for(let n of d)Je(e,t,n,s,o,c,f)}let{count:p}=f;return{count:p,positions:n.subarray(0,p*3),sizes:r.subarray(0,p),sourceComponentIds:i.subarray(0,p),verticalAllowed:a.subarray(0,p),horizontalAllowed:o.subarray(0,p),supportIds:s.subarray(0,p)}}function Xe(e,t){return e.horizontalAllowed[t]===1}function Ze(e){return{count:e,positions:new Float64Array(e*3),sizes:new Float32Array(e),sourceComponentIds:new Int32Array(e),verticalAllowed:new Uint8Array(e),horizontalAllowed:new Uint8Array(e),supportIds:new Int32Array(e).fill(-1)}}function Qe(e,t,r,i,a){let o=new n,s=a?/* @__PURE__ */ new Set:null;for(let n=0;n<e.length;n+=2){let l=t[e.get(n)],u=t[e.get(n+1)];if(l===u)continue;let d=c(l,u,r);if(i.has(d)||s?.has(d))continue;s?.add(d);let f=a&&(a.clusterCounts[l]>1||a.clusterCounts[u]>1),p=a&&(Xe(a.cells,l)||Xe(a.cells,u));(!f||p||a.edgeIsClear(a.cells,l,u))&&(i.add(d),o.push(l,u))}return o}function $e(e,t){let n=new Uint32Array(t);for(let t of e)n[t]++;return n}function et(t,n,r){let i=new Uint8Array(t.count);for(let e=0;e<t.count;e++)(t.verticalAllowed[e]===1||t.horizontalAllowed[e]===1)&&(i[e]=1);let o=(e,n)=>i[e]===0&&i[n]===0&&t.supportIds[e]>=0&&t.supportIds[e]===t.supportIds[n]&&Math.floor(a(t,e)/r)===Math.floor(a(t,n)/r)&&Math.floor(s(t,e)/r)===Math.floor(s(t,n)/r),c=new e(t.count);for(let e=0;e<n.length;e+=2){let t=n.get(e),r=n.get(e+1);o(t,r)&&c.merge(t,r)}return c}function tt(e,t){let n=/* @__PURE__ */ new Map,r=new Uint32Array(t);for(let i=0;i<t;i++){let t=e.find(i),a=n.get(t);a===void 0&&(a=n.size,n.set(t,a)),r[i]=a}return{remap:r,count:n.size}}function nt(e,t,n){let r=Ze(n),i=new Uint32Array(n);for(let n=0;n<e.count;n++){let c=t[n],l=c*3;r.positions[l]+=a(e,n),r.positions[l+1]+=o(e,n),r.positions[l+2]+=s(e,n),r.sizes[c]=Math.max(r.sizes[c],e.sizes[n]),r.sourceComponentIds[c]=e.sourceComponentIds[n],r.verticalAllowed[c]||=e.verticalAllowed[n],r.horizontalAllowed[c]||=e.horizontalAllowed[n],i[c]===0?r.supportIds[c]=e.supportIds[n]:r.supportIds[c]!==e.supportIds[n]&&(r.supportIds[c]=-1),i[c]++}for(let e=0;e<n;e++){let t=e*3;r.positions[t]/=i[e],r.positions[t+1]/=i[e],r.positions[t+2]/=i[e]}return r}function rt(e,t,n,r,i){if(r.maximumMergeDistance<=1e-6)return{cells:e,horizontalEdges:t,verticalEdges:n};let{remap:a,count:o}=tt(et(e,t,r.maximumMergeDistance),e.count),s=nt(e,a,o),c=/* @__PURE__ */ new Set,l=Qe(n,a,o,c);return{cells:s,horizontalEdges:Qe(t,a,o,c,i?{cells:s,clusterCounts:$e(a,o),edgeIsClear:i}:void 0),verticalEdges:l}}function it(e,t,n,r,i){let a=r.maximumMergeDistance,o=a*4,s=rt(e,t,n,r,i),c=s.cells.count>r.targetNodeCount&&a>1e-6;for(let e=0;e<4&&c;e++){let e=Math.max(2,Math.sqrt(s.cells.count/r.targetNodeCount));if(a=Math.min(a*e,o),s=rt(s.cells,s.horizontalEdges,s.verticalEdges,{...r,maximumMergeDistance:a},i),a>=o)break;c=s.cells.count>r.targetNodeCount&&a>1e-6}return s}function at(e,t,n,r){let i=a(e,n),c=o(e,n),l=s(e,n),u=a(e,r)-i,d=o(e,r)-c,f=s(e,r)-l,p=u*u+d*d+f*f;if(p<=1e-6)return Math.hypot(a(e,t)-i,o(e,t)-c,s(e,t)-l);let m=Math.max(0,Math.min(1,((a(e,t)-i)*u+(o(e,t)-c)*d+(s(e,t)-l)*f)/p));return Math.hypot(a(e,t)-(i+m*u),o(e,t)-(c+m*d),s(e,t)-(l+m*f))}function ot(e,t,n,r,i,a){a[r]=1,a[i]=1;let o=[r,i];for(;o.length>0;){let r=o.pop(),i=o.pop(),s=-1,c=n;for(let n=i+1;n<r;n++){let a=at(e,t[n],t[i],t[r]);a>c&&(c=a,s=n)}s<0||(a[s]=1,o.push(i,s,s,r))}}function st(e,t,n){if(t.length<=2||n<=1e-6)return t;let r=new Uint8Array(t.length),i=t.length-1,a=0;for(;a<i;){let o=Math.min(a+256-1,i);ot(e,t,n,a,o,r),a=o}return t.filter((e,t)=>r[t]===1)}function ct(e,t,n){let r=(t.length+n.length)/2,i=new Uint32Array(e),a=new Uint32Array(r),o=new Uint32Array(r),s=new Uint8Array(r),c=[{edges:t,isVertical:!1},{edges:n,isVertical:!0}],l=0;for(let{edges:e,isVertical:t}of c)for(let n=0;n<e.length;n+=2){let r=e.get(n),c=e.get(n+1);a[l]=r,o[l]=c,s[l]=+!!t,i[r]++,i[c]++,l++}let u=new Uint32Array(e+1);for(let t=0;t<e;t++)u[t+1]=u[t]+i[t];let d=u.slice(0,e),f=new Uint32Array(r*2);for(let e=0;e<r;e++)f[d[a[e]]++]=e,f[d[o[e]]++]=e;return{count:r,degrees:i,first:a,second:o,vertical:s,offsets:u,incidentEdges:f}}function lt(e,t){let{degrees:n,first:r,second:i,vertical:a}=t,o=new Uint8Array(e.count);for(let t=0;t<e.count;t++){let r=n[t]===2&&e.verticalAllowed[t]===0&&e.horizontalAllowed[t]===0&&e.supportIds[t]>=0;o[t]=+!r}for(let n=0;n<t.count;n++){let t=r[n],s=i[n];(a[n]===1||e.supportIds[t]!==e.supportIds[s])&&(o[t]=1,o[s]=1)}return o}function ut(e,t,n,r,i){let a=[e],o=t,s=e,c=!1;for(;;){i[o]=1,c||=n.vertical[o]===1;let e=n.first[o]===s?n.second[o]:n.first[o];if(a.push(e),r[e]===1)break;let t=n.incidentEdges[n.offsets[e]],l=n.incidentEdges[n.offsets[e]+1];s=e,o=t===o?l:t}return{path:a,containsVertical:c}}function dt(e,t,r,i){let a=new Uint8Array(t.count),o=new Uint8Array(e.count),s=new n,c=new n,l=(t,n)=>{let r=n?t:st(e,t,i);for(let e of r)o[e]=1;let a=n?c:s;for(let e=1;e<r.length;e++)a.push(r[e-1],r[e])};for(let n=0;n<e.count;n++)if(r[n]!==0){t.degrees[n]===0&&(o[n]=1);for(let e=t.offsets[n];e<t.offsets[n+1];e++){let i=t.incidentEdges[e];if(a[i]===1)continue;let{path:o,containsVertical:s}=ut(n,i,t,r,a);l(o,s)}}for(let e=0;e<t.count;e++)a[e]!==1&&(o[t.first[e]]=1,o[t.second[e]]=1,(t.vertical[e]===1?c:s).push(t.first[e],t.second[e]));return{retainedNodes:o,horizontalEdges:s,verticalEdges:c}}function ft(e,t){let n=new Uint32Array(e.count);n.fill(4294967295);let r=0;for(let i=0;i<e.count;i++)t[i]===1&&(n[i]=r++);let i=Ze(r);for(let t=0;t<e.count;t++){let r=n[t];r!==4294967295&&(i.positions.set(e.positions.subarray(t*3,t*3+3),r*3),i.sizes[r]=e.sizes[t],i.sourceComponentIds[r]=e.sourceComponentIds[t],i.verticalAllowed[r]=e.verticalAllowed[t],i.horizontalAllowed[r]=e.horizontalAllowed[t],i.supportIds[r]=e.supportIds[t])}return{cells:i,remap:n}}function pt(e,t,n,r){if(t.length+n.length===0||r<=1e-6)return{cells:e,horizontalEdges:t,verticalEdges:n};let i=ct(e.count,t,n),a=dt(e,i,lt(e,i),r),{cells:o,remap:s}=ft(e,a.retainedNodes),c=/* @__PURE__ */ new Set,l=o.count,u=Qe(a.verticalEdges,s,l,c);return{cells:o,horizontalEdges:Qe(a.horizontalEdges,s,l,c),verticalEdges:u}}\n/**\n* @license\n* Copyright 2010-2026 Three.js Authors\n* SPDX-License-Identifier: MIT\n*/\nlet mt=1e3,ht=1001,gt=1002,_t=2300,vt=2301,yt=2302,bt=2303,xt=2400,St=2401,Ct=2402,wt=`srgb`,Tt=`srgb-linear`,Et=`linear`,Dt=2e3;function Ot(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function kt(e){return ArrayBuffer.isView(e)&&!(e instanceof DataView)}function At(e){return document.createElementNS(`http://www.w3.org/1999/xhtml`,e)}let jt={};function Mt(e){let t=e[0];if(typeof t==`string`&&t.startsWith(`TSL:`)){let t=e[1];t&&t.isStackTrace?e[0]+=` `+t.getLocation():e[1]=`Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.`}return e}function M(...e){e=Mt(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.warn(n.getError(t)):console.warn(t,...e)}}function N(...e){e=Mt(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.error(n.getError(t)):console.error(t,...e)}}function Nt(...e){let t=e.join(` `);t in jt||(jt[t]=!0,M(...e))}var Pt=class{addEventListener(e,t){this._listeners===void 0&&(this._listeners={});let n=this._listeners;n[e]===void 0&&(n[e]=[]),n[e].indexOf(t)===-1&&n[e].push(t)}hasEventListener(e,t){let n=this._listeners;return n!==void 0&&n[e]!==void 0&&n[e].indexOf(t)!==-1}removeEventListener(e,t){let n=this._listeners;if(n===void 0)return;let r=n[e];if(r!==void 0){let e=r.indexOf(t);e!==-1&&r.splice(e,1)}}dispatchEvent(e){let t=this._listeners;if(t===void 0)return;let n=t[e.type];if(n!==void 0){e.target=this;let t=n.slice(0);for(let n=0,r=t.length;n<r;n++)t[n].call(this,e);e.target=null}}};let P=/* @__PURE__ */ `00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff`.split(`.`);function Ft(){let e=Math.random()*4294967295|0,t=Math.random()*4294967295|0,n=Math.random()*4294967295|0,r=Math.random()*4294967295|0;return(P[e&255]+P[e>>8&255]+P[e>>16&255]+P[e>>24&255]+`-`+P[t&255]+P[t>>8&255]+`-`+P[t>>16&15|64]+P[t>>24&255]+`-`+P[n&63|128]+P[n>>8&255]+`-`+P[n>>16&255]+P[n>>24&255]+P[r&255]+P[r>>8&255]+P[r>>16&255]+P[r>>24&255]).toLowerCase()}function F(e,t,n){return Math.max(t,Math.min(n,e))}function It(e,t){return(e%t+t)%t}function Lt(e,t,n){return(1-n)*e+n*t}function Rt(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:case Uint8ClampedArray:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}function zt(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(e*4294967295);case Uint16Array:return Math.round(e*65535);case Uint8Array:case Uint8ClampedArray:return Math.round(e*255);case Int32Array:return Math.round(e*2147483647);case Int16Array:return Math.round(e*32767);case Int8Array:return Math.round(e*127);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}var I=class e{static{e.prototype.isVector2=!0}constructor(e=0,t=0){this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw Error(`THREE.Vector2: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw Error(`THREE.Vector2: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){let t=this.x,n=this.y,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6],this.y=r[1]*t+r[4]*n+r[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=F(this.x,e.x,t.x),this.y=F(this.y,e.y,t.y),this}clampScalar(e,t){return this.x=F(this.x,e,t),this.y=F(this.y,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(F(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(F(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){let n=Math.cos(t),r=Math.sin(t),i=this.x-e.x,a=this.y-e.y;return this.x=i*n-a*r+e.x,this.y=i*r+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}},Bt=class{constructor(e=0,t=0,n=0,r=1){this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=r}static slerpFlat(e,t,n,r,i,a,o){let s=n[r+0],c=n[r+1],l=n[r+2],u=n[r+3],d=i[a+0],f=i[a+1],p=i[a+2],m=i[a+3];if(u!==m||s!==d||c!==f||l!==p){let e=s*d+c*f+l*p+u*m;e<0&&(d=-d,f=-f,p=-p,m=-m,e=-e);let t=1-o;if(e<.9995){let n=Math.acos(e),r=Math.sin(n);t=Math.sin(t*n)/r,o=Math.sin(o*n)/r,s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o}else{s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o;let e=1/Math.sqrt(s*s+c*c+l*l+u*u);s*=e,c*=e,l*=e,u*=e}}e[t]=s,e[t+1]=c,e[t+2]=l,e[t+3]=u}static multiplyQuaternionsFlat(e,t,n,r,i,a){let o=n[r],s=n[r+1],c=n[r+2],l=n[r+3],u=i[a],d=i[a+1],f=i[a+2],p=i[a+3];return e[t]=o*p+l*u+s*f-c*d,e[t+1]=s*p+l*d+c*u-o*f,e[t+2]=c*p+l*f+o*d-s*u,e[t+3]=l*p-o*u-s*d-c*f,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,r){return this._x=e,this._y=t,this._z=n,this._w=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t=!0){let n=e._x,r=e._y,i=e._z,a=e._order,o=Math.cos,s=Math.sin,c=o(n/2),l=o(r/2),u=o(i/2),d=s(n/2),f=s(r/2),p=s(i/2);switch(a){case`XYZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`YXZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`ZXY`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`ZYX`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`YZX`:this._x=d*l*u+c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u-d*f*p;break;case`XZY`:this._x=d*l*u-c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u+d*f*p;break;default:M(`Quaternion: .setFromEuler() encountered an unknown order: `+a)}return t===!0&&this._onChangeCallback(),this}setFromAxisAngle(e,t){let n=t/2,r=Math.sin(n);return this._x=e.x*r,this._y=e.y*r,this._z=e.z*r,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){let t=e.elements,n=t[0],r=t[4],i=t[8],a=t[1],o=t[5],s=t[9],c=t[2],l=t[6],u=t[10],d=n+o+u;if(d>0){let e=.5/Math.sqrt(d+1);this._w=.25/e,this._x=(l-s)*e,this._y=(i-c)*e,this._z=(a-r)*e}else if(n>o&&n>u){let e=2*Math.sqrt(1+n-o-u);this._w=(l-s)/e,this._x=.25*e,this._y=(r+a)/e,this._z=(i+c)/e}else if(o>u){let e=2*Math.sqrt(1+o-n-u);this._w=(i-c)/e,this._x=(r+a)/e,this._y=.25*e,this._z=(s+l)/e}else{let e=2*Math.sqrt(1+u-n-o);this._w=(a-r)/e,this._x=(i+c)/e,this._y=(s+l)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<1e-8?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(F(this.dot(e),-1,1)))}rotateTowards(e,t){let n=this.angleTo(e);if(n===0)return this;let r=Math.min(1,t/n);return this.slerp(e,r),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return e===0?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x*=e,this._y*=e,this._z*=e,this._w*=e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=t._x,s=t._y,c=t._z,l=t._w;return this._x=n*l+a*o+r*c-i*s,this._y=r*l+a*s+i*o-n*c,this._z=i*l+a*c+n*s-r*o,this._w=a*l-n*o-r*s-i*c,this._onChangeCallback(),this}slerp(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=this.dot(e);o<0&&(n=-n,r=-r,i=-i,a=-a,o=-o);let s=1-t;if(o<.9995){let e=Math.acos(o),c=Math.sin(e);s=Math.sin(s*e)/c,t=Math.sin(t*e)/c,this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this._onChangeCallback()}else this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this.normalize();return this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){let e=2*Math.PI*Math.random(),t=2*Math.PI*Math.random(),n=Math.random(),r=Math.sqrt(1-n),i=Math.sqrt(n);return this.set(r*Math.sin(e),r*Math.cos(e),i*Math.sin(t),i*Math.cos(t))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e,t=0){return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this._onChangeCallback(),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}},L=class e{static{e.prototype.isVector3=!0}constructor(e=0,t=0,n=0){this.x=e,this.y=t,this.z=n}set(e,t,n){return n===void 0&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw Error(`THREE.Vector3: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw Error(`THREE.Vector3: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(Ht.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(Ht.setFromAxisAngle(e,t))}applyMatrix3(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6]*r,this.y=i[1]*t+i[4]*n+i[7]*r,this.z=i[2]*t+i[5]*n+i[8]*r,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=e.elements,a=1/(i[3]*t+i[7]*n+i[11]*r+i[15]);return this.x=(i[0]*t+i[4]*n+i[8]*r+i[12])*a,this.y=(i[1]*t+i[5]*n+i[9]*r+i[13])*a,this.z=(i[2]*t+i[6]*n+i[10]*r+i[14])*a,this}applyQuaternion(e){let t=this.x,n=this.y,r=this.z,i=e.x,a=e.y,o=e.z,s=e.w,c=2*(a*r-o*n),l=2*(o*t-i*r),u=2*(i*n-a*t);return this.x=t+s*c+a*u-o*l,this.y=n+s*l+o*c-i*u,this.z=r+s*u+i*l-a*c,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[4]*n+i[8]*r,this.y=i[1]*t+i[5]*n+i[9]*r,this.z=i[2]*t+i[6]*n+i[10]*r,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=F(this.x,e.x,t.x),this.y=F(this.y,e.y,t.y),this.z=F(this.z,e.z,t.z),this}clampScalar(e,t){return this.x=F(this.x,e,t),this.y=F(this.y,e,t),this.z=F(this.z,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(F(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){let n=e.x,r=e.y,i=e.z,a=t.x,o=t.y,s=t.z;return this.x=r*s-i*o,this.y=i*a-n*s,this.z=n*o-r*a,this}projectOnVector(e){let t=e.lengthSq();if(t===0)return this.set(0,0,0);let n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return Vt.copy(this).projectOnVector(e),this.sub(Vt)}reflect(e){return this.sub(Vt.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(F(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y,r=this.z-e.z;return t*t+n*n+r*r}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){let r=Math.sin(t)*e;return this.x=r*Math.sin(n),this.y=Math.cos(t)*e,this.z=r*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){let t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),r=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=r,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,t*4)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,t*3)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){let e=Math.random()*Math.PI*2,t=Math.random()*2-1,n=Math.sqrt(1-t*t);return this.x=n*Math.cos(e),this.y=t,this.z=n*Math.sin(e),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}};let Vt=/*@__PURE__*/ new L,Ht=/*@__PURE__*/ new Bt;var Ut=class e{static{e.prototype.isMatrix3=!0}constructor(e,t,n,r,i,a,o,s,c){this.elements=[1,0,0,0,1,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c)}set(e,t,n,r,i,a,o,s,c){let l=this.elements;return l[0]=e,l[1]=r,l[2]=o,l[3]=t,l[4]=i,l[5]=s,l[6]=n,l[7]=a,l[8]=c,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){let t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[3],s=n[6],c=n[1],l=n[4],u=n[7],d=n[2],f=n[5],p=n[8],m=r[0],h=r[3],g=r[6],_=r[1],v=r[4],y=r[7],b=r[2],x=r[5],S=r[8];return i[0]=a*m+o*_+s*b,i[3]=a*h+o*v+s*x,i[6]=a*g+o*y+s*S,i[1]=c*m+l*_+u*b,i[4]=c*h+l*v+u*x,i[7]=c*g+l*y+u*S,i[2]=d*m+f*_+p*b,i[5]=d*h+f*v+p*x,i[8]=d*g+f*y+p*S,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8];return t*a*l-t*o*c-n*i*l+n*o*s+r*i*c-r*a*s}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=l*a-o*c,d=o*s-l*i,f=c*i-a*s,p=t*u+n*d+r*f;if(p===0)return this.set(0,0,0,0,0,0,0,0,0);let m=1/p;return e[0]=u*m,e[1]=(r*c-l*n)*m,e[2]=(o*n-r*a)*m,e[3]=d*m,e[4]=(l*t-r*s)*m,e[5]=(r*i-o*t)*m,e[6]=f*m,e[7]=(n*s-c*t)*m,e[8]=(a*t-n*i)*m,this}transpose(){let e,t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){let t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,r,i,a,o){let s=Math.cos(i),c=Math.sin(i);return this.set(n*s,n*c,-n*(s*a+c*o)+a+e,-r*c,r*s,-r*(-c*a+s*o)+o+t,0,0,1),this}scale(e,t){return Nt(`Matrix3: .scale() is deprecated. Use .makeScale() instead.`),this.premultiply(Wt.makeScale(e,t)),this}rotate(e){return Nt(`Matrix3: .rotate() is deprecated. Use .makeRotation() instead.`),this.premultiply(Wt.makeRotation(-e)),this}translate(e,t){return Nt(`Matrix3: .translate() is deprecated. Use .makeTranslation() instead.`),this.premultiply(Wt.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return new this.constructor().fromArray(this.elements)}};let Wt=/*@__PURE__*/ new Ut,Gt=/*@__PURE__*/ new Ut().set(.4123908,.3575843,.1804808,.212639,.7151687,.0721923,.0193308,.1191948,.9505322),Kt=/*@__PURE__*/ new Ut().set(3.2409699,-1.5373832,-.4986108,-.9692436,1.8759675,.0415551,.0556301,-.203977,1.0569715);function qt(){let e={enabled:!0,workingColorSpace:Tt,spaces:{},convert:function(e,t,n){return this.enabled===!1||t===n||!t||!n?e:(this.spaces[t].transfer===`srgb`&&(e.r=Yt(e.r),e.g=Yt(e.g),e.b=Yt(e.b)),this.spaces[t].primaries!==this.spaces[n].primaries&&(e.applyMatrix3(this.spaces[t].toXYZ),e.applyMatrix3(this.spaces[n].fromXYZ)),this.spaces[n].transfer===`srgb`&&(e.r=Xt(e.r),e.g=Xt(e.g),e.b=Xt(e.b)),e)},workingToColorSpace:function(e,t){return this.convert(e,this.workingColorSpace,t)},colorSpaceToWorking:function(e,t){return this.convert(e,t,this.workingColorSpace)},getPrimaries:function(e){return this.spaces[e].primaries},getTransfer:function(e){return e===``?Et:this.spaces[e].transfer},getToneMappingMode:function(e){return this.spaces[e].outputColorSpaceConfig.toneMappingMode||`standard`},getLuminanceCoefficients:function(e,t=this.workingColorSpace){return e.fromArray(this.spaces[t].luminanceCoefficients)},define:function(e){Object.assign(this.spaces,e)},_getMatrix:function(e,t,n){return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ)},_getDrawingBufferColorSpace:function(e){return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace},_getUnpackColorSpace:function(e=this.workingColorSpace){return this.spaces[e].workingColorSpaceConfig.unpackColorSpace},fromWorkingColorSpace:function(t,n){return Nt(`ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().`),e.workingToColorSpace(t,n)},toWorkingColorSpace:function(t,n){return Nt(`ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().`),e.colorSpaceToWorking(t,n)}},t=[.64,.33,.3,.6,.15,.06],n=[.2126,.7152,.0722],r=[.3127,.329];return e.define({[Tt]:{primaries:t,whitePoint:r,transfer:Et,toXYZ:Gt,fromXYZ:Kt,luminanceCoefficients:n,workingColorSpaceConfig:{unpackColorSpace:wt},outputColorSpaceConfig:{drawingBufferColorSpace:wt}},[wt]:{primaries:t,whitePoint:r,transfer:`srgb`,toXYZ:Gt,fromXYZ:Kt,luminanceCoefficients:n,outputColorSpaceConfig:{drawingBufferColorSpace:wt}}}),e}let Jt=/*@__PURE__*/ qt();function Yt(e){return e<.04045?e*.0773993808:(e*.9478672986+.0521327014)**2.4}function Xt(e){return e<.0031308?e*12.92:1.055*e**.41666-.055}let Zt;var Qt=class{static getDataURL(e,t=`image/png`){if(/^data:/i.test(e.src)||typeof HTMLCanvasElement>`u`)return e.src;let n;if(e instanceof HTMLCanvasElement)n=e;else{Zt===void 0&&(Zt=At(`canvas`)),Zt.width=e.width,Zt.height=e.height;let t=Zt.getContext(`2d`);e instanceof ImageData?t.putImageData(e,0,0):t.drawImage(e,0,0,e.width,e.height),n=Zt}return n.toDataURL(t)}static sRGBToLinear(e){if(typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap){let t=At(`canvas`);t.width=e.width,t.height=e.height;let n=t.getContext(`2d`);n.drawImage(e,0,0,e.width,e.height);let r=n.getImageData(0,0,e.width,e.height),i=r.data;for(let e=0;e<i.length;e++)i[e]=Yt(i[e]/255)*255;return n.putImageData(r,0,0),t}if(e.data){let t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(Yt(t[e]/255)*255):t[e]=Yt(t[e]);return{data:t,width:e.width,height:e.height}}return M(`ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.`),e}};let $t=0;var en=class{constructor(e=null){this.isTextureSource=!0,Object.defineProperty(this,\"id\",{value:$t++}),this.uuid=Ft(),this.data=e,this.dataReady=!0,this.version=0}getSize(e){let t=this.data;return typeof HTMLVideoElement<`u`&&t instanceof HTMLVideoElement?e.set(t.videoWidth,t.videoHeight,0):typeof VideoFrame<`u`&&t instanceof VideoFrame?e.set(t.displayWidth,t.displayHeight,0):t===null?e.set(0,0,0):e.set(t.width,t.height,t.depth||0),e}set needsUpdate(e){e===!0&&this.version++}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.images[this.uuid]!==void 0)return e.images[this.uuid];let n={uuid:this.uuid,url:``},r=this.data;if(r!==null){let e;if(Array.isArray(r)){e=[];for(let t=0,n=r.length;t<n;t++)r[t].isDataTexture?e.push(tn(r[t].image)):e.push(tn(r[t]))}else e=tn(r);n.url=e}return t||(e.images[this.uuid]=n),n}};function tn(e){return typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap?Qt.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(M(`Texture: Unable to serialize Texture.`),{})}let nn=0,rn=/*@__PURE__*/ new L;var an=class e extends Pt{constructor(t=e.DEFAULT_IMAGE,n=e.DEFAULT_MAPPING,r=ht,i=ht,a=1006,o=1008,s=1023,c=1009,l=e.DEFAULT_ANISOTROPY,u=``){super(),this.isTexture=!0,Object.defineProperty(this,\"id\",{value:nn++}),this.uuid=Ft(),this.name=``,this.source=new en(t),this.mipmaps=[],this.mapping=n,this.channel=0,this.wrapS=r,this.wrapT=i,this.magFilter=a,this.minFilter=o,this.anisotropy=l,this.format=s,this.internalFormat=null,this.type=c,this.offset=new I(0,0),this.repeat=new I(1,1),this.center=new I(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new Ut,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.colorSpace=u,this.userData={},this.updateRanges=[],this.version=0,this.onUpdate=null,this.renderTarget=null,this.isRenderTargetTexture=!1,this.isArrayTexture=!!(t&&t.depth&&t.depth>1),this.pmremVersion=0,this.normalized=!1}get width(){return this.source.getSize(rn).x}get height(){return this.source.getSize(rn).y}get depth(){return this.source.getSize(rn).z}get image(){return this.source.data}set image(e){this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}clone(){return new this.constructor().copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.normalized=e.normalized,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.renderTarget=e.renderTarget,this.isRenderTargetTexture=e.isRenderTargetTexture,this.isArrayTexture=e.isArrayTexture,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}setValues(e){for(let t in e){let n=e[t];if(n===void 0){M(`Texture.setValues(): parameter '${t}' has value of undefined.`);continue}let r=this[t];if(r===void 0){M(`Texture.setValues(): property '${t}' does not exist.`);continue}r&&n&&r.isVector2&&n.isVector2||r&&n&&r.isVector3&&n.isVector3||r&&n&&r.isMatrix3&&n.isMatrix3?r.copy(n):this[t]=n}}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.textures[this.uuid]!==void 0)return e.textures[this.uuid];let n={metadata:{version:4.7,type:`Texture`,generator:`Texture.toJSON`},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,normalized:this.normalized,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:`dispose`})}transformUv(e){if(this.mapping!==300)return e;if(e.applyMatrix3(this.matrix),e.x<0||e.x>1)switch(this.wrapS){case mt:e.x-=Math.floor(e.x);break;case ht:e.x=e.x<0?0:1;break;case gt:Math.abs(Math.floor(e.x)%2)===1?e.x=Math.ceil(e.x)-e.x:e.x-=Math.floor(e.x)}if(e.y<0||e.y>1)switch(this.wrapT){case mt:e.y-=Math.floor(e.y);break;case ht:e.y=e.y<0?0:1;break;case gt:Math.abs(Math.floor(e.y)%2)===1?e.y=Math.ceil(e.y)-e.y:e.y-=Math.floor(e.y)}return this.flipY&&(e.y=1-e.y),e}set needsUpdate(e){e===!0&&(this.version++,this.source.needsUpdate=!0)}set needsPMREMUpdate(e){e===!0&&this.pmremVersion++}};an.DEFAULT_IMAGE=null,an.DEFAULT_MAPPING=300,an.DEFAULT_ANISOTROPY=1;var on=class e{static{e.prototype.isVector4=!0}constructor(e=0,t=0,n=0,r=1){this.x=e,this.y=t,this.z=n,this.w=r}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,r){return this.x=e,this.y=t,this.z=n,this.w=r,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw Error(`THREE.Vector4: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw Error(`THREE.Vector4: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=e.w===void 0?1:e.w,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*r+a[12]*i,this.y=a[1]*t+a[5]*n+a[9]*r+a[13]*i,this.z=a[2]*t+a[6]*n+a[10]*r+a[14]*i,this.w=a[3]*t+a[7]*n+a[11]*r+a[15]*i,this}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this.w/=e.w,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);let t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,r,i,a=.01,o=.1,s=e.elements,c=s[0],l=s[4],u=s[8],d=s[1],f=s[5],p=s[9],m=s[2],h=s[6],g=s[10];if(Math.abs(l-d)<a&&Math.abs(u-m)<a&&Math.abs(p-h)<a){if(Math.abs(l+d)<o&&Math.abs(u+m)<o&&Math.abs(p+h)<o&&Math.abs(c+f+g-3)<o)return this.set(1,0,0,0),this;t=Math.PI;let e=(c+1)/2,s=(f+1)/2,_=(g+1)/2,v=(l+d)/4,y=(u+m)/4,b=(p+h)/4;return e>s&&e>_?e<a?(n=0,r=.707106781,i=.707106781):(n=Math.sqrt(e),r=v/n,i=y/n):s>_?s<a?(n=.707106781,r=0,i=.707106781):(r=Math.sqrt(s),n=v/r,i=b/r):_<a?(n=.707106781,r=.707106781,i=0):(i=Math.sqrt(_),n=y/i,r=b/i),this.set(n,r,i,t),this}let _=Math.sqrt((h-p)*(h-p)+(u-m)*(u-m)+(d-l)*(d-l));return Math.abs(_)<.001&&(_=1),this.x=(h-p)/_,this.y=(u-m)/_,this.z=(d-l)/_,this.w=Math.acos((c+f+g-1)/2),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this.w=t[15],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=F(this.x,e.x,t.x),this.y=F(this.y,e.y,t.y),this.z=F(this.z,e.z,t.z),this.w=F(this.w,e.w,t.w),this}clampScalar(e,t){return this.x=F(this.x,e,t),this.y=F(this.y,e,t),this.z=F(this.z,e,t),this.w=F(this.w,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(F(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}},R=class e{static{e.prototype.isMatrix4=!0}constructor(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h)}set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){let g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=r,g[1]=i,g[5]=a,g[9]=o,g[13]=s,g[2]=c,g[6]=l,g[10]=u,g[14]=d,g[3]=f,g[7]=p,g[11]=m,g[15]=h,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return new e().fromArray(this.elements)}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){let t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){let t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return this.determinantAffine()===0?(e.set(1,0,0),t.set(0,1,0),n.set(0,0,1),this):(e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this)}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){if(e.determinantAffine()===0)return this.identity();let t=this.elements,n=e.elements,r=1/sn.setFromMatrixColumn(e,0).length(),i=1/sn.setFromMatrixColumn(e,1).length(),a=1/sn.setFromMatrixColumn(e,2).length();return t[0]=n[0]*r,t[1]=n[1]*r,t[2]=n[2]*r,t[3]=0,t[4]=n[4]*i,t[5]=n[5]*i,t[6]=n[6]*i,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){let t=this.elements,n=e.x,r=e.y,i=e.z,a=Math.cos(n),o=Math.sin(n),s=Math.cos(r),c=Math.sin(r),l=Math.cos(i),u=Math.sin(i);if(e.order===`XYZ`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=-s*u,t[8]=c,t[1]=n+r*c,t[5]=e-i*c,t[9]=-o*s,t[2]=i-e*c,t[6]=r+n*c,t[10]=a*s}else if(e.order===`YXZ`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e+i*o,t[4]=r*o-n,t[8]=a*c,t[1]=a*u,t[5]=a*l,t[9]=-o,t[2]=n*o-r,t[6]=i+e*o,t[10]=a*s}else if(e.order===`ZXY`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e-i*o,t[4]=-a*u,t[8]=r+n*o,t[1]=n+r*o,t[5]=a*l,t[9]=i-e*o,t[2]=-a*c,t[6]=o,t[10]=a*s}else if(e.order===`ZYX`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=r*c-n,t[8]=e*c+i,t[1]=s*u,t[5]=i*c+e,t[9]=n*c-r,t[2]=-c,t[6]=o*s,t[10]=a*s}else if(e.order===`YZX`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=i-e*u,t[8]=r*u+n,t[1]=u,t[5]=a*l,t[9]=-o*l,t[2]=-c*l,t[6]=n*u+r,t[10]=e-i*u}else if(e.order===`XZY`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=-u,t[8]=c*l,t[1]=e*u+i,t[5]=a*l,t[9]=n*u-r,t[2]=r*u-n,t[6]=o*l,t[10]=i*u+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(ln,e,un)}lookAt(e,t,n){let r=this.elements;return pn.subVectors(e,t),pn.lengthSq()===0&&(pn.z=1),pn.normalize(),dn.crossVectors(n,pn),dn.lengthSq()===0&&(Math.abs(n.z)===1?pn.x+=1e-4:pn.z+=1e-4,pn.normalize(),dn.crossVectors(n,pn)),dn.normalize(),fn.crossVectors(pn,dn),r[0]=dn.x,r[4]=fn.x,r[8]=pn.x,r[1]=dn.y,r[5]=fn.y,r[9]=pn.y,r[2]=dn.z,r[6]=fn.z,r[10]=pn.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[4],s=n[8],c=n[12],l=n[1],u=n[5],d=n[9],f=n[13],p=n[2],m=n[6],h=n[10],g=n[14],_=n[3],v=n[7],y=n[11],b=n[15],x=r[0],S=r[4],C=r[8],w=r[12],T=r[1],E=r[5],D=r[9],O=r[13],k=r[2],A=r[6],j=r[10],ee=r[14],te=r[3],ne=r[7],re=r[11],ie=r[15];return i[0]=a*x+o*T+s*k+c*te,i[4]=a*S+o*E+s*A+c*ne,i[8]=a*C+o*D+s*j+c*re,i[12]=a*w+o*O+s*ee+c*ie,i[1]=l*x+u*T+d*k+f*te,i[5]=l*S+u*E+d*A+f*ne,i[9]=l*C+u*D+d*j+f*re,i[13]=l*w+u*O+d*ee+f*ie,i[2]=p*x+m*T+h*k+g*te,i[6]=p*S+m*E+h*A+g*ne,i[10]=p*C+m*D+h*j+g*re,i[14]=p*w+m*O+h*ee+g*ie,i[3]=_*x+v*T+y*k+b*te,i[7]=_*S+v*E+y*A+b*ne,i[11]=_*C+v*D+y*j+b*re,i[15]=_*w+v*O+y*ee+b*ie,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[12],a=e[1],o=e[5],s=e[9],c=e[13],l=e[2],u=e[6],d=e[10],f=e[14],p=e[3],m=e[7],h=e[11],g=e[15],_=s*f-c*d,v=o*f-c*u,y=o*d-s*u,b=a*f-c*l,x=a*d-s*l,S=a*u-o*l;return t*(m*_-h*v+g*y)-n*(p*_-h*b+g*x)+r*(p*v-m*b+g*S)-i*(p*y-m*x+h*S)}determinantAffine(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[1],a=e[5],o=e[9],s=e[2],c=e[6],l=e[10];return t*(a*l-o*c)-n*(i*l-o*s)+r*(i*c-a*s)}transpose(){let e=this.elements,t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){let r=this.elements;return e.isVector3?(r[12]=e.x,r[13]=e.y,r[14]=e.z):(r[12]=e,r[13]=t,r[14]=n),this}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=e[9],d=e[10],f=e[11],p=e[12],m=e[13],h=e[14],g=e[15],_=t*o-n*a,v=t*s-r*a,y=t*c-i*a,b=n*s-r*o,x=n*c-i*o,S=r*c-i*s,C=l*m-u*p,w=l*h-d*p,T=l*g-f*p,E=u*h-d*m,D=u*g-f*m,O=d*g-f*h,k=_*O-v*D+y*E+b*T-x*w+S*C;if(k===0)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);let A=1/k;return e[0]=(o*O-s*D+c*E)*A,e[1]=(r*D-n*O-i*E)*A,e[2]=(m*S-h*x+g*b)*A,e[3]=(d*x-u*S-f*b)*A,e[4]=(s*T-a*O-c*w)*A,e[5]=(t*O-r*T+i*w)*A,e[6]=(h*y-p*S-g*v)*A,e[7]=(l*S-d*y+f*v)*A,e[8]=(a*D-o*T+c*C)*A,e[9]=(n*T-t*D-i*C)*A,e[10]=(p*x-m*y+g*_)*A,e[11]=(u*y-l*x-f*_)*A,e[12]=(o*w-a*E-s*C)*A,e[13]=(t*E-n*w+r*C)*A,e[14]=(m*v-p*b-h*_)*A,e[15]=(l*b-u*v+d*_)*A,this}scale(e){let t=this.elements,n=e.x,r=e.y,i=e.z;return t[0]*=n,t[4]*=r,t[8]*=i,t[1]*=n,t[5]*=r,t[9]*=i,t[2]*=n,t[6]*=r,t[10]*=i,t[3]*=n,t[7]*=r,t[11]*=i,this}getMaxScaleOnAxis(){let e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],r=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,r))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){let t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){let n=Math.cos(t),r=Math.sin(t),i=1-n,a=e.x,o=e.y,s=e.z,c=i*a,l=i*o;return this.set(c*a+n,c*o-r*s,c*s+r*o,0,c*o+r*s,l*o+n,l*s-r*a,0,c*s-r*o,l*s+r*a,i*s*s+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,r,i,a){return this.set(1,n,i,0,e,1,a,0,t,r,1,0,0,0,0,1),this}compose(e,t,n){let r=this.elements,i=t._x,a=t._y,o=t._z,s=t._w,c=i+i,l=a+a,u=o+o,d=i*c,f=i*l,p=i*u,m=a*l,h=a*u,g=o*u,_=s*c,v=s*l,y=s*u,b=n.x,x=n.y,S=n.z;return r[0]=(1-(m+g))*b,r[1]=(f+y)*b,r[2]=(p-v)*b,r[3]=0,r[4]=(f-y)*x,r[5]=(1-(d+g))*x,r[6]=(h+_)*x,r[7]=0,r[8]=(p+v)*S,r[9]=(h-_)*S,r[10]=(1-(d+m))*S,r[11]=0,r[12]=e.x,r[13]=e.y,r[14]=e.z,r[15]=1,this}decompose(e,t,n){let r=this.elements;e.x=r[12],e.y=r[13],e.z=r[14];let i=this.determinantAffine();if(i===0)return n.set(1,1,1),t.identity(),this;let a=sn.set(r[0],r[1],r[2]).length(),o=sn.set(r[4],r[5],r[6]).length(),s=sn.set(r[8],r[9],r[10]).length();i<0&&(a=-a),cn.copy(this);let c=1/a,l=1/o,u=1/s;return cn.elements[0]*=c,cn.elements[1]*=c,cn.elements[2]*=c,cn.elements[4]*=l,cn.elements[5]*=l,cn.elements[6]*=l,cn.elements[8]*=u,cn.elements[9]*=u,cn.elements[10]*=u,t.setFromRotationMatrix(cn),n.x=a,n.y=o,n.z=s,this}makePerspective(e,t,n,r,i,a,o=Dt,s=!1){let c=this.elements,l=2*i/(t-e),u=2*i/(n-r),d=(t+e)/(t-e),f=(n+r)/(n-r),p,m;if(s)p=i/(a-i),m=a*i/(a-i);else if(o===2e3)p=-(a+i)/(a-i),m=-2*a*i/(a-i);else if(o===2001)p=-a/(a-i),m=-a*i/(a-i);else throw Error(`THREE.Matrix4.makePerspective(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=d,c[12]=0,c[1]=0,c[5]=u,c[9]=f,c[13]=0,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=-1,c[15]=0,this}makeOrthographic(e,t,n,r,i,a,o=Dt,s=!1){let c=this.elements,l=2/(t-e),u=2/(n-r),d=-(t+e)/(t-e),f=-(n+r)/(n-r),p,m;if(s)p=1/(a-i),m=a/(a-i);else if(o===2e3)p=-2/(a-i),m=-(a+i)/(a-i);else if(o===2001)p=-1/(a-i),m=-i/(a-i);else throw Error(`THREE.Matrix4.makeOrthographic(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=0,c[12]=d,c[1]=0,c[5]=u,c[9]=0,c[13]=f,c[2]=0,c[6]=0,c[10]=p,c[14]=m,c[3]=0,c[7]=0,c[11]=0,c[15]=1,this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}};let sn=/*@__PURE__*/ new L,cn=/*@__PURE__*/ new R,ln=/*@__PURE__*/ new L(0,0,0),un=/*@__PURE__*/ new L(1,1,1),dn=/*@__PURE__*/ new L,fn=/*@__PURE__*/ new L,pn=/*@__PURE__*/ new L,mn=/*@__PURE__*/ new R,hn=/*@__PURE__*/ new Bt;var gn=class e{constructor(t=0,n=0,r=0,i=e.DEFAULT_ORDER){this.isEuler=!0,this._x=t,this._y=n,this._z=r,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n,r=this._order){return this._x=e,this._y=t,this._z=n,this._order=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e,t=this._order,n=!0){let r=e.elements,i=r[0],a=r[4],o=r[8],s=r[1],c=r[5],l=r[9],u=r[2],d=r[6],f=r[10];switch(t){case`XYZ`:this._y=Math.asin(F(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-l,f),this._z=Math.atan2(-a,i)):(this._x=Math.atan2(d,c),this._z=0);break;case`YXZ`:this._x=Math.asin(-F(l,-1,1)),Math.abs(l)<.9999999?(this._y=Math.atan2(o,f),this._z=Math.atan2(s,c)):(this._y=Math.atan2(-u,i),this._z=0);break;case`ZXY`:this._x=Math.asin(F(d,-1,1)),Math.abs(d)<.9999999?(this._y=Math.atan2(-u,f),this._z=Math.atan2(-a,c)):(this._y=0,this._z=Math.atan2(s,i));break;case`ZYX`:this._y=Math.asin(-F(u,-1,1)),Math.abs(u)<.9999999?(this._x=Math.atan2(d,f),this._z=Math.atan2(s,i)):(this._x=0,this._z=Math.atan2(-a,c));break;case`YZX`:this._z=Math.asin(F(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-l,c),this._y=Math.atan2(-u,i)):(this._x=0,this._y=Math.atan2(o,f));break;case`XZY`:this._z=Math.asin(-F(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(d,c),this._y=Math.atan2(o,i)):(this._x=Math.atan2(-l,f),this._y=0);break;default:M(`Euler: .setFromRotationMatrix() encountered an unknown order: `+t)}return this._order=t,n===!0&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return mn.makeRotationFromQuaternion(e),this.setFromRotationMatrix(mn,t,n)}setFromVector3(e,t=this._order){return this.set(e.x,e.y,e.z,t)}reorder(e){return hn.setFromEuler(this),this.setFromQuaternion(hn,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],e[3]!==void 0&&(this._order=e[3]),this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}};gn.DEFAULT_ORDER=`XYZ`;var _n=class{constructor(){this.mask=1}set(e){this.mask=(1<<e|0)>>>0}enable(e){this.mask|=1<<e|0}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e|0}disable(e){this.mask&=~(1<<e|0)}disableAll(){this.mask=0}test(e){return(this.mask&e.mask)!==0}isEnabled(e){return!!(this.mask&(1<<e|0))}};let vn=0,yn=/*@__PURE__*/ new L,bn=/*@__PURE__*/ new Bt,xn=/*@__PURE__*/ new R,Sn=/*@__PURE__*/ new L,Cn=/*@__PURE__*/ new L,wn=/*@__PURE__*/ new L,Tn=/*@__PURE__*/ new Bt,En=/*@__PURE__*/ new L(1,0,0),Dn=/*@__PURE__*/ new L(0,1,0),On=/*@__PURE__*/ new L(0,0,1),kn={type:`added`},An={type:`removed`},jn={type:`childadded`,child:null},Mn={type:`childremoved`,child:null};var Nn=class e extends Pt{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,\"id\",{value:vn++}),this.uuid=Ft(),this.name=``,this.type=`Object3D`,this.parent=null,this.children=[],this.up=e.DEFAULT_UP.clone();let t=new L,n=new gn,r=new Bt,i=new L(1,1,1);function a(){r.setFromEuler(n,!1)}function o(){n.setFromQuaternion(r,void 0,!1)}n._onChange(a),r._onChange(o),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:t},rotation:{configurable:!0,enumerable:!0,value:n},quaternion:{configurable:!0,enumerable:!0,value:r},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new R},normalMatrix:{value:new Ut}}),this.matrix=new R,this.matrixWorld=new R,this.matrixAutoUpdate=e.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldAutoUpdate=e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.layers=new _n,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.customDepthMaterial=void 0,this.customDistanceMaterial=void 0,this.static=!1,this.userData={},this.pivot=null}onBeforeShadow(){}onAfterShadow(){}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return bn.setFromAxisAngle(e,t),this.quaternion.multiply(bn),this}rotateOnWorldAxis(e,t){return bn.setFromAxisAngle(e,t),this.quaternion.premultiply(bn),this}rotateX(e){return this.rotateOnAxis(En,e)}rotateY(e){return this.rotateOnAxis(Dn,e)}rotateZ(e){return this.rotateOnAxis(On,e)}translateOnAxis(e,t){return yn.copy(e).applyQuaternion(this.quaternion),this.position.add(yn.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(En,e)}translateY(e){return this.translateOnAxis(Dn,e)}translateZ(e){return this.translateOnAxis(On,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(xn.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?Sn.copy(e):Sn.set(e,t,n);let r=this.parent;this.updateWorldMatrix(!0,!1),Cn.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?xn.lookAt(Cn,Sn,this.up):xn.lookAt(Sn,Cn,this.up),this.quaternion.setFromRotationMatrix(xn),r&&(xn.extractRotation(r.matrixWorld),bn.setFromRotationMatrix(xn),this.quaternion.premultiply(bn.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(N(`Object3D.add: object can't be added as a child of itself.`,e),this):(e&&e.isObject3D?(e.removeFromParent(),e.parent=this,this.children.push(e),e.dispatchEvent(kn),jn.child=e,this.dispatchEvent(jn),jn.child=null):N(`Object3D.add: object not an instance of THREE.Object3D.`,e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}let t=this.children.indexOf(e);return t!==-1&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(An),Mn.child=e,this.dispatchEvent(Mn),Mn.child=null),this}removeFromParent(){let e=this.parent;return e!==null&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),xn.copy(this.matrixWorld).invert(),e.parent!==null&&(e.parent.updateWorldMatrix(!0,!1),xn.multiply(e.parent.matrixWorld)),e.applyMatrix4(xn),e.removeFromParent(),e.parent=this,this.children.push(e),e.updateWorldMatrix(!1,!0),e.dispatchEvent(kn),jn.child=e,this.dispatchEvent(jn),jn.child=null,this}getObjectById(e){return this.getObjectByProperty(`id`,e)}getObjectByName(e){return this.getObjectByProperty(`name`,e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,r=this.children.length;n<r;n++){let r=this.children[n].getObjectByProperty(e,t);if(r!==void 0)return r}}getObjectsByProperty(e,t,n=[]){this[e]===t&&n.push(this);let r=this.children;for(let i=0,a=r.length;i<a;i++)r[i].getObjectsByProperty(e,t,n);return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(Cn,e,wn),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(Cn,Tn,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);let t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}intersectsFrustum(){}traverse(e){e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverse(e)}traverseVisible(e){if(this.visible===!1)return;e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverseVisible(e)}traverseAncestors(e){let t=this.parent;t!==null&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale);let e=this.pivot;if(e!==null){let t=e.x,n=e.y,r=e.z,i=this.matrix.elements;i[12]+=t-i[0]*t-i[4]*n-i[8]*r,i[13]+=n-i[1]*t-i[5]*n-i[9]*r,i[14]+=r-i[2]*t-i[6]*n-i[10]*r}this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,e=!0);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].updateMatrixWorld(e)}updateWorldMatrix(e,t,n=!1){let r=this.parent;if(e===!0&&r!==null&&r.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||n)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,n=!0),t===!0){let e=this.children;for(let t=0,r=e.length;t<r;t++)e[t].updateWorldMatrix(!1,!0,n)}}toJSON(e){let t=e===void 0||typeof e==`string`,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.7,type:`Object`,generator:`Object3D.toJSON`});let r={};r.uuid=this.uuid,r.type=this.type,r.name=this.name,r.castShadow=this.castShadow,r.receiveShadow=this.receiveShadow,r.visible=this.visible,r.frustumCulled=this.frustumCulled,r.renderOrder=this.renderOrder,r.static=this.static,r.matrixAutoUpdate=this.matrixAutoUpdate,Object.keys(this.userData).length>0&&(r.userData=this.userData),r.layers=this.layers.mask,r.matrix=this.matrix.toArray(),r.up=this.up.toArray(),this.pivot!==null&&(r.pivot=this.pivot.toArray()),this.morphTargetDictionary!==void 0&&(r.morphTargetDictionary=Object.assign({},this.morphTargetDictionary)),this.morphTargetInfluences!==void 0&&(r.morphTargetInfluences=this.morphTargetInfluences.slice()),this.isInstancedMesh&&(r.type=`InstancedMesh`,r.count=this.count,r.instanceMatrix=this.instanceMatrix.toJSON(),this.instanceColor!==null&&(r.instanceColor=this.instanceColor.toJSON())),this.isBatchedMesh&&(r.type=`BatchedMesh`,r.perObjectFrustumCulled=this.perObjectFrustumCulled,r.sortObjects=this.sortObjects,r.drawRanges=this._drawRanges,r.reservedRanges=this._reservedRanges,r.geometryInfo=this._geometryInfo.map(e=>({...e,boundingBox:e.boundingBox?e.boundingBox.toJSON():void 0,boundingSphere:e.boundingSphere?e.boundingSphere.toJSON():void 0})),r.instanceInfo=this._instanceInfo.map(e=>({...e})),r.availableInstanceIds=this._availableInstanceIds.slice(),r.availableGeometryIds=this._availableGeometryIds.slice(),r.nextIndexStart=this._nextIndexStart,r.nextVertexStart=this._nextVertexStart,r.geometryCount=this._geometryCount,r.maxInstanceCount=this._maxInstanceCount,r.maxVertexCount=this._maxVertexCount,r.maxIndexCount=this._maxIndexCount,r.geometryInitialized=this._geometryInitialized,r.matricesTexture=this._matricesTexture.toJSON(e),r.indirectTexture=this._indirectTexture.toJSON(e),this._colorsTexture!==null&&(r.colorsTexture=this._colorsTexture.toJSON(e)),this.boundingSphere!==null&&(r.boundingSphere=this.boundingSphere.toJSON()),this.boundingBox!==null&&(r.boundingBox=this.boundingBox.toJSON()));function i(t,n){return t[n.uuid]===void 0&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(this.isScene)this.background&&(this.background.isColor?r.background=this.background.toJSON():this.background.isTexture&&(r.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&this.environment.isRenderTargetTexture!==!0&&(r.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){r.geometry=i(e.geometries,this.geometry);let t=this.geometry.parameters;if(t!==void 0&&t.shapes!==void 0){let n=t.shapes;if(Array.isArray(n))for(let t=0,r=n.length;t<r;t++){let r=n[t];i(e.shapes,r)}else i(e.shapes,n)}}if(this.isSkinnedMesh&&(r.bindMode=this.bindMode,r.bindMatrix=this.bindMatrix.toArray(),this.skeleton!==void 0&&(i(e.skeletons,this.skeleton),r.skeleton=this.skeleton.uuid)),this.material!==void 0){if(Array.isArray(this.material)){let t=[];for(let n=0,r=this.material.length;n<r;n++)t.push(i(e.materials,this.material[n]));r.material=t}else r.material=i(e.materials,this.material)}if(this.children.length>0){r.children=[];for(let t=0;t<this.children.length;t++)r.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){r.animations=[];for(let t=0;t<this.animations.length;t++){let n=this.animations[t];r.animations.push(i(e.animations,n))}}if(t){let t=a(e.geometries),r=a(e.materials),i=a(e.textures),o=a(e.images),s=a(e.shapes),c=a(e.skeletons),l=a(e.animations),u=a(e.nodes);t.length>0&&(n.geometries=t),r.length>0&&(n.materials=r),i.length>0&&(n.textures=i),o.length>0&&(n.images=o),s.length>0&&(n.shapes=s),c.length>0&&(n.skeletons=c),l.length>0&&(n.animations=l),u.length>0&&(n.nodes=u)}return n.object=r,n;function a(e){let t=[];for(let n in e){let r=e[n];delete r.metadata,t.push(r)}return t}}clone(e){return new this.constructor().copy(this,e)}copy(e,t=!0){if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.pivot=e.pivot===null?null:e.pivot.clone(),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.static=e.static,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),t===!0)for(let t=0;t<e.children.length;t++){let n=e.children[t];this.add(n.clone())}return this}dispose(){this.dispatchEvent({type:`dispose`})}};Nn.DEFAULT_UP=/*@__PURE__*/ new L(0,1,0),Nn.DEFAULT_MATRIX_AUTO_UPDATE=!0,Nn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;let Pn={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},Fn={h:0,s:0,l:0},In={h:0,s:0,l:0};function Ln(e,t,n){return n<0&&(n+=1),n>1&&--n,n<1/6?e+(t-e)*6*n:n<1/2?t:n<2/3?e+(t-e)*6*(2/3-n):e}var Rn=class{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(t===void 0&&n===void 0){let t=e;t&&t.isColor?this.copy(t):typeof t==`number`?this.setHex(t):typeof t==`string`&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e,t=wt){return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(e&255)/255,Jt.colorSpaceToWorking(this,t),this}setRGB(e,t,n,r=Jt.workingColorSpace){return this.r=e,this.g=t,this.b=n,Jt.colorSpaceToWorking(this,r),this}setHSL(e,t,n,r=Jt.workingColorSpace){if(e=It(e,1),t=F(t,0,1),n=F(n,0,1),t===0)this.r=this.g=this.b=n;else{let r=n<=.5?n*(1+t):n+t-n*t,i=2*n-r;this.r=Ln(i,r,e+1/3),this.g=Ln(i,r,e),this.b=Ln(i,r,e-1/3)}return Jt.colorSpaceToWorking(this,r),this}setStyle(e,t=wt){function n(t){t!==void 0&&parseFloat(t)<1&&M(`Color: Alpha component of `+e+` will be ignored.`)}let r;if(r=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let i,a=r[1],o=r[2];switch(a){case`rgb`:case`rgba`:if(i=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(255,parseInt(i[1],10))/255,Math.min(255,parseInt(i[2],10))/255,Math.min(255,parseInt(i[3],10))/255,t);if(i=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(100,parseInt(i[1],10))/100,Math.min(100,parseInt(i[2],10))/100,Math.min(100,parseInt(i[3],10))/100,t);break;case`hsl`:case`hsla`:if(i=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setHSL(parseFloat(i[1])/360,parseFloat(i[2])/100,parseFloat(i[3])/100,t);break;default:M(`Color: Unknown color model `+e)}}else if(r=/^\\#([A-Fa-f\\d]+)$/.exec(e)){let n=r[1],i=n.length;if(i===3)return this.setRGB(parseInt(n.charAt(0),16)/15,parseInt(n.charAt(1),16)/15,parseInt(n.charAt(2),16)/15,t);if(i===6)return this.setHex(parseInt(n,16),t);M(`Color: Invalid hex color `+e)}else if(e&&e.length>0)return this.setColorName(e,t);return this}setColorName(e,t=wt){let n=Pn[e.toLowerCase()];return n===void 0?M(`Color: Unknown color `+e):this.setHex(n,t),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=Yt(e.r),this.g=Yt(e.g),this.b=Yt(e.b),this}copyLinearToSRGB(e){return this.r=Xt(e.r),this.g=Xt(e.g),this.b=Xt(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(e=wt){return Jt.workingToColorSpace(z.copy(this),e),Math.round(F(z.r*255,0,255))*65536+Math.round(F(z.g*255,0,255))*256+Math.round(F(z.b*255,0,255))}getHexString(e=wt){return(`000000`+this.getHex(e).toString(16)).slice(-6)}getHSL(e,t=Jt.workingColorSpace){Jt.workingToColorSpace(z.copy(this),t);let n=z.r,r=z.g,i=z.b,a=Math.max(n,r,i),o=Math.min(n,r,i),s,c,l=(o+a)/2;if(o===a)s=0,c=0;else{let e=a-o;switch(c=l<=.5?e/(a+o):e/(2-a-o),a){case n:s=(r-i)/e+(r<i?6:0);break;case r:s=(i-n)/e+2;break;case i:s=(n-r)/e+4}s/=6}return e.h=s,e.s=c,e.l=l,e}getRGB(e,t=Jt.workingColorSpace){return Jt.workingToColorSpace(z.copy(this),t),e.r=z.r,e.g=z.g,e.b=z.b,e}getStyle(e=wt){Jt.workingToColorSpace(z.copy(this),e);let t=z.r,n=z.g,r=z.b;return e===`srgb`?`rgb(${Math.round(t*255)},${Math.round(n*255)},${Math.round(r*255)})`:`color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`}offsetHSL(e,t,n){return this.getHSL(Fn),this.setHSL(Fn.h+e,Fn.s+t,Fn.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(Fn),e.getHSL(In);let n=Lt(Fn.h,In.h,t),r=Lt(Fn.s,In.s,t),i=Lt(Fn.l,In.l,t);return this.setHSL(n,r,i),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){let t=this.r,n=this.g,r=this.b,i=e.elements;return this.r=i[0]*t+i[3]*n+i[6]*r,this.g=i[1]*t+i[4]*n+i[7]*r,this.b=i[2]*t+i[5]*n+i[8]*r,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e,t=0){return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(e=[],t=0){return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}};let z=/*@__PURE__*/ new Rn;Rn.NAMES=Pn;let zn=/*@__PURE__*/ new L,Bn=/*@__PURE__*/ new L,Vn=/*@__PURE__*/ new L,Hn=/*@__PURE__*/ new L,Un=/*@__PURE__*/ new L,Wn=/*@__PURE__*/ new L,Gn=/*@__PURE__*/ new L,Kn=/*@__PURE__*/ new L,qn=/*@__PURE__*/ new L,Jn=/*@__PURE__*/ new L,Yn=/*@__PURE__*/ new on,Xn=/*@__PURE__*/ new on,Zn=/*@__PURE__*/ new on;var Qn=class e{constructor(e=new L,t=new L,n=new L){this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,r){r.subVectors(n,t),zn.subVectors(e,t),r.cross(zn);let i=r.lengthSq();return i>0?r.multiplyScalar(1/Math.sqrt(i)):r.set(0,0,0)}static getBarycoord(e,t,n,r,i){zn.subVectors(r,t),Bn.subVectors(n,t),Vn.subVectors(e,t);let a=zn.dot(zn),o=zn.dot(Bn),s=zn.dot(Vn),c=Bn.dot(Bn),l=Bn.dot(Vn),u=a*c-o*o;if(u===0)return i.set(0,0,0),null;let d=1/u,f=(c*s-o*l)*d,p=(a*l-o*s)*d;return i.set(1-f-p,p,f)}static containsPoint(e,t,n,r){return this.getBarycoord(e,t,n,r,Hn)!==null&&Hn.x>=0&&Hn.y>=0&&Hn.x+Hn.y<=1}static getInterpolation(e,t,n,r,i,a,o,s){return this.getBarycoord(e,t,n,r,Hn)===null?(s.x=0,s.y=0,`z`in s&&(s.z=0),`w`in s&&(s.w=0),null):(s.setScalar(0),s.addScaledVector(i,Hn.x),s.addScaledVector(a,Hn.y),s.addScaledVector(o,Hn.z),s)}static getInterpolatedAttribute(e,t,n,r,i,a){return Yn.setScalar(0),Xn.setScalar(0),Zn.setScalar(0),Yn.fromBufferAttribute(e,t),Xn.fromBufferAttribute(e,n),Zn.fromBufferAttribute(e,r),a.setScalar(0),a.addScaledVector(Yn,i.x),a.addScaledVector(Xn,i.y),a.addScaledVector(Zn,i.z),a}static isFrontFacing(e,t,n,r){return zn.subVectors(n,t),Bn.subVectors(e,t),zn.cross(Bn).dot(r)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,r){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[r]),this}setFromAttributeAndIndices(e,t,n,r){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,r),this}clone(){return new this.constructor().copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return zn.subVectors(this.c,this.b),Bn.subVectors(this.a,this.b),zn.cross(Bn).length()*.5}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(t){return e.getNormal(this.a,this.b,this.c,t)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(t,n){return e.getBarycoord(t,this.a,this.b,this.c,n)}getInterpolation(t,n,r,i,a){return e.getInterpolation(t,this.a,this.b,this.c,n,r,i,a)}containsPoint(t){return e.containsPoint(t,this.a,this.b,this.c)}isFrontFacing(t){return e.isFrontFacing(this.a,this.b,this.c,t)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){let n=this.a,r=this.b,i=this.c,a,o;Un.subVectors(r,n),Wn.subVectors(i,n),Kn.subVectors(e,n);let s=Un.dot(Kn),c=Wn.dot(Kn);if(s<=0&&c<=0)return t.copy(n);qn.subVectors(e,r);let l=Un.dot(qn),u=Wn.dot(qn);if(l>=0&&u<=l)return t.copy(r);let d=s*u-l*c;if(d<=0&&s>=0&&l<=0)return a=s/(s-l),t.copy(n).addScaledVector(Un,a);Jn.subVectors(e,i);let f=Un.dot(Jn),p=Wn.dot(Jn);if(p>=0&&f<=p)return t.copy(i);let m=f*c-s*p;if(m<=0&&c>=0&&p<=0)return o=c/(c-p),t.copy(n).addScaledVector(Wn,o);let h=l*p-f*u;if(h<=0&&u-l>=0&&f-p>=0)return Gn.subVectors(i,r),o=(u-l)/(u-l+(f-p)),t.copy(r).addScaledVector(Gn,o);let g=1/(h+m+d);return a=m*g,o=d*g,t.copy(n).addScaledVector(Un,a).addScaledVector(Wn,o)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}},B=class{constructor(e=new L(1/0,1/0,1/0),t=new L(-1/0,-1/0,-1/0)){this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(er.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(er.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){let n=er.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e,t=!1){return this.makeEmpty(),this.expandByObject(e,t)}clone(){return new this.constructor().copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e,t=!1){e.updateWorldMatrix(!1,!1);let n=e.geometry;if(n!==void 0){let r=n.getAttribute(`position`);if(t===!0&&r!==void 0&&e.isInstancedMesh!==!0)for(let t=0,n=r.count;t<n;t++)e.isMesh===!0?e.getVertexPosition(t,er):er.fromBufferAttribute(r,t),er.applyMatrix4(e.matrixWorld),this.expandByPoint(er);else e.boundingBox===void 0?(n.boundingBox===null&&n.computeBoundingBox(),tr.copy(n.boundingBox)):(e.boundingBox===null&&e.computeBoundingBox(),tr.copy(e.boundingBox)),tr.applyMatrix4(e.matrixWorld),this.union(tr)}let r=e.children;for(let e=0,n=r.length;e<n;e++)this.expandByObject(r[e],t);return this}containsPoint(e){return e.x>=this.min.x&&e.x<=this.max.x&&e.y>=this.min.y&&e.y<=this.max.y&&e.z>=this.min.z&&e.z<=this.max.z}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return e.max.x>=this.min.x&&e.min.x<=this.max.x&&e.max.y>=this.min.y&&e.min.y<=this.max.y&&e.max.z>=this.min.z&&e.min.z<=this.max.z}intersectsSphere(e){return this.clampPoint(e.center,er),er.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(cr),lr.subVectors(this.max,cr),nr.subVectors(e.a,cr),rr.subVectors(e.b,cr),ir.subVectors(e.c,cr),ar.subVectors(rr,nr),or.subVectors(ir,rr),sr.subVectors(nr,ir);let t=[0,-ar.z,ar.y,0,-or.z,or.y,0,-sr.z,sr.y,ar.z,0,-ar.x,or.z,0,-or.x,sr.z,0,-sr.x,-ar.y,ar.x,0,-or.y,or.x,0,-sr.y,sr.x,0];return!fr(t,nr,rr,ir,lr)||(t=[1,0,0,0,1,0,0,0,1],!fr(t,nr,rr,ir,lr))?!1:(ur.crossVectors(ar,or),t=[ur.x,ur.y,ur.z],fr(t,nr,rr,ir,lr))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,er).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=this.getSize(er).length()*.5),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()?this:($n[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),$n[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),$n[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),$n[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),$n[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),$n[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),$n[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),$n[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints($n),this)}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}toJSON(){return{min:this.min.toArray(),max:this.max.toArray()}}fromJSON(e){return this.min.fromArray(e.min),this.max.fromArray(e.max),this}};let $n=[/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L,/*@__PURE__*/ new L],er=/*@__PURE__*/ new L,tr=/*@__PURE__*/ new B,nr=/*@__PURE__*/ new L,rr=/*@__PURE__*/ new L,ir=/*@__PURE__*/ new L,ar=/*@__PURE__*/ new L,or=/*@__PURE__*/ new L,sr=/*@__PURE__*/ new L,cr=/*@__PURE__*/ new L,lr=/*@__PURE__*/ new L,ur=/*@__PURE__*/ new L,dr=/*@__PURE__*/ new L;function fr(e,t,n,r,i){for(let a=0,o=e.length-3;a<=o;a+=3){dr.fromArray(e,a);let o=i.x*Math.abs(dr.x)+i.y*Math.abs(dr.y)+i.z*Math.abs(dr.z),s=t.dot(dr),c=n.dot(dr),l=r.dot(dr);if(Math.max(-Math.max(s,c,l),Math.min(s,c,l))>o)return!1}return!0}let V=/*@__PURE__*/ new L,pr=/*@__PURE__*/ new I,mr=0;var hr=class extends Pt{constructor(e,t,n=!1){if(super(),Array.isArray(e))throw TypeError(`THREE.BufferAttribute: array should be a Typed Array.`);this.isBufferAttribute=!0,Object.defineProperty(this,\"id\",{value:mr++}),this.name=``,this.array=e,this.itemSize=t,this.count=e===void 0?0:e.length/t,this.normalized=n,this.usage=35044,this.updateRanges=[],this.gpuType=1015,this.version=0}onUploadCallback(){}set needsUpdate(e){e===!0&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let r=0,i=this.itemSize;r<i;r++)this.array[e+r]=t.array[n+r];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(this.itemSize===2)for(let t=0,n=this.count;t<n;t++)pr.fromBufferAttribute(this,t),pr.applyMatrix3(e),this.setXY(t,pr.x,pr.y);else if(this.itemSize===3)for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyMatrix3(e),this.setXYZ(t,V.x,V.y,V.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyMatrix4(e),this.setXYZ(t,V.x,V.y,V.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.applyNormalMatrix(e),this.setXYZ(t,V.x,V.y,V.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)V.fromBufferAttribute(this,t),V.transformDirection(e),this.setXYZ(t,V.x,V.y,V.z);return this}set(e,t=0){return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=Rt(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=zt(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=Rt(t,this.array)),t}setX(e,t){return this.normalized&&(t=zt(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=Rt(t,this.array)),t}setY(e,t){return this.normalized&&(t=zt(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=Rt(t,this.array)),t}setZ(e,t){return this.normalized&&(t=zt(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=Rt(t,this.array)),t}setW(e,t){return this.normalized&&(t=zt(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=zt(t,this.array),n=zt(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,r){return e*=this.itemSize,this.normalized&&(t=zt(t,this.array),n=zt(n,this.array),r=zt(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this}setXYZW(e,t,n,r,i){return e*=this.itemSize,this.normalized&&(t=zt(t,this.array),n=zt(n,this.array),r=zt(r,this.array),i=zt(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this.array[e+3]=i,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){let e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return e.name=this.name,e.usage=this.usage,e.gpuType=this.gpuType,e}dispose(){this.dispatchEvent({type:`dispose`})}},gr=class extends hr{constructor(e,t,n){super(new Uint16Array(e),t,n)}},_r=class extends hr{constructor(e,t,n){super(new Uint32Array(e),t,n)}},vr=class extends hr{constructor(e,t,n){super(new Float32Array(e),t,n)}};let yr=/*@__PURE__*/ new B,br=/*@__PURE__*/ new L,xr=/*@__PURE__*/ new L;var Sr=class{constructor(e=new L,t=-1){this.isSphere=!0,this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){let n=this.center;t===void 0?yr.setFromPoints(e).getCenter(n):n.copy(t);let r=0;for(let t=0,i=e.length;t<i;t++)r=Math.max(r,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(r),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){let t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){let n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius*=e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;br.subVectors(e,this.center);let t=br.lengthSq();if(t>this.radius*this.radius){let e=Math.sqrt(t),n=(e-this.radius)*.5;this.center.addScaledVector(br,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(this.center.equals(e.center)===!0?this.radius=Math.max(this.radius,e.radius):(xr.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(br.copy(e.center).add(xr)),this.expandByPoint(br.copy(e.center).sub(xr))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return new this.constructor().copy(this)}toJSON(){return{radius:this.radius,center:this.center.toArray()}}fromJSON(e){return this.radius=e.radius,this.center.fromArray(e.center),this}};let Cr=0,wr=/*@__PURE__*/ new R,Tr=/*@__PURE__*/ new Nn,Er=/*@__PURE__*/ new L,Dr=/*@__PURE__*/ new B,Or=/*@__PURE__*/ new B,H=/*@__PURE__*/ new L;var kr=class e extends Pt{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,\"id\",{value:Cr++}),this.uuid=Ft(),this.name=``,this.type=`BufferGeometry`,this.index=null,this.indirect=null,this.indirectOffset=0,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={},this._transformed=!1}getIndex(){return this.index}setIndex(e){return this.index=Array.isArray(e)?new(Ot(e)?_r:gr)(e,1):e,this}setIndirect(e,t=0){return this.indirect=e,this.indirectOffset=t,this}getIndirect(){return this.indirect}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return this.attributes[e]!==void 0}addGroup(e,t,n=0){this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){let t=this.attributes.position;t!==void 0&&(t.applyMatrix4(e),t.needsUpdate=!0);let n=this.attributes.normal;if(n!==void 0){let t=new Ut().getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}let r=this.attributes.tangent;return r!==void 0&&(r.transformDirection(e),r.needsUpdate=!0),this.boundingBox!==null&&this.computeBoundingBox(),this.boundingSphere!==null&&this.computeBoundingSphere(),this._transformed=!0,this}applyQuaternion(e){return wr.makeRotationFromQuaternion(e),this.applyMatrix4(wr),this}rotateX(e){return wr.makeRotationX(e),this.applyMatrix4(wr),this}rotateY(e){return wr.makeRotationY(e),this.applyMatrix4(wr),this}rotateZ(e){return wr.makeRotationZ(e),this.applyMatrix4(wr),this}translate(e,t,n){return wr.makeTranslation(e,t,n),this.applyMatrix4(wr),this}scale(e,t,n){return wr.makeScale(e,t,n),this.applyMatrix4(wr),this}lookAt(e){return Tr.lookAt(e),Tr.updateMatrix(),this.applyMatrix4(Tr.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter(Er).negate(),this.translate(Er.x,Er.y,Er.z),this}setFromPoints(e){let t=this.getAttribute(`position`);if(t===void 0){let t=[];for(let n=0,r=e.length;n<r;n++){let r=e[n];t.push(r.x,r.y,r.z||0)}this.setAttribute(`position`,new vr(t,3))}else{let n=Math.min(e.length,t.count);for(let r=0;r<n;r++){let n=e[r];t.setXYZ(r,n.x,n.y,n.z||0)}e.length>t.count&&M(`BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.`),t.needsUpdate=!0}return this}computeBoundingBox(){this.boundingBox===null&&(this.boundingBox=new B);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){N(`BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.`,this),this.boundingBox.set(new L(-1/0,-1/0,-1/0),new L(1/0,1/0,1/0));return}if(e!==void 0){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];Dr.setFromBufferAttribute(n),this.morphTargetsRelative?(H.addVectors(this.boundingBox.min,Dr.min),this.boundingBox.expandByPoint(H),H.addVectors(this.boundingBox.max,Dr.max),this.boundingBox.expandByPoint(H)):(this.boundingBox.expandByPoint(Dr.min),this.boundingBox.expandByPoint(Dr.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&N(`BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.`,this)}computeBoundingSphere(){this.boundingSphere===null&&(this.boundingSphere=new Sr);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){N(`BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.`,this),this.boundingSphere.set(new L,1/0);return}if(e){let n=this.boundingSphere.center;if(Dr.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];Or.setFromBufferAttribute(n),this.morphTargetsRelative?(H.addVectors(Dr.min,Or.min),Dr.expandByPoint(H),H.addVectors(Dr.max,Or.max),Dr.expandByPoint(H)):(Dr.expandByPoint(Or.min),Dr.expandByPoint(Or.max))}Dr.getCenter(n);let r=0;for(let t=0,i=e.count;t<i;t++)H.fromBufferAttribute(e,t),r=Math.max(r,n.distanceToSquared(H));if(t)for(let i=0,a=t.length;i<a;i++){let a=t[i],o=this.morphTargetsRelative;for(let t=0,i=a.count;t<i;t++)H.fromBufferAttribute(a,t),o&&(Er.fromBufferAttribute(e,t),H.add(Er)),r=Math.max(r,n.distanceToSquared(H))}this.boundingSphere.radius=Math.sqrt(r),isNaN(this.boundingSphere.radius)&&N(`BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.`,this)}}computeTangents(){let e=this.index,t=this.attributes;if(e===null||t.position===void 0||t.normal===void 0||t.uv===void 0){N(`BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)`);return}let n=t.position,r=t.normal,i=t.uv,a=this.getAttribute(`tangent`);(a===void 0||a.count!==n.count)&&(a=new hr(new Float32Array(4*n.count),4),this.setAttribute(`tangent`,a));let o=[],s=[];for(let e=0;e<n.count;e++)o[e]=new L,s[e]=new L;let c=new L,l=new L,u=new L,d=new I,f=new I,p=new I,m=new L,h=new L;function g(e,t,r){c.fromBufferAttribute(n,e),l.fromBufferAttribute(n,t),u.fromBufferAttribute(n,r),d.fromBufferAttribute(i,e),f.fromBufferAttribute(i,t),p.fromBufferAttribute(i,r),l.sub(c),u.sub(c),f.sub(d),p.sub(d);let a=1/(f.x*p.y-p.x*f.y);isFinite(a)&&(m.copy(l).multiplyScalar(p.y).addScaledVector(u,-f.y).multiplyScalar(a),h.copy(u).multiplyScalar(f.x).addScaledVector(l,-p.x).multiplyScalar(a),o[e].add(m),o[t].add(m),o[r].add(m),s[e].add(h),s[t].add(h),s[r].add(h))}let _=this.groups;_.length===0&&(_=[{start:0,count:e.count}]);for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)g(e.getX(t+0),e.getX(t+1),e.getX(t+2))}let v=new L,y=new L,b=new L,x=new L;function S(e){b.fromBufferAttribute(r,e),x.copy(b);let t=o[e];v.copy(t),v.sub(b.multiplyScalar(b.dot(t))).normalize(),y.crossVectors(x,t);let n=y.dot(s[e])<0?-1:1;a.setXYZW(e,v.x,v.y,v.z,n)}for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)S(e.getX(t+0)),S(e.getX(t+1)),S(e.getX(t+2))}this._transformed=!0}computeVertexNormals(){let e=this.index,t=this.getAttribute(`position`);if(t!==void 0){let n=this.getAttribute(`normal`);if(n===void 0||n.count!==t.count)n=new hr(new Float32Array(t.count*3),3),this.setAttribute(`normal`,n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);let r=new L,i=new L,a=new L,o=new L,s=new L,c=new L,l=new L,u=new L;if(e)for(let d=0,f=e.count;d<f;d+=3){let f=e.getX(d+0),p=e.getX(d+1),m=e.getX(d+2);r.fromBufferAttribute(t,f),i.fromBufferAttribute(t,p),a.fromBufferAttribute(t,m),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),o.fromBufferAttribute(n,f),s.fromBufferAttribute(n,p),c.fromBufferAttribute(n,m),o.add(l),s.add(l),c.add(l),n.setXYZ(f,o.x,o.y,o.z),n.setXYZ(p,s.x,s.y,s.z),n.setXYZ(m,c.x,c.y,c.z)}else for(let e=0,o=t.count;e<o;e+=3)r.fromBufferAttribute(t,e+0),i.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),n.setXYZ(e+0,l.x,l.y,l.z),n.setXYZ(e+1,l.x,l.y,l.z),n.setXYZ(e+2,l.x,l.y,l.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){let e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)H.fromBufferAttribute(e,t),H.normalize(),e.setXYZ(t,H.x,H.y,H.z)}toNonIndexed(){function t(e,t){let n=e.array,r=e.itemSize,i=e.normalized,a=new n.constructor(t.length*r),o=0,s=0;for(let i=0,c=t.length;i<c;i++){o=e.isInterleavedBufferAttribute?t[i]*e.data.stride+e.offset:t[i]*r;for(let e=0;e<r;e++)a[s++]=n[o++]}return new hr(a,r,i)}if(this.index===null)return M(`BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.`),this;let n=new e,r=this.index.array,i=this.attributes;for(let e in i){let a=i[e],o=t(a,r);n.setAttribute(e,o)}let a=this.morphAttributes;for(let e in a){let i=[],o=a[e];for(let e=0,n=o.length;e<n;e++){let n=o[e],a=t(n,r);i.push(a)}n.morphAttributes[e]=i}n.morphTargetsRelative=this.morphTargetsRelative;let o=this.groups;for(let e=0,t=o.length;e<t;e++){let t=o[e];n.addGroup(t.start,t.count,t.materialIndex)}return n}toJSON(){let e={metadata:{version:4.7,type:`BufferGeometry`,generator:`BufferGeometry.toJSON`}};if(e.uuid=this.uuid,e.type=this.parameters!==void 0&&this._transformed===!0?`BufferGeometry`:this.type,e.name=this.name,Object.keys(this.userData).length>0&&(e.userData=this.userData),this.parameters!==void 0&&this._transformed!==!0){let t=this.parameters;for(let n in t)t[n]!==void 0&&(e[n]=t[n]);return e}e.data={attributes:{}};let t=this.index;t!==null&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});let n=this.attributes;for(let t in n){let r=n[t];e.data.attributes[t]=r.toJSON(e.data)}let r={},i=!1;for(let t in this.morphAttributes){let n=this.morphAttributes[t],a=[];for(let t=0,r=n.length;t<r;t++){let r=n[t];a.push(r.toJSON(e.data))}a.length>0&&(r[t]=a,i=!0)}i&&(e.data.morphAttributes=r,e.data.morphTargetsRelative=this.morphTargetsRelative);let a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));let o=this.boundingSphere;return o!==null&&(e.data.boundingSphere=o.toJSON()),e}clone(){return new this.constructor().copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;let t={};this.name=e.name;let n=e.index;n!==null&&this.setIndex(n.clone());let r=e.attributes;for(let e in r){let n=r[e];this.setAttribute(e,n.clone(t))}let i=e.morphAttributes;for(let e in i){let n=[],r=i[e];for(let e=0,i=r.length;e<i;e++)n.push(r[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;let a=e.groups;for(let e=0,t=a.length;e<t;e++){let t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}let o=e.boundingBox;o!==null&&(this.boundingBox=o.clone());let s=e.boundingSphere;return s!==null&&(this.boundingSphere=s.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this._transformed=e._transformed,this}dispose(){this.dispatchEvent({type:`dispose`})}};let Ar=/*@__PURE__*/ new L,jr=/*@__PURE__*/ new L,Mr=/*@__PURE__*/ new Ut;var Nr=class{constructor(e=new L(1,0,0),t=0){this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,r){return this.normal.set(e,t,n),this.constant=r,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){let r=Ar.subVectors(n,t).cross(jr.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(r,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){let e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t,n=!0){let r=e.delta(Ar),i=this.normal.dot(r);if(i===0)return this.distanceToPoint(e.start)===0?t.copy(e.start):null;let a=-(e.start.dot(this.normal)+this.constant)/i;return n===!0&&(a<0||a>1)?null:t.copy(e.start).addScaledVector(r,a)}intersectsLine(e){let t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){let n=t||Mr.getNormalMatrix(e),r=this.coplanarPoint(Ar).applyMatrix4(e),i=this.normal.applyMatrix3(n).normalize();return this.constant=-r.dot(i),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return new this.constructor().copy(this)}toJSON(){return{normal:this.normal.toArray(),constant:this.constant}}fromJSON(e){return this.normal.fromArray(e.normal),this.constant=e.constant,this}};let Pr=/*@__PURE__*/ new L,Fr=/*@__PURE__*/ new L,Ir=/*@__PURE__*/ new L,Lr=/*@__PURE__*/ new L;var Rr=class{constructor(e=new L,t=new L(0,0,-1)){this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,Pr)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);let n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){let t=Pr.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(Pr.copy(this.origin).addScaledVector(this.direction,t),Pr.distanceToSquared(e))}distanceSqToSegment(e,t,n,r){Fr.copy(e).add(t).multiplyScalar(.5),Ir.copy(t).sub(e).normalize(),Lr.copy(this.origin).sub(Fr);let i=e.distanceTo(t)*.5,a=-this.direction.dot(Ir),o=Lr.dot(this.direction),s=-Lr.dot(Ir),c=Lr.lengthSq(),l=Math.abs(1-a*a),u,d,f,p;if(l>0){if(u=a*s-o,d=a*o-s,p=i*l,u>=0){if(d>=-p){if(d<=p){let e=1/l;u*=e,d*=e,f=u*(u+a*d+2*o)+d*(a*u+d+2*s)+c}else d=i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d=-i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d<=-p?(u=Math.max(0,-(-a*i+o)),d=u>0?-i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c):d<=p?(u=0,d=Math.min(Math.max(-i,-s),i),f=d*(d+2*s)+c):(u=Math.max(0,-(a*i+o)),d=u>0?i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c)}else d=a>0?-i:i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c;return n&&n.copy(this.origin).addScaledVector(this.direction,u),r&&r.copy(Fr).addScaledVector(Ir,d),f}intersectSphere(e,t){if(e.radius<0)return null;Pr.subVectors(e.center,this.origin);let n=Pr.dot(this.direction),r=Pr.dot(Pr)-n*n,i=e.radius*e.radius;if(r>i)return null;let a=Math.sqrt(i-r),o=n-a,s=n+a;return s<0?null:o<0?this.at(s,t):this.at(o,t)}intersectsSphere(e){return e.radius<0?!1:this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){let t=e.normal.dot(this.direction);if(t===0)return e.distanceToPoint(this.origin)===0?0:null;let n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){let n=this.distanceToPlane(e);return n===null?null:this.at(n,t)}intersectsPlane(e){let t=e.distanceToPoint(this.origin);return t===0||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,r,i,a,o,s,c=1/this.direction.x,l=1/this.direction.y,u=1/this.direction.z,d=this.origin;return c>=0?(n=(e.min.x-d.x)*c,r=(e.max.x-d.x)*c):(n=(e.max.x-d.x)*c,r=(e.min.x-d.x)*c),l>=0?(i=(e.min.y-d.y)*l,a=(e.max.y-d.y)*l):(i=(e.max.y-d.y)*l,a=(e.min.y-d.y)*l),n>a||i>r||((i>n||isNaN(n))&&(n=i),(a<r||isNaN(r))&&(r=a),u>=0?(o=(e.min.z-d.z)*u,s=(e.max.z-d.z)*u):(o=(e.max.z-d.z)*u,s=(e.min.z-d.z)*u),n>s||o>r)||((o>n||n!==n)&&(n=o),(s<r||r!==r)&&(r=s),r<0)?null:this.at(n>=0?n:r,t)}intersectsBox(e){return this.intersectBox(e,Pr)!==null}intersectTriangle(e,t,n,r,i){let a=this.origin,o=this.direction,s=o.x,c=o.y,l=o.z,u=e.x-a.x,d=e.y-a.y,f=e.z-a.z,p=t.x-a.x,m=t.y-a.y,h=t.z-a.z,g=n.x-a.x,_=n.y-a.y,v=n.z-a.z,y=Math.abs(s),b=Math.abs(c),x=Math.abs(l),S,C,w,T,E,D,O,k,A,j,ee,te;if(y>=b&&y>=x?(w=s,D=u,A=p,te=g,s>=0?(S=c,C=l,T=d,E=f,O=m,k=h,j=_,ee=v):(S=l,C=c,T=f,E=d,O=h,k=m,j=v,ee=_)):b>=x?(w=c,D=d,A=m,te=_,c>=0?(S=l,C=s,T=f,E=u,O=h,k=p,j=v,ee=g):(S=s,C=l,T=u,E=f,O=p,k=h,j=g,ee=v)):(w=l,D=f,A=h,te=v,l>=0?(S=s,C=c,T=u,E=d,O=p,k=m,j=g,ee=_):(S=c,C=s,T=d,E=u,O=m,k=p,j=_,ee=g)),w===0)return null;let ne=S/w,re=C/w,ie=1/w,ae=T-ne*D,oe=E-re*D,se=O-ne*A,ce=k-re*A,le=j-ne*te,ue=ee-re*te,de=le*ce-ue*se,fe=ae*ue-oe*le,pe=se*oe-ce*ae;if(r){if(de<0||fe<0||pe<0)return null}else if((de<0||fe<0||pe<0)&&(de>0||fe>0||pe>0))return null;let me=de+fe+pe;if(me===0)return null;let he=ie*(de*D+fe*A+pe*te);return(me>0?he<0:he>0)?null:this.at(he/me,i)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return new this.constructor().copy(this)}};function zr(e,t){return!e||e.constructor===t?e:typeof t.BYTES_PER_ELEMENT==`number`?new t(e):Array.prototype.slice.call(e)}function Br(e){return e!==void 0&&e.inTangents!==void 0&&e.outTangents!==void 0}var Vr=class{constructor(e,t,n,r){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=r===void 0?new t.constructor(n):r,this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){let t=this.parameterPositions,n=this._cachedIndex,r=t[n],i=t[n-1];validate_interval:{seek:{let a;linear_scan:{forward_scan:if(!(e<r)){for(let a=n+2;;){if(r===void 0){if(e<i)break forward_scan;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(i=r,r=t[++n],e<r)break seek}a=t.length;break linear_scan}if(!(e>=i)){let o=t[1];e<o&&(n=2,i=o);for(let a=n-2;;){if(i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(r=i,i=t[--n-1],e>=i)break seek}a=n,n=0;break linear_scan}break validate_interval}for(;n<a;){let r=n+a>>>1;e<t[r]?a=r:n=r+1}if(r=t[n],i=t[n-1],i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(r===void 0)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,i,r)}return this.interpolate_(n,i,e,r)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){let t=this.resultBuffer,n=this.sampleValues,r=this.valueSize,i=e*r;for(let e=0;e!==r;++e)t[e]=n[i+e];return t}interpolate_(){throw Error(`THREE.Interpolant: Call to abstract method.`)}intervalChanged_(){}},Hr=class extends Vr{constructor(e,t,n,r){super(e,t,n,r),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:xt,endingEnd:xt}}intervalChanged_(e,t,n){let r=this.parameterPositions,i=e-2,a=e+1,o=r[i],s=r[a];if(o===void 0)switch(this.getSettings_().endingStart){case St:i=e,o=2*t-n;break;case Ct:i=r.length-2,o=t+r[i]-r[i+1];break;default:i=e,o=n}if(s===void 0)switch(this.getSettings_().endingEnd){case St:a=e,s=2*n-t;break;case Ct:a=1,s=n+r[1]-r[0];break;default:a=e-1,s=t}let c=(n-t)*.5,l=this.valueSize;this._weightPrev=c/(t-o),this._weightNext=c/(s-n),this._offsetPrev=i*l,this._offsetNext=a*l}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this._offsetPrev,u=this._offsetNext,d=this._weightPrev,f=this._weightNext,p=(n-t)/(r-t),m=p*p,h=m*p,g=-d*h+2*d*m-d*p,_=(1+d)*h+(-1.5-2*d)*m+(-.5+d)*p+1,v=(-1-f)*h+(1.5+f)*m+.5*p,y=f*h-f*m;for(let e=0;e!==o;++e)i[e]=g*a[l+e]+_*a[c+e]+v*a[s+e]+y*a[u+e];return i}},Ur=class extends Vr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=(n-t)/(r-t),u=1-l;for(let e=0;e!==o;++e)i[e]=a[c+e]*u+a[s+e]*l;return i}},Wr=class extends Vr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e){return this.copySampleValue_(e-1)}},Gr=class extends Vr{interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this.inTangents,u=this.outTangents;if(!l||!u){let e=(n-t)/(r-t),l=1-e;for(let t=0;t!==o;++t)i[t]=a[c+t]*l+a[s+t]*e;return i}let d=o*2,f=e-1;for(let p=0;p!==o;++p){let o=a[c+p],m=a[s+p],h=f*d+p*2,g=u[h],_=u[h+1],v=e*d+p*2,y=l[v],b=l[v+1],x=Jr(n,t,g,y,r);i[p]=Kr(x,o,_,b,m)}return i}};function Kr(e,t,n,r,i){let a=1-e;return a*a*a*t+3*a*a*e*n+3*a*e*e*r+e*e*e*i}function qr(e,t,n,r,i){let a=1-e;return 3*a*a*(n-t)+6*a*e*(r-n)+3*e*e*(i-r)}function Jr(e,t,n,r,i){let a=(e-t)/(i-t);for(let o=0;o<8;o++){let o=Kr(a,t,n,r,i)-e;if(Math.abs(o)<1e-10)break;let s=qr(a,t,n,r,i);if(Math.abs(s)<1e-10)break;a=Math.max(0,Math.min(1,a-o/s))}return a}var Yr=class{constructor(e,t,n,r){if(e===void 0)throw Error(`THREE.KeyframeTrack: track name is undefined`);if(t===void 0||t.length===0)throw Error(`THREE.KeyframeTrack: no keyframes in track named `+e);this.name=e,this.times=zr(t,this.TimeBufferType),this.values=zr(n,this.ValueBufferType),this.setInterpolation(r||this.DefaultInterpolation)}static toJSON(e){let t=e.constructor,n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:zr(e.times,Array),values:zr(e.values,Array)};let t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t),Br(e.settings)&&(n.settings={inTangents:zr(e.settings.inTangents,Array),outTangents:zr(e.settings.outTangents,Array)})}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new Wr(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new Ur(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new Hr(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodBezier(e){let t=new Gr(this.times,this.values,this.getValueSize(),e);return this.settings&&(t.inTangents=this.settings.inTangents,t.outTangents=this.settings.outTangents),t}setInterpolation(e){let t;switch(e){case _t:t=this.InterpolantFactoryMethodDiscrete;break;case vt:t=this.InterpolantFactoryMethodLinear;break;case yt:t=this.InterpolantFactoryMethodSmooth;break;case bt:t=this.InterpolantFactoryMethodBezier}if(t===void 0){let t=`unsupported interpolation for `+this.ValueTypeName+` keyframe track named `+this.name;if(this.createInterpolant===void 0){if(e!==this.DefaultInterpolation)this.setInterpolation(this.DefaultInterpolation);else throw Error(t)}return M(`KeyframeTrack:`,t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return _t;case this.InterpolantFactoryMethodLinear:return vt;case this.InterpolantFactoryMethodSmooth:return yt;case this.InterpolantFactoryMethodBezier:return bt}}getValueSize(){return this.values.length/this.times.length}shift(e){if(e!==0){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]+=e}return this}scale(e){if(e!==1){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]*=e;Br(this.settings)&&(Xr(this.settings.inTangents,e),Xr(this.settings.outTangents,e))}return this}trim(e,t){let n=this.times,r=n.length,i=0,a=r-1;for(;i!==r&&n[i]<e;)++i;for(;a!==-1&&n[a]>t;)--a;if(++a,i!==0||a!==r){i>=a&&(a=Math.max(a,1),i=a-1);let e=this.getValueSize();this.times=n.slice(i,a),this.values=this.values.slice(i*e,a*e)}return this}validate(){let e=!0,t=this.getValueSize();t-Math.floor(t)!==0&&(N(`KeyframeTrack: Invalid value size in track.`,this),e=!1);let n=this.times,r=this.values,i=n.length;i===0&&(N(`KeyframeTrack: Track is empty.`,this),e=!1);let a=null;for(let t=0;t!==i;t++){let r=n[t];if(typeof r==`number`&&isNaN(r)){N(`KeyframeTrack: Time is not a valid number.`,this,t,r),e=!1;break}if(a!==null&&a>r){N(`KeyframeTrack: Out of order keys.`,this,t,r,a),e=!1;break}a=r}if(r!==void 0&&kt(r))for(let t=0,n=r.length;t!==n;++t){let n=r[t];if(isNaN(n)){N(`KeyframeTrack: Value is not a valid number.`,this,t,n),e=!1;break}}return e}optimize(){let e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),r=this.getInterpolation()===yt,i=e.length-1,a=1;for(let o=1;o<i;++o){let i=!1,s=e[o];if(s!==e[o+1]&&(o!==1||s!==e[0])){if(r)i=!0;else{let e=o*n,r=e-n,a=e+n;for(let o=0;o!==n;++o){let n=t[e+o];if(n!==t[r+o]||n!==t[a+o]){i=!0;break}}}}if(i){if(o!==a){e[a]=e[o];let r=o*n,i=a*n;for(let e=0;e!==n;++e)t[i+e]=t[r+e]}++a}}if(i>0){e[a]=e[i];for(let e=i*n,r=a*n,o=0;o!==n;++o)t[r+o]=t[e+o];++a}return a===e.length?(this.times=e,this.values=t):(this.times=e.slice(0,a),this.values=t.slice(0,a*n)),this}clone(){let e=this.times.slice(),t=this.values.slice(),n=this.constructor,r=new n(this.name,e,t);return r.createInterpolant=this.createInterpolant,Br(this.settings)&&(r.settings={inTangents:this.settings.inTangents.slice(),outTangents:this.settings.outTangents.slice()}),r}};function Xr(e,t){for(let n=0,r=e.length;n!==r;n+=2)e[n]*=t}Yr.prototype.ValueTypeName=``,Yr.prototype.TimeBufferType=Float32Array,Yr.prototype.ValueBufferType=Float32Array,Yr.prototype.DefaultInterpolation=vt;var Zr=class extends Yr{constructor(e,t,n){super(e,t,n)}};Zr.prototype.ValueTypeName=`bool`,Zr.prototype.ValueBufferType=Array,Zr.prototype.DefaultInterpolation=_t,Zr.prototype.InterpolantFactoryMethodLinear=void 0,Zr.prototype.InterpolantFactoryMethodSmooth=void 0;var Qr=class extends Yr{constructor(e,t,n,r){super(e,t,n,r)}};Qr.prototype.ValueTypeName=`color`;var $r=class extends Yr{constructor(e,t,n,r){super(e,t,n,r)}};$r.prototype.ValueTypeName=`number`;var ei=class extends Vr{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=(n-t)/(r-t),c=e*o;for(let e=c+o;c!==e;c+=4)Bt.slerpFlat(i,0,a,c-o,a,c,s);return i}},ti=class extends Yr{constructor(e,t,n,r){super(e,t,n,r)}InterpolantFactoryMethodLinear(e){return new ei(this.times,this.values,this.getValueSize(),e)}};ti.prototype.ValueTypeName=`quaternion`,ti.prototype.InterpolantFactoryMethodSmooth=void 0;var ni=class extends Yr{constructor(e,t,n){super(e,t,n)}};ni.prototype.ValueTypeName=`string`,ni.prototype.ValueBufferType=Array,ni.prototype.DefaultInterpolation=_t,ni.prototype.InterpolantFactoryMethodLinear=void 0,ni.prototype.InterpolantFactoryMethodSmooth=void 0;var ri=class extends Yr{constructor(e,t,n,r){super(e,t,n,r)}};ri.prototype.ValueTypeName=`vector`;let ii=/* @__PURE__ */ RegExp(`[\\\\[\\\\]\\\\.:\\\\/]`,`g`),ai=/* @__PURE__ */ RegExp(`^((?:[^\\\\[\\\\]\\\\.:\\\\/]+[\\\\/:])*)([^\\\\[\\\\]:\\\\/]+)?(?:\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?)?\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?$`),oi=[`material`,`materials`,`bones`,`map`];var si=class{constructor(e,t,n){let r=n||U.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,r)}getValue(e,t){this.bind();let n=this._targetGroup.nCachedObjects_,r=this._bindings[n];r!==void 0&&r.getValue(e,t)}setValue(e,t){let n=this._bindings;for(let r=this._targetGroup.nCachedObjects_,i=n.length;r!==i;++r)n[r].setValue(e,t)}bind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},U=class e{constructor(t,n,r){this.path=n,this.parsedPath=r||e.parseTrackName(n),this.node=e.findNode(t,this.parsedPath.nodeName),this.rootNode=t,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(t,n,r){return t&&t.isAnimationObjectGroup?new e.Composite(t,n,r):new e(t,n,r)}static sanitizeNodeName(e){return e.replace(/\\s/g,`_`).replace(ii,``)}static parseTrackName(e){let t=ai.exec(e);if(t===null)throw Error(`THREE.PropertyBinding: Cannot parse trackName: `+e);let n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},r=n.nodeName&&n.nodeName.lastIndexOf(`.`);if(r!==void 0&&r!==-1){let e=n.nodeName.substring(r+1);oi.indexOf(e)!==-1&&(n.nodeName=n.nodeName.substring(0,r),n.objectName=e)}if(n.propertyName===null||n.propertyName.length===0)throw Error(`THREE.PropertyBinding: can not parse propertyName from trackName: `+e);return n}static findNode(e,t){if(t===void 0||t===``||t===`.`||t===-1||t===e.name||t===e.uuid)return e;if(e.skeleton){let n=e.skeleton.getBoneByName(t);if(n!==void 0)return n}if(e.children){let n=function(e){for(let r=0;r<e.length;r++){let i=e[r];if(i.name===t||i.uuid===t)return i;let a=n(i.children);if(a)return a}return null},r=n(e.children);if(r)return r}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)e[t++]=n[r]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++]}_setValue_array_setNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let t=this.node,n=this.parsedPath,r=n.objectName,i=n.propertyName,a=n.propertyIndex;if(t||(t=e.findNode(this.rootNode,n.nodeName),this.node=t),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!t){M(`PropertyBinding: No target node found for track: `+this.path+`.`);return}if(r){let e=n.objectIndex;switch(r){case`materials`:if(!t.material){N(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.materials){N(`PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.`,this);return}t=t.material.materials;break;case`bones`:if(!t.skeleton){N(`PropertyBinding: Can not bind to bones as node does not have a skeleton.`,this);return}t=t.skeleton.bones;for(let n=0;n<t.length;n++)if(t[n].name===e){e=n;break}break;case`map`:if(`map`in t){t=t.map;break}if(!t.material){N(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.map){N(`PropertyBinding: Can not bind to material.map as node.material does not have a map.`,this);return}t=t.material.map;break;default:if(t[r]===void 0){N(`PropertyBinding: Can not bind to objectName of node undefined.`,this);return}t=t[r]}if(e!==void 0){if(t[e]===void 0){N(`PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.`,this,t);return}t=t[e]}}let o=t[i];if(o===void 0){let e=n.nodeName;N(`PropertyBinding: Trying to update property for track: `+e+`.`+i+` but it wasn't found.`,t);return}let s=this.Versioning.None;this.targetObject=t,t.isMaterial===!0?s=this.Versioning.NeedsUpdate:t.isObject3D===!0&&(s=this.Versioning.MatrixWorldNeedsUpdate);let c=this.BindingType.Direct;if(a!==void 0){if(i===`morphTargetInfluences`){if(!t.geometry){N(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.`,this);return}if(!t.geometry.morphAttributes){N(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.`,this);return}t.morphTargetDictionary[a]!==void 0&&(a=t.morphTargetDictionary[a])}c=this.BindingType.ArrayElement,this.resolvedProperty=o,this.propertyIndex=a}else o.fromArray!==void 0&&o.toArray!==void 0?(c=this.BindingType.HasFromToArray,this.resolvedProperty=o):Array.isArray(o)?(c=this.BindingType.EntireArray,this.resolvedProperty=o):this.propertyName=i;this.getValue=this.GetterByBindingType[c],this.setValue=this.SetterByBindingTypeAndVersioning[c][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}};U.Composite=si,U.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},U.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},U.prototype.GetterByBindingType=[U.prototype._getValue_direct,U.prototype._getValue_array,U.prototype._getValue_arrayElement,U.prototype._getValue_toArray],U.prototype.SetterByBindingTypeAndVersioning=[[U.prototype._setValue_direct,U.prototype._setValue_direct_setNeedsUpdate,U.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[U.prototype._setValue_array,U.prototype._setValue_array_setNeedsUpdate,U.prototype._setValue_array_setMatrixWorldNeedsUpdate],[U.prototype._setValue_arrayElement,U.prototype._setValue_arrayElement_setNeedsUpdate,U.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[U.prototype._setValue_fromArray,U.prototype._setValue_fromArray_setNeedsUpdate,U.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],class e{static{e.prototype.isMatrix2=!0}constructor(e,t,n,r){this.elements=[1,0,0,1],e!==void 0&&this.set(e,t,n,r)}identity(){return this.set(1,0,0,1),this}fromArray(e,t=0){for(let n=0;n<4;n++)this.elements[n]=e[n+t];return this}set(e,t,n,r){let i=this.elements;return i[0]=e,i[2]=t,i[1]=n,i[3]=r,this}};let ci=/*@__PURE__*/ new L,li=/*@__PURE__*/ new L,ui=/*@__PURE__*/ new L,di=/*@__PURE__*/ new L,fi=/*@__PURE__*/ new L,pi=/*@__PURE__*/ new L,mi=/*@__PURE__*/ new L;var hi=class{constructor(e=new L,t=new L){this.start=e,this.end=t}set(e,t){return this.start.copy(e),this.end.copy(t),this}copy(e){return this.start.copy(e.start),this.end.copy(e.end),this}getCenter(e){return e.addVectors(this.start,this.end).multiplyScalar(.5)}delta(e){return e.subVectors(this.end,this.start)}distanceSq(){return this.start.distanceToSquared(this.end)}distance(){return this.start.distanceTo(this.end)}at(e,t){return this.delta(t).multiplyScalar(e).add(this.start)}closestPointToPointParameter(e,t){ci.subVectors(e,this.start),li.subVectors(this.end,this.start);let n=li.dot(li);if(n===0)return 0;let r=li.dot(ci)/n;return t&&(r=F(r,0,1)),r}closestPointToPoint(e,t,n){let r=this.closestPointToPointParameter(e,t);return this.delta(n).multiplyScalar(r).add(this.start)}distanceSqToLine3(e,t=pi,n=mi){let r=1e-8*1e-8,i,a,o=this.start,s=e.start,c=this.end,l=e.end;ui.subVectors(c,o),di.subVectors(l,s),fi.subVectors(o,s);let u=ui.dot(ui),d=di.dot(di),f=di.dot(fi);if(u<=r&&d<=r)return t.copy(o),n.copy(s),t.sub(n),t.dot(t);if(u<=r)i=0,a=f/d,a=F(a,0,1);else{let e=ui.dot(fi);if(d<=r)a=0,i=F(-e/u,0,1);else{let t=ui.dot(di),n=u*d-t*t;i=n===0?0:F((t*f-e*d)/n,0,1),a=(t*i+f)/d,a<0?(a=0,i=F(-e/u,0,1)):a>1&&(a=1,i=F((t-e)/u,0,1))}}return t.copy(o).addScaledVector(ui,i),n.copy(s).addScaledVector(di,a),t.distanceToSquared(n)}applyMatrix4(e){return this.start.applyMatrix4(e),this.end.applyMatrix4(e),this}equals(e){return e.start.equals(this.start)&&e.end.equals(this.end)}clone(){return new this.constructor().copy(this)}};typeof __THREE_DEVTOOLS__<`u`&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`register`,{detail:{revision:`186`}})),typeof window<`u`&&(window.__THREE__?M(`WARNING: Multiple instances of Three.js being imported.`):window.__THREE__=`186`);function gi(e,t,n,r){let{node:i}=e.layout;return!(t[n+i.MAX_X]<r.min.x||t[n+i.MIN_X]>r.max.x||t[n+i.MAX_Y]<r.min.y||t[n+i.MIN_Y]>r.max.y||t[n+i.MAX_Z]<r.min.z||t[n+i.MIN_Z]>r.max.z)}function _i(e,t){let{header:n,node:r}=e;return n.STRIDE+t*r.STRIDE}function vi(e,t){return{root:e.boxTree.root,layout:e.boxTree.layout,bounds:new Float32Array(e.boxTree.buffer),indices:new Int32Array(e.boxTree.buffer),instancesByLeaf:t,stack:[]}}function yi(e,t,n,r){if(r.length=0,e.root===e.layout.notDefined)return;let{bounds:i,indices:a,instancesByLeaf:o,stack:s}=e,{node:c,notDefined:l}=e.layout;for(s.length=0,s.push(e.root,0,0);s.length>0;){let u=s.pop()===1,d=s.pop(),f=s.pop(),p=_i(e.layout,f);if(!u&&!gi(e,i,p,t))continue;let m=a[p+c.OBJID];if(m!==l){o[m]!==void 0&&r.push(m);continue}let h=u||d>=n,g=d+1,_=+!!h;s.push(a[p+c.LEFT],g,_,a[p+c.RIGHT],g,_)}}let bi=1.25,xi=65535,Si=2**-24,Ci=Symbol(`SKIP_GENERATION`),wi={strategy:0,maxDepth:40,targetLeafSize:10,useSharedArrayBuffer:!1,setBoundingBox:!0,onProgress:null,indirect:!1,verbose:!0,range:null,[Ci]:!1};function W(e,t,n){return n.min.x=t[e],n.min.y=t[e+1],n.min.z=t[e+2],n.max.x=t[e+3],n.max.y=t[e+4],n.max.z=t[e+5],n}function Ti(e){let t=-1,n=-1/0;for(let r=0;r<3;r++){let i=e[r+3]-e[r];i>n&&(n=i,t=r)}return t}function Ei(e,t){t.set(e)}function Di(e,t,n){let r,i;for(let a=0;a<3;a++){let o=a+3;r=e[a],i=t[a],n[a]=r<i?r:i,r=e[o],i=t[o],n[o]=r>i?r:i}}function Oi(e,t,n){for(let r=0;r<3;r++){let i=t[e+2*r],a=t[e+2*r+1],o=i-a,s=i+a;o<n[r]&&(n[r]=o),s>n[r+3]&&(n[r+3]=s)}}function ki(e){let t=e[3]-e[0],n=e[4]-e[1],r=e[5]-e[2];return 2*(t*n+n*r+r*t)}function G(e,t){return t[e+15]===xi}function K(e,t){return t[e+6]}function q(e,t){return t[e+14]}function J(e){return e+8}function Y(e,t){return e+t[e+6]*8}function Ai(e,t){return t[e+7]}function X(e){return e}function ji(e,t,n,r,i){let a=1/0,o=1/0,s=1/0,c=-1/0,l=-1/0,u=-1/0,d=1/0,f=1/0,p=1/0,m=-1/0,h=-1/0,g=-1/0,_=e.offset||0;for(let r=(t-_)*6,i=(t+n-_)*6;r<i;r+=6){let t=e[r+0],n=e[r+1],i=t-n,_=t+n;i<a&&(a=i),_>c&&(c=_),t<d&&(d=t),t>m&&(m=t);let v=e[r+2],y=e[r+3],b=v-y,x=v+y;b<o&&(o=b),x>l&&(l=x),v<f&&(f=v),v>h&&(h=v);let S=e[r+4],C=e[r+5],w=S-C,T=S+C;w<s&&(s=w),T>u&&(u=T),S<p&&(p=S),S>g&&(g=S)}r[0]=a,r[1]=o,r[2]=s,r[3]=c,r[4]=l,r[5]=u,i[0]=d,i[1]=f,i[2]=p,i[3]=m,i[4]=h,i[5]=g}let Mi=(e,t)=>e.candidate-t.candidate,Ni=/* @__PURE__ */ Array(32).fill().map(()=>({count:0,bounds:/* @__PURE__ */ new Float32Array(6),rightCacheBounds:/* @__PURE__ */ new Float32Array(6),leftCacheBounds:/* @__PURE__ */ new Float32Array(6),candidate:0})),Pi=/* @__PURE__ */ new Float32Array(6);function Fi(e,t,n,r,i,a){let o=-1,s=0;if(a===0)o=Ti(t),o!==-1&&(s=(t[o]+t[o+3])/2);else if(a===1)o=Ti(e),o!==-1&&(s=Ii(n,r,i,o));else if(a===2){let a=ki(e),c=bi*i,l=n.offset||0,u=(r-l)*6,d=(r+i-l)*6;for(let e=0;e<3;e++){let r=t[e],l=(t[e+3]-r)/32;if(i<8){let t=[...Ni];t.length=i;let r=0;for(let i=u;i<d;i+=6,r++){let a=t[r];a.candidate=n[i+2*e],a.count=0;let{bounds:o,leftCacheBounds:s,rightCacheBounds:c}=a;for(let e=0;e<3;e++)c[e]=1/0,c[e+3]=-1/0,s[e]=1/0,s[e+3]=-1/0,o[e]=1/0,o[e+3]=-1/0;Oi(i,n,o)}t.sort(Mi);let l=i;for(let e=0;e<l;e++){let n=t[e];for(;e+1<l&&t[e+1].candidate===n.candidate;)t.splice(e+1,1),l--}for(let r=u;r<d;r+=6){let i=n[r+2*e];for(let e=0;e<l;e++){let a=t[e];i>=a.candidate?Oi(r,n,a.rightCacheBounds):(Oi(r,n,a.leftCacheBounds),a.count++)}}for(let n=0;n<l;n++){let r=t[n],l=r.count,u=i-r.count,d=r.leftCacheBounds,f=r.rightCacheBounds,p=0;l!==0&&(p=ki(d)/a);let m=0;u!==0&&(m=ki(f)/a);let h=1+bi*(p*l+m*u);h<c&&(o=e,c=h,s=r.candidate)}}else{for(let e=0;e<32;e++){let t=Ni[e];t.count=0,t.candidate=r+l+e*l;let n=t.bounds;for(let e=0;e<3;e++)n[e]=1/0,n[e+3]=-1/0}for(let t=u;t<d;t+=6){let i=~~((n[t+2*e]-r)/l);i>=32&&(i=31);let a=Ni[i];a.count++,Oi(t,n,a.bounds)}let t=Ni[31];Ei(t.bounds,t.rightCacheBounds);for(let e=30;e>=0;e--){let t=Ni[e],n=Ni[e+1];Di(t.bounds,n.rightCacheBounds,t.rightCacheBounds)}let f=0;for(let t=0;t<31;t++){let n=Ni[t],r=n.count,l=n.bounds,u=Ni[t+1].rightCacheBounds;r!==0&&(f===0?Ei(l,Pi):Di(l,Pi,Pi)),f+=r;let d=0,p=0;f!==0&&(d=ki(Pi)/a);let m=i-f;m!==0&&(p=ki(u)/a);let h=1+bi*(d*f+p*m);h<c&&(o=e,c=h,s=n.candidate)}}}}else console.warn(`BVH: Invalid build strategy value ${a} used.`);return{axis:o,pos:s}}function Ii(e,t,n,r){let i=0,a=e.offset;for(let o=t,s=t+n;o<s;o++)i+=e[(o-a)*6+r*2];return i/n}var Li=class{constructor(){this.boundingData=/* @__PURE__ */ new Float32Array(6)}};function Ri(e,t,n,r,i,a){let o=r,s=r+i-1,c=a.pos,l=a.axis*2,u=n.offset||0;for(;;){for(;o<=s&&n[(o-u)*6+l]<c;)o++;for(;o<=s&&n[(s-u)*6+l]>=c;)s--;if(o<s){for(let n=0;n<t;n++){let r=e[o*t+n];e[o*t+n]=e[s*t+n],e[s*t+n]=r}for(let e=0;e<6;e++){let t=o-u,r=s-u,i=n[t*6+e];n[t*6+e]=n[r*6+e],n[r*6+e]=i}o++,s--}else return o}}let zi,Bi,Vi,Hi,Ui=2**32;function Wi(e){return`count`in e?1:1+Wi(e.left)+Wi(e.right)}function Gi(e,t,n){return zi=new Float32Array(n),Bi=new Uint32Array(n),Vi=new Uint16Array(n),Hi=new Uint8Array(n),Ki(e,t)}function Ki(e,t){let n=e/4,r=e/2,i=`count`in t,a=t.boundingData;for(let e=0;e<6;e++)zi[n+e]=a[e];if(i)return t.buffer?(Hi.set(new Uint8Array(t.buffer),e),e+t.buffer.byteLength):(Bi[n+6]=t.offset,Vi[r+14]=t.count,Vi[r+15]=xi,e+32);{let{left:r,right:i,splitAxis:a}=t,o=Ki(e+32,r),s=e/32,c=o/32-s;if(c>Ui)throw Error(`MeshBVH: Cannot store relative child node offset greater than 32 bits.`);return Bi[n+6]=c,Bi[n+7]=a,Ki(o,i)}}function qi(e,t,n,r,i,a){let{maxDepth:o,verbose:s,targetLeafSize:c,_strictLeafSize:l=1/0,strategy:u,onProgress:d}=i,f=e.primitiveBuffer,p=e.primitiveBufferStride,m=/* @__PURE__ */ new Float32Array(6),h=!1,g=new Li;return ji(t,n,r,g.boundingData,m),v(g,n,r,m),g;function _(e){d&&d((e-a.offset)/a.count)}function v(e,n,r,i=null,a=0){!h&&a>=o&&(h=!0,s&&console.warn(`BVH: Max depth of ${o} reached when generating BVH. Consider increasing maxDepth.`));let d=r>l;if(r<=c&&!d||a>=o)return _(n+r),e.offset=n,e.count=r,e;let g=Fi(e.boundingData,i,t,n,r,u),y=g.axis===-1?-1:Ri(f,p,t,n,r,g);if(g.axis===-1||y===n||y===n+r){if(!d)return _(n+r),e.offset=n,e.count=r,e;g.axis=Math.max(0,Ti(e.boundingData)),y=n+Math.max(1,Math.floor(r/2))}e.splitAxis=g.axis;let b=new Li,x=n,S=y-n;e.left=b,ji(t,x,S,b.boundingData,m),v(b,x,S,m,a+1);let C=new Li,w=y,T=r-S;return e.right=C,ji(t,w,T,C.boundingData,m),v(C,w,T,m,a+1),e}}function Ji(e,t){let n=t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer,r=e.getRootRanges(t.range),i=r[0],a=r[r.length-1],o={offset:i.offset,count:a.offset+a.count-i.offset},s=new Float32Array(6*o.count);s.offset=o.offset,e.computePrimitiveBounds(o.offset,o.count,s),e._roots=r.map(r=>{let i=qi(e,s,r.offset,r.count,t,o),a=Wi(i),c=new n(32*a);return Gi(0,i,c),c})}var Yi=class{constructor(e){this._getNewPrimitive=e,this._primitives=[]}getPrimitive(){let e=this._primitives;return e.length===0?this._getNewPrimitive():e.pop()}releasePrimitive(e){this._primitives.push(e)}};let Z=/* @__PURE__ */ new class{constructor(){this.float32Array=null,this.uint16Array=null,this.uint32Array=null;let e=[],t=null;this.setBuffer=n=>{t&&e.push(t),t=n,this.float32Array=new Float32Array(n),this.uint16Array=new Uint16Array(n),this.uint32Array=new Uint32Array(n)},this.clearBuffer=()=>{t=null,this.float32Array=null,this.uint16Array=null,this.uint32Array=null,e.length!==0&&this.setBuffer(e.pop())}}},Xi,Zi,Qi=[],$i=/* @__PURE__ */ new Yi(()=>new B);function ea(e,t,n,r,i,a){Xi=$i.getPrimitive(),Zi=$i.getPrimitive(),Qi.push(Xi,Zi),Z.setBuffer(e._roots[t]);let o=ta(0,e.geometry,n,r,i,a);Z.clearBuffer(),$i.releasePrimitive(Xi),$i.releasePrimitive(Zi),Qi.pop(),Qi.pop();let s=Qi.length;return s>0&&(Zi=Qi[s-1],Xi=Qi[s-2]),o}function ta(e,t,n,r,i=null,a=0,o=0){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c)){let t=K(e,l),n=q(u,c);return W(X(e),s,Xi),r(t,n,!1,o,a+e/8,Xi)}{let u=J(e),p=Y(e,l),m=u,h=p,g,_,v,y;if(i&&(v=Xi,y=Zi,W(X(m),s,v),W(X(h),s,y),g=i(v),_=i(y),_<g)){m=p,h=u;let e=g;g=_,_=e,v=y}v||(v=Xi,W(X(m),s,v));let b=G(m*2,c),x=n(v,b,g,o+1,a+m/8),S;if(x===2){let e=d(m);S=r(e,f(m)-e,!0,o+1,a+m/8,v)}else S=x&&ta(m,t,n,r,i,a,o+1);if(S)return!0;y=Zi,W(X(h),s,y);let C=G(h*2,c),w=n(y,C,_,o+1,a+h/8),T;if(w===2){let e=d(h);T=r(e,f(h)-e,!0,o+1,a+h/8,y)}else T=w&&ta(h,t,n,r,i,a,o+1);return!!T;function d(e){let{uint16Array:t,uint32Array:n}=Z,r=e*2;for(;!G(r,t);)e=J(e),r=e*2;return K(e,n)}function f(e){let{uint16Array:t,uint32Array:n}=Z,r=e*2;for(;!G(r,t);)e=Y(e,n),r=e*2;return K(e,n)+q(r,t)}}}let na=/* @__PURE__ */ new Z.constructor,ra=/* @__PURE__ */ new Z.constructor,ia=/* @__PURE__ */ new Yi(()=>new B),aa=/* @__PURE__ */ new B,oa=/* @__PURE__ */ new B,sa=/* @__PURE__ */ new B,ca=/* @__PURE__ */ new B,la=!1;function ua(e,t,n,r){if(la)throw Error(`MeshBVH: Recursive calls to bvhcast not supported.`);la=!0;let i=e._roots,a=t._roots,o,s=0,c=0,l=new R().copy(n).invert();for(let e=0,t=i.length;e<t;e++){na.setBuffer(i[e]),c=0;let t=ia.getPrimitive();W(X(0),na.float32Array,t),t.applyMatrix4(l);for(let e=0,i=a.length;e<i&&(ra.setBuffer(a[e]),o=da(0,0,n,l,r,s,c,0,0,t),ra.clearBuffer(),c+=a[e].byteLength/32,!o);e++);if(ia.releasePrimitive(t),na.clearBuffer(),s+=i[e].byteLength/32,o)break}return la=!1,o}function da(e,t,n,r,i,a=0,o=0,s=0,c=0,l=null,u=!1){let d,f;u?(d=ra,f=na):(d=na,f=ra);let p=d.float32Array,m=d.uint32Array,h=d.uint16Array,g=f.float32Array,_=f.uint32Array,v=f.uint16Array,y=e*2,b=t*2,x=G(y,h),S=G(b,v),C=!1;if(S&&x)C=u?i(K(t,_),q(t*2,v),K(e,m),q(e*2,h),c,o+t/8,s,a+e/8):i(K(e,m),q(e*2,h),K(t,_),q(t*2,v),s,a+e/8,c,o+t/8);else if(S){let l=ia.getPrimitive();W(X(t),g,l),l.applyMatrix4(n);let d=J(e),f=Y(e,m);W(X(d),p,aa),W(X(f),p,oa);let h=l.intersectsBox(aa),_=l.intersectsBox(oa);C=h&&da(t,d,r,n,i,o,a,c,s+1,l,!u)||_&&da(t,f,r,n,i,o,a,c,s+1,l,!u),ia.releasePrimitive(l)}else{let d=J(t),f=Y(t,_);W(X(d),g,sa),W(X(f),g,ca);let h=l.intersectsBox(sa),v=l.intersectsBox(ca);if(h&&v)C=da(e,d,n,r,i,a,o,s,c+1,l,u)||da(e,f,n,r,i,a,o,s,c+1,l,u);else if(h){if(x)C=da(e,d,n,r,i,a,o,s,c+1,l,u);else{let t=ia.getPrimitive();t.copy(sa).applyMatrix4(n);let l=J(e),f=Y(e,m);W(X(l),p,aa),W(X(f),p,oa);let h=t.intersectsBox(aa),g=t.intersectsBox(oa);C=h&&da(d,l,r,n,i,o,a,c,s+1,t,!u)||g&&da(d,f,r,n,i,o,a,c,s+1,t,!u),ia.releasePrimitive(t)}}else if(v){if(x)C=da(e,f,n,r,i,a,o,s,c+1,l,u);else{let t=ia.getPrimitive();t.copy(ca).applyMatrix4(n);let l=J(e),d=Y(e,m);W(X(l),p,aa),W(X(d),p,oa);let h=t.intersectsBox(aa),g=t.intersectsBox(oa);C=h&&da(f,l,r,n,i,o,a,c,s+1,t,!u)||g&&da(f,d,r,n,i,o,a,c,s+1,t,!u),ia.releasePrimitive(t)}}}return C}let fa=new class{constructor(){let e=null,t=null,n=null,r=!1;this.root=null,this.buffer=null,this.uint32Array=null,this.uint16Array=null,this.setBVH=(i,a)=>{if(r)throw Error(`BVHTraversalHelper: cannot call setBVH during an active traversal.`);this.root=a,this.buffer=e=i._roots[a],this.uint16Array=n=new Uint16Array(e),this.uint32Array=t=new Uint32Array(e)},this.reset=()=>{this.root=null,this.buffer=e=null,this.uint16Array=n=null,this.uint32Array=t=null},this.getRangeStart=e=>{let r=e*2;for(;!G(r,n);)e=J(e),r=e*2;return K(e,t)},this.getRangeEnd=e=>{let r=e*2;for(;!G(r,n);)e=Y(e,t),r=e*2;return K(e,t)+q(r,n)};let i=(e,r,a)=>{let o=G(r*2,n);if(!e(a,o,r)&&!o){let n=J(r),o=Y(r,t);i(e,n,a+1),i(e,o,a+1)}};this.traverseBuffer=e=>{if(r)throw Error(`BVHTraversalHelper: cannot start a traversal during an active traversal.`);r=!0;try{i(e,0,0)}finally{r=!1}},this.traverse=r=>{this.traverseBuffer((i,a,o)=>{if(a){let s=o*2,c=t[o+6],l=n[s+14];return r(i,a,new Float32Array(e,o*4,6),c,l)}{let n=Ai(o,t);return r(i,a,new Float32Array(e,o*4,6),n)}})}}},pa=/* @__PURE__ */ new B,ma=/* @__PURE__ */ new Float32Array(6);var ha=class{constructor(){this._roots=null,this.primitiveBuffer=null,this.primitiveBufferStride=null}init(e){e={...wi,...e},`maxLeafSize`in e&&(console.warn(`BVH: \"maxLeafSize\" option has been deprecated. Use \"targetLeafSize\", instead.`),e={...e,targetLeafSize:e.maxLeafSize}),Ji(this,e)}getRootRanges(){throw Error(`BVH: getRootRanges() not implemented`)}writePrimitiveBounds(){throw Error(`BVH: writePrimitiveBounds() not implemented`)}writePrimitiveRangeBounds(e,t,n,r){let i=1/0,a=1/0,o=1/0,s=-1/0,c=-1/0,l=-1/0;for(let n=e,r=e+t;n<r;n++){this.writePrimitiveBounds(n,ma,0);let[e,t,r,u,d,f]=ma;e<i&&(i=e),u>s&&(s=u),t<a&&(a=t),d>c&&(c=d),r<o&&(o=r),f>l&&(l=f)}return n[r+0]=i,n[r+1]=a,n[r+2]=o,n[r+3]=s,n[r+4]=c,n[r+5]=l,n}computePrimitiveBounds(e,t,n){let r=n.offset||0;for(let i=e,a=e+t;i<a;i++){this.writePrimitiveBounds(i,ma,0);let[e,t,a,o,s,c]=ma,l=(e+o)/2,u=(t+s)/2,d=(a+c)/2,f=(o-e)/2,p=(s-t)/2,m=(c-a)/2,h=(i-r)*6;n[h+0]=l,n[h+1]=f+(Math.abs(l)+f)*Si,n[h+2]=u,n[h+3]=p+(Math.abs(u)+p)*Si,n[h+4]=d,n[h+5]=m+(Math.abs(d)+m)*Si}return n}shiftPrimitiveOffsets(e){let t=this._indirectBuffer;if(t)for(let n=0,r=t.length;n<r;n++)t[n]+=e;else{let t=this._roots;for(let n=0;n<t.length;n++){let r=t[n],i=new Uint32Array(r),a=new Uint16Array(r),o=r.byteLength/32;for(let t=0;t<o;t++){let n=8*t;G(2*n,a)&&(i[n+6]+=e)}}}}traverse(e,t=0){fa.setBVH(this,t),fa.traverse(e),fa.reset()}refit(){let e=this._roots;for(let t=0,n=e.length;t<n;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n),a=new Float32Array(n),o=n.byteLength/32;for(let e=o-1;e>=0;e--){let t=e*8,n=t*2;if(G(n,i)){let e=K(t,r),o=q(n,i);this.writePrimitiveRangeBounds(e,o,ma,0),a.set(ma,t)}else{let e=J(t),n=Y(t,r);for(let r=0;r<3;r++){let i=a[e+r],o=a[e+r+3],s=a[n+r],c=a[n+r+3];a[t+r]=i<s?i:s,a[t+r+3]=o>c?o:c}}}}}getBoundingBox(e){return e.makeEmpty(),this._roots.forEach(t=>{W(0,new Float32Array(t),pa),e.union(pa)}),e}shapecast(e){let{boundsTraverseOrder:t,intersectsBounds:n,intersectsRange:r,intersectsPrimitive:i,scratchPrimitive:a,iterate:o}=e;if(r&&i){let e=r;r=(t,n,r,s,c)=>e(t,n,r,s,c)?!0:o(t,n,this,i,r,s,a)}else r||=i?(e,t,n,r)=>o(e,t,this,i,n,r,a):(e,t,n)=>n;let s=!1,c=0,l=this._roots;for(let e=0,i=l.length;e<i;e++){let i=l[e];if(s=ea(this,e,n,r,t,c),s)break;c+=i.byteLength/32}return s}bvhcast(e,t,n){let{intersectsRanges:r}=n;return ua(this,e,t,r)}};function ga(){return typeof SharedArrayBuffer<`u`}function _a(e){return e.index?e.index.count:e.attributes.position.count}function va(e){return _a(e)/3}function ya(e,t=ArrayBuffer){return e>65535?new Uint32Array(new t(4*e)):new Uint16Array(new t(2*e))}function ba(e,t){if(!e.index){let n=e.attributes.position.count,r=ya(n,t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer);e.setIndex(new hr(r,1));for(let e=0;e<n;e++)r[e]=e}}function xa(e,t,n){let r=_a(e)/n,i=t||e.drawRange,a=i.start/n,o=(i.start+i.count)/n,s=Math.max(0,a),c=Math.min(r,o)-s;return{offset:Math.floor(s),count:Math.floor(c)}}function Sa(e,t){return e.groups.map(e=>({offset:e.start/t,count:e.count/t}))}function Ca(e,t,n){let r=xa(e,t,n),i=Sa(e,n);if(!i.length)return[r];let a=[],o=r.offset,s=r.offset+r.count,c=_a(e)/n,l=[];for(let e of i){let{offset:t,count:n}=e,r=t,i=t+(isFinite(n)?n:c-t);r<s&&i>o&&(l.push({pos:Math.max(o,r),isStart:!0}),l.push({pos:Math.min(s,i),isStart:!1}))}l.sort((e,t)=>e.pos===t.pos?e.type===`end`?-1:1:e.pos-t.pos);let u=0,d=null;for(let e of l){let t=e.pos;u!==0&&t!==d&&a.push({offset:d,count:t-d}),u+=e.isStart?1:-1,d=t}return a}function wa(e,t){let n=e[e.length-1],r=n.offset+n.count>2**16,i=e.reduce((e,t)=>e+t.count,0),a=r?4:2,o=t?new SharedArrayBuffer(i*a):new ArrayBuffer(i*a),s=r?new Uint32Array(o):new Uint16Array(o),c=0;for(let t=0;t<e.length;t++){let{offset:n,count:r}=e[t];for(let e=0;e<r;e++)s[c+e]=n+e;c+=r}return s}var Ta=class extends ha{get indirect(){return!!this._indirectBuffer}get primitiveStride(){return null}get primitiveBufferStride(){return this.indirect?1:this.primitiveStride}set primitiveBufferStride(e){}get primitiveBuffer(){return this.indirect?this._indirectBuffer:this.geometry.index.array}set primitiveBuffer(e){}constructor(e,t={}){if(!e.isBufferGeometry)throw Error(`BVH: Only BufferGeometries are supported.`);if(e.index&&e.index.isInterleavedBufferAttribute)throw Error(`BVH: InterleavedBufferAttribute is not supported for the index attribute.`);if(t.useSharedArrayBuffer&&!ga())throw Error(`BVH: SharedArrayBuffer is not available.`);super(),this.geometry=e,this.resolvePrimitiveIndex=t.indirect?e=>this._indirectBuffer[e]:e=>e,this.primitiveBuffer=null,this.primitiveBufferStride=null,this._indirectBuffer=null,t={...wi,...t},t[Ci]||this.init(t)}init(e){let{geometry:t,primitiveStride:n}=this;if(e.indirect){let r=wa(Ca(t,e.range,n),e.useSharedArrayBuffer);this._indirectBuffer=r}else ba(t,e);super.init(e),!t.boundingBox&&e.setBoundingBox&&(t.boundingBox=this.getBoundingBox(new B))}getRootRanges(e){return this.indirect?[{offset:0,count:this._indirectBuffer.length}]:Ca(this.geometry,e,this.primitiveStride)}raycastObject3D(){throw Error(`BVH: raycastObject3D() not implemented`)}},Ea=class{constructor(){this.min=1/0,this.max=-1/0}setFromPointsField(e,t){let n=1/0,r=-1/0;for(let i=0,a=e.length;i<a;i++){let a=e[i][t];n=a<n?a:n,r=a>r?a:r}this.min=n,this.max=r}setFromPoints(e,t){let n=1/0,r=-1/0;for(let i=0,a=t.length;i<a;i++){let a=t[i],o=e.dot(a);n=o<n?o:n,r=o>r?o:r}this.min=n,this.max=r}isSeparated(e){return this.min>e.max||e.min>this.max}};Ea.prototype.setFromBox=(function(){let e=/* @__PURE__ */ new L;return function(t,n){let r=n.min,i=n.max,a=1/0,o=-1/0;for(let n=0;n<=1;n++)for(let s=0;s<=1;s++)for(let c=0;c<=1;c++){e.x=r.x*n+i.x*(1-n),e.y=r.y*s+i.y*(1-s),e.z=r.z*c+i.z*(1-c);let l=t.dot(e);a=Math.min(l,a),o=Math.max(l,o)}this.min=a,this.max=o}})();let Da=(function(){let e=/* @__PURE__ */ new L,t=/* @__PURE__ */ new L,n=/* @__PURE__ */ new L;return function(r,i,a){let o=r.start,s=e,c=i.start,l=t;n.subVectors(o,c),e.subVectors(r.end,r.start),t.subVectors(i.end,i.start);let u=n.dot(l),d=l.dot(s),f=l.dot(l),p=n.dot(s),m=s.dot(s)*f-d*d,h,g;h=m===0?0:(u*d-p*f)/m,g=(u+h*d)/f,a.x=h,a.y=g}})(),Oa=(function(){let e=/* @__PURE__ */ new I,t=/* @__PURE__ */ new L,n=/* @__PURE__ */ new L;return function(r,i,a,o){Da(r,i,e);let s=e.x,c=e.y;if(s>=0&&s<=1&&c>=0&&c<=1){r.at(s,a),i.at(c,o);return}if(s>=0&&s<=1){c<0?i.at(0,o):i.at(1,o),r.closestPointToPoint(o,!0,a);return}if(c>=0&&c<=1){s<0?r.at(0,a):r.at(1,a),i.closestPointToPoint(a,!0,o);return}{let e;e=s<0?r.start:r.end;let l;l=c<0?i.start:i.end;let u=t,d=n;if(r.closestPointToPoint(l,!0,t),i.closestPointToPoint(e,!0,n),u.distanceToSquared(l)<=d.distanceToSquared(e)){a.copy(u),o.copy(l);return}a.copy(e),o.copy(d);return}}})(),ka=(function(){let e=/* @__PURE__ */ new L,t=/* @__PURE__ */ new L,n=/* @__PURE__ */ new Nr,r=/* @__PURE__ */ new hi;return function(i,a){let{radius:o,center:s}=i,{a:c,b:l,c:u}=a;if(r.start=c,r.end=l,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o||(r.start=c,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o)||(r.start=l,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o))return!0;let d=a.getPlane(n);if(Math.abs(d.distanceToPoint(s))<=o){let e=d.projectPoint(s,t);if(a.containsPoint(e))return!0}return!1}})(),Aa=[`x`,`y`,`z`],ja=1e-15,Ma=ja*ja;function Na(e){return Math.abs(e)<ja}var Pa=class extends Qn{constructor(...e){super(...e),this.isExtendedTriangle=!0,this.satAxes=[,,,,].fill().map(()=>new L),this.satBounds=[,,,,].fill().map(()=>new Ea),this.points=[this.a,this.b,this.c],this.plane=new Nr,this.isDegenerateIntoSegment=!1,this.isDegenerateIntoPoint=!1,this.degenerateSegment=new hi,this.needsUpdate=!0}intersectsSphere(e){return ka(e,this)}update(){let e=this.a,t=this.b,n=this.c,r=this.points,i=this.satAxes,a=this.satBounds,o=i[0],s=a[0];this.getNormal(o),s.setFromPoints(o,r);let c=i[1],l=a[1];c.subVectors(e,t),l.setFromPoints(c,r);let u=i[2],d=a[2];u.subVectors(t,n),d.setFromPoints(u,r);let f=i[3],p=a[3];f.subVectors(n,e),p.setFromPoints(f,r);let m=c.length(),h=u.length(),g=f.length();this.isDegenerateIntoPoint=!1,this.isDegenerateIntoSegment=!1,m<ja?h<ja||g<ja?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(e),this.degenerateSegment.end.copy(n)):h<ja?g<ja?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(t),this.degenerateSegment.end.copy(e)):g<ja&&(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(n),this.degenerateSegment.end.copy(t)),this.plane.setFromNormalAndCoplanarPoint(o,e),this.needsUpdate=!1}};Pa.prototype.closestPointToSegment=(function(){let e=/* @__PURE__ */ new L,t=/* @__PURE__ */ new L,n=/* @__PURE__ */ new hi;return function(r,i=null,a=null){let{start:o,end:s}=r,c=this.points,l,u=1/0;for(let o=0;o<3;o++){let s=(o+1)%3;n.start.copy(c[o]),n.end.copy(c[s]),Oa(n,r,e,t),l=e.distanceToSquared(t),l<u&&(u=l,i&&i.copy(e),a&&a.copy(t))}return this.closestPointToPoint(o,e),l=o.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(o)),this.closestPointToPoint(s,e),l=s.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(s)),Math.sqrt(u)}})(),Pa.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new Pa,t=/* @__PURE__ */ new Ea,n=/* @__PURE__ */ new Ea,r=/* @__PURE__ */ new L,i=/* @__PURE__ */ new L,a=/* @__PURE__ */ new L,o=/* @__PURE__ */ new L,s=/* @__PURE__ */ new hi,c=/* @__PURE__ */ new hi,l=/* @__PURE__ */ new L,u=/* @__PURE__ */ new I,d=/* @__PURE__ */ new I;function f(e,i,a,s){let c=r;!e.isDegenerateIntoPoint&&!e.isDegenerateIntoSegment?c.copy(e.plane.normal):c.copy(i.plane.normal);let l=e.satBounds,u=e.satAxes;for(let r=1;r<4;r++){let a=l[r],s=u[r];if(t.setFromPoints(s,i.points),a.isSeparated(t)||(o.copy(c).cross(s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}let d=i.satBounds,f=i.satAxes;for(let r=1;r<4;r++){let a=d[r],s=f[r];if(t.setFromPoints(s,e.points),a.isSeparated(t)||(o.crossVectors(c,s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}return a&&(s||console.warn(`ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.`),a.start.set(0,0,0),a.end.set(0,0,0)),!0}function p(e,t,n,r,i,a,o,s,c,l,u){let d=o/(o-s);l.x=r+(i-r)*d,u.start.subVectors(t,e).multiplyScalar(d).add(e),d=o/(o-c),l.y=r+(a-r)*d,u.end.subVectors(n,e).multiplyScalar(d).add(e)}function m(e,t,n,r,i,a,o,s,c,l,u){if(i>0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else if(a>0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(s*c>0||o!=0)p(e.a,e.b,e.c,t,n,r,o,s,c,l,u);else if(s!=0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(c!=0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else return!0;return!1}function h(e,t,n,i){let a=t.degenerateSegment,o=e.plane.distanceToPoint(a.start),s=e.plane.distanceToPoint(a.end);return Na(o)?Na(s)?f(e,t,n,i):(n&&(n.start.copy(a.start),n.end.copy(a.start)),e.containsPoint(a.start)):Na(s)?(n&&(n.start.copy(a.end),n.end.copy(a.end)),e.containsPoint(a.end)):e.plane.intersectLine(a,r)!=null&&(n&&(n.start.copy(r),n.end.copy(r)),e.containsPoint(r))}function g(e,t,n){let r=t.a;return Na(e.plane.distanceToPoint(r))&&e.containsPoint(r)?(n&&(n.start.copy(r),n.end.copy(r)),!0):!1}function _(e,t,n){let i=e.degenerateSegment,a=t.a;return i.closestPointToPoint(a,!0,r),a.distanceToSquared(r)<Ma&&(n&&(n.start.copy(a),n.end.copy(a)),!0)}function v(e,t,n,o){if(e.isDegenerateIntoSegment){if(t.isDegenerateIntoSegment){let o=e.degenerateSegment,s=t.degenerateSegment,c=i,l=a;o.delta(c),s.delta(l);let u=r.subVectors(s.start,o.start),d=c.x*l.y-c.y*l.x;if(Na(d))return!1;let f=(u.x*l.y-u.y*l.x)/d,p=-(c.x*u.y-c.y*u.x)/d;return f<0||f>1||p<0||p>1?!1:Na(o.start.z+c.z*f-(s.start.z+l.z*p))?(n&&(n.start.copy(o.start).addScaledVector(c,f),n.end.copy(o.start).addScaledVector(c,f)),!0):!1}return t.isDegenerateIntoPoint?_(e,t,n):h(t,e,n,o)}if(e.isDegenerateIntoPoint)return t.isDegenerateIntoPoint?t.a.distanceToSquared(e.a)<Ma&&(n&&(n.start.copy(e.a),n.end.copy(e.a)),!0):t.isDegenerateIntoSegment?_(t,e,n):g(t,e,n);if(t.isDegenerateIntoPoint)return g(e,t,n);if(t.isDegenerateIntoSegment)return h(e,t,n,o)}return function(t,n=null,r=!1){this.needsUpdate&&this.update(),t.isExtendedTriangle?t.needsUpdate&&t.update():(e.copy(t),e.update(),t=e);let o=v(this,t,n,r);if(o!==void 0)return o;let p=this.plane,h=t.plane,g=h.distanceToPoint(this.a),_=h.distanceToPoint(this.b),y=h.distanceToPoint(this.c);Na(g)&&(g=0),Na(_)&&(_=0),Na(y)&&(y=0);let b=g*_,x=g*y;if(b>0&&x>0)return!1;let S=p.distanceToPoint(t.a),C=p.distanceToPoint(t.b),w=p.distanceToPoint(t.c);Na(S)&&(S=0),Na(C)&&(C=0),Na(w)&&(w=0);let T=S*C,E=S*w;if(T>0&&E>0)return!1;i.copy(p.normal),a.copy(h.normal);let D=i.cross(a),O=0,k=Math.abs(D.x),A=Math.abs(D.y);A>k&&(k=A,O=1),Math.abs(D.z)>k&&(O=2);let j=Aa[O],ee=this.a[j],te=this.b[j],ne=this.c[j],re=t.a[j],ie=t.b[j],ae=t.c[j];if(m(this,ee,te,ne,b,x,g,_,y,u,s)||m(t,re,ie,ae,T,E,S,C,w,d,c))return f(this,t,n,r);if(u.y<u.x){let e=u.y;u.y=u.x,u.x=e,l.copy(s.start),s.start.copy(s.end),s.end.copy(l)}if(d.y<d.x){let e=d.y;d.y=d.x,d.x=e,l.copy(c.start),c.start.copy(c.end),c.end.copy(l)}return u.y<d.x||d.y<u.x?!1:(n&&(d.x>u.x?n.start.copy(c.start):n.start.copy(s.start),d.y<u.y?n.end.copy(c.end):n.end.copy(s.end)),!0)}})(),Pa.prototype.distanceToPoint=(function(){let e=/* @__PURE__ */ new L;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),Pa.prototype.distanceToTriangle=(function(){let e=/* @__PURE__ */ new L,t=/* @__PURE__ */ new L,n=[`a`,`b`,`c`],r=/* @__PURE__ */ new hi,i=/* @__PURE__ */ new hi;return function(a,o=null,s=null){let c=o||s?r:null;if(this.intersectsTriangle(a,c,!0))return(o||s)&&(o&&c.getCenter(o),s&&c.getCenter(s)),0;let l=1/0;for(let t=0;t<3;t++){let r,i=n[t],c=a[i];this.closestPointToPoint(c,e),r=c.distanceToSquared(e),r<l&&(l=r,o&&o.copy(e),s&&s.copy(c));let u=this[i];a.closestPointToPoint(u,e),r=u.distanceToSquared(e),r<l&&(l=r,o&&o.copy(u),s&&s.copy(e))}for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];r.set(this[u],this[d]);for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];i.set(a[u],a[d]),Oa(r,i,e,t);let f=e.distanceToSquared(t);f<l&&(l=f,o&&o.copy(e),s&&s.copy(t))}}return Math.sqrt(l)}})();var Q=class{constructor(e,t,n){this.isOrientedBox=!0,this.min=new L,this.max=new L,this.matrix=new R,this.invMatrix=new R,this.points=Array(8).fill().map(()=>new L),this.satAxes=[,,,].fill().map(()=>new L),this.satBounds=[,,,].fill().map(()=>new Ea),this.alignedSatBounds=[,,,].fill().map(()=>new Ea),this.needsUpdate=!1,e&&this.min.copy(e),t&&this.max.copy(t),n&&this.matrix.copy(n)}set(e,t,n){this.min.copy(e),this.max.copy(t),this.matrix.copy(n),this.needsUpdate=!0}copy(e){this.min.copy(e.min),this.max.copy(e.max),this.matrix.copy(e.matrix),this.needsUpdate=!0}};Q.prototype.update=(function(){return function(){let e=this.matrix,t=this.min,n=this.max,r=this.points;for(let i=0;i<=1;i++)for(let a=0;a<=1;a++)for(let o=0;o<=1;o++){let s=r[1*i|2*a|4*o];s.x=i?n.x:t.x,s.y=a?n.y:t.y,s.z=o?n.z:t.z,s.applyMatrix4(e)}let i=this.satBounds,a=this.satAxes,o=r[0];for(let e=0;e<3;e++){let t=a[e],n=i[e],s=r[1<<e];t.subVectors(o,s),n.setFromPoints(t,r)}let s=this.alignedSatBounds;s[0].setFromPointsField(r,`x`),s[1].setFromPointsField(r,`y`),s[2].setFromPointsField(r,`z`),this.invMatrix.copy(this.matrix).invert(),this.needsUpdate=!1}})(),Q.prototype.intersectsBox=(function(){let e=/* @__PURE__ */ new Ea;return function(t){this.needsUpdate&&this.update();let n=t.min,r=t.max,i=this.satBounds,a=this.satAxes,o=this.alignedSatBounds;if(e.min=n.x,e.max=r.x,o[0].isSeparated(e)||(e.min=n.y,e.max=r.y,o[1].isSeparated(e))||(e.min=n.z,e.max=r.z,o[2].isSeparated(e)))return!1;for(let n=0;n<3;n++){let r=a[n],o=i[n];if(e.setFromBox(r,t),o.isSeparated(e))return!1}return!0}})(),Q.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new Pa,t=[,,,],n=/* @__PURE__ */ new Ea,r=/* @__PURE__ */ new Ea,i=/* @__PURE__ */ new L;return function(a){this.needsUpdate&&this.update(),a.isExtendedTriangle?a.needsUpdate&&a.update():(e.copy(a),e.update(),a=e);let o=this.satBounds,s=this.satAxes;t[0]=a.a,t[1]=a.b,t[2]=a.c;for(let e=0;e<3;e++){let r=o[e],i=s[e];if(n.setFromPoints(i,t),r.isSeparated(n))return!1}let c=a.satBounds,l=a.satAxes,u=this.points;for(let e=0;e<3;e++){let t=c[e],r=l[e];if(n.setFromPoints(r,u),t.isSeparated(n))return!1}for(let e=0;e<3;e++){let a=s[e];for(let e=0;e<4;e++){let o=l[e];if(i.crossVectors(a,o),n.setFromPoints(i,t),r.setFromPoints(i,u),n.isSeparated(r))return!1}}return!0}})(),Q.prototype.closestPointToPoint=(function(){return function(e,t){return this.needsUpdate&&this.update(),t.copy(e).applyMatrix4(this.invMatrix).clamp(this.min,this.max).applyMatrix4(this.matrix),t}})(),Q.prototype.distanceToPoint=(function(){let e=new L;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),Q.prototype.distanceToBox=(function(){let e=[`x`,`y`,`z`],t=/* @__PURE__ */ Array(12).fill().map(()=>new hi),n=/* @__PURE__ */ Array(12).fill().map(()=>new hi),r=/* @__PURE__ */ new L,i=/* @__PURE__ */ new L;return function(a,o=0,s=null,c=null){if(this.needsUpdate&&this.update(),this.intersectsBox(a))return(s||c)&&(a.getCenter(i),this.closestPointToPoint(i,r),a.closestPointToPoint(r,i),s&&s.copy(r),c&&c.copy(i)),0;let l=o*o,u=a.min,d=a.max,f=this.points,p=1/0;for(let e=0;e<8;e++){let t=f[e];i.copy(t).clamp(u,d);let n=t.distanceToSquared(i);if(n<p&&(p=n,s&&s.copy(t),c&&c.copy(i),n<l))return Math.sqrt(n)}let m=0;for(let r=0;r<3;r++)for(let i=0;i<=1;i++)for(let a=0;a<=1;a++){let o=(r+1)%3,s=(r+2)%3,c=i<<o|a<<s,l=1<<r|i<<o|a<<s,p=f[c],h=f[l];t[m].set(p,h);let g=e[r],_=e[o],v=e[s],y=n[m],b=y.start,x=y.end;b[g]=u[g],b[_]=i?u[_]:d[_],b[v]=a?u[v]:d[_],x[g]=d[g],x[_]=i?u[_]:d[_],x[v]=a?u[v]:d[_],m++}for(let e=0;e<=1;e++)for(let t=0;t<=1;t++)for(let n=0;n<=1;n++){i.x=e?d.x:u.x,i.y=t?d.y:u.y,i.z=n?d.z:u.z,this.closestPointToPoint(i,r);let a=i.distanceToSquared(r);if(a<p&&(p=a,s&&s.copy(r),c&&c.copy(i),a<l))return Math.sqrt(a)}for(let e=0;e<12;e++){let a=t[e];for(let e=0;e<12;e++){let t=n[e];Oa(a,t,r,i);let o=r.distanceToSquared(i);if(o<p&&(p=o,s&&s.copy(r),c&&c.copy(i),o<l))return Math.sqrt(o)}}return Math.sqrt(p)}})();let Fa=/* @__PURE__ */ new class extends Yi{constructor(){super(()=>new Pa)}},Ia=/* @__PURE__ */ new L,La=/* @__PURE__ */ new L;function Ra(e,t,n={},r=0,i=1/0){let a=r*r,o=i*i,s=1/0,c=null;if(e.shapecast({boundsTraverseOrder:e=>(Ia.copy(t).clamp(e.min,e.max),Ia.distanceToSquared(t)),intersectsBounds:(e,t,n)=>n<s&&n<o,intersectsTriangle:(e,n)=>{e.closestPointToPoint(t,Ia);let r=t.distanceToSquared(Ia);return r<s&&(La.copy(Ia),s=r,c=n),r<a}}),s===1/0)return null;let l=Math.sqrt(s);return n.point?n.point.copy(La):n.point=La.clone(),n.distance=l,n.faceIndex=c,n}let za=/* @__PURE__ */ new L,Ba=/* @__PURE__ */ new L,Va=/* @__PURE__ */ new L,Ha=/* @__PURE__ */ new I,Ua=/* @__PURE__ */ new I,Wa=/* @__PURE__ */ new I,Ga=/* @__PURE__ */ new L,Ka=/* @__PURE__ */ new L,qa=/* @__PURE__ */ new L,Ja=/* @__PURE__ */ new L;function Ya(e,t,n,r,i,a,o,s){let c;if(c=a===1?e.intersectTriangle(r,n,t,!0,i):e.intersectTriangle(t,n,r,a!==2,i),c===null)return null;let l=e.origin.distanceTo(i);return l<o||l>s?null:{distance:l,point:i.clone()}}function Xa(e,t,n,r,i,a,o,s,c,l,u){za.fromBufferAttribute(t,a),Ba.fromBufferAttribute(t,o),Va.fromBufferAttribute(t,s);let d=Ya(e,za,Ba,Va,Ja,c,l,u);if(d){r&&(Ha.fromBufferAttribute(r,a),Ua.fromBufferAttribute(r,o),Wa.fromBufferAttribute(r,s),d.uv=new I,Qn.getInterpolation(Ja,za,Ba,Va,Ha,Ua,Wa,d.uv)),i&&(Ha.fromBufferAttribute(i,a),Ua.fromBufferAttribute(i,o),Wa.fromBufferAttribute(i,s),d.uv1=new I,Qn.getInterpolation(Ja,za,Ba,Va,Ha,Ua,Wa,d.uv1)),n&&(Ga.fromBufferAttribute(n,a),Ka.fromBufferAttribute(n,o),qa.fromBufferAttribute(n,s),d.normal=new L,Qn.getInterpolation(Ja,za,Ba,Va,Ga,Ka,qa,d.normal),d.normal.dot(e.direction)>0&&d.normal.multiplyScalar(-1));let t={a,b:o,c:s,normal:new L,materialIndex:0};Qn.getNormal(za,Ba,Va,t.normal),d.face=t,d.faceIndex=a;{let e=new L;Qn.getBarycoord(Ja,za,Ba,Va,e),d.barycoord=e}}return d}function Za(e){return e&&e.isMaterial?e.side:e}function Qa(e,t,n,r,i,a,o){let s=r*3,c=s+0,l=s+1,u=s+2,{index:d,groups:f}=e;e.index&&(c=d.getX(c),l=d.getX(l),u=d.getX(u));let{position:p,normal:m,uv:h,uv1:g}=e.attributes;if(Array.isArray(t)){let e=r*3;for(let s=0,d=f.length;s<d;s++){let{start:d,count:_,materialIndex:v}=f[s];if(e>=d&&e<d+_){let e=Za(t[v]),s=Xa(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=v,i)i.push(s);else return s}}}}else{let e=Za(t),s=Xa(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=0,i)i.push(s);else return s}}return null}function $(e,t,n,r){let i=e.a,a=e.b,o=e.c,s=t,c=t+1,l=t+2;n&&(s=n.getX(s),c=n.getX(c),l=n.getX(l)),i.x=r.getX(s),i.y=r.getY(s),i.z=r.getZ(s),a.x=r.getX(c),a.y=r.getY(c),a.z=r.getZ(c),o.x=r.getX(l),o.y=r.getY(l),o.z=r.getZ(l)}function $a(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,l=r+i;e<l;e++)Qa(c,t,n,e,a,o,s)}function eo(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,c=r+i;e<c;e++){let r;r=Qa(s,t,n,e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function to(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let n=e,s=t+e;n<s;n++){let e;if(e=n,$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function no(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(e,n,a=!1){let l=e*2;if(G(l,s)){let t=K(e,o),n=q(l,s),a=1/0,u=1/0,d=1/0,f=-1/0,p=-1/0,m=-1/0;for(let e=3*t,o=3*(t+n);e<o;e++){let t=r[e],n=i.getX(t),o=i.getY(t),s=i.getZ(t);n<a&&(a=n),n>f&&(f=n),o<u&&(u=o),o>p&&(p=o),s<d&&(d=s),s>m&&(m=s)}return c[e+0]!==a||c[e+1]!==u||c[e+2]!==d||c[e+3]!==f||c[e+4]!==p||c[e+5]!==m?(c[e+0]=a,c[e+1]=u,c[e+2]=d,c[e+3]=f,c[e+4]=p,c[e+5]=m,!0):!1}{let r=J(e),i=Y(e,o),s=a,l=!1,u=!1;if(t){if(!s){let e=r/8+n/32,a=i/8+n/32;l=t.has(e),u=t.has(a),s=!l&&!u}}else l=!0,u=!0;let f=s||l,p=s||u,m=!1;f&&(m=d(r,n,s));let h=!1;p&&(h=d(i,n,s));let g=m||h;if(g)for(let t=0;t<3;t++){let n=r+t,a=i+t,o=c[n],s=c[n+3],l=c[a],u=c[a+3];c[e+t]=o<l?o:l,c[e+t+3]=s>u?s:u}return g}}}function ro(e,t,n,r,i){let a,o,s,c,l,u,d=1/n.direction.x,f=1/n.direction.y,p=1/n.direction.z,m=n.origin.x,h=n.origin.y,g=n.origin.z,_=t[e],v=t[e+3],y=t[e+1],b=t[e+3+1],x=t[e+2],S=t[e+3+2];return d>=0?(a=(_-m)*d,o=(v-m)*d):(a=(v-m)*d,o=(_-m)*d),f>=0?(s=(y-h)*f,c=(b-h)*f):(s=(b-h)*f,c=(y-h)*f),a>c||s>o||((s>a||isNaN(a))&&(a=s),(c<o||isNaN(o))&&(o=c),p>=0?(l=(x-g)*p,u=(S-g)*p):(l=(S-g)*p,u=(x-g)*p),a>u||l>o)?!1:((l>a||a!==a)&&(a=l),(u<o||o!==o)&&(o=u),a<=i&&o>=r)}function io(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,u=r+i;e<u;e++)Qa(c,t,n,l?l[e]:e,a,o,s)}function ao(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,d=r+i;e<d;e++){let r;r=Qa(s,t,n,c?c[e]:e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function oo(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let s=e,u=t+e;s<u;s++){let e;if(e=n.resolveTriangleIndex(s),$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function so(e,t,n,r,i,a,o){Z.setBuffer(e._roots[t]),co(0,e,n,r,i,a,o),Z.clearBuffer()}function co(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c))$a(t,n,r,K(e,l),q(u,c),i,a,o);else{let c=J(e);ro(c,s,r,a,o)&&co(c,t,n,r,i,a,o);let u=Y(e,l);ro(u,s,r,a,o)&&co(u,t,n,r,i,a,o)}}let lo=[`x`,`y`,`z`];function uo(e,t,n,r,i,a){Z.setBuffer(e._roots[t]);let o=fo(0,e,n,r,i,a);return Z.clearBuffer(),o}function fo(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Z,l=e*2;if(G(l,s))return eo(t,n,r,K(e,c),q(l,s),i,a);{let s=Ai(e,c),l=lo[s],u=r.direction[l]>=0,d,f;u?(d=J(e),f=Y(e,c)):(d=Y(e,c),f=J(e));let p=ro(d,o,r,i,a)?fo(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=ro(f,o,r,i,a)?fo(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let po=/* @__PURE__ */ new B,mo=/* @__PURE__ */ new Pa,ho=/* @__PURE__ */ new Pa,go=/* @__PURE__ */ new R,_o=/* @__PURE__ */ new Q,vo=/* @__PURE__ */ new Q;function yo(e,t,n,r){Z.setBuffer(e._roots[t]);let i=bo(0,e,n,r);return Z.clearBuffer(),i}function bo(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Z,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),_o.set(n.boundingBox.min,n.boundingBox.max,r),i=_o),G(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=K(e,s),m=q(c,o);if(go.copy(r).invert(),n.boundsTree)return W(X(e),a,vo),vo.matrix.copy(go),vo.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>vo.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let t=p*3,n=(m+p)*3;t<n;t+=3)if($(ho,t,l,u),ho.needsUpdate=!0,e.intersectsTriangle(ho))return!0;return!1}});{let e=va(n);for(let t=p*3,n=(m+p)*3;t<n;t+=3){$(mo,t,l,u),mo.a.applyMatrix4(go),mo.b.applyMatrix4(go),mo.c.applyMatrix4(go),mo.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(ho,t,d,f),ho.needsUpdate=!0,mo.intersectsTriangle(ho))return!0}}}else{let o=J(e),c=Y(e,s);return W(X(o),a,po),!!(i.intersectsBox(po)&&bo(o,t,n,r,i)||(W(X(c),a,po),i.intersectsBox(po)&&bo(c,t,n,r,i)))}}let xo=/* @__PURE__ */ new R,So=/* @__PURE__ */ new Q,Co=/* @__PURE__ */ new Q,wo=/* @__PURE__ */ new L,To=/* @__PURE__ */ new L,Eo=/* @__PURE__ */ new L,Do=/* @__PURE__ */ new L;function Oo(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),So.set(t.boundingBox.min,t.boundingBox.max,n),So.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=Fa.getPrimitive(),p=Fa.getPrimitive(),m=wo,h=To,g=null,_=null;i&&(g=Eo,_=Do);let v=1/0,y=null,b=null;return xo.copy(n).invert(),Co.matrix.copy(xo),e.shapecast({boundsTraverseOrder:e=>So.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&(Co.min.copy(e.min),Co.max.copy(e.max),Co.needsUpdate=!0),!0),intersectsRange:(e,r)=>{if(t.boundsTree)return t.boundsTree.shapecast({boundsTraverseOrder:e=>Co.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,i)=>{for(let o=t,s=t+i;o<s;o++){$(p,3*o,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=e,n=e+r;t<n;t++){$(f,3*t,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=t,b=o),e<a)return!0}}}});{let i=va(t);for(let t=0,o=i;t<o;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=e,i=e+r;n<i;n++){$(f,3*n,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=n,b=t),e<a)return!0}}}}}),Fa.releasePrimitive(f),Fa.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(xo),h.applyMatrix4(xo),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function ko(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(n,a,l=!1){let u=n*2;if(G(u,s)){let t=K(n,o),a=q(u,s),l=1/0,d=1/0,f=1/0,p=-1/0,m=-1/0,h=-1/0;for(let n=t,o=t+a;n<o;n++){let t=3*e.resolveTriangleIndex(n);for(let e=0;e<3;e++){let n=t+e;n=r?r[n]:n;let a=i.getX(n),o=i.getY(n),s=i.getZ(n);a<l&&(l=a),a>p&&(p=a),o<d&&(d=o),o>m&&(m=o),s<f&&(f=s),s>h&&(h=s)}}return c[n+0]!==l||c[n+1]!==d||c[n+2]!==f||c[n+3]!==p||c[n+4]!==m||c[n+5]!==h?(c[n+0]=l,c[n+1]=d,c[n+2]=f,c[n+3]=p,c[n+4]=m,c[n+5]=h,!0):!1}{let e=J(n),r=Y(n,o),i=l,s=!1,u=!1;if(t){if(!i){let n=e/8+a/32,o=r/8+a/32;s=t.has(n),u=t.has(o),i=!s&&!u}}else s=!0,u=!0;let f=i||s,p=i||u,m=!1;f&&(m=d(e,a,i));let h=!1;p&&(h=d(r,a,i));let g=m||h;if(g)for(let t=0;t<3;t++){let i=e+t,a=r+t,o=c[i],s=c[i+3],l=c[a],u=c[a+3];c[n+t]=o<l?o:l,c[n+t+3]=s>u?s:u}return g}}}function Ao(e,t,n,r,i,a,o){Z.setBuffer(e._roots[t]),jo(0,e,n,r,i,a,o),Z.clearBuffer()}function jo(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c))io(t,n,r,K(e,l),q(u,c),i,a,o);else{let c=J(e);ro(c,s,r,a,o)&&jo(c,t,n,r,i,a,o);let u=Y(e,l);ro(u,s,r,a,o)&&jo(u,t,n,r,i,a,o)}}let Mo=[`x`,`y`,`z`];function No(e,t,n,r,i,a){Z.setBuffer(e._roots[t]);let o=Po(0,e,n,r,i,a);return Z.clearBuffer(),o}function Po(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Z,l=e*2;if(G(l,s))return ao(t,n,r,K(e,c),q(l,s),i,a);{let s=Ai(e,c),l=Mo[s],u=r.direction[l]>=0,d,f;u?(d=J(e),f=Y(e,c)):(d=Y(e,c),f=J(e));let p=ro(d,o,r,i,a)?Po(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=ro(f,o,r,i,a)?Po(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let Fo=/* @__PURE__ */ new B,Io=/* @__PURE__ */ new Pa,Lo=/* @__PURE__ */ new Pa,Ro=/* @__PURE__ */ new R,zo=/* @__PURE__ */ new Q,Bo=/* @__PURE__ */ new Q;function Vo(e,t,n,r){Z.setBuffer(e._roots[t]);let i=Ho(0,e,n,r);return Z.clearBuffer(),i}function Ho(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Z,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),zo.set(n.boundingBox.min,n.boundingBox.max,r),i=zo),G(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=K(e,s),m=q(c,o);if(Ro.copy(r).invert(),n.boundsTree)return W(X(e),a,Bo),Bo.matrix.copy(Ro),Bo.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>Bo.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let n=p,r=m+p;n<r;n++)if($(Lo,3*t.resolveTriangleIndex(n),l,u),Lo.needsUpdate=!0,e.intersectsTriangle(Lo))return!0;return!1}});{let e=va(n);for(let n=p,r=m+p;n<r;n++){let r=t.resolveTriangleIndex(n);$(Io,3*r,l,u),Io.a.applyMatrix4(Ro),Io.b.applyMatrix4(Ro),Io.c.applyMatrix4(Ro),Io.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(Lo,t,d,f),Lo.needsUpdate=!0,Io.intersectsTriangle(Lo))return!0}}}else{let o=J(e),c=Y(e,s);return W(X(o),a,Fo),!!(i.intersectsBox(Fo)&&Ho(o,t,n,r,i)||(W(X(c),a,Fo),i.intersectsBox(Fo)&&Ho(c,t,n,r,i)))}}let Uo=/* @__PURE__ */ new R,Wo=/* @__PURE__ */ new Q,Go=/* @__PURE__ */ new Q,Ko=/* @__PURE__ */ new L,qo=/* @__PURE__ */ new L,Jo=/* @__PURE__ */ new L,Yo=/* @__PURE__ */ new L;function Xo(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),Wo.set(t.boundingBox.min,t.boundingBox.max,n),Wo.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=Fa.getPrimitive(),p=Fa.getPrimitive(),m=Ko,h=qo,g=null,_=null;i&&(g=Jo,_=Yo);let v=1/0,y=null,b=null;return Uo.copy(n).invert(),Go.matrix.copy(Uo),e.shapecast({boundsTraverseOrder:e=>Wo.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&(Go.min.copy(e.min),Go.max.copy(e.max),Go.needsUpdate=!0),!0),intersectsRange:(r,i)=>{if(t.boundsTree){let s=t.boundsTree;return s.shapecast({boundsTraverseOrder:e=>Go.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,o)=>{for(let x=t,S=t+o;x<S;x++){let t=s.resolveTriangleIndex(x);$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=r,n=r+i;t<n;t++){let n=e.resolveTriangleIndex(t);$(f,3*n,l,c),f.needsUpdate=!0;let r=f.distanceToTriangle(p,m,g);if(r<v&&(h.copy(m),_&&_.copy(g),v=r,y=t,b=x),r<a)return!0}}}})}{let o=va(t);for(let t=0,s=o;t<s;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=r,o=r+i;n<o;n++){let r=e.resolveTriangleIndex(n);$(f,3*r,l,c),f.needsUpdate=!0;let i=f.distanceToTriangle(p,m,g);if(i<v&&(h.copy(m),_&&_.copy(g),v=i,y=n,b=t),i<a)return!0}}}}}),Fa.releasePrimitive(f),Fa.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(Uo),h.applyMatrix4(Uo),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function Zo(e,t,n){return e===null?null:(e.point.applyMatrix4(t.matrixWorld),e.distance=e.point.distanceTo(n.ray.origin),e.object=t,e)}let Qo=/* @__PURE__ */ new Q,$o=/* @__PURE__ */ new Rr,es=/* @__PURE__ */ new L,ts=/* @__PURE__ */ new R,ns=/* @__PURE__ */ new L,rs=[`getX`,`getY`,`getZ`];var is=class e extends Ta{static serialize(e,t={}){t={cloneBuffers:!0,...t};let n=e.geometry,r=e._roots,i=e._indirectBuffer,a=n.getIndex(),o={version:1,roots:null,index:null,indirectBuffer:null};return t.cloneBuffers?(o.roots=r.map(e=>e.slice()),o.index=a?a.array.slice():null,o.indirectBuffer=i?i.slice():null):(o.roots=r,o.index=a?a.array:null,o.indirectBuffer=i),o}static deserialize(t,n,r={}){r={setIndex:!0,indirect:!!t.indirectBuffer,...r};let{index:i,roots:a,indirectBuffer:o}=t;t.version||(console.warn(`MeshBVH.deserialize: Serialization format has been changed and will be fixed up. It is recommended to regenerate any stored serialized data.`),c(a));let s=new e(n,{...r,[Ci]:!0});if(s._roots=a,s._indirectBuffer=o||null,r.setIndex){let e=n.getIndex();if(e===null){let e=new hr(t.index,1,!1);n.setIndex(e)}else e.array!==i&&(e.array.set(i),e.needsUpdate=!0)}return s;function c(e){for(let t=0;t<e.length;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n);for(let e=0,t=n.byteLength/32;e<t;e++){let t=8*e;G(2*t,i)||(r[t+6]=r[t+6]/8-e)}}}}get primitiveStride(){return 3}get resolveTriangleIndex(){return this.resolvePrimitiveIndex}constructor(e,t={}){t.maxLeafTris&&(console.warn(`MeshBVH: \"maxLeafTris\" option has been deprecated. Use \"targetLeafSize\", instead.`),t={...t,targetLeafSize:t.maxLeafTris}),super(e,t)}shiftTriangleOffsets(e){return super.shiftPrimitiveOffsets(e)}writePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=(i?i[e]:e)*3,c=s+0,l=s+1,u=s+2;o&&(c=o[c],l=o[l],u=o[u]);for(let e=0;e<3;e++){let r=a[rs[e]](c),i=a[rs[e]](l),o=a[rs[e]](u),s=r;i<s&&(s=i),o<s&&(s=o);let d=r;i>d&&(d=i),o>d&&(d=o),t[n+e]=s,t[n+e+3]=d}return t}computePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=a.normalized;if(e<0||t+e-n.offset>n.length/6)throw Error(`MeshBVH: compute triangle bounds range is invalid.`);let c=a.array,l=a.offset||0,u=3;a.isInterleavedBufferAttribute&&(u=a.data.stride);let d=[`getX`,`getY`,`getZ`],f=n.offset;for(let r=e,p=e+t;r<p;r++){let e=(i?i[r]:r)*3,t=(r-f)*6,p=e+0,m=e+1,h=e+2;o&&(p=o[p],m=o[m],h=o[h]),s||(p=p*u+l,m=m*u+l,h=h*u+l);for(let e=0;e<3;e++){let r,i,o;s?(r=a[d[e]](p),i=a[d[e]](m),o=a[d[e]](h)):(r=c[p+e],i=c[m+e],o=c[h+e]);let l=r;i<l&&(l=i),o<l&&(l=o);let u=r;i>u&&(u=i),o>u&&(u=o);let f=(u-l)/2,g=e*2;n[t+g+0]=l+f,n[t+g+1]=f+(Math.abs(l)+f)*Si}}return n}raycastObject3D(e,t,n=[]){let{material:r}=e;if(r===void 0)return;ts.copy(e.matrixWorld).invert(),$o.copy(t.ray).applyMatrix4(ts),ns.setFromMatrixScale(e.matrixWorld),es.copy($o.direction).multiply(ns);let i=es.length(),a=t.near/i,o=t.far/i;if(t.firstHitOnly===!0){let i=this.raycastFirst($o,r,a,o);i=Zo(i,e,t),i&&n.push(i)}else{let i=this.raycast($o,r,a,o);for(let r=0,a=i.length;r<a;r++){let a=Zo(i[r],e,t);a&&n.push(a)}}return n}refit(e=null){return(this.indirect?ko:no)(this,e)}raycast(e,t=0,n=0,r=1/0){let i=this._roots,a=[],o=this.indirect?Ao:so;for(let s=0,c=i.length;s<c;s++)o(this,s,t,e,a,n,r);return a}raycastFirst(e,t=0,n=0,r=1/0){let i=this._roots,a=null,o=this.indirect?No:uo;for(let s=0,c=i.length;s<c;s++){let i=o(this,s,t,e,n,r);i!=null&&(a==null||i.distance<a.distance)&&(a=i)}return a}intersectsGeometry(e,t){let n=!1,r=this._roots,i=this.indirect?Vo:yo;for(let a=0,o=r.length;a<o&&(n=i(this,a,e,t),!n);a++);return n}shapecast(e){let t=Fa.getPrimitive(),n=super.shapecast({...e,intersectsPrimitive:e.intersectsTriangle,scratchPrimitive:t,iterate:this.indirect?oo:to});return Fa.releasePrimitive(t),n}bvhcast(t,n,r){let{intersectsRanges:i,intersectsTriangles:a}=r,o=Fa.getPrimitive(),s=this.geometry.index,c=this.geometry.attributes.position,l=this.indirect?e=>{let t=this.resolveTriangleIndex(e);$(o,t*3,s,c)}:e=>{$(o,e*3,s,c)},u=Fa.getPrimitive(),d=t.geometry.index,f=t.geometry.attributes.position,p=t.indirect?e=>{let n=t.resolveTriangleIndex(e);$(u,n*3,d,f)}:e=>{$(u,e*3,d,f)};if(a){if(!(t instanceof e))throw Error(`MeshBVH: \"intersectsTriangles\" callback can only be used with another MeshBVH.`);let r=(e,t,r,i,s,c,d,f)=>{for(let m=r,h=r+i;m<h;m++){p(m),u.a.applyMatrix4(n),u.b.applyMatrix4(n),u.c.applyMatrix4(n),u.needsUpdate=!0;for(let n=e,r=e+t;n<r;n++)if(l(n),o.needsUpdate=!0,a(o,u,n,m,s,c,d,f))return!0}return!1};if(i){let e=i;i=function(t,n,i,a,o,s,c,l){return e(t,n,i,a,o,s,c,l)?!0:r(t,n,i,a,o,s,c,l)}}else i=r}return super.bvhcast(t,n,{intersectsRanges:i})}intersectsBox(e,t){return Qo.set(e.min,e.max,t),Qo.needsUpdate=!0,this.shapecast({intersectsBounds:e=>Qo.intersectsBox(e),intersectsTriangle:e=>Qo.intersectsTriangle(e)})}intersectsSphere(e){return this.shapecast({intersectsBounds:t=>e.intersectsBox(t),intersectsTriangle:t=>t.intersectsSphere(e)})}closestPointToGeometry(e,t,n={},r={},i=0,a=1/0){return(this.indirect?Xo:Oo)(this,e,t,n,r,i,a)}closestPointToPoint(e,t={},n=0,r=1/0){return Ra(this,e,t,n,r)}};function as(e){let t=new kr;return t.setAttribute(`position`,new hr(e.positions,3)),e.index&&t.setIndex(new hr(e.index,1)),{bvh:is.deserialize(e.bvh,t,{setIndex:!1})}}function os(e){return e.geometries.map(as)}function ss(e,t,n){let r=new R().fromArray(t,e.matrixOffset);return{...e,supportId:n,inverseMatrix:r,localToWorldMatrix:r.clone().invert()}}function cs(e){let t=/* @__PURE__ */ new Map;for(let n=0;n<e.instances.length;n++){let r=e.instances[n],i=ss(r,e.inverseInstanceMatrices,n),a=t.get(i.objectUuid)??[];a.push(i),t.set(i.objectUuid,a)}return e.boxTree.identifiers.map(e=>e===null?void 0:t.get(e))}let ls=/* @__PURE__ */ new B,us=/* @__PURE__ */ new L,ds=/* @__PURE__ */ new L,fs=/* @__PURE__ */ new L,ps=/* @__PURE__ */ new L,ms=/* @__PURE__ */ new Rr,hs=/* @__PURE__ */ new Rr,gs=i;function _s(e,t,n,r){let i=Math.max(Math.abs(t)/r,Math.abs(n)/r);return e/2/i}function vs(e,t,n){let i=a(e,t),c=o(e,t),l=s(e,t),u=a(e,n)-i,d=o(e,n)-c,f=s(e,n)-l,p=Math.hypot(u,f);if(p<=1e-6)return null;let m=_s(e.sizes[t],u,f,p),h=p-_s(e.sizes[n],u,f,p);if(m>=h-1e-6)return null;let g=(m+r*2)/p,_=(h-r*2)/p;us.set(i+u*g,c+d*g+gs,l+f*g),ds.set(i+u*_,c+d*_+gs,l+f*_),fs.subVectors(ds,us);let v=fs.length();return fs.divideScalar(v),ms.set(us,fs),v}function ys(e,t){ls.makeEmpty(),ls.expandByPoint(us),ls.expandByPoint(ds),yi(e.boxTree,ls,2**53-1,e.candidateLeaves);for(let n of e.candidateLeaves){let r=e.instancesByLeaf[n];if(r)for(let n of r){if(n.occupancyBlocking===!1)continue;let r=e.geometries[n.geometryIndex];if(!r)continue;hs.copy(ms).applyMatrix4(n.inverseMatrix);let i=r.bvh.raycastFirst(hs,2);if(i&&(ps.copy(i.point).applyMatrix4(n.localToWorldMatrix),ps.distanceTo(us)<=t+1e-6))return!0}}return!1}function bs(e){let t=os(e),n=cs(e),r={geometries:t,instancesByLeaf:n,boxTree:vi(e,n),candidateLeaves:[]};return(e,t,n)=>{let i=vs(e,t,n);return i===null||!ys(r,i)}}function xs(t,r,i){if(!t.classification)throw Error(`Flood fill must be completed before generating a navigation mesh.`);let a=Ye(t),o=new n,s=new n,c=new e(a.count),l=Be(t,a,r,o,s,c);({cells:a,horizontalEdges:o,verticalEdges:s,landingConnections:l}=b(a,o,s,l)),{cells:a,verticalEdges:s}=E(a,s,l);let u=a.count,d=(o.length+s.length)/2,f=i?bs(i):void 0;if({cells:a,horizontalEdges:o,verticalEdges:s}=it(a,o,s,r,f),{cells:a,horizontalEdges:o,verticalEdges:s}=pt(a,o,s,r.simplificationTolerance),a.count>r.maximumNodeCount)throw Error(`Navigation mesh generated ${a.count} nodes, above the configured limit of ${r.maximumNodeCount}. Increase the maximum merge distance instead of the node limit to reduce the graph before rendering.`);let p=(o.length+s.length)/2;if(p>r.maximumEdgeCount)throw Error(`Navigation mesh generated ${p} edges, above the configured limit of ${r.maximumEdgeCount}.`);c=new e(a.count);for(let e of[o,s])for(let t=0;t<e.length;t+=2)c.merge(e.get(t),e.get(t+1));let m=new Int32Array(a.count),h=/* @__PURE__ */ new Map;for(let e=0;e<a.count;e++){let t=c.find(e),n=h.get(t);n===void 0&&(n=h.size,h.set(t,n)),m[e]=n}return{originalNodeCount:u,originalEdgeCount:d,positions:a.positions,sizes:a.sizes,componentIds:m,horizontalEdges:o.toUint32Array(),verticalEdges:s.toUint32Array()}}self.onmessage=e=>{try{let t=xs(e.data.grid,e.data.options,e.data.sceneSnapshot),n={type:`NavigationMeshGenerated`,result:t};self.postMessage(n,{transfer:[t.positions.buffer,t.sizes.buffer,t.componentIds.buffer,t.horizontalEdges.buffer,t.verticalEdges.buffer]})}catch(e){let t={type:`NavigationMeshError`,error:typeof e==`object`&&e&&`message`in e?String(e.message):String(e)};self.postMessage(t)}}})();\n//# sourceMappingURL=NavigationMeshWorker-eTGOZLsk.js.map", Qi = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Zi], { type: "text/javascript;charset=utf-8" });
function $i(e) {
	let t;
	try {
		if (t = Qi && (self.URL || self.webkitURL).createObjectURL(Qi), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(Zi), { name: e?.name });
	}
}
//#endregion
//#region src/PathPlugin/navmesh/worker/NavigationMeshWorkerController.ts
var ea = class {
	constructor() {
		this.controller = new Ce($i, "PathNavigationMeshWorker", 1), this.resolvePromise = null, this.rejectPromise = null, this.running = !1, this.handleMessage = (e) => {
			if (!this.running) return Promise.resolve();
			if (e.data.type === "NavigationMeshError") {
				let t = this.rejectPromise;
				return this.finish(!1), t?.(Error(e.data.error)), Promise.resolve();
			}
			let t = this.resolvePromise;
			return this.finish(!1), t?.(e.data.result), Promise.resolve();
		}, this.handleError = (e) => {
			if (!this.running) return Promise.resolve();
			let t = this.rejectPromise;
			return this.finish(!0), t?.(Error(e.message.trim() || "Navigation mesh worker stopped unexpectedly.")), Promise.resolve();
		}, this.handleMessageError = () => {
			if (!this.running) return Promise.resolve();
			let e = this.rejectPromise;
			return this.finish(!0), e?.(/* @__PURE__ */ Error("Navigation mesh worker returned an unreadable message.")), Promise.resolve();
		}, this.controller.onmessage = this.handleMessage, this.controller.onerror = this.handleError, this.controller.onmessageerror = this.handleMessageError;
	}
	start(e, t, n) {
		return this.cancel(), this.controller.reset(), this.running = !0, this.controller.lockWorker(0), new Promise((r, i) => {
			this.resolvePromise = r, this.rejectPromise = i, this.controller.postMessageWithId(0, {
				type: "GenerateNavigationMesh",
				grid: e,
				sceneSnapshot: t,
				options: n
			});
		});
	}
	cancel() {
		if (!this.running) return;
		let e = this.rejectPromise;
		this.finish(!0), e?.(/* @__PURE__ */ Error("Navigation mesh generation was cancelled."));
	}
	dispose() {
		this.cancel(), this.controller.terminateWorkers();
	}
	finish(e) {
		e ? this.controller.terminateWorker(0) : this.controller.freeWorker(0), this.running = !1, this.resolvePromise = null, this.rejectPromise = null;
	}
}, ta = /* @__PURE__ */ new A(), na = class {
	constructor(e, t, n, r) {
		this.viewer = e, this.voxelizationController = t, this.floodFillController = n, this.graphController = r, this.signals = { onChanged: new T() }, this.workerController = new ea(), this.currentStatus = "idle", this.currentResult = null, this.currentError = null, this.currentNeedsUpdate = !1, this.sourceClassification = null, this.runId = 0, this.handleFloodFillChanged = () => {
			this.currentResult && (this.currentNeedsUpdate = this.floodFillController.needsUpdate || this.floodFillController.result !== this.sourceClassification, this.signals.onChanged.emit());
		};
	}
	get status() {
		return this.currentStatus;
	}
	get result() {
		return this.currentResult;
	}
	get error() {
		return this.currentError;
	}
	get needsUpdate() {
		return this.currentNeedsUpdate;
	}
	setup() {
		this.floodFillController.signals.onChanged.connect(this.handleFloodFillChanged);
	}
	async start(e) {
		let t = this.voxelizationController.result, n = this.voxelizationController.sceneSnapshot, r = this.floodFillController.result;
		if (!t || !n || !r || this.voxelizationController.needsUpdate || this.floodFillController.needsUpdate) throw Error("Flood fill must be completed before generating a navigation mesh.");
		aa(e);
		let i = ++this.runId;
		this.workerController.cancel(), this.currentStatus = "running", this.currentError = null, this.signals.onChanged.emit();
		try {
			let a = {
				...t.snapshot,
				classification: r
			}, o = await this.workerController.start(a, n, e);
			if (i !== this.runId) throw Error("Navigation mesh generation was cancelled.");
			let s = ra(o);
			return this.applyResult(o, s, r), s;
		} catch (e) {
			throw i === this.runId && (this.currentStatus = "error", this.currentError = typeof e == "object" && e && "message" in e ? String(e.message) : String(e), this.signals.onChanged.emit()), e;
		}
	}
	restore(e, t) {
		let n = e ? this.floodFillController.result : null;
		this.applyResult(e, t, n);
	}
	cancel() {
		this.runId++, this.workerController.cancel(), this.currentStatus = "idle", this.signals.onChanged.emit();
	}
	clear() {
		this.cancel(), this.currentResult = null, this.currentError = null, this.currentNeedsUpdate = !1, this.sourceClassification = null, this.signals.onChanged.emit();
	}
	dispose() {
		this.floodFillController.signals.onChanged.disconnect(this.handleFloodFillChanged), this.workerController.dispose();
	}
	applyResult(e, t, n) {
		t ? this.graphController.setGraph(t, !1, e ? () => ra(e) : void 0) : this.graphController.clear(), this.currentResult = e, this.sourceClassification = n, this.currentNeedsUpdate = !1, this.currentStatus = e ? "completed" : "idle", this.currentError = null, this.signals.onChanged.emit(), this.viewer.requestRender();
	}
};
function ra(e) {
	let t = new Yi(), n = Array(e.componentIds.length);
	for (let r = 0; r < e.componentIds.length; r++) {
		let i = `generated-node-${r}`;
		n[r] = i, t.addNode(ta.fromArray(e.positions, r * 3), {
			id: i,
			source: "generated",
			componentId: e.componentIds[r]
		});
	}
	return ia(t, n, e.horizontalEdges, "horizontal"), ia(t, n, e.verticalEdges, "vertical"), t;
}
function ia(e, t, n, r) {
	for (let i = 0; i < n.length; i += 2) e.addEdge(t[n[i]], t[n[i + 1]], {
		id: `generated-${r}-edge-${i / 2}`,
		kind: r
	});
}
function aa(e) {
	if (!Number.isInteger(e.targetNodeCount) || e.targetNodeCount <= 0) throw Error("Target navigation node count must be a positive integer.");
	if (e.targetNodeCount > e.maximumNodeCount) throw Error("Target navigation node count cannot exceed the maximum node count.");
	if (!Number.isInteger(e.maximumNodeCount) || e.maximumNodeCount <= 0) throw Error("Maximum navigation node count must be a positive integer.");
	if (!Number.isInteger(e.maximumEdgeCount) || e.maximumEdgeCount <= 0) throw Error("Maximum navigation edge count must be a positive integer.");
	if (!Number.isFinite(e.maximumHeightDifference) || e.maximumHeightDifference < 0) throw Error("Maximum height difference must be a finite positive number.");
	if (!Number.isFinite(e.maximumSlopeAngle) || e.maximumSlopeAngle < 0 || e.maximumSlopeAngle >= 90) throw Error("Maximum slope angle must be between 0 and 90 degrees.");
	if (!Number.isFinite(e.simplificationTolerance) || e.simplificationTolerance < 0) throw Error("Simplification tolerance must be a finite positive number.");
	if (!Number.isFinite(e.maximumMergeDistance) || e.maximumMergeDistance < 0) throw Error("Maximum merge distance must be a finite positive number.");
}
//#endregion
//#region src/PathPlugin/commands/navmesh/GenerateNavigationGraphCommand.ts
var oa = class extends u {
	constructor(e, t) {
		super(e), this.options = t, this.name = "GenerateNavigationGraphCommand", this.isUndoable = !0, this.previousGraph = null, this.previousResult = null, this.generatedResult = null, this.initialized = !1;
	}
	async _do() {
		let e = this.viewer.getPlugin("Path");
		if (this.initialized ||= (this.previousGraph = e.navigationGraphController.activeGraph?.clone() ?? null, this.previousResult = e.navigationGraphGenerationController.result, !0), this.generatedResult) {
			let t = ra(this.generatedResult);
			return e.navigationGraphGenerationController.restore(this.generatedResult, t), t;
		}
		let t = await e.navigationGraphGenerationController.start(this.options);
		return this.generatedResult = e.navigationGraphGenerationController.result, t;
	}
	_undo() {
		return this.viewer.getPlugin("Path").navigationGraphGenerationController.restore(this.previousResult, this.previousGraph?.clone() ?? null), Promise.resolve();
	}
}, sa = class extends u {
	constructor(e, t, n, r = !0) {
		super(e), this.pointType = t, this.shouldReconnect = r, this.name = "SetNavigationRoutePointCommand", this.isUndoable = !0, this.isUpdatable = !0, this.position = n.clone();
	}
	async _do() {
		let e = this.viewer.getPlugin("Path").navigationRoutingController, t = this.pointType === "start" ? e.startPoint : e.endPoint, n = this.previousPosition !== void 0;
		this.previousPosition === void 0 && (this.previousPosition = t?.position.clone() ?? null), e.setPoint(this.pointType, this.position, n || this.shouldReconnect);
	}
	async _undo() {
		let e = this.viewer.getPlugin("Path").navigationRoutingController;
		this.previousPosition ? e.setPoint(this.pointType, this.previousPosition) : e.removePoint(this.pointType);
	}
	async update(e) {
		this.position.copy(e), this.viewer.getPlugin("Path").navigationRoutingController.setPoint(this.pointType, this.position, !1), await super.update();
	}
	reconnect() {
		this.viewer.getPlugin("Path").navigationRoutingController.reconnectPoint(this.pointType);
	}
}, ca = class extends ue {
	constructor(e, t, n) {
		super(), this.isGuidePath = !0, this.guidePathLine = null, this.guidePathPoints = [], this.isSelectable = !1, this.isTransformable = !1, this.handler = e, this.controlPoints = t.map((e) => e.clone()), this.pathOptions = { ...n };
	}
	get points() {
		return this.controlPoints;
	}
	get options() {
		return this.pathOptions;
	}
	get line() {
		return this.guidePathLine;
	}
	get renderPoints() {
		return this.guidePathPoints;
	}
	show() {
		this.visible = !0, this.handler.visibilityChanged(this);
	}
	hide() {
		this.visible = !1, this.handler.visibilityChanged(this);
	}
	update(e, t) {
		this.handler.update(this, e, t);
	}
	clear() {
		this.handler.clear(this);
	}
	setData(e, t) {
		this.controlPoints = e.map((e) => e.clone()), this.pathOptions = { ...t };
	}
	setRenderObjects(e, t) {
		this.guidePathLine = e, this.guidePathPoints = t;
		for (let e of t) this.addSubMesh(e);
		this.addSubMesh(e);
	}
	clearRenderObjects() {
		for (let e of this.guidePathPoints) this.removeSubMesh(e);
		this.guidePathLine && this.removeSubMesh(this.guidePathLine), this.guidePathLine = null, this.guidePathPoints = [];
	}
}, la = {
	color: 49151,
	thickness: 6,
	speed: .25,
	opacity: 1,
	segmentLength: .12,
	segmentSpacing: .08,
	smoothing: 16,
	pointRadius: .08,
	heightOffset: .02,
	cornerRadius: .25
};
function K(e = {}) {
	let t = {
		...la,
		...e
	};
	if (!Number.isFinite(t.thickness) || t.thickness <= 0) throw Error("Guide path thickness must be greater than zero.");
	if (!Number.isFinite(t.speed) || t.speed < 0) throw Error("Guide path speed must be a finite positive value.");
	if (!Number.isFinite(t.opacity) || t.opacity < 0 || t.opacity > 1) throw Error("Guide path opacity must be between zero and one.");
	if (!Number.isFinite(t.smoothing) || t.smoothing < 1) throw Error("Guide path smoothing must be at least one.");
	if (!Number.isFinite(t.pointRadius) || t.pointRadius <= 0) throw Error("Guide path point radius must be greater than zero.");
	if (!Number.isFinite(t.heightOffset) || t.heightOffset < 0) throw Error("Guide path height offset cannot be negative.");
	if (!Number.isFinite(t.segmentLength) || t.segmentLength <= 0) throw Error("Guide path segment length must be greater than zero.");
	if (!Number.isFinite(t.segmentSpacing) || t.segmentSpacing < 0) throw Error("Guide path segment spacing cannot be negative.");
	if (!Number.isFinite(t.cornerRadius) || t.cornerRadius < 0 || t.cornerRadius > .5) throw Error("Guide path corner radius must be between zero and 0.5.");
	return t.smoothing = Math.floor(t.smoothing), t;
}
//#endregion
//#region src/PathPlugin/core/GuidePathLine.ts
var ua = class extends ce {
	constructor(e, t) {
		super(), this.box = new je(), this.sphere = new k(), this.options = t, this.geometry = this.createGeometry(e), this.material = this.createMaterial(t), this.line = this.createLine(), this.setupBounds(), this.isSelectable = !1, this.isTransformable = !1;
	}
	createGeometry(e) {
		let t = new wt();
		return t.setPositions(e.flatMap((e) => [
			e.x,
			e.y,
			e.z
		])), t;
	}
	createMaterial(e) {
		return new Tt({
			color: e.color,
			linewidth: e.thickness,
			opacity: e.opacity,
			transparent: e.opacity < 1,
			depthTest: !0,
			depthWrite: !1,
			polygonOffset: !0,
			polygonOffsetFactor: -1,
			polygonOffsetUnits: -1,
			dashed: !0,
			dashSize: e.segmentLength,
			gapSize: e.segmentSpacing,
			alphaToCoverage: !0
		});
	}
	createLine() {
		let e = new Ct(this.geometry, this.material);
		return e.layers.set(x.Base), e.computeLineDistances(), e.frustumCulled = !1, e.renderOrder = 1, e;
	}
	setupBounds() {
		this.geometry.computeBoundingBox(), this.geometry.computeBoundingSphere(), this.box.copy(this.geometry.boundingBox ?? new je()), this.sphere.copy(this.geometry.boundingSphere ?? new k());
	}
	updateResolution(e, t) {
		this.material.resolution.set(e, t);
	}
	animate(e) {
		this.material.dashOffset -= e * this.options.speed;
	}
	set visible(e) {
		super.visible = e, this.line.visible = e;
	}
	get visible() {
		return super.visible;
	}
	set diffuseColor(e) {
		this.material.color.set(e);
	}
	get diffuseColor() {
		return this.material.color;
	}
	set opacity(e) {
		this.material.opacity = e, this.material.transparent = e < 1;
	}
	get opacity() {
		return this.material.opacity;
	}
	set emissiveColor(e) {}
	get emissiveColor() {
		return this.diffuseColor;
	}
	set xRay(e) {}
	get xRay() {
		return !1;
	}
	set roughness(e) {}
	get roughness() {
		return 1;
	}
	set metalness(e) {}
	get metalness() {
		return 0;
	}
	set edgesColor(e) {}
	get edgesColor() {
		return this.diffuseColor;
	}
	set edgesOpacity(e) {}
	get edgesOpacity() {
		return 0;
	}
	setMatrix(e) {
		this.line.matrix.copy(e), this.line.matrix.decompose(this.line.position, this.line.quaternion, this.line.scale);
	}
	getMatrix(e) {
		return e.copy(this.line.matrix);
	}
	getBoundingBox(e) {
		return e.copy(this.box).applyMatrix4(this.line.matrix);
	}
	getBoundingSphere(e) {
		return e.copy(this.sphere).applyMatrix4(this.line.matrix);
	}
	raycast(e, t) {}
	projectPointOnEdges(e, t, n) {
		return !1;
	}
	showNormalsHelper(e, t) {}
	showBoundingBoxHelper(e, t) {}
	dispose() {
		this.line.removeFromParent(), this.geometry.dispose(), this.material.dispose(), this.options = {
			...this.options,
			speed: 0
		};
	}
}, da = class extends de {
	constructor(e) {
		super(e), this.isGuidePathPoint = !0, this.isSelectable = !1, this.isTransformable = !1;
	}
};
//#endregion
//#region src/PathPlugin/core/utils.ts
function fa(e, t) {
	if (e.length === 2 || t.cornerRadius === 0) return e.map((e) => e.clone());
	let n = [], r = e[0].clone();
	for (let i = 1; i < e.length - 1; i++) {
		let a = e[i - 1], o = e[i], s = e[i + 1], c = o.clone().lerp(a, t.cornerRadius), l = o.clone().lerp(s, t.cornerRadius);
		ha(n, new Ge(r, c).getPoints(1)), ha(n, new tt(c, o, l).getPoints(t.smoothing)), r = l;
	}
	return ha(n, new Ge(r, e.at(-1)).getPoints(1)), n;
}
function pa(e) {
	if (!Array.isArray(e) || e.length < 2) throw Error("A guide path requires at least two points.");
	return e.map((e, t) => {
		if (!(e instanceof A) || ![
			e.x,
			e.y,
			e.z
		].every(Number.isFinite)) throw Error(`Guide path point at index ${t} has invalid coordinates.`);
		return e.clone();
	});
}
function ma(e) {
	let t = () => new S(e, {
		active: "float",
		diffuse: "vec3",
		opacity: "float"
	});
	return [{
		material: new h(t(), {
			depthTest: !0,
			depthWrite: !0,
			polygonOffset: !0,
			polygonOffsetFactor: -1,
			polygonOffsetUnits: -1
		}),
		type: C.Opaque,
		layer: x.Base
	}, {
		material: new h(t(), {
			depthTest: !0,
			depthWrite: !1,
			polygonOffset: !0,
			polygonOffsetFactor: -1,
			polygonOffsetUnits: -1,
			transparent: !0
		}),
		type: C.Transparent,
		layer: x.Base
	}];
}
function ha(e, t) {
	for (let n of t) e.at(-1)?.equals(n) || e.push(n);
}
//#endregion
//#region src/PathPlugin/core/PathController.ts
var ga = 1e4, _a = /* @__PURE__ */ new lt(1, 12, 8), va = /* @__PURE__ */ new O(), ya = class extends le {
	constructor(e) {
		super(e), this.isPathController = !0, this.lineGroup = new He(), this.clock = new Fe(!1), this.onViewportAdded = () => {
			this.connectRenderer();
			for (let e of this._objects.values()) e.line && this.updateLineResolution(e.line);
			this.updateAnimationState();
		}, this.onViewportRemoved = () => {
			this.disconnectRenderer(), this.clock.stop();
		}, this.animate = () => {
			let e = this.clock.getDelta(), t = !1;
			for (let n of this._objects.values()) n.visible && n.line && this.visible && (n.line.animate(e), t = !0);
			t && this._viewer.requestRender();
		}, this.attachRenderContainers = () => {
			this._viewer.scene.addInternalObject(this.pointContainer.root), this._viewer.scene.addInternalObject(this.lineGroup);
		}, this.pointContainer = new g(_a, ma(ga), ga), this.lineGroup.name = "GuidePaths";
	}
	createPath(e, t) {
		let n = pa(e), r = K({
			...this.getPluginOptions(),
			...t
		}), i = new ca(this, n, r), a = this.buildRenderObjects(i, n, r);
		return i.setRenderObjects(a.line, a.points), i;
	}
	addObject(e, t = null) {
		if (!e.line) {
			let t = this.buildRenderObjects(e, e.points, e.options);
			e.setRenderObjects(t.line, t.points);
		}
		super.addObject(e, t), this.updateAnimationState();
	}
	removeObject(e) {
		this.disposeRenderObjects(e), super.removeObject(e), this.updateAnimationState();
	}
	update(e, t, n) {
		if (!this.hasObjectUUID(e.uuid)) throw Error("Cannot update a guide path that is not managed by this controller.");
		let r = pa(t), i = K({
			...e.options,
			...n
		});
		this.disposeRenderObjects(e);
		let a = this.buildRenderObjects(e, r, i);
		e.setRenderObjects(a.line, a.points), e.setData(r, i), this._viewer.requestRender();
	}
	clear(e) {
		if (e && this.hasObjectUUID(e.uuid)) {
			this.removeObject(e);
			return;
		}
		for (let e of this._objects.values()) this.removeObject(e);
		this.pointContainer.clear(), super.clear();
	}
	onSceneSetup(e) {
		this.attachRenderContainers(), this._viewer.signals.onSceneClear.connect(this.attachRenderContainers), this._viewer.signals.onViewportAdded.connect(this.onViewportAdded), this._viewer.signals.onViewportRemoved.connect(this.onViewportRemoved), this.connectRenderer();
	}
	onSceneClear(e) {
		this.disconnectRenderer(), this._viewer.signals.onSceneClear.disconnect(this.attachRenderContainers), this._viewer.signals.onViewportAdded.disconnect(this.onViewportAdded), this._viewer.signals.onViewportRemoved.disconnect(this.onViewportRemoved), e.removeInternalObject(this.pointContainer.root), e.removeInternalObject(this.lineGroup);
	}
	accepts(e) {
		return e.isGuidePath === !0;
	}
	*meshContainers() {
		yield this.pointContainer;
	}
	*lineContainers() {}
	*edgesContainers() {}
	_setVisibility(e) {
		super._setVisibility(e), this.lineGroup.visible = e, this.updateAnimationState();
	}
	visibilityChanged(e) {
		this.updateAnimationState(), this._viewer.requestRender();
	}
	buildRenderObjects(e, t, n) {
		let r = fa(t, n);
		for (let e of r) e.y += n.heightOffset;
		let i = new ua(r, n);
		return i.visible = e.visible, this.lineGroup.add(i.line), this.updateLineResolution(i), {
			line: i,
			points: t.map((t) => {
				let r = new _(this.pointContainer, -1, _a.uuid), i = new da(r);
				return this.pointContainer.addInstance(r), va.makeScale(n.pointRadius, n.pointRadius, n.pointRadius), va.setPosition(t.clone().setY(t.y + n.heightOffset)), i.setMatrix(va), i.diffuseColor = n.color, i.opacity = n.opacity, i.visible = e.visible, i;
			})
		};
	}
	disposeRenderObjects(e) {
		for (let t of e.renderPoints) this.pointContainer.removeInstance(t.meshProxy);
		e.line?.dispose(), e.clearRenderObjects();
	}
	connectRenderer() {
		this._viewer.viewport?.renderer.signals.frameHasRendered.connect(this.animate);
	}
	disconnectRenderer() {
		this._viewer.viewport?.renderer.signals.frameHasRendered.disconnect(this.animate);
	}
	updateAnimationState() {
		let e = this.visible && this._objects.values().some((e) => e.visible);
		e && !this.clock.running ? (this.clock.start(), this._viewer.requestRender()) : !e && this.clock.running && this.clock.stop();
	}
	updateLineResolution(e) {
		let t = this._viewer.viewport?.canvas;
		t && e.updateResolution(t.clientWidth, t.clientHeight);
	}
	applyPluginSettings() {
		let e = this.getPluginOptions();
		for (let t of this._objects.values()) this.update(t, t.points, e);
	}
	getPluginOptions() {
		let e = this._viewer.getPlugin("Path").settings;
		return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, t.value]));
	}
}, ba = class extends de {
	constructor(e, t) {
		super(e, null, t), this.pointType = t, this.isNavigationRoutingObject = !0, this.isSelectable = !1, this.isTransformable = !1;
	}
};
function xa(e) {
	return e.isNavigationRoutingObject === !0;
}
//#endregion
//#region src/PathPlugin/utils/ObjectTypeUtils.ts
function Sa(e) {
	let t = e.stereograph;
	if (typeof t != "object" || !t) return null;
	let n = "objectType" in t ? t.objectType : null;
	return typeof n == "string" ? n : null;
}
function Ca(e) {
	let t = e.parent ? Sa(e.parent.userData) : null;
	return Sa(e.userData) ?? t;
}
function wa(e) {
	return new Set(e.map((e) => e.toLocaleLowerCase()));
}
function Ta(e, t) {
	return e !== null && t.has(e.toLocaleLowerCase());
}
//#endregion
//#region src/PathPlugin/navigation/NavigationGraphSceneObject.ts
var Ea = class extends de {
	constructor(e, t, n) {
		super(e, null, n), this.elementType = t, this.elementId = n, this.isNavigationGraphObject = !0, this.isSelectable = !1, this.isTransformable = !1;
	}
};
function Da(e) {
	return e.isNavigationGraphObject === !0;
}
//#endregion
//#region src/PathPlugin/navigation/NavigationGraphValidator.ts
var Oa = /* @__PURE__ */ new rt(), ka = /* @__PURE__ */ new A(), Aa = /* @__PURE__ */ new A(), ja = .03, Ma = .03, Na = .1, Pa = .5, Fa = .5, Ia = 1, La = class {
	constructor(e) {
		this.viewer = e, this.ignoredObjectTypes = /* @__PURE__ */ new Set();
	}
	setIgnoredObjectTypes(e) {
		this.ignoredObjectTypes = wa(e);
	}
	validateEdge(e, t) {
		let n = e.requireNode(t.fromNodeId).position, r = e.requireNode(t.toNodeId).position;
		return this.validateSegment(n, r);
	}
	validateSegment(e, t) {
		ka.subVectors(t, e);
		let n = ka.length();
		if (!Number.isFinite(n) || n <= ja * 2) return !1;
		ka.normalize(), Aa.copy(e).addScaledVector(ka, ja), Aa.y += Ma, Oa.set(Aa, ka), Oa.near = 0, Oa.far = n - ja * 2;
		let r = this.viewer.scene.raycastBoxTree(Oa.ray, .05);
		for (let e of r) {
			let { object: t } = e;
			if (Da(t) || xa(t) || Ta(Ca(t), this.ignoredObjectTypes)) continue;
			let n = [];
			if (t.raycast(Oa, n), n.some((e) => e.distance <= Oa.far)) return !1;
		}
		return !0;
	}
	projectOnSurface(e, t) {
		Aa.copy(e), Aa.y += t, ka.set(0, -1, 0), Oa.set(Aa, ka), Oa.near = 0, Oa.far = t * 2;
		let n = this.raycastScene(), r = null, i = t;
		for (let t of n) {
			let n = t.point.distanceTo(e);
			n <= i && (i = n, r = t.point);
		}
		return r?.clone() ?? null;
	}
	validateNodePosition(e) {
		return this.projectOnSurface(e, Na) !== null;
	}
	traceSurfaceSegment(e, t) {
		let n = Math.hypot(t.x - e.x, t.z - e.z), r = Math.max(1, Math.ceil(n / Pa)), i = Array(r + 1);
		i[0] = e.clone();
		for (let n = 1; n < r; n++) {
			let a = new A().lerpVectors(e, t, n / r), o = this.projectOnSurface(a, Fa);
			if (!o) return null;
			i[n] = o;
		}
		i[r] = t.clone();
		for (let e = 1; e < i.length; e++) if (!this.validateSegment(i[e - 1], i[e])) return null;
		return i;
	}
	validateGraph(e) {
		for (let t of e.nodes.values()) t.positionValid = this.validateNodePosition(t.position);
		for (let t of e.edges.values()) t.geometryValid = this.validateEdge(e, t);
	}
	raycastScene() {
		let e = [], t = this.viewer.scene.raycastBoxTree(Oa.ray, .05);
		for (let n of t) {
			let { object: t } = n;
			Da(t) || xa(t) || t.raycast(Oa, e);
		}
		return e.filter((e) => e.distance <= Oa.far);
	}
}, Ra = /* @__PURE__ */ new A();
function za(e) {
	return {
		version: Yi.formatVersion,
		id: e.id,
		nodes: Array.from(e.nodes.values(), (e) => ({
			id: e.id,
			position: e.position.toArray(),
			accessible: e.accessible,
			source: e.source,
			componentId: e.componentId
		})),
		edges: Array.from(e.edges.values(), (e) => ({
			id: e.id,
			fromNodeId: e.fromNodeId,
			toNodeId: e.toNodeId,
			direction: e.direction,
			accessible: e.accessible,
			kind: e.kind
		}))
	};
}
function Ba(e) {
	if (!Va(e) || e.version !== 1 || typeof e.id != "string" || !Array.isArray(e.nodes) || !Array.isArray(e.edges)) throw Error("Unsupported or invalid navigation graph JSON.");
	let t = new Yi(e.id);
	for (let n of e.nodes) {
		if (!Va(n) || typeof n.id != "string" || !Ha(n.position) || typeof n.accessible != "boolean" || n.source !== "manual" && n.source !== "generated") throw Error("Invalid navigation node in JSON.");
		let e = n.componentId ?? null;
		if (e !== null && (typeof e != "number" || !Number.isInteger(e) || e < 0)) throw Error("Invalid navigation node component in JSON.");
		t.addNode(Ra.set(n.position[0], n.position[1], n.position[2]), {
			id: n.id,
			accessible: n.accessible,
			source: n.source,
			componentId: e
		});
	}
	for (let n of e.edges) {
		if (!Va(n) || typeof n.id != "string" || typeof n.fromNodeId != "string" || typeof n.toNodeId != "string" || n.direction !== "both" && n.direction !== "forward" || typeof n.accessible != "boolean") throw Error("Invalid navigation edge in JSON.");
		let e = n.kind === void 0 ? "horizontal" : n.kind;
		if (e !== "horizontal" && e !== "vertical") throw Error("Invalid navigation edge kind in JSON.");
		t.addEdge(n.fromNodeId, n.toNodeId, {
			id: n.id,
			direction: n.direction,
			accessible: n.accessible,
			geometryValid: !0,
			kind: e
		});
	}
	return t;
}
function Va(e) {
	return typeof e == "object" && !!e;
}
function Ha(e) {
	return Array.isArray(e) && e.length === 3 && e.every((e) => typeof e == "number" && Number.isFinite(e));
}
//#endregion
//#region src/PathPlugin/navigation/NavigationGraphController.ts
var Ua = class {
	constructor(e) {
		this.viewer = e, this.signals = {
			onGraphChanged: new T(),
			onSelectionChanged: new T(),
			onEditingChanged: new T()
		}, this.graph = null, this.savedGraph = null, this.createSavedGraph = null, this.selection = {
			type: "node",
			ids: []
		}, this.editing = !1, this.ignoredObjectTypesKey = "", this.validator = new La(e);
	}
	get activeGraph() {
		return this.graph;
	}
	get selectedElements() {
		return this.selection;
	}
	get isEditing() {
		return this.editing;
	}
	setIgnoredObjectTypes(e) {
		let t = Array.from(new Set(e.map((e) => e.toLocaleLowerCase()))).sort((e, t) => e.localeCompare(t)), n = JSON.stringify(t);
		n !== this.ignoredObjectTypesKey && (this.ignoredObjectTypesKey = n, this.validator.setIgnoredObjectTypes(t), this.graph && (this.validator.validateGraph(this.graph), this.emitGraphChanged()));
	}
	createGraph(e) {
		let t = new Yi(e);
		return this.setGraph(t, !0), t;
	}
	importGraph(e) {
		let t = Ba(e);
		return this.setGraph(t, !0), this.validate(), t;
	}
	exportGraph() {
		return this.commit(), za(this.requireGraph());
	}
	setGraph(e, t = !1, n) {
		this.graph = e, this.savedGraph = t ? e.clone() : null, this.createSavedGraph = t ? null : n ?? null, this.updateSelection({
			type: "node",
			ids: []
		}), this.emitGraphChanged();
	}
	clear() {
		this.graph = null, this.savedGraph = null, this.createSavedGraph = null, this.editing ? this.setEditing(!1) : this.updateSelection({
			type: "node",
			ids: []
		}), this.emitGraphChanged();
	}
	setEditing(e) {
		this.editing !== e && (this.editing = e, e || this.updateSelection({
			type: "node",
			ids: []
		}), this.signals.onEditingChanged.emit(e));
	}
	selectNodes(e) {
		let t = this.requireGraph();
		this.updateSelection({
			type: "node",
			ids: Array.from(new Set(e)).filter((e) => t.nodes.has(e))
		});
	}
	selectEdges(e) {
		let t = this.requireGraph();
		this.updateSelection({
			type: "edge",
			ids: Array.from(new Set(e)).filter((e) => t.edges.has(e))
		});
	}
	addNode(e, t) {
		let n = this.requireGraph().addNode(e, t);
		return n.positionValid = this.validator.validateNodePosition(n.position), this.changed([n.id]), n;
	}
	moveNode(e, t, n = !0) {
		let r = this.requireGraph(), i = r.requireNode(e);
		r.moveNode(e, t, i.positionValid), n && (i.positionValid = this.validator.validateNodePosition(i.position), this.revalidateNodeEdges(e)), this.changed([e], Array.from(i.edgeIds), !n);
	}
	validateNodeGeometry(e) {
		let t = this.requireGraph().requireNode(e);
		t.positionValid = this.validator.validateNodePosition(t.position), this.revalidateNodeEdges(e), this.emitGraphChanged({
			nodeIds: [e],
			edgeIds: Array.from(t.edgeIds)
		});
	}
	deleteNode(e) {
		let t = this.requireGraph(), n = Array.from(t.requireNode(e).edgeIds);
		t.deleteNode(e), this.removeFromSelection(e), this.changed([e], n);
	}
	addEdge(e, t, n) {
		let r = this.requireGraph(), i = r.addEdge(e, t, n);
		return i.geometryValid = this.validator.validateEdge(r, i), this.changed([], [i.id]), i;
	}
	deleteEdge(e) {
		this.requireGraph().deleteEdge(e), this.removeFromSelection(e), this.changed([], [e]);
	}
	deleteConnectedComponent(e) {
		this.requireGraph().deleteConnectedComponent(e), this.updateSelection({
			type: "node",
			ids: []
		}), this.changed();
	}
	mergeNodes(e, t) {
		let n = this.requireGraph().mergeNodes(e, t);
		if (t === "center") {
			let e = this.validator.projectOnSurface(n.position, 1);
			e && n.position.copy(e);
		}
		return n.positionValid = this.validator.validateNodePosition(n.position), this.selectNodes([n.id]), this.revalidateNodeEdges(n.id), this.changed(), n;
	}
	setNodeAccessible(e, t) {
		this.requireGraph().requireNode(e).accessible = t, this.changed([e]);
	}
	setEdgeAccessible(e, t) {
		this.requireGraph().requireEdge(e).accessible = t, this.changed([], [e]);
	}
	setEdgeDirection(e, t) {
		this.requireGraph().requireEdge(e).direction = t, this.changed([], [e]);
	}
	reverseEdge(e) {
		this.requireGraph().reverseEdge(e), this.changed([], [e]);
	}
	validate() {
		return this.requireGraph().validate();
	}
	commit() {
		if (this.validate().length > 0) throw Error("An invalid navigation graph cannot be saved.");
		this.savedGraph = this.requireGraph().clone(), this.createSavedGraph = null;
	}
	revert() {
		let e = this.savedGraph?.clone() ?? this.createSavedGraph?.() ?? null;
		if (e) {
			if (this.graph = e, this.graph.nodes.size === 0 && this.graph.edges.size === 0) {
				this.clear();
				return;
			}
			this.updateSelection({
				type: "node",
				ids: []
			}), this.emitGraphChanged();
		}
	}
	snapshot() {
		return this.requireGraph().clone();
	}
	restore(e) {
		this.graph = e.clone(), this.updateSelection({
			type: "node",
			ids: []
		}), this.emitGraphChanged();
	}
	revalidateNodeEdges(e) {
		let t = this.requireGraph();
		for (let n of t.requireNode(e).edgeIds) {
			let e = t.requireEdge(n);
			e.geometryValid = this.validator.validateEdge(t, e);
		}
	}
	changed(e, t, n = !1) {
		this.emitGraphChanged(e !== void 0 || t !== void 0 ? {
			nodeIds: e ?? [],
			edgeIds: t ?? [],
			...n ? { transient: !0 } : {}
		} : void 0);
	}
	emitGraphChanged(e) {
		this.signals.onGraphChanged.emit(e), this.viewer.requestRender();
	}
	removeFromSelection(e) {
		this.updateSelection({
			...this.selection,
			ids: this.selection.ids.filter((t) => t !== e)
		});
	}
	updateSelection(e) {
		let t = this.selection;
		this.selection = e, this.signals.onSelectionChanged.emit({
			previous: t,
			current: e
		});
	}
	requireGraph() {
		if (!this.graph) throw Error("No active navigation graph.");
		return this.graph;
	}
}, Wa = /* @__PURE__ */ new A(0, 1, 0), Ga = /* @__PURE__ */ new A(), Ka = /* @__PURE__ */ new A(), qa = /* @__PURE__ */ new A(), Ja = /* @__PURE__ */ new A(), Ya = /* @__PURE__ */ new nt(), Xa = /* @__PURE__ */ new O();
function Za(e, t, n = !1, r = x.Tool) {
	let i = new S(t, {
		active: "float",
		diffuse: "vec3"
	}), a = new h(i, {
		depthTest: !0,
		depthWrite: !0,
		polygonOffset: n,
		polygonOffsetFactor: n ? -1 : 0,
		polygonOffsetUnits: n ? -1 : 0
	});
	return new g(e, [{
		material: a,
		type: C.Opaque,
		layer: r
	}], t);
}
function Qa(e) {
	for (let t of e.getMaterials()) t.dispose();
}
function $a(e, t, n) {
	Ga.copy(t), Ga.y += n, Xa.compose(Ga, Ya.identity(), Ja.set(1, 1, 1)), e.setMatrix(Xa);
}
function eo(e, t, n, r, i) {
	let a = no(t, n, i);
	Xa.compose(qa, Ya, Ja.set(r, a, r)), e.setMatrix(Xa);
}
function to(e, t, n, r) {
	no(t, n, r), Xa.compose(qa, Ya, Ja.set(1, 1, 1)), e.setMatrix(Xa);
}
function no(e, t, n) {
	Ka.subVectors(t, e);
	let r = Ka.length();
	return qa.addVectors(e, t).multiplyScalar(.5), qa.y += n, Ya.setFromUnitVectors(Wa, Ka.normalize()), r;
}
//#endregion
//#region src/PathPlugin/navigation/NavigationGraphSceneController.ts
var ro = .05, io = 1e4, ao = 3e4, oo = io, so = ao, co = 3046706, lo = 13840175, uo = 7697781, fo = new Re(.12, .12, .1, 12), po = new Re(1, 1, 1, 8), mo = new Le(.09, .2, 10), ho = /* @__PURE__ */ new O(), go = /* @__PURE__ */ new Ie(), _o = 10, vo = class extends le {
	constructor(e, t) {
		super(e), this.graphController = t, this.isNavigationGraphSceneController = !0, this.nodeContainer = Za(fo, oo, !0, x.Base), this.edgeContainer = Za(po, so, !0, x.Base), this.arrowContainer = Za(mo, so, !0, x.Base), this.nodeCapacity = oo, this.edgeCapacity = so, this.compactGroup = new He(), this.compactPoints = null, this.compactLines = null, this.compactNodeIds = [], this.compactNodeIndices = /* @__PURE__ */ new Map(), this.compactEdgeIndices = /* @__PURE__ */ new Map(), this.nodes = /* @__PURE__ */ new Map(), this.edges = /* @__PURE__ */ new Map(), this.arrows = /* @__PURE__ */ new Map(), this.synchronize = (e) => {
			let t = this.graphController.activeGraph;
			if (!t) {
				this.clear(), this._viewer.requestRender();
				return;
			}
			if (this.shouldUseCompactRendering(t)) {
				if (e && this.synchronizeCompactChange(t, e)) {
					this.clearInteractiveElements(), this.synchronizeSelectedInteractiveElements(t), this._viewer.requestRender();
					return;
				}
				this.clear(), this.buildCompactGraph(t), this.synchronizeSelectedInteractiveElements(t), this._viewer.requestRender();
				return;
			}
			this.disposeCompactGraph();
			let n = this.ensureContainerCapacity(t.nodes.size, t.edges.size);
			if (e && !n) {
				this.synchronizeChangedElements(t, e), this._viewer.requestRender();
				return;
			}
			let r = this.graphController.selectedElements, i = new Set(r.ids);
			this.removeMissingElements(t.nodes, this.nodes), this.removeMissingElements(t.edges, this.edges), this.removeMissingArrows(t.edges);
			for (let e of t.nodes.values()) {
				let t = r.type === "node" && i.has(e.id);
				this.synchronizeNode(e, t);
			}
			for (let e of t.edges.values()) {
				let n = r.type === "edge" && i.has(e.id);
				this.synchronizeEdge(t, e, n);
			}
			this._viewer.requestRender();
		}, this.synchronizeSelection = (e) => {
			let t = this.graphController.activeGraph;
			if (!t) return;
			if (this.compactPoints) {
				this.clearInteractiveElements(), this.synchronizeSelectedInteractiveElements(t), this._viewer.requestRender();
				return;
			}
			let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
			for (let t of [e.previous, e.current]) {
				let e = t.type === "node" ? n : r;
				for (let n of t.ids) e.add(n);
			}
			for (let r of n) {
				let n = t.nodes.get(r);
				n && this.synchronizeNode(n, e.current.type === "node" && e.current.ids.includes(r));
			}
			for (let n of r) {
				let r = t.edges.get(n);
				r && this.synchronizeEdge(t, r, e.current.type === "edge" && e.current.ids.includes(n));
			}
			this._viewer.requestRender();
		}, this.updateRaycastability = (e) => {
			for (let t of this._objects.values()) t.isRaycastable = e;
		}, this.synchronizeAll = () => {
			this.synchronize();
		}, this.attachContainers = () => {
			for (let e of this.containers()) this._viewer.scene.addInternalObject(e.root);
			this._viewer.scene.addInternalObject(this.compactGroup);
		}, this.nameContainers(), this.compactGroup.name = "GeneratedNavigationGraph";
	}
	onSceneSetup(e) {
		this.graphController.signals.onGraphChanged.connect(this.synchronize), this.graphController.signals.onSelectionChanged.connect(this.synchronizeSelection), this.graphController.signals.onEditingChanged.connect(this.updateRaycastability), this._viewer.settings.objects.highlightColor.onChange.connect(this.synchronizeAll), this.attachContainers(), this._viewer.signals.onSceneClear.connect(this.attachContainers), this.synchronize();
	}
	onSceneClear(e) {
		this.graphController.signals.onGraphChanged.disconnect(this.synchronize), this.graphController.signals.onSelectionChanged.disconnect(this.synchronizeSelection), this.graphController.signals.onEditingChanged.disconnect(this.updateRaycastability), this._viewer.settings.objects.highlightColor.onChange.disconnect(this.synchronizeAll), this._viewer.signals.onSceneClear.disconnect(this.attachContainers);
		for (let t of this.containers()) e.removeInternalObject(t.root);
		e.removeInternalObject(this.compactGroup);
		for (let t of this._objects.values()) e.isObjectInBoxTree(t) && e.removeObjectFromBoxTree(t);
	}
	accepts(e) {
		return e.isNavigationGraphObject;
	}
	*meshContainers() {
		yield this.nodeContainer, yield this.edgeContainer, yield this.arrowContainer;
	}
	*lineContainers() {}
	*edgesContainers() {}
	_setVisibility(e) {
		super._setVisibility(e), this.compactGroup.visible = e;
	}
	addObject(e) {
		super.addObject(e, null), this._viewer.scene.addObjectIntoBoxTree(e);
	}
	removeObject(e) {
		this._viewer.scene.isObjectInBoxTree(e) && this._viewer.scene.removeObjectFromBoxTree(e), (e.elementType === "node" ? this.nodeContainer : this.edgeContainer).removeInstance(e.meshProxy), super.removeObject(e);
	}
	synchronizeChangedElements(e, t) {
		let n = this.graphController.selectedElements, r = new Set(n.ids);
		for (let i of t.nodeIds) {
			let t = e.nodes.get(i);
			if (t) this.synchronizeNode(t, n.type === "node" && r.has(i));
			else {
				let e = this.nodes.get(i);
				e && (this.removeObject(e.object), this.nodes.delete(i));
			}
		}
		for (let i of t.edgeIds) {
			let t = e.edges.get(i);
			if (t) this.synchronizeEdge(e, t, n.type === "edge" && r.has(i));
			else {
				let e = this.edges.get(i);
				e && (this.removeObject(e.object), this.edges.delete(i)), this.removeArrow(i);
			}
		}
	}
	clear() {
		this.disposeCompactGraph();
		let e = Array.from(this._objects.values());
		for (let t of e) this.removeObject(t);
		for (let e of this.arrows.values()) this.arrowContainer.removeInstance(e.proxy);
		this.nodes.clear(), this.edges.clear(), this.arrows.clear();
	}
	dispose() {
		this.graphController.signals.onGraphChanged.disconnect(this.synchronize), this.graphController.signals.onSelectionChanged.disconnect(this.synchronizeSelection), this.graphController.signals.onEditingChanged.disconnect(this.updateRaycastability), this._viewer.settings.objects.highlightColor.onChange.disconnect(this.synchronizeAll), this.clear(), Qa(this.nodeContainer), Qa(this.edgeContainer), Qa(this.arrowContainer), super.dispose();
	}
	get selectionColor() {
		return this._viewer.settings.objects.highlightColor.value;
	}
	shouldUseCompactRendering(e) {
		return e.nodes.size <= io && e.edges.size <= ao ? !1 : e.nodes.values().next().value?.source === "generated";
	}
	pickCompactNode(e) {
		let t = this.compactPoints, n = this._viewer.viewport;
		if (!t || !n || !this.graphController.isEditing) return null;
		let r = n.canvas.getBoundingClientRect();
		if (r.width <= 0 || r.height <= 0) return null;
		n.camera.updateMatrixWorld(), ho.multiplyMatrices(n.camera.projectionMatrix, n.camera.matrixWorldInverse);
		let i = t.geometry.getAttribute("position"), a = ho.elements, o = e.clientX - r.left, s = e.clientY - r.top, c = _o ** 2, l = -1, u = c, d = Infinity;
		for (let e = 0; e < i.count; e++) {
			let t = i.getX(e), n = i.getY(e), c = i.getZ(e), f = a[3] * t + a[7] * n + a[11] * c + a[15];
			if (f <= 0) continue;
			let p = (a[2] * t + a[6] * n + a[10] * c + a[14]) / f;
			if (p < -1 || p > 1) continue;
			let m = ((a[0] * t + a[4] * n + a[8] * c + a[12]) / f + 1) * r.width / 2, h = (1 - (a[1] * t + a[5] * n + a[9] * c + a[13]) / f) * r.height / 2, g = (m - o) ** 2 + (h - s) ** 2;
			g > u || g === u && p >= d || (l = e, u = g, d = p);
		}
		return l < 0 ? null : this.compactNodeIds[l] ?? null;
	}
	buildCompactGraph(e) {
		let t = new Float32Array(e.nodes.size * 3), n = null;
		this.compactNodeIds = Array(e.nodes.size);
		let r = 0;
		for (let i of e.nodes.values()) {
			let a = r / 3;
			this.compactNodeIds[a] = i.id, this.compactNodeIndices.set(i.id, a), t[r++] = i.position.x, t[r++] = i.position.y + ro, t[r++] = i.position.z;
			let o = yo(i);
			o !== co && (n ??= xo(e.nodes.size), So(n, a * 3, o));
		}
		let i = new Ne();
		i.setAttribute("position", new Ve(t, 3)), n && i.setAttribute("color", new Ve(n, 3));
		let a = new et({
			color: co,
			size: 4,
			sizeAttenuation: !1,
			vertexColors: n !== null
		});
		this.compactPoints = new $e(i, a), this.compactPoints.name = "GeneratedNavigationGraphNodes", this.compactPoints.frustumCulled = !1;
		let o = new Float32Array(e.edges.size * 6), s = null, c = 0;
		for (let t of e.edges.values()) {
			let n = c / 6;
			this.compactEdgeIndices.set(t.id, n);
			let r = e.requireNode(t.fromNodeId).position, i = e.requireNode(t.toNodeId).position;
			o[c++] = r.x, o[c++] = r.y + ro, o[c++] = r.z, o[c++] = i.x, o[c++] = i.y + ro, o[c++] = i.z;
			let a = bo(t);
			a !== co && (s ??= xo(e.edges.size * 2), So(s, n * 6, a), So(s, n * 6 + 3, a));
		}
		let l = new Ne();
		l.setAttribute("position", new Ve(o, 3)), s && l.setAttribute("color", new Ve(s, 3)), this.compactLines = new Ke(l, new D({
			color: co,
			vertexColors: s !== null
		})), this.compactLines.name = "GeneratedNavigationGraphEdges", this.compactLines.frustumCulled = !1, this.compactGroup.add(this.compactLines, this.compactPoints);
	}
	disposeCompactGraph() {
		this.compactPoints && (this.compactPoints.geometry.dispose(), this.compactPoints.material.dispose(), this.compactPoints.removeFromParent(), this.compactPoints = null, this.compactNodeIds = [], this.compactNodeIndices.clear()), this.compactLines && (this.compactLines.geometry.dispose(), this.compactLines.material.dispose(), this.compactLines.removeFromParent(), this.compactLines = null, this.compactEdgeIndices.clear());
	}
	synchronizeCompactChange(e, t) {
		let n = this.compactPoints, r = this.compactLines;
		return !(!n || !r || this.compactNodeIndices.size !== e.nodes.size || this.compactEdgeIndices.size !== e.edges.size || !this.synchronizeCompactNodes(e, t, n) || !this.synchronizeCompactEdges(e, t, r));
	}
	synchronizeCompactNodes(e, t, n) {
		let r = n.geometry.getAttribute("position"), i = n.geometry.getAttribute("color");
		for (let n of t.nodeIds) {
			let t = e.nodes.get(n), a = this.compactNodeIndices.get(n);
			if (!t || a === void 0 || !i && yo(t) !== co) return !1;
			r.setXYZ(a, t.position.x, t.position.y + ro, t.position.z), r.addUpdateRange(a * 3, 3), i && Co(i, a, yo(t));
		}
		return r.needsUpdate = t.nodeIds.length > 0, i && (i.needsUpdate = t.nodeIds.length > 0), !0;
	}
	synchronizeCompactEdges(e, t, n) {
		let r = n.geometry.getAttribute("position"), i = n.geometry.getAttribute("color");
		for (let n of t.edgeIds) {
			let t = e.edges.get(n), a = this.compactEdgeIndices.get(n);
			if (!t || a === void 0 || !i && bo(t) !== co) return !1;
			let o = e.requireNode(t.fromNodeId).position, s = e.requireNode(t.toNodeId).position, c = a * 2;
			r.setXYZ(c, o.x, o.y + ro, o.z), r.setXYZ(c + 1, s.x, s.y + ro, s.z), r.addUpdateRange(c * 3, 6), i && (Co(i, c, bo(t)), Co(i, c + 1, bo(t)));
		}
		return r.needsUpdate = t.edgeIds.length > 0, i && (i.needsUpdate = t.edgeIds.length > 0), !0;
	}
	synchronizeSelectedInteractiveElements(e) {
		let t = this.graphController.selectedElements;
		if (t.type === "node") for (let n of t.ids) {
			let t = e.nodes.get(n);
			t && this.synchronizeNode(t, !0);
		}
		else for (let n of t.ids) {
			let t = e.edges.get(n);
			t && this.synchronizeEdge(e, t, !0);
		}
	}
	ensureContainerCapacity(e, t) {
		if (e <= this.nodeCapacity && t <= this.edgeCapacity) return !1;
		let n = e > this.nodeCapacity ? Math.max(e, Math.ceil(this.nodeCapacity * 1.5)) : this.nodeCapacity, r = t > this.edgeCapacity ? Math.max(t, Math.ceil(this.edgeCapacity * 1.5)) : this.edgeCapacity, i = [
			this.nodeContainer,
			this.edgeContainer,
			this.arrowContainer
		];
		this.clear();
		for (let e of i) this._viewer.scene.removeInternalObject(e.root), Qa(e);
		return this.nodeCapacity = n, this.edgeCapacity = r, this.nodeContainer = Za(fo, n, !0, x.Base), this.edgeContainer = Za(po, r, !0, x.Base), this.arrowContainer = Za(mo, r, !0, x.Base), this.nameContainers(), this.attachContainers(), !0;
	}
	nameContainers() {
		this.nodeContainer.root.name = "NavigationGraphNodes", this.edgeContainer.root.name = "NavigationGraphEdges", this.arrowContainer.root.name = "NavigationGraphArrows";
	}
	clearInteractiveElements() {
		for (let e of [...this.nodes.values(), ...this.edges.values()]) this.removeObject(e.object);
		for (let e of this.arrows.values()) this.arrowContainer.removeInstance(e.proxy);
		this.nodes.clear(), this.edges.clear(), this.arrows.clear();
	}
	synchronizeNode(e, t) {
		let n = t ? this.selectionColor : yo(e), r = wo(e), i = this.nodes.get(e.id);
		i ??= this.addElement(this.nodeContainer, this.nodes, "node", e.id), i.transformState !== r && ($a(i.object, e.position, ro), this._viewer.scene.updateObjectInBoxTree(i.object), i.transformState = r), i.color !== n && (i.object.diffuseColor = n, i.color = n);
	}
	synchronizeEdge(e, t, n) {
		let r = n ? this.selectionColor : bo(t), i = e.requireNode(t.fromNodeId).position, a = e.requireNode(t.toNodeId).position, o = To(i, a), s = this.edges.get(t.id);
		s ??= this.addElement(this.edgeContainer, this.edges, "edge", t.id), s.transformState !== o && (eo(s.object, i, a, .04, ro), this._viewer.scene.updateObjectInBoxTree(s.object), s.transformState = o), s.color !== r && (s.object.diffuseColor = r, s.color = r), this.synchronizeArrow(t, i, a, o, r);
	}
	synchronizeArrow(e, t, n, r, i) {
		if (e.direction !== "forward") {
			this.removeArrow(e.id);
			return;
		}
		let a = this.arrows.get(e.id);
		a ??= this.addArrow(e.id), a.transformState !== r && (to(a.proxy, t, n, ro), a.transformState = r), a.color !== i && (a.proxy.setDiffuseColor(i), a.color = i);
	}
	addElement(e, t, n, r) {
		let i = new _(e, -1, e.geometry.uuid);
		e.addInstance(i);
		let a = new Ea(i, n, r);
		a.isRaycastable = this.graphController.isEditing;
		let o = {
			object: a,
			transformState: "",
			color: null
		};
		return t.set(r, o), this.addObject(a), o;
	}
	addArrow(e) {
		let t = new _(this.arrowContainer, -1, mo.uuid);
		this.arrowContainer.addInstance(t);
		let n = {
			proxy: t,
			transformState: "",
			color: null
		};
		return this.arrows.set(e, n), n;
	}
	removeArrow(e) {
		let t = this.arrows.get(e);
		t && (this.arrowContainer.removeInstance(t.proxy), this.arrows.delete(e));
	}
	removeMissingElements(e, t) {
		for (let [n, r] of t) e.has(n) || (this.removeObject(r.object), t.delete(n));
	}
	removeMissingArrows(e) {
		for (let t of this.arrows.keys()) e.has(t) || this.removeArrow(t);
	}
};
function yo(e) {
	return e.positionValid ? e.accessible ? co : uo : lo;
}
function bo(e) {
	return e.geometryValid ? e.accessible ? co : uo : lo;
}
function xo(e) {
	let t = new Float32Array(e * 3);
	go.set(co);
	for (let e = 0; e < t.length; e += 3) t[e] = go.r, t[e + 1] = go.g, t[e + 2] = go.b;
	return t;
}
function So(e, t, n) {
	go.set(n), e[t] = go.r, e[t + 1] = go.g, e[t + 2] = go.b;
}
function Co(e, t, n) {
	go.set(n), e.setXYZ(t, go.r, go.g, go.b), e.addUpdateRange(t * 3, 3);
}
function wo(e) {
	return `${e.position.x}:${e.position.y}:${e.position.z}`;
}
function To(e, t) {
	return `${e.x}:${e.y}:${e.z}:${t.x}:${t.y}:${t.z}`;
}
//#endregion
//#region src/PathPlugin/navmesh/NavigationMeshTypes.ts
var Eo = {
	targetNodeCount: 1e5,
	maximumNodeCount: 5e5,
	maximumEdgeCount: 15e5,
	maximumHeightDifference: .25,
	maximumSlopeAngle: 35,
	simplificationTolerance: .05,
	maximumMergeDistance: 2
}, Do = 1e-12, Oo = class extends Se {
	constructor(e) {
		super(e), this.name = "NavigationGraphOperator", this.isNavigationGraphOperator = !0, this.previousNodeId = null, this.draggedNodeId = null, this.moveCommand = null, this.hasMoved = !1, this.nodeCount = 0, this.onGraphChanged = () => {
			let e = this.controller.activeGraph, t = e?.nodes.size ?? 0;
			if (t !== this.nodeCount) {
				let n = null;
				e && (n = Array.from(e.nodes.keys()).at(-1) ?? null), this.previousNodeId = n, this.nodeCount = t;
			} else this.previousNodeId && !e?.nodes.has(this.previousNodeId) && (this.previousNodeId = null);
		}, this.nodeCount = this.controller.activeGraph?.nodes.size ?? 0;
	}
	initialize() {
		this.controller.signals.onGraphChanged.connect(this.onGraphChanged);
	}
	onPointerDown(e) {
		if (e.button !== 0) return;
		let t = this.graphElement(e);
		if (t?.elementType === "node") {
			let n = this.controller.selectedElements, r = n.type === "node" ? Array.from(n.ids) : [], i = e.ctrlKey || e.metaKey, a;
			a = i ? r.includes(t.elementId) ? r.filter((e) => e !== t.elementId) : r.concat(t.elementId) : [t.elementId], this.controller.selectNodes(a), this.draggedNodeId = t.elementId, this.hasMoved = !1, this.stopCameraControlOnDrag = !0;
		}
	}
	onPointerDrag(e) {
		if (!this.draggedNodeId) return;
		let t = this.scenePoint(e), n = this.controller.activeGraph?.nodes.get(this.draggedNodeId);
		if (!(!t || !n || n.position.distanceToSquared(t) <= Do)) {
			if (!this.moveCommand) {
				this.moveCommand = new Ui(this._viewport.viewer, this.draggedNodeId, t), this.moveCommand.execute(), this.hasMoved = !0;
				return;
			}
			this.moveCommand.update(t);
		}
	}
	onPointerUp() {
		this.draggedNodeId && this.hasMoved && (this.moveCommand?.validateGeometry(), this.mergeCloseNode(this.draggedNodeId)), this.draggedNodeId = null, this.moveCommand = null, this.hasMoved = !1, this.stopCameraControlOnDrag = !1;
	}
	onPointerClick(e) {
		this.handlePointerClick(e);
	}
	async handlePointerClick(e) {
		let t = this.graphElement(e);
		if (e.button === 2) {
			t?.elementType === "node" && await new Bi(this._viewport.viewer, t.elementId).execute();
			return;
		}
		if (e.button !== 0) return;
		if (t?.elementType === "node") {
			this.previousNodeId = t.elementId;
			return;
		}
		if (t?.elementType === "edge") {
			this.controller.selectEdges([t.elementId]);
			return;
		}
		let n = this.scenePoint(e);
		if (!n) return;
		let r = this._viewport.viewer.getPlugin("Path").navigationGraphSettings.connectNodesAutomatically.value, i = (await new Ni(this._viewport.viewer, n, r ? this.previousNodeId : null).execute()).nodeId;
		this.controller.selectNodes([i]), this.previousNodeId = i;
	}
	onKeyDown(e) {
		e.key === "Escape" && (this.clearSelection(), e.preventDefault(), e.stopPropagation());
	}
	clearSelection() {
		this.previousNodeId = null, this.controller.selectNodes([]);
	}
	dispose() {
		this.controller.signals.onGraphChanged.disconnect(this.onGraphChanged), this.draggedNodeId = null, this.moveCommand = null, this.hasMoved = !1, this.stopCameraControlOnDrag = !1;
	}
	get controller() {
		return this._viewport.viewer.getPlugin("Path").navigationGraphController;
	}
	scenePoint(e) {
		return this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: e.shiftKey,
			filterFunc: (e) => !Da(e)
		})[0]?.point.clone() ?? null;
	}
	graphElement(e) {
		let t = this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: !0,
			filterFunc: Da
		})[0]?.object;
		if (t && Da(t)) return t;
		let n = this._viewport.viewer.getPlugin("Path").navigationGraphSceneController.pickCompactNode(e);
		return n ? {
			elementType: "node",
			elementId: n
		} : null;
	}
	mergeCloseNode(e) {
		let t = this.controller.activeGraph;
		if (!t) return;
		let n = t.nodes.get(e);
		if (!n) return;
		let r = this._viewport.viewer.getPlugin("Path").navigationGraphSettings.mergeThreshold.value, i = null, a = r;
		for (let r of t.nodes.values()) {
			if (r.id === e) continue;
			let t = r.position.distanceTo(n.position);
			t <= a && (a = t, i = r.id);
		}
		i && (new Hi(this._viewport.viewer, [i, e], "first").execute(), this.previousNodeId = i);
	}
}, ko = 1e-12, Ao = class extends Se {
	constructor(e, t, n) {
		super(e), this.controller = t, this.placementMode = n, this.name = "NavigationRoutingOperator", this.draggedPointType = null, this.dragPointCommand = null;
	}
	onPointerDown(e) {
		if (e.button !== 0) return;
		let t = this.raycastRoutePoint(e);
		t && (this.draggedPointType = t.pointType, this.stopCameraControlOnDrag = !0);
	}
	onPointerDrag(e) {
		if (!this.draggedPointType) return;
		let t = this.raycastScenePoint(e), n = this.draggedPointType === "start" ? this.controller.startPoint : this.controller.endPoint;
		if (!(!t || !n || n.position.distanceToSquared(t) <= ko)) {
			if (!this.dragPointCommand) {
				this.dragPointCommand = new sa(this._viewport.viewer, this.draggedPointType, t, !1), this.dragPointCommand.execute();
				return;
			}
			this.dragPointCommand.update(t);
		}
	}
	onPointerUp() {
		this.dragPointCommand?.reconnect(), this.draggedPointType = null, this.dragPointCommand = null, this.stopCameraControlOnDrag = !1;
	}
	onPointerClick(e) {
		this.handlePointerClick(e);
	}
	dispose() {
		this.draggedPointType = null, this.dragPointCommand = null, this.stopCameraControlOnDrag = !1;
	}
	async handlePointerClick(e) {
		let t = this.raycastRoutePoint(e);
		if (e.button === 2 && t) {
			await new Vi(this._viewport.viewer, t.pointType).execute();
			return;
		}
		if (e.button !== 0 || t) return;
		let n = this.raycastScenePoint(e);
		n && new sa(this._viewport.viewer, this.placementMode, n).execute();
	}
	raycastScenePoint(e) {
		return this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: e.shiftKey,
			filterFunc: (e) => !Da(e) && !xa(e)
		})[0]?.point.clone() ?? null;
	}
	raycastRoutePoint(e) {
		return this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: !0,
			filterFunc: xa
		})[0]?.object ?? null;
	}
}, jo = class extends de {
	constructor(e, t) {
		super(e, null, t), this.seedId = t, this.isFloodFillSeedObject = !0, this.isSelectable = !1, this.isTransformable = !1;
	}
};
function Mo(e) {
	return e.isFloodFillSeedObject === !0;
}
//#endregion
//#region src/PathPlugin/operators/FloodFillSeedOperator.ts
var q = class extends Se {
	constructor(...e) {
		super(...e), this.name = "FloodFillSeedOperator";
	}
	onPointerClick(e) {
		if (e.button === 2) {
			let t = this.findSeed(e);
			t !== null && new Ai(this._viewport.viewer, t.seedId).execute();
			return;
		}
		if (e.button !== 0) return;
		let t = this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: e.shiftKey,
			filterFunc: (e) => !Mo(e)
		})[0]?.point;
		t && new ki(this._viewport.viewer, t).execute();
	}
	findSeed(e) {
		return this._viewport.raycaster.raycastEvent(e, {
			raycastTransparentMeshes: !0,
			filterFunc: Mo
		})[0]?.object ?? null;
	}
}, No = {
	seedObjectTypes: ["IfcDoor"],
	maximumSeedDistance: 1,
	workerCount: 8
}, Po = "(function(){function e(e){return`isPacked`in e?{version:e.version,origin:e.origin,gridBounds:e.gridBounds,granularities:e.granularities,voxelCount:e.voxelCount,solidVoxelCount:e.solidVoxelCount,emptyVoxelCount:e.emptyVoxelCount,chunks:[{coordinates:e.coordinates,levels:e.levels,states:e.states}]}:e}var t=class{constructor(){this.parents=/* @__PURE__ */ new Map}add(e){this.parents.set(e,e)}find(e){let t=e;for(;this.parents.get(t)!==t;)t=this.parents.get(t);let n=e;for(;n!==t;){let e=this.parents.get(n);this.parents.set(n,t),n=e}return t}merge(e,t){let n=this.find(e),r=this.find(t);n!==r&&this.parents.set(Math.max(n,r),Math.min(n,r))}};function n(e){let n=new t,r=/* @__PURE__ */ new Map;for(let t of e)for(let e of t.partitionComponents)n.add(e.provisionalComponentId),r.set(e.provisionalComponentId,e);return{union:n,partitionComponentsById:r}}function r(e,t,n){for(let r of t)for(let t=0;t<r.boundaryLinks.length;t+=2){let i=r.boundaryLinks[t],a=e[r.boundaryLinks[t+1]];a>=0&&n.merge(i,a)}}function i(e,t,n){let r=/* @__PURE__ */ new Map;for(let i of e){if(i.voxelIndex<0)continue;let e=t[i.voxelIndex];if(e<0)continue;let a=n.find(e);r.has(a)||r.set(a,r.size)}return r}function a(e,t,n){let r=Array.from(e,([,e])=>({id:e,voxelCount:0,bounds:new Float64Array([1/0,1/0,1/0,-1/0,-1/0,-1/0]),seedIds:[],estimatedVolume:0}));for(let i of t.values()){let t=e.get(n.find(i.provisionalComponentId));if(t===void 0)continue;let a=r[t];a.voxelCount+=i.voxelCount,a.estimatedVolume+=i.estimatedVolume;for(let e=0;e<3;e++)a.bounds[e]=Math.min(a.bounds[e],i.bounds[e]),a.bounds[e+3]=Math.max(a.bounds[e+3],i.bounds[e+3])}return r}function o(e,t,n,r,i){for(let a of e){if(a.voxelIndex<0)continue;let e=t[a.voxelIndex];if(e<0)continue;let o=n.get(r.find(e));o!==void 0&&i[o].seedIds.push(a.id)}}function s(e,t,n){for(let r=0;r<e.length;r++){let i=e[r];if(i<0)continue;let a=t.get(n.find(i));a===void 0?e[r]=-1:e[r]=a}}function c(e,t){let{union:c,partitionComponentsById:l}=n(t);r(e,t,c);let u=t.flatMap(e=>e.seeds).sort((e,t)=>e.id.localeCompare(t.id)),d=i(u,e,c),f=a(d,l,c);return o(u,e,d,c,f),s(e,d,c),{componentIds:e,components:f,seeds:u}}let l=/* @__PURE__ */ function(e){return e[e.Unclassified=0]=`Unclassified`,e[e.Solid=1]=`Solid`,e[e.Navigable=2]=`Navigable`,e}({}),u=1048576;var d=class{constructor(){this.blocks=[],this.readIndex=0,this.writeIndex=0}get length(){return this.writeIndex-this.readIndex}push(e){let t=Math.floor(this.writeIndex/u);this.blocks[t]??=new Uint32Array(u),this.blocks[t][this.writeIndex%u]=e,this.writeIndex++}shift(){let e=this.blocks[Math.floor(this.readIndex/u)][this.readIndex%u];return this.readIndex++,e}};let f=[[0,-1],[0,1],[1,-1],[1,1],[2,-1],[2,1]];function p(e){let t=Math.trunc(e)^Math.trunc(e/4294967296);return t^=t>>>16,t=Math.imul(t,2146121005),t^=t>>>15,t=Math.imul(t,2221713035),t^=t>>>16,(t>>>0)%256}var m=class{constructor(e,t=()=>!0){this.grid=e,this.voxelByLevel=Array.from(e.granularities,()=>/* @__PURE__ */ new Map),this.chunkOffsets=new Uint32Array(e.chunks.length+1),this.coordinateWidths=Uint32Array.from(e.granularities,t=>Math.ceil((e.gridBounds[3]-e.origin[0])/t)),this.coordinateHeights=Uint32Array.from(e.granularities,t=>Math.ceil((e.gridBounds[4]-e.origin[1])/t)),this.coordinateDepths=Uint32Array.from(e.granularities,t=>Math.ceil((e.gridBounds[5]-e.origin[2])/t));let n=e.granularities.at(-1);this.unitsByLevel=Uint32Array.from(e.granularities,e=>Math.round(e/n)),this.fillParams(e,t)}fillParams(e,t){let n=0;for(let r=0;r<e.chunks.length;r++){let i=e.chunks[r];this.chunkOffsets[r]=n;for(let r=0;r<i.states.length;r++){let a=r*3,o=i.levels[r],s=i.coordinates[a],c=i.coordinates[a+1],l=i.coordinates[a+2];t(s,c,l,o,e.granularities[o])&&this.setVoxelIndex(o,this.voxelKey(o,s,c,l),n),n++}}this.chunkOffsets[e.chunks.length]=n}getVoxel(e){let t=this.findChunkIndex(e),n=e-this.chunkOffsets[t],r=this.grid.chunks[t],i=n*3,a=r.levels[n];return{globalIndex:e,chunkIndex:t,localIndex:n,x:r.coordinates[i],y:r.coordinates[i+1],z:r.coordinates[i+2],level:a,size:this.grid.granularities[a],state:r.states[n]}}getVoxelState(e){let t=this.findChunkIndex(e),n=e-this.chunkOffsets[t];return this.grid.chunks[t].states[n]}findContainingVoxel(e){for(let t=this.grid.granularities.length-1;t>=0;t--){let n=this.grid.granularities[t],r=Math.floor((e[0]-this.grid.origin[0])/n),i=Math.floor((e[1]-this.grid.origin[1])/n),a=Math.floor((e[2]-this.grid.origin[2])/n),o=this.getVoxelIndex(t,r,i,a);if(o!==void 0)return o}return-1}findNearestVoxel(e,t,n){let r={index:-1,distanceSquared:t*t};for(let i=0;i<this.grid.granularities.length;i++)this.findNearestVoxelAtLevel(e,t,i,n,r);return r.index}forEachNeighbor(e,t){let n=this.getVoxel(e);for(let[e,r]of f){let i=this.getSameLevelNeighbor(n,e,r);if(i!==void 0){t(i);continue}this.forEachNeighborAtOtherLevels(n,e,r,t)}}findNearestVoxelAtLevel(e,t,n,r,i){let a=this.grid.granularities[n],o=[0,1,2].map(n=>Math.floor((e[n]-t-this.grid.origin[n])/a)),s=[0,1,2].map(n=>Math.floor((e[n]+t-this.grid.origin[n])/a));for(let t=o[2];t<=s[2];t++)for(let a=o[1];a<=s[1];a++)for(let c=o[0];c<=s[0];c++){let o=this.getVoxelIndex(n,c,a,t);o!==void 0&&this.updateNearestVoxel(e,o,r,i)}}updateNearestVoxel(e,t,n,r){let i=this.getVoxel(t);if(!n(i))return;let a=this.distanceToVoxelSquared(e,i),o=a<r.distanceSquared,s=a===r.distanceSquared&&(r.index<0||t<r.index);(o||s)&&(r.distanceSquared=a,r.index=t)}getSameLevelNeighbor(e,t,n){let r=this.getAxisCoordinate(e,t)+n;if(!(r<0||r>=this.getAxisCoordinateCount(e.level,t)))return this.getVoxelIndex(e.level,t===0?r:e.x,t===1?r:e.y,t===2?r:e.z)}getAxisCoordinate(e,t){return t===0?e.x:t===1?e.y:e.z}getAxisCoordinateCount(e,t){return t===0?this.coordinateWidths[e]:t===1?this.coordinateHeights[e]:this.coordinateDepths[e]}forEachNeighborAtOtherLevels(e,t,n,r){let i=this.unitsByLevel[e.level],a=[e.x*i,e.y*i,e.z*i],o=a.map(e=>e+i),s=(t+1)%3,c=(t+2)%3,l=n<0?a[t]:o[t];for(let i=0;i<this.voxelByLevel.length;i++){if(i===e.level)continue;let u=this.unitsByLevel[i];if(l%u!==0)continue;let d=[0,0,0];d[t]=l/u+(n<0?-1:0);let f=Math.floor(a[s]/u),p=Math.ceil(o[s]/u)-1,m=Math.floor(a[c]/u),h=Math.ceil(o[c]/u)-1;for(let e=f;e<=p;e++){d[s]=e;for(let e=m;e<=h;e++){d[c]=e;let t=this.getVoxelIndex(i,d[0],d[1],d[2]);t!==void 0&&r(t)}}}}findChunkIndex(e){let t=0,n=this.grid.chunks.length;for(;t+1<n;){let r=Math.floor((t+n)/2);this.chunkOffsets[r]<=e?t=r:n=r}return t}setVoxelIndex(e,t,n){let r=p(t),i=this.voxelByLevel[e].get(r);i===void 0&&(i=/* @__PURE__ */ new Map,this.voxelByLevel[e].set(r,i)),i.set(t,n)}getVoxelIndex(e,t,n,r){if(t<0||t>=this.coordinateWidths[e]||n<0||n>=this.coordinateHeights[e]||r<0||r>=this.coordinateDepths[e])return;let i=this.voxelKey(e,t,n,r),a=p(i);return this.voxelByLevel[e].get(a)?.get(i)}voxelKey(e,t,n,r){return(r*this.coordinateHeights[e]+n)*this.coordinateWidths[e]+t}distanceToVoxelSquared(e,t){let n=[this.grid.origin[0]+t.x*t.size,this.grid.origin[1]+t.y*t.size,this.grid.origin[2]+t.z*t.size],r=0;for(let i=0;i<3;i++){let a=e[i]<n[i]?n[i]-e[i]:Math.max(0,e[i]-(n[i]+t.size));r+=a*a}return r}};function h(){}function g(e){return e!==l.Solid}function _(e,t,n){let r=t.gridBounds[0],i=t.gridBounds[3]-r;return i<=0?0:Math.min(n-1,Math.max(0,Math.floor((e-r)/i*n)))}function v(e,t,n){let r=(e.gridBounds[3]-e.gridBounds[0])/n,i=e.gridBounds[0]+t*r;return{minimum:i,maximum:t===n-1?e.gridBounds[3]:i+r}}function y(e,t,n,r){return _(t.origin[0]+(e.x+.5)*e.size,t,r)===n}function b(e,t,n){let r=Math.max(n,e.granularities[0]);return new m(e,(n,i,a,o,s)=>{let c=e.origin[0]+n*s;return c+s>=t.minimum-r&&c<=t.maximum+r})}function x(e,t,n){let r=n[0]+t.x*t.size,i=n[1]+t.y*t.size,a=n[2]+t.z*t.size;e[0]=Math.min(e[0],r),e[1]=Math.min(e[1],i),e[2]=Math.min(e[2],a),e[3]=Math.max(e[3],r+t.size),e[4]=Math.max(e[4],i+t.size),e[5]=Math.max(e[5],a+t.size)}function S(e,t,n){let r=t.findContainingVoxel(e.position);if(r>=0&&g(t.getVoxelState(r)))return{...e,voxelIndex:r,warning:null};let i=t.findNearestVoxel(e.position,n,e=>g(e.state));return{...e,voxelIndex:i,warning:i<0?`No non-solid voxel found within ${n}m.`:`Seed moved to the nearest non-solid voxel.`}}function C(e,t,n){let{index:r,componentIds:i,workerIndex:a,workerCount:o,boundaryLinks:s,onVisited:c}=n,l=new d,u=new Float64Array([1/0,1/0,1/0,-1/0,-1/0,-1/0]),f=0,p=0;for(i[e]=t,l.push(e);l.length>0;){let e=l.shift(),n=r.getVoxel(e);f++,p+=n.size**3,x(u,n,r.grid.origin),c(),r.forEachNeighbor(e,e=>{if(g(r.getVoxelState(e))){if(!y(r.getVoxel(e),r.grid,a,o)){s.push(t,e);return}i[e]===-1&&(i[e]=t,l.push(e))}})}return{provisionalComponentId:t,voxelCount:f,bounds:u,estimatedVolume:p}}function w(e,t,n,r,i,a){let o=[],s=[],c=0,l=0,u={index:t,componentIds:n,workerIndex:r,workerCount:i,boundaryLinks:s,onVisited:()=>{l++,l%1e5==0&&a({visitedVoxelCount:l,navigableVoxelCount:0})}};for(let t of e.chunks)for(let a=0;a<t.states.length;a++,c++){if(!g(t.states[a])||n[c]!==-1)continue;let s=t.levels[a],l=e.granularities[s],d=t.coordinates[a*3];if(_(e.origin[0]+(d+.5)*l,e,i)!==r)continue;let f=o.length*i+r;o.push(C(c,f,u))}return{partitionComponents:o,boundaryLinks:Int32Array.from(s),visitedVoxelCount:l}}function T(e,t,n,r,i){return e.filter(e=>_(e.position[0],t,r.workerCount)===i).map(e=>S(e,n,r.maximumSeedDistance))}function E(e,t,n,r,i,a=h){if(t.length===0)return a({visitedVoxelCount:0,navigableVoxelCount:0}),{workerIndex:r,partitionComponents:[],boundaryLinks:/* @__PURE__ */ new Int32Array,seeds:[],visitedVoxelCount:0};let o=b(e,v(e,r,n.workerCount),n.maximumSeedDistance),s=w(e,o,i,r,n.workerCount,a),c=T(t,e,o,n,r);return a({visitedVoxelCount:s.visitedVoxelCount,navigableVoxelCount:0}),{workerIndex:r,...s,seeds:c}}function D(e,t=[]){self.postMessage(e,{transfer:t})}self.onmessage=t=>{try{if(t.data.type===`StartFloodFillPartition`){let n=E(e(t.data.grid),t.data.seeds,t.data.options,t.data.workerIndex,t.data.componentIds,e=>D({type:`FloodFillPartitionProgress`,progress:e}));D({type:`FloodFillPartitionFinished`,result:n},[n.boundaryLinks.buffer]);return}D({type:`FloodFillFinished`,...c(t.data.componentIds,t.data.partitions)})}catch(e){D({type:`FloodFillError`,error:typeof e==`object`&&e&&`message`in e?String(e.message):String(e)})}}})();\n//# sourceMappingURL=FloodFillWorker-D6_7DFiX.js.map", Fo = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Po], { type: "text/javascript;charset=utf-8" });
function Io(e) {
	let t;
	try {
		if (t = Fo && (self.URL || self.webkitURL).createObjectURL(Fo), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(Po), { name: e?.name });
	}
}
//#endregion
//#region src/PathPlugin/floodFill/worker/FloodFillWorkerController.ts
var Lo = class {
	constructor() {
		this.controller = new Ce(Io, "PathFloodFillWorker", 1), this.workerIds = /* @__PURE__ */ new Set(), this.progressByWorker = /* @__PURE__ */ new Map(), this.partitionResults = [], this.resolvePromise = null, this.rejectPromise = null, this.onProgress = null, this.componentIds = null, this.workerCount = 0, this.handleMessage = async (e, t) => {
			if (!this.workerIds.has(t)) return;
			if (e.data.type === "FloodFillPartitionProgress") {
				this.progressByWorker.set(t, e.data.progress), this.emitProgress();
				return;
			}
			if (e.data.type === "FloodFillError") {
				this.fail(Error(e.data.error));
				return;
			}
			if (e.data.type === "FloodFillPartitionFinished") {
				this.partitionResults.push(e.data.result), this.partitionResults.length === this.workerCount && this.startMerge();
				return;
			}
			let n = this.resolvePromise, r = e.data;
			this.onProgress?.({
				visitedVoxelCount: Array.from(this.progressByWorker.values()).reduce((e, t) => e + t.visitedVoxelCount, 0),
				navigableVoxelCount: r.components.reduce((e, t) => e + t.voxelCount, 0)
			}), this.finish(!1), n?.(r);
		}, this.handleError = async (e, t) => {
			this.workerIds.has(t) && this.fail(Error(e.message.trim() || "Flood-fill worker stopped unexpectedly."));
		}, this.handleMessageError = async (e, t) => {
			this.workerIds.has(t) && this.fail(/* @__PURE__ */ Error("Flood-fill worker returned an unreadable message."));
		}, this.controller.onmessage = this.handleMessage, this.controller.onerror = this.handleError, this.controller.onmessageerror = this.handleMessageError;
	}
	start(e, t, n, r) {
		if (!Number.isInteger(n.workerCount) || n.workerCount < 1 || n.workerCount > 32) throw Error("Flood-fill worker count must be an integer between 1 and 32.");
		this.cancel(), this.controller.reset(), this.controller.maxWorkers = Math.max(this.controller.maxWorkers, n.workerCount), this.onProgress = r, this.workerCount = n.workerCount, this.workerIds.clear(), this.progressByWorker.clear(), this.partitionResults.length = 0;
		let i = new Int32Array(new SharedArrayBuffer(e.voxelCount * Int32Array.BYTES_PER_ELEMENT));
		return i.fill(-1), this.componentIds = i, new Promise((r, a) => {
			this.resolvePromise = r, this.rejectPromise = a;
			for (let r = 0; r < n.workerCount; r++) this.workerIds.add(r), this.progressByWorker.set(r, {
				visitedVoxelCount: 0,
				navigableVoxelCount: 0
			}), this.controller.lockWorker(r), this.controller.postMessageWithId(r, {
				type: "StartFloodFillPartition",
				grid: e,
				seeds: t,
				options: n,
				workerIndex: r,
				componentIds: i
			});
		});
	}
	cancel() {
		if (this.workerIds.size === 0) return;
		let e = this.rejectPromise;
		this.finish(!0), e?.(/* @__PURE__ */ Error("Flood fill was cancelled."));
	}
	startMerge() {
		this.componentIds !== null && this.controller.postMessageWithId(0, {
			type: "MergeFloodFillPartitions",
			componentIds: this.componentIds,
			partitions: this.partitionResults
		}, this.partitionResults.map((e) => e.boundaryLinks.buffer));
	}
	emitProgress() {
		let e = 0;
		for (let t of this.progressByWorker.values()) e += t.visitedVoxelCount;
		this.onProgress?.({
			visitedVoxelCount: e,
			navigableVoxelCount: 0
		});
	}
	fail(e) {
		let t = this.rejectPromise;
		this.finish(!0), t?.(e);
	}
	finish(e) {
		for (let t of this.workerIds) e ? this.controller.terminateWorker(t) : this.controller.freeWorker(t);
		this.workerIds.clear(), this.progressByWorker.clear(), this.partitionResults.length = 0, this.componentIds = null, this.resolvePromise = null, this.rejectPromise = null, this.onProgress = null, this.workerCount = 0;
	}
}, Ro = /* @__PURE__ */ new je(), zo = /* @__PURE__ */ new A(), Bo = {
	visitedVoxelCount: 0,
	navigableVoxelCount: 0
}, Vo = class {
	constructor(e, t, n) {
		this.viewer = e, this.voxelizationController = t, this.voxelDebugController = n, this.signals = {
			onChanged: new T(),
			onManualSeedsChanged: new T()
		}, this.workerController = new Lo(), this.currentGrid = null, this.currentStatus = "idle", this.currentProgress = Bo, this.currentError = null, this.currentNeedsUpdate = !1, this.currentOptions = structuredClone(No), this.currentManualSeeds = [], this.manualSeedId = 0, this.runId = 0, this.synchronizeGrid = () => {
			let e = this.voxelizationController.result;
			if (e === this.currentGrid) {
				this.voxelizationController.needsUpdate && this.markResultForUpdate();
				return;
			}
			this.currentGrid = e, this.clear();
		};
	}
	get grid() {
		return this.currentGrid;
	}
	get status() {
		return this.currentStatus;
	}
	get progress() {
		return this.currentProgress;
	}
	get result() {
		return this.currentGrid?.classification ?? null;
	}
	get error() {
		return this.currentError;
	}
	get needsUpdate() {
		return this.currentNeedsUpdate;
	}
	set options(e) {
		Ho(e, this.currentOptions) || (this.currentOptions = structuredClone(e), this.markResultForUpdate());
	}
	get manualSeeds() {
		return this.currentManualSeeds;
	}
	setup() {
		this.voxelizationController.signals.onChanged.connect(this.synchronizeGrid), this.synchronizeGrid();
	}
	addManualSeed(e) {
		if (this.currentGrid === null) throw Error("A voxel grid is required before adding flood-fill seeds.");
		let t = {
			id: `manual-seed-${++this.manualSeedId}`,
			source: "manual",
			position: new Float64Array(e.toArray())
		};
		return this.insertManualSeed(t), t;
	}
	restoreManualSeed(e) {
		if (this.currentGrid === null) throw Error("A voxel grid is required before restoring a flood-fill seed.");
		if (this.currentManualSeeds.some((t) => t.id === e.id)) throw Error(`Flood-fill seed "${e.id}" already exists.`);
		this.insertManualSeed({
			...e,
			position: new Float64Array(e.position)
		});
	}
	removeManualSeed(e) {
		let t = this.currentManualSeeds.findIndex((t) => t.id === e);
		if (t < 0) return null;
		let [n] = this.currentManualSeeds.splice(t, 1);
		return this.markResultForUpdate(), this.signals.onManualSeedsChanged.emit(), this.signals.onChanged.emit(), n;
	}
	async start() {
		let e = this.currentGrid;
		if (e === null) throw Error("A voxel grid is required before running flood fill.");
		this.voxelDebugController.visible = !1;
		let t = ++this.runId;
		this.workerController.cancel(), this.currentStatus = "running", this.currentError = null, this.currentProgress = Bo, this.signals.onChanged.emit();
		try {
			let n = [...this.collectBimSeeds(), ...this.currentManualSeeds], r = await this.workerController.start(e.packedSnapshot ?? e.snapshot, n, this.currentOptions, (e) => {
				t === this.runId && (this.currentProgress = e, this.signals.onChanged.emit());
			});
			if (t !== this.runId || e !== this.currentGrid) throw Error("Flood fill was cancelled.");
			let i = {
				componentIds: r.componentIds,
				components: r.components,
				seeds: r.seeds
			};
			return e.applyClassification(i), this.currentNeedsUpdate = !1, this.currentStatus = "completed", this.voxelDebugController.refreshClassification(!1), this.signals.onChanged.emit(), i;
		} catch (e) {
			throw t === this.runId && (this.currentStatus = "error", this.currentError = typeof e == "object" && e && "message" in e ? String(e.message) : String(e), this.signals.onChanged.emit()), e;
		}
	}
	cancel() {
		this.runId++, this.workerController.cancel(), this.currentStatus = "idle", this.currentProgress = Bo, this.signals.onChanged.emit();
	}
	clear() {
		this.cancel();
		let e = this.currentManualSeeds.length > 0;
		this.currentManualSeeds.length = 0, this.currentGrid?.clearClassification(), this.currentError = null, this.currentNeedsUpdate = !1, this.voxelDebugController.refreshClassification(!1), e && this.signals.onManualSeedsChanged.emit(), this.signals.onChanged.emit();
	}
	dispose() {
		this.voxelizationController.signals.onChanged.disconnect(this.synchronizeGrid), this.workerController.cancel();
	}
	collectBimSeeds() {
		let e = [], t = wa(this.currentOptions.seedObjectTypes);
		for (let n of this.viewer.scene.bimMeshController.getAllObjects()) Ta(Ca(n), t) && (n.getBoundingBox(Ro).getCenter(zo), e.push({
			id: `bim-seed-${n.uuid}`,
			source: "bim",
			position: new Float64Array(zo.toArray())
		}));
		return e;
	}
	markResultForUpdate() {
		this.currentGrid?.classification && (this.currentNeedsUpdate = !0, this.voxelDebugController.refreshClassification(!0));
	}
	insertManualSeed(e) {
		this.currentManualSeeds.push(e), this.markResultForUpdate(), this.signals.onManualSeedsChanged.emit(), this.signals.onChanged.emit();
	}
};
function Ho(e, t) {
	return Object.keys(e).every((n) => {
		let r = e[n], i = t[n];
		return Array.isArray(r) && Array.isArray(i) ? r.length === i.length && r.every((e, t) => e === i[t]) : r === i;
	});
}
//#endregion
//#region src/PathPlugin/routing/SearchPriorityQueue.ts
var Uo = class {
	constructor(e) {
		this.compare = e, this.entries = [];
	}
	get size() {
		return this.entries.length;
	}
	push(e) {
		this.entries.push(e), this.moveUp(this.entries.length - 1);
	}
	pop() {
		let e = this.entries[0], t = this.entries.pop();
		return e === void 0 || t === void 0 || this.entries.length > 0 && (this.entries[0] = t, this.moveDown(0)), e;
	}
	moveUp(e) {
		let t = e;
		for (; t > 0;) {
			let e = Math.floor((t - 1) / 2);
			if (this.compare(this.entries[e], this.entries[t]) <= 0) return;
			[this.entries[e], this.entries[t]] = [this.entries[t], this.entries[e]], t = e;
		}
	}
	moveDown(e) {
		let t = e;
		for (;;) {
			let e = t * 2 + 1, n = e + 1, r = t;
			if (e < this.entries.length && this.compare(this.entries[e], this.entries[r]) < 0 && (r = e), n < this.entries.length && this.compare(this.entries[n], this.entries[r]) < 0 && (r = n), r === t) return;
			[this.entries[t], this.entries[r]] = [this.entries[r], this.entries[t]], t = r;
		}
	}
};
//#endregion
//#region src/PathPlugin/routing/NavigationRouting.ts
function Wo(e) {
	return new es(e).findRoute();
}
function Go(e, t, n) {
	let r = n.x - t.x, i = n.y - t.y, a = n.z - t.z, o = r * r + i * i + a * a;
	if (o === 0) return e.distanceToSquared(t);
	let s = Math.max(0, Math.min(1, ((e.x - t.x) * r + (e.y - t.y) * i + (e.z - t.z) * a) / o)), c = e.x - (t.x + r * s), l = e.y - (t.y + i * s), u = e.z - (t.z + a * s);
	return c * c + l * l + u * u;
}
function Ko(e, t, n, r, i) {
	let a = i * i;
	for (let i = t + 1; i < n; i++) {
		let t = Infinity;
		for (let n = 1; n < r.length; n++) t = Math.min(t, Go(e[i], r[n - 1], r[n]));
		if (t > a) return !1;
	}
	return !0;
}
function qo(e, t, n, r, i) {
	let a = e.positions[t], o = e.positions[n];
	return i ? i(a, o) : r(a, o) ? [a, o] : null;
}
function Jo(e, t) {
	let n = /* @__PURE__ */ new Set([0, e.positions.length - 1]);
	for (let r = 0; r + 1 < e.nodeIds.length; r++) t.findEdge(e.nodeIds[r], e.nodeIds[r + 1])?.kind === "vertical" && (n.add(r + 1), n.add(r + 2));
	return Array.from(n).sort((e, t) => e - t);
}
function Yo(e, t, n, r, i, a) {
	let o = t + 1, s = [e.positions[t], e.positions[o]], c = t + 2, l = n;
	for (; c <= l;) {
		let n = Math.floor((c + l) / 2), u = qo(e, t, n, i, a), d = u && Ko(e.positions, t, n, u, r);
		u && d ? (o = n, s = u, c = n + 1) : l = n - 1;
	}
	return {
		next: o,
		nextPositions: s
	};
}
function Xo(e, t, n, r, i, a) {
	let o = [], s = t;
	for (; s < n;) {
		let t = Yo(e, s, n, r, i, a);
		o.push(...t.nextPositions.slice(1).map((e) => e.clone())), s = t.next;
	}
	return o;
}
function Zo(e) {
	let t = 0;
	for (let n = 1; n < e.length; n++) t += e[n - 1].distanceTo(e[n]);
	return t;
}
function Qo(e, t, n, r, i) {
	if (e.positions.length <= 2 || n <= 0) return e;
	let a = Jo(e, t), o = [e.positions[0].clone()];
	for (let t = 1; t < a.length; t++) {
		let s = a[t];
		o.push(...Xo(e, a[t - 1], s, n, r, i));
	}
	let s = Zo(o);
	return s > e.distance * 1.05 ? e : {
		...e,
		positions: o,
		distance: s
	};
}
function $o(e, t, n) {
	return new ts(e, t, n).sharesComponent();
}
var es = class e {
	constructor({ graph: t, start: n, end: r }) {
		this.open = new Uo(e.compareEntries), this.costs = /* @__PURE__ */ new Map(), this.previous = /* @__PURE__ */ new Map(), this.destinationId = null, this.destinationCost = Infinity, this.graph = t, this.start = n, this.end = r, this.endConnections = new Map(r.connections.map((e) => [e.nodeId, e.distance]));
	}
	findRoute() {
		if (this.initializeFromStartConnections(), this.search(), !this.destinationId) return null;
		let e = this.buildNodePath(this.destinationId);
		return {
			nodeIds: e,
			positions: [
				this.start.position.clone(),
				...e.map((e) => this.graph.requireNode(e).position.clone()),
				this.end.position.clone()
			],
			distance: this.destinationCost
		};
	}
	initializeFromStartConnections() {
		for (let e of this.start.connections) {
			let t = this.graph.nodes.get(e.nodeId);
			t?.accessible && t.positionValid && (this.costs.set(t.id, e.distance), this.open.push({
				nodeId: t.id,
				cost: e.distance,
				score: this.calculateScore(e.distance, t.position)
			}));
		}
	}
	search() {
		for (; this.open.size > 0;) {
			let e = this.open.pop();
			e && e.cost === this.costs.get(e.nodeId) && this.visitEntry(e);
		}
	}
	visitEntry(e) {
		let t = this.graph.requireNode(e.nodeId), n = this.endConnections.get(e.nodeId);
		if (n !== void 0 && e.cost + n < this.destinationCost && (this.destinationId = e.nodeId, this.destinationCost = e.cost + n), !(e.cost + t.position.distanceTo(this.end.position) >= this.destinationCost)) for (let n of t.edgeIds) this.visitEdge(e, n);
	}
	visitEdge(e, t) {
		let n = this.graph.requireEdge(t);
		if (!n.accessible || !n.geometryValid) return;
		let r = this.getTraversableNeighbor(n, e.nodeId);
		if (!r) return;
		let i = this.graph.requireNode(e.nodeId), a = this.graph.requireNode(r);
		if (!a.accessible || !a.positionValid) return;
		let o = e.cost + i.position.distanceTo(a.position);
		o >= (this.costs.get(r) ?? Infinity) || (this.costs.set(r, o), this.previous.set(r, e.nodeId), this.open.push({
			nodeId: r,
			cost: o,
			score: this.calculateScore(o, a.position)
		}));
	}
	getTraversableNeighbor(e, t) {
		return e.fromNodeId === t ? e.toNodeId : e.direction === "both" && e.toNodeId === t ? e.fromNodeId : null;
	}
	buildNodePath(e) {
		let t = [e], n = e, r = this.previous.get(n);
		for (; r !== void 0;) n = r, t.push(n), r = this.previous.get(n);
		return t.reverse(), t;
	}
	calculateScore(e, t) {
		return e + t.distanceTo(this.end.position);
	}
	static compareEntries(e, t) {
		let n = e.score - t.score;
		return n === 0 ? e.nodeId.localeCompare(t.nodeId) : n;
	}
}, ts = class {
	constructor(e, t, n) {
		this.graph = e, this.visited = /* @__PURE__ */ new Set(), this.pending = Array.from(t), this.endIds = new Set(n);
	}
	sharesComponent() {
		for (; this.pending.length > 0;) {
			let e = this.pending.pop();
			if (e === void 0 || this.visited.has(e)) continue;
			let t = this.graph.nodes.get(e);
			if (t?.accessible && t.positionValid) {
				if (this.endIds.has(e)) return !0;
				this.visited.add(e), this.enqueueConnectedNeighbors(e, t.edgeIds);
			}
		}
		return !1;
	}
	enqueueConnectedNeighbors(e, t) {
		for (let n of t) {
			let t = this.graph.edges.get(n);
			if (!t?.accessible || !t.geometryValid) continue;
			let r = t.fromNodeId === e ? t.toNodeId : t.fromNodeId, i = this.graph.nodes.get(r);
			i?.accessible && i.positionValid && !this.visited.has(r) && this.pending.push(r);
		}
	}
}, ns = .3, rs = class {
	constructor(e, t, n, r, i = () => .05) {
		this.viewer = e, this.graphController = t, this.pathController = n, this.getMaximumConnectionDistance = r, this.getSimplificationTolerance = i, this.signals = { onChanged: new T() }, this.points = {
			start: null,
			end: null
		}, this.route = null, this.displayedPath = null, this.calculationError = null, this.graphError = "missing-graph", this.pointsConnected = !1, this.routingError = "missing-graph", this.refreshConnections = () => {
			this.startPoint && this.connectPoint(this.startPoint), this.endPoint && this.connectPoint(this.endPoint), this.resetRoute(), this.updatePointRoutingState(), this.emitChanged(["start", "end"]);
		}, this.onGraphChanged = (e) => {
			e?.transient || (this.updateGraphError(), this.refreshConnections());
		}, this.graphController.signals.onGraphChanged.connect(this.onGraphChanged);
	}
	get startPoint() {
		return this.points.start;
	}
	get endPoint() {
		return this.points.end;
	}
	get activeRoute() {
		return this.route;
	}
	get error() {
		return this.routingError;
	}
	setPoint(e, t, n = !0) {
		this.resetRoute();
		let r = this.points[e];
		if (r) r.position.copy(t), n ? this.connectPoint(r) : (r.connections = [], r.rejectedConnection = null);
		else {
			let r = {
				position: t.clone(),
				connections: [],
				rejectedConnection: null
			};
			this.points[e] = r, n && this.connectPoint(r);
		}
		this.updatePointRoutingState(), this.emitChanged([e]);
	}
	reconnectPoint(e) {
		let t = this.points[e];
		t && (this.connectPoint(t), this.updatePointRoutingState(), this.emitChanged([e]));
	}
	removePoint(e) {
		this.points[e] && (this.points[e] = null, this.resetRoute(), this.updatePointRoutingState(), this.emitChanged([e]));
	}
	clearPoints() {
		this.points.start = null, this.points.end = null, this.resetRoute(), this.updatePointRoutingState(), this.emitChanged(["start", "end"]);
	}
	calculateRoute() {
		if (this.calculationError = null, this.updateRoutingError(), this.routingError) return null;
		let e = Wo({
			graph: this.graphController.activeGraph,
			start: this.startPoint,
			end: this.endPoint
		});
		return e ? (this.route = Qo(e, this.graphController.activeGraph, this.getSimplificationTolerance(), (e, t) => this.graphController.validator.validateSegment(e, t), (e, t) => this.graphController.validator.traceSurfaceSegment(e, t)), this.updateRoutingError(), this.emitChanged(), this.route) : (this.calculationError = "no-route", this.updateRoutingError(), this.emitChanged(), null);
	}
	restoreRoute(e) {
		this.route = e, this.calculationError = null, this.updateRoutingError(), this.emitChanged();
	}
	setDisplayedPath(e) {
		this.removeDisplayedPath(), this.displayedPath = e;
	}
	clearRoute() {
		this.resetRoute(), this.updateRoutingError(), this.emitChanged();
	}
	resetRoute() {
		this.route = null, this.calculationError = null, this.removeDisplayedPath();
	}
	dispose() {
		this.graphController.signals.onGraphChanged.disconnect(this.onGraphChanged), this.clearPoints();
	}
	connectPoint(e) {
		let t = this.graphController.activeGraph;
		if (e.connections = [], e.rejectedConnection = null, !t) return;
		let n = this.getMaximumConnectionDistance(), r = Array.from(t.nodes.values()).filter((t) => !t.accessible || !t.positionValid ? !1 : Math.hypot(e.position.x - t.position.x, e.position.z - t.position.z) <= n), i = r.reduce((t, n) => Math.min(t, Math.abs(e.position.y - n.position.y)), Infinity);
		if (i > ns) return;
		let a = [], o = null;
		for (let t of r) {
			if (Math.abs(e.position.y - t.position.y) > i + ns) continue;
			let n = e.position.distanceTo(t.position), r = {
				nodeId: t.id,
				distance: n
			};
			this.graphController.validator.validateSegment(e.position, t.position) ? a.push(r) : (!o || n < o.distance) && (o = r);
		}
		e.connections = a, e.rejectedConnection = o;
	}
	removeDisplayedPath() {
		this.displayedPath &&= (this.pathController.hasObjectUUID(this.displayedPath.uuid) && this.pathController.clear(this.displayedPath), null);
	}
	updateGraphError() {
		let e = this.graphController.activeGraph;
		if (!e) {
			this.graphError = "missing-graph";
			return;
		}
		this.graphError = e.validate().length > 0 ? "invalid-graph" : null;
	}
	updateRoutingError() {
		if (this.graphError) {
			this.routingError = this.graphError;
			return;
		}
		if (!this.startPoint) {
			this.routingError = "missing-start";
			return;
		}
		if (!this.endPoint) {
			this.routingError = "missing-end";
			return;
		}
		if (this.startPoint.connections.length === 0) {
			this.routingError = "unconnected-start";
			return;
		}
		if (this.endPoint.connections.length === 0) {
			this.routingError = "unconnected-end";
			return;
		}
		this.routingError = this.pointsConnected ? this.calculationError : "disconnected-components";
	}
	updatePointRoutingState() {
		let e = this.graphController.activeGraph, t = this.startPoint, n = this.endPoint;
		this.pointsConnected = !!e && !!t && !!n && t.connections.length > 0 && n.connections.length > 0 && $o(e, t.connections.map(is), n.connections.map(is)), this.updateRoutingError();
	}
	emitChanged(e) {
		this.signals.onChanged.emit({ pointTypes: e ?? [] }), this.viewer.requestRender();
	}
};
function is(e) {
	return e.nodeId;
}
//#endregion
//#region src/PathPlugin/routing/NavigationRoutingSceneController.ts
var as = 2e4, os = "#42a5f5", ss = "#3949ab", cs = 13840175, ls = /* @__PURE__ */ new lt(.14, 12, 8), us = /* @__PURE__ */ new Re(1, 1, 1, 8), ds = class extends le {
	constructor(e, t, n) {
		super(e), this.routingController = t, this.graphController = n, this.pointContainer = Za(ls, 2), this.connectionContainer = Za(us, as), this.pointObjects = {
			start: null,
			end: null
		}, this.connectionProxies = {
			start: [],
			end: []
		}, this.synchronize = (e) => {
			let t = e?.pointTypes ?? ["start", "end"];
			for (let e of t) {
				let t = e === "start" ? this.routingController.startPoint : this.routingController.endPoint;
				this.synchronizePoint(e, t);
			}
			this._viewer.requestRender();
		}, this.attachContainers = () => {
			this._viewer.scene.addInternalObject(this.pointContainer.root), this._viewer.scene.addInternalObject(this.connectionContainer.root);
		}, this.pointContainer.root.name = "NavigationRoutePoints", this.connectionContainer.root.name = "NavigationRouteConnections";
	}
	onSceneSetup(e) {
		this.routingController.signals.onChanged.connect(this.synchronize), this.attachContainers(), this._viewer.signals.onSceneClear.connect(this.attachContainers), this.synchronize();
	}
	onSceneClear(e) {
		this.routingController.signals.onChanged.disconnect(this.synchronize), this._viewer.signals.onSceneClear.disconnect(this.attachContainers), e.removeInternalObject(this.pointContainer.root), e.removeInternalObject(this.connectionContainer.root);
	}
	accepts(e) {
		return e.isNavigationRoutingObject;
	}
	*meshContainers() {
		yield this.pointContainer, yield this.connectionContainer;
	}
	*lineContainers() {}
	*edgesContainers() {}
	addObject(e) {
		super.addObject(e, null), this._viewer.scene.addObjectIntoBoxTree(e);
	}
	removeObject(e) {
		this._viewer.scene.isObjectInBoxTree(e) && this._viewer.scene.removeObjectFromBoxTree(e), this.pointContainer.removeInstance(e.meshProxy), super.removeObject(e);
	}
	clear() {
		for (let e of Array.from(this._objects.values())) this.removeObject(e);
		for (let e of ["start", "end"]) {
			for (let t of this.connectionProxies[e]) this.connectionContainer.removeInstance(t);
			this.connectionProxies[e].length = 0;
		}
		this.pointObjects.start = null, this.pointObjects.end = null;
	}
	dispose() {
		this.routingController.signals.onChanged.disconnect(this.synchronize), this._viewer.signals.onSceneClear.disconnect(this.attachContainers), this.clear(), Qa(this.pointContainer), Qa(this.connectionContainer), super.dispose();
	}
	synchronizePoint(e, t) {
		if (!t) {
			this.removePoint(e);
			return;
		}
		let n = this.pointObjects[e];
		if (!n) {
			this.addPoint(e, t);
			return;
		}
		$a(n, t.position, ro), this._viewer.scene.updateObjectInBoxTree(n), this.synchronizeConnections(e, t);
	}
	removePoint(e) {
		let t = this.pointObjects[e];
		t && (this.removeObject(t), this.pointObjects[e] = null), this.removeConnections(e);
	}
	removeConnections(e) {
		for (let t of this.connectionProxies[e]) this.connectionContainer.removeInstance(t);
		this.connectionProxies[e].length = 0;
	}
	addPoint(e, t) {
		let n = new _(this.pointContainer, -1, ls.uuid), r = new ba(n, e), i = e === "start" ? os : ss;
		this.pointContainer.addInstance(n), $a(r, t.position, ro), r.diffuseColor = i, r.isRaycastable = !0, this.pointObjects[e] = r, this.addObject(r), this.synchronizeConnections(e, t);
	}
	synchronizeConnections(e, t) {
		this.removeConnections(e);
		let n = this.graphController.activeGraph;
		if (!n) return;
		let r = e === "start" ? os : ss;
		for (let i of t.connections) {
			let a = n.nodes.get(i.nodeId);
			a && this.addConnection(e, t.position, a.position, r);
		}
		if (t.connections.length === 0 && t.rejectedConnection) {
			let r = n.nodes.get(t.rejectedConnection.nodeId);
			r && this.addConnection(e, t.position, r.position, cs);
		}
	}
	addConnection(e, t, n, r) {
		let i = new _(this.connectionContainer, -1, us.uuid);
		this.connectionContainer.addInstance(i), eo(i, t, n, .025, ro), i.setDiffuseColor(r), this.connectionProxies[e].push(i);
	}
}, fs = 402653184, ps = 3 * Int32Array.BYTES_PER_ELEMENT + 4 * Uint8Array.BYTES_PER_ELEMENT + Float32Array.BYTES_PER_ELEMENT + Int32Array.BYTES_PER_ELEMENT;
function ms(e) {
	let t = e.voxelCount * ps;
	if (t > fs) return null;
	let n;
	try {
		n = new SharedArrayBuffer(t);
	} catch {
		return null;
	}
	let r = new Int32Array(n, 0, e.voxelCount * 3), i = new Float32Array(n, r.byteLength, e.voxelCount);
	i.fill(NaN);
	let a = new Int32Array(n, r.byteLength + i.byteLength, e.voxelCount);
	a.fill(-1);
	let o = new Uint8Array(n, a.byteOffset + a.byteLength, e.voxelCount), s = new Uint8Array(n, o.byteOffset + o.byteLength, e.voxelCount), c = new Uint8Array(n, s.byteOffset + s.byteLength, e.voxelCount), l = new Uint8Array(n, c.byteOffset + c.byteLength, e.voxelCount), u = 0;
	for (let t of e.chunks) r.set(t.coordinates, u * 3), o.set(t.levels, u), s.set(t.states, u), t.verticalConnections && c.set(t.verticalConnections, u), t.supportHeights && i.set(t.supportHeights, u), t.supportIds && a.set(t.supportIds, u), t.horizontalConnections && l.set(t.horizontalConnections, u), u += t.states.length;
	return {
		isPacked: !0,
		version: e.version,
		origin: e.origin,
		gridBounds: e.gridBounds,
		granularities: e.granularities,
		voxelCount: e.voxelCount,
		solidVoxelCount: e.solidVoxelCount,
		emptyVoxelCount: e.emptyVoxelCount,
		coordinates: r,
		levels: o,
		states: s,
		verticalConnections: c,
		horizontalConnections: l,
		supportHeights: i,
		supportIds: a
	};
}
//#endregion
//#region src/PathPlugin/voxelization/VoxelizationTypes.ts
var hs = /* @__PURE__ */ function(e) {
	return e[e.Unclassified = 0] = "Unclassified", e[e.Solid = 1] = "Solid", e[e.Navigable = 2] = "Navigable", e;
}({}), gs = {
	granularities: [.4, .2],
	boxTreeLevel: 32,
	workerCount: 8,
	includedObjectTypes: [],
	excludedObjectTypes: [
		"IfcSpace",
		"IfcZone",
		"IfcAnnotation",
		"IfcGrid"
	],
	passableObjectTypes: [
		"IfcDoor",
		"IfcStair",
		"IfcStairFlight"
	],
	verticalConnectionObjectTypes: [
		"IfcStair",
		"IfcStairFlight",
		"IfcRamp",
		"IfcRampFlight"
	],
	maxVoxelCount: 1e8
};
//#endregion
//#region src/PathPlugin/voxelization/VoxelGrid.ts
function _s(e, t, n) {
	if (e.length !== t) throw Error(n);
}
function vs(e, t, n) {
	if (e && e.length !== t) throw Error(`Voxel chunk ${n} and states must have the same length.`);
}
function ys(e) {
	_s(e.rootCoordinates, 3, "Voxel chunk rootCoordinates must contain 3 values."), _s(e.bounds, 6, "Voxel chunk bounds must contain 6 values.");
	let t = e.states.length;
	return _s(e.levels, t, "Voxel chunk levels and states must have the same length."), vs(e.verticalConnections, t, "verticalConnections"), vs(e.horizontalConnections, t, "horizontalConnections"), vs(e.supportHeights, t, "supportHeights"), vs(e.supportIds, t, "supportIds"), _s(e.coordinates, t * 3, "Voxel chunk coordinates must contain 3 values per state."), t;
}
var bs = class e {
	constructor(t) {
		if (this.version = 1, this.currentClassification = null, e.validate(t), this.origin = t.origin, this.gridBounds = t.gridBounds, this.granularities = t.granularities, this.packedSnapshot = ms(t), this.packedSnapshot === null) this.chunks = t.chunks;
		else {
			let e = 0, n = this.packedSnapshot;
			this.chunks = t.chunks.map((t) => {
				let r = e;
				return e += t.states.length, {
					rootCoordinates: t.rootCoordinates,
					bounds: t.bounds,
					coordinates: n.coordinates.subarray(r * 3, e * 3),
					levels: n.levels.subarray(r, e),
					states: n.states.subarray(r, e),
					verticalConnections: n.verticalConnections.subarray(r, e),
					horizontalConnections: n.horizontalConnections.subarray(r, e),
					supportHeights: n.supportHeights.subarray(r, e),
					supportIds: n.supportIds.subarray(r, e)
				};
			});
		}
		this.voxelCount = t.voxelCount, this.solidVoxelCount = t.solidVoxelCount, this.emptyVoxelCount = t.emptyVoxelCount;
	}
	get classification() {
		return this.currentClassification;
	}
	applyClassification(e) {
		if (e.componentIds.length !== this.voxelCount) throw Error("Voxel classification componentIds must match the grid voxel count.");
		let t = 0;
		for (let n of this.chunks) for (let r = 0; r < n.states.length; r++, t++) n.states[r] !== hs.Solid && (n.states[r] = e.componentIds[t] >= 0 ? hs.Navigable : hs.Unclassified);
		this.currentClassification = e;
	}
	clearClassification() {
		if (this.currentClassification !== null) {
			for (let e of this.chunks) for (let t = 0; t < e.states.length; t++) e.states[t] === hs.Navigable && (e.states[t] = hs.Unclassified);
			this.currentClassification = null;
		}
	}
	get snapshot() {
		return {
			version: this.version,
			origin: this.origin,
			gridBounds: this.gridBounds,
			granularities: this.granularities,
			chunks: [...this.chunks],
			voxelCount: this.voxelCount,
			solidVoxelCount: this.solidVoxelCount,
			emptyVoxelCount: this.emptyVoxelCount
		};
	}
	static validate(e) {
		if (_s(e.origin, 3, "VoxelGrid origin must contain 3 values."), _s(e.gridBounds, 6, "VoxelGrid gridBounds must contain 6 values."), e.granularities.length === 0) throw Error("VoxelGrid must contain at least one granularity.");
		let t = 0;
		for (let n of e.chunks) t += ys(n);
		if (e.voxelCount !== t) throw Error("VoxelGrid voxelCount does not match its chunks.");
		if (e.voxelCount !== e.solidVoxelCount + e.emptyVoxelCount) throw Error("VoxelGrid state counts do not match voxelCount.");
	}
	*voxels() {
		for (let e of this.chunks) for (let t = 0; t < e.levels.length; t++) {
			let n = this.granularities[e.levels[t]];
			yield {
				x: e.coordinates[t * 3],
				y: e.coordinates[t * 3 + 1],
				z: e.coordinates[t * 3 + 2],
				level: e.levels[t],
				size: n,
				state: e.states[t],
				verticalConnectionAllowed: e.verticalConnections?.[t] === 1,
				supportHeight: e.supportHeights?.[t] ?? NaN,
				supportId: e.supportIds?.[t] ?? -1
			};
		}
	}
};
//#endregion
//#region src/PathPlugin/voxelization/SharedBufferUtils.ts
function xs(e) {
	if (!Array.isArray(e) && e.buffer[Symbol.toStringTag] === "SharedArrayBuffer") return e;
	let t = new Float32Array(new SharedArrayBuffer(e.length * Float32Array.BYTES_PER_ELEMENT));
	return t.set(e), t;
}
function Ss(e) {
	if (e.buffer[Symbol.toStringTag] === "SharedArrayBuffer") return e;
	if (e[Symbol.toStringTag] === "Uint16Array") {
		let t = new Uint16Array(new SharedArrayBuffer(e.length * Uint16Array.BYTES_PER_ELEMENT));
		return t.set(e), t;
	}
	let t = new Uint32Array(new SharedArrayBuffer(e.length * Uint32Array.BYTES_PER_ELEMENT));
	return t.set(e), t;
}
function Cs(e) {
	if (e[Symbol.toStringTag] === "SharedArrayBuffer") return e;
	let t = new SharedArrayBuffer(e.byteLength);
	return new Uint8Array(t).set(new Uint8Array(e)), t;
}
//#endregion
//#region src/PathPlugin/voxelization/geometry/VoxelizationGeometrySerialization.ts
function ws(e) {
	let t = _t.serialize(e, { cloneBuffers: !1 });
	return {
		...t,
		roots: t.roots.map(Cs),
		index: t.index === null ? null : Ss(t.index),
		indirectBuffer: t.indirectBuffer ? Ss(t.indirectBuffer) : t.indirectBuffer
	};
}
function Ts(e, t) {
	let n = e.geometry.getAttribute("position"), r = e.geometry.getIndex();
	if (n.array[Symbol.toStringTag] !== "Float32Array") throw Error("Voxelization only supports Float32 position buffers.");
	return {
		positions: xs(n.array),
		index: r ? Ss(r.array) : null,
		bvh: ws(t)
	};
}
//#endregion
//#region src/PathPlugin/voxelization/geometry/SceneGeometryExtractor.ts
var Es = /* @__PURE__ */ new je(), Ds = /* @__PURE__ */ new O();
function Os(e, t, n) {
	return e === null ? t.size === 0 : Ta(e, n) ? !1 : t.size === 0 || Ta(e, t);
}
function* ks(e) {
	for (let t of e) t.active && ("isSceneMeshProxy" in t ? yield t : "isSceneMeshGroup" in t && (yield* ks(t.meshes)));
}
function As(e) {
	if (e.isEmpty()) throw Error("The scene does not contain voxelizable geometry.");
	return new Float64Array([
		e.min.x,
		e.min.y,
		e.min.z,
		e.max.x,
		e.max.y,
		e.max.z
	]);
}
function js(e, t, n, r) {
	let i = r.get(e.srcGeometryUuid);
	if (i !== void 0) return i;
	let a = n.length;
	return n.push(Ts(e, t)), r.set(e.srcGeometryUuid, a), a;
}
function Ms(e, t) {
	let n = [], r = [], i = [], a = /* @__PURE__ */ new Map(), o = new je(), s = wa(t.includedObjectTypes), c = wa(t.excludedObjectTypes), l = wa(t.passableObjectTypes), u = wa(t.verticalConnectionObjectTypes), d = 0, f = 0;
	for (let t of e.scene.bimMeshController.getAllObjects()) {
		d++;
		let e = Ca(t);
		e !== null && f++;
		let p = Os(e, s, c), m = Ta(e, l);
		if (!p && !m) continue;
		let h = Ta(e, u), g = !m || h;
		for (let e of ks(t.getSubMeshes())) {
			let s = e.meshProxy, c = s.getGeometryBVH();
			if (!c) continue;
			e.getBoundingBox(Es), g && o.union(Es);
			let l = js(s, c, n, a);
			e.getMatrix(Ds), Ds.invert();
			let u = i.length;
			i.push(...Ds.elements), r.push({
				objectUuid: t.uuid,
				geometryIndex: l,
				matrixOffset: u,
				verticalConnectionAllowed: h,
				occupancyBlocking: g
			});
		}
	}
	return {
		geometries: n,
		instances: r,
		inverseInstanceMatrices: xs(i),
		bounds: o,
		inspectedObjectCount: d,
		objectWithTypeCount: f
	};
}
function Ns(e, t) {
	let { bounds: n, geometries: r, inspectedObjectCount: i, instances: a, inverseInstanceMatrices: o, objectWithTypeCount: s } = Ms(e, t);
	if (a.length === 0) throw Error("No scene geometry matches the voxelization filters.");
	return {
		snapshot: {
			sceneBounds: As(n),
			boxTree: e.scene.getBoxTreeSnapshot(),
			geometries: r,
			instances: a,
			inverseInstanceMatrices: o
		},
		statistics: {
			inspectedObjectCount: i,
			objectWithTypeCount: s
		}
	};
}
//#endregion
//#region src/PathPlugin/voxelization/VoxelizationOptions.ts
var Ps = 1e-9;
function Fs(e) {
	let { granularities: t } = e;
	if (t.length === 0) throw Error("At least one granularity is required.");
	if (t.some((e) => !Number.isFinite(e) || e <= 0)) throw Error("Granularities must be finite positive numbers.");
	for (let e = 1; e < t.length; e++) {
		let n = t[e - 1], r = t[e];
		if (r >= n) throw Error("Granularities must be strictly decreasing.");
		let i = n / r;
		if (Math.abs(i - Math.round(i)) > Ps) throw Error(`Granularity ${n} must be exactly divisible by ${r}.`);
	}
	if (!Number.isInteger(e.boxTreeLevel) || e.boxTreeLevel < 0) throw Error("The BoxTree level must be a positive integer.");
	if (!Number.isInteger(e.workerCount) || e.workerCount <= 0 || e.workerCount > 32) throw Error("The worker count must be an integer between 1 and 32.");
	if (!Number.isInteger(e.maxVoxelCount) || e.maxVoxelCount <= 0) throw Error("The maximum voxel count must be a positive integer.");
}
function Is(e, t) {
	return new Float64Array([
		Math.floor(e[0] / t + Ps) * t,
		Math.floor(e[1] / t + Ps) * t,
		Math.floor(e[2] / t + Ps) * t,
		Math.ceil(e[3] / t - Ps) * t,
		Math.ceil(e[4] / t - Ps) * t,
		Math.ceil(e[5] / t - Ps) * t
	]);
}
//#endregion
//#region src/PathPlugin/voxelization/worker/VoxelizationWorker.ts?worker&inline
var Ls = "(function(){\n/**\n* @license\n* Copyright 2010-2026 Three.js Authors\n* SPDX-License-Identifier: MIT\n*/\nlet e=1e3,t=1001,n=1002,r=2300,i=2301,a=2302,o=2303,s=2400,c=2401,l=2402,u=`srgb`,d=`srgb-linear`,f=`linear`,p=2e3;function m(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function h(e){return ArrayBuffer.isView(e)&&!(e instanceof DataView)}function g(e){return document.createElementNS(`http://www.w3.org/1999/xhtml`,e)}let _={};function v(e){let t=e[0];if(typeof t==`string`&&t.startsWith(`TSL:`)){let t=e[1];t&&t.isStackTrace?e[0]+=` `+t.getLocation():e[1]=`Stack trace not available. Enable \"THREE.Node.captureStackTrace\" to capture stack traces.`}return e}function y(...e){e=v(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.warn(n.getError(t)):console.warn(t,...e)}}function b(...e){e=v(e);let t=`THREE.`+e.shift();{let n=e[0];n&&n.isStackTrace?console.error(n.getError(t)):console.error(t,...e)}}function x(...e){let t=e.join(` `);t in _||(_[t]=!0,y(...e))}var S=class{addEventListener(e,t){this._listeners===void 0&&(this._listeners={});let n=this._listeners;n[e]===void 0&&(n[e]=[]),n[e].indexOf(t)===-1&&n[e].push(t)}hasEventListener(e,t){let n=this._listeners;return n!==void 0&&n[e]!==void 0&&n[e].indexOf(t)!==-1}removeEventListener(e,t){let n=this._listeners;if(n===void 0)return;let r=n[e];if(r!==void 0){let e=r.indexOf(t);e!==-1&&r.splice(e,1)}}dispatchEvent(e){let t=this._listeners;if(t===void 0)return;let n=t[e.type];if(n!==void 0){e.target=this;let t=n.slice(0);for(let n=0,r=t.length;n<r;n++)t[n].call(this,e);e.target=null}}};let C=/* @__PURE__ */ `00.01.02.03.04.05.06.07.08.09.0a.0b.0c.0d.0e.0f.10.11.12.13.14.15.16.17.18.19.1a.1b.1c.1d.1e.1f.20.21.22.23.24.25.26.27.28.29.2a.2b.2c.2d.2e.2f.30.31.32.33.34.35.36.37.38.39.3a.3b.3c.3d.3e.3f.40.41.42.43.44.45.46.47.48.49.4a.4b.4c.4d.4e.4f.50.51.52.53.54.55.56.57.58.59.5a.5b.5c.5d.5e.5f.60.61.62.63.64.65.66.67.68.69.6a.6b.6c.6d.6e.6f.70.71.72.73.74.75.76.77.78.79.7a.7b.7c.7d.7e.7f.80.81.82.83.84.85.86.87.88.89.8a.8b.8c.8d.8e.8f.90.91.92.93.94.95.96.97.98.99.9a.9b.9c.9d.9e.9f.a0.a1.a2.a3.a4.a5.a6.a7.a8.a9.aa.ab.ac.ad.ae.af.b0.b1.b2.b3.b4.b5.b6.b7.b8.b9.ba.bb.bc.bd.be.bf.c0.c1.c2.c3.c4.c5.c6.c7.c8.c9.ca.cb.cc.cd.ce.cf.d0.d1.d2.d3.d4.d5.d6.d7.d8.d9.da.db.dc.dd.de.df.e0.e1.e2.e3.e4.e5.e6.e7.e8.e9.ea.eb.ec.ed.ee.ef.f0.f1.f2.f3.f4.f5.f6.f7.f8.f9.fa.fb.fc.fd.fe.ff`.split(`.`);function w(){let e=Math.random()*4294967295|0,t=Math.random()*4294967295|0,n=Math.random()*4294967295|0,r=Math.random()*4294967295|0;return(C[e&255]+C[e>>8&255]+C[e>>16&255]+C[e>>24&255]+`-`+C[t&255]+C[t>>8&255]+`-`+C[t>>16&15|64]+C[t>>24&255]+`-`+C[n&63|128]+C[n>>8&255]+`-`+C[n>>16&255]+C[n>>24&255]+C[r&255]+C[r>>8&255]+C[r>>16&255]+C[r>>24&255]).toLowerCase()}function T(e,t,n){return Math.max(t,Math.min(n,e))}function E(e,t){return(e%t+t)%t}function D(e,t,n){return(1-n)*e+n*t}function O(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:case Uint8ClampedArray:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}function k(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(e*4294967295);case Uint16Array:return Math.round(e*65535);case Uint8Array:case Uint8ClampedArray:return Math.round(e*255);case Int32Array:return Math.round(e*2147483647);case Int16Array:return Math.round(e*32767);case Int8Array:return Math.round(e*127);default:throw Error(`THREE.MathUtils: Invalid component type.`)}}var A=class e{static{e.prototype.isVector2=!0}constructor(e=0,t=0){this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw Error(`THREE.Vector2: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw Error(`THREE.Vector2: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){let t=this.x,n=this.y,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6],this.y=r[1]*t+r[4]*n+r[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=T(this.x,e.x,t.x),this.y=T(this.y,e.y,t.y),this}clampScalar(e,t){return this.x=T(this.x,e,t),this.y=T(this.y,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(T(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(T(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){let n=Math.cos(t),r=Math.sin(t),i=this.x-e.x,a=this.y-e.y;return this.x=i*n-a*r+e.x,this.y=i*r+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}},j=class{constructor(e=0,t=0,n=0,r=1){this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=r}static slerpFlat(e,t,n,r,i,a,o){let s=n[r+0],c=n[r+1],l=n[r+2],u=n[r+3],d=i[a+0],f=i[a+1],p=i[a+2],m=i[a+3];if(u!==m||s!==d||c!==f||l!==p){let e=s*d+c*f+l*p+u*m;e<0&&(d=-d,f=-f,p=-p,m=-m,e=-e);let t=1-o;if(e<.9995){let n=Math.acos(e),r=Math.sin(n);t=Math.sin(t*n)/r,o=Math.sin(o*n)/r,s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o}else{s=s*t+d*o,c=c*t+f*o,l=l*t+p*o,u=u*t+m*o;let e=1/Math.sqrt(s*s+c*c+l*l+u*u);s*=e,c*=e,l*=e,u*=e}}e[t]=s,e[t+1]=c,e[t+2]=l,e[t+3]=u}static multiplyQuaternionsFlat(e,t,n,r,i,a){let o=n[r],s=n[r+1],c=n[r+2],l=n[r+3],u=i[a],d=i[a+1],f=i[a+2],p=i[a+3];return e[t]=o*p+l*u+s*f-c*d,e[t+1]=s*p+l*d+c*u-o*f,e[t+2]=c*p+l*f+o*d-s*u,e[t+3]=l*p-o*u-s*d-c*f,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,r){return this._x=e,this._y=t,this._z=n,this._w=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t=!0){let n=e._x,r=e._y,i=e._z,a=e._order,o=Math.cos,s=Math.sin,c=o(n/2),l=o(r/2),u=o(i/2),d=s(n/2),f=s(r/2),p=s(i/2);switch(a){case`XYZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`YXZ`:this._x=d*l*u+c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`ZXY`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u-d*f*p;break;case`ZYX`:this._x=d*l*u-c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u+d*f*p;break;case`YZX`:this._x=d*l*u+c*f*p,this._y=c*f*u+d*l*p,this._z=c*l*p-d*f*u,this._w=c*l*u-d*f*p;break;case`XZY`:this._x=d*l*u-c*f*p,this._y=c*f*u-d*l*p,this._z=c*l*p+d*f*u,this._w=c*l*u+d*f*p;break;default:y(`Quaternion: .setFromEuler() encountered an unknown order: `+a)}return t===!0&&this._onChangeCallback(),this}setFromAxisAngle(e,t){let n=t/2,r=Math.sin(n);return this._x=e.x*r,this._y=e.y*r,this._z=e.z*r,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){let t=e.elements,n=t[0],r=t[4],i=t[8],a=t[1],o=t[5],s=t[9],c=t[2],l=t[6],u=t[10],d=n+o+u;if(d>0){let e=.5/Math.sqrt(d+1);this._w=.25/e,this._x=(l-s)*e,this._y=(i-c)*e,this._z=(a-r)*e}else if(n>o&&n>u){let e=2*Math.sqrt(1+n-o-u);this._w=(l-s)/e,this._x=.25*e,this._y=(r+a)/e,this._z=(i+c)/e}else if(o>u){let e=2*Math.sqrt(1+o-n-u);this._w=(i-c)/e,this._x=(r+a)/e,this._y=.25*e,this._z=(s+l)/e}else{let e=2*Math.sqrt(1+u-n-o);this._w=(a-r)/e,this._x=(i+c)/e,this._y=(s+l)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<1e-8?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(T(this.dot(e),-1,1)))}rotateTowards(e,t){let n=this.angleTo(e);if(n===0)return this;let r=Math.min(1,t/n);return this.slerp(e,r),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return e===0?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x*=e,this._y*=e,this._z*=e,this._w*=e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=t._x,s=t._y,c=t._z,l=t._w;return this._x=n*l+a*o+r*c-i*s,this._y=r*l+a*s+i*o-n*c,this._z=i*l+a*c+n*s-r*o,this._w=a*l-n*o-r*s-i*c,this._onChangeCallback(),this}slerp(e,t){let n=e._x,r=e._y,i=e._z,a=e._w,o=this.dot(e);o<0&&(n=-n,r=-r,i=-i,a=-a,o=-o);let s=1-t;if(o<.9995){let e=Math.acos(o),c=Math.sin(e);s=Math.sin(s*e)/c,t=Math.sin(t*e)/c,this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this._onChangeCallback()}else this._x=this._x*s+n*t,this._y=this._y*s+r*t,this._z=this._z*s+i*t,this._w=this._w*s+a*t,this.normalize();return this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){let e=2*Math.PI*Math.random(),t=2*Math.PI*Math.random(),n=Math.random(),r=Math.sqrt(1-n),i=Math.sqrt(n);return this.set(r*Math.sin(e),r*Math.cos(e),i*Math.sin(t),i*Math.cos(t))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e,t=0){return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this._onChangeCallback(),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}},M=class e{static{e.prototype.isVector3=!0}constructor(e=0,t=0,n=0){this.x=e,this.y=t,this.z=n}set(e,t,n){return n===void 0&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw Error(`THREE.Vector3: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw Error(`THREE.Vector3: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(ee.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(ee.setFromAxisAngle(e,t))}applyMatrix3(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6]*r,this.y=i[1]*t+i[4]*n+i[7]*r,this.z=i[2]*t+i[5]*n+i[8]*r,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=e.elements,a=1/(i[3]*t+i[7]*n+i[11]*r+i[15]);return this.x=(i[0]*t+i[4]*n+i[8]*r+i[12])*a,this.y=(i[1]*t+i[5]*n+i[9]*r+i[13])*a,this.z=(i[2]*t+i[6]*n+i[10]*r+i[14])*a,this}applyQuaternion(e){let t=this.x,n=this.y,r=this.z,i=e.x,a=e.y,o=e.z,s=e.w,c=2*(a*r-o*n),l=2*(o*t-i*r),u=2*(i*n-a*t);return this.x=t+s*c+a*u-o*l,this.y=n+s*l+o*c-i*u,this.z=r+s*u+i*l-a*c,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){let t=this.x,n=this.y,r=this.z,i=e.elements;return this.x=i[0]*t+i[4]*n+i[8]*r,this.y=i[1]*t+i[5]*n+i[9]*r,this.z=i[2]*t+i[6]*n+i[10]*r,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=T(this.x,e.x,t.x),this.y=T(this.y,e.y,t.y),this.z=T(this.z,e.z,t.z),this}clampScalar(e,t){return this.x=T(this.x,e,t),this.y=T(this.y,e,t),this.z=T(this.z,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(T(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){let n=e.x,r=e.y,i=e.z,a=t.x,o=t.y,s=t.z;return this.x=r*s-i*o,this.y=i*a-n*s,this.z=n*o-r*a,this}projectOnVector(e){let t=e.lengthSq();if(t===0)return this.set(0,0,0);let n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return N.copy(this).projectOnVector(e),this.sub(N)}reflect(e){return this.sub(N.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){let t=Math.sqrt(this.lengthSq()*e.lengthSq());if(t===0)return Math.PI/2;let n=this.dot(e)/t;return Math.acos(T(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){let t=this.x-e.x,n=this.y-e.y,r=this.z-e.z;return t*t+n*n+r*r}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){let r=Math.sin(t)*e;return this.x=r*Math.sin(n),this.y=Math.cos(t)*e,this.z=r*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){let t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),r=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=r,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,t*4)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,t*3)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){let e=Math.random()*Math.PI*2,t=Math.random()*2-1,n=Math.sqrt(1-t*t);return this.x=n*Math.cos(e),this.y=t,this.z=n*Math.sin(e),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}};let N=/*@__PURE__*/ new M,ee=/*@__PURE__*/ new j;var P=class e{static{e.prototype.isMatrix3=!0}constructor(e,t,n,r,i,a,o,s,c){this.elements=[1,0,0,0,1,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c)}set(e,t,n,r,i,a,o,s,c){let l=this.elements;return l[0]=e,l[1]=r,l[2]=o,l[3]=t,l[4]=i,l[5]=s,l[6]=n,l[7]=a,l[8]=c,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){let t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[3],s=n[6],c=n[1],l=n[4],u=n[7],d=n[2],f=n[5],p=n[8],m=r[0],h=r[3],g=r[6],_=r[1],v=r[4],y=r[7],b=r[2],x=r[5],S=r[8];return i[0]=a*m+o*_+s*b,i[3]=a*h+o*v+s*x,i[6]=a*g+o*y+s*S,i[1]=c*m+l*_+u*b,i[4]=c*h+l*v+u*x,i[7]=c*g+l*y+u*S,i[2]=d*m+f*_+p*b,i[5]=d*h+f*v+p*x,i[8]=d*g+f*y+p*S,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8];return t*a*l-t*o*c-n*i*l+n*o*s+r*i*c-r*a*s}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=l*a-o*c,d=o*s-l*i,f=c*i-a*s,p=t*u+n*d+r*f;if(p===0)return this.set(0,0,0,0,0,0,0,0,0);let m=1/p;return e[0]=u*m,e[1]=(r*c-l*n)*m,e[2]=(o*n-r*a)*m,e[3]=d*m,e[4]=(l*t-r*s)*m,e[5]=(r*i-o*t)*m,e[6]=f*m,e[7]=(n*s-c*t)*m,e[8]=(a*t-n*i)*m,this}transpose(){let e,t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){let t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,r,i,a,o){let s=Math.cos(i),c=Math.sin(i);return this.set(n*s,n*c,-n*(s*a+c*o)+a+e,-r*c,r*s,-r*(-c*a+s*o)+o+t,0,0,1),this}scale(e,t){return x(`Matrix3: .scale() is deprecated. Use .makeScale() instead.`),this.premultiply(te.makeScale(e,t)),this}rotate(e){return x(`Matrix3: .rotate() is deprecated. Use .makeRotation() instead.`),this.premultiply(te.makeRotation(-e)),this}translate(e,t){return x(`Matrix3: .translate() is deprecated. Use .makeTranslation() instead.`),this.premultiply(te.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return new this.constructor().fromArray(this.elements)}};let te=/*@__PURE__*/ new P,ne=/*@__PURE__*/ new P().set(.4123908,.3575843,.1804808,.212639,.7151687,.0721923,.0193308,.1191948,.9505322),re=/*@__PURE__*/ new P().set(3.2409699,-1.5373832,-.4986108,-.9692436,1.8759675,.0415551,.0556301,-.203977,1.0569715);function ie(){let e={enabled:!0,workingColorSpace:d,spaces:{},convert:function(e,t,n){return this.enabled===!1||t===n||!t||!n?e:(this.spaces[t].transfer===`srgb`&&(e.r=ae(e.r),e.g=ae(e.g),e.b=ae(e.b)),this.spaces[t].primaries!==this.spaces[n].primaries&&(e.applyMatrix3(this.spaces[t].toXYZ),e.applyMatrix3(this.spaces[n].fromXYZ)),this.spaces[n].transfer===`srgb`&&(e.r=oe(e.r),e.g=oe(e.g),e.b=oe(e.b)),e)},workingToColorSpace:function(e,t){return this.convert(e,this.workingColorSpace,t)},colorSpaceToWorking:function(e,t){return this.convert(e,t,this.workingColorSpace)},getPrimaries:function(e){return this.spaces[e].primaries},getTransfer:function(e){return e===``?f:this.spaces[e].transfer},getToneMappingMode:function(e){return this.spaces[e].outputColorSpaceConfig.toneMappingMode||`standard`},getLuminanceCoefficients:function(e,t=this.workingColorSpace){return e.fromArray(this.spaces[t].luminanceCoefficients)},define:function(e){Object.assign(this.spaces,e)},_getMatrix:function(e,t,n){return e.copy(this.spaces[t].toXYZ).multiply(this.spaces[n].fromXYZ)},_getDrawingBufferColorSpace:function(e){return this.spaces[e].outputColorSpaceConfig.drawingBufferColorSpace},_getUnpackColorSpace:function(e=this.workingColorSpace){return this.spaces[e].workingColorSpaceConfig.unpackColorSpace},fromWorkingColorSpace:function(t,n){return x(`ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().`),e.workingToColorSpace(t,n)},toWorkingColorSpace:function(t,n){return x(`ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().`),e.colorSpaceToWorking(t,n)}},t=[.64,.33,.3,.6,.15,.06],n=[.2126,.7152,.0722],r=[.3127,.329];return e.define({[d]:{primaries:t,whitePoint:r,transfer:f,toXYZ:ne,fromXYZ:re,luminanceCoefficients:n,workingColorSpaceConfig:{unpackColorSpace:u},outputColorSpaceConfig:{drawingBufferColorSpace:u}},[u]:{primaries:t,whitePoint:r,transfer:`srgb`,toXYZ:ne,fromXYZ:re,luminanceCoefficients:n,outputColorSpaceConfig:{drawingBufferColorSpace:u}}}),e}let F=/*@__PURE__*/ ie();function ae(e){return e<.04045?e*.0773993808:(e*.9478672986+.0521327014)**2.4}function oe(e){return e<.0031308?e*12.92:1.055*e**.41666-.055}let se;var ce=class{static getDataURL(e,t=`image/png`){if(/^data:/i.test(e.src)||typeof HTMLCanvasElement>`u`)return e.src;let n;if(e instanceof HTMLCanvasElement)n=e;else{se===void 0&&(se=g(`canvas`)),se.width=e.width,se.height=e.height;let t=se.getContext(`2d`);e instanceof ImageData?t.putImageData(e,0,0):t.drawImage(e,0,0,e.width,e.height),n=se}return n.toDataURL(t)}static sRGBToLinear(e){if(typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap){let t=g(`canvas`);t.width=e.width,t.height=e.height;let n=t.getContext(`2d`);n.drawImage(e,0,0,e.width,e.height);let r=n.getImageData(0,0,e.width,e.height),i=r.data;for(let e=0;e<i.length;e++)i[e]=ae(i[e]/255)*255;return n.putImageData(r,0,0),t}if(e.data){let t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(ae(t[e]/255)*255):t[e]=ae(t[e]);return{data:t,width:e.width,height:e.height}}return y(`ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.`),e}};let le=0;var ue=class{constructor(e=null){this.isTextureSource=!0,Object.defineProperty(this,\"id\",{value:le++}),this.uuid=w(),this.data=e,this.dataReady=!0,this.version=0}getSize(e){let t=this.data;return typeof HTMLVideoElement<`u`&&t instanceof HTMLVideoElement?e.set(t.videoWidth,t.videoHeight,0):typeof VideoFrame<`u`&&t instanceof VideoFrame?e.set(t.displayWidth,t.displayHeight,0):t===null?e.set(0,0,0):e.set(t.width,t.height,t.depth||0),e}set needsUpdate(e){e===!0&&this.version++}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.images[this.uuid]!==void 0)return e.images[this.uuid];let n={uuid:this.uuid,url:``},r=this.data;if(r!==null){let e;if(Array.isArray(r)){e=[];for(let t=0,n=r.length;t<n;t++)r[t].isDataTexture?e.push(de(r[t].image)):e.push(de(r[t]))}else e=de(r);n.url=e}return t||(e.images[this.uuid]=n),n}};function de(e){return typeof HTMLImageElement<`u`&&e instanceof HTMLImageElement||typeof HTMLCanvasElement<`u`&&e instanceof HTMLCanvasElement||typeof ImageBitmap<`u`&&e instanceof ImageBitmap?ce.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(y(`Texture: Unable to serialize Texture.`),{})}let fe=0,pe=/*@__PURE__*/ new M;var me=class r extends S{constructor(e=r.DEFAULT_IMAGE,n=r.DEFAULT_MAPPING,i=t,a=t,o=1006,s=1008,c=1023,l=1009,u=r.DEFAULT_ANISOTROPY,d=``){super(),this.isTexture=!0,Object.defineProperty(this,\"id\",{value:fe++}),this.uuid=w(),this.name=``,this.source=new ue(e),this.mipmaps=[],this.mapping=n,this.channel=0,this.wrapS=i,this.wrapT=a,this.magFilter=o,this.minFilter=s,this.anisotropy=u,this.format=c,this.internalFormat=null,this.type=l,this.offset=new A(0,0),this.repeat=new A(1,1),this.center=new A(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new P,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.colorSpace=d,this.userData={},this.updateRanges=[],this.version=0,this.onUpdate=null,this.renderTarget=null,this.isRenderTargetTexture=!1,this.isArrayTexture=!!(e&&e.depth&&e.depth>1),this.pmremVersion=0,this.normalized=!1}get width(){return this.source.getSize(pe).x}get height(){return this.source.getSize(pe).y}get depth(){return this.source.getSize(pe).z}get image(){return this.source.data}set image(e){this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}clone(){return new this.constructor().copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.normalized=e.normalized,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.renderTarget=e.renderTarget,this.isRenderTargetTexture=e.isRenderTargetTexture,this.isArrayTexture=e.isArrayTexture,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}setValues(e){for(let t in e){let n=e[t];if(n===void 0){y(`Texture.setValues(): parameter '${t}' has value of undefined.`);continue}let r=this[t];if(r===void 0){y(`Texture.setValues(): property '${t}' does not exist.`);continue}r&&n&&r.isVector2&&n.isVector2||r&&n&&r.isVector3&&n.isVector3||r&&n&&r.isMatrix3&&n.isMatrix3?r.copy(n):this[t]=n}}toJSON(e){let t=e===void 0||typeof e==`string`;if(!t&&e.textures[this.uuid]!==void 0)return e.textures[this.uuid];let n={metadata:{version:4.7,type:`Texture`,generator:`Texture.toJSON`},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,normalized:this.normalized,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:`dispose`})}transformUv(r){if(this.mapping!==300)return r;if(r.applyMatrix3(this.matrix),r.x<0||r.x>1)switch(this.wrapS){case e:r.x-=Math.floor(r.x);break;case t:r.x=r.x<0?0:1;break;case n:Math.abs(Math.floor(r.x)%2)===1?r.x=Math.ceil(r.x)-r.x:r.x-=Math.floor(r.x)}if(r.y<0||r.y>1)switch(this.wrapT){case e:r.y-=Math.floor(r.y);break;case t:r.y=r.y<0?0:1;break;case n:Math.abs(Math.floor(r.y)%2)===1?r.y=Math.ceil(r.y)-r.y:r.y-=Math.floor(r.y)}return this.flipY&&(r.y=1-r.y),r}set needsUpdate(e){e===!0&&(this.version++,this.source.needsUpdate=!0)}set needsPMREMUpdate(e){e===!0&&this.pmremVersion++}};me.DEFAULT_IMAGE=null,me.DEFAULT_MAPPING=300,me.DEFAULT_ANISOTROPY=1;var he=class e{static{e.prototype.isVector4=!0}constructor(e=0,t=0,n=0,r=1){this.x=e,this.y=t,this.z=n,this.w=r}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,r){return this.x=e,this.y=t,this.z=n,this.w=r,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw Error(`THREE.Vector4: index is out of range: `+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw Error(`THREE.Vector4: index is out of range: `+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=e.w===void 0?1:e.w,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){let t=this.x,n=this.y,r=this.z,i=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*r+a[12]*i,this.y=a[1]*t+a[5]*n+a[9]*r+a[13]*i,this.z=a[2]*t+a[6]*n+a[10]*r+a[14]*i,this.w=a[3]*t+a[7]*n+a[11]*r+a[15]*i,this}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this.w/=e.w,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);let t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,r,i,a=.01,o=.1,s=e.elements,c=s[0],l=s[4],u=s[8],d=s[1],f=s[5],p=s[9],m=s[2],h=s[6],g=s[10];if(Math.abs(l-d)<a&&Math.abs(u-m)<a&&Math.abs(p-h)<a){if(Math.abs(l+d)<o&&Math.abs(u+m)<o&&Math.abs(p+h)<o&&Math.abs(c+f+g-3)<o)return this.set(1,0,0,0),this;t=Math.PI;let e=(c+1)/2,s=(f+1)/2,_=(g+1)/2,v=(l+d)/4,y=(u+m)/4,b=(p+h)/4;return e>s&&e>_?e<a?(n=0,r=.707106781,i=.707106781):(n=Math.sqrt(e),r=v/n,i=y/n):s>_?s<a?(n=.707106781,r=0,i=.707106781):(r=Math.sqrt(s),n=v/r,i=b/r):_<a?(n=.707106781,r=.707106781,i=0):(i=Math.sqrt(_),n=y/i,r=b/i),this.set(n,r,i,t),this}let _=Math.sqrt((h-p)*(h-p)+(u-m)*(u-m)+(d-l)*(d-l));return Math.abs(_)<.001&&(_=1),this.x=(h-p)/_,this.y=(u-m)/_,this.z=(d-l)/_,this.w=Math.acos((c+f+g-1)/2),this}setFromMatrixPosition(e){let t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this.w=t[15],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=T(this.x,e.x,t.x),this.y=T(this.y,e.y,t.y),this.z=T(this.z,e.z,t.z),this.w=T(this.w,e.w,t.w),this}clampScalar(e,t){return this.x=T(this.x,e,t),this.y=T(this.y,e,t),this.z=T(this.z,e,t),this.w=T(this.w,e,t),this}clampLength(e,t){let n=this.length();return this.divideScalar(n||1).multiplyScalar(T(n,e,t))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e,t=0){return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(e=[],t=0){return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}},I=class e{static{e.prototype.isMatrix4=!0}constructor(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e!==void 0&&this.set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h)}set(e,t,n,r,i,a,o,s,c,l,u,d,f,p,m,h){let g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=r,g[1]=i,g[5]=a,g[9]=o,g[13]=s,g[2]=c,g[6]=l,g[10]=u,g[14]=d,g[3]=f,g[7]=p,g[11]=m,g[15]=h,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return new e().fromArray(this.elements)}copy(e){let t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){let t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){let t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return this.determinantAffine()===0?(e.set(1,0,0),t.set(0,1,0),n.set(0,0,1),this):(e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this)}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){if(e.determinantAffine()===0)return this.identity();let t=this.elements,n=e.elements,r=1/ge.setFromMatrixColumn(e,0).length(),i=1/ge.setFromMatrixColumn(e,1).length(),a=1/ge.setFromMatrixColumn(e,2).length();return t[0]=n[0]*r,t[1]=n[1]*r,t[2]=n[2]*r,t[3]=0,t[4]=n[4]*i,t[5]=n[5]*i,t[6]=n[6]*i,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){let t=this.elements,n=e.x,r=e.y,i=e.z,a=Math.cos(n),o=Math.sin(n),s=Math.cos(r),c=Math.sin(r),l=Math.cos(i),u=Math.sin(i);if(e.order===`XYZ`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=-s*u,t[8]=c,t[1]=n+r*c,t[5]=e-i*c,t[9]=-o*s,t[2]=i-e*c,t[6]=r+n*c,t[10]=a*s}else if(e.order===`YXZ`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e+i*o,t[4]=r*o-n,t[8]=a*c,t[1]=a*u,t[5]=a*l,t[9]=-o,t[2]=n*o-r,t[6]=i+e*o,t[10]=a*s}else if(e.order===`ZXY`){let e=s*l,n=s*u,r=c*l,i=c*u;t[0]=e-i*o,t[4]=-a*u,t[8]=r+n*o,t[1]=n+r*o,t[5]=a*l,t[9]=i-e*o,t[2]=-a*c,t[6]=o,t[10]=a*s}else if(e.order===`ZYX`){let e=a*l,n=a*u,r=o*l,i=o*u;t[0]=s*l,t[4]=r*c-n,t[8]=e*c+i,t[1]=s*u,t[5]=i*c+e,t[9]=n*c-r,t[2]=-c,t[6]=o*s,t[10]=a*s}else if(e.order===`YZX`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=i-e*u,t[8]=r*u+n,t[1]=u,t[5]=a*l,t[9]=-o*l,t[2]=-c*l,t[6]=n*u+r,t[10]=e-i*u}else if(e.order===`XZY`){let e=a*s,n=a*c,r=o*s,i=o*c;t[0]=s*l,t[4]=-u,t[8]=c*l,t[1]=e*u+i,t[5]=a*l,t[9]=n*u-r,t[2]=r*u-n,t[6]=o*l,t[10]=i*u+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(ve,e,ye)}lookAt(e,t,n){let r=this.elements;return L.subVectors(e,t),L.lengthSq()===0&&(L.z=1),L.normalize(),be.crossVectors(n,L),be.lengthSq()===0&&(Math.abs(n.z)===1?L.x+=1e-4:L.z+=1e-4,L.normalize(),be.crossVectors(n,L)),be.normalize(),xe.crossVectors(L,be),r[0]=be.x,r[4]=xe.x,r[8]=L.x,r[1]=be.y,r[5]=xe.y,r[9]=L.y,r[2]=be.z,r[6]=xe.z,r[10]=L.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){let n=e.elements,r=t.elements,i=this.elements,a=n[0],o=n[4],s=n[8],c=n[12],l=n[1],u=n[5],d=n[9],f=n[13],p=n[2],m=n[6],h=n[10],g=n[14],_=n[3],v=n[7],y=n[11],b=n[15],x=r[0],S=r[4],C=r[8],w=r[12],T=r[1],E=r[5],D=r[9],O=r[13],k=r[2],A=r[6],j=r[10],M=r[14],N=r[3],ee=r[7],P=r[11],te=r[15];return i[0]=a*x+o*T+s*k+c*N,i[4]=a*S+o*E+s*A+c*ee,i[8]=a*C+o*D+s*j+c*P,i[12]=a*w+o*O+s*M+c*te,i[1]=l*x+u*T+d*k+f*N,i[5]=l*S+u*E+d*A+f*ee,i[9]=l*C+u*D+d*j+f*P,i[13]=l*w+u*O+d*M+f*te,i[2]=p*x+m*T+h*k+g*N,i[6]=p*S+m*E+h*A+g*ee,i[10]=p*C+m*D+h*j+g*P,i[14]=p*w+m*O+h*M+g*te,i[3]=_*x+v*T+y*k+b*N,i[7]=_*S+v*E+y*A+b*ee,i[11]=_*C+v*D+y*j+b*P,i[15]=_*w+v*O+y*M+b*te,this}multiplyScalar(e){let t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[12],a=e[1],o=e[5],s=e[9],c=e[13],l=e[2],u=e[6],d=e[10],f=e[14],p=e[3],m=e[7],h=e[11],g=e[15],_=s*f-c*d,v=o*f-c*u,y=o*d-s*u,b=a*f-c*l,x=a*d-s*l,S=a*u-o*l;return t*(m*_-h*v+g*y)-n*(p*_-h*b+g*x)+r*(p*v-m*b+g*S)-i*(p*y-m*x+h*S)}determinantAffine(){let e=this.elements,t=e[0],n=e[4],r=e[8],i=e[1],a=e[5],o=e[9],s=e[2],c=e[6],l=e[10];return t*(a*l-o*c)-n*(i*l-o*s)+r*(i*c-a*s)}transpose(){let e=this.elements,t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){let r=this.elements;return e.isVector3?(r[12]=e.x,r[13]=e.y,r[14]=e.z):(r[12]=e,r[13]=t,r[14]=n),this}invert(){let e=this.elements,t=e[0],n=e[1],r=e[2],i=e[3],a=e[4],o=e[5],s=e[6],c=e[7],l=e[8],u=e[9],d=e[10],f=e[11],p=e[12],m=e[13],h=e[14],g=e[15],_=t*o-n*a,v=t*s-r*a,y=t*c-i*a,b=n*s-r*o,x=n*c-i*o,S=r*c-i*s,C=l*m-u*p,w=l*h-d*p,T=l*g-f*p,E=u*h-d*m,D=u*g-f*m,O=d*g-f*h,k=_*O-v*D+y*E+b*T-x*w+S*C;if(k===0)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);let A=1/k;return e[0]=(o*O-s*D+c*E)*A,e[1]=(r*D-n*O-i*E)*A,e[2]=(m*S-h*x+g*b)*A,e[3]=(d*x-u*S-f*b)*A,e[4]=(s*T-a*O-c*w)*A,e[5]=(t*O-r*T+i*w)*A,e[6]=(h*y-p*S-g*v)*A,e[7]=(l*S-d*y+f*v)*A,e[8]=(a*D-o*T+c*C)*A,e[9]=(n*T-t*D-i*C)*A,e[10]=(p*x-m*y+g*_)*A,e[11]=(u*y-l*x-f*_)*A,e[12]=(o*w-a*E-s*C)*A,e[13]=(t*E-n*w+r*C)*A,e[14]=(m*v-p*b-h*_)*A,e[15]=(l*b-u*v+d*_)*A,this}scale(e){let t=this.elements,n=e.x,r=e.y,i=e.z;return t[0]*=n,t[4]*=r,t[8]*=i,t[1]*=n,t[5]*=r,t[9]*=i,t[2]*=n,t[6]*=r,t[10]*=i,t[3]*=n,t[7]*=r,t[11]*=i,this}getMaxScaleOnAxis(){let e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],r=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,r))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){let t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){let t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){let n=Math.cos(t),r=Math.sin(t),i=1-n,a=e.x,o=e.y,s=e.z,c=i*a,l=i*o;return this.set(c*a+n,c*o-r*s,c*s+r*o,0,c*o+r*s,l*o+n,l*s-r*a,0,c*s-r*o,l*s+r*a,i*s*s+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,r,i,a){return this.set(1,n,i,0,e,1,a,0,t,r,1,0,0,0,0,1),this}compose(e,t,n){let r=this.elements,i=t._x,a=t._y,o=t._z,s=t._w,c=i+i,l=a+a,u=o+o,d=i*c,f=i*l,p=i*u,m=a*l,h=a*u,g=o*u,_=s*c,v=s*l,y=s*u,b=n.x,x=n.y,S=n.z;return r[0]=(1-(m+g))*b,r[1]=(f+y)*b,r[2]=(p-v)*b,r[3]=0,r[4]=(f-y)*x,r[5]=(1-(d+g))*x,r[6]=(h+_)*x,r[7]=0,r[8]=(p+v)*S,r[9]=(h-_)*S,r[10]=(1-(d+m))*S,r[11]=0,r[12]=e.x,r[13]=e.y,r[14]=e.z,r[15]=1,this}decompose(e,t,n){let r=this.elements;e.x=r[12],e.y=r[13],e.z=r[14];let i=this.determinantAffine();if(i===0)return n.set(1,1,1),t.identity(),this;let a=ge.set(r[0],r[1],r[2]).length(),o=ge.set(r[4],r[5],r[6]).length(),s=ge.set(r[8],r[9],r[10]).length();i<0&&(a=-a),_e.copy(this);let c=1/a,l=1/o,u=1/s;return _e.elements[0]*=c,_e.elements[1]*=c,_e.elements[2]*=c,_e.elements[4]*=l,_e.elements[5]*=l,_e.elements[6]*=l,_e.elements[8]*=u,_e.elements[9]*=u,_e.elements[10]*=u,t.setFromRotationMatrix(_e),n.x=a,n.y=o,n.z=s,this}makePerspective(e,t,n,r,i,a,o=p,s=!1){let c=this.elements,l=2*i/(t-e),u=2*i/(n-r),d=(t+e)/(t-e),f=(n+r)/(n-r),m,h;if(s)m=i/(a-i),h=a*i/(a-i);else if(o===2e3)m=-(a+i)/(a-i),h=-2*a*i/(a-i);else if(o===2001)m=-a/(a-i),h=-a*i/(a-i);else throw Error(`THREE.Matrix4.makePerspective(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=d,c[12]=0,c[1]=0,c[5]=u,c[9]=f,c[13]=0,c[2]=0,c[6]=0,c[10]=m,c[14]=h,c[3]=0,c[7]=0,c[11]=-1,c[15]=0,this}makeOrthographic(e,t,n,r,i,a,o=p,s=!1){let c=this.elements,l=2/(t-e),u=2/(n-r),d=-(t+e)/(t-e),f=-(n+r)/(n-r),m,h;if(s)m=1/(a-i),h=a/(a-i);else if(o===2e3)m=-2/(a-i),h=-(a+i)/(a-i);else if(o===2001)m=-1/(a-i),h=-i/(a-i);else throw Error(`THREE.Matrix4.makeOrthographic(): Invalid coordinate system: `+o);return c[0]=l,c[4]=0,c[8]=0,c[12]=d,c[1]=0,c[5]=u,c[9]=0,c[13]=f,c[2]=0,c[6]=0,c[10]=m,c[14]=h,c[3]=0,c[7]=0,c[11]=0,c[15]=1,this}equals(e){let t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e,t=0){for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(e=[],t=0){let n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}};let ge=/*@__PURE__*/ new M,_e=/*@__PURE__*/ new I,ve=/*@__PURE__*/ new M(0,0,0),ye=/*@__PURE__*/ new M(1,1,1),be=/*@__PURE__*/ new M,xe=/*@__PURE__*/ new M,L=/*@__PURE__*/ new M,Se=/*@__PURE__*/ new I,Ce=/*@__PURE__*/ new j;var we=class e{constructor(t=0,n=0,r=0,i=e.DEFAULT_ORDER){this.isEuler=!0,this._x=t,this._y=n,this._z=r,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n,r=this._order){return this._x=e,this._y=t,this._z=n,this._order=r,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e,t=this._order,n=!0){let r=e.elements,i=r[0],a=r[4],o=r[8],s=r[1],c=r[5],l=r[9],u=r[2],d=r[6],f=r[10];switch(t){case`XYZ`:this._y=Math.asin(T(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-l,f),this._z=Math.atan2(-a,i)):(this._x=Math.atan2(d,c),this._z=0);break;case`YXZ`:this._x=Math.asin(-T(l,-1,1)),Math.abs(l)<.9999999?(this._y=Math.atan2(o,f),this._z=Math.atan2(s,c)):(this._y=Math.atan2(-u,i),this._z=0);break;case`ZXY`:this._x=Math.asin(T(d,-1,1)),Math.abs(d)<.9999999?(this._y=Math.atan2(-u,f),this._z=Math.atan2(-a,c)):(this._y=0,this._z=Math.atan2(s,i));break;case`ZYX`:this._y=Math.asin(-T(u,-1,1)),Math.abs(u)<.9999999?(this._x=Math.atan2(d,f),this._z=Math.atan2(s,i)):(this._x=0,this._z=Math.atan2(-a,c));break;case`YZX`:this._z=Math.asin(T(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-l,c),this._y=Math.atan2(-u,i)):(this._x=0,this._y=Math.atan2(o,f));break;case`XZY`:this._z=Math.asin(-T(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(d,c),this._y=Math.atan2(o,i)):(this._x=Math.atan2(-l,f),this._y=0);break;default:y(`Euler: .setFromRotationMatrix() encountered an unknown order: `+t)}return this._order=t,n===!0&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return Se.makeRotationFromQuaternion(e),this.setFromRotationMatrix(Se,t,n)}setFromVector3(e,t=this._order){return this.set(e.x,e.y,e.z,t)}reorder(e){return Ce.setFromEuler(this),this.setFromQuaternion(Ce,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],e[3]!==void 0&&(this._order=e[3]),this._onChangeCallback(),this}toArray(e=[],t=0){return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}};we.DEFAULT_ORDER=`XYZ`;var Te=class{constructor(){this.mask=1}set(e){this.mask=(1<<e|0)>>>0}enable(e){this.mask|=1<<e|0}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e|0}disable(e){this.mask&=~(1<<e|0)}disableAll(){this.mask=0}test(e){return(this.mask&e.mask)!==0}isEnabled(e){return!!(this.mask&(1<<e|0))}};let Ee=0,De=/*@__PURE__*/ new M,Oe=/*@__PURE__*/ new j,ke=/*@__PURE__*/ new I,Ae=/*@__PURE__*/ new M,je=/*@__PURE__*/ new M,Me=/*@__PURE__*/ new M,Ne=/*@__PURE__*/ new j,Pe=/*@__PURE__*/ new M(1,0,0),Fe=/*@__PURE__*/ new M(0,1,0),Ie=/*@__PURE__*/ new M(0,0,1),Le={type:`added`},Re={type:`removed`},ze={type:`childadded`,child:null},Be={type:`childremoved`,child:null};var Ve=class e extends S{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,\"id\",{value:Ee++}),this.uuid=w(),this.name=``,this.type=`Object3D`,this.parent=null,this.children=[],this.up=e.DEFAULT_UP.clone();let t=new M,n=new we,r=new j,i=new M(1,1,1);function a(){r.setFromEuler(n,!1)}function o(){n.setFromQuaternion(r,void 0,!1)}n._onChange(a),r._onChange(o),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:t},rotation:{configurable:!0,enumerable:!0,value:n},quaternion:{configurable:!0,enumerable:!0,value:r},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new I},normalMatrix:{value:new P}}),this.matrix=new I,this.matrixWorld=new I,this.matrixAutoUpdate=e.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldAutoUpdate=e.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.layers=new Te,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.customDepthMaterial=void 0,this.customDistanceMaterial=void 0,this.static=!1,this.userData={},this.pivot=null}onBeforeShadow(){}onAfterShadow(){}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return Oe.setFromAxisAngle(e,t),this.quaternion.multiply(Oe),this}rotateOnWorldAxis(e,t){return Oe.setFromAxisAngle(e,t),this.quaternion.premultiply(Oe),this}rotateX(e){return this.rotateOnAxis(Pe,e)}rotateY(e){return this.rotateOnAxis(Fe,e)}rotateZ(e){return this.rotateOnAxis(Ie,e)}translateOnAxis(e,t){return De.copy(e).applyQuaternion(this.quaternion),this.position.add(De.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(Pe,e)}translateY(e){return this.translateOnAxis(Fe,e)}translateZ(e){return this.translateOnAxis(Ie,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(ke.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?Ae.copy(e):Ae.set(e,t,n);let r=this.parent;this.updateWorldMatrix(!0,!1),je.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?ke.lookAt(je,Ae,this.up):ke.lookAt(Ae,je,this.up),this.quaternion.setFromRotationMatrix(ke),r&&(ke.extractRotation(r.matrixWorld),Oe.setFromRotationMatrix(ke),this.quaternion.premultiply(Oe.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(b(`Object3D.add: object can't be added as a child of itself.`,e),this):(e&&e.isObject3D?(e.removeFromParent(),e.parent=this,this.children.push(e),e.dispatchEvent(Le),ze.child=e,this.dispatchEvent(ze),ze.child=null):b(`Object3D.add: object not an instance of THREE.Object3D.`,e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}let t=this.children.indexOf(e);return t!==-1&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(Re),Be.child=e,this.dispatchEvent(Be),Be.child=null),this}removeFromParent(){let e=this.parent;return e!==null&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),ke.copy(this.matrixWorld).invert(),e.parent!==null&&(e.parent.updateWorldMatrix(!0,!1),ke.multiply(e.parent.matrixWorld)),e.applyMatrix4(ke),e.removeFromParent(),e.parent=this,this.children.push(e),e.updateWorldMatrix(!1,!0),e.dispatchEvent(Le),ze.child=e,this.dispatchEvent(ze),ze.child=null,this}getObjectById(e){return this.getObjectByProperty(`id`,e)}getObjectByName(e){return this.getObjectByProperty(`name`,e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,r=this.children.length;n<r;n++){let r=this.children[n].getObjectByProperty(e,t);if(r!==void 0)return r}}getObjectsByProperty(e,t,n=[]){this[e]===t&&n.push(this);let r=this.children;for(let i=0,a=r.length;i<a;i++)r[i].getObjectsByProperty(e,t,n);return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(je,e,Me),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(je,Ne,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);let t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}intersectsFrustum(){}traverse(e){e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverse(e)}traverseVisible(e){if(this.visible===!1)return;e(this);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].traverseVisible(e)}traverseAncestors(e){let t=this.parent;t!==null&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale);let e=this.pivot;if(e!==null){let t=e.x,n=e.y,r=e.z,i=this.matrix.elements;i[12]+=t-i[0]*t-i[4]*n-i[8]*r,i[13]+=n-i[1]*t-i[5]*n-i[9]*r,i[14]+=r-i[2]*t-i[6]*n-i[10]*r}this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,e=!0);let t=this.children;for(let n=0,r=t.length;n<r;n++)t[n].updateMatrixWorld(e)}updateWorldMatrix(e,t,n=!1){let r=this.parent;if(e===!0&&r!==null&&r.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||n)&&(this.matrixWorldAutoUpdate===!0&&(this.parent===null?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix)),this.matrixWorldNeedsUpdate=!1,n=!0),t===!0){let e=this.children;for(let t=0,r=e.length;t<r;t++)e[t].updateWorldMatrix(!1,!0,n)}}toJSON(e){let t=e===void 0||typeof e==`string`,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.7,type:`Object`,generator:`Object3D.toJSON`});let r={};r.uuid=this.uuid,r.type=this.type,r.name=this.name,r.castShadow=this.castShadow,r.receiveShadow=this.receiveShadow,r.visible=this.visible,r.frustumCulled=this.frustumCulled,r.renderOrder=this.renderOrder,r.static=this.static,r.matrixAutoUpdate=this.matrixAutoUpdate,Object.keys(this.userData).length>0&&(r.userData=this.userData),r.layers=this.layers.mask,r.matrix=this.matrix.toArray(),r.up=this.up.toArray(),this.pivot!==null&&(r.pivot=this.pivot.toArray()),this.morphTargetDictionary!==void 0&&(r.morphTargetDictionary=Object.assign({},this.morphTargetDictionary)),this.morphTargetInfluences!==void 0&&(r.morphTargetInfluences=this.morphTargetInfluences.slice()),this.isInstancedMesh&&(r.type=`InstancedMesh`,r.count=this.count,r.instanceMatrix=this.instanceMatrix.toJSON(),this.instanceColor!==null&&(r.instanceColor=this.instanceColor.toJSON())),this.isBatchedMesh&&(r.type=`BatchedMesh`,r.perObjectFrustumCulled=this.perObjectFrustumCulled,r.sortObjects=this.sortObjects,r.drawRanges=this._drawRanges,r.reservedRanges=this._reservedRanges,r.geometryInfo=this._geometryInfo.map(e=>({...e,boundingBox:e.boundingBox?e.boundingBox.toJSON():void 0,boundingSphere:e.boundingSphere?e.boundingSphere.toJSON():void 0})),r.instanceInfo=this._instanceInfo.map(e=>({...e})),r.availableInstanceIds=this._availableInstanceIds.slice(),r.availableGeometryIds=this._availableGeometryIds.slice(),r.nextIndexStart=this._nextIndexStart,r.nextVertexStart=this._nextVertexStart,r.geometryCount=this._geometryCount,r.maxInstanceCount=this._maxInstanceCount,r.maxVertexCount=this._maxVertexCount,r.maxIndexCount=this._maxIndexCount,r.geometryInitialized=this._geometryInitialized,r.matricesTexture=this._matricesTexture.toJSON(e),r.indirectTexture=this._indirectTexture.toJSON(e),this._colorsTexture!==null&&(r.colorsTexture=this._colorsTexture.toJSON(e)),this.boundingSphere!==null&&(r.boundingSphere=this.boundingSphere.toJSON()),this.boundingBox!==null&&(r.boundingBox=this.boundingBox.toJSON()));function i(t,n){return t[n.uuid]===void 0&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(this.isScene)this.background&&(this.background.isColor?r.background=this.background.toJSON():this.background.isTexture&&(r.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&this.environment.isRenderTargetTexture!==!0&&(r.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){r.geometry=i(e.geometries,this.geometry);let t=this.geometry.parameters;if(t!==void 0&&t.shapes!==void 0){let n=t.shapes;if(Array.isArray(n))for(let t=0,r=n.length;t<r;t++){let r=n[t];i(e.shapes,r)}else i(e.shapes,n)}}if(this.isSkinnedMesh&&(r.bindMode=this.bindMode,r.bindMatrix=this.bindMatrix.toArray(),this.skeleton!==void 0&&(i(e.skeletons,this.skeleton),r.skeleton=this.skeleton.uuid)),this.material!==void 0){if(Array.isArray(this.material)){let t=[];for(let n=0,r=this.material.length;n<r;n++)t.push(i(e.materials,this.material[n]));r.material=t}else r.material=i(e.materials,this.material)}if(this.children.length>0){r.children=[];for(let t=0;t<this.children.length;t++)r.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){r.animations=[];for(let t=0;t<this.animations.length;t++){let n=this.animations[t];r.animations.push(i(e.animations,n))}}if(t){let t=a(e.geometries),r=a(e.materials),i=a(e.textures),o=a(e.images),s=a(e.shapes),c=a(e.skeletons),l=a(e.animations),u=a(e.nodes);t.length>0&&(n.geometries=t),r.length>0&&(n.materials=r),i.length>0&&(n.textures=i),o.length>0&&(n.images=o),s.length>0&&(n.shapes=s),c.length>0&&(n.skeletons=c),l.length>0&&(n.animations=l),u.length>0&&(n.nodes=u)}return n.object=r,n;function a(e){let t=[];for(let n in e){let r=e[n];delete r.metadata,t.push(r)}return t}}clone(e){return new this.constructor().copy(this,e)}copy(e,t=!0){if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.pivot=e.pivot===null?null:e.pivot.clone(),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.static=e.static,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),t===!0)for(let t=0;t<e.children.length;t++){let n=e.children[t];this.add(n.clone())}return this}dispose(){this.dispatchEvent({type:`dispose`})}};Ve.DEFAULT_UP=/*@__PURE__*/ new M(0,1,0),Ve.DEFAULT_MATRIX_AUTO_UPDATE=!0,Ve.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;let He={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},Ue={h:0,s:0,l:0},We={h:0,s:0,l:0};function Ge(e,t,n){return n<0&&(n+=1),n>1&&--n,n<1/6?e+(t-e)*6*n:n<1/2?t:n<2/3?e+(t-e)*6*(2/3-n):e}var Ke=class{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(t===void 0&&n===void 0){let t=e;t&&t.isColor?this.copy(t):typeof t==`number`?this.setHex(t):typeof t==`string`&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e,t=u){return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(e&255)/255,F.colorSpaceToWorking(this,t),this}setRGB(e,t,n,r=F.workingColorSpace){return this.r=e,this.g=t,this.b=n,F.colorSpaceToWorking(this,r),this}setHSL(e,t,n,r=F.workingColorSpace){if(e=E(e,1),t=T(t,0,1),n=T(n,0,1),t===0)this.r=this.g=this.b=n;else{let r=n<=.5?n*(1+t):n+t-n*t,i=2*n-r;this.r=Ge(i,r,e+1/3),this.g=Ge(i,r,e),this.b=Ge(i,r,e-1/3)}return F.colorSpaceToWorking(this,r),this}setStyle(e,t=u){function n(t){t!==void 0&&parseFloat(t)<1&&y(`Color: Alpha component of `+e+` will be ignored.`)}let r;if(r=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let i,a=r[1],o=r[2];switch(a){case`rgb`:case`rgba`:if(i=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(255,parseInt(i[1],10))/255,Math.min(255,parseInt(i[2],10))/255,Math.min(255,parseInt(i[3],10))/255,t);if(i=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setRGB(Math.min(100,parseInt(i[1],10))/100,Math.min(100,parseInt(i[2],10))/100,Math.min(100,parseInt(i[3],10))/100,t);break;case`hsl`:case`hsla`:if(i=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(o))return n(i[4]),this.setHSL(parseFloat(i[1])/360,parseFloat(i[2])/100,parseFloat(i[3])/100,t);break;default:y(`Color: Unknown color model `+e)}}else if(r=/^\\#([A-Fa-f\\d]+)$/.exec(e)){let n=r[1],i=n.length;if(i===3)return this.setRGB(parseInt(n.charAt(0),16)/15,parseInt(n.charAt(1),16)/15,parseInt(n.charAt(2),16)/15,t);if(i===6)return this.setHex(parseInt(n,16),t);y(`Color: Invalid hex color `+e)}else if(e&&e.length>0)return this.setColorName(e,t);return this}setColorName(e,t=u){let n=He[e.toLowerCase()];return n===void 0?y(`Color: Unknown color `+e):this.setHex(n,t),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=ae(e.r),this.g=ae(e.g),this.b=ae(e.b),this}copyLinearToSRGB(e){return this.r=oe(e.r),this.g=oe(e.g),this.b=oe(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(e=u){return F.workingToColorSpace(R.copy(this),e),Math.round(T(R.r*255,0,255))*65536+Math.round(T(R.g*255,0,255))*256+Math.round(T(R.b*255,0,255))}getHexString(e=u){return(`000000`+this.getHex(e).toString(16)).slice(-6)}getHSL(e,t=F.workingColorSpace){F.workingToColorSpace(R.copy(this),t);let n=R.r,r=R.g,i=R.b,a=Math.max(n,r,i),o=Math.min(n,r,i),s,c,l=(o+a)/2;if(o===a)s=0,c=0;else{let e=a-o;switch(c=l<=.5?e/(a+o):e/(2-a-o),a){case n:s=(r-i)/e+(r<i?6:0);break;case r:s=(i-n)/e+2;break;case i:s=(n-r)/e+4}s/=6}return e.h=s,e.s=c,e.l=l,e}getRGB(e,t=F.workingColorSpace){return F.workingToColorSpace(R.copy(this),t),e.r=R.r,e.g=R.g,e.b=R.b,e}getStyle(e=u){F.workingToColorSpace(R.copy(this),e);let t=R.r,n=R.g,r=R.b;return e===`srgb`?`rgb(${Math.round(t*255)},${Math.round(n*255)},${Math.round(r*255)})`:`color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`}offsetHSL(e,t,n){return this.getHSL(Ue),this.setHSL(Ue.h+e,Ue.s+t,Ue.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(Ue),e.getHSL(We);let n=D(Ue.h,We.h,t),r=D(Ue.s,We.s,t),i=D(Ue.l,We.l,t);return this.setHSL(n,r,i),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){let t=this.r,n=this.g,r=this.b,i=e.elements;return this.r=i[0]*t+i[3]*n+i[6]*r,this.g=i[1]*t+i[4]*n+i[7]*r,this.b=i[2]*t+i[5]*n+i[8]*r,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e,t=0){return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(e=[],t=0){return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}};let R=/*@__PURE__*/ new Ke;Ke.NAMES=He;let qe=/*@__PURE__*/ new M,Je=/*@__PURE__*/ new M,Ye=/*@__PURE__*/ new M,Xe=/*@__PURE__*/ new M,Ze=/*@__PURE__*/ new M,Qe=/*@__PURE__*/ new M,$e=/*@__PURE__*/ new M,et=/*@__PURE__*/ new M,tt=/*@__PURE__*/ new M,nt=/*@__PURE__*/ new M,rt=/*@__PURE__*/ new he,it=/*@__PURE__*/ new he,at=/*@__PURE__*/ new he;var ot=class e{constructor(e=new M,t=new M,n=new M){this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,r){r.subVectors(n,t),qe.subVectors(e,t),r.cross(qe);let i=r.lengthSq();return i>0?r.multiplyScalar(1/Math.sqrt(i)):r.set(0,0,0)}static getBarycoord(e,t,n,r,i){qe.subVectors(r,t),Je.subVectors(n,t),Ye.subVectors(e,t);let a=qe.dot(qe),o=qe.dot(Je),s=qe.dot(Ye),c=Je.dot(Je),l=Je.dot(Ye),u=a*c-o*o;if(u===0)return i.set(0,0,0),null;let d=1/u,f=(c*s-o*l)*d,p=(a*l-o*s)*d;return i.set(1-f-p,p,f)}static containsPoint(e,t,n,r){return this.getBarycoord(e,t,n,r,Xe)!==null&&Xe.x>=0&&Xe.y>=0&&Xe.x+Xe.y<=1}static getInterpolation(e,t,n,r,i,a,o,s){return this.getBarycoord(e,t,n,r,Xe)===null?(s.x=0,s.y=0,`z`in s&&(s.z=0),`w`in s&&(s.w=0),null):(s.setScalar(0),s.addScaledVector(i,Xe.x),s.addScaledVector(a,Xe.y),s.addScaledVector(o,Xe.z),s)}static getInterpolatedAttribute(e,t,n,r,i,a){return rt.setScalar(0),it.setScalar(0),at.setScalar(0),rt.fromBufferAttribute(e,t),it.fromBufferAttribute(e,n),at.fromBufferAttribute(e,r),a.setScalar(0),a.addScaledVector(rt,i.x),a.addScaledVector(it,i.y),a.addScaledVector(at,i.z),a}static isFrontFacing(e,t,n,r){return qe.subVectors(n,t),Je.subVectors(e,t),qe.cross(Je).dot(r)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,r){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[r]),this}setFromAttributeAndIndices(e,t,n,r){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,r),this}clone(){return new this.constructor().copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return qe.subVectors(this.c,this.b),Je.subVectors(this.a,this.b),qe.cross(Je).length()*.5}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(t){return e.getNormal(this.a,this.b,this.c,t)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(t,n){return e.getBarycoord(t,this.a,this.b,this.c,n)}getInterpolation(t,n,r,i,a){return e.getInterpolation(t,this.a,this.b,this.c,n,r,i,a)}containsPoint(t){return e.containsPoint(t,this.a,this.b,this.c)}isFrontFacing(t){return e.isFrontFacing(this.a,this.b,this.c,t)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){let n=this.a,r=this.b,i=this.c,a,o;Ze.subVectors(r,n),Qe.subVectors(i,n),et.subVectors(e,n);let s=Ze.dot(et),c=Qe.dot(et);if(s<=0&&c<=0)return t.copy(n);tt.subVectors(e,r);let l=Ze.dot(tt),u=Qe.dot(tt);if(l>=0&&u<=l)return t.copy(r);let d=s*u-l*c;if(d<=0&&s>=0&&l<=0)return a=s/(s-l),t.copy(n).addScaledVector(Ze,a);nt.subVectors(e,i);let f=Ze.dot(nt),p=Qe.dot(nt);if(p>=0&&f<=p)return t.copy(i);let m=f*c-s*p;if(m<=0&&c>=0&&p<=0)return o=c/(c-p),t.copy(n).addScaledVector(Qe,o);let h=l*p-f*u;if(h<=0&&u-l>=0&&f-p>=0)return $e.subVectors(i,r),o=(u-l)/(u-l+(f-p)),t.copy(r).addScaledVector($e,o);let g=1/(h+m+d);return a=m*g,o=d*g,t.copy(n).addScaledVector(Ze,a).addScaledVector(Qe,o)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}},z=class{constructor(e=new M(1/0,1/0,1/0),t=new M(-1/0,-1/0,-1/0)){this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(ct.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(ct.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){let n=ct.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e,t=!1){return this.makeEmpty(),this.expandByObject(e,t)}clone(){return new this.constructor().copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e,t=!1){e.updateWorldMatrix(!1,!1);let n=e.geometry;if(n!==void 0){let r=n.getAttribute(`position`);if(t===!0&&r!==void 0&&e.isInstancedMesh!==!0)for(let t=0,n=r.count;t<n;t++)e.isMesh===!0?e.getVertexPosition(t,ct):ct.fromBufferAttribute(r,t),ct.applyMatrix4(e.matrixWorld),this.expandByPoint(ct);else e.boundingBox===void 0?(n.boundingBox===null&&n.computeBoundingBox(),lt.copy(n.boundingBox)):(e.boundingBox===null&&e.computeBoundingBox(),lt.copy(e.boundingBox)),lt.applyMatrix4(e.matrixWorld),this.union(lt)}let r=e.children;for(let e=0,n=r.length;e<n;e++)this.expandByObject(r[e],t);return this}containsPoint(e){return e.x>=this.min.x&&e.x<=this.max.x&&e.y>=this.min.y&&e.y<=this.max.y&&e.z>=this.min.z&&e.z<=this.max.z}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return e.max.x>=this.min.x&&e.min.x<=this.max.x&&e.max.y>=this.min.y&&e.min.y<=this.max.y&&e.max.z>=this.min.z&&e.min.z<=this.max.z}intersectsSphere(e){return this.clampPoint(e.center,ct),ct.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(gt),_t.subVectors(this.max,gt),ut.subVectors(e.a,gt),dt.subVectors(e.b,gt),ft.subVectors(e.c,gt),pt.subVectors(dt,ut),mt.subVectors(ft,dt),ht.subVectors(ut,ft);let t=[0,-pt.z,pt.y,0,-mt.z,mt.y,0,-ht.z,ht.y,pt.z,0,-pt.x,mt.z,0,-mt.x,ht.z,0,-ht.x,-pt.y,pt.x,0,-mt.y,mt.x,0,-ht.y,ht.x,0];return!bt(t,ut,dt,ft,_t)||(t=[1,0,0,0,1,0,0,0,1],!bt(t,ut,dt,ft,_t))?!1:(vt.crossVectors(pt,mt),t=[vt.x,vt.y,vt.z],bt(t,ut,dt,ft,_t))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,ct).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=this.getSize(ct).length()*.5),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()?this:(st[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),st[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),st[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),st[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),st[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),st[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),st[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),st[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(st),this)}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}toJSON(){return{min:this.min.toArray(),max:this.max.toArray()}}fromJSON(e){return this.min.fromArray(e.min),this.max.fromArray(e.max),this}};let st=[/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M,/*@__PURE__*/ new M],ct=/*@__PURE__*/ new M,lt=/*@__PURE__*/ new z,ut=/*@__PURE__*/ new M,dt=/*@__PURE__*/ new M,ft=/*@__PURE__*/ new M,pt=/*@__PURE__*/ new M,mt=/*@__PURE__*/ new M,ht=/*@__PURE__*/ new M,gt=/*@__PURE__*/ new M,_t=/*@__PURE__*/ new M,vt=/*@__PURE__*/ new M,yt=/*@__PURE__*/ new M;function bt(e,t,n,r,i){for(let a=0,o=e.length-3;a<=o;a+=3){yt.fromArray(e,a);let o=i.x*Math.abs(yt.x)+i.y*Math.abs(yt.y)+i.z*Math.abs(yt.z),s=t.dot(yt),c=n.dot(yt),l=r.dot(yt);if(Math.max(-Math.max(s,c,l),Math.min(s,c,l))>o)return!1}return!0}let B=/*@__PURE__*/ new M,xt=/*@__PURE__*/ new A,St=0;var Ct=class extends S{constructor(e,t,n=!1){if(super(),Array.isArray(e))throw TypeError(`THREE.BufferAttribute: array should be a Typed Array.`);this.isBufferAttribute=!0,Object.defineProperty(this,\"id\",{value:St++}),this.name=``,this.array=e,this.itemSize=t,this.count=e===void 0?0:e.length/t,this.normalized=n,this.usage=35044,this.updateRanges=[],this.gpuType=1015,this.version=0}onUploadCallback(){}set needsUpdate(e){e===!0&&this.version++}setUsage(e){return this.usage=e,this}addUpdateRange(e,t){this.updateRanges.push({start:e,count:t})}clearUpdateRanges(){this.updateRanges.length=0}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let r=0,i=this.itemSize;r<i;r++)this.array[e+r]=t.array[n+r];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(this.itemSize===2)for(let t=0,n=this.count;t<n;t++)xt.fromBufferAttribute(this,t),xt.applyMatrix3(e),this.setXY(t,xt.x,xt.y);else if(this.itemSize===3)for(let t=0,n=this.count;t<n;t++)B.fromBufferAttribute(this,t),B.applyMatrix3(e),this.setXYZ(t,B.x,B.y,B.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)B.fromBufferAttribute(this,t),B.applyMatrix4(e),this.setXYZ(t,B.x,B.y,B.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)B.fromBufferAttribute(this,t),B.applyNormalMatrix(e),this.setXYZ(t,B.x,B.y,B.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)B.fromBufferAttribute(this,t),B.transformDirection(e),this.setXYZ(t,B.x,B.y,B.z);return this}set(e,t=0){return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=O(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=k(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=O(t,this.array)),t}setX(e,t){return this.normalized&&(t=k(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=O(t,this.array)),t}setY(e,t){return this.normalized&&(t=k(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=O(t,this.array)),t}setZ(e,t){return this.normalized&&(t=k(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=O(t,this.array)),t}setW(e,t){return this.normalized&&(t=k(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=k(t,this.array),n=k(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,r){return e*=this.itemSize,this.normalized&&(t=k(t,this.array),n=k(n,this.array),r=k(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this}setXYZW(e,t,n,r,i){return e*=this.itemSize,this.normalized&&(t=k(t,this.array),n=k(n,this.array),r=k(r,this.array),i=k(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=r,this.array[e+3]=i,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){let e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return e.name=this.name,e.usage=this.usage,e.gpuType=this.gpuType,e}dispose(){this.dispatchEvent({type:`dispose`})}},wt=class extends Ct{constructor(e,t,n){super(new Uint16Array(e),t,n)}},Tt=class extends Ct{constructor(e,t,n){super(new Uint32Array(e),t,n)}},Et=class extends Ct{constructor(e,t,n){super(new Float32Array(e),t,n)}};let Dt=/*@__PURE__*/ new z,Ot=/*@__PURE__*/ new M,kt=/*@__PURE__*/ new M;var At=class{constructor(e=new M,t=-1){this.isSphere=!0,this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){let n=this.center;t===void 0?Dt.setFromPoints(e).getCenter(n):n.copy(t);let r=0;for(let t=0,i=e.length;t<i;t++)r=Math.max(r,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(r),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){let t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){let n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius*=e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;Ot.subVectors(e,this.center);let t=Ot.lengthSq();if(t>this.radius*this.radius){let e=Math.sqrt(t),n=(e-this.radius)*.5;this.center.addScaledVector(Ot,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(this.center.equals(e.center)===!0?this.radius=Math.max(this.radius,e.radius):(kt.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(Ot.copy(e.center).add(kt)),this.expandByPoint(Ot.copy(e.center).sub(kt))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return new this.constructor().copy(this)}toJSON(){return{radius:this.radius,center:this.center.toArray()}}fromJSON(e){return this.radius=e.radius,this.center.fromArray(e.center),this}};let jt=0,Mt=/*@__PURE__*/ new I,Nt=/*@__PURE__*/ new Ve,Pt=/*@__PURE__*/ new M,V=/*@__PURE__*/ new z,Ft=/*@__PURE__*/ new z,H=/*@__PURE__*/ new M;var It=class e extends S{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,\"id\",{value:jt++}),this.uuid=w(),this.name=``,this.type=`BufferGeometry`,this.index=null,this.indirect=null,this.indirectOffset=0,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={},this._transformed=!1}getIndex(){return this.index}setIndex(e){return this.index=Array.isArray(e)?new(m(e)?Tt:wt)(e,1):e,this}setIndirect(e,t=0){return this.indirect=e,this.indirectOffset=t,this}getIndirect(){return this.indirect}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return this.attributes[e]!==void 0}addGroup(e,t,n=0){this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){let t=this.attributes.position;t!==void 0&&(t.applyMatrix4(e),t.needsUpdate=!0);let n=this.attributes.normal;if(n!==void 0){let t=new P().getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}let r=this.attributes.tangent;return r!==void 0&&(r.transformDirection(e),r.needsUpdate=!0),this.boundingBox!==null&&this.computeBoundingBox(),this.boundingSphere!==null&&this.computeBoundingSphere(),this._transformed=!0,this}applyQuaternion(e){return Mt.makeRotationFromQuaternion(e),this.applyMatrix4(Mt),this}rotateX(e){return Mt.makeRotationX(e),this.applyMatrix4(Mt),this}rotateY(e){return Mt.makeRotationY(e),this.applyMatrix4(Mt),this}rotateZ(e){return Mt.makeRotationZ(e),this.applyMatrix4(Mt),this}translate(e,t,n){return Mt.makeTranslation(e,t,n),this.applyMatrix4(Mt),this}scale(e,t,n){return Mt.makeScale(e,t,n),this.applyMatrix4(Mt),this}lookAt(e){return Nt.lookAt(e),Nt.updateMatrix(),this.applyMatrix4(Nt.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter(Pt).negate(),this.translate(Pt.x,Pt.y,Pt.z),this}setFromPoints(e){let t=this.getAttribute(`position`);if(t===void 0){let t=[];for(let n=0,r=e.length;n<r;n++){let r=e[n];t.push(r.x,r.y,r.z||0)}this.setAttribute(`position`,new Et(t,3))}else{let n=Math.min(e.length,t.count);for(let r=0;r<n;r++){let n=e[r];t.setXYZ(r,n.x,n.y,n.z||0)}e.length>t.count&&y(`BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.`),t.needsUpdate=!0}return this}computeBoundingBox(){this.boundingBox===null&&(this.boundingBox=new z);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){b(`BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.`,this),this.boundingBox.set(new M(-1/0,-1/0,-1/0),new M(1/0,1/0,1/0));return}if(e!==void 0){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];V.setFromBufferAttribute(n),this.morphTargetsRelative?(H.addVectors(this.boundingBox.min,V.min),this.boundingBox.expandByPoint(H),H.addVectors(this.boundingBox.max,V.max),this.boundingBox.expandByPoint(H)):(this.boundingBox.expandByPoint(V.min),this.boundingBox.expandByPoint(V.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&b(`BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The \"position\" attribute is likely to have NaN values.`,this)}computeBoundingSphere(){this.boundingSphere===null&&(this.boundingSphere=new At);let e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute){b(`BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.`,this),this.boundingSphere.set(new M,1/0);return}if(e){let n=this.boundingSphere.center;if(V.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){let n=t[e];Ft.setFromBufferAttribute(n),this.morphTargetsRelative?(H.addVectors(V.min,Ft.min),V.expandByPoint(H),H.addVectors(V.max,Ft.max),V.expandByPoint(H)):(V.expandByPoint(Ft.min),V.expandByPoint(Ft.max))}V.getCenter(n);let r=0;for(let t=0,i=e.count;t<i;t++)H.fromBufferAttribute(e,t),r=Math.max(r,n.distanceToSquared(H));if(t)for(let i=0,a=t.length;i<a;i++){let a=t[i],o=this.morphTargetsRelative;for(let t=0,i=a.count;t<i;t++)H.fromBufferAttribute(a,t),o&&(Pt.fromBufferAttribute(e,t),H.add(Pt)),r=Math.max(r,n.distanceToSquared(H))}this.boundingSphere.radius=Math.sqrt(r),isNaN(this.boundingSphere.radius)&&b(`BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The \"position\" attribute is likely to have NaN values.`,this)}}computeTangents(){let e=this.index,t=this.attributes;if(e===null||t.position===void 0||t.normal===void 0||t.uv===void 0){b(`BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)`);return}let n=t.position,r=t.normal,i=t.uv,a=this.getAttribute(`tangent`);(a===void 0||a.count!==n.count)&&(a=new Ct(new Float32Array(4*n.count),4),this.setAttribute(`tangent`,a));let o=[],s=[];for(let e=0;e<n.count;e++)o[e]=new M,s[e]=new M;let c=new M,l=new M,u=new M,d=new A,f=new A,p=new A,m=new M,h=new M;function g(e,t,r){c.fromBufferAttribute(n,e),l.fromBufferAttribute(n,t),u.fromBufferAttribute(n,r),d.fromBufferAttribute(i,e),f.fromBufferAttribute(i,t),p.fromBufferAttribute(i,r),l.sub(c),u.sub(c),f.sub(d),p.sub(d);let a=1/(f.x*p.y-p.x*f.y);isFinite(a)&&(m.copy(l).multiplyScalar(p.y).addScaledVector(u,-f.y).multiplyScalar(a),h.copy(u).multiplyScalar(f.x).addScaledVector(l,-p.x).multiplyScalar(a),o[e].add(m),o[t].add(m),o[r].add(m),s[e].add(h),s[t].add(h),s[r].add(h))}let _=this.groups;_.length===0&&(_=[{start:0,count:e.count}]);for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)g(e.getX(t+0),e.getX(t+1),e.getX(t+2))}let v=new M,y=new M,x=new M,S=new M;function C(e){x.fromBufferAttribute(r,e),S.copy(x);let t=o[e];v.copy(t),v.sub(x.multiplyScalar(x.dot(t))).normalize(),y.crossVectors(S,t);let n=y.dot(s[e])<0?-1:1;a.setXYZW(e,v.x,v.y,v.z,n)}for(let t=0,n=_.length;t<n;++t){let n=_[t],r=n.start,i=n.count;for(let t=r,n=r+i;t<n;t+=3)C(e.getX(t+0)),C(e.getX(t+1)),C(e.getX(t+2))}this._transformed=!0}computeVertexNormals(){let e=this.index,t=this.getAttribute(`position`);if(t!==void 0){let n=this.getAttribute(`normal`);if(n===void 0||n.count!==t.count)n=new Ct(new Float32Array(t.count*3),3),this.setAttribute(`normal`,n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);let r=new M,i=new M,a=new M,o=new M,s=new M,c=new M,l=new M,u=new M;if(e)for(let d=0,f=e.count;d<f;d+=3){let f=e.getX(d+0),p=e.getX(d+1),m=e.getX(d+2);r.fromBufferAttribute(t,f),i.fromBufferAttribute(t,p),a.fromBufferAttribute(t,m),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),o.fromBufferAttribute(n,f),s.fromBufferAttribute(n,p),c.fromBufferAttribute(n,m),o.add(l),s.add(l),c.add(l),n.setXYZ(f,o.x,o.y,o.z),n.setXYZ(p,s.x,s.y,s.z),n.setXYZ(m,c.x,c.y,c.z)}else for(let e=0,o=t.count;e<o;e+=3)r.fromBufferAttribute(t,e+0),i.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),l.subVectors(a,i),u.subVectors(r,i),l.cross(u),n.setXYZ(e+0,l.x,l.y,l.z),n.setXYZ(e+1,l.x,l.y,l.z),n.setXYZ(e+2,l.x,l.y,l.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){let e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)H.fromBufferAttribute(e,t),H.normalize(),e.setXYZ(t,H.x,H.y,H.z)}toNonIndexed(){function t(e,t){let n=e.array,r=e.itemSize,i=e.normalized,a=new n.constructor(t.length*r),o=0,s=0;for(let i=0,c=t.length;i<c;i++){o=e.isInterleavedBufferAttribute?t[i]*e.data.stride+e.offset:t[i]*r;for(let e=0;e<r;e++)a[s++]=n[o++]}return new Ct(a,r,i)}if(this.index===null)return y(`BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.`),this;let n=new e,r=this.index.array,i=this.attributes;for(let e in i){let a=i[e],o=t(a,r);n.setAttribute(e,o)}let a=this.morphAttributes;for(let e in a){let i=[],o=a[e];for(let e=0,n=o.length;e<n;e++){let n=o[e],a=t(n,r);i.push(a)}n.morphAttributes[e]=i}n.morphTargetsRelative=this.morphTargetsRelative;let o=this.groups;for(let e=0,t=o.length;e<t;e++){let t=o[e];n.addGroup(t.start,t.count,t.materialIndex)}return n}toJSON(){let e={metadata:{version:4.7,type:`BufferGeometry`,generator:`BufferGeometry.toJSON`}};if(e.uuid=this.uuid,e.type=this.parameters!==void 0&&this._transformed===!0?`BufferGeometry`:this.type,e.name=this.name,Object.keys(this.userData).length>0&&(e.userData=this.userData),this.parameters!==void 0&&this._transformed!==!0){let t=this.parameters;for(let n in t)t[n]!==void 0&&(e[n]=t[n]);return e}e.data={attributes:{}};let t=this.index;t!==null&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});let n=this.attributes;for(let t in n){let r=n[t];e.data.attributes[t]=r.toJSON(e.data)}let r={},i=!1;for(let t in this.morphAttributes){let n=this.morphAttributes[t],a=[];for(let t=0,r=n.length;t<r;t++){let r=n[t];a.push(r.toJSON(e.data))}a.length>0&&(r[t]=a,i=!0)}i&&(e.data.morphAttributes=r,e.data.morphTargetsRelative=this.morphTargetsRelative);let a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));let o=this.boundingSphere;return o!==null&&(e.data.boundingSphere=o.toJSON()),e}clone(){return new this.constructor().copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;let t={};this.name=e.name;let n=e.index;n!==null&&this.setIndex(n.clone());let r=e.attributes;for(let e in r){let n=r[e];this.setAttribute(e,n.clone(t))}let i=e.morphAttributes;for(let e in i){let n=[],r=i[e];for(let e=0,i=r.length;e<i;e++)n.push(r[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;let a=e.groups;for(let e=0,t=a.length;e<t;e++){let t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}let o=e.boundingBox;o!==null&&(this.boundingBox=o.clone());let s=e.boundingSphere;return s!==null&&(this.boundingSphere=s.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this._transformed=e._transformed,this}dispose(){this.dispatchEvent({type:`dispose`})}};let Lt=/*@__PURE__*/ new M,Rt=/*@__PURE__*/ new M,zt=/*@__PURE__*/ new P;var Bt=class{constructor(e=new M(1,0,0),t=0){this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,r){return this.normal.set(e,t,n),this.constant=r,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){let r=Lt.subVectors(n,t).cross(Rt.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(r,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){let e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t,n=!0){let r=e.delta(Lt),i=this.normal.dot(r);if(i===0)return this.distanceToPoint(e.start)===0?t.copy(e.start):null;let a=-(e.start.dot(this.normal)+this.constant)/i;return n===!0&&(a<0||a>1)?null:t.copy(e.start).addScaledVector(r,a)}intersectsLine(e){let t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){let n=t||zt.getNormalMatrix(e),r=this.coplanarPoint(Lt).applyMatrix4(e),i=this.normal.applyMatrix3(n).normalize();return this.constant=-r.dot(i),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return new this.constructor().copy(this)}toJSON(){return{normal:this.normal.toArray(),constant:this.constant}}fromJSON(e){return this.normal.fromArray(e.normal),this.constant=e.constant,this}};let Vt=/*@__PURE__*/ new M,Ht=/*@__PURE__*/ new M,Ut=/*@__PURE__*/ new M,Wt=/*@__PURE__*/ new M;var Gt=class{constructor(e=new M,t=new M(0,0,-1)){this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,Vt)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);let n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){let t=Vt.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(Vt.copy(this.origin).addScaledVector(this.direction,t),Vt.distanceToSquared(e))}distanceSqToSegment(e,t,n,r){Ht.copy(e).add(t).multiplyScalar(.5),Ut.copy(t).sub(e).normalize(),Wt.copy(this.origin).sub(Ht);let i=e.distanceTo(t)*.5,a=-this.direction.dot(Ut),o=Wt.dot(this.direction),s=-Wt.dot(Ut),c=Wt.lengthSq(),l=Math.abs(1-a*a),u,d,f,p;if(l>0){if(u=a*s-o,d=a*o-s,p=i*l,u>=0){if(d>=-p){if(d<=p){let e=1/l;u*=e,d*=e,f=u*(u+a*d+2*o)+d*(a*u+d+2*s)+c}else d=i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d=-i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c}else d<=-p?(u=Math.max(0,-(-a*i+o)),d=u>0?-i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c):d<=p?(u=0,d=Math.min(Math.max(-i,-s),i),f=d*(d+2*s)+c):(u=Math.max(0,-(a*i+o)),d=u>0?i:Math.min(Math.max(-i,-s),i),f=-u*u+d*(d+2*s)+c)}else d=a>0?-i:i,u=Math.max(0,-(a*d+o)),f=-u*u+d*(d+2*s)+c;return n&&n.copy(this.origin).addScaledVector(this.direction,u),r&&r.copy(Ht).addScaledVector(Ut,d),f}intersectSphere(e,t){if(e.radius<0)return null;Vt.subVectors(e.center,this.origin);let n=Vt.dot(this.direction),r=Vt.dot(Vt)-n*n,i=e.radius*e.radius;if(r>i)return null;let a=Math.sqrt(i-r),o=n-a,s=n+a;return s<0?null:o<0?this.at(s,t):this.at(o,t)}intersectsSphere(e){return e.radius<0?!1:this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){let t=e.normal.dot(this.direction);if(t===0)return e.distanceToPoint(this.origin)===0?0:null;let n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){let n=this.distanceToPlane(e);return n===null?null:this.at(n,t)}intersectsPlane(e){let t=e.distanceToPoint(this.origin);return t===0||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,r,i,a,o,s,c=1/this.direction.x,l=1/this.direction.y,u=1/this.direction.z,d=this.origin;return c>=0?(n=(e.min.x-d.x)*c,r=(e.max.x-d.x)*c):(n=(e.max.x-d.x)*c,r=(e.min.x-d.x)*c),l>=0?(i=(e.min.y-d.y)*l,a=(e.max.y-d.y)*l):(i=(e.max.y-d.y)*l,a=(e.min.y-d.y)*l),n>a||i>r||((i>n||isNaN(n))&&(n=i),(a<r||isNaN(r))&&(r=a),u>=0?(o=(e.min.z-d.z)*u,s=(e.max.z-d.z)*u):(o=(e.max.z-d.z)*u,s=(e.min.z-d.z)*u),n>s||o>r)||((o>n||n!==n)&&(n=o),(s<r||r!==r)&&(r=s),r<0)?null:this.at(n>=0?n:r,t)}intersectsBox(e){return this.intersectBox(e,Vt)!==null}intersectTriangle(e,t,n,r,i){let a=this.origin,o=this.direction,s=o.x,c=o.y,l=o.z,u=e.x-a.x,d=e.y-a.y,f=e.z-a.z,p=t.x-a.x,m=t.y-a.y,h=t.z-a.z,g=n.x-a.x,_=n.y-a.y,v=n.z-a.z,y=Math.abs(s),b=Math.abs(c),x=Math.abs(l),S,C,w,T,E,D,O,k,A,j,M,N;if(y>=b&&y>=x?(w=s,D=u,A=p,N=g,s>=0?(S=c,C=l,T=d,E=f,O=m,k=h,j=_,M=v):(S=l,C=c,T=f,E=d,O=h,k=m,j=v,M=_)):b>=x?(w=c,D=d,A=m,N=_,c>=0?(S=l,C=s,T=f,E=u,O=h,k=p,j=v,M=g):(S=s,C=l,T=u,E=f,O=p,k=h,j=g,M=v)):(w=l,D=f,A=h,N=v,l>=0?(S=s,C=c,T=u,E=d,O=p,k=m,j=g,M=_):(S=c,C=s,T=d,E=u,O=m,k=p,j=_,M=g)),w===0)return null;let ee=S/w,P=C/w,te=1/w,ne=T-ee*D,re=E-P*D,ie=O-ee*A,F=k-P*A,ae=j-ee*N,oe=M-P*N,se=ae*F-oe*ie,ce=ne*oe-re*ae,le=ie*re-F*ne;if(r){if(se<0||ce<0||le<0)return null}else if((se<0||ce<0||le<0)&&(se>0||ce>0||le>0))return null;let ue=se+ce+le;if(ue===0)return null;let de=te*(se*D+ce*A+le*N);return(ue>0?de<0:de>0)?null:this.at(de/ue,i)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return new this.constructor().copy(this)}};function Kt(e,t){return!e||e.constructor===t?e:typeof t.BYTES_PER_ELEMENT==`number`?new t(e):Array.prototype.slice.call(e)}function qt(e){return e!==void 0&&e.inTangents!==void 0&&e.outTangents!==void 0}var Jt=class{constructor(e,t,n,r){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=r===void 0?new t.constructor(n):r,this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){let t=this.parameterPositions,n=this._cachedIndex,r=t[n],i=t[n-1];validate_interval:{seek:{let a;linear_scan:{forward_scan:if(!(e<r)){for(let a=n+2;;){if(r===void 0){if(e<i)break forward_scan;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(i=r,r=t[++n],e<r)break seek}a=t.length;break linear_scan}if(!(e>=i)){let o=t[1];e<o&&(n=2,i=o);for(let a=n-2;;){if(i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(r=i,i=t[--n-1],e>=i)break seek}a=n,n=0;break linear_scan}break validate_interval}for(;n<a;){let r=n+a>>>1;e<t[r]?a=r:n=r+1}if(r=t[n],i=t[n-1],i===void 0)return this._cachedIndex=0,this.copySampleValue_(0);if(r===void 0)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,i,r)}return this.interpolate_(n,i,e,r)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){let t=this.resultBuffer,n=this.sampleValues,r=this.valueSize,i=e*r;for(let e=0;e!==r;++e)t[e]=n[i+e];return t}interpolate_(){throw Error(`THREE.Interpolant: Call to abstract method.`)}intervalChanged_(){}},Yt=class extends Jt{constructor(e,t,n,r){super(e,t,n,r),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:s,endingEnd:s}}intervalChanged_(e,t,n){let r=this.parameterPositions,i=e-2,a=e+1,o=r[i],s=r[a];if(o===void 0)switch(this.getSettings_().endingStart){case c:i=e,o=2*t-n;break;case l:i=r.length-2,o=t+r[i]-r[i+1];break;default:i=e,o=n}if(s===void 0)switch(this.getSettings_().endingEnd){case c:a=e,s=2*n-t;break;case l:a=1,s=n+r[1]-r[0];break;default:a=e-1,s=t}let u=(n-t)*.5,d=this.valueSize;this._weightPrev=u/(t-o),this._weightNext=u/(s-n),this._offsetPrev=i*d,this._offsetNext=a*d}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this._offsetPrev,u=this._offsetNext,d=this._weightPrev,f=this._weightNext,p=(n-t)/(r-t),m=p*p,h=m*p,g=-d*h+2*d*m-d*p,_=(1+d)*h+(-1.5-2*d)*m+(-.5+d)*p+1,v=(-1-f)*h+(1.5+f)*m+.5*p,y=f*h-f*m;for(let e=0;e!==o;++e)i[e]=g*a[l+e]+_*a[c+e]+v*a[s+e]+y*a[u+e];return i}},Xt=class extends Jt{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=(n-t)/(r-t),u=1-l;for(let e=0;e!==o;++e)i[e]=a[c+e]*u+a[s+e]*l;return i}},Zt=class extends Jt{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e){return this.copySampleValue_(e-1)}},Qt=class extends Jt{interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=e*o,c=s-o,l=this.inTangents,u=this.outTangents;if(!l||!u){let e=(n-t)/(r-t),l=1-e;for(let t=0;t!==o;++t)i[t]=a[c+t]*l+a[s+t]*e;return i}let d=o*2,f=e-1;for(let p=0;p!==o;++p){let o=a[c+p],m=a[s+p],h=f*d+p*2,g=u[h],_=u[h+1],v=e*d+p*2,y=l[v],b=l[v+1],x=tn(n,t,g,y,r);i[p]=$t(x,o,_,b,m)}return i}};function $t(e,t,n,r,i){let a=1-e;return a*a*a*t+3*a*a*e*n+3*a*e*e*r+e*e*e*i}function en(e,t,n,r,i){let a=1-e;return 3*a*a*(n-t)+6*a*e*(r-n)+3*e*e*(i-r)}function tn(e,t,n,r,i){let a=(e-t)/(i-t);for(let o=0;o<8;o++){let o=$t(a,t,n,r,i)-e;if(Math.abs(o)<1e-10)break;let s=en(a,t,n,r,i);if(Math.abs(s)<1e-10)break;a=Math.max(0,Math.min(1,a-o/s))}return a}var nn=class{constructor(e,t,n,r){if(e===void 0)throw Error(`THREE.KeyframeTrack: track name is undefined`);if(t===void 0||t.length===0)throw Error(`THREE.KeyframeTrack: no keyframes in track named `+e);this.name=e,this.times=Kt(t,this.TimeBufferType),this.values=Kt(n,this.ValueBufferType),this.setInterpolation(r||this.DefaultInterpolation)}static toJSON(e){let t=e.constructor,n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:Kt(e.times,Array),values:Kt(e.values,Array)};let t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t),qt(e.settings)&&(n.settings={inTangents:Kt(e.settings.inTangents,Array),outTangents:Kt(e.settings.outTangents,Array)})}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new Zt(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new Xt(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new Yt(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodBezier(e){let t=new Qt(this.times,this.values,this.getValueSize(),e);return this.settings&&(t.inTangents=this.settings.inTangents,t.outTangents=this.settings.outTangents),t}setInterpolation(e){let t;switch(e){case r:t=this.InterpolantFactoryMethodDiscrete;break;case i:t=this.InterpolantFactoryMethodLinear;break;case a:t=this.InterpolantFactoryMethodSmooth;break;case o:t=this.InterpolantFactoryMethodBezier}if(t===void 0){let t=`unsupported interpolation for `+this.ValueTypeName+` keyframe track named `+this.name;if(this.createInterpolant===void 0){if(e!==this.DefaultInterpolation)this.setInterpolation(this.DefaultInterpolation);else throw Error(t)}return y(`KeyframeTrack:`,t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return r;case this.InterpolantFactoryMethodLinear:return i;case this.InterpolantFactoryMethodSmooth:return a;case this.InterpolantFactoryMethodBezier:return o}}getValueSize(){return this.values.length/this.times.length}shift(e){if(e!==0){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]+=e}return this}scale(e){if(e!==1){let t=this.times;for(let n=0,r=t.length;n!==r;++n)t[n]*=e;qt(this.settings)&&(rn(this.settings.inTangents,e),rn(this.settings.outTangents,e))}return this}trim(e,t){let n=this.times,r=n.length,i=0,a=r-1;for(;i!==r&&n[i]<e;)++i;for(;a!==-1&&n[a]>t;)--a;if(++a,i!==0||a!==r){i>=a&&(a=Math.max(a,1),i=a-1);let e=this.getValueSize();this.times=n.slice(i,a),this.values=this.values.slice(i*e,a*e)}return this}validate(){let e=!0,t=this.getValueSize();t-Math.floor(t)!==0&&(b(`KeyframeTrack: Invalid value size in track.`,this),e=!1);let n=this.times,r=this.values,i=n.length;i===0&&(b(`KeyframeTrack: Track is empty.`,this),e=!1);let a=null;for(let t=0;t!==i;t++){let r=n[t];if(typeof r==`number`&&isNaN(r)){b(`KeyframeTrack: Time is not a valid number.`,this,t,r),e=!1;break}if(a!==null&&a>r){b(`KeyframeTrack: Out of order keys.`,this,t,r,a),e=!1;break}a=r}if(r!==void 0&&h(r))for(let t=0,n=r.length;t!==n;++t){let n=r[t];if(isNaN(n)){b(`KeyframeTrack: Value is not a valid number.`,this,t,n),e=!1;break}}return e}optimize(){let e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),r=this.getInterpolation()===a,i=e.length-1,o=1;for(let a=1;a<i;++a){let i=!1,s=e[a];if(s!==e[a+1]&&(a!==1||s!==e[0])){if(r)i=!0;else{let e=a*n,r=e-n,o=e+n;for(let a=0;a!==n;++a){let n=t[e+a];if(n!==t[r+a]||n!==t[o+a]){i=!0;break}}}}if(i){if(a!==o){e[o]=e[a];let r=a*n,i=o*n;for(let e=0;e!==n;++e)t[i+e]=t[r+e]}++o}}if(i>0){e[o]=e[i];for(let e=i*n,r=o*n,a=0;a!==n;++a)t[r+a]=t[e+a];++o}return o===e.length?(this.times=e,this.values=t):(this.times=e.slice(0,o),this.values=t.slice(0,o*n)),this}clone(){let e=this.times.slice(),t=this.values.slice(),n=this.constructor,r=new n(this.name,e,t);return r.createInterpolant=this.createInterpolant,qt(this.settings)&&(r.settings={inTangents:this.settings.inTangents.slice(),outTangents:this.settings.outTangents.slice()}),r}};function rn(e,t){for(let n=0,r=e.length;n!==r;n+=2)e[n]*=t}nn.prototype.ValueTypeName=``,nn.prototype.TimeBufferType=Float32Array,nn.prototype.ValueBufferType=Float32Array,nn.prototype.DefaultInterpolation=i;var an=class extends nn{constructor(e,t,n){super(e,t,n)}};an.prototype.ValueTypeName=`bool`,an.prototype.ValueBufferType=Array,an.prototype.DefaultInterpolation=r,an.prototype.InterpolantFactoryMethodLinear=void 0,an.prototype.InterpolantFactoryMethodSmooth=void 0;var on=class extends nn{constructor(e,t,n,r){super(e,t,n,r)}};on.prototype.ValueTypeName=`color`;var sn=class extends nn{constructor(e,t,n,r){super(e,t,n,r)}};sn.prototype.ValueTypeName=`number`;var cn=class extends Jt{constructor(e,t,n,r){super(e,t,n,r)}interpolate_(e,t,n,r){let i=this.resultBuffer,a=this.sampleValues,o=this.valueSize,s=(n-t)/(r-t),c=e*o;for(let e=c+o;c!==e;c+=4)j.slerpFlat(i,0,a,c-o,a,c,s);return i}},ln=class extends nn{constructor(e,t,n,r){super(e,t,n,r)}InterpolantFactoryMethodLinear(e){return new cn(this.times,this.values,this.getValueSize(),e)}};ln.prototype.ValueTypeName=`quaternion`,ln.prototype.InterpolantFactoryMethodSmooth=void 0;var un=class extends nn{constructor(e,t,n){super(e,t,n)}};un.prototype.ValueTypeName=`string`,un.prototype.ValueBufferType=Array,un.prototype.DefaultInterpolation=r,un.prototype.InterpolantFactoryMethodLinear=void 0,un.prototype.InterpolantFactoryMethodSmooth=void 0;var dn=class extends nn{constructor(e,t,n,r){super(e,t,n,r)}};dn.prototype.ValueTypeName=`vector`;let fn=/* @__PURE__ */ RegExp(`[\\\\[\\\\]\\\\.:\\\\/]`,`g`),pn=/* @__PURE__ */ RegExp(`^((?:[^\\\\[\\\\]\\\\.:\\\\/]+[\\\\/:])*)([^\\\\[\\\\]:\\\\/]+)?(?:\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?)?\\\\.([^\\\\[\\\\]\\\\.:\\\\/]+)(?:\\\\[(.+)\\\\])?$`),mn=[`material`,`materials`,`bones`,`map`];var hn=class{constructor(e,t,n){let r=n||U.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,r)}getValue(e,t){this.bind();let n=this._targetGroup.nCachedObjects_,r=this._bindings[n];r!==void 0&&r.getValue(e,t)}setValue(e,t){let n=this._bindings;for(let r=this._targetGroup.nCachedObjects_,i=n.length;r!==i;++r)n[r].setValue(e,t)}bind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){let e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},U=class e{constructor(t,n,r){this.path=n,this.parsedPath=r||e.parseTrackName(n),this.node=e.findNode(t,this.parsedPath.nodeName),this.rootNode=t,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(t,n,r){return t&&t.isAnimationObjectGroup?new e.Composite(t,n,r):new e(t,n,r)}static sanitizeNodeName(e){return e.replace(/\\s/g,`_`).replace(fn,``)}static parseTrackName(e){let t=pn.exec(e);if(t===null)throw Error(`THREE.PropertyBinding: Cannot parse trackName: `+e);let n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},r=n.nodeName&&n.nodeName.lastIndexOf(`.`);if(r!==void 0&&r!==-1){let e=n.nodeName.substring(r+1);mn.indexOf(e)!==-1&&(n.nodeName=n.nodeName.substring(0,r),n.objectName=e)}if(n.propertyName===null||n.propertyName.length===0)throw Error(`THREE.PropertyBinding: can not parse propertyName from trackName: `+e);return n}static findNode(e,t){if(t===void 0||t===``||t===`.`||t===-1||t===e.name||t===e.uuid)return e;if(e.skeleton){let n=e.skeleton.getBoneByName(t);if(n!==void 0)return n}if(e.children){let n=function(e){for(let r=0;r<e.length;r++){let i=e[r];if(i.name===t||i.uuid===t)return i;let a=n(i.children);if(a)return a}return null},r=n(e.children);if(r)return r}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)e[t++]=n[r]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++]}_setValue_array_setNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){let n=this.resolvedProperty;for(let r=0,i=n.length;r!==i;++r)n[r]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let t=this.node,n=this.parsedPath,r=n.objectName,i=n.propertyName,a=n.propertyIndex;if(t||(t=e.findNode(this.rootNode,n.nodeName),this.node=t),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!t){y(`PropertyBinding: No target node found for track: `+this.path+`.`);return}if(r){let e=n.objectIndex;switch(r){case`materials`:if(!t.material){b(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.materials){b(`PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.`,this);return}t=t.material.materials;break;case`bones`:if(!t.skeleton){b(`PropertyBinding: Can not bind to bones as node does not have a skeleton.`,this);return}t=t.skeleton.bones;for(let n=0;n<t.length;n++)if(t[n].name===e){e=n;break}break;case`map`:if(`map`in t){t=t.map;break}if(!t.material){b(`PropertyBinding: Can not bind to material as node does not have a material.`,this);return}if(!t.material.map){b(`PropertyBinding: Can not bind to material.map as node.material does not have a map.`,this);return}t=t.material.map;break;default:if(t[r]===void 0){b(`PropertyBinding: Can not bind to objectName of node undefined.`,this);return}t=t[r]}if(e!==void 0){if(t[e]===void 0){b(`PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.`,this,t);return}t=t[e]}}let o=t[i];if(o===void 0){let e=n.nodeName;b(`PropertyBinding: Trying to update property for track: `+e+`.`+i+` but it wasn't found.`,t);return}let s=this.Versioning.None;this.targetObject=t,t.isMaterial===!0?s=this.Versioning.NeedsUpdate:t.isObject3D===!0&&(s=this.Versioning.MatrixWorldNeedsUpdate);let c=this.BindingType.Direct;if(a!==void 0){if(i===`morphTargetInfluences`){if(!t.geometry){b(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.`,this);return}if(!t.geometry.morphAttributes){b(`PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.`,this);return}t.morphTargetDictionary[a]!==void 0&&(a=t.morphTargetDictionary[a])}c=this.BindingType.ArrayElement,this.resolvedProperty=o,this.propertyIndex=a}else o.fromArray!==void 0&&o.toArray!==void 0?(c=this.BindingType.HasFromToArray,this.resolvedProperty=o):Array.isArray(o)?(c=this.BindingType.EntireArray,this.resolvedProperty=o):this.propertyName=i;this.getValue=this.GetterByBindingType[c],this.setValue=this.SetterByBindingTypeAndVersioning[c][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}};U.Composite=hn,U.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},U.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},U.prototype.GetterByBindingType=[U.prototype._getValue_direct,U.prototype._getValue_array,U.prototype._getValue_arrayElement,U.prototype._getValue_toArray],U.prototype.SetterByBindingTypeAndVersioning=[[U.prototype._setValue_direct,U.prototype._setValue_direct_setNeedsUpdate,U.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[U.prototype._setValue_array,U.prototype._setValue_array_setNeedsUpdate,U.prototype._setValue_array_setMatrixWorldNeedsUpdate],[U.prototype._setValue_arrayElement,U.prototype._setValue_arrayElement_setNeedsUpdate,U.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[U.prototype._setValue_fromArray,U.prototype._setValue_fromArray_setNeedsUpdate,U.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],class e{static{e.prototype.isMatrix2=!0}constructor(e,t,n,r){this.elements=[1,0,0,1],e!==void 0&&this.set(e,t,n,r)}identity(){return this.set(1,0,0,1),this}fromArray(e,t=0){for(let n=0;n<4;n++)this.elements[n]=e[n+t];return this}set(e,t,n,r){let i=this.elements;return i[0]=e,i[2]=t,i[1]=n,i[3]=r,this}};let gn=/*@__PURE__*/ new M,_n=/*@__PURE__*/ new M,vn=/*@__PURE__*/ new M,yn=/*@__PURE__*/ new M,bn=/*@__PURE__*/ new M,xn=/*@__PURE__*/ new M,Sn=/*@__PURE__*/ new M;var Cn=class{constructor(e=new M,t=new M){this.start=e,this.end=t}set(e,t){return this.start.copy(e),this.end.copy(t),this}copy(e){return this.start.copy(e.start),this.end.copy(e.end),this}getCenter(e){return e.addVectors(this.start,this.end).multiplyScalar(.5)}delta(e){return e.subVectors(this.end,this.start)}distanceSq(){return this.start.distanceToSquared(this.end)}distance(){return this.start.distanceTo(this.end)}at(e,t){return this.delta(t).multiplyScalar(e).add(this.start)}closestPointToPointParameter(e,t){gn.subVectors(e,this.start),_n.subVectors(this.end,this.start);let n=_n.dot(_n);if(n===0)return 0;let r=_n.dot(gn)/n;return t&&(r=T(r,0,1)),r}closestPointToPoint(e,t,n){let r=this.closestPointToPointParameter(e,t);return this.delta(n).multiplyScalar(r).add(this.start)}distanceSqToLine3(e,t=xn,n=Sn){let r=1e-8*1e-8,i,a,o=this.start,s=e.start,c=this.end,l=e.end;vn.subVectors(c,o),yn.subVectors(l,s),bn.subVectors(o,s);let u=vn.dot(vn),d=yn.dot(yn),f=yn.dot(bn);if(u<=r&&d<=r)return t.copy(o),n.copy(s),t.sub(n),t.dot(t);if(u<=r)i=0,a=f/d,a=T(a,0,1);else{let e=vn.dot(bn);if(d<=r)a=0,i=T(-e/u,0,1);else{let t=vn.dot(yn),n=u*d-t*t;i=n===0?0:T((t*f-e*d)/n,0,1),a=(t*i+f)/d,a<0?(a=0,i=T(-e/u,0,1)):a>1&&(a=1,i=T((t-e)/u,0,1))}}return t.copy(o).addScaledVector(vn,i),n.copy(s).addScaledVector(yn,a),t.distanceToSquared(n)}applyMatrix4(e){return this.start.applyMatrix4(e),this.end.applyMatrix4(e),this}equals(e){return e.start.equals(this.start)&&e.end.equals(this.end)}clone(){return new this.constructor().copy(this)}};typeof __THREE_DEVTOOLS__<`u`&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent(`register`,{detail:{revision:`186`}})),typeof window<`u`&&(window.__THREE__?y(`WARNING: Multiple instances of Three.js being imported.`):window.__THREE__=`186`);let wn=1e-9;function Tn(e){let{granularities:t}=e;if(t.length===0)throw Error(`At least one granularity is required.`);if(t.some(e=>!Number.isFinite(e)||e<=0))throw Error(`Granularities must be finite positive numbers.`);for(let e=1;e<t.length;e++){let n=t[e-1],r=t[e];if(r>=n)throw Error(`Granularities must be strictly decreasing.`);let i=n/r;if(Math.abs(i-Math.round(i))>wn)throw Error(`Granularity ${n} must be exactly divisible by ${r}.`)}if(!Number.isInteger(e.boxTreeLevel)||e.boxTreeLevel<0)throw Error(`The BoxTree level must be a positive integer.`);if(!Number.isInteger(e.workerCount)||e.workerCount<=0||e.workerCount>32)throw Error(`The worker count must be an integer between 1 and 32.`);if(!Number.isInteger(e.maxVoxelCount)||e.maxVoxelCount<=0)throw Error(`The maximum voxel count must be a positive integer.`)}function En(e,t){return new Float64Array([Math.floor(e[0]/t+wn)*t,Math.floor(e[1]/t+wn)*t,Math.floor(e[2]/t+wn)*t,Math.ceil(e[3]/t-wn)*t,Math.ceil(e[4]/t-wn)*t,Math.ceil(e[5]/t-wn)*t])}let Dn=/* @__PURE__ */ new Gt,On=/* @__PURE__ */ new Gt,kn=/* @__PURE__ */ new M,An=/* @__PURE__ */ new M(0,-1,0),jn=1e-5;function Mn(e,t,n){Dn.origin.set((n.min.x+n.max.x)/2,n.max.y+jn,(n.min.z+n.max.z)/2),Dn.direction.copy(An),On.copy(Dn).applyMatrix4(e.inverseMatrix);let r=t.bvh.raycastFirst(On,2);return!r||(kn.copy(r.point).applyMatrix4(e.localToWorldMatrix),kn.y<n.min.y-jn||kn.y>n.max.y+jn)?NaN:kn.y}function Nn(e,t,n,r){let{node:i}=e.layout;return!(t[n+i.MAX_X]<r.min.x||t[n+i.MIN_X]>r.max.x||t[n+i.MAX_Y]<r.min.y||t[n+i.MIN_Y]>r.max.y||t[n+i.MAX_Z]<r.min.z||t[n+i.MIN_Z]>r.max.z)}function Pn(e,t){let{header:n,node:r}=e;return n.STRIDE+t*r.STRIDE}function Fn(e,t){return{root:e.boxTree.root,layout:e.boxTree.layout,bounds:new Float32Array(e.boxTree.buffer),indices:new Int32Array(e.boxTree.buffer),instancesByLeaf:t,stack:[]}}function In(e,t,n,r){if(r.length=0,e.root===e.layout.notDefined)return;let{bounds:i,indices:a,instancesByLeaf:o,stack:s}=e,{node:c,notDefined:l}=e.layout;for(s.length=0,s.push(e.root,0,0);s.length>0;){let u=s.pop()===1,d=s.pop(),f=s.pop(),p=Pn(e.layout,f);if(!u&&!Nn(e,i,p,t))continue;let m=a[p+c.OBJID];if(m!==l){o[m]!==void 0&&r.push(m);continue}let h=u||d>=n,g=d+1,_=+!!h;s.push(a[p+c.LEFT],g,_,a[p+c.RIGHT],g,_)}}function Ln(e,t,n,r){r.length=0;let{bounds:i}=e;for(let a of n)Nn(e,i,Pn(e.layout,a),t)&&r.push(a)}function Rn(e,t,n,r,i,a=!1){let{instancesByLeaf:o}=e;zn(i);for(let e of t){let t=o[e];if(t!==void 0)for(let e of t){let t=r[e.geometryIndex];if(t?.bvh.intersectsBox(n,e.inverseMatrix)&&(Bn(i,e,t,n,a),!a&&i.verticalConnectionAllowed))return i}}return i}function zn(e){e.solid=!1,e.verticalConnectionAllowed=!1,e.horizontalConnectionAllowed=!1,e.supportHeight=NaN,e.supportId=-1}function Bn(e,t,n,r,i){if(t.occupancyBlocking===!1){e.horizontalConnectionAllowed=!0;return}if(e.solid=!0,e.verticalConnectionAllowed||=t.verticalConnectionAllowed===!0,!i)return;let a=Mn(t,n,r);Number.isFinite(a)&&(!Number.isNaN(e.supportHeight)&&a<=e.supportHeight||(e.supportHeight=a,e.supportId=t.supportId))}let Vn=/* @__PURE__ */ function(e){return e[e.Unclassified=0]=`Unclassified`,e[e.Solid=1]=`Solid`,e[e.Navigable=2]=`Navigable`,e}({});function Hn(e){let t=new Int32Array(new SharedArrayBuffer(e.length*Int32Array.BYTES_PER_ELEMENT));return t.set(e),t}function Un(e){let t=new Uint8Array(new SharedArrayBuffer(e.length*Uint8Array.BYTES_PER_ELEMENT));return t.set(e),t}function Wn(e){if(!Array.isArray(e)&&e.buffer[Symbol.toStringTag]===`SharedArrayBuffer`)return e;let t=new Float32Array(new SharedArrayBuffer(e.length*Float32Array.BYTES_PER_ELEMENT));return t.set(e),t}let Gn=1024;var Kn=class{constructor(){this.values=new Int32Array(Gn*4),this.voxelCount=0}get length(){return this.voxelCount}reset(e){this.voxelCount=0,this.push(e.x,e.y,e.z,e.level)}push(e,t,n,r){this.ensureCapacity(this.voxelCount+1);let i=this.voxelCount*4;this.values[i]=e,this.values[i+1]=t,this.values[i+2]=n,this.values[i+3]=r,this.voxelCount++}pop(e){if(this.voxelCount===0)return!1;this.voxelCount--;let t=this.voxelCount*4;return e.x=this.values[t],e.y=this.values[t+1],e.z=this.values[t+2],e.level=this.values[t+3],!0}ensureCapacity(e){if(e*4<=this.values.length)return;let t=new Int32Array(Math.max(this.values.length*2,e*4));t.set(this.values),this.values=t}},qn=class{constructor(){this.pending=new Kn,this.coordinates=new Int32Array(Gn*3),this.levels=new Uint8Array(Gn),this.states=new Uint8Array(Gn),this.verticalConnections=new Uint8Array(Gn),this.horizontalConnections=new Uint8Array(Gn),this.supportHeights=new Float32Array(Gn),this.supportIds=new Int32Array(Gn).fill(-1),this.currentLeafCount=0}get leafCount(){return this.currentLeafCount}reset(e){this.currentLeafCount=0,this.pending.reset(e)}pushLeaf(e,t,n=!1,r=!1,i=NaN,a=-1){this.ensureLeafCapacity(this.currentLeafCount+1);let o=this.currentLeafCount*3;this.coordinates[o]=e.x,this.coordinates[o+1]=e.y,this.coordinates[o+2]=e.z,this.levels[this.currentLeafCount]=e.level,this.states[this.currentLeafCount]=t,this.verticalConnections[this.currentLeafCount]=+!!n,this.horizontalConnections[this.currentLeafCount]=+!!r,this.supportHeights[this.currentLeafCount]=i,this.supportIds[this.currentLeafCount]=a,this.currentLeafCount++}getCopiedCoordinates(){return Hn(this.coordinates.subarray(0,this.currentLeafCount*3))}getCopiedLevels(){return Un(this.levels.subarray(0,this.currentLeafCount))}getCopiedStates(){return Un(this.states.subarray(0,this.currentLeafCount))}getCopiedVerticalConnections(){return Un(this.verticalConnections.subarray(0,this.currentLeafCount))}getCopiedSupportHeights(){return Wn(this.supportHeights.subarray(0,this.currentLeafCount))}getCopiedSupportIds(){return Hn(this.supportIds.subarray(0,this.currentLeafCount))}getCopiedHorizontalConnections(){return Un(this.horizontalConnections.subarray(0,this.currentLeafCount))}ensureLeafCapacity(e){if(e<=this.levels.length)return;let t=Math.max(this.levels.length*2,e),n=new Int32Array(t*3),r=new Uint8Array(t),i=new Uint8Array(t),a=new Uint8Array(t),o=new Uint8Array(t),s=new Float32Array(t),c=new Int32Array(t);c.fill(-1),n.set(this.coordinates),r.set(this.levels),i.set(this.states),a.set(this.verticalConnections),o.set(this.horizontalConnections),s.set(this.supportHeights),c.set(this.supportIds),this.coordinates=n,this.levels=r,this.states=i,this.verticalConnections=a,this.horizontalConnections=o,this.supportHeights=s,this.supportIds=c}};function Jn(e,t,n,r){for(let i=0;i<n;i++)for(let a=0;a<n;a++)for(let o=0;o<n;o++)r.push(e.x*n+o,e.y*n+a,e.z*n+i,t)}function Yn(e,t,n,r,i){r.pushLeaf(e,t?Vn.Solid:Vn.Unclassified,t&&n.verticalConnectionAllowed,!t&&n.horizontalConnectionAllowed,t?n.supportHeight:NaN,t?n.supportId:-1),t?i.solidVoxelCount++:i.emptyVoxelCount++}function Xn(e,t,n,r){return{rootCoordinates:Hn([e.x,e.y,e.z]),bounds:new Float64Array([n[0]+e.x*t,n[1]+e.y*t,n[2]+e.z*t,n[0]+(e.x+1)*t,n[1]+(e.y+1)*t,n[2]+(e.z+1)*t]),coordinates:r.getCopiedCoordinates(),levels:r.getCopiedLevels(),states:r.getCopiedStates(),verticalConnections:r.getCopiedVerticalConnections(),horizontalConnections:r.getCopiedHorizontalConnections(),supportHeights:r.getCopiedSupportHeights(),supportIds:r.getCopiedSupportIds()}}let Zn=1.25,Qn=65535,$n=2**-24,er=Symbol(`SKIP_GENERATION`),tr={strategy:0,maxDepth:40,targetLeafSize:10,useSharedArrayBuffer:!1,setBoundingBox:!0,onProgress:null,indirect:!1,verbose:!0,range:null,[er]:!1};function W(e,t,n){return n.min.x=t[e],n.min.y=t[e+1],n.min.z=t[e+2],n.max.x=t[e+3],n.max.y=t[e+4],n.max.z=t[e+5],n}function nr(e){let t=-1,n=-1/0;for(let r=0;r<3;r++){let i=e[r+3]-e[r];i>n&&(n=i,t=r)}return t}function rr(e,t){t.set(e)}function ir(e,t,n){let r,i;for(let a=0;a<3;a++){let o=a+3;r=e[a],i=t[a],n[a]=r<i?r:i,r=e[o],i=t[o],n[o]=r>i?r:i}}function ar(e,t,n){for(let r=0;r<3;r++){let i=t[e+2*r],a=t[e+2*r+1],o=i-a,s=i+a;o<n[r]&&(n[r]=o),s>n[r+3]&&(n[r+3]=s)}}function or(e){let t=e[3]-e[0],n=e[4]-e[1],r=e[5]-e[2];return 2*(t*n+n*r+r*t)}function G(e,t){return t[e+15]===Qn}function K(e,t){return t[e+6]}function q(e,t){return t[e+14]}function J(e){return e+8}function Y(e,t){return e+t[e+6]*8}function sr(e,t){return t[e+7]}function X(e){return e}function cr(e,t,n,r,i){let a=1/0,o=1/0,s=1/0,c=-1/0,l=-1/0,u=-1/0,d=1/0,f=1/0,p=1/0,m=-1/0,h=-1/0,g=-1/0,_=e.offset||0;for(let r=(t-_)*6,i=(t+n-_)*6;r<i;r+=6){let t=e[r+0],n=e[r+1],i=t-n,_=t+n;i<a&&(a=i),_>c&&(c=_),t<d&&(d=t),t>m&&(m=t);let v=e[r+2],y=e[r+3],b=v-y,x=v+y;b<o&&(o=b),x>l&&(l=x),v<f&&(f=v),v>h&&(h=v);let S=e[r+4],C=e[r+5],w=S-C,T=S+C;w<s&&(s=w),T>u&&(u=T),S<p&&(p=S),S>g&&(g=S)}r[0]=a,r[1]=o,r[2]=s,r[3]=c,r[4]=l,r[5]=u,i[0]=d,i[1]=f,i[2]=p,i[3]=m,i[4]=h,i[5]=g}let lr=(e,t)=>e.candidate-t.candidate,ur=/* @__PURE__ */ Array(32).fill().map(()=>({count:0,bounds:/* @__PURE__ */ new Float32Array(6),rightCacheBounds:/* @__PURE__ */ new Float32Array(6),leftCacheBounds:/* @__PURE__ */ new Float32Array(6),candidate:0})),dr=/* @__PURE__ */ new Float32Array(6);function fr(e,t,n,r,i,a){let o=-1,s=0;if(a===0)o=nr(t),o!==-1&&(s=(t[o]+t[o+3])/2);else if(a===1)o=nr(e),o!==-1&&(s=pr(n,r,i,o));else if(a===2){let a=or(e),c=Zn*i,l=n.offset||0,u=(r-l)*6,d=(r+i-l)*6;for(let e=0;e<3;e++){let r=t[e],l=(t[e+3]-r)/32;if(i<8){let t=[...ur];t.length=i;let r=0;for(let i=u;i<d;i+=6,r++){let a=t[r];a.candidate=n[i+2*e],a.count=0;let{bounds:o,leftCacheBounds:s,rightCacheBounds:c}=a;for(let e=0;e<3;e++)c[e]=1/0,c[e+3]=-1/0,s[e]=1/0,s[e+3]=-1/0,o[e]=1/0,o[e+3]=-1/0;ar(i,n,o)}t.sort(lr);let l=i;for(let e=0;e<l;e++){let n=t[e];for(;e+1<l&&t[e+1].candidate===n.candidate;)t.splice(e+1,1),l--}for(let r=u;r<d;r+=6){let i=n[r+2*e];for(let e=0;e<l;e++){let a=t[e];i>=a.candidate?ar(r,n,a.rightCacheBounds):(ar(r,n,a.leftCacheBounds),a.count++)}}for(let n=0;n<l;n++){let r=t[n],l=r.count,u=i-r.count,d=r.leftCacheBounds,f=r.rightCacheBounds,p=0;l!==0&&(p=or(d)/a);let m=0;u!==0&&(m=or(f)/a);let h=1+Zn*(p*l+m*u);h<c&&(o=e,c=h,s=r.candidate)}}else{for(let e=0;e<32;e++){let t=ur[e];t.count=0,t.candidate=r+l+e*l;let n=t.bounds;for(let e=0;e<3;e++)n[e]=1/0,n[e+3]=-1/0}for(let t=u;t<d;t+=6){let i=~~((n[t+2*e]-r)/l);i>=32&&(i=31);let a=ur[i];a.count++,ar(t,n,a.bounds)}let t=ur[31];rr(t.bounds,t.rightCacheBounds);for(let e=30;e>=0;e--){let t=ur[e],n=ur[e+1];ir(t.bounds,n.rightCacheBounds,t.rightCacheBounds)}let f=0;for(let t=0;t<31;t++){let n=ur[t],r=n.count,l=n.bounds,u=ur[t+1].rightCacheBounds;r!==0&&(f===0?rr(l,dr):ir(l,dr,dr)),f+=r;let d=0,p=0;f!==0&&(d=or(dr)/a);let m=i-f;m!==0&&(p=or(u)/a);let h=1+Zn*(d*f+p*m);h<c&&(o=e,c=h,s=n.candidate)}}}}else console.warn(`BVH: Invalid build strategy value ${a} used.`);return{axis:o,pos:s}}function pr(e,t,n,r){let i=0,a=e.offset;for(let o=t,s=t+n;o<s;o++)i+=e[(o-a)*6+r*2];return i/n}var mr=class{constructor(){this.boundingData=/* @__PURE__ */ new Float32Array(6)}};function hr(e,t,n,r,i,a){let o=r,s=r+i-1,c=a.pos,l=a.axis*2,u=n.offset||0;for(;;){for(;o<=s&&n[(o-u)*6+l]<c;)o++;for(;o<=s&&n[(s-u)*6+l]>=c;)s--;if(o<s){for(let n=0;n<t;n++){let r=e[o*t+n];e[o*t+n]=e[s*t+n],e[s*t+n]=r}for(let e=0;e<6;e++){let t=o-u,r=s-u,i=n[t*6+e];n[t*6+e]=n[r*6+e],n[r*6+e]=i}o++,s--}else return o}}let gr,_r,vr,yr,br=2**32;function xr(e){return`count`in e?1:1+xr(e.left)+xr(e.right)}function Sr(e,t,n){return gr=new Float32Array(n),_r=new Uint32Array(n),vr=new Uint16Array(n),yr=new Uint8Array(n),Cr(e,t)}function Cr(e,t){let n=e/4,r=e/2,i=`count`in t,a=t.boundingData;for(let e=0;e<6;e++)gr[n+e]=a[e];if(i)return t.buffer?(yr.set(new Uint8Array(t.buffer),e),e+t.buffer.byteLength):(_r[n+6]=t.offset,vr[r+14]=t.count,vr[r+15]=Qn,e+32);{let{left:r,right:i,splitAxis:a}=t,o=Cr(e+32,r),s=e/32,c=o/32-s;if(c>br)throw Error(`MeshBVH: Cannot store relative child node offset greater than 32 bits.`);return _r[n+6]=c,_r[n+7]=a,Cr(o,i)}}function wr(e,t,n,r,i,a){let{maxDepth:o,verbose:s,targetLeafSize:c,_strictLeafSize:l=1/0,strategy:u,onProgress:d}=i,f=e.primitiveBuffer,p=e.primitiveBufferStride,m=/* @__PURE__ */ new Float32Array(6),h=!1,g=new mr;return cr(t,n,r,g.boundingData,m),v(g,n,r,m),g;function _(e){d&&d((e-a.offset)/a.count)}function v(e,n,r,i=null,a=0){!h&&a>=o&&(h=!0,s&&console.warn(`BVH: Max depth of ${o} reached when generating BVH. Consider increasing maxDepth.`));let d=r>l;if(r<=c&&!d||a>=o)return _(n+r),e.offset=n,e.count=r,e;let g=fr(e.boundingData,i,t,n,r,u),y=g.axis===-1?-1:hr(f,p,t,n,r,g);if(g.axis===-1||y===n||y===n+r){if(!d)return _(n+r),e.offset=n,e.count=r,e;g.axis=Math.max(0,nr(e.boundingData)),y=n+Math.max(1,Math.floor(r/2))}e.splitAxis=g.axis;let b=new mr,x=n,S=y-n;e.left=b,cr(t,x,S,b.boundingData,m),v(b,x,S,m,a+1);let C=new mr,w=y,T=r-S;return e.right=C,cr(t,w,T,C.boundingData,m),v(C,w,T,m,a+1),e}}function Tr(e,t){let n=t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer,r=e.getRootRanges(t.range),i=r[0],a=r[r.length-1],o={offset:i.offset,count:a.offset+a.count-i.offset},s=new Float32Array(6*o.count);s.offset=o.offset,e.computePrimitiveBounds(o.offset,o.count,s),e._roots=r.map(r=>{let i=wr(e,s,r.offset,r.count,t,o),a=xr(i),c=new n(32*a);return Sr(0,i,c),c})}var Er=class{constructor(e){this._getNewPrimitive=e,this._primitives=[]}getPrimitive(){let e=this._primitives;return e.length===0?this._getNewPrimitive():e.pop()}releasePrimitive(e){this._primitives.push(e)}};let Z=/* @__PURE__ */ new class{constructor(){this.float32Array=null,this.uint16Array=null,this.uint32Array=null;let e=[],t=null;this.setBuffer=n=>{t&&e.push(t),t=n,this.float32Array=new Float32Array(n),this.uint16Array=new Uint16Array(n),this.uint32Array=new Uint32Array(n)},this.clearBuffer=()=>{t=null,this.float32Array=null,this.uint16Array=null,this.uint32Array=null,e.length!==0&&this.setBuffer(e.pop())}}},Dr,Or,kr=[],Ar=/* @__PURE__ */ new Er(()=>new z);function jr(e,t,n,r,i,a){Dr=Ar.getPrimitive(),Or=Ar.getPrimitive(),kr.push(Dr,Or),Z.setBuffer(e._roots[t]);let o=Mr(0,e.geometry,n,r,i,a);Z.clearBuffer(),Ar.releasePrimitive(Dr),Ar.releasePrimitive(Or),kr.pop(),kr.pop();let s=kr.length;return s>0&&(Or=kr[s-1],Dr=kr[s-2]),o}function Mr(e,t,n,r,i=null,a=0,o=0){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c)){let t=K(e,l),n=q(u,c);return W(X(e),s,Dr),r(t,n,!1,o,a+e/8,Dr)}{let u=J(e),p=Y(e,l),m=u,h=p,g,_,v,y;if(i&&(v=Dr,y=Or,W(X(m),s,v),W(X(h),s,y),g=i(v),_=i(y),_<g)){m=p,h=u;let e=g;g=_,_=e,v=y}v||(v=Dr,W(X(m),s,v));let b=G(m*2,c),x=n(v,b,g,o+1,a+m/8),S;if(x===2){let e=d(m);S=r(e,f(m)-e,!0,o+1,a+m/8,v)}else S=x&&Mr(m,t,n,r,i,a,o+1);if(S)return!0;y=Or,W(X(h),s,y);let C=G(h*2,c),w=n(y,C,_,o+1,a+h/8),T;if(w===2){let e=d(h);T=r(e,f(h)-e,!0,o+1,a+h/8,y)}else T=w&&Mr(h,t,n,r,i,a,o+1);return!!T;function d(e){let{uint16Array:t,uint32Array:n}=Z,r=e*2;for(;!G(r,t);)e=J(e),r=e*2;return K(e,n)}function f(e){let{uint16Array:t,uint32Array:n}=Z,r=e*2;for(;!G(r,t);)e=Y(e,n),r=e*2;return K(e,n)+q(r,t)}}}let Nr=/* @__PURE__ */ new Z.constructor,Pr=/* @__PURE__ */ new Z.constructor,Fr=/* @__PURE__ */ new Er(()=>new z),Ir=/* @__PURE__ */ new z,Lr=/* @__PURE__ */ new z,Rr=/* @__PURE__ */ new z,zr=/* @__PURE__ */ new z,Br=!1;function Vr(e,t,n,r){if(Br)throw Error(`MeshBVH: Recursive calls to bvhcast not supported.`);Br=!0;let i=e._roots,a=t._roots,o,s=0,c=0,l=new I().copy(n).invert();for(let e=0,t=i.length;e<t;e++){Nr.setBuffer(i[e]),c=0;let t=Fr.getPrimitive();W(X(0),Nr.float32Array,t),t.applyMatrix4(l);for(let e=0,i=a.length;e<i&&(Pr.setBuffer(a[e]),o=Hr(0,0,n,l,r,s,c,0,0,t),Pr.clearBuffer(),c+=a[e].byteLength/32,!o);e++);if(Fr.releasePrimitive(t),Nr.clearBuffer(),s+=i[e].byteLength/32,o)break}return Br=!1,o}function Hr(e,t,n,r,i,a=0,o=0,s=0,c=0,l=null,u=!1){let d,f;u?(d=Pr,f=Nr):(d=Nr,f=Pr);let p=d.float32Array,m=d.uint32Array,h=d.uint16Array,g=f.float32Array,_=f.uint32Array,v=f.uint16Array,y=e*2,b=t*2,x=G(y,h),S=G(b,v),C=!1;if(S&&x)C=u?i(K(t,_),q(t*2,v),K(e,m),q(e*2,h),c,o+t/8,s,a+e/8):i(K(e,m),q(e*2,h),K(t,_),q(t*2,v),s,a+e/8,c,o+t/8);else if(S){let l=Fr.getPrimitive();W(X(t),g,l),l.applyMatrix4(n);let d=J(e),f=Y(e,m);W(X(d),p,Ir),W(X(f),p,Lr);let h=l.intersectsBox(Ir),_=l.intersectsBox(Lr);C=h&&Hr(t,d,r,n,i,o,a,c,s+1,l,!u)||_&&Hr(t,f,r,n,i,o,a,c,s+1,l,!u),Fr.releasePrimitive(l)}else{let d=J(t),f=Y(t,_);W(X(d),g,Rr),W(X(f),g,zr);let h=l.intersectsBox(Rr),v=l.intersectsBox(zr);if(h&&v)C=Hr(e,d,n,r,i,a,o,s,c+1,l,u)||Hr(e,f,n,r,i,a,o,s,c+1,l,u);else if(h){if(x)C=Hr(e,d,n,r,i,a,o,s,c+1,l,u);else{let t=Fr.getPrimitive();t.copy(Rr).applyMatrix4(n);let l=J(e),f=Y(e,m);W(X(l),p,Ir),W(X(f),p,Lr);let h=t.intersectsBox(Ir),g=t.intersectsBox(Lr);C=h&&Hr(d,l,r,n,i,o,a,c,s+1,t,!u)||g&&Hr(d,f,r,n,i,o,a,c,s+1,t,!u),Fr.releasePrimitive(t)}}else if(v){if(x)C=Hr(e,f,n,r,i,a,o,s,c+1,l,u);else{let t=Fr.getPrimitive();t.copy(zr).applyMatrix4(n);let l=J(e),d=Y(e,m);W(X(l),p,Ir),W(X(d),p,Lr);let h=t.intersectsBox(Ir),g=t.intersectsBox(Lr);C=h&&Hr(f,l,r,n,i,o,a,c,s+1,t,!u)||g&&Hr(f,d,r,n,i,o,a,c,s+1,t,!u),Fr.releasePrimitive(t)}}}return C}let Ur=new class{constructor(){let e=null,t=null,n=null,r=!1;this.root=null,this.buffer=null,this.uint32Array=null,this.uint16Array=null,this.setBVH=(i,a)=>{if(r)throw Error(`BVHTraversalHelper: cannot call setBVH during an active traversal.`);this.root=a,this.buffer=e=i._roots[a],this.uint16Array=n=new Uint16Array(e),this.uint32Array=t=new Uint32Array(e)},this.reset=()=>{this.root=null,this.buffer=e=null,this.uint16Array=n=null,this.uint32Array=t=null},this.getRangeStart=e=>{let r=e*2;for(;!G(r,n);)e=J(e),r=e*2;return K(e,t)},this.getRangeEnd=e=>{let r=e*2;for(;!G(r,n);)e=Y(e,t),r=e*2;return K(e,t)+q(r,n)};let i=(e,r,a)=>{let o=G(r*2,n);if(!e(a,o,r)&&!o){let n=J(r),o=Y(r,t);i(e,n,a+1),i(e,o,a+1)}};this.traverseBuffer=e=>{if(r)throw Error(`BVHTraversalHelper: cannot start a traversal during an active traversal.`);r=!0;try{i(e,0,0)}finally{r=!1}},this.traverse=r=>{this.traverseBuffer((i,a,o)=>{if(a){let s=o*2,c=t[o+6],l=n[s+14];return r(i,a,new Float32Array(e,o*4,6),c,l)}{let n=sr(o,t);return r(i,a,new Float32Array(e,o*4,6),n)}})}}},Wr=/* @__PURE__ */ new z,Gr=/* @__PURE__ */ new Float32Array(6);var Kr=class{constructor(){this._roots=null,this.primitiveBuffer=null,this.primitiveBufferStride=null}init(e){e={...tr,...e},`maxLeafSize`in e&&(console.warn(`BVH: \"maxLeafSize\" option has been deprecated. Use \"targetLeafSize\", instead.`),e={...e,targetLeafSize:e.maxLeafSize}),Tr(this,e)}getRootRanges(){throw Error(`BVH: getRootRanges() not implemented`)}writePrimitiveBounds(){throw Error(`BVH: writePrimitiveBounds() not implemented`)}writePrimitiveRangeBounds(e,t,n,r){let i=1/0,a=1/0,o=1/0,s=-1/0,c=-1/0,l=-1/0;for(let n=e,r=e+t;n<r;n++){this.writePrimitiveBounds(n,Gr,0);let[e,t,r,u,d,f]=Gr;e<i&&(i=e),u>s&&(s=u),t<a&&(a=t),d>c&&(c=d),r<o&&(o=r),f>l&&(l=f)}return n[r+0]=i,n[r+1]=a,n[r+2]=o,n[r+3]=s,n[r+4]=c,n[r+5]=l,n}computePrimitiveBounds(e,t,n){let r=n.offset||0;for(let i=e,a=e+t;i<a;i++){this.writePrimitiveBounds(i,Gr,0);let[e,t,a,o,s,c]=Gr,l=(e+o)/2,u=(t+s)/2,d=(a+c)/2,f=(o-e)/2,p=(s-t)/2,m=(c-a)/2,h=(i-r)*6;n[h+0]=l,n[h+1]=f+(Math.abs(l)+f)*$n,n[h+2]=u,n[h+3]=p+(Math.abs(u)+p)*$n,n[h+4]=d,n[h+5]=m+(Math.abs(d)+m)*$n}return n}shiftPrimitiveOffsets(e){let t=this._indirectBuffer;if(t)for(let n=0,r=t.length;n<r;n++)t[n]+=e;else{let t=this._roots;for(let n=0;n<t.length;n++){let r=t[n],i=new Uint32Array(r),a=new Uint16Array(r),o=r.byteLength/32;for(let t=0;t<o;t++){let n=8*t;G(2*n,a)&&(i[n+6]+=e)}}}}traverse(e,t=0){Ur.setBVH(this,t),Ur.traverse(e),Ur.reset()}refit(){let e=this._roots;for(let t=0,n=e.length;t<n;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n),a=new Float32Array(n),o=n.byteLength/32;for(let e=o-1;e>=0;e--){let t=e*8,n=t*2;if(G(n,i)){let e=K(t,r),o=q(n,i);this.writePrimitiveRangeBounds(e,o,Gr,0),a.set(Gr,t)}else{let e=J(t),n=Y(t,r);for(let r=0;r<3;r++){let i=a[e+r],o=a[e+r+3],s=a[n+r],c=a[n+r+3];a[t+r]=i<s?i:s,a[t+r+3]=o>c?o:c}}}}}getBoundingBox(e){return e.makeEmpty(),this._roots.forEach(t=>{W(0,new Float32Array(t),Wr),e.union(Wr)}),e}shapecast(e){let{boundsTraverseOrder:t,intersectsBounds:n,intersectsRange:r,intersectsPrimitive:i,scratchPrimitive:a,iterate:o}=e;if(r&&i){let e=r;r=(t,n,r,s,c)=>e(t,n,r,s,c)?!0:o(t,n,this,i,r,s,a)}else r||=i?(e,t,n,r)=>o(e,t,this,i,n,r,a):(e,t,n)=>n;let s=!1,c=0,l=this._roots;for(let e=0,i=l.length;e<i;e++){let i=l[e];if(s=jr(this,e,n,r,t,c),s)break;c+=i.byteLength/32}return s}bvhcast(e,t,n){let{intersectsRanges:r}=n;return Vr(this,e,t,r)}};function qr(){return typeof SharedArrayBuffer<`u`}function Jr(e){return e.index?e.index.count:e.attributes.position.count}function Yr(e){return Jr(e)/3}function Xr(e,t=ArrayBuffer){return e>65535?new Uint32Array(new t(4*e)):new Uint16Array(new t(2*e))}function Zr(e,t){if(!e.index){let n=e.attributes.position.count,r=Xr(n,t.useSharedArrayBuffer?SharedArrayBuffer:ArrayBuffer);e.setIndex(new Ct(r,1));for(let e=0;e<n;e++)r[e]=e}}function Qr(e,t,n){let r=Jr(e)/n,i=t||e.drawRange,a=i.start/n,o=(i.start+i.count)/n,s=Math.max(0,a),c=Math.min(r,o)-s;return{offset:Math.floor(s),count:Math.floor(c)}}function $r(e,t){return e.groups.map(e=>({offset:e.start/t,count:e.count/t}))}function ei(e,t,n){let r=Qr(e,t,n),i=$r(e,n);if(!i.length)return[r];let a=[],o=r.offset,s=r.offset+r.count,c=Jr(e)/n,l=[];for(let e of i){let{offset:t,count:n}=e,r=t,i=t+(isFinite(n)?n:c-t);r<s&&i>o&&(l.push({pos:Math.max(o,r),isStart:!0}),l.push({pos:Math.min(s,i),isStart:!1}))}l.sort((e,t)=>e.pos===t.pos?e.type===`end`?-1:1:e.pos-t.pos);let u=0,d=null;for(let e of l){let t=e.pos;u!==0&&t!==d&&a.push({offset:d,count:t-d}),u+=e.isStart?1:-1,d=t}return a}function ti(e,t){let n=e[e.length-1],r=n.offset+n.count>2**16,i=e.reduce((e,t)=>e+t.count,0),a=r?4:2,o=t?new SharedArrayBuffer(i*a):new ArrayBuffer(i*a),s=r?new Uint32Array(o):new Uint16Array(o),c=0;for(let t=0;t<e.length;t++){let{offset:n,count:r}=e[t];for(let e=0;e<r;e++)s[c+e]=n+e;c+=r}return s}var ni=class extends Kr{get indirect(){return!!this._indirectBuffer}get primitiveStride(){return null}get primitiveBufferStride(){return this.indirect?1:this.primitiveStride}set primitiveBufferStride(e){}get primitiveBuffer(){return this.indirect?this._indirectBuffer:this.geometry.index.array}set primitiveBuffer(e){}constructor(e,t={}){if(!e.isBufferGeometry)throw Error(`BVH: Only BufferGeometries are supported.`);if(e.index&&e.index.isInterleavedBufferAttribute)throw Error(`BVH: InterleavedBufferAttribute is not supported for the index attribute.`);if(t.useSharedArrayBuffer&&!qr())throw Error(`BVH: SharedArrayBuffer is not available.`);super(),this.geometry=e,this.resolvePrimitiveIndex=t.indirect?e=>this._indirectBuffer[e]:e=>e,this.primitiveBuffer=null,this.primitiveBufferStride=null,this._indirectBuffer=null,t={...tr,...t},t[er]||this.init(t)}init(e){let{geometry:t,primitiveStride:n}=this;if(e.indirect){let r=ti(ei(t,e.range,n),e.useSharedArrayBuffer);this._indirectBuffer=r}else Zr(t,e);super.init(e),!t.boundingBox&&e.setBoundingBox&&(t.boundingBox=this.getBoundingBox(new z))}getRootRanges(e){return this.indirect?[{offset:0,count:this._indirectBuffer.length}]:ei(this.geometry,e,this.primitiveStride)}raycastObject3D(){throw Error(`BVH: raycastObject3D() not implemented`)}},ri=class{constructor(){this.min=1/0,this.max=-1/0}setFromPointsField(e,t){let n=1/0,r=-1/0;for(let i=0,a=e.length;i<a;i++){let a=e[i][t];n=a<n?a:n,r=a>r?a:r}this.min=n,this.max=r}setFromPoints(e,t){let n=1/0,r=-1/0;for(let i=0,a=t.length;i<a;i++){let a=t[i],o=e.dot(a);n=o<n?o:n,r=o>r?o:r}this.min=n,this.max=r}isSeparated(e){return this.min>e.max||e.min>this.max}};ri.prototype.setFromBox=(function(){let e=/* @__PURE__ */ new M;return function(t,n){let r=n.min,i=n.max,a=1/0,o=-1/0;for(let n=0;n<=1;n++)for(let s=0;s<=1;s++)for(let c=0;c<=1;c++){e.x=r.x*n+i.x*(1-n),e.y=r.y*s+i.y*(1-s),e.z=r.z*c+i.z*(1-c);let l=t.dot(e);a=Math.min(l,a),o=Math.max(l,o)}this.min=a,this.max=o}})();let ii=(function(){let e=/* @__PURE__ */ new M,t=/* @__PURE__ */ new M,n=/* @__PURE__ */ new M;return function(r,i,a){let o=r.start,s=e,c=i.start,l=t;n.subVectors(o,c),e.subVectors(r.end,r.start),t.subVectors(i.end,i.start);let u=n.dot(l),d=l.dot(s),f=l.dot(l),p=n.dot(s),m=s.dot(s)*f-d*d,h,g;h=m===0?0:(u*d-p*f)/m,g=(u+h*d)/f,a.x=h,a.y=g}})(),ai=(function(){let e=/* @__PURE__ */ new A,t=/* @__PURE__ */ new M,n=/* @__PURE__ */ new M;return function(r,i,a,o){ii(r,i,e);let s=e.x,c=e.y;if(s>=0&&s<=1&&c>=0&&c<=1){r.at(s,a),i.at(c,o);return}if(s>=0&&s<=1){c<0?i.at(0,o):i.at(1,o),r.closestPointToPoint(o,!0,a);return}if(c>=0&&c<=1){s<0?r.at(0,a):r.at(1,a),i.closestPointToPoint(a,!0,o);return}{let e;e=s<0?r.start:r.end;let l;l=c<0?i.start:i.end;let u=t,d=n;if(r.closestPointToPoint(l,!0,t),i.closestPointToPoint(e,!0,n),u.distanceToSquared(l)<=d.distanceToSquared(e)){a.copy(u),o.copy(l);return}a.copy(e),o.copy(d);return}}})(),oi=(function(){let e=/* @__PURE__ */ new M,t=/* @__PURE__ */ new M,n=/* @__PURE__ */ new Bt,r=/* @__PURE__ */ new Cn;return function(i,a){let{radius:o,center:s}=i,{a:c,b:l,c:u}=a;if(r.start=c,r.end=l,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o||(r.start=c,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o)||(r.start=l,r.end=u,r.closestPointToPoint(s,!0,e).distanceTo(s)<=o))return!0;let d=a.getPlane(n);if(Math.abs(d.distanceToPoint(s))<=o){let e=d.projectPoint(s,t);if(a.containsPoint(e))return!0}return!1}})(),si=[`x`,`y`,`z`],ci=1e-15,li=ci*ci;function ui(e){return Math.abs(e)<ci}var di=class extends ot{constructor(...e){super(...e),this.isExtendedTriangle=!0,this.satAxes=[,,,,].fill().map(()=>new M),this.satBounds=[,,,,].fill().map(()=>new ri),this.points=[this.a,this.b,this.c],this.plane=new Bt,this.isDegenerateIntoSegment=!1,this.isDegenerateIntoPoint=!1,this.degenerateSegment=new Cn,this.needsUpdate=!0}intersectsSphere(e){return oi(e,this)}update(){let e=this.a,t=this.b,n=this.c,r=this.points,i=this.satAxes,a=this.satBounds,o=i[0],s=a[0];this.getNormal(o),s.setFromPoints(o,r);let c=i[1],l=a[1];c.subVectors(e,t),l.setFromPoints(c,r);let u=i[2],d=a[2];u.subVectors(t,n),d.setFromPoints(u,r);let f=i[3],p=a[3];f.subVectors(n,e),p.setFromPoints(f,r);let m=c.length(),h=u.length(),g=f.length();this.isDegenerateIntoPoint=!1,this.isDegenerateIntoSegment=!1,m<ci?h<ci||g<ci?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(e),this.degenerateSegment.end.copy(n)):h<ci?g<ci?this.isDegenerateIntoPoint=!0:(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(t),this.degenerateSegment.end.copy(e)):g<ci&&(this.isDegenerateIntoSegment=!0,this.degenerateSegment.start.copy(n),this.degenerateSegment.end.copy(t)),this.plane.setFromNormalAndCoplanarPoint(o,e),this.needsUpdate=!1}};di.prototype.closestPointToSegment=(function(){let e=/* @__PURE__ */ new M,t=/* @__PURE__ */ new M,n=/* @__PURE__ */ new Cn;return function(r,i=null,a=null){let{start:o,end:s}=r,c=this.points,l,u=1/0;for(let o=0;o<3;o++){let s=(o+1)%3;n.start.copy(c[o]),n.end.copy(c[s]),ai(n,r,e,t),l=e.distanceToSquared(t),l<u&&(u=l,i&&i.copy(e),a&&a.copy(t))}return this.closestPointToPoint(o,e),l=o.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(o)),this.closestPointToPoint(s,e),l=s.distanceToSquared(e),l<u&&(u=l,i&&i.copy(e),a&&a.copy(s)),Math.sqrt(u)}})(),di.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new di,t=/* @__PURE__ */ new ri,n=/* @__PURE__ */ new ri,r=/* @__PURE__ */ new M,i=/* @__PURE__ */ new M,a=/* @__PURE__ */ new M,o=/* @__PURE__ */ new M,s=/* @__PURE__ */ new Cn,c=/* @__PURE__ */ new Cn,l=/* @__PURE__ */ new M,u=/* @__PURE__ */ new A,d=/* @__PURE__ */ new A;function f(e,i,a,s){let c=r;!e.isDegenerateIntoPoint&&!e.isDegenerateIntoSegment?c.copy(e.plane.normal):c.copy(i.plane.normal);let l=e.satBounds,u=e.satAxes;for(let r=1;r<4;r++){let a=l[r],s=u[r];if(t.setFromPoints(s,i.points),a.isSeparated(t)||(o.copy(c).cross(s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}let d=i.satBounds,f=i.satAxes;for(let r=1;r<4;r++){let a=d[r],s=f[r];if(t.setFromPoints(s,e.points),a.isSeparated(t)||(o.crossVectors(c,s),t.setFromPoints(o,e.points),n.setFromPoints(o,i.points),t.isSeparated(n)))return!1}return a&&(s||console.warn(`ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.`),a.start.set(0,0,0),a.end.set(0,0,0)),!0}function p(e,t,n,r,i,a,o,s,c,l,u){let d=o/(o-s);l.x=r+(i-r)*d,u.start.subVectors(t,e).multiplyScalar(d).add(e),d=o/(o-c),l.y=r+(a-r)*d,u.end.subVectors(n,e).multiplyScalar(d).add(e)}function m(e,t,n,r,i,a,o,s,c,l,u){if(i>0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else if(a>0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(s*c>0||o!=0)p(e.a,e.b,e.c,t,n,r,o,s,c,l,u);else if(s!=0)p(e.b,e.a,e.c,n,t,r,s,o,c,l,u);else if(c!=0)p(e.c,e.a,e.b,r,t,n,c,o,s,l,u);else return!0;return!1}function h(e,t,n,i){let a=t.degenerateSegment,o=e.plane.distanceToPoint(a.start),s=e.plane.distanceToPoint(a.end);return ui(o)?ui(s)?f(e,t,n,i):(n&&(n.start.copy(a.start),n.end.copy(a.start)),e.containsPoint(a.start)):ui(s)?(n&&(n.start.copy(a.end),n.end.copy(a.end)),e.containsPoint(a.end)):e.plane.intersectLine(a,r)!=null&&(n&&(n.start.copy(r),n.end.copy(r)),e.containsPoint(r))}function g(e,t,n){let r=t.a;return ui(e.plane.distanceToPoint(r))&&e.containsPoint(r)?(n&&(n.start.copy(r),n.end.copy(r)),!0):!1}function _(e,t,n){let i=e.degenerateSegment,a=t.a;return i.closestPointToPoint(a,!0,r),a.distanceToSquared(r)<li&&(n&&(n.start.copy(a),n.end.copy(a)),!0)}function v(e,t,n,o){if(e.isDegenerateIntoSegment){if(t.isDegenerateIntoSegment){let o=e.degenerateSegment,s=t.degenerateSegment,c=i,l=a;o.delta(c),s.delta(l);let u=r.subVectors(s.start,o.start),d=c.x*l.y-c.y*l.x;if(ui(d))return!1;let f=(u.x*l.y-u.y*l.x)/d,p=-(c.x*u.y-c.y*u.x)/d;return f<0||f>1||p<0||p>1?!1:ui(o.start.z+c.z*f-(s.start.z+l.z*p))?(n&&(n.start.copy(o.start).addScaledVector(c,f),n.end.copy(o.start).addScaledVector(c,f)),!0):!1}return t.isDegenerateIntoPoint?_(e,t,n):h(t,e,n,o)}if(e.isDegenerateIntoPoint)return t.isDegenerateIntoPoint?t.a.distanceToSquared(e.a)<li&&(n&&(n.start.copy(e.a),n.end.copy(e.a)),!0):t.isDegenerateIntoSegment?_(t,e,n):g(t,e,n);if(t.isDegenerateIntoPoint)return g(e,t,n);if(t.isDegenerateIntoSegment)return h(e,t,n,o)}return function(t,n=null,r=!1){this.needsUpdate&&this.update(),t.isExtendedTriangle?t.needsUpdate&&t.update():(e.copy(t),e.update(),t=e);let o=v(this,t,n,r);if(o!==void 0)return o;let p=this.plane,h=t.plane,g=h.distanceToPoint(this.a),_=h.distanceToPoint(this.b),y=h.distanceToPoint(this.c);ui(g)&&(g=0),ui(_)&&(_=0),ui(y)&&(y=0);let b=g*_,x=g*y;if(b>0&&x>0)return!1;let S=p.distanceToPoint(t.a),C=p.distanceToPoint(t.b),w=p.distanceToPoint(t.c);ui(S)&&(S=0),ui(C)&&(C=0),ui(w)&&(w=0);let T=S*C,E=S*w;if(T>0&&E>0)return!1;i.copy(p.normal),a.copy(h.normal);let D=i.cross(a),O=0,k=Math.abs(D.x),A=Math.abs(D.y);A>k&&(k=A,O=1),Math.abs(D.z)>k&&(O=2);let j=si[O],M=this.a[j],N=this.b[j],ee=this.c[j],P=t.a[j],te=t.b[j],ne=t.c[j];if(m(this,M,N,ee,b,x,g,_,y,u,s)||m(t,P,te,ne,T,E,S,C,w,d,c))return f(this,t,n,r);if(u.y<u.x){let e=u.y;u.y=u.x,u.x=e,l.copy(s.start),s.start.copy(s.end),s.end.copy(l)}if(d.y<d.x){let e=d.y;d.y=d.x,d.x=e,l.copy(c.start),c.start.copy(c.end),c.end.copy(l)}return u.y<d.x||d.y<u.x?!1:(n&&(d.x>u.x?n.start.copy(c.start):n.start.copy(s.start),d.y<u.y?n.end.copy(c.end):n.end.copy(s.end)),!0)}})(),di.prototype.distanceToPoint=(function(){let e=/* @__PURE__ */ new M;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),di.prototype.distanceToTriangle=(function(){let e=/* @__PURE__ */ new M,t=/* @__PURE__ */ new M,n=[`a`,`b`,`c`],r=/* @__PURE__ */ new Cn,i=/* @__PURE__ */ new Cn;return function(a,o=null,s=null){let c=o||s?r:null;if(this.intersectsTriangle(a,c,!0))return(o||s)&&(o&&c.getCenter(o),s&&c.getCenter(s)),0;let l=1/0;for(let t=0;t<3;t++){let r,i=n[t],c=a[i];this.closestPointToPoint(c,e),r=c.distanceToSquared(e),r<l&&(l=r,o&&o.copy(e),s&&s.copy(c));let u=this[i];a.closestPointToPoint(u,e),r=u.distanceToSquared(e),r<l&&(l=r,o&&o.copy(u),s&&s.copy(e))}for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];r.set(this[u],this[d]);for(let c=0;c<3;c++){let u=n[c],d=n[(c+1)%3];i.set(a[u],a[d]),ai(r,i,e,t);let f=e.distanceToSquared(t);f<l&&(l=f,o&&o.copy(e),s&&s.copy(t))}}return Math.sqrt(l)}})();var Q=class{constructor(e,t,n){this.isOrientedBox=!0,this.min=new M,this.max=new M,this.matrix=new I,this.invMatrix=new I,this.points=Array(8).fill().map(()=>new M),this.satAxes=[,,,].fill().map(()=>new M),this.satBounds=[,,,].fill().map(()=>new ri),this.alignedSatBounds=[,,,].fill().map(()=>new ri),this.needsUpdate=!1,e&&this.min.copy(e),t&&this.max.copy(t),n&&this.matrix.copy(n)}set(e,t,n){this.min.copy(e),this.max.copy(t),this.matrix.copy(n),this.needsUpdate=!0}copy(e){this.min.copy(e.min),this.max.copy(e.max),this.matrix.copy(e.matrix),this.needsUpdate=!0}};Q.prototype.update=(function(){return function(){let e=this.matrix,t=this.min,n=this.max,r=this.points;for(let i=0;i<=1;i++)for(let a=0;a<=1;a++)for(let o=0;o<=1;o++){let s=r[1*i|2*a|4*o];s.x=i?n.x:t.x,s.y=a?n.y:t.y,s.z=o?n.z:t.z,s.applyMatrix4(e)}let i=this.satBounds,a=this.satAxes,o=r[0];for(let e=0;e<3;e++){let t=a[e],n=i[e],s=r[1<<e];t.subVectors(o,s),n.setFromPoints(t,r)}let s=this.alignedSatBounds;s[0].setFromPointsField(r,`x`),s[1].setFromPointsField(r,`y`),s[2].setFromPointsField(r,`z`),this.invMatrix.copy(this.matrix).invert(),this.needsUpdate=!1}})(),Q.prototype.intersectsBox=(function(){let e=/* @__PURE__ */ new ri;return function(t){this.needsUpdate&&this.update();let n=t.min,r=t.max,i=this.satBounds,a=this.satAxes,o=this.alignedSatBounds;if(e.min=n.x,e.max=r.x,o[0].isSeparated(e)||(e.min=n.y,e.max=r.y,o[1].isSeparated(e))||(e.min=n.z,e.max=r.z,o[2].isSeparated(e)))return!1;for(let n=0;n<3;n++){let r=a[n],o=i[n];if(e.setFromBox(r,t),o.isSeparated(e))return!1}return!0}})(),Q.prototype.intersectsTriangle=(function(){let e=/* @__PURE__ */ new di,t=[,,,],n=/* @__PURE__ */ new ri,r=/* @__PURE__ */ new ri,i=/* @__PURE__ */ new M;return function(a){this.needsUpdate&&this.update(),a.isExtendedTriangle?a.needsUpdate&&a.update():(e.copy(a),e.update(),a=e);let o=this.satBounds,s=this.satAxes;t[0]=a.a,t[1]=a.b,t[2]=a.c;for(let e=0;e<3;e++){let r=o[e],i=s[e];if(n.setFromPoints(i,t),r.isSeparated(n))return!1}let c=a.satBounds,l=a.satAxes,u=this.points;for(let e=0;e<3;e++){let t=c[e],r=l[e];if(n.setFromPoints(r,u),t.isSeparated(n))return!1}for(let e=0;e<3;e++){let a=s[e];for(let e=0;e<4;e++){let o=l[e];if(i.crossVectors(a,o),n.setFromPoints(i,t),r.setFromPoints(i,u),n.isSeparated(r))return!1}}return!0}})(),Q.prototype.closestPointToPoint=(function(){return function(e,t){return this.needsUpdate&&this.update(),t.copy(e).applyMatrix4(this.invMatrix).clamp(this.min,this.max).applyMatrix4(this.matrix),t}})(),Q.prototype.distanceToPoint=(function(){let e=new M;return function(t){return this.closestPointToPoint(t,e),t.distanceTo(e)}})(),Q.prototype.distanceToBox=(function(){let e=[`x`,`y`,`z`],t=/* @__PURE__ */ Array(12).fill().map(()=>new Cn),n=/* @__PURE__ */ Array(12).fill().map(()=>new Cn),r=/* @__PURE__ */ new M,i=/* @__PURE__ */ new M;return function(a,o=0,s=null,c=null){if(this.needsUpdate&&this.update(),this.intersectsBox(a))return(s||c)&&(a.getCenter(i),this.closestPointToPoint(i,r),a.closestPointToPoint(r,i),s&&s.copy(r),c&&c.copy(i)),0;let l=o*o,u=a.min,d=a.max,f=this.points,p=1/0;for(let e=0;e<8;e++){let t=f[e];i.copy(t).clamp(u,d);let n=t.distanceToSquared(i);if(n<p&&(p=n,s&&s.copy(t),c&&c.copy(i),n<l))return Math.sqrt(n)}let m=0;for(let r=0;r<3;r++)for(let i=0;i<=1;i++)for(let a=0;a<=1;a++){let o=(r+1)%3,s=(r+2)%3,c=i<<o|a<<s,l=1<<r|i<<o|a<<s,p=f[c],h=f[l];t[m].set(p,h);let g=e[r],_=e[o],v=e[s],y=n[m],b=y.start,x=y.end;b[g]=u[g],b[_]=i?u[_]:d[_],b[v]=a?u[v]:d[_],x[g]=d[g],x[_]=i?u[_]:d[_],x[v]=a?u[v]:d[_],m++}for(let e=0;e<=1;e++)for(let t=0;t<=1;t++)for(let n=0;n<=1;n++){i.x=e?d.x:u.x,i.y=t?d.y:u.y,i.z=n?d.z:u.z,this.closestPointToPoint(i,r);let a=i.distanceToSquared(r);if(a<p&&(p=a,s&&s.copy(r),c&&c.copy(i),a<l))return Math.sqrt(a)}for(let e=0;e<12;e++){let a=t[e];for(let e=0;e<12;e++){let t=n[e];ai(a,t,r,i);let o=r.distanceToSquared(i);if(o<p&&(p=o,s&&s.copy(r),c&&c.copy(i),o<l))return Math.sqrt(o)}}return Math.sqrt(p)}})();let fi=/* @__PURE__ */ new class extends Er{constructor(){super(()=>new di)}},pi=/* @__PURE__ */ new M,mi=/* @__PURE__ */ new M;function hi(e,t,n={},r=0,i=1/0){let a=r*r,o=i*i,s=1/0,c=null;if(e.shapecast({boundsTraverseOrder:e=>(pi.copy(t).clamp(e.min,e.max),pi.distanceToSquared(t)),intersectsBounds:(e,t,n)=>n<s&&n<o,intersectsTriangle:(e,n)=>{e.closestPointToPoint(t,pi);let r=t.distanceToSquared(pi);return r<s&&(mi.copy(pi),s=r,c=n),r<a}}),s===1/0)return null;let l=Math.sqrt(s);return n.point?n.point.copy(mi):n.point=mi.clone(),n.distance=l,n.faceIndex=c,n}let gi=/* @__PURE__ */ new M,_i=/* @__PURE__ */ new M,vi=/* @__PURE__ */ new M,yi=/* @__PURE__ */ new A,bi=/* @__PURE__ */ new A,xi=/* @__PURE__ */ new A,Si=/* @__PURE__ */ new M,Ci=/* @__PURE__ */ new M,wi=/* @__PURE__ */ new M,Ti=/* @__PURE__ */ new M;function Ei(e,t,n,r,i,a,o,s){let c;if(c=a===1?e.intersectTriangle(r,n,t,!0,i):e.intersectTriangle(t,n,r,a!==2,i),c===null)return null;let l=e.origin.distanceTo(i);return l<o||l>s?null:{distance:l,point:i.clone()}}function Di(e,t,n,r,i,a,o,s,c,l,u){gi.fromBufferAttribute(t,a),_i.fromBufferAttribute(t,o),vi.fromBufferAttribute(t,s);let d=Ei(e,gi,_i,vi,Ti,c,l,u);if(d){r&&(yi.fromBufferAttribute(r,a),bi.fromBufferAttribute(r,o),xi.fromBufferAttribute(r,s),d.uv=new A,ot.getInterpolation(Ti,gi,_i,vi,yi,bi,xi,d.uv)),i&&(yi.fromBufferAttribute(i,a),bi.fromBufferAttribute(i,o),xi.fromBufferAttribute(i,s),d.uv1=new A,ot.getInterpolation(Ti,gi,_i,vi,yi,bi,xi,d.uv1)),n&&(Si.fromBufferAttribute(n,a),Ci.fromBufferAttribute(n,o),wi.fromBufferAttribute(n,s),d.normal=new M,ot.getInterpolation(Ti,gi,_i,vi,Si,Ci,wi,d.normal),d.normal.dot(e.direction)>0&&d.normal.multiplyScalar(-1));let t={a,b:o,c:s,normal:new M,materialIndex:0};ot.getNormal(gi,_i,vi,t.normal),d.face=t,d.faceIndex=a;{let e=new M;ot.getBarycoord(Ti,gi,_i,vi,e),d.barycoord=e}}return d}function Oi(e){return e&&e.isMaterial?e.side:e}function ki(e,t,n,r,i,a,o){let s=r*3,c=s+0,l=s+1,u=s+2,{index:d,groups:f}=e;e.index&&(c=d.getX(c),l=d.getX(l),u=d.getX(u));let{position:p,normal:m,uv:h,uv1:g}=e.attributes;if(Array.isArray(t)){let e=r*3;for(let s=0,d=f.length;s<d;s++){let{start:d,count:_,materialIndex:v}=f[s];if(e>=d&&e<d+_){let e=Oi(t[v]),s=Di(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=v,i)i.push(s);else return s}}}}else{let e=Oi(t),s=Di(n,p,m,h,g,c,l,u,e,a,o);if(s){if(s.faceIndex=r,s.face.materialIndex=0,i)i.push(s);else return s}}return null}function $(e,t,n,r){let i=e.a,a=e.b,o=e.c,s=t,c=t+1,l=t+2;n&&(s=n.getX(s),c=n.getX(c),l=n.getX(l)),i.x=r.getX(s),i.y=r.getY(s),i.z=r.getZ(s),a.x=r.getX(c),a.y=r.getY(c),a.z=r.getZ(c),o.x=r.getX(l),o.y=r.getY(l),o.z=r.getZ(l)}function Ai(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,l=r+i;e<l;e++)ki(c,t,n,e,a,o,s)}function ji(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,c=r+i;e<c;e++){let r;r=ki(s,t,n,e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function Mi(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let n=e,s=t+e;n<s;n++){let e;if(e=n,$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function Ni(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(e,n,a=!1){let l=e*2;if(G(l,s)){let t=K(e,o),n=q(l,s),a=1/0,u=1/0,d=1/0,f=-1/0,p=-1/0,m=-1/0;for(let e=3*t,o=3*(t+n);e<o;e++){let t=r[e],n=i.getX(t),o=i.getY(t),s=i.getZ(t);n<a&&(a=n),n>f&&(f=n),o<u&&(u=o),o>p&&(p=o),s<d&&(d=s),s>m&&(m=s)}return c[e+0]!==a||c[e+1]!==u||c[e+2]!==d||c[e+3]!==f||c[e+4]!==p||c[e+5]!==m?(c[e+0]=a,c[e+1]=u,c[e+2]=d,c[e+3]=f,c[e+4]=p,c[e+5]=m,!0):!1}{let r=J(e),i=Y(e,o),s=a,l=!1,u=!1;if(t){if(!s){let e=r/8+n/32,a=i/8+n/32;l=t.has(e),u=t.has(a),s=!l&&!u}}else l=!0,u=!0;let f=s||l,p=s||u,m=!1;f&&(m=d(r,n,s));let h=!1;p&&(h=d(i,n,s));let g=m||h;if(g)for(let t=0;t<3;t++){let n=r+t,a=i+t,o=c[n],s=c[n+3],l=c[a],u=c[a+3];c[e+t]=o<l?o:l,c[e+t+3]=s>u?s:u}return g}}}function Pi(e,t,n,r,i){let a,o,s,c,l,u,d=1/n.direction.x,f=1/n.direction.y,p=1/n.direction.z,m=n.origin.x,h=n.origin.y,g=n.origin.z,_=t[e],v=t[e+3],y=t[e+1],b=t[e+3+1],x=t[e+2],S=t[e+3+2];return d>=0?(a=(_-m)*d,o=(v-m)*d):(a=(v-m)*d,o=(_-m)*d),f>=0?(s=(y-h)*f,c=(b-h)*f):(s=(b-h)*f,c=(y-h)*f),a>c||s>o||((s>a||isNaN(a))&&(a=s),(c<o||isNaN(o))&&(o=c),p>=0?(l=(x-g)*p,u=(S-g)*p):(l=(S-g)*p,u=(x-g)*p),a>u||l>o)?!1:((l>a||a!==a)&&(a=l),(u<o||o!==o)&&(o=u),a<=i&&o>=r)}function Fi(e,t,n,r,i,a,o,s){let{geometry:c,_indirectBuffer:l}=e;for(let e=r,u=r+i;e<u;e++)ki(c,t,n,l?l[e]:e,a,o,s)}function Ii(e,t,n,r,i,a,o){let{geometry:s,_indirectBuffer:c}=e,l=1/0,u=null;for(let e=r,d=r+i;e<d;e++){let r;r=ki(s,t,n,c?c[e]:e,null,a,o),r&&r.distance<l&&(u=r,l=r.distance)}return u}function Li(e,t,n,r,i,a,o){let{geometry:s}=n,{index:c}=s,l=s.attributes.position;for(let s=e,u=t+e;s<u;s++){let e;if(e=n.resolveTriangleIndex(s),$(o,e*3,c,l),o.needsUpdate=!0,r(o,e,i,a))return!0}return!1}function Ri(e,t,n,r,i,a,o){Z.setBuffer(e._roots[t]),zi(0,e,n,r,i,a,o),Z.clearBuffer()}function zi(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c))Ai(t,n,r,K(e,l),q(u,c),i,a,o);else{let c=J(e);Pi(c,s,r,a,o)&&zi(c,t,n,r,i,a,o);let u=Y(e,l);Pi(u,s,r,a,o)&&zi(u,t,n,r,i,a,o)}}let Bi=[`x`,`y`,`z`];function Vi(e,t,n,r,i,a){Z.setBuffer(e._roots[t]);let o=Hi(0,e,n,r,i,a);return Z.clearBuffer(),o}function Hi(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Z,l=e*2;if(G(l,s))return ji(t,n,r,K(e,c),q(l,s),i,a);{let s=sr(e,c),l=Bi[s],u=r.direction[l]>=0,d,f;u?(d=J(e),f=Y(e,c)):(d=Y(e,c),f=J(e));let p=Pi(d,o,r,i,a)?Hi(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=Pi(f,o,r,i,a)?Hi(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let Ui=/* @__PURE__ */ new z,Wi=/* @__PURE__ */ new di,Gi=/* @__PURE__ */ new di,Ki=/* @__PURE__ */ new I,qi=/* @__PURE__ */ new Q,Ji=/* @__PURE__ */ new Q;function Yi(e,t,n,r){Z.setBuffer(e._roots[t]);let i=Xi(0,e,n,r);return Z.clearBuffer(),i}function Xi(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Z,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),qi.set(n.boundingBox.min,n.boundingBox.max,r),i=qi),G(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=K(e,s),m=q(c,o);if(Ki.copy(r).invert(),n.boundsTree)return W(X(e),a,Ji),Ji.matrix.copy(Ki),Ji.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>Ji.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let t=p*3,n=(m+p)*3;t<n;t+=3)if($(Gi,t,l,u),Gi.needsUpdate=!0,e.intersectsTriangle(Gi))return!0;return!1}});{let e=Yr(n);for(let t=p*3,n=(m+p)*3;t<n;t+=3){$(Wi,t,l,u),Wi.a.applyMatrix4(Ki),Wi.b.applyMatrix4(Ki),Wi.c.applyMatrix4(Ki),Wi.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(Gi,t,d,f),Gi.needsUpdate=!0,Wi.intersectsTriangle(Gi))return!0}}}else{let o=J(e),c=Y(e,s);return W(X(o),a,Ui),!!(i.intersectsBox(Ui)&&Xi(o,t,n,r,i)||(W(X(c),a,Ui),i.intersectsBox(Ui)&&Xi(c,t,n,r,i)))}}let Zi=/* @__PURE__ */ new I,Qi=/* @__PURE__ */ new Q,$i=/* @__PURE__ */ new Q,ea=/* @__PURE__ */ new M,ta=/* @__PURE__ */ new M,na=/* @__PURE__ */ new M,ra=/* @__PURE__ */ new M;function ia(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),Qi.set(t.boundingBox.min,t.boundingBox.max,n),Qi.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=fi.getPrimitive(),p=fi.getPrimitive(),m=ea,h=ta,g=null,_=null;i&&(g=na,_=ra);let v=1/0,y=null,b=null;return Zi.copy(n).invert(),$i.matrix.copy(Zi),e.shapecast({boundsTraverseOrder:e=>Qi.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&($i.min.copy(e.min),$i.max.copy(e.max),$i.needsUpdate=!0),!0),intersectsRange:(e,r)=>{if(t.boundsTree)return t.boundsTree.shapecast({boundsTraverseOrder:e=>$i.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,i)=>{for(let o=t,s=t+i;o<s;o++){$(p,3*o,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=e,n=e+r;t<n;t++){$(f,3*t,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=t,b=o),e<a)return!0}}}});{let i=Yr(t);for(let t=0,o=i;t<o;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=e,i=e+r;n<i;n++){$(f,3*n,l,c),f.needsUpdate=!0;let e=f.distanceToTriangle(p,m,g);if(e<v&&(h.copy(m),_&&_.copy(g),v=e,y=n,b=t),e<a)return!0}}}}}),fi.releasePrimitive(f),fi.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(Zi),h.applyMatrix4(Zi),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function aa(e,t=null){t&&Array.isArray(t)&&(t=new Set(t));let n=e.geometry,r=n.index?n.index.array:null,i=n.attributes.position,a,o,s,c,l=0,u=e._roots;for(let e=0,t=u.length;e<t;e++)a=u[e],o=new Uint32Array(a),s=new Uint16Array(a),c=new Float32Array(a),d(0,l),l+=a.byteLength;function d(n,a,l=!1){let u=n*2;if(G(u,s)){let t=K(n,o),a=q(u,s),l=1/0,d=1/0,f=1/0,p=-1/0,m=-1/0,h=-1/0;for(let n=t,o=t+a;n<o;n++){let t=3*e.resolveTriangleIndex(n);for(let e=0;e<3;e++){let n=t+e;n=r?r[n]:n;let a=i.getX(n),o=i.getY(n),s=i.getZ(n);a<l&&(l=a),a>p&&(p=a),o<d&&(d=o),o>m&&(m=o),s<f&&(f=s),s>h&&(h=s)}}return c[n+0]!==l||c[n+1]!==d||c[n+2]!==f||c[n+3]!==p||c[n+4]!==m||c[n+5]!==h?(c[n+0]=l,c[n+1]=d,c[n+2]=f,c[n+3]=p,c[n+4]=m,c[n+5]=h,!0):!1}{let e=J(n),r=Y(n,o),i=l,s=!1,u=!1;if(t){if(!i){let n=e/8+a/32,o=r/8+a/32;s=t.has(n),u=t.has(o),i=!s&&!u}}else s=!0,u=!0;let f=i||s,p=i||u,m=!1;f&&(m=d(e,a,i));let h=!1;p&&(h=d(r,a,i));let g=m||h;if(g)for(let t=0;t<3;t++){let i=e+t,a=r+t,o=c[i],s=c[i+3],l=c[a],u=c[a+3];c[n+t]=o<l?o:l,c[n+t+3]=s>u?s:u}return g}}}function oa(e,t,n,r,i,a,o){Z.setBuffer(e._roots[t]),sa(0,e,n,r,i,a,o),Z.clearBuffer()}function sa(e,t,n,r,i,a,o){let{float32Array:s,uint16Array:c,uint32Array:l}=Z,u=e*2;if(G(u,c))Fi(t,n,r,K(e,l),q(u,c),i,a,o);else{let c=J(e);Pi(c,s,r,a,o)&&sa(c,t,n,r,i,a,o);let u=Y(e,l);Pi(u,s,r,a,o)&&sa(u,t,n,r,i,a,o)}}let ca=[`x`,`y`,`z`];function la(e,t,n,r,i,a){Z.setBuffer(e._roots[t]);let o=ua(0,e,n,r,i,a);return Z.clearBuffer(),o}function ua(e,t,n,r,i,a){let{float32Array:o,uint16Array:s,uint32Array:c}=Z,l=e*2;if(G(l,s))return Ii(t,n,r,K(e,c),q(l,s),i,a);{let s=sr(e,c),l=ca[s],u=r.direction[l]>=0,d,f;u?(d=J(e),f=Y(e,c)):(d=Y(e,c),f=J(e));let p=Pi(d,o,r,i,a)?ua(d,t,n,r,i,a):null;if(p){let e=p.point[l];if(u?e<=o[f+s]:e>=o[f+s+3])return p}let m=Pi(f,o,r,i,a)?ua(f,t,n,r,i,a):null;return p&&m?p.distance<=m.distance?p:m:p||m||null}}let da=/* @__PURE__ */ new z,fa=/* @__PURE__ */ new di,pa=/* @__PURE__ */ new di,ma=/* @__PURE__ */ new I,ha=/* @__PURE__ */ new Q,ga=/* @__PURE__ */ new Q;function _a(e,t,n,r){Z.setBuffer(e._roots[t]);let i=va(0,e,n,r);return Z.clearBuffer(),i}function va(e,t,n,r,i=null){let{float32Array:a,uint16Array:o,uint32Array:s}=Z,c=e*2;if(i===null&&(n.boundingBox||n.computeBoundingBox(),ha.set(n.boundingBox.min,n.boundingBox.max,r),i=ha),G(c,o)){let i=t.geometry,l=i.index,u=i.attributes.position,d=n.index,f=n.attributes.position,p=K(e,s),m=q(c,o);if(ma.copy(r).invert(),n.boundsTree)return W(X(e),a,ga),ga.matrix.copy(ma),ga.needsUpdate=!0,n.boundsTree.shapecast({intersectsBounds:e=>ga.intersectsBox(e),intersectsTriangle:e=>{e.a.applyMatrix4(r),e.b.applyMatrix4(r),e.c.applyMatrix4(r),e.needsUpdate=!0;for(let n=p,r=m+p;n<r;n++)if($(pa,3*t.resolveTriangleIndex(n),l,u),pa.needsUpdate=!0,e.intersectsTriangle(pa))return!0;return!1}});{let e=Yr(n);for(let n=p,r=m+p;n<r;n++){let r=t.resolveTriangleIndex(n);$(fa,3*r,l,u),fa.a.applyMatrix4(ma),fa.b.applyMatrix4(ma),fa.c.applyMatrix4(ma),fa.needsUpdate=!0;for(let t=0,n=e*3;t<n;t+=3)if($(pa,t,d,f),pa.needsUpdate=!0,fa.intersectsTriangle(pa))return!0}}}else{let o=J(e),c=Y(e,s);return W(X(o),a,da),!!(i.intersectsBox(da)&&va(o,t,n,r,i)||(W(X(c),a,da),i.intersectsBox(da)&&va(c,t,n,r,i)))}}let ya=/* @__PURE__ */ new I,ba=/* @__PURE__ */ new Q,xa=/* @__PURE__ */ new Q,Sa=/* @__PURE__ */ new M,Ca=/* @__PURE__ */ new M,wa=/* @__PURE__ */ new M,Ta=/* @__PURE__ */ new M;function Ea(e,t,n,r={},i={},a=0,o=1/0){t.boundingBox||t.computeBoundingBox(),ba.set(t.boundingBox.min,t.boundingBox.max,n),ba.needsUpdate=!0;let s=e.geometry,c=s.attributes.position,l=s.index,u=t.attributes.position,d=t.index,f=fi.getPrimitive(),p=fi.getPrimitive(),m=Sa,h=Ca,g=null,_=null;i&&(g=wa,_=Ta);let v=1/0,y=null,b=null;return ya.copy(n).invert(),xa.matrix.copy(ya),e.shapecast({boundsTraverseOrder:e=>ba.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o&&(t&&(xa.min.copy(e.min),xa.max.copy(e.max),xa.needsUpdate=!0),!0),intersectsRange:(r,i)=>{if(t.boundsTree){let s=t.boundsTree;return s.shapecast({boundsTraverseOrder:e=>xa.distanceToBox(e),intersectsBounds:(e,t,n)=>n<v&&n<o,intersectsRange:(t,o)=>{for(let x=t,S=t+o;x<S;x++){let t=s.resolveTriangleIndex(x);$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let t=r,n=r+i;t<n;t++){let n=e.resolveTriangleIndex(t);$(f,3*n,l,c),f.needsUpdate=!0;let r=f.distanceToTriangle(p,m,g);if(r<v&&(h.copy(m),_&&_.copy(g),v=r,y=t,b=x),r<a)return!0}}}})}{let o=Yr(t);for(let t=0,s=o;t<s;t++){$(p,3*t,d,u),p.a.applyMatrix4(n),p.b.applyMatrix4(n),p.c.applyMatrix4(n),p.needsUpdate=!0;for(let n=r,o=r+i;n<o;n++){let r=e.resolveTriangleIndex(n);$(f,3*r,l,c),f.needsUpdate=!0;let i=f.distanceToTriangle(p,m,g);if(i<v&&(h.copy(m),_&&_.copy(g),v=i,y=n,b=t),i<a)return!0}}}}}),fi.releasePrimitive(f),fi.releasePrimitive(p),v===1/0?null:(r.point?r.point.copy(h):r.point=h.clone(),r.distance=v,r.faceIndex=y,i&&(i.point?i.point.copy(_):i.point=_.clone(),i.point.applyMatrix4(ya),h.applyMatrix4(ya),i.distance=h.sub(i.point).length(),i.faceIndex=b),r)}function Da(e,t,n){return e===null?null:(e.point.applyMatrix4(t.matrixWorld),e.distance=e.point.distanceTo(n.ray.origin),e.object=t,e)}let Oa=/* @__PURE__ */ new Q,ka=/* @__PURE__ */ new Gt,Aa=/* @__PURE__ */ new M,ja=/* @__PURE__ */ new I,Ma=/* @__PURE__ */ new M,Na=[`getX`,`getY`,`getZ`];var Pa=class e extends ni{static serialize(e,t={}){t={cloneBuffers:!0,...t};let n=e.geometry,r=e._roots,i=e._indirectBuffer,a=n.getIndex(),o={version:1,roots:null,index:null,indirectBuffer:null};return t.cloneBuffers?(o.roots=r.map(e=>e.slice()),o.index=a?a.array.slice():null,o.indirectBuffer=i?i.slice():null):(o.roots=r,o.index=a?a.array:null,o.indirectBuffer=i),o}static deserialize(t,n,r={}){r={setIndex:!0,indirect:!!t.indirectBuffer,...r};let{index:i,roots:a,indirectBuffer:o}=t;t.version||(console.warn(`MeshBVH.deserialize: Serialization format has been changed and will be fixed up. It is recommended to regenerate any stored serialized data.`),c(a));let s=new e(n,{...r,[er]:!0});if(s._roots=a,s._indirectBuffer=o||null,r.setIndex){let e=n.getIndex();if(e===null){let e=new Ct(t.index,1,!1);n.setIndex(e)}else e.array!==i&&(e.array.set(i),e.needsUpdate=!0)}return s;function c(e){for(let t=0;t<e.length;t++){let n=e[t],r=new Uint32Array(n),i=new Uint16Array(n);for(let e=0,t=n.byteLength/32;e<t;e++){let t=8*e;G(2*t,i)||(r[t+6]=r[t+6]/8-e)}}}}get primitiveStride(){return 3}get resolveTriangleIndex(){return this.resolvePrimitiveIndex}constructor(e,t={}){t.maxLeafTris&&(console.warn(`MeshBVH: \"maxLeafTris\" option has been deprecated. Use \"targetLeafSize\", instead.`),t={...t,targetLeafSize:t.maxLeafTris}),super(e,t)}shiftTriangleOffsets(e){return super.shiftPrimitiveOffsets(e)}writePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=(i?i[e]:e)*3,c=s+0,l=s+1,u=s+2;o&&(c=o[c],l=o[l],u=o[u]);for(let e=0;e<3;e++){let r=a[Na[e]](c),i=a[Na[e]](l),o=a[Na[e]](u),s=r;i<s&&(s=i),o<s&&(s=o);let d=r;i>d&&(d=i),o>d&&(d=o),t[n+e]=s,t[n+e+3]=d}return t}computePrimitiveBounds(e,t,n){let r=this.geometry,i=this._indirectBuffer,a=r.attributes.position,o=r.index?r.index.array:null,s=a.normalized;if(e<0||t+e-n.offset>n.length/6)throw Error(`MeshBVH: compute triangle bounds range is invalid.`);let c=a.array,l=a.offset||0,u=3;a.isInterleavedBufferAttribute&&(u=a.data.stride);let d=[`getX`,`getY`,`getZ`],f=n.offset;for(let r=e,p=e+t;r<p;r++){let e=(i?i[r]:r)*3,t=(r-f)*6,p=e+0,m=e+1,h=e+2;o&&(p=o[p],m=o[m],h=o[h]),s||(p=p*u+l,m=m*u+l,h=h*u+l);for(let e=0;e<3;e++){let r,i,o;s?(r=a[d[e]](p),i=a[d[e]](m),o=a[d[e]](h)):(r=c[p+e],i=c[m+e],o=c[h+e]);let l=r;i<l&&(l=i),o<l&&(l=o);let u=r;i>u&&(u=i),o>u&&(u=o);let f=(u-l)/2,g=e*2;n[t+g+0]=l+f,n[t+g+1]=f+(Math.abs(l)+f)*$n}}return n}raycastObject3D(e,t,n=[]){let{material:r}=e;if(r===void 0)return;ja.copy(e.matrixWorld).invert(),ka.copy(t.ray).applyMatrix4(ja),Ma.setFromMatrixScale(e.matrixWorld),Aa.copy(ka.direction).multiply(Ma);let i=Aa.length(),a=t.near/i,o=t.far/i;if(t.firstHitOnly===!0){let i=this.raycastFirst(ka,r,a,o);i=Da(i,e,t),i&&n.push(i)}else{let i=this.raycast(ka,r,a,o);for(let r=0,a=i.length;r<a;r++){let a=Da(i[r],e,t);a&&n.push(a)}}return n}refit(e=null){return(this.indirect?aa:Ni)(this,e)}raycast(e,t=0,n=0,r=1/0){let i=this._roots,a=[],o=this.indirect?oa:Ri;for(let s=0,c=i.length;s<c;s++)o(this,s,t,e,a,n,r);return a}raycastFirst(e,t=0,n=0,r=1/0){let i=this._roots,a=null,o=this.indirect?la:Vi;for(let s=0,c=i.length;s<c;s++){let i=o(this,s,t,e,n,r);i!=null&&(a==null||i.distance<a.distance)&&(a=i)}return a}intersectsGeometry(e,t){let n=!1,r=this._roots,i=this.indirect?_a:Yi;for(let a=0,o=r.length;a<o&&(n=i(this,a,e,t),!n);a++);return n}shapecast(e){let t=fi.getPrimitive(),n=super.shapecast({...e,intersectsPrimitive:e.intersectsTriangle,scratchPrimitive:t,iterate:this.indirect?Li:Mi});return fi.releasePrimitive(t),n}bvhcast(t,n,r){let{intersectsRanges:i,intersectsTriangles:a}=r,o=fi.getPrimitive(),s=this.geometry.index,c=this.geometry.attributes.position,l=this.indirect?e=>{let t=this.resolveTriangleIndex(e);$(o,t*3,s,c)}:e=>{$(o,e*3,s,c)},u=fi.getPrimitive(),d=t.geometry.index,f=t.geometry.attributes.position,p=t.indirect?e=>{let n=t.resolveTriangleIndex(e);$(u,n*3,d,f)}:e=>{$(u,e*3,d,f)};if(a){if(!(t instanceof e))throw Error(`MeshBVH: \"intersectsTriangles\" callback can only be used with another MeshBVH.`);let r=(e,t,r,i,s,c,d,f)=>{for(let m=r,h=r+i;m<h;m++){p(m),u.a.applyMatrix4(n),u.b.applyMatrix4(n),u.c.applyMatrix4(n),u.needsUpdate=!0;for(let n=e,r=e+t;n<r;n++)if(l(n),o.needsUpdate=!0,a(o,u,n,m,s,c,d,f))return!0}return!1};if(i){let e=i;i=function(t,n,i,a,o,s,c,l){return e(t,n,i,a,o,s,c,l)?!0:r(t,n,i,a,o,s,c,l)}}else i=r}return super.bvhcast(t,n,{intersectsRanges:i})}intersectsBox(e,t){return Oa.set(e.min,e.max,t),Oa.needsUpdate=!0,this.shapecast({intersectsBounds:e=>Oa.intersectsBox(e),intersectsTriangle:e=>Oa.intersectsTriangle(e)})}intersectsSphere(e){return this.shapecast({intersectsBounds:t=>e.intersectsBox(t),intersectsTriangle:t=>t.intersectsSphere(e)})}closestPointToGeometry(e,t,n={},r={},i=0,a=1/0){return(this.indirect?Ea:ia)(this,e,t,n,r,i,a)}closestPointToPoint(e,t={},n=0,r=1/0){return hi(this,e,t,n,r)}};function Fa(e){let t=new It;return t.setAttribute(`position`,new Ct(e.positions,3)),e.index&&t.setIndex(new Ct(e.index,1)),{bvh:Pa.deserialize(e.bvh,t,{setIndex:!1})}}function Ia(e){return e.geometries.map(Fa)}function La(e,t,n){let r=new I().fromArray(t,e.matrixOffset);return{...e,supportId:n,inverseMatrix:r,localToWorldMatrix:r.clone().invert()}}function Ra(e){let t=/* @__PURE__ */ new Map;for(let n=0;n<e.instances.length;n++){let r=e.instances[n],i=La(r,e.inverseInstanceMatrices,n),a=t.get(i.objectUuid)??[];a.push(i),t.set(i.objectUuid,a)}return e.boxTree.identifiers.map(e=>e===null?void 0:t.get(e))}function za(e,t=[]){self.postMessage(e,{transfer:t})}function Ba(e){za({type:`VoxelizationProgress`,progress:e})}function Va(e,t){za({type:`VoxelizationChunk`,rootIndex:t,chunk:e})}function Ha(e,t){za({type:`VoxelizationFinished`,metadata:e,processedVoxelCount:t},[e.origin.buffer,e.gridBounds.buffer,e.granularities.buffer])}function Ua(e){za({type:`VoxelizationError`,error:typeof e==`object`&&e&&`message`in e?String(e.message):String(e)})}let Wa=/* @__PURE__ */ new z,Ga={solid:!1,verticalConnectionAllowed:!1,horizontalConnectionAllowed:!1,supportHeight:NaN,supportId:-1};function Ka(e,t,n){let r=t.granularities[0],i=En(e.sceneBounds,r),a=Math.max(i[3]-i[0],i[4]-i[1],i[5]-i[2]),o=r*32,s=r;for(;s<a&&s<o;)s*=2;let c=En(e.sceneBounds,s),l=new Float64Array(c.slice(0,3)),u=[];for(let e=s;e>t.granularities[0];e/=2)u.push(e);u.push(...t.granularities);let d=Ia(e),f=Ra(e);return{options:t,globalMaxVoxelCount:n,rootSize:s,gridBounds:c,origin:l,granularities:new Float32Array(u),geometries:d,boxTree:Fn(e,f)}}function qa(e){let{gridBounds:t,rootSize:n}=e;return[Math.round((t[3]-t[0])/n),Math.round((t[4]-t[1])/n),Math.round((t[5]-t[2])/n)]}function Ja(e,t,n){let r=n[0]*n[1];e.x=t%n[0],e.y=Math.floor(t/n[0])%n[1],e.z=Math.floor(t/r),e.level=0}function Ya(){return{processedVoxelCount:0,voxelCount:0,solidVoxelCount:0,emptyVoxelCount:0,progress:0}}function Xa(e,t,n,r){if(!(t+n<=e))throw Error(`Voxelization exceeds this worker's share of ${e} retained voxels (global limit ${r}) (${t} leaves and ${n} pending).`)}function Za(e,t,n,r,i,a){let{options:o,origin:s,granularities:c}=r;a.reset(e);let l={x:0,y:0,z:0,level:0},u=i.processedVoxelCount,d=Array.from(c,()=>[]);for(;a.pending.pop(l);){let e=c[l.level];Wa.min.set(s[0]+l.x*e,s[1]+l.y*e,s[2]+l.z*e),Wa.max.copy(Wa.min).addScalar(e);let f=d[l.level];l.level===0?In(r.boxTree,Wa,o.boxTreeLevel,f):Ln(r.boxTree,Wa,d[l.level-1],f);let p=Rn(r.boxTree,f,Wa,r.geometries,Ga,l.level===c.length-1),{solid:m}=p;i.processedVoxelCount++;let h=n-t-1;if((m||p.horizontalConnectionAllowed)&&l.level+1<c.length){let t=l.level+1,n=Math.round(e/c[t]),s=n**3;Xa(o.maxVoxelCount,i.voxelCount+a.leafCount,a.pending.length+s+h,r.globalMaxVoxelCount),Jn(l,t,n,a.pending)}else{Yn(l,m,p,a,i);let e=i.voxelCount+a.leafCount;Xa(o.maxVoxelCount,e,a.pending.length+h,r.globalMaxVoxelCount)}let g=a.pending.length+h;if(i.processedVoxelCount%1e4==0){let e=i.processedVoxelCount-u,r=e/(e+a.pending.length);i.progress=Math.max(i.progress,(t+r)/n),Ba({processedVoxelCount:i.processedVoxelCount,pendingVoxelCount:g,progress:i.progress})}}return i.voxelCount+=a.leafCount,Xn(e,r.rootSize,s,a)}function Qa(e,t){return{version:1,origin:e.origin,gridBounds:e.gridBounds,granularities:e.granularities,voxelCount:t.voxelCount,solidVoxelCount:t.solidVoxelCount,emptyVoxelCount:t.emptyVoxelCount}}function $a(e,t,n,r,i){Tn(t);let a=Ka(e,t,i),o=qa(a),s=o[0]*o[1]*o[2],c=Ya(),l=new qn,u=Math.max(0,Math.ceil((s-n)/r));if(u>t.maxVoxelCount)throw Error(`This worker's root grid requires ${u} voxels, above this worker's share of ${t.maxVoxelCount} (global limit ${i}).`);let d=0,f={x:0,y:0,z:0,level:0};for(let e=n;e<s;e+=r)Ja(f,e,o),Va(Za(f,d,u,a,c,l),e),d++,c.progress=d/u,Ba({processedVoxelCount:c.processedVoxelCount,pendingVoxelCount:u-d,progress:c.progress});return{metadata:Qa(a,c),processedVoxelCount:c.processedVoxelCount}}self.onmessage=e=>{try{let t=$a(e.data.snapshot,e.data.options,e.data.workerIndex,e.data.workerCount,e.data.globalMaxVoxelCount);Ha(t.metadata,t.processedVoxelCount)}catch(e){Ua(e)}}})();\n//# sourceMappingURL=VoxelizationWorker-Cat7shE7.js.map", Rs = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Ls], { type: "text/javascript;charset=utf-8" });
function zs(e) {
	let t;
	try {
		if (t = Rs && (self.URL || self.webkitURL).createObjectURL(Rs), !t) throw "";
		let n = new Worker(t, { name: e?.name });
		return n.addEventListener("error", () => {
			(self.URL || self.webkitURL).revokeObjectURL(t);
		}), n;
	} catch {
		return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(Ls), { name: e?.name });
	}
}
//#endregion
//#region src/PathPlugin/voxelization/worker/VoxelizationWorkerController.ts
function Bs(e, t) {
	let n = e[0];
	if (n === void 0) throw Error("Voxelization finished without worker metadata.");
	let r = [...t].sort((e, t) => e.rootIndex - t.rootIndex).map(({ chunk: e }) => e);
	return {
		...n,
		chunks: r,
		voxelCount: e.reduce((e, t) => e + t.voxelCount, 0),
		solidVoxelCount: e.reduce((e, t) => e + t.solidVoxelCount, 0),
		emptyVoxelCount: e.reduce((e, t) => e + t.emptyVoxelCount, 0)
	};
}
var Vs = class {
	get running() {
		return this.workerIds.size > 0;
	}
	constructor() {
		this.controller = new Ce(zs, "PathVoxelizationWorker", 1), this.workerIds = /* @__PURE__ */ new Set(), this.finishedWorkerIds = /* @__PURE__ */ new Set(), this.progressByWorker = /* @__PURE__ */ new Map(), this.resolvePromise = null, this.rejectPromise = null, this.onProgress = null, this.chunks = [], this.metadata = [], this.maxVoxelCount = 0, this.retainedVoxelCount = 0, this.lastProgress = 0, this.lastNotifiedPercentage = -1, this.handleMessage = async (e, t) => {
			if (!this.workerIds.has(t)) return;
			let n = e.data;
			n.type === "VoxelizationProgress" ? (this.progressByWorker.set(t, n.progress), this.emitProgress()) : n.type === "VoxelizationChunk" ? (this.chunks.push({
				rootIndex: n.rootIndex,
				chunk: n.chunk
			}), this.retainedVoxelCount += n.chunk.states.length, this.retainedVoxelCount > this.maxVoxelCount && this.fail(/* @__PURE__ */ Error(`Voxelization requires more than ${this.maxVoxelCount} retained voxels.`))) : n.type === "VoxelizationFinished" ? this.handleWorkerFinished(t, n.metadata, n.processedVoxelCount) : this.fail(Error(n.error));
		}, this.handleError = async (e, t) => {
			this.workerIds.has(t) && this.fail(Error(e.message.trim() || "Voxelization worker stopped unexpectedly."));
		}, this.handleMessageError = async (e, t) => {
			this.workerIds.has(t) && this.fail(/* @__PURE__ */ Error("Voxelization worker returned an unreadable message."));
		}, this.controller.onmessage = this.handleMessage, this.controller.onerror = this.handleError, this.controller.onmessageerror = this.handleMessageError;
	}
	start(e, t, n) {
		return this.cancel(), this.controller.reset(), this.controller.maxWorkers = Math.max(this.controller.maxWorkers, t.workerCount), this.onProgress = n, this.chunks = [], this.metadata = [], this.maxVoxelCount = t.maxVoxelCount, this.retainedVoxelCount = 0, this.lastProgress = 0, this.lastNotifiedPercentage = -1, this.workerIds.clear(), this.finishedWorkerIds.clear(), this.progressByWorker.clear(), new Promise((n, r) => {
			this.resolvePromise = n, this.rejectPromise = r;
			try {
				let n = Math.floor(t.maxVoxelCount / t.workerCount);
				if (n < 1) throw Error("Maximum voxel count must be at least the worker count.");
				for (let r = 0; r < t.workerCount; r++) this.workerIds.add(r), this.progressByWorker.set(r, {
					processedVoxelCount: 0,
					pendingVoxelCount: 1,
					progress: 0
				}), this.controller.lockWorker(r), this.controller.postMessageWithId(r, {
					type: "StartVoxelization",
					snapshot: e,
					options: {
						...t,
						maxVoxelCount: n
					},
					workerIndex: r,
					workerCount: t.workerCount,
					globalMaxVoxelCount: t.maxVoxelCount
				});
			} catch (e) {
				let t = typeof e == "object" && e && "message" in e ? String(e.message) : String(e);
				this.finish(!0), r(Error(t));
			}
		});
	}
	cancel() {
		if (!this.running) return;
		let e = this.rejectPromise;
		this.finish(!0), e?.(/* @__PURE__ */ Error("Voxelization was cancelled."));
	}
	dispose() {
		this.cancel(), this.controller.terminateWorkers();
	}
	emitProgress(e = !1) {
		let t = 0, n = 0, r = 0;
		for (let e of this.progressByWorker.values()) t += e.processedVoxelCount, n += e.pendingVoxelCount, r += e.progress;
		let i = Math.max(this.lastProgress, r / this.progressByWorker.size);
		this.lastProgress = i;
		let a = Math.floor(i * 100);
		(e || a !== this.lastNotifiedPercentage) && (this.lastNotifiedPercentage = a, this.onProgress?.({
			processedVoxelCount: t,
			pendingVoxelCount: n,
			progress: i
		}));
	}
	handleWorkerFinished(e, t, n) {
		if (this.finishedWorkerIds.add(e), this.metadata.push(t), this.progressByWorker.set(e, {
			processedVoxelCount: n,
			pendingVoxelCount: 0,
			progress: 1
		}), this.controller.freeWorker(e), this.emitProgress(!0), this.finishedWorkerIds.size !== this.workerIds.size) return;
		let r = this.resolvePromise, i = Bs(this.metadata, this.chunks);
		this.finish(!1), r?.(i);
	}
	fail(e) {
		let t = this.rejectPromise;
		this.finish(!0), t?.(e);
	}
	finish(e) {
		for (let t of this.workerIds) e ? this.controller.terminateWorker(t) : this.controller.freeWorker(t);
		this.workerIds.clear(), this.finishedWorkerIds.clear(), this.progressByWorker.clear(), this.resolvePromise = null, this.rejectPromise = null, this.onProgress = null, this.chunks = [], this.metadata = [], this.maxVoxelCount = 0, this.retainedVoxelCount = 0, this.lastProgress = 0, this.lastNotifiedPercentage = -1;
	}
}, Hs = {
	processedVoxelCount: 0,
	pendingVoxelCount: 0,
	progress: 0
}, Us = class {
	constructor(e, t) {
		this.viewer = e, this.debugController = t, this.signals = { onChanged: new T() }, this.workerController = new Vs(), this.currentStatus = "idle", this.currentProgress = Hs, this.currentResult = null, this.currentError = null, this.currentWarning = null, this.currentSceneSnapshot = null, this.currentNeedsUpdate = !1, this.runId = 0;
	}
	get status() {
		return this.currentStatus;
	}
	get progress() {
		return this.currentProgress;
	}
	get result() {
		return this.currentResult;
	}
	get error() {
		return this.currentError;
	}
	get warning() {
		return this.currentWarning;
	}
	get needsUpdate() {
		return this.currentNeedsUpdate;
	}
	get sceneSnapshot() {
		return this.currentSceneSnapshot;
	}
	markResultForUpdate() {
		this.currentResult && !this.currentNeedsUpdate && (this.currentNeedsUpdate = !0, this.signals.onChanged.emit());
	}
	cancel() {
		this.runId++, this.workerController.cancel(), this.currentStatus = "idle", this.currentProgress = Hs, this.signals.onChanged.emit();
	}
	clear() {
		this.cancel(), this.currentResult = null, this.currentError = null, this.currentWarning = null, this.currentSceneSnapshot = null, this.currentNeedsUpdate = !1, this.debugController.setGrid(null), this.signals.onChanged.emit();
	}
	dispose() {
		this.runId++, this.workerController.dispose();
	}
	async start(e) {
		let t = this.beginRun();
		try {
			Fs(e);
			let { snapshot: n, statistics: r } = Ns(this.viewer, e);
			r.inspectedObjectCount > 0 && r.objectWithTypeCount === 0 && (this.currentWarning = "missingObjectTypes"), this.ensureRunIsActive(t), this.currentStatus = "running", this.signals.onChanged.emit();
			let i = await this.workerController.start(n, e, (e) => {
				t === this.runId && (this.currentProgress = e, this.signals.onChanged.emit());
			});
			return this.ensureRunIsActive(t), this.completeRun(i, n);
		} catch (e) {
			throw this.failRun(e, t), e;
		}
	}
	beginRun() {
		this.workerController.cancel();
		let e = ++this.runId;
		return this.currentStatus = "preparing", this.currentError = null, this.currentWarning = null, this.currentNeedsUpdate = !1, this.currentProgress = Hs, this.signals.onChanged.emit(), e;
	}
	ensureRunIsActive(e) {
		if (e !== this.runId) throw Error("Voxelization was cancelled.");
	}
	completeRun(e, t) {
		let n = new bs(e);
		this.currentResult = n, this.currentSceneSnapshot = t, this.currentStatus = "completed", this.currentNeedsUpdate = !1, this.currentProgress = {
			processedVoxelCount: e.voxelCount,
			pendingVoxelCount: 0,
			progress: 1
		};
		let r = this.debugController.visible;
		return this.debugController.visible = !1, this.debugController.setGrid(n), this.debugController.visible = r, this.signals.onChanged.emit(), n;
	}
	failRun(e, t) {
		t === this.runId && (this.currentStatus = "error", this.currentError = typeof e == "object" && e && "message" in e ? String(e.message) : String(e), this.signals.onChanged.emit());
	}
}, Ws = /* @__PURE__ */ new Ie(1477887), Gs = /* @__PURE__ */ new Ie(16724016), Ks = /* @__PURE__ */ new Ie(2148715), qs = /* @__PURE__ */ new Ie(16750592), Js = /* @__PURE__ */ new Ie(8421504), Ys = /* @__PURE__ */ new Me(1, 1, 1), Xs = /* @__PURE__ */ new Be(Ys), Zs = 5, Qs = 3;
function $s(e, t, n, r, i) {
	return i === 1 || ((Math.imul(e, 73856093) ^ Math.imul(t, 19349663) ^ Math.imul(n, 83492791) ^ Math.imul(r, 2654435761)) >>> 0) % i == 0;
}
var ec = "\n  attribute vec3 instanceOffset;\n  uniform float voxelSize;\n\n  void main() {\n    vec3 transformed = position * voxelSize + instanceOffset;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(transformed, 1.0);\n  }\n", tc = "\n  uniform vec3 voxelColor;\n\n  void main() {\n    gl_FragColor = vec4(voxelColor, 1.0);\n  }\n", nc = class {
	constructor(e) {
		this.viewer = e, this.signals = { onChanged: new T() }, this.group = new He(), this.isVisible = !1, this.selectedLevel = null, this.currentGrid = null, this.currentDisplayStride = Zs, this.selectedCategory = "all", this.displayedClassification = null, this.floodFillNeedsUpdate = !1, this.voxelsOnTop = !1, this.attachGroup = () => {
			this.viewer.scene.addInternalObject(this.group);
		}, this.group.name = "VoxelDebug", this.group.visible = !1;
	}
	get visible() {
		return this.isVisible;
	}
	set visible(e) {
		e !== this.isVisible && (this.isVisible = e, this.group.visible = e, e && this.group.children.length === 0 && this.rebuildMeshes(), this.viewer.requestRender(), this.signals.onChanged.emit());
	}
	get level() {
		return this.selectedLevel;
	}
	set level(e) {
		e !== this.selectedLevel && (this.selectedLevel = e, this.applyFilters(), this.signals.onChanged.emit());
	}
	get displayStride() {
		return this.currentDisplayStride;
	}
	set displayStride(e) {
		let t = Number.isFinite(e) ? Math.max(1, Math.floor(e)) : 1;
		t !== this.currentDisplayStride && (this.currentDisplayStride = t, this.disposeMeshes(), this.isVisible && this.rebuildMeshes(), this.viewer.requestRender(), this.signals.onChanged.emit());
	}
	get category() {
		return this.selectedCategory;
	}
	set category(e) {
		e !== this.selectedCategory && (this.selectedCategory = e, this.applyFilters(), this.signals.onChanged.emit());
	}
	get showVoxelsOnTop() {
		return this.voxelsOnTop;
	}
	set showVoxelsOnTop(e) {
		if (e !== this.voxelsOnTop) {
			this.voxelsOnTop = e;
			for (let t of this.group.children) {
				let n = t.material;
				n.depthTest = !e, n.depthWrite = !e;
			}
			this.viewer.requestRender(), this.signals.onChanged.emit();
		}
	}
	setup() {
		this.attachGroup(), this.viewer.signals.onSceneClear.connect(this.attachGroup);
	}
	setGrid(e) {
		this.currentGrid = e, this.displayedClassification = e?.classification ?? null, this.selectedLevel = null, this.floodFillNeedsUpdate = !1, !e?.classification && (this.selectedCategory === "navigable" || this.selectedCategory === "unclassified") && (this.selectedCategory = "all"), this.rebuildCurrentGrid(), this.signals.onChanged.emit();
	}
	refreshClassification(e) {
		let t = this.currentGrid?.classification ?? null, n = t !== this.displayedClassification;
		if (this.displayedClassification = t, this.floodFillNeedsUpdate = e, n) {
			(t === null ? this.selectedCategory === "navigable" || this.selectedCategory === "unclassified" : this.selectedCategory === "empty") && (this.selectedCategory = "all"), this.rebuildCurrentGrid(), this.signals.onChanged.emit();
			return;
		}
		for (let t of this.group.children) {
			if (t.userData.voxelState !== hs.Navigable) continue;
			let n = t.material;
			n.uniforms.voxelColor.value = e ? qs : Ks;
		}
		this.viewer.requestRender(), this.signals.onChanged.emit();
	}
	dispose() {
		this.viewer.signals.onSceneClear.disconnect(this.attachGroup), this.disposeMeshes(), this.viewer.scene.removeInternalObject(this.group);
	}
	rebuildCurrentGrid() {
		this.disposeMeshes(), this.isVisible && this.rebuildMeshes(), this.viewer.requestRender();
	}
	rebuildMeshes() {
		let e = this.currentGrid;
		if (e === null) return;
		let t = e.granularities.length * Qs, n = this.countDisplayedVoxels(e), r = Array.from(n, (e) => new Float32Array(e * 3)), i = new Uint32Array(t);
		this.fillDisplayedVoxelOffsets(e, r, i), this.createVoxelObjects(e, r), this.applyFilters();
	}
	countDisplayedVoxels(e) {
		let t = new Uint32Array(e.granularities.length * Qs);
		for (let n of e.chunks) for (let e = 0; e < n.states.length; e++) {
			let r = e * 3, i = n.levels[e];
			if (!$s(n.coordinates[r], n.coordinates[r + 1], n.coordinates[r + 2], i, this.currentDisplayStride)) continue;
			let a = n.states[e];
			t[i * Qs + a]++;
		}
		return t;
	}
	fillDisplayedVoxelOffsets(e, t, n) {
		for (let r of e.chunks) for (let i = 0; i < r.states.length; i++) {
			let a = i * 3, o = r.coordinates[a], s = r.coordinates[a + 1], c = r.coordinates[a + 2], l = r.levels[i];
			if (!$s(o, s, c, l, this.currentDisplayStride)) continue;
			let u = r.states[i], d = l * Qs + u, f = n[d] * 3, p = e.granularities[l], m = t[d];
			m[f] = e.origin[0] + (o + .5) * p, m[f + 1] = e.origin[1] + (s + .5) * p, m[f + 2] = e.origin[2] + (c + .5) * p, n[d]++;
		}
	}
	createVoxelObjects(e, t) {
		for (let n = 0; n < t.length; n++) {
			let r = t[n];
			if (r.length === 0) continue;
			let i = n % Qs, a = Math.floor(n / Qs), o = e.granularities[a], s = i === hs.Solid ? this.createSolidCubes(o, r) : this.createVoxelLines(o, r, i);
			s.name = `VoxelDebug:${a}:${i}`, s.userData.voxelState = i, s.userData.voxelLevel = a, s.frustumCulled = !1, this.group.add(s);
		}
	}
	createSolidCubes(e, t) {
		let n = this.createInstancedGeometry(t, Ys), r = this.createVoxelMaterial(e, Gs), i = new Xe(n, r);
		return i.renderOrder = 10, i;
	}
	createVoxelLines(e, t, n) {
		let r = this.createInstancedGeometry(t, Xs), i = this.floodFillNeedsUpdate ? qs : Ks, a = this.currentGrid?.classification === null ? Ws : Js, o = n === hs.Navigable ? i : a, s = this.createVoxelMaterial(e, o), c = new Ke(r, s);
		return c.renderOrder = 20, c;
	}
	createInstancedGeometry(e, t) {
		let n = new We();
		return n.setAttribute("position", t.getAttribute("position").clone()), n.setIndex(t.getIndex()?.clone() ?? null), n.setAttribute("instanceOffset", new Ue(e, 3)), n.instanceCount = e.length / 3, n;
	}
	createVoxelMaterial(e, t) {
		return new at({
			uniforms: {
				voxelSize: { value: e },
				voxelColor: { value: t }
			},
			vertexShader: ec,
			fragmentShader: tc,
			transparent: !1,
			depthTest: !this.voxelsOnTop,
			depthWrite: !this.voxelsOnTop
		});
	}
	disposeMeshes() {
		for (let e of Array.from(this.group.children)) {
			let t = e;
			t.geometry.dispose(), Array.isArray(t.material) ? t.material.forEach((e) => e.dispose()) : t.material.dispose(), t.removeFromParent();
		}
	}
	applyFilters() {
		for (let e of this.group.children) {
			let t = e.userData.voxelState, n = e.userData.voxelLevel;
			e.visible = (this.selectedCategory === "all" || this.stateMatchesSelectedCategory(t)) && (this.selectedLevel === null || this.selectedLevel === n);
		}
		this.viewer.requestRender();
	}
	stateMatchesSelectedCategory(e) {
		return this.selectedCategory === "solid" ? e === hs.Solid : this.selectedCategory === "navigable" ? e === hs.Navigable : this.selectedCategory === "empty" || this.selectedCategory === "unclassified" ? e === hs.Unclassified : !1;
	}
}, rc = 1e4, ic = /* @__PURE__ */ new lt(.14, 12, 8), ac = /* @__PURE__ */ new A(), oc = class extends le {
	constructor(e, t) {
		super(e), this.controller = t, this.container = Za(ic, rc), this.objectsBySeedId = /* @__PURE__ */ new Map(), this.attachContainer = () => {
			this._viewer.scene.addInternalObject(this.container.root);
		}, this.synchronize = () => {
			let e = /* @__PURE__ */ new Set();
			for (let t of this.controller.manualSeeds) {
				e.add(t.id);
				let n = this.objectsBySeedId.get(t.id);
				if (!n) {
					let e = new _(this.container, -1, ic.uuid);
					n = new jo(e, t.id), this.container.addInstance(e), n.diffuseColor = "#ffb300", n.isRaycastable = !0, this.objectsBySeedId.set(t.id, n), this.addObject(n);
				}
				ac.fromArray(t.position), $a(n, ac, 0), this._viewer.scene.updateObjectInBoxTree(n);
			}
			for (let [t, n] of this.objectsBySeedId) e.has(t) || (this.removeObject(n), this.objectsBySeedId.delete(t));
			this._viewer.requestRender();
		};
	}
	onSceneSetup(e) {
		this.controller.signals.onManualSeedsChanged.connect(this.synchronize), this.attachContainer(), this._viewer.signals.onSceneClear.connect(this.attachContainer), this.synchronize();
	}
	onSceneClear(e) {
		this.controller.signals.onManualSeedsChanged.disconnect(this.synchronize), this._viewer.signals.onSceneClear.disconnect(this.attachContainer), e.removeInternalObject(this.container.root);
	}
	accepts(e) {
		return e.isFloodFillSeedObject;
	}
	*meshContainers() {
		yield this.container;
	}
	*lineContainers() {}
	*edgesContainers() {}
	addObject(e) {
		super.addObject(e, null), this._viewer.scene.addObjectIntoBoxTree(e);
	}
	removeObject(e) {
		this._viewer.scene.isObjectInBoxTree(e) && this._viewer.scene.removeObjectFromBoxTree(e), this.container.removeInstance(e.meshProxy), super.removeObject(e);
	}
	clear() {
		for (let e of Array.from(this.objectsBySeedId.values())) this.removeObject(e);
		this.objectsBySeedId.clear();
	}
	dispose() {
		this.controller.signals.onManualSeedsChanged.disconnect(this.synchronize), this._viewer.signals.onSceneClear.disconnect(this.attachContainer), this.clear(), Qa(this.container), super.dispose();
	}
}, sc = xe.Create("Path", () => ({
	color: new l("#00bfff"),
	thickness: new w(6, {
		min: 1,
		max: 30,
		step: 1
	}),
	speed: new w(.25, {
		min: 0,
		max: 10,
		step: .05
	}),
	opacity: new w(1, {
		min: 0,
		max: 1,
		step: .05
	}),
	segmentLength: new w(.12, {
		min: .01,
		max: 10,
		step: .01
	}),
	segmentSpacing: new w(.08, {
		min: 0,
		max: 10,
		step: .01
	}),
	smoothing: new w(16, {
		min: 1,
		max: 64,
		step: 1
	}),
	pointRadius: new w(.08, {
		min: .01,
		max: 2,
		step: .01
	}),
	heightOffset: new w(.02, {
		min: 0,
		max: 1,
		step: .01
	}),
	cornerRadius: new w(.15, {
		min: 0,
		max: .5,
		step: .05
	})
})), cc = class extends sc {
	constructor(e) {
		super(e), this.navigationGraphSettings = {
			connectNodesAutomatically: new s(!0),
			mergeThreshold: new w(.1, {
				min: .01,
				max: 5,
				step: .01
			}),
			routingConnectionDistance: new w(2, {
				min: .1,
				max: 100,
				step: .5
			}),
			simplificationTolerance: new w(.05, {
				min: 0,
				max: 5,
				step: .01
			})
		}, this.onSettingsChanged = () => {
			this.pathController.applyPluginSettings();
		}, this.restoreNavigationToolsWhenRouteIsCleared = () => {
			this.navigationRoutingController.activeRoute || this.setNavigationToolsVisible(!0);
		}, this.pathController = new ya(e), this.navigationGraphController = new Ua(e), this.navigationGraphSceneController = new vo(e, this.navigationGraphController), this.navigationRoutingController = new rs(e, this.navigationGraphController, this.pathController, () => this.navigationGraphSettings.routingConnectionDistance.value, () => this.navigationGraphSettings.simplificationTolerance.value), this.navigationRoutingSceneController = new ds(e, this.navigationRoutingController, this.navigationGraphController), this.voxelDebugController = new nc(e), this.voxelizationController = new Us(e, this.voxelDebugController), this.floodFillController = new Vo(e, this.voxelizationController, this.voxelDebugController), this.floodFillSeedSceneController = new oc(e, this.floodFillController), this.navigationGraphGenerationController = new na(e, this.voxelizationController, this.floodFillController, this.navigationGraphController);
	}
	onRegister() {
		this.voxelDebugController.setup(), this.floodFillController.setup(), this.navigationGraphGenerationController.setup(), this.viewer.scene.addController(this.pathController), this.viewer.scene.addController(this.navigationGraphSceneController), this.viewer.scene.addController(this.navigationRoutingSceneController), this.viewer.scene.addController(this.floodFillSeedSceneController), this.navigationGraphSettings.routingConnectionDistance.onChange.connect(this.navigationRoutingController.refreshConnections), this.navigationRoutingController.signals.onChanged.connect(this.restoreNavigationToolsWhenRouteIsCleared);
		for (let e of Object.values(this.settings)) e.onChange.connect(this.onSettingsChanged);
	}
	onUnregister() {
		for (let e of Object.values(this.settings)) e.onChange.disconnect(this.onSettingsChanged);
		this.navigationGraphSettings.routingConnectionDistance.onChange.disconnect(this.navigationRoutingController.refreshConnections), this.navigationRoutingController.signals.onChanged.disconnect(this.restoreNavigationToolsWhenRouteIsCleared), this.viewer.scene.removeController(this.pathController), this.viewer.scene.removeController(this.navigationGraphSceneController), this.viewer.scene.removeController(this.navigationRoutingSceneController), this.viewer.scene.removeController(this.floodFillSeedSceneController), this.pathController.clear(), this.navigationGraphSceneController.dispose(), this.navigationRoutingSceneController.dispose(), this.navigationRoutingController.dispose(), this.floodFillSeedSceneController.dispose(), this.floodFillController.dispose(), this.navigationGraphGenerationController.dispose(), this.voxelizationController.dispose(), this.voxelDebugController.dispose();
	}
	clear() {
		this.pathController.clear(), this.navigationGraphController.clear(), this.navigationRoutingController.clearPoints(), this.voxelizationController.clear(), this.navigationGraphGenerationController.clear(), this.setNavigationToolsVisible(!0);
	}
	setNavigationToolsVisible(e) {
		this.navigationGraphSceneController.visible = e, this.navigationRoutingSceneController.visible = e, this.viewer.requestRender();
	}
};
//#endregion
//#region src/TeiaPlugin/api/common/apiUtils.ts
async function lc(e, t = 1, n = 2e3) {
	let r = [];
	return await uc(e, r.push.bind(r), t, n), r;
}
async function uc(e, t, n = 1, r = 2e3) {
	function i(e) {
		for (let n of e.data) t(n);
	}
	let a = await e(n, r), { totalPages: o, pageSize: s } = a;
	i(a);
	let c = [];
	for (let t = n + 1; t <= o; t++) {
		let n = e(t, s).then((e) => i(e));
		c.push(n);
	}
	await Promise.all(c);
}
//#endregion
//#region src/TeiaPlugin/api/TwinProjectionApi.ts
var dc = /* @__PURE__ */ function(e) {
	return e.Dot = "dot", e.Dash = "dash", e.Solid = "solid", e;
}({}), fc = [
	"ToDo",
	"Completed",
	"Failed",
	"Deleted",
	"Degraded",
	"InProgress"
], pc = ["pdf", "svg"], mc = (e) => ({
	getTwinProjections(t, n, r, i, a, o, s) {
		let { projectId: c, type: l } = t, u = new URL(`${e.baseUrl}projects/${c}/twin/projections`);
		if (u.searchParams.set("pageNumber", String(n)), u.searchParams.set("pageSize", String(r)), u.searchParams.set("twinProjectType", l), i && u.searchParams.set("name", i), a) for (let e of a) u.searchParams.append("status", e);
		o && u.searchParams.set("orderBy", o), s && u.searchParams.set("orderDirection", s);
		let d = new Request(u, { method: "GET" });
		return e.sendRequest(d);
	},
	addProjection(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/twin/projections`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, {
			method: "POST",
			body: JSON.stringify(n),
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(o);
	},
	deleteProjection(t, n) {
		let r = e.URL(`projects/${t}/twin/projections/${n}`), i = new Request(r, { method: "DELETE" });
		return e.sendRequest(i);
	},
	updateProjection(t, n, r) {
		let { projectId: i, type: a } = t, o = e.URL(`projects/${i}/twin/projections/${n}`);
		o.searchParams.set("twinProjectType", a);
		let s = new Request(o, {
			method: "PUT",
			body: JSON.stringify(r),
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(s);
	},
	getSVGPaths(t, n, r, i) {
		let { projectId: a, type: o } = t, s = e.URL(`projects/${a}/twin/projections/layer/${n}/paths`);
		s.searchParams.set("twinProjectType", o), i && s.searchParams.set("pageNumber", String(i)), r && s.searchParams.set("pageSize", String(r));
		let c = new Request(s, { method: "GET" });
		return e.sendRequest(c);
	},
	async downloadExport(t, n, r) {
		let { projectId: i, type: a } = t, o = e.URL(`projects/${i}/twin/projections/${n}/export`);
		o.searchParams.set("twinProjectType", a), o.searchParams.set("format", r);
		let s = new Request(o, {
			method: "GET",
			headers: { "Content-Type": "application/octet-stream" }
		}), c = await (await e.sendRequest(s)).blob();
		return URL.createObjectURL(c);
	},
	generateReport(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/twin/projections/${n}/analyse`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, {
			method: "POST",
			headers: { "Content-type": "application/json" }
		});
		return e.sendRequest(o);
	},
	async downloadReport(t, n) {
		let { projectId: r } = t, i = e.URL(`projects/${r}/twin/projections/${n}/analyse/download`), a = new Request(i, {
			method: "GET",
			headers: { "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
		}), o = await (await e.sendRequest(a)).blob();
		return URL.createObjectURL(o);
	},
	async downloadConfiguration(t, n) {
		let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/twin/projections/${n}/configuration/export`);
		a.searchParams.set("twinProjectType", i);
		let o = new Request(a, { method: "GET" }), s = await (await e.sendRequest(o)).blob();
		return URL.createObjectURL(s);
	},
	async importConfiguration(t, n) {
		let { projectId: r, type: i } = t, a = new URL(`${e.baseUrl}projects/${r}/twin/projections/configuration/import`);
		a.searchParams.set("twinProjectType", i);
		let o = new FormData();
		for (let e of n) o.append("files", e);
		let s = new Request(a, {
			method: "POST",
			body: o
		}), c = await (await e.sendRequest(s)).blob();
		return URL.createObjectURL(c);
	},
	getAnalysis(t, n, r, i, a, o) {
		let { projectId: s, type: c } = t, l = e.URL(`projects/${s}/twin/projections/${n}/analyse`);
		l.searchParams.set("twinProjectType", c), l.searchParams.set("pageNumber", String(r)), l.searchParams.set("pageSize", String(i)), a && l.searchParams.set("orderBy", a), o && l.searchParams.set("orderDirection", o);
		let u = new Request(l, { method: "GET" });
		return e.sendRequest(u);
	}
}), hc = class extends e {
	constructor(e, t, n, r = {}) {
		super(e, r), this._twin = t, this._projectionConfig = n, this.name = "AddProjectionCommand";
	}
	async _createObject() {
		let e = this.viewer.getPlugin("Teia"), t = this.viewer.getPlugin("Projection"), n = [];
		for (let t of this._projectionConfig.twinProjectionLayerDtos) {
			let r = await lc((n, r) => mc(e.twinApiClient).getSVGPaths(this._twin, t.id, r, n));
			n.push({
				id: t.id,
				paths: r,
				config: {
					displayBackground: t.displayBackground,
					displayBorders: t.displayBorders,
					fillColor: t.fillColor,
					lineColor: t.lineColor,
					lineWidth: t.lineWidth,
					lineType: t.lineType,
					fontSize: t.fontSize,
					order: t.order
				}
			});
		}
		return t.projectionController.createProjection(this._projectionConfig.direction, this._projectionConfig.id, this._projectionConfig.name, n);
	}
	async _clean() {
		this._object &&= (this._object.dispose(), null);
	}
}, gc = class extends ue {
	constructor(e) {
		super(), this.isSceneProjection = !0, this.transformConfig = {
			...this.transformConfig,
			scale: {
				x: !1,
				y: !1,
				z: !1
			}
		}, this.twinProjectionConfigurationId = e;
	}
	get opacity() {
		return 1;
	}
	set opacity(e) {
		super.opacity = e;
	}
	getInitialMatrix(e) {
		return this.meshes[0]?._getInitialMatrix(e);
	}
	raycast(e, t) {
		let n = this.meshes, r = [];
		for (let t of n) t.raycast(e, r);
		for (let e of r) t.push({
			object: this,
			distance: e.distance,
			point: e.point,
			rayDistance: 0
		});
	}
}, _c = (e) => {
	let { hitObject: t, viewer: n } = e, r = [];
	return t && t.isSceneProjection && r.push({
		type: "group",
		text: "Projection",
		items: [{
			type: "action",
			text: gt("teia.context_menu.remove_projection.text", { ns: "teiaviewer" }),
			action: () => {
				new f(n, t).execute();
			}
		}]
	}), r;
}, vc = (e) => new st(e), yc = (e) => {
	let t = [];
	bc(e, t);
	for (let n of e.holes) bc(n, t);
	let n = new Ne();
	return n.setFromPoints(t), n.index?.array.reverse(), n;
}, bc = (e, t) => {
	let n = e.getPoints();
	for (let e = 0, r = n.length; e < r; e++) {
		let r = (e + 1) % n.length, i = n[e], a = n[r];
		t.push(i, a);
	}
}, xc = (e) => {
	let t = [], n = [], r = e.replaceAll(" ", "").split("Z"), i = null, a = null;
	for (let e of r) {
		if (e === "") continue;
		let r = e.replace("M", "").split("L"), o = [];
		for (let e of r) {
			let t = e.split(",");
			if (t.length === 2) {
				let e = new pt(Number(t[0]), Number(t[1]));
				o.push(e), !i || !a ? (i = {
					x: e.x,
					y: e.y
				}, a = {
					x: e.x,
					y: e.y
				}) : (i.x = Math.min(i.x, e.x), i.y = Math.min(i.y, e.y), a.x = Math.max(e.x, a.x), a.y = Math.max(e.y, a.y));
			}
		}
		if (o.length > 0) {
			let e = new ot();
			e.setFromPoints(o), ct.isClockWise(o) ? t.push(e) : (e.holes = t, n.push(e));
		}
	}
	return {
		solidShapes: n,
		min: i,
		max: a
	};
}, Sc = .02, Cc = class {
	constructor(e, t, n, r, i, a, o) {
		this._annotations = e, this._fontSize = t, this._direction = n, this._index = r, this._layerNb = i, this._min = a, this._width = o.x - a.x, this._height = o.y - a.y;
		let s = new Qe(this._width, this._height);
		this.material = new Ze({
			color: 16777215,
			side: ze,
			transparent: !0,
			depthWrite: !1,
			map: this._getCanvasTexture()
		}), this.plane = new Xe(s, this.material);
	}
	setMatrix(e) {
		this.plane.position.set(this._min.x, this._min.y, 0), this.plane.position.x += this._width / 2, this.plane.position.y += this._height / 2, this.plane.position.z -= Sc * (this._index + 1) + Pc * this._layerNb, this.plane.quaternion.identity(), this.plane.scale.set(1, 1, 1), this.plane.applyMatrix4(e);
	}
	_getCanvasTexture() {
		let e = document.createElement("canvas"), t = e.getContext("2d"), n = new Pe(e);
		e.width = Math.min(this._width * 50, 16384), e.height = Math.min(this._height * 50, 16384);
		let r = e.width / this._width, i = e.height / this._height, a = -this._min.x, o = -this._min.y;
		if (t) {
			t.font = `${this._fontSize * 40}px serif`, t.fillStyle = "rgb(0, 0, 0)";
			for (let e of this._annotations) {
				let n = (e.x + a) * r, s = (e.y + o) * i, c = t.measureText(e.text), l = n - c.width / 2, u = s + (c.actualBoundingBoxAscent + c.actualBoundingBoxDescent) / 2;
				(this._direction.y < this._direction.x || this._direction.y < this._direction.z) && (t.translate(n, s), t.rotate(Math.PI / 180 * 180), t.translate(-n, -s)), t.fillText(e.text, l, u), (this._direction.y < this._direction.x || this._direction.y < this._direction.z) && (t.translate(n, s), t.rotate(-(Math.PI / 180) * 180), t.translate(-n, -s));
			}
		}
		return n.flipY = !1, n.needsUpdate = !0, n;
	}
	dispose() {
		this.material.map?.dispose(), this.material.dispose();
	}
}, wc = /* @__PURE__ */ new je(), Tc = /* @__PURE__ */ new O(), Ec = /* @__PURE__ */ new O(), Dc = /* @__PURE__ */ new O(), Oc = /* @__PURE__ */ new O(), kc = /* @__PURE__ */ new A(), Ac = /* @__PURE__ */ new nt(), jc = /* @__PURE__ */ new A(), Mc = /* @__PURE__ */ new A(), Nc = /* @__PURE__ */ new A(), Pc = .01, Fc = class extends ue {
	constructor(e, t, n, r, i, a) {
		super(), this._direction = n, this._config = r, this._index = i, this._layerNb = a, this._sceneAnnotations = null, this._isOverlayActive = !1, this.meshContainer = e, this.lineContainer = t;
		let o = vt(this._config.fillColor).toHexString();
		this.diffuseColor = o;
	}
	setMatrix(e) {
		return e.decompose(kc, Ac, jc), kc.add(this._getTranslationVector(Mc)), Tc.compose(kc, Ac, jc), this._sceneAnnotations?.setMatrix(Tc), super.setMatrix(Tc);
	}
	get annotationsMesh() {
		return this._sceneAnnotations?.plane;
	}
	set visible(e) {
		super.visible = e, this.annotationsMesh && (this.annotationsMesh.visible = e);
	}
	get visible() {
		return super.visible;
	}
	set selected(e) {
		super.selected = e, this._setAnnotationsLayer();
	}
	get selected() {
		return super.selected;
	}
	_getTranslationVector(e) {
		return e.set(-this._direction.x * Pc * this._index, -this._direction.y * Pc * this._index, -this._direction.z * Pc * this._index);
	}
	_getInitialMatrix(e) {
		e.identity();
		let t = Dc.makeTranslation(this._getTranslationVector(Mc)), n = Oc.lookAt(Nc.set(0, 0, 0), this._direction, new A(0, 1, 0));
		return e.multiply(t), e.multiply(n), e;
	}
	_setAnnotationsLayer() {
		this.selected && this._isOverlayActive ? this._sceneAnnotations?.plane.layers.set(x.SelectedObject) : this._sceneAnnotations?.plane.layers.set(x.Base);
	}
	setupLayer(e, t, n) {
		let r = 0;
		for (let n of e) this._addShape(n, t[r]), r++;
		n.length > 0 && (this.getBoundingBox(wc), this._sceneAnnotations = new Cc(n, this._config.fontSize, this._direction, this._index, this._layerNb, new pt(wc.min.x, wc.min.y), new pt(wc.max.x, wc.max.y))), this._config.lineType !== dc.Solid && this.lineContainer.geometry.computeLineDistanceAttribute(), this._initializeMatrix();
	}
	_initializeMatrix() {
		let e = this._getInitialMatrix(Tc);
		this._sceneAnnotations?.setMatrix(e);
		for (let t of this.meshes.values()) t.setMatrix(e);
	}
	_addShape(e, t) {
		e.computeBoundingBox();
		let n = this.meshContainer.geometry.addGeometry(e), r = new o(this.meshContainer, n, e.uuid), a = this.lineContainer.geometry.addGeometry(t), s = new i(this.lineContainer, a, t.uuid), c = new _t(e, { useSharedArrayBuffer: !0 });
		this.meshContainer.registerBVH(e.uuid, c);
		let l = new de(r, s);
		l.setMatrix(Ec), this._setupProxy(l), this.addSubMesh(l), l.active = !0;
	}
	_setupProxy(e) {
		if (this._config.displayBackground) {
			let t = vt(this._config.fillColor).toHexString(), n = vt(this._config.fillColor).getAlpha();
			e.diffuseColor = t, e.opacity = n;
		} else e.opacity = 0;
		if (this._config.displayBorders) {
			let t = vt(this._config.lineColor).toHexString(), n = vt(this._config.lineColor).getAlpha();
			e.edgesColor = t, e.edgesOpacity = n;
		} else e.edgesOpacity = 0;
	}
	dispose() {
		super.dispose(), this.meshes.forEach((e) => e.dispose()), this._sceneAnnotations?.dispose(), this._sceneAnnotations = null;
	}
}, Ic = class extends le {
	constructor(...e) {
		super(...e), this.isSceneProjectionController = !0;
	}
	onSceneSetup(e) {
		for (let t of this._objects.values()) for (let n of t.meshes) e.addInternalObject(n.meshContainer.root), e.addInternalObject(n.lineContainer.root), n.annotationsMesh && e.addInternalObject(n.annotationsMesh);
	}
	onSceneClear(e) {
		for (let t of this._objects.values()) for (let n of t.meshes) e.removeInternalObject(n.meshContainer.root), e.removeInternalObject(n.lineContainer.root), n.annotationsMesh && e.removeInternalObject(n.annotationsMesh);
	}
	accepts(e) {
		return e.isSceneProjection;
	}
	*meshContainers() {
		for (let e of this._objects.values()) for (let t of e.meshes) yield t.meshContainer;
	}
	*lineContainers() {
		for (let e of this._objects.values()) for (let t of e.meshes) yield t.lineContainer;
	}
	*edgesContainers() {}
	addObject(e, t) {
		for (let t of e.meshes) this._viewer.scene.addInternalObject(t.meshContainer.root), this._viewer.scene.addInternalObject(t.lineContainer.root), t.annotationsMesh && this._viewer.scene.addInternalObject(t.annotationsMesh);
		this._viewer.scene.addObjectIntoBoxTree(e), super.addObject(e, t);
	}
	removeObject(e) {
		for (let t of e.meshes) this._viewer.scene.removeInternalObject(t.meshContainer.root), this._viewer.scene.removeInternalObject(t.lineContainer.root), t.annotationsMesh && this._viewer.scene.removeInternalObject(t.annotationsMesh);
		this._viewer.scene.removeObjectFromBoxTree(e), super.removeObject(e);
	}
	_createLayer(e, i, o, s) {
		let { annotations: c, shapes: l } = Lc(e.paths);
		if (l.length === 0) return null;
		let u = [], d = [], f = 0, p = 0, m = 0;
		for (let e of l) {
			let t = vc(e), n = yc(e);
			u.push(t), d.push(n), f += t.attributes.position.count, t.index && (p += t.index.count), m += n.attributes.position.count;
		}
		let h = new t({
			useIndex: !0,
			maxGeometryCount: l.length,
			maxVertexCount: f,
			maxIndexCount: p
		}), g = new r({
			maxGeometryCount: l.length,
			maxVertexCount: m
		}), _ = new S(l.length, {
			opacity: "float",
			diffuse: "vec3"
		}), v = new a(l.length, h, this._getMeshMaterials(_)), y = new S(l.length, {
			opacity: "float",
			diffuse: "vec3"
		}), b = new Fc(v, new n(l.length, g, this._getLineSegmentsMaterials(y, { lineType: e.config.lineType })), s, e.config, i, o);
		return b.setupLayer(u, d, c), b;
	}
	createProjection(e, t, n, r) {
		let i = new A().fromArray(e), a = new gc(t);
		a.name = n, r.sort((e, t) => e.config.order > t.config.order ? -1 : +(e.config.order < t.config.order));
		let o = 0;
		for (let e of r) {
			let t = this._createLayer(e, o, r.length, i);
			t && (a.addSubMesh(t), o++);
		}
		return this._viewer.viewport?.renderModeController.applyCurrentRenderModeOnController(this), a;
	}
	getSceneProjectionWithConfigurationId(e) {
		for (let t of this._objects.values()) if (t.twinProjectionConfigurationId === e) return t;
		return null;
	}
	_getMeshMaterials(e) {
		let t = this._viewer.materialFactory;
		return [
			t.getBatchedMeshOpaqueMaterial(e),
			t.getBatchedMeshOpaqueMaterial_Selected(e),
			t.getBatchedMeshTransparentMaterial(e),
			t.getBatchedMeshTransparentMaterial_Selected(e),
			t.getBatchedMeshXRayMaterial(e),
			t.getBatchedMeshXRayMaterial_Selected(e)
		];
	}
	_getLineSegmentsMaterials(e, t) {
		let n = this._viewer.materialFactory, r = 1, i = 0;
		return t.lineType === "dot" ? (r = .01, i = .1) : t.lineType === "dash" && (r = .2, i = .2), [
			n.getBatchedEdgesOpaqueMaterial(e, {
				dashSize: r,
				gapSize: i
			}),
			n.getBatchedEdgesOpaqueMaterial_Selected(e, {
				dashSize: r,
				gapSize: i
			}),
			n.getBatchedEdgesXRayMaterial(e, {
				dashSize: r,
				gapSize: i
			}),
			n.getBatchedEdgesXRayMaterial_Selected(e, {
				dashSize: r,
				gapSize: i
			}),
			n.getBatchedEdgesTransparentMaterial(e, {
				dashSize: r,
				gapSize: i
			}),
			n.getBatchedEdgesTransparentMaterial_Selected(e, {
				dashSize: r,
				gapSize: i
			})
		];
	}
};
function Lc(e) {
	let t = [], n = [];
	for (let r of e) if (r.svg && r.svg !== "") {
		let { solidShapes: e, min: i, max: a } = xc(r.svg);
		i && a && r.annotation && t.push({
			text: r.annotation,
			x: (a.x + i.x) / 2,
			y: (a.y + i.y) / 2
		}), n.push(...e);
	}
	return {
		annotations: t,
		shapes: n
	};
}
//#endregion
//#region src/ProjectionPlugin/ProjectionPlugin.ts
var Rc = xe.Create("Projection"), zc = class extends Rc {
	constructor(e) {
		super(e), this._setupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.add(_c);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.delete(_c);
		}, this.projectionController = new Ic(e);
	}
	dependencies() {
		return ["Teia"];
	}
	onRegister() {
		this.viewer.scene.addController(this.projectionController), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this._setupViewport();
	}
	onUnregister() {
		this.viewer.scene.removeController(this.projectionController), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this._unsetupViewport();
	}
}, Bc = class {
	constructor(e = "", t = "", n = "") {
		this._token = "", this._baseUrl = "", this._instanceToken = "", this.baseUrl = e, this.token = t, this.instanceToken = n;
	}
	get baseUrl() {
		return this._baseUrl;
	}
	set baseUrl(e) {
		this._baseUrl = e;
	}
	get instanceToken() {
		return this._instanceToken;
	}
	set instanceToken(e) {
		this._instanceToken = e;
	}
	get token() {
		return this._token;
	}
	set token(e) {
		this._token = e;
	}
	URL(e) {
		return new URL(e, this.baseUrl);
	}
	async sendRequest(e) {
		return e.headers.append("Authorization", `Bearer ${this.token}`), fetch(e).then((e) => e.status === 204 ? Promise.resolve() : e.ok ? e.headers.get("Content-Type")?.includes("json") ? e.json() : Promise.resolve(e) : Promise.reject(Error(`${e.status}: ${e.statusText}`, { cause: e })));
	}
}, Vc = (e) => ({
	getModels(t = 1, n = 1e3) {
		let r = e.URL("models");
		r.searchParams.set("pageNumber", String(t)), r.searchParams.set("pageSize", String(n));
		let i = new Request(r, { method: "GET" });
		return e.sendRequest(i);
	},
	getTreeView(t, n) {
		let { modelId: r, version: i } = t, a = e.URL(`models/${r}/versions/${i}/treeview`), o = new Request(a, {
			method: "GET",
			signal: n
		});
		return e.sendRequest(o);
	},
	getGeometryInfo(t) {
		let { modelId: n, version: r } = t, i = e.URL(`models/${n}/versions/${r}/geometries/informations`), a = new Request(i, { method: "GET" });
		return e.sendRequest(a);
	},
	getGeometryRequest(t, n, r) {
		let { modelId: i, version: a } = t, o = e.URL(`models/${i}/versions/${a}/geometries`);
		return o.searchParams.set("pageNumber", String(n)), o.searchParams.set("pageSize", String(r)), {
			url: o.toString(),
			method: "GET",
			headers: { Authorization: `Bearer ${e.token}` }
		};
	},
	getObjectDetails(t, n) {
		let { modelId: r, version: i } = t, a = e.URL(`models/${r}/versions/${i}/objects/${n}/details`), o = new Request(a, { method: "GET" });
		return e.sendRequest(o);
	}
}), Hc = (e) => ({ generateSearchFilter(t) {
	let n = new Request(e.URL("powered_tools/generate_search_filter"), {
		method: "POST",
		body: JSON.stringify(t),
		headers: { "Content-Type": "application/json" }
	});
	return e.sendRequest(n);
} }), Uc = [
	"application/pdf",
	"image/jpeg",
	"image/png",
	"image/gif",
	"image/webp",
	"video/mp4",
	"video/quicktime",
	"audio/mpeg",
	"audio/ogg",
	"audio/wav"
], Wc = async (e) => {
	let t = await Et(e);
	if (t) return Uc.find((e) => e === t.mime);
}, Gc = (e) => ({ async download(t, n) {
	let { projectId: r, type: i } = t, a = e.URL(`projects/${r}/twin/docdata/${n}/download`);
	a.searchParams.set("twinProjectType", i);
	let o = new Request(a, { method: "GET" }), s = await (await e.sendRequest(o)).blob(), c = await Wc(s);
	if (!c) {
		console.error("Mimetype undefined");
		return;
	}
	let l = s.slice(0, s.size, c);
	return {
		filePath: URL.createObjectURL(l),
		fileType: c
	};
} }), Kc = class extends u {
	constructor(e, t) {
		super(e), this.isUndoable = !1, this._controller = t;
	}
	async _do() {
		let e = await this.getFileRequests();
		e.length !== 0 && (this._command = new b(this.viewer, e, this._controller), await this._command.execute({
			requestRender: !1,
			addToUndoHistory: !1
		}));
	}
	async _undo() {
		throw new te(this);
	}
	displayObjectCountWarning(e) {
		let t = this.viewer.getPlugin("Teia");
		e > t.settings.objectCountWarningLimit.value && ne.instance.pushNotification({
			type: "technical_limitation",
			status: "warning",
			message: `${gt("teiaviewer:teia.info_banner.objects_limit_warning_start.text")} ${t.settings.objectCountWarningLimit.value} ${gt("teiaviewer:teia.info_banner.objects_limit_warning_end.text")}`,
			title: gt("teiaviewer:teia.info_banner.objects_limit_warning.title")
		});
	}
}, qc = class extends Kc {
	constructor(e, t, n = {}) {
		super(e, new re(e)), this.name = "LoadCustomUrlCommand", this._url = t, this._geometryType = n.geometryType ?? "3D";
	}
	async getFileRequests() {
		return [{
			url: new URL(this._url).toString(),
			format: "GLTF",
			geometryType: this._geometryType
		}];
	}
}, Jc = class extends re {
	shouldKeepObject(e, t) {
		let n = this._viewer.scene.bimMeshController.getObjectByUUID(e.uuid), r = !1;
		if (!n) r = !0;
		else if (e.isInMeshGroup && e.uuid) r = t.has(e.uuid);
		else {
			let t = e.geometryType ?? e.geometryType;
			r = !n.has2dMeshes && t === "2D" || !n.has3dMeshes && t === "3D";
		}
		return r;
	}
}, Yc = class extends Jc {
	constructor(e, t) {
		super(e), this._allObjects = /* @__PURE__ */ new Map(), this._model = t;
	}
	async prepare(e) {
		let t = await Vc(this._viewer.getPlugin("Teia").twinApiClient).getTreeView(this._model, e);
		this._allObjects = Xc(t);
	}
	getInitialObjects() {
		return this._allObjects.values();
	}
	updateObject(e) {
		let t = e;
		if (t.isSerializedMesh && t.isInMeshGroup && e.userData.stereograph?.parentGuid) e.parentUuid = e.userData.stereograph.parentGuid;
		else {
			let t = this._allObjects.get(e.userData.stereograph?.guid);
			E(t, `Model object info not available for uuid ${e.userData.stereograph?.guid}`), e.uuid = t.uuid, e.parentUuid = t.parentUuid, e.name = t.name, e.userData.stereograph = {
				...e.userData.stereograph,
				...t.userData.stereograph
			};
		}
	}
	getObject(e) {
		return this._allObjects.get(e) ?? null;
	}
	clean() {
		this._allObjects = /* @__PURE__ */ new Map();
	}
};
function Xc(e) {
	let t = /* @__PURE__ */ new Map(), n = [...e];
	for (; n.length > 0;) {
		let e = n.pop();
		if (!e) continue;
		for (let t of e.children ?? []) n.push(t);
		let r = e.typeId ? { stereograph: { objectType: e.typeId } } : {};
		t.set(e.guid, {
			isSerializedObject3D: !0,
			name: e.name ?? "",
			parentUuid: e.parentGuid ?? null,
			uuid: e.guid,
			userData: r,
			isMeshGroup: !1,
			isInMeshGroup: !1
		});
	}
	return t;
}
//#endregion
//#region src/TeiaPlugin/command/LoadFileCommand.ts
var Zc = class extends Kc {
	constructor(e, t) {
		let { projectId: n, modelId: r, version: i } = t, a = {
			projectId: n,
			modelId: r,
			version: i,
			sourceType: jn.File
		};
		super(e, new Yc(e, a)), this.name = "LoadFileCommand", this._file = a, e.getPlugin("Teia").currentSource = a;
	}
	async getFileRequests() {
		let e = this.viewer.getPlugin("Teia"), t = [], n = Vc(e.twinApiClient), { nodeCount: r, fileType: i } = await n.getGeometryInfo(this._file), a = Qc(i), o = e.settings.objectsPerRequest.value;
		this.displayObjectCountWarning(r);
		let s = 0;
		for (let e = 0; e < r; e += o) {
			s += 1;
			let e = n.getGeometryRequest(this._file, s, o);
			t.push({
				...e,
				format: "GLTF",
				geometryType: a
			});
		}
		return t;
	}
};
function Qc(e) {
	return e?.toLowerCase() === "dwg" ? "2D" : "3D";
}
//#endregion
//#region src/TeiaPlugin/controllers/TwinObjectHierarchyCache.ts
var $c = class {
	constructor(e) {
		this.client = e, this.twinProjectId = null, this.hierarchy = null;
	}
	get(e, t) {
		if (this.twinProjectId !== e || !this.hierarchy) {
			this.clear(), this.twinProjectId = e;
			let n = Bt(this.client).getTwinTreeView(e, t).then(tl).catch((e) => {
				throw this.hierarchy === n && this.clear(), e;
			});
			this.hierarchy = n;
		}
		return this.hierarchy;
	}
	clear() {
		this.twinProjectId = null, this.hierarchy = null;
	}
};
function el(e, t) {
	return !e || !t ? null : `${e}${t.charAt(0).toUpperCase() + t.slice(1)}`;
}
function tl(e) {
	let t = /* @__PURE__ */ new Map(), n = Array.isArray(e) ? [...e] : [e];
	for (; n.length > 0;) {
		let e = n.pop();
		if (!e) continue;
		let r = el(e.typeId, e.teiaType), i = r === null ? {} : { stereograph: { objectType: r } };
		t.set(e.guid, {
			isSerializedObject3D: !0,
			name: e.name ?? "",
			parentUuid: e.parentGuid,
			uuid: e.guid,
			userData: i,
			isMeshGroup: !1,
			isInMeshGroup: !1
		}), e.children && n.push(...e.children);
	}
	return t;
}
//#endregion
//#region src/TeiaPlugin/controllers/TwinObjectImportController.ts
var nl = class extends Jc {
	constructor(e, t) {
		super(e), this._allTwinObjects = /* @__PURE__ */ new Map(), this._twin = t;
	}
	async prepare(e) {
		let t = this._viewer.getPlugin("Teia");
		this._allTwinObjects = await t.twinObjectHierarchyCache.get(this._twin.id, e);
	}
	updateObject(e) {
		let t = this._allTwinObjects.get(e.userData.stereograph?.guid) ?? null;
		Te(t !== null), e.uuid = t.uuid, e.parentUuid = t.parentUuid, e.name = t.name;
		let n = t.userData.stereograph?.objectType, r = typeof n == "string" ? { objectType: n } : {};
		e.userData.stereograph = {
			...e.userData.stereograph,
			...r
		};
	}
	getObject(e) {
		return this._allTwinObjects.get(e) ?? null;
	}
	clean() {
		this._allTwinObjects = /* @__PURE__ */ new Map();
	}
}, rl = ["And", "Or"], il = [
	"Attribute",
	"Guid",
	"OpenData",
	"Parent",
	"Property",
	"Type",
	"UserDataByApplication",
	"UserData",
	"OpenDataAll",
	"Integration",
	"IntegrationObject",
	"Field",
	"TwinProject"
], al = [
	"Contains",
	"EndWith",
	"EqualTo",
	"GreaterThan",
	"GreaterThanOrEqualTo",
	"IsNotNull",
	"IsNull",
	"LessThan",
	"LessThanOrEqualTo",
	"NotContains",
	"NotEqualTo",
	"StartWith"
];
function ol(e, t = "And") {
	let n = {
		condition: t,
		rules: []
	};
	return e.forEach((e) => {
		Object.keys(e).length > 0 && n.rules.push(e);
	}), n;
}
//#endregion
//#region src/TeiaPlugin/command/LoadTwinCommand.ts
var sl = class extends Kc {
	constructor(e, t, n = {}) {
		let { onlySetSource: r = !1, geometryType: i = "Original", axis: a, filter: o = {
			type: "TwinProject",
			operator: "EqualTo",
			value: String(t.id)
		}, fieldSelectionRules: s = [], endpoint: c = "objects" } = n, l = e.getPlugin("Teia");
		if (l.currentSource?.sourceType == jn.File) throw Error("Cannot load a twin if a file is already loaded.");
		if (l.currentSource && l.currentSource.id !== t.id) throw Error(`Cannot load multiple twins simultaneously.
        Current=${l.currentSource?.id} new=${t.id}`);
		let u = new nl(e, t);
		super(e, u), this.name = "LoadTwinCommand", this._twin = t, this._filter = o, this._fieldSelectionRules = s, this._endpoint = c, this._geometryType = i, this._axis = a, l.currentSource = {
			...t,
			sourceType: jn.Twin,
			filter: cl(this.viewer, o)
		}, this._skipLoading = r;
	}
	async _do() {
		if (this._skipLoading) return;
		let e = await On(this.viewer.getPlugin("Teia").twinApiClient).getTwinProjectInfo(this._twin), t = e.optimizationStatus;
		t == "Complete" ? e.status != "Complete" && ne.instance.pushNotification({
			type: "technical_limitation",
			status: "warning",
			title: gt("teiaviewer:teia.info_banner.twin_process_warning.title"),
			message: `${gt("teiaviewer:teia.info_banner.twin_process_warning.text")} ${e.status}`
		}) : ne.instance.pushNotification({
			type: "technical_limitation",
			status: "warning",
			title: gt("teiaviewer:teia.info_banner.twin_optimization_warning.title"),
			message: `${gt("teiaviewer:teia.info_banner.twin_optimization_warning.text")} ${t}`
		}), await super._do();
	}
	async getFileRequests() {
		let e = this.viewer.getPlugin("Teia"), t = [], n = await jt(e.twinApiClient).getSearchFilterHash(this._filter, this._fieldSelectionRules), r = Bt(e.twinApiClient), i = e.settings.objectsPerRequest.value, a = await r.getGeometryInfo(this._endpoint, n, this._geometryType, this._axis);
		this.displayObjectCountWarning(a);
		let o = 0;
		for (let e = 0; e < a; e += i) {
			o += 1;
			let e = r.getGeometryRequest(this._endpoint, n, o, i, this._geometryType, this._axis);
			t.push({
				...e,
				format: "GLTF",
				geometryType: "3D"
			});
		}
		return t;
	}
};
function cl(e, t) {
	let n = e.getPlugin("Teia").currentSource;
	return n?.filter ? ol([n.filter, t], "Or") : t;
}
//#endregion
//#region ../../node_modules/typed-signals/dist/Collector.js
var ll = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Collector = void 0, e.Collector = class {
		constructor(e) {
			this.emit = (...t) => {
				e.emitCollecting(this, t);
			};
		}
	};
})), ul = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CollectorArray = void 0;
	var t = ll();
	e.CollectorArray = class extends t.Collector {
		constructor() {
			super(...arguments), this.result = [];
		}
		handleResult(e) {
			return this.result.push(e), !0;
		}
		getResult() {
			return this.result;
		}
		reset() {
			this.result.length = 0;
		}
	};
})), dl = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CollectorLast = void 0;
	var t = ll();
	e.CollectorLast = class extends t.Collector {
		handleResult(e) {
			return this.result = e, !0;
		}
		getResult() {
			return this.result;
		}
		reset() {
			delete this.result;
		}
	};
})), fl = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CollectorUntil0 = void 0;
	var t = ll();
	e.CollectorUntil0 = class extends t.Collector {
		constructor() {
			super(...arguments), this.result = !1;
		}
		handleResult(e) {
			return this.result = e, this.result;
		}
		getResult() {
			return this.result;
		}
		reset() {
			this.result = !1;
		}
	};
})), pl = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.CollectorWhile0 = void 0;
	var t = ll();
	e.CollectorWhile0 = class extends t.Collector {
		constructor() {
			super(...arguments), this.result = !1;
		}
		handleResult(e) {
			return this.result = e, !this.result;
		}
		getResult() {
			return this.result;
		}
		reset() {
			this.result = !1;
		}
	};
})), ml = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SignalConnectionImpl = void 0, e.SignalConnectionImpl = class {
		constructor(e) {
			this.link = e;
		}
		disconnect() {
			return this.link.unlink();
		}
		set enabled(e) {
			this.link.setEnabled(e);
		}
		get enabled() {
			return this.link.isEnabled();
		}
	};
})), hl = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SignalLink = void 0, e.SignalLink = class e {
		constructor(e, t, n) {
			this.enabled = !0, this.newLink = !1, this.prev = e ?? this, this.next = t ?? this, this.order = n.order, this.isPublic = n.isPublic, this.callback = n.callback, this.onUnlink = n.onUnlink;
		}
		isEnabled() {
			return this.enabled && !this.newLink;
		}
		setEnabled(e) {
			this.enabled = e;
		}
		unlink() {
			return this.callback ? (delete this.callback, this.next.prev = this.prev, this.prev.next = this.next, this.onUnlink(), !0) : !1;
		}
		insert(t) {
			let { order: n } = t, r = this.prev;
			for (; r !== this && !(r.order <= n);) r = r.prev;
			let i = new e(r, r.next, t);
			return r.next = i, i.next.prev = i, i;
		}
	};
})), gl = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Signal = void 0;
	var t = ml(), n = hl(), r = {
		order: 0,
		isPublic: !0,
		onUnlink() {}
	};
	e.Signal = class {
		constructor() {
			this.head = new n.SignalLink(null, null, r), this.hasNewLinks = !1, this.emitDepth = 0, this.connectionsCount = 0, this.onUnlink = () => {
				this.connectionsCount--;
			};
		}
		getConnectionsCount() {
			return this.connectionsCount;
		}
		hasConnections() {
			return this.connectionsCount > 0;
		}
		connect(e, { order: n = 0, isPublic: r = !0 } = {}) {
			this.connectionsCount++;
			let i = this.head.insert({
				callback: e,
				order: n,
				isPublic: r,
				onUnlink: this.onUnlink
			});
			return this.emitDepth > 0 && (this.hasNewLinks = !0, i.newLink = !0), new t.SignalConnectionImpl(i);
		}
		disconnect(e) {
			for (let t = this.head.next; t !== this.head; t = t.next) if (t.callback === e) return t.unlink(), !0;
			return !1;
		}
		disconnectAll() {
			let { next: e } = this.head;
			for (; e !== this.head;) e.isPublic && e.unlink(), e = e.next;
		}
		emit(...e) {
			this.emitDepth++;
			for (let t = this.head.next; t !== this.head; t = t.next) t.isEnabled() && t.callback && t.callback.apply(null, e);
			this.emitDepth--, this.unsetNewLink();
		}
		emitCollecting(e, t) {
			this.emitDepth++;
			for (let n = this.head.next; n !== this.head; n = n.next) if (n.isEnabled() && n.callback) {
				let r = n.callback.apply(null, t);
				if (!e.handleResult(r)) break;
			}
			this.emitDepth--, this.unsetNewLink();
		}
		unsetNewLink() {
			if (this.hasNewLinks && this.emitDepth === 0) {
				for (let e = this.head.next; e !== this.head; e = e.next) e.newLink = !1;
				this.hasNewLinks = !1;
			}
		}
	};
})), _l = /* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SignalConnections = void 0, e.SignalConnections = class {
		constructor() {
			this.list = [];
		}
		add(e) {
			this.list.push(e);
		}
		disconnectAll() {
			for (let e of this.list) e.disconnect();
			this.list = [];
		}
		getCount() {
			return this.list.length;
		}
		isEmpty() {
			return this.list.length === 0;
		}
	};
})), vl = (/* @__PURE__ */ At(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SignalConnections = e.Signal = e.CollectorWhile0 = e.CollectorUntil0 = e.CollectorLast = e.CollectorArray = e.Collector = void 0;
	var t = ll();
	Object.defineProperty(e, "Collector", {
		enumerable: !0,
		get: function() {
			return t.Collector;
		}
	});
	var n = ul();
	Object.defineProperty(e, "CollectorArray", {
		enumerable: !0,
		get: function() {
			return n.CollectorArray;
		}
	});
	var r = dl();
	Object.defineProperty(e, "CollectorLast", {
		enumerable: !0,
		get: function() {
			return r.CollectorLast;
		}
	});
	var i = fl();
	Object.defineProperty(e, "CollectorUntil0", {
		enumerable: !0,
		get: function() {
			return i.CollectorUntil0;
		}
	});
	var a = pl();
	Object.defineProperty(e, "CollectorWhile0", {
		enumerable: !0,
		get: function() {
			return a.CollectorWhile0;
		}
	});
	var o = gl();
	Object.defineProperty(e, "Signal", {
		enumerable: !0,
		get: function() {
			return o.Signal;
		}
	});
	var s = _l();
	Object.defineProperty(e, "SignalConnections", {
		enumerable: !0,
		get: function() {
			return s.SignalConnections;
		}
	});
})))(), yl = /* @__PURE__ */ function(e) {
	return e.Develop = "Develop", e.Staging = "Staging", e.Preprod = "Preprod", e.Localhost = "Localhost", e;
}({});
function bl(e) {
	switch (e) {
		case "Develop":
		case "Localhost": return "develop";
		case "Staging": return "staging";
		case "Preprod": return "preprod";
		default: throw Error("Unsupport environment");
	}
}
var xl = class {
	constructor(e = "Develop") {
		this._user = null, this.signals = {
			onUserLogin: new vl.Signal(),
			onUserLogout: new vl.Signal()
		}, this._onUserLoaded = (e) => {
			if (e.expired) {
				this._userManager.signinSilent().catch(() => this._userManager.removeUser());
				return;
			}
			this._user = e, this.signals.onUserLogin.emit();
		}, this._onUserUnloaded = () => {
			this._user = null, this.signals.onUserLogout.emit();
		}, this._processAuth = async () => {
			let e = new URL(location.href);
			if (e.searchParams.has("code") && e.searchParams.has("state")) {
				await this._userManager.signinCallback();
				let e = localStorage.getItem("viewer-redirect-search-params"), t = e ? `?${e}` : "";
				localStorage.removeItem("viewer-redirect-search-params"), history.replaceState({}, document.title, new URL(location.origin + location.pathname + t));
			}
			await this._userManager.getUser(!0);
		}, this._userManager = this._initUserManager(e), setTimeout(this._processAuth);
	}
	setEnv(e) {
		this._userManager.stopSilentRenew(), this._userManager.events.removeUserLoaded(this._onUserLoaded), this._userManager.events.removeUserUnloaded(this._onUserUnloaded), this._userManager = this._initUserManager(e), this._user = null, this._processAuth();
	}
	_initUserManager(e) {
		let t = new Dt({
			authority: `https://identity-${bl(e)}.teia-solution.com`,
			redirect_uri: location.origin + location.pathname,
			client_id: "teia.viewer",
			scope: "digitaltwin.ro openid offline_access profile IdentityServerApi",
			automaticSilentRenew: !0,
			filterProtocolClaims: !0,
			monitorSession: !1,
			loadUserInfo: !0,
			userStore: new Ot({
				store: localStorage,
				prefix: "teiaviewer.demo.auth." + bl(e) + "."
			}),
			post_logout_redirect_uri: location.origin + location.pathname
		});
		return t.events.addUserLoaded(this._onUserLoaded), t.events.addUserUnloaded(this._onUserUnloaded), t;
	}
	get isAuthenticated() {
		return !!this._user && !this._user.expired;
	}
	get user() {
		return this._user;
	}
	get accessToken() {
		return this._user?.access_token ?? null;
	}
	signinRedirect() {
		let e = new URL(location.href);
		localStorage.setItem("viewer-redirect-search-params", e.searchParams.toString());
		let t = location.origin + location.pathname;
		this._userManager.signinRedirect({ redirect_uri: t });
	}
	signoutRedirect() {
		this._userManager.signoutRedirect();
	}
}, Sl = (e, t) => {
	let n = "";
	switch (e) {
		case yl.Develop:
			n = "-develop";
			break;
		case yl.Staging:
			n = "-staging";
			break;
		case yl.Preprod:
			n = "-preprod";
			break;
		case yl.Localhost: return `http://localhost:${t}/api/`;
	}
	return `https://teiatwin${n}.teia-solution.com/api/`;
}, Cl = (e, t) => {
	let n = "";
	switch (e) {
		case yl.Develop:
			n = "-develop";
			break;
		case yl.Staging:
			n = "-staging";
			break;
		case yl.Preprod:
			n = "-preprod";
			break;
		case yl.Localhost: return `http://localhost:${t}/api/`;
	}
	return `https://teiatia${n}.teia-solution.com/api/`;
}, wl = {
	get: () => localStorage.getItem("viewer-target-env") ?? yl.Develop,
	set: (e) => {
		localStorage.setItem("viewer-target-env", e);
	}
}, Tl = class extends p {
	constructor() {
		super(), this.name = "TeiaAuth", this.type = "dev", this._folder = null, this.authController = new xl(wl.get()), this._params = {
			user: "",
			instance: "",
			environment: wl.get(),
			port: 44331,
			language: "en"
		}, this._onUpdateLanguage = () => {
			j.changeLanguage(this._params.language);
		}, this._onUpdateEnvironment = () => {
			this.authController.setEnv(this._params.environment), wl.set(this._params.environment), this._portInput.hidden = this._params.environment !== yl.Localhost;
		}, this._login = () => {
			this.authController.signinRedirect();
		}, this._logout = () => {
			this.authController.signoutRedirect();
		}, this._onUserLogin = () => {
			this._updateSettings();
		}, this._onUserLogout = () => {
			this._updateSettings();
		}, this.authController.signals.onUserLogin.connect(this._onUserLogin), this.authController.signals.onUserLogout.connect(this._onUserLogout);
	}
	get isAuthenticated() {
		return this.authController.isAuthenticated;
	}
	setup(e, t) {
		this._viewer = e, this._folder = t.addFolder({
			title: "Authentication",
			expanded: !0,
			index: 0
		}), this._folder.addBinding(this._params, "language", { options: {
			en: "en",
			fr: "fr"
		} }).on("change", this._onUpdateLanguage), this._folder.addBinding(this._params, "environment", { options: {
			Develop: yl.Develop,
			Staging: yl.Staging,
			Preprod: yl.Preprod,
			Localhost: yl.Localhost
		} }).on("change", this._onUpdateEnvironment), this._portInput = this._folder.addBinding(this._params, "port", {
			step: 1,
			hidden: this._params.environment !== yl.Localhost
		}), this._loginButton = this._folder.addButton({ title: "Login" }).on("click", this._login), this._logoutButton = this._folder.addButton({
			title: "Logout",
			hidden: !0
		}).on("click", this._logout), this._instanceLabel = this._folder.addBinding(this._params, "instance", {
			readonly: !0,
			hidden: !0
		}), this._userLabel = this._folder.addBinding(this._params, "user", {
			readonly: !0,
			hidden: !0
		});
		let n = this._userLabel.element.querySelector(".tp-lblv_v");
		n && (n.style.flexGrow = "2"), n = this._instanceLabel.element.querySelector(".tp-lblv_v"), n && (n.style.flexGrow = "2");
	}
	_updateSettings() {
		let e = this.authController.user, t = this.authController.isAuthenticated;
		this._params.user = e?.profile.name ?? "<User>", this._params.instance = JSON.stringify(e?.profile.instance_name) ?? "<instance>", this._loginButton.hidden = t, this._logoutButton.hidden = !t, this._userLabel.hidden = !t, this._instanceLabel.hidden = !t, this._folder?.refresh();
		let n = this._viewer.getPlugin("Teia");
		n.settings.api.tiaApiUrl.value = Cl(this._params.environment, this._params.port), n.settings.api.twinApiUrl.value = Sl(this._params.environment, this._params.port);
		let r = t ? this.authController.user?.access_token ?? "" : "";
		n.settings.api.token.value = r;
	}
	dispose() {
		this._folder?.dispose(), this._folder = null;
	}
}, El = (/* @__PURE__ */ At(((e, t) => {
	(function() {
		var n, r = "Expected a function", i = "__lodash_hash_undefined__", a = "__lodash_placeholder__", o = 1, s = 2, c = 8, l = 16, u = 32, d = 64, f = 128, p = 256, m = 512, h = 1 / 0, g = 9007199254740991, _ = 17976931348623157e292, v = NaN, y = 4294967295, b = y - 1, ee = y >>> 1, x = [
			["ary", f],
			["bind", o],
			["bindKey", s],
			["curry", c],
			["curryRight", l],
			["flip", m],
			["partial", u],
			["partialRight", d],
			["rearg", p]
		], S = "[object Arguments]", C = "[object Array]", te = "[object AsyncFunction]", ne = "[object Boolean]", w = "[object Date]", re = "[object DOMException]", ie = "[object Error]", ae = "[object Function]", oe = "[object GeneratorFunction]", se = "[object Map]", ce = "[object Number]", le = "[object Null]", ue = "[object Object]", de = "[object Promise]", fe = "[object Proxy]", pe = "[object RegExp]", me = "[object Set]", he = "[object String]", ge = "[object Symbol]", _e = "[object Undefined]", ve = "[object WeakMap]", ye = "[object WeakSet]", be = "[object ArrayBuffer]", xe = "[object DataView]", T = "[object Float32Array]", Se = "[object Float64Array]", Ce = "[object Int8Array]", we = "[object Int16Array]", Te = "[object Int32Array]", E = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", De = "[object Uint16Array]", Oe = "[object Uint32Array]", ke = /\b__p \+= '';/g, Ae = /\b(__p \+=) '' \+/g, je = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Me = /&(?:amp|lt|gt|quot|#39);/g, Ne = /[&<>"']/g, Pe = RegExp(Me.source), Fe = RegExp(Ne.source), Ie = /<%-([\s\S]+?)%>/g, Le = /<%([\s\S]+?)%>/g, Re = /<%=([\s\S]+?)%>/g, ze = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Be = /^\w*$/, Ve = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, He = /[\\^$.*+?()[\]{}|]/g, Ue = RegExp(He.source), We = /^\s+/, D = /\s/, Ge = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ke = /\{\n\/\* \[wrapped with (.+)\] \*/, qe = /,? & /, Je = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ye = /[()=,{}\[\]\/\s]/, O = /\\(\\)?/g, Xe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ze = /\w*$/, Qe = /^[-+]0x[0-9a-f]+$/i, $e = /^0b[01]+$/i, et = /^\[object .+?Constructor\]$/, tt = /^0o[0-7]+$/i, nt = /^(?:0|[1-9]\d*)$/, rt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, it = /($^)/, at = /['\n\r\u2028\u2029\\]/g, ot = "\\ud800-\\udfff", st = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", ct = "\\u2700-\\u27bf", k = "a-z\\xdf-\\xf6\\xf8-\\xff", lt = "\\xac\\xb1\\xd7\\xf7", ut = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", dt = "\\u2000-\\u206f", ft = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", pt = "A-Z\\xc0-\\xd6\\xd8-\\xde", A = "\\ufe0e\\ufe0f", mt = lt + ut + dt + ft, ht = "['’]", j = "[" + ot + "]", gt = "[" + mt + "]", _t = "[" + st + "]", vt = "\\d+", yt = "[" + ct + "]", bt = "[" + k + "]", xt = "[^" + ot + mt + vt + ct + k + pt + "]", St = "\\ud83c[\\udffb-\\udfff]", Ct = "(?:" + _t + "|" + St + ")", wt = "[^" + ot + "]", Tt = "(?:\\ud83c[\\udde6-\\uddff]){2}", Et = "[\\ud800-\\udbff][\\udc00-\\udfff]", Dt = "[" + pt + "]", Ot = "\\u200d", kt = "(?:" + bt + "|" + xt + ")", At = "(?:" + Dt + "|" + xt + ")", jt = "(?:" + ht + "(?:d|ll|m|re|s|t|ve))?", Mt = "(?:" + ht + "(?:D|LL|M|RE|S|T|VE))?", Nt = Ct + "?", Pt = "[" + A + "]?", Ft = "(?:" + Ot + "(?:" + [
			wt,
			Tt,
			Et
		].join("|") + ")" + Pt + Nt + ")*", It = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Lt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Rt = Pt + Nt + Ft, zt = "(?:" + [
			yt,
			Tt,
			Et
		].join("|") + ")" + Rt, Bt = "(?:" + [
			wt + _t + "?",
			_t,
			Tt,
			Et,
			j
		].join("|") + ")", Vt = RegExp(ht, "g"), Ht = RegExp(_t, "g"), Ut = RegExp(St + "(?=" + St + ")|" + Bt + Rt, "g"), Wt = RegExp([
			Dt + "?" + bt + "+" + jt + "(?=" + [
				gt,
				Dt,
				"$"
			].join("|") + ")",
			At + "+" + Mt + "(?=" + [
				gt,
				Dt + kt,
				"$"
			].join("|") + ")",
			Dt + "?" + kt + "+" + jt,
			Dt + "+" + Mt,
			Lt,
			It,
			vt,
			zt
		].join("|"), "g"), Gt = RegExp("[" + Ot + ot + st + A + "]"), M = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Kt = /* @__PURE__ */ "Array.Buffer.DataView.Date.Error.Float32Array.Float64Array.Function.Int8Array.Int16Array.Int32Array.Map.Math.Object.Promise.RegExp.Set.String.Symbol.TypeError.Uint8Array.Uint8ClampedArray.Uint16Array.Uint32Array.WeakMap._.clearTimeout.isFinite.parseInt.setTimeout".split("."), qt = -1, N = {};
		N[T] = N[Se] = N[Ce] = N[we] = N[Te] = N[E] = N[Ee] = N[De] = N[Oe] = !0, N[S] = N[C] = N[be] = N[ne] = N[xe] = N[w] = N[ie] = N[ae] = N[se] = N[ce] = N[ue] = N[pe] = N[me] = N[he] = N[ve] = !1;
		var P = {};
		P[S] = P[C] = P[be] = P[xe] = P[ne] = P[w] = P[T] = P[Se] = P[Ce] = P[we] = P[Te] = P[se] = P[ce] = P[ue] = P[pe] = P[me] = P[he] = P[ge] = P[E] = P[Ee] = P[De] = P[Oe] = !0, P[ie] = P[ae] = P[ve] = !1;
		var F = {
			À: "A",
			Á: "A",
			Â: "A",
			Ã: "A",
			Ä: "A",
			Å: "A",
			à: "a",
			á: "a",
			â: "a",
			ã: "a",
			ä: "a",
			å: "a",
			Ç: "C",
			ç: "c",
			Ð: "D",
			ð: "d",
			È: "E",
			É: "E",
			Ê: "E",
			Ë: "E",
			è: "e",
			é: "e",
			ê: "e",
			ë: "e",
			Ì: "I",
			Í: "I",
			Î: "I",
			Ï: "I",
			ì: "i",
			í: "i",
			î: "i",
			ï: "i",
			Ñ: "N",
			ñ: "n",
			Ò: "O",
			Ó: "O",
			Ô: "O",
			Õ: "O",
			Ö: "O",
			Ø: "O",
			ò: "o",
			ó: "o",
			ô: "o",
			õ: "o",
			ö: "o",
			ø: "o",
			Ù: "U",
			Ú: "U",
			Û: "U",
			Ü: "U",
			ù: "u",
			ú: "u",
			û: "u",
			ü: "u",
			Ý: "Y",
			ý: "y",
			ÿ: "y",
			Æ: "Ae",
			æ: "ae",
			Þ: "Th",
			þ: "th",
			ß: "ss",
			Ā: "A",
			Ă: "A",
			Ą: "A",
			ā: "a",
			ă: "a",
			ą: "a",
			Ć: "C",
			Ĉ: "C",
			Ċ: "C",
			Č: "C",
			ć: "c",
			ĉ: "c",
			ċ: "c",
			č: "c",
			Ď: "D",
			Đ: "D",
			ď: "d",
			đ: "d",
			Ē: "E",
			Ĕ: "E",
			Ė: "E",
			Ę: "E",
			Ě: "E",
			ē: "e",
			ĕ: "e",
			ė: "e",
			ę: "e",
			ě: "e",
			Ĝ: "G",
			Ğ: "G",
			Ġ: "G",
			Ģ: "G",
			ĝ: "g",
			ğ: "g",
			ġ: "g",
			ģ: "g",
			Ĥ: "H",
			Ħ: "H",
			ĥ: "h",
			ħ: "h",
			Ĩ: "I",
			Ī: "I",
			Ĭ: "I",
			Į: "I",
			İ: "I",
			ĩ: "i",
			ī: "i",
			ĭ: "i",
			į: "i",
			ı: "i",
			Ĵ: "J",
			ĵ: "j",
			Ķ: "K",
			ķ: "k",
			ĸ: "k",
			Ĺ: "L",
			Ļ: "L",
			Ľ: "L",
			Ŀ: "L",
			Ł: "L",
			ĺ: "l",
			ļ: "l",
			ľ: "l",
			ŀ: "l",
			ł: "l",
			Ń: "N",
			Ņ: "N",
			Ň: "N",
			Ŋ: "N",
			ń: "n",
			ņ: "n",
			ň: "n",
			ŋ: "n",
			Ō: "O",
			Ŏ: "O",
			Ő: "O",
			ō: "o",
			ŏ: "o",
			ő: "o",
			Ŕ: "R",
			Ŗ: "R",
			Ř: "R",
			ŕ: "r",
			ŗ: "r",
			ř: "r",
			Ś: "S",
			Ŝ: "S",
			Ş: "S",
			Š: "S",
			ś: "s",
			ŝ: "s",
			ş: "s",
			š: "s",
			Ţ: "T",
			Ť: "T",
			Ŧ: "T",
			ţ: "t",
			ť: "t",
			ŧ: "t",
			Ũ: "U",
			Ū: "U",
			Ŭ: "U",
			Ů: "U",
			Ű: "U",
			Ų: "U",
			ũ: "u",
			ū: "u",
			ŭ: "u",
			ů: "u",
			ű: "u",
			ų: "u",
			Ŵ: "W",
			ŵ: "w",
			Ŷ: "Y",
			ŷ: "y",
			Ÿ: "Y",
			Ź: "Z",
			Ż: "Z",
			Ž: "Z",
			ź: "z",
			ż: "z",
			ž: "z",
			Ĳ: "IJ",
			ĳ: "ij",
			Œ: "Oe",
			œ: "oe",
			ŉ: "'n",
			ſ: "s"
		}, Jt = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;",
			"'": "&#39;"
		}, Yt = {
			"&amp;": "&",
			"&lt;": "<",
			"&gt;": ">",
			"&quot;": "\"",
			"&#39;": "'"
		}, Xt = {
			"\\": "\\",
			"'": "'",
			"\n": "n",
			"\r": "r",
			"\u2028": "u2028",
			"\u2029": "u2029"
		}, Zt = parseFloat, Qt = parseInt, $t = typeof global == "object" && global && global.Object === Object && global, en = typeof self == "object" && self && self.Object === Object && self, I = $t || en || Function("return this")(), tn = typeof e == "object" && e && !e.nodeType && e, nn = tn && typeof t == "object" && t && !t.nodeType && t, rn = nn && nn.exports === tn, an = rn && $t.process, L = function() {
			try {
				return nn && nn.require && nn.require("util").types || an && an.binding && an.binding("util");
			} catch {}
		}(), on = L && L.isArrayBuffer, sn = L && L.isDate, cn = L && L.isMap, ln = L && L.isRegExp, un = L && L.isSet, dn = L && L.isTypedArray;
		function fn(e, t, n) {
			switch (n.length) {
				case 0: return e.call(t);
				case 1: return e.call(t, n[0]);
				case 2: return e.call(t, n[0], n[1]);
				case 3: return e.call(t, n[0], n[1], n[2]);
			}
			return e.apply(t, n);
		}
		function pn(e, t, n, r) {
			for (var i = -1, a = e == null ? 0 : e.length; ++i < a;) {
				var o = e[i];
				t(r, o, n(o), e);
			}
			return r;
		}
		function mn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
			return e;
		}
		function hn(e, t) {
			for (var n = e == null ? 0 : e.length; n-- && t(e[n], n, e) !== !1;);
			return e;
		}
		function gn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
			return !0;
		}
		function _n(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
				var o = e[n];
				t(o, n, e) && (a[i++] = o);
			}
			return a;
		}
		function vn(e, t) {
			return !!(e != null && e.length) && kn(e, t, 0) > -1;
		}
		function yn(e, t, n) {
			for (var r = -1, i = e == null ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
			return !1;
		}
		function R(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
			return i;
		}
		function bn(e, t) {
			for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
			return e;
		}
		function xn(e, t, n, r) {
			var i = -1, a = e == null ? 0 : e.length;
			for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
			return n;
		}
		function Sn(e, t, n, r) {
			var i = e == null ? 0 : e.length;
			for (r && i && (n = e[--i]); i--;) n = t(n, e[i], i, e);
			return n;
		}
		function Cn(e, t) {
			for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
			return !1;
		}
		var wn = Nn("length");
		function Tn(e) {
			return e.split("");
		}
		function En(e) {
			return e.match(Je) || [];
		}
		function Dn(e, t, n) {
			var r;
			return n(e, function(e, n, i) {
				if (t(e, n, i)) return r = n, !1;
			}), r;
		}
		function On(e, t, n, r) {
			for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
			return -1;
		}
		function kn(e, t, n) {
			return t === t ? ir(e, t, n) : On(e, jn, n);
		}
		function An(e, t, n, r) {
			for (var i = n - 1, a = e.length; ++i < a;) if (r(e[i], t)) return i;
			return -1;
		}
		function jn(e) {
			return e !== e;
		}
		function Mn(e, t) {
			var n = e == null ? 0 : e.length;
			return n ? Ln(e, t) / n : v;
		}
		function Nn(e) {
			return function(t) {
				return t == null ? n : t[e];
			};
		}
		function Pn(e) {
			return function(t) {
				return e == null ? n : e[t];
			};
		}
		function Fn(e, t, n, r, i) {
			return i(e, function(e, i, a) {
				n = r ? (r = !1, e) : t(n, e, i, a);
			}), n;
		}
		function In(e, t) {
			var n = e.length;
			for (e.sort(t); n--;) e[n] = e[n].value;
			return e;
		}
		function Ln(e, t) {
			for (var r, i = -1, a = e.length; ++i < a;) {
				var o = t(e[i]);
				o !== n && (r = r === n ? o : r + o);
			}
			return r;
		}
		function Rn(e, t) {
			for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
			return r;
		}
		function zn(e, t) {
			return R(t, function(t) {
				return [t, e[t]];
			});
		}
		function Bn(e) {
			return e && e.slice(0, cr(e) + 1).replace(We, "");
		}
		function z(e) {
			return function(t) {
				return e(t);
			};
		}
		function Vn(e, t) {
			return R(t, function(t) {
				return e[t];
			});
		}
		function Hn(e, t) {
			return e.has(t);
		}
		function Un(e, t) {
			for (var n = -1, r = e.length; ++n < r && kn(t, e[n], 0) > -1;);
			return n;
		}
		function Wn(e, t) {
			for (var n = e.length; n-- && kn(t, e[n], 0) > -1;);
			return n;
		}
		function Gn(e, t) {
			for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
			return r;
		}
		var Kn = Pn(F), qn = Pn(Jt);
		function Jn(e) {
			return "\\" + Xt[e];
		}
		function Yn(e, t) {
			return e == null ? n : e[t];
		}
		function Xn(e) {
			return Gt.test(e);
		}
		function Zn(e) {
			return M.test(e);
		}
		function Qn(e) {
			for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
			return n;
		}
		function $n(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e, r) {
				n[++t] = [r, e];
			}), n;
		}
		function er(e, t) {
			return function(n) {
				return e(t(n));
			};
		}
		function tr(e, t) {
			for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
				var s = e[n];
				(s === t || s === a) && (e[n] = a, o[i++] = n);
			}
			return o;
		}
		function nr(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = e;
			}), n;
		}
		function rr(e) {
			var t = -1, n = Array(e.size);
			return e.forEach(function(e) {
				n[++t] = [e, e];
			}), n;
		}
		function ir(e, t, n) {
			for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
			return -1;
		}
		function ar(e, t, n) {
			for (var r = n + 1; r--;) if (e[r] === t) return r;
			return r;
		}
		function or(e) {
			return Xn(e) ? ur(e) : wn(e);
		}
		function sr(e) {
			return Xn(e) ? dr(e) : Tn(e);
		}
		function cr(e) {
			for (var t = e.length; t-- && D.test(e.charAt(t)););
			return t;
		}
		var lr = Pn(Yt);
		function ur(e) {
			for (var t = Ut.lastIndex = 0; Ut.test(e);) ++t;
			return t;
		}
		function dr(e) {
			return e.match(Ut) || [];
		}
		function fr(e) {
			return e.match(Wt) || [];
		}
		var pr = (function e(t) {
			t = t == null ? I : pr.defaults(I.Object(), t, pr.pick(I, Kt));
			var D = t.Array, Je = t.Date, ot = t.Error, st = t.Function, ct = t.Math, k = t.Object, lt = t.RegExp, ut = t.String, dt = t.TypeError, ft = D.prototype, pt = st.prototype, A = k.prototype, mt = t["__core-js_shared__"], ht = pt.toString, j = A.hasOwnProperty, gt = 0, _t = function() {
				var e = /[^.]+$/.exec(mt && mt.keys && mt.keys.IE_PROTO || "");
				return e ? "Symbol(src)_1." + e : "";
			}(), vt = A.toString, yt = ht.call(k), bt = I._, xt = lt("^" + ht.call(j).replace(He, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), St = rn ? t.Buffer : n, Ct = t.Symbol, wt = t.Uint8Array, Tt = St ? St.allocUnsafe : n, Et = er(k.getPrototypeOf, k), Dt = k.create, Ot = A.propertyIsEnumerable, kt = ft.splice, At = Ct ? Ct.isConcatSpreadable : n, jt = Ct ? Ct.iterator : n, Mt = Ct ? Ct.toStringTag : n, Nt = function() {
				try {
					var e = Fo(k, "defineProperty");
					return e({}, "", {}), e;
				} catch {}
			}(), Pt = t.clearTimeout !== I.clearTimeout && t.clearTimeout, Ft = Je && Je.now !== I.Date.now && Je.now, It = t.setTimeout !== I.setTimeout && t.setTimeout, Lt = ct.ceil, Rt = ct.floor, zt = k.getOwnPropertySymbols, Bt = St ? St.isBuffer : n, Ut = t.isFinite, Wt = ft.join, Gt = er(k.keys, k), M = ct.max, F = ct.min, Jt = Je.now, Yt = t.parseInt, Xt = ct.random, $t = ft.reverse, en = Fo(t, "DataView"), tn = Fo(t, "Map"), nn = Fo(t, "Promise"), an = Fo(t, "Set"), L = Fo(t, "WeakMap"), wn = Fo(k, "create"), Tn = L && new L(), Pn = {}, ir = bs(en), ur = bs(tn), dr = bs(nn), mr = bs(an), hr = bs(L), gr = Ct ? Ct.prototype : n, _r = gr ? gr.valueOf : n, vr = gr ? gr.toString : n;
			function B(e) {
				if (Z(e) && !J(e) && !(e instanceof H)) {
					if (e instanceof V) return e;
					if (j.call(e, "__wrapped__")) return Ss(e);
				}
				return new V(e);
			}
			var yr = function() {
				function e() {}
				return function(t) {
					if (!X(t)) return {};
					if (Dt) return Dt(t);
					e.prototype = t;
					var r = new e();
					return e.prototype = n, r;
				};
			}();
			function br() {}
			function V(e, t) {
				this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
			}
			B.templateSettings = {
				escape: Ie,
				evaluate: Le,
				interpolate: Re,
				variable: "",
				imports: { _: B }
			}, B.prototype = br.prototype, B.prototype.constructor = B, V.prototype = yr(br.prototype), V.prototype.constructor = V;
			function H(e) {
				this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = y, this.__views__ = [];
			}
			function xr() {
				var e = new H(this.__wrapped__);
				return e.__actions__ = Ka(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ka(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ka(this.__views__), e;
			}
			function Sr() {
				if (this.__filtered__) {
					var e = new H(this);
					e.__dir__ = -1, e.__filtered__ = !0;
				} else e = this.clone(), e.__dir__ *= -1;
				return e;
			}
			function Cr() {
				var e = this.__wrapped__.value(), t = this.__dir__, n = J(e), r = t < 0, i = n ? e.length : 0, a = Bo(0, i, this.__views__), o = a.start, s = a.end, c = s - o, l = r ? s : o - 1, u = this.__iteratees__, d = u.length, f = 0, p = F(c, this.__takeCount__);
				if (!n || !r && i == c && p == c) return Da(e, this.__actions__);
				var m = [];
				outer: for (; c-- && f < p;) {
					l += t;
					for (var h = -1, g = e[l]; ++h < d;) {
						var _ = u[h], v = _.iteratee, y = _.type, b = v(g);
						if (y == 2) g = b;
						else if (!b) {
							if (y == 1) continue outer;
							break outer;
						}
					}
					m[f++] = g;
				}
				return m;
			}
			H.prototype = yr(br.prototype), H.prototype.constructor = H;
			function wr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Tr() {
				this.__data__ = wn ? wn(null) : {}, this.size = 0;
			}
			function Er(e) {
				var t = this.has(e) && delete this.__data__[e];
				return this.size -= +!!t, t;
			}
			function Dr(e) {
				var t = this.__data__;
				if (wn) {
					var r = t[e];
					return r === i ? n : r;
				}
				return j.call(t, e) ? t[e] : n;
			}
			function Or(e) {
				var t = this.__data__;
				return wn ? t[e] !== n : j.call(t, e);
			}
			function kr(e, t) {
				var r = this.__data__;
				return this.size += +!this.has(e), r[e] = wn && t === n ? i : t, this;
			}
			wr.prototype.clear = Tr, wr.prototype.delete = Er, wr.prototype.get = Dr, wr.prototype.has = Or, wr.prototype.set = kr;
			function U(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Ar() {
				this.__data__ = [], this.size = 0;
			}
			function jr(e) {
				var t = this.__data__, n = ni(t, e);
				return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : kt.call(t, n, 1), --this.size, !0);
			}
			function Mr(e) {
				var t = this.__data__, r = ni(t, e);
				return r < 0 ? n : t[r][1];
			}
			function Nr(e) {
				return ni(this.__data__, e) > -1;
			}
			function Pr(e, t) {
				var n = this.__data__, r = ni(n, e);
				return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
			}
			U.prototype.clear = Ar, U.prototype.delete = jr, U.prototype.get = Mr, U.prototype.has = Nr, U.prototype.set = Pr;
			function Fr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.clear(); ++t < n;) {
					var r = e[t];
					this.set(r[0], r[1]);
				}
			}
			function Ir() {
				this.size = 0, this.__data__ = {
					hash: new wr(),
					map: new (tn || U)(),
					string: new wr()
				};
			}
			function Lr(e) {
				var t = No(this, e).delete(e);
				return this.size -= +!!t, t;
			}
			function Rr(e) {
				return No(this, e).get(e);
			}
			function zr(e) {
				return No(this, e).has(e);
			}
			function Br(e, t) {
				var n = No(this, e), r = n.size;
				return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
			}
			Fr.prototype.clear = Ir, Fr.prototype.delete = Lr, Fr.prototype.get = Rr, Fr.prototype.has = zr, Fr.prototype.set = Br;
			function Vr(e) {
				var t = -1, n = e == null ? 0 : e.length;
				for (this.__data__ = new Fr(); ++t < n;) this.add(e[t]);
			}
			function Hr(e) {
				return this.__data__.set(e, i), this;
			}
			function Ur(e) {
				return this.__data__.has(e);
			}
			Vr.prototype.add = Vr.prototype.push = Hr, Vr.prototype.has = Ur;
			function Wr(e) {
				var t = this.__data__ = new U(e);
				this.size = t.size;
			}
			function Gr() {
				this.__data__ = new U(), this.size = 0;
			}
			function Kr(e) {
				var t = this.__data__, n = t.delete(e);
				return this.size = t.size, n;
			}
			function qr(e) {
				return this.__data__.get(e);
			}
			function Jr(e) {
				return this.__data__.has(e);
			}
			function Yr(e, t) {
				var n = this.__data__;
				if (n instanceof U) {
					var r = n.__data__;
					if (!tn || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
					n = this.__data__ = new Fr(r);
				}
				return n.set(e, t), this.size = n.size, this;
			}
			Wr.prototype.clear = Gr, Wr.prototype.delete = Kr, Wr.prototype.get = qr, Wr.prototype.has = Jr, Wr.prototype.set = Yr;
			function Xr(e, t) {
				var n = J(e), r = !n && Yl(e), i = !n && !r && $l(e), a = !n && !r && !i && wu(e), o = n || r || i || a, s = o ? Rn(e.length, ut) : [], c = s.length;
				for (var l in e) (t || j.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Jo(l, c))) && s.push(l);
				return s;
			}
			function Zr(e) {
				var t = e.length;
				return t ? e[sa(0, t - 1)] : n;
			}
			function Qr(e, t) {
				return _s(Ka(e), ci(t, 0, e.length));
			}
			function $r(e) {
				return _s(Ka(e));
			}
			function ei(e, t, r) {
				(r !== n && !Kl(e[t], r) || r === n && !(t in e)) && oi(e, t, r);
			}
			function ti(e, t, r) {
				var i = e[t];
				(!(j.call(e, t) && Kl(i, r)) || r === n && !(t in e)) && oi(e, t, r);
			}
			function ni(e, t) {
				for (var n = e.length; n--;) if (Kl(e[n][0], t)) return n;
				return -1;
			}
			function ri(e, t, n, r) {
				return mi(e, function(e, i, a) {
					t(r, e, n(e), a);
				}), r;
			}
			function ii(e, t) {
				return e && qa(t, id(t), e);
			}
			function ai(e, t) {
				return e && qa(t, ad(t), e);
			}
			function oi(e, t, n) {
				t == "__proto__" && Nt ? Nt(e, t, {
					configurable: !0,
					enumerable: !0,
					value: n,
					writable: !0
				}) : e[t] = n;
			}
			function si(e, t) {
				for (var r = -1, i = t.length, a = D(i), o = e == null; ++r < i;) a[r] = o ? n : Qu(e, t[r]);
				return a;
			}
			function ci(e, t, r) {
				return e === e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e;
			}
			function li(e, t, r, i, a, o) {
				var s, c = t & 1, l = t & 2, u = t & 4;
				if (r && (s = a ? r(e, i, a, o) : r(e)), s !== n) return s;
				if (!X(e)) return e;
				var d = J(e);
				if (d) {
					if (s = Uo(e), !c) return Ka(e, s);
				} else {
					var f = zo(e), p = f == ae || f == oe;
					if ($l(e)) return Ia(e, c);
					if (f == ue || f == S || p && !a) {
						if (s = l || p ? {} : Wo(e), !c) return l ? Ya(e, ai(s, e)) : Ja(e, ii(s, e));
					} else {
						if (!P[f]) return a ? e : {};
						s = Go(e, f, c);
					}
				}
				o ||= new Wr();
				var m = o.get(e);
				if (m) return m;
				o.set(e, s), xu(e) ? e.forEach(function(n) {
					s.add(li(n, t, r, n, e, o));
				}) : uu(e) && e.forEach(function(n, i) {
					s.set(i, li(n, t, r, i, e, o));
				});
				var h = d ? n : (u ? l ? ko : Oo : l ? ad : id)(e);
				return mn(h || e, function(n, i) {
					h && (i = n, n = e[i]), ti(s, i, li(n, t, r, i, e, o));
				}), s;
			}
			function ui(e) {
				var t = id(e);
				return function(n) {
					return di(n, e, t);
				};
			}
			function di(e, t, r) {
				var i = r.length;
				if (e == null) return !i;
				for (e = k(e); i--;) {
					var a = r[i], o = t[a], s = e[a];
					if (s === n && !(a in e) || !o(s)) return !1;
				}
				return !0;
			}
			function fi(e, t, i) {
				if (typeof e != "function") throw new dt(r);
				return ps(function() {
					e.apply(n, i);
				}, t);
			}
			function pi(e, t, n, r) {
				var i = -1, a = vn, o = !0, s = e.length, c = [], l = t.length;
				if (!s) return c;
				n && (t = R(t, z(n))), r ? (a = yn, o = !1) : t.length >= 200 && (a = Hn, o = !1, t = new Vr(t));
				outer: for (; ++i < s;) {
					var u = e[i], d = n == null ? u : n(u);
					if (u = r || u !== 0 ? u : 0, o && d === d) {
						for (var f = l; f--;) if (t[f] === d) continue outer;
						c.push(u);
					} else a(t, d, r) || c.push(u);
				}
				return c;
			}
			var mi = Qa(Si), hi = Qa(Ci, !0);
			function gi(e, t) {
				var n = !0;
				return mi(e, function(e, r, i) {
					return n = !!t(e, r, i), n;
				}), n;
			}
			function _i(e, t, r) {
				for (var i = -1, a = e.length; ++i < a;) {
					var o = e[i], s = t(o);
					if (s != null && (c === n ? s === s && !Cu(s) : r(s, c))) var c = s, l = o;
				}
				return l;
			}
			function vi(e, t, r, i) {
				var a = e.length;
				for (r = Q(r), r < 0 && (r = -r > a ? 0 : a + r), i = i === n || i > a ? a : Q(i), i < 0 && (i += a), i = r > i ? 0 : Mu(i); r < i;) e[r++] = t;
				return e;
			}
			function yi(e, t) {
				var n = [];
				return mi(e, function(e, r, i) {
					t(e, r, i) && n.push(e);
				}), n;
			}
			function W(e, t, n, r, i) {
				var a = -1, o = e.length;
				for (n ||= qo, i ||= []; ++a < o;) {
					var s = e[a];
					t > 0 && n(s) ? t > 1 ? W(s, t - 1, n, r, i) : bn(i, s) : r || (i[i.length] = s);
				}
				return i;
			}
			var bi = $a(), xi = $a(!0);
			function Si(e, t) {
				return e && bi(e, t, id);
			}
			function Ci(e, t) {
				return e && xi(e, t, id);
			}
			function G(e, t) {
				return _n(t, function(t) {
					return su(e[t]);
				});
			}
			function wi(e, t) {
				t = Ma(t, e);
				for (var r = 0, i = t.length; e != null && r < i;) e = e[ys(t[r++])];
				return r && r == i ? e : n;
			}
			function Ti(e, t, n) {
				var r = t(e);
				return J(e) ? r : bn(r, n(e));
			}
			function Ei(e) {
				return e == null ? e === n ? _e : le : Mt && Mt in k(e) ? Io(e) : ss(e);
			}
			function Di(e, t) {
				return e > t;
			}
			function Oi(e, t) {
				return e != null && j.call(e, t);
			}
			function ki(e, t) {
				return e != null && t in k(e);
			}
			function Ai(e, t, n) {
				return e >= F(t, n) && e < M(t, n);
			}
			function ji(e, t, r) {
				for (var i = r ? yn : vn, a = e[0].length, o = e.length, s = o, c = D(o), l = Infinity, u = []; s--;) {
					var d = e[s];
					s && t && (d = R(d, z(t))), l = F(d.length, l), c[s] = !r && (t || a >= 120 && d.length >= 120) ? new Vr(s && d) : n;
				}
				d = e[0];
				var f = -1, p = c[0];
				outer: for (; ++f < a && u.length < l;) {
					var m = d[f], h = t ? t(m) : m;
					if (m = r || m !== 0 ? m : 0, !(p ? Hn(p, h) : i(u, h, r))) {
						for (s = o; --s;) {
							var g = c[s];
							if (!(g ? Hn(g, h) : i(e[s], h, r))) continue outer;
						}
						p && p.push(h), u.push(m);
					}
				}
				return u;
			}
			function Mi(e, t, n, r) {
				return Si(e, function(e, i, a) {
					t(r, n(e), i, a);
				}), r;
			}
			function Ni(e, t, r) {
				t = Ma(t, e), e = ls(e, t);
				var i = e == null ? e : e[ys(qs(t))];
				return i == null ? n : fn(i, e, r);
			}
			function Pi(e) {
				return Z(e) && Ei(e) == S;
			}
			function Fi(e) {
				return Z(e) && Ei(e) == be;
			}
			function Ii(e) {
				return Z(e) && Ei(e) == w;
			}
			function Li(e, t, n, r, i) {
				return e === t ? !0 : e == null || t == null || !Z(e) && !Z(t) ? e !== e && t !== t : Ri(e, t, n, r, Li, i);
			}
			function Ri(e, t, n, r, i, a) {
				var o = J(e), s = J(t), c = o ? C : zo(e), l = s ? C : zo(t);
				c = c == S ? ue : c, l = l == S ? ue : l;
				var u = c == ue, d = l == ue, f = c == l;
				if (f && $l(e)) {
					if (!$l(t)) return !1;
					o = !0, u = !1;
				}
				if (f && !u) return a ||= new Wr(), o || wu(e) ? wo(e, t, n, r, i, a) : To(e, t, c, n, r, i, a);
				if (!(n & 1)) {
					var p = u && j.call(e, "__wrapped__"), m = d && j.call(t, "__wrapped__");
					if (p || m) {
						var h = p ? e.value() : e, g = m ? t.value() : t;
						return a ||= new Wr(), i(h, g, n, r, a);
					}
				}
				return f ? (a ||= new Wr(), Eo(e, t, n, r, i, a)) : !1;
			}
			function zi(e) {
				return Z(e) && zo(e) == se;
			}
			function Bi(e, t, r, i) {
				var a = r.length, o = a, s = !i;
				if (e == null) return !o;
				for (e = k(e); a--;) {
					var c = r[a];
					if (s && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
				}
				for (; ++a < o;) {
					c = r[a];
					var l = c[0], u = e[l], d = c[1];
					if (s && c[2]) {
						if (u === n && !(l in e)) return !1;
					} else {
						var f = new Wr();
						if (i) var p = i(u, d, l, e, t, f);
						if (!(p === n ? Li(d, u, 3, i, f) : p)) return !1;
					}
				}
				return !0;
			}
			function Vi(e) {
				return !X(e) || $o(e) ? !1 : (su(e) ? xt : et).test(bs(e));
			}
			function Hi(e) {
				return Z(e) && Ei(e) == pe;
			}
			function Ui(e) {
				return Z(e) && zo(e) == me;
			}
			function Wi(e) {
				return Z(e) && lu(e.length) && !!N[Ei(e)];
			}
			function Gi(e) {
				return typeof e == "function" ? e : e == null ? pf : typeof e == "object" ? J(e) ? Zi(e[0], e[1]) : Xi(e) : Ef(e);
			}
			function Ki(e) {
				if (!ts(e)) return Gt(e);
				var t = [];
				for (var n in k(e)) j.call(e, n) && n != "constructor" && t.push(n);
				return t;
			}
			function qi(e) {
				if (!X(e)) return os(e);
				var t = ts(e), n = [];
				for (var r in e) (r != "constructor" || !t && j.call(e, r)) && n.push(r);
				return n;
			}
			function Ji(e, t) {
				return e < t;
			}
			function Yi(e, t) {
				var n = -1, r = Zl(e) ? D(e.length) : [];
				return mi(e, function(e, i, a) {
					r[++n] = t(e, i, a);
				}), r;
			}
			function Xi(e) {
				var t = Po(e);
				return t.length == 1 && t[0][2] ? rs(t[0][0], t[0][1]) : function(n) {
					return n === e || Bi(n, e, t);
				};
			}
			function Zi(e, t) {
				return Xo(e) && ns(t) ? rs(ys(e), t) : function(r) {
					var i = Qu(r, e);
					return i === n && i === t ? ed(r, e) : Li(t, i, 3);
				};
			}
			function Qi(e, t, r, i, a) {
				e !== t && bi(t, function(o, s) {
					if (a ||= new Wr(), X(o)) $i(e, t, s, r, Qi, i, a);
					else {
						var c = i ? i(ds(e, s), o, s + "", e, t, a) : n;
						c === n && (c = o), ei(e, s, c);
					}
				}, ad);
			}
			function $i(e, t, r, i, a, o, s) {
				var c = ds(e, r), l = ds(t, r), u = s.get(l);
				if (u) {
					ei(e, r, u);
					return;
				}
				var d = o ? o(c, l, r + "", e, t, s) : n, f = d === n;
				if (f) {
					var p = J(l), m = !p && $l(l), h = !p && !m && wu(l);
					d = l, p || m || h ? J(c) ? d = c : Y(c) ? d = Ka(c) : m ? (f = !1, d = Ia(l, !0)) : h ? (f = !1, d = Va(l, !0)) : d = [] : vu(l) || Yl(l) ? (d = c, Yl(c) ? d = Pu(c) : (!X(c) || su(c)) && (d = Wo(l))) : f = !1;
				}
				f && (s.set(l, d), a(d, l, i, o, s), s.delete(l)), ei(e, r, d);
			}
			function ea(e, t) {
				var r = e.length;
				if (r) return t += t < 0 ? r : 0, Jo(t, r) ? e[t] : n;
			}
			function ta(e, t, n) {
				t = t.length ? R(t, function(e) {
					return J(e) ? function(t) {
						return wi(t, e.length === 1 ? e[0] : e);
					} : e;
				}) : [pf];
				var r = -1;
				return t = R(t, z(q())), In(Yi(e, function(e, n, i) {
					return {
						criteria: R(t, function(t) {
							return t(e);
						}),
						index: ++r,
						value: e
					};
				}), function(e, t) {
					return Ua(e, t, n);
				});
			}
			function na(e, t) {
				return ra(e, t, function(t, n) {
					return ed(e, n);
				});
			}
			function ra(e, t, n) {
				for (var r = -1, i = t.length, a = {}; ++r < i;) {
					var o = t[r], s = wi(e, o);
					n(s, o) && fa(a, Ma(o, e), s);
				}
				return a;
			}
			function ia(e) {
				return function(t) {
					return wi(t, e);
				};
			}
			function aa(e, t, n, r) {
				var i = r ? An : kn, a = -1, o = t.length, s = e;
				for (e === t && (t = Ka(t)), n && (s = R(e, z(n))); ++a < o;) for (var c = 0, l = t[a], u = n ? n(l) : l; (c = i(s, u, c, r)) > -1;) s !== e && kt.call(s, c, 1), kt.call(e, c, 1);
				return e;
			}
			function oa(e, t) {
				for (var n = e ? t.length : 0, r = n - 1; n--;) {
					var i = t[n];
					if (n == r || i !== a) {
						var a = i;
						Jo(i) ? kt.call(e, i, 1) : wa(e, i);
					}
				}
				return e;
			}
			function sa(e, t) {
				return e + Rt(Xt() * (t - e + 1));
			}
			function ca(e, t, n, r) {
				for (var i = -1, a = M(Lt((t - e) / (n || 1)), 0), o = D(a); a--;) o[r ? a : ++i] = e, e += n;
				return o;
			}
			function la(e, t) {
				var n = "";
				if (!e || t < 1 || t > g) return n;
				do
					t % 2 && (n += e), t = Rt(t / 2), t && (e += e);
				while (t);
				return n;
			}
			function K(e, t) {
				return ms(cs(e, t, pf), e + "");
			}
			function ua(e) {
				return Zr(Cd(e));
			}
			function da(e, t) {
				var n = Cd(e);
				return _s(n, ci(t, 0, n.length));
			}
			function fa(e, t, r, i) {
				if (!X(e)) return e;
				t = Ma(t, e);
				for (var a = -1, o = t.length, s = o - 1, c = e; c != null && ++a < o;) {
					var l = ys(t[a]), u = r;
					if (l === "__proto__" || l === "constructor" || l === "prototype") return e;
					if (a != s) {
						var d = c[l];
						u = i ? i(d, l, c) : n, u === n && (u = X(d) ? d : Jo(t[a + 1]) ? [] : {});
					}
					ti(c, l, u), c = c[l];
				}
				return e;
			}
			var pa = Tn ? function(e, t) {
				return Tn.set(e, t), e;
			} : pf, ma = Nt ? function(e, t) {
				return Nt(e, "toString", {
					configurable: !0,
					enumerable: !1,
					value: lf(t),
					writable: !0
				});
			} : pf;
			function ha(e) {
				return _s(Cd(e));
			}
			function ga(e, t, n) {
				var r = -1, i = e.length;
				t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
				for (var a = D(i); ++r < i;) a[r] = e[r + t];
				return a;
			}
			function _a(e, t) {
				var n;
				return mi(e, function(e, r, i) {
					return n = t(e, r, i), !n;
				}), !!n;
			}
			function va(e, t, n) {
				var r = 0, i = e == null ? r : e.length;
				if (typeof t == "number" && t === t && i <= ee) {
					for (; r < i;) {
						var a = r + i >>> 1, o = e[a];
						o !== null && !Cu(o) && (n ? o <= t : o < t) ? r = a + 1 : i = a;
					}
					return i;
				}
				return ya(e, t, pf, n);
			}
			function ya(e, t, r, i) {
				var a = 0, o = e == null ? 0 : e.length;
				if (o === 0) return 0;
				t = r(t);
				for (var s = t !== t, c = t === null, l = Cu(t), u = t === n; a < o;) {
					var d = Rt((a + o) / 2), f = r(e[d]), p = f !== n, m = f === null, h = f === f, g = Cu(f);
					if (s) var _ = i || h;
					else _ = u ? h && (i || p) : c ? h && p && (i || !m) : l ? h && p && !m && (i || !g) : m || g ? !1 : i ? f <= t : f < t;
					_ ? a = d + 1 : o = d;
				}
				return F(o, b);
			}
			function ba(e, t) {
				for (var n = -1, r = e.length, i = 0, a = []; ++n < r;) {
					var o = e[n], s = t ? t(o) : o;
					if (!n || !Kl(s, c)) {
						var c = s;
						a[i++] = o === 0 ? 0 : o;
					}
				}
				return a;
			}
			function xa(e) {
				return typeof e == "number" ? e : Cu(e) ? v : +e;
			}
			function Sa(e) {
				if (typeof e == "string") return e;
				if (J(e)) return R(e, Sa) + "";
				if (Cu(e)) return vr ? vr.call(e) : "";
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function Ca(e, t, n) {
				var r = -1, i = vn, a = e.length, o = !0, s = [], c = s;
				if (n) o = !1, i = yn;
				else if (a >= 200) {
					var l = t ? null : vo(e);
					if (l) return nr(l);
					o = !1, i = Hn, c = new Vr();
				} else c = t ? [] : s;
				outer: for (; ++r < a;) {
					var u = e[r], d = t ? t(u) : u;
					if (u = n || u !== 0 ? u : 0, o && d === d) {
						for (var f = c.length; f--;) if (c[f] === d) continue outer;
						t && c.push(d), s.push(u);
					} else i(c, d, n) || (c !== s && c.push(d), s.push(u));
				}
				return s;
			}
			function wa(e, t) {
				t = Ma(t, e);
				var n = -1, r = t.length;
				if (!r) return !0;
				for (; ++n < r;) {
					var i = ys(t[n]);
					if (i === "__proto__" && !j.call(e, "__proto__") || (i === "constructor" || i === "prototype") && n < r - 1) return !1;
				}
				var a = ls(e, t);
				return a == null || delete a[ys(qs(t))];
			}
			function Ta(e, t, n, r) {
				return fa(e, t, n(wi(e, t)), r);
			}
			function Ea(e, t, n, r) {
				for (var i = e.length, a = r ? i : -1; (r ? a-- : ++a < i) && t(e[a], a, e););
				return n ? ga(e, r ? 0 : a, r ? a + 1 : i) : ga(e, r ? a + 1 : 0, r ? i : a);
			}
			function Da(e, t) {
				var n = e;
				return n instanceof H && (n = n.value()), xn(t, function(e, t) {
					return t.func.apply(t.thisArg, bn([e], t.args));
				}, n);
			}
			function Oa(e, t, n) {
				var r = e.length;
				if (r < 2) return r ? Ca(e[0]) : [];
				for (var i = -1, a = D(r); ++i < r;) for (var o = e[i], s = -1; ++s < r;) s != i && (a[i] = pi(a[i] || o, e[s], t, n));
				return Ca(W(a, 1), t, n);
			}
			function ka(e, t, r) {
				for (var i = -1, a = e.length, o = t.length, s = {}; ++i < a;) {
					var c = i < o ? t[i] : n;
					r(s, e[i], c);
				}
				return s;
			}
			function Aa(e) {
				return Y(e) ? e : [];
			}
			function ja(e) {
				return typeof e == "function" ? e : pf;
			}
			function Ma(e, t) {
				return J(e) ? e : Xo(e, t) ? [e] : vs($(e));
			}
			var Na = K;
			function Pa(e, t, r) {
				var i = e.length;
				return r = r === n ? i : r, !t && r >= i ? e : ga(e, t, r);
			}
			var Fa = Pt || function(e) {
				return I.clearTimeout(e);
			};
			function Ia(e, t) {
				if (t) return e.slice();
				var n = e.length, r = Tt ? Tt(n) : new e.constructor(n);
				return e.copy(r), r;
			}
			function La(e) {
				var t = new e.constructor(e.byteLength);
				return new wt(t).set(new wt(e)), t;
			}
			function Ra(e, t) {
				var n = t ? La(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.byteLength);
			}
			function za(e) {
				var t = new e.constructor(e.source, Ze.exec(e));
				return t.lastIndex = e.lastIndex, t;
			}
			function Ba(e) {
				return _r ? k(_r.call(e)) : {};
			}
			function Va(e, t) {
				var n = t ? La(e.buffer) : e.buffer;
				return new e.constructor(n, e.byteOffset, e.length);
			}
			function Ha(e, t) {
				if (e !== t) {
					var r = e !== n, i = e === null, a = e === e, o = Cu(e), s = t !== n, c = t === null, l = t === t, u = Cu(t);
					if (!c && !u && !o && e > t || o && s && l && !c && !u || i && s && l || !r && l || !a) return 1;
					if (!i && !o && !u && e < t || u && r && a && !i && !o || c && r && a || !s && a || !l) return -1;
				}
				return 0;
			}
			function Ua(e, t, n) {
				for (var r = -1, i = e.criteria, a = t.criteria, o = i.length, s = n.length; ++r < o;) {
					var c = Ha(i[r], a[r]);
					if (c) return r >= s ? c : c * (n[r] == "desc" ? -1 : 1);
				}
				return e.index - t.index;
			}
			function Wa(e, t, n, r) {
				for (var i = -1, a = e.length, o = n.length, s = -1, c = t.length, l = M(a - o, 0), u = D(c + l), d = !r; ++s < c;) u[s] = t[s];
				for (; ++i < o;) (d || i < a) && (u[n[i]] = e[i]);
				for (; l--;) u[s++] = e[i++];
				return u;
			}
			function Ga(e, t, n, r) {
				for (var i = -1, a = e.length, o = -1, s = n.length, c = -1, l = t.length, u = M(a - s, 0), d = D(u + l), f = !r; ++i < u;) d[i] = e[i];
				for (var p = i; ++c < l;) d[p + c] = t[c];
				for (; ++o < s;) (f || i < a) && (d[p + n[o]] = e[i++]);
				return d;
			}
			function Ka(e, t) {
				var n = -1, r = e.length;
				for (t ||= D(r); ++n < r;) t[n] = e[n];
				return t;
			}
			function qa(e, t, r, i) {
				var a = !r;
				r ||= {};
				for (var o = -1, s = t.length; ++o < s;) {
					var c = t[o], l = i ? i(r[c], e[c], c, r, e) : n;
					l === n && (l = e[c]), a ? oi(r, c, l) : ti(r, c, l);
				}
				return r;
			}
			function Ja(e, t) {
				return qa(e, Lo(e), t);
			}
			function Ya(e, t) {
				return qa(e, Ro(e), t);
			}
			function Xa(e, t) {
				return function(n, r) {
					var i = J(n) ? pn : ri, a = t ? t() : {};
					return i(n, e, q(r, 2), a);
				};
			}
			function Za(e) {
				return K(function(t, r) {
					var i = -1, a = r.length, o = a > 1 ? r[a - 1] : n, s = a > 2 ? r[2] : n;
					for (o = e.length > 3 && typeof o == "function" ? (a--, o) : n, s && Yo(r[0], r[1], s) && (o = a < 3 ? n : o, a = 1), t = k(t); ++i < a;) {
						var c = r[i];
						c && e(t, c, i, o);
					}
					return t;
				});
			}
			function Qa(e, t) {
				return function(n, r) {
					if (n == null) return n;
					if (!Zl(n)) return e(n, r);
					for (var i = n.length, a = t ? i : -1, o = k(n); (t ? a-- : ++a < i) && r(o[a], a, o) !== !1;);
					return n;
				};
			}
			function $a(e) {
				return function(t, n, r) {
					for (var i = -1, a = k(t), o = r(t), s = o.length; s--;) {
						var c = o[e ? s : ++i];
						if (n(a[c], c, a) === !1) break;
					}
					return t;
				};
			}
			function eo(e, t, n) {
				var r = t & o, i = ro(e);
				function a() {
					return (this && this !== I && this instanceof a ? i : e).apply(r ? n : this, arguments);
				}
				return a;
			}
			function to(e) {
				return function(t) {
					t = $(t);
					var r = Xn(t) ? sr(t) : n, i = r ? r[0] : t.charAt(0), a = r ? Pa(r, 1).join("") : t.slice(1);
					return i[e]() + a;
				};
			}
			function no(e) {
				return function(t) {
					return xn(rf(Ad(t).replace(Vt, "")), e, "");
				};
			}
			function ro(e) {
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return new e();
						case 1: return new e(t[0]);
						case 2: return new e(t[0], t[1]);
						case 3: return new e(t[0], t[1], t[2]);
						case 4: return new e(t[0], t[1], t[2], t[3]);
						case 5: return new e(t[0], t[1], t[2], t[3], t[4]);
						case 6: return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
						case 7: return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
					}
					var n = yr(e.prototype), r = e.apply(n, t);
					return X(r) ? r : n;
				};
			}
			function io(e, t, r) {
				var i = ro(e);
				function a() {
					for (var o = arguments.length, s = D(o), c = o, l = Mo(a); c--;) s[c] = arguments[c];
					var u = o < 3 && s[0] !== l && s[o - 1] !== l ? [] : tr(s, l);
					return o -= u.length, o < r ? go(e, t, so, a.placeholder, n, s, u, n, n, r - o) : fn(this && this !== I && this instanceof a ? i : e, this, s);
				}
				return a;
			}
			function ao(e) {
				return function(t, r, i) {
					var a = k(t);
					if (!Zl(t)) {
						var o = q(r, 3);
						t = id(t), r = function(e) {
							return o(a[e], e, a);
						};
					}
					var s = e(t, r, i);
					return s > -1 ? a[o ? t[s] : s] : n;
				};
			}
			function oo(e) {
				return Do(function(t) {
					var i = t.length, a = i, o = V.prototype.thru;
					for (e && t.reverse(); a--;) {
						var s = t[a];
						if (typeof s != "function") throw new dt(r);
						if (o && !l && jo(s) == "wrapper") var l = new V([], !0);
					}
					for (a = l ? a : i; ++a < i;) {
						s = t[a];
						var d = jo(s), m = d == "wrapper" ? Ao(s) : n;
						l = m && Qo(m[0]) && m[1] == (f | c | u | p) && !m[4].length && m[9] == 1 ? l[jo(m[0])].apply(l, m[3]) : s.length == 1 && Qo(s) ? l[d]() : l.thru(s);
					}
					return function() {
						var e = arguments, n = e[0];
						if (l && e.length == 1 && J(n)) return l.plant(n).value();
						for (var r = 0, a = i ? t[r].apply(this, e) : n; ++r < i;) a = t[r].call(this, a);
						return a;
					};
				});
			}
			function so(e, t, r, i, a, u, d, p, h, g) {
				var _ = t & f, v = t & o, y = t & s, b = t & (c | l), ee = t & m, x = y ? n : ro(e);
				function S() {
					for (var n = arguments.length, o = D(n), s = n; s--;) o[s] = arguments[s];
					if (b) var c = Mo(S), l = Gn(o, c);
					if (i && (o = Wa(o, i, a, b)), u && (o = Ga(o, u, d, b)), n -= l, b && n < g) {
						var f = tr(o, c);
						return go(e, t, so, S.placeholder, r, o, f, p, h, g - n);
					}
					var m = v ? r : this, C = y ? m[e] : e;
					return n = o.length, p ? o = us(o, p) : ee && n > 1 && o.reverse(), _ && h < n && (o.length = h), this && this !== I && this instanceof S && (C = x || ro(C)), C.apply(m, o);
				}
				return S;
			}
			function co(e, t) {
				return function(n, r) {
					return Mi(n, e, t(r), {});
				};
			}
			function lo(e, t) {
				return function(r, i) {
					var a;
					if (r === n && i === n) return t;
					if (r !== n && (a = r), i !== n) {
						if (a === n) return i;
						typeof r == "string" || typeof i == "string" ? (r = Sa(r), i = Sa(i)) : (r = xa(r), i = xa(i)), a = e(r, i);
					}
					return a;
				};
			}
			function uo(e) {
				return Do(function(t) {
					return t = R(t, z(q())), K(function(n) {
						var r = this;
						return e(t, function(e) {
							return fn(e, r, n);
						});
					});
				});
			}
			function fo(e, t) {
				t = t === n ? " " : Sa(t);
				var r = t.length;
				if (r < 2) return r ? la(t, e) : t;
				var i = la(t, Lt(e / or(t)));
				return Xn(t) ? Pa(sr(i), 0, e).join("") : i.slice(0, e);
			}
			function po(e, t, n, r) {
				var i = t & o, a = ro(e);
				function s() {
					for (var t = -1, o = arguments.length, c = -1, l = r.length, u = D(l + o), d = this && this !== I && this instanceof s ? a : e; ++c < l;) u[c] = r[c];
					for (; o--;) u[c++] = arguments[++t];
					return fn(d, i ? n : this, u);
				}
				return s;
			}
			function mo(e) {
				return function(t, r, i) {
					return i && typeof i != "number" && Yo(t, r, i) && (r = i = n), t = ju(t), r === n ? (r = t, t = 0) : r = ju(r), i = i === n ? t < r ? 1 : -1 : ju(i), ca(t, r, i, e);
				};
			}
			function ho(e) {
				return function(t, n) {
					return (typeof t != "string" || typeof n != "string") && (t = Nu(t), n = Nu(n)), e(t, n);
				};
			}
			function go(e, t, r, i, a, l, f, p, m, h) {
				var g = t & c, _ = g ? f : n, v = g ? n : f, y = g ? l : n, b = g ? n : l;
				t |= g ? u : d, t &= ~(g ? d : u), t & 4 || (t &= ~(o | s));
				var ee = [
					e,
					t,
					a,
					y,
					_,
					b,
					v,
					p,
					m,
					h
				], x = r.apply(n, ee);
				return Qo(e) && fs(x, ee), x.placeholder = i, hs(x, e, t);
			}
			function _o(e) {
				var t = ct[e];
				return function(e, n) {
					if (e = Nu(e), n = n == null ? 0 : F(Q(n), 292), n && Ut(e)) {
						var r = ($(e) + "e").split("e");
						return r = ($(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"), +(r[0] + "e" + (+r[1] - n));
					}
					return t(e);
				};
			}
			var vo = an && 1 / nr(new an([, -0]))[1] == h ? function(e) {
				return new an(e);
			} : xf;
			function yo(e) {
				return function(t) {
					var n = zo(t);
					return n == se ? $n(t) : n == me ? rr(t) : zn(t, e(t));
				};
			}
			function bo(e, t, i, a, f, p, m, h) {
				var g = t & s;
				if (!g && typeof e != "function") throw new dt(r);
				var _ = a ? a.length : 0;
				if (_ || (t &= ~(u | d), a = f = n), m = m === n ? m : M(Q(m), 0), h = h === n ? h : Q(h), _ -= f ? f.length : 0, t & d) {
					var v = a, y = f;
					a = f = n;
				}
				var b = g ? n : Ao(e), ee = [
					e,
					t,
					i,
					a,
					f,
					v,
					y,
					p,
					m,
					h
				];
				if (b && as(ee, b), e = ee[0], t = ee[1], i = ee[2], a = ee[3], f = ee[4], h = ee[9] = ee[9] === n ? g ? 0 : e.length : M(ee[9] - _, 0), !h && t & (c | l) && (t &= ~(c | l)), !t || t == o) var x = eo(e, t, i);
				else x = t == c || t == l ? io(e, t, h) : (t == u || t == (o | u)) && !f.length ? po(e, t, i, a) : so.apply(n, ee);
				return hs((b ? pa : fs)(x, ee), e, t);
			}
			function xo(e, t, r, i) {
				return e === n || Kl(e, A[r]) && !j.call(i, r) ? t : e;
			}
			function So(e, t, r, i, a, o) {
				return X(e) && X(t) && (o.set(t, e), Qi(e, t, n, So, o), o.delete(t)), e;
			}
			function Co(e) {
				return vu(e) ? n : e;
			}
			function wo(e, t, r, i, a, o) {
				var s = r & 1, c = e.length, l = t.length;
				if (c != l && !(s && l > c)) return !1;
				var u = o.get(e), d = o.get(t);
				if (u && d) return u == t && d == e;
				var f = -1, p = !0, m = r & 2 ? new Vr() : n;
				for (o.set(e, t), o.set(t, e); ++f < c;) {
					var h = e[f], g = t[f];
					if (i) var _ = s ? i(g, h, f, t, e, o) : i(h, g, f, e, t, o);
					if (_ !== n) {
						if (_) continue;
						p = !1;
						break;
					}
					if (m) {
						if (!Cn(t, function(e, t) {
							if (!Hn(m, t) && (h === e || a(h, e, r, i, o))) return m.push(t);
						})) {
							p = !1;
							break;
						}
					} else if (!(h === g || a(h, g, r, i, o))) {
						p = !1;
						break;
					}
				}
				return o.delete(e), o.delete(t), p;
			}
			function To(e, t, n, r, i, a, o) {
				switch (n) {
					case xe:
						if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
						e = e.buffer, t = t.buffer;
					case be: return !(e.byteLength != t.byteLength || !a(new wt(e), new wt(t)));
					case ne:
					case w:
					case ce: return Kl(+e, +t);
					case ie: return e.name == t.name && e.message == t.message;
					case pe:
					case he: return e == t + "";
					case se: var s = $n;
					case me:
						var c = r & 1;
						if (s ||= nr, e.size != t.size && !c) return !1;
						var l = o.get(e);
						if (l) return l == t;
						r |= 2, o.set(e, t);
						var u = wo(s(e), s(t), r, i, a, o);
						return o.delete(e), u;
					case ge: if (_r) return _r.call(e) == _r.call(t);
				}
				return !1;
			}
			function Eo(e, t, r, i, a, o) {
				var s = r & 1, c = Oo(e), l = c.length;
				if (l != Oo(t).length && !s) return !1;
				for (var u = l; u--;) {
					var d = c[u];
					if (!(s ? d in t : j.call(t, d))) return !1;
				}
				var f = o.get(e), p = o.get(t);
				if (f && p) return f == t && p == e;
				var m = !0;
				o.set(e, t), o.set(t, e);
				for (var h = s; ++u < l;) {
					d = c[u];
					var g = e[d], _ = t[d];
					if (i) var v = s ? i(_, g, d, t, e, o) : i(g, _, d, e, t, o);
					if (!(v === n ? g === _ || a(g, _, r, i, o) : v)) {
						m = !1;
						break;
					}
					h ||= d == "constructor";
				}
				if (m && !h) {
					var y = e.constructor, b = t.constructor;
					y != b && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof b == "function" && b instanceof b) && (m = !1);
				}
				return o.delete(e), o.delete(t), m;
			}
			function Do(e) {
				return ms(cs(e, n, Is), e + "");
			}
			function Oo(e) {
				return Ti(e, id, Lo);
			}
			function ko(e) {
				return Ti(e, ad, Ro);
			}
			var Ao = Tn ? function(e) {
				return Tn.get(e);
			} : xf;
			function jo(e) {
				for (var t = e.name + "", n = Pn[t], r = j.call(Pn, t) ? n.length : 0; r--;) {
					var i = n[r], a = i.func;
					if (a == null || a == e) return i.name;
				}
				return t;
			}
			function Mo(e) {
				return (j.call(B, "placeholder") ? B : e).placeholder;
			}
			function q() {
				var e = B.iteratee || mf;
				return e = e === mf ? Gi : e, arguments.length ? e(arguments[0], arguments[1]) : e;
			}
			function No(e, t) {
				var n = e.__data__;
				return Zo(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
			}
			function Po(e) {
				for (var t = id(e), n = t.length; n--;) {
					var r = t[n], i = e[r];
					t[n] = [
						r,
						i,
						ns(i)
					];
				}
				return t;
			}
			function Fo(e, t) {
				var r = Yn(e, t);
				return Vi(r) ? r : n;
			}
			function Io(e) {
				var t = j.call(e, Mt), r = e[Mt];
				try {
					e[Mt] = n;
					var i = !0;
				} catch {}
				var a = vt.call(e);
				return i && (t ? e[Mt] = r : delete e[Mt]), a;
			}
			var Lo = zt ? function(e) {
				return e == null ? [] : (e = k(e), _n(zt(e), function(t) {
					return Ot.call(e, t);
				}));
			} : Af, Ro = zt ? function(e) {
				for (var t = []; e;) bn(t, Lo(e)), e = Et(e);
				return t;
			} : Af, zo = Ei;
			(en && zo(new en(/* @__PURE__ */ new ArrayBuffer(1))) != xe || tn && zo(new tn()) != se || nn && zo(nn.resolve()) != de || an && zo(new an()) != me || L && zo(new L()) != ve) && (zo = function(e) {
				var t = Ei(e), r = t == ue ? e.constructor : n, i = r ? bs(r) : "";
				if (i) switch (i) {
					case ir: return xe;
					case ur: return se;
					case dr: return de;
					case mr: return me;
					case hr: return ve;
				}
				return t;
			});
			function Bo(e, t, n) {
				for (var r = -1, i = n.length; ++r < i;) {
					var a = n[r], o = a.size;
					switch (a.type) {
						case "drop":
							e += o;
							break;
						case "dropRight":
							t -= o;
							break;
						case "take":
							t = F(t, e + o);
							break;
						case "takeRight": e = M(e, t - o);
					}
				}
				return {
					start: e,
					end: t
				};
			}
			function Vo(e) {
				var t = e.match(Ke);
				return t ? t[1].split(qe) : [];
			}
			function Ho(e, t, n) {
				t = Ma(t, e);
				for (var r = -1, i = t.length, a = !1; ++r < i;) {
					var o = ys(t[r]);
					if (!(a = e != null && n(e, o))) break;
					e = e[o];
				}
				return a || ++r != i ? a : (i = e == null ? 0 : e.length, !!i && lu(i) && Jo(o, i) && (J(e) || Yl(e)));
			}
			function Uo(e) {
				var t = e.length, n = new e.constructor(t);
				return t && typeof e[0] == "string" && j.call(e, "index") && (n.index = e.index, n.input = e.input), n;
			}
			function Wo(e) {
				return typeof e.constructor == "function" && !ts(e) ? yr(Et(e)) : {};
			}
			function Go(e, t, n) {
				var r = e.constructor;
				switch (t) {
					case be: return La(e);
					case ne:
					case w: return new r(+e);
					case xe: return Ra(e, n);
					case T:
					case Se:
					case Ce:
					case we:
					case Te:
					case E:
					case Ee:
					case De:
					case Oe: return Va(e, n);
					case se: return new r();
					case ce:
					case he: return new r(e);
					case pe: return za(e);
					case me: return new r();
					case ge: return Ba(e);
				}
			}
			function Ko(e, t) {
				var n = t.length;
				if (!n) return e;
				var r = n - 1;
				return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Ge, "{\n/* [wrapped with " + t + "] */\n");
			}
			function qo(e) {
				return J(e) || Yl(e) || !!(At && e && e[At]);
			}
			function Jo(e, t) {
				var n = typeof e;
				return t ??= g, !!t && (n == "number" || n != "symbol" && nt.test(e)) && e > -1 && e % 1 == 0 && e < t;
			}
			function Yo(e, t, n) {
				if (!X(n)) return !1;
				var r = typeof t;
				return (r == "number" ? Zl(n) && Jo(t, n.length) : r == "string" && t in n) ? Kl(n[t], e) : !1;
			}
			function Xo(e, t) {
				if (J(e)) return !1;
				var n = typeof e;
				return n == "number" || n == "symbol" || n == "boolean" || e == null || Cu(e) ? !0 : Be.test(e) || !ze.test(e) || t != null && e in k(t);
			}
			function Zo(e) {
				var t = typeof e;
				return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
			}
			function Qo(e) {
				var t = jo(e), n = B[t];
				if (typeof n != "function" || !(t in H.prototype)) return !1;
				if (e === n) return !0;
				var r = Ao(n);
				return !!r && e === r[0];
			}
			function $o(e) {
				return !!_t && _t in e;
			}
			var es = mt ? su : jf;
			function ts(e) {
				var t = e && e.constructor;
				return e === (typeof t == "function" && t.prototype || A);
			}
			function ns(e) {
				return e === e && !X(e);
			}
			function rs(e, t) {
				return function(r) {
					return r != null && r[e] === t && (t !== n || e in k(r));
				};
			}
			function is(e) {
				var t = Ol(e, function(e) {
					return n.size === 500 && n.clear(), e;
				}), n = t.cache;
				return t;
			}
			function as(e, t) {
				var n = e[1], r = t[1], i = n | r, l = i < (o | s | f), u = r == f && n == c || r == f && n == p && e[7].length <= t[8] || r == (f | p) && t[7].length <= t[8] && n == c;
				if (!(l || u)) return e;
				r & o && (e[2] = t[2], i |= n & o ? 0 : 4);
				var d = t[3];
				if (d) {
					var m = e[3];
					e[3] = m ? Wa(m, d, t[4]) : d, e[4] = m ? tr(e[3], a) : t[4];
				}
				return d = t[5], d && (m = e[5], e[5] = m ? Ga(m, d, t[6]) : d, e[6] = m ? tr(e[5], a) : t[6]), d = t[7], d && (e[7] = d), r & f && (e[8] = e[8] == null ? t[8] : F(e[8], t[8])), e[9] ??= t[9], e[0] = t[0], e[1] = i, e;
			}
			function os(e) {
				var t = [];
				if (e != null) for (var n in k(e)) t.push(n);
				return t;
			}
			function ss(e) {
				return vt.call(e);
			}
			function cs(e, t, r) {
				return t = M(t === n ? e.length - 1 : t, 0), function() {
					for (var n = arguments, i = -1, a = M(n.length - t, 0), o = D(a); ++i < a;) o[i] = n[t + i];
					i = -1;
					for (var s = D(t + 1); ++i < t;) s[i] = n[i];
					return s[t] = r(o), fn(e, this, s);
				};
			}
			function ls(e, t) {
				return t.length < 2 ? e : wi(e, ga(t, 0, -1));
			}
			function us(e, t) {
				for (var r = e.length, i = F(t.length, r), a = Ka(e); i--;) {
					var o = t[i];
					e[i] = Jo(o, r) ? a[o] : n;
				}
				return e;
			}
			function ds(e, t) {
				if ((t !== "constructor" || typeof e[t] != "function") && t != "__proto__") return e[t];
			}
			var fs = gs(pa), ps = It || function(e, t) {
				return I.setTimeout(e, t);
			}, ms = gs(ma);
			function hs(e, t, n) {
				var r = t + "";
				return ms(e, Ko(r, xs(Vo(r), n)));
			}
			function gs(e) {
				var t = 0, r = 0;
				return function() {
					var i = Jt(), a = 16 - (i - r);
					if (r = i, a > 0) {
						if (++t >= 800) return arguments[0];
					} else t = 0;
					return e.apply(n, arguments);
				};
			}
			function _s(e, t) {
				var r = -1, i = e.length, a = i - 1;
				for (t = t === n ? i : t; ++r < t;) {
					var o = sa(r, a), s = e[o];
					e[o] = e[r], e[r] = s;
				}
				return e.length = t, e;
			}
			var vs = is(function(e) {
				var t = [];
				return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ve, function(e, n, r, i) {
					t.push(r ? i.replace(O, "$1") : n || e);
				}), t;
			});
			function ys(e) {
				if (typeof e == "string" || Cu(e)) return e;
				var t = e + "";
				return t == "0" && 1 / e == -Infinity ? "-0" : t;
			}
			function bs(e) {
				if (e != null) {
					try {
						return ht.call(e);
					} catch {}
					try {
						return e + "";
					} catch {}
				}
				return "";
			}
			function xs(e, t) {
				return mn(x, function(n) {
					var r = "_." + n[0];
					t & n[1] && !vn(e, r) && e.push(r);
				}), e.sort();
			}
			function Ss(e) {
				if (e instanceof H) return e.clone();
				var t = new V(e.__wrapped__, e.__chain__);
				return t.__actions__ = Ka(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
			}
			function Cs(e, t, r) {
				t = (r ? Yo(e, t, r) : t === n) ? 1 : M(Q(t), 0);
				var i = e == null ? 0 : e.length;
				if (!i || t < 1) return [];
				for (var a = 0, o = 0, s = D(Lt(i / t)); a < i;) s[o++] = ga(e, a, a += t);
				return s;
			}
			function ws(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++t < n;) {
					var a = e[t];
					a && (i[r++] = a);
				}
				return i;
			}
			function Ts() {
				var e = arguments.length;
				if (!e) return [];
				for (var t = D(e - 1), n = arguments[0], r = e; r--;) t[r - 1] = arguments[r];
				return bn(J(n) ? Ka(n) : [n], W(t, 1));
			}
			var Es = K(function(e, t) {
				return Y(e) ? pi(e, W(t, 1, Y, !0)) : [];
			}), Ds = K(function(e, t) {
				var r = qs(t);
				return Y(r) && (r = n), Y(e) ? pi(e, W(t, 1, Y, !0), q(r, 2)) : [];
			}), Os = K(function(e, t) {
				var r = qs(t);
				return Y(r) && (r = n), Y(e) ? pi(e, W(t, 1, Y, !0), n, r) : [];
			});
			function ks(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), ga(e, t < 0 ? 0 : t, i)) : [];
			}
			function As(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), t = i - t, ga(e, 0, t < 0 ? 0 : t)) : [];
			}
			function js(e, t) {
				return e && e.length ? Ea(e, q(t, 3), !0, !0) : [];
			}
			function Ms(e, t) {
				return e && e.length ? Ea(e, q(t, 3), !0) : [];
			}
			function Ns(e, t, n, r) {
				var i = e == null ? 0 : e.length;
				return i ? (n && typeof n != "number" && Yo(e, t, n) && (n = 0, r = i), vi(e, t, n, r)) : [];
			}
			function Ps(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Q(n);
				return i < 0 && (i = M(r + i, 0)), On(e, q(t, 3), i);
			}
			function Fs(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i - 1;
				return r !== n && (a = Q(r), a = r < 0 ? M(i + a, 0) : F(a, i - 1)), On(e, q(t, 3), a, !0);
			}
			function Is(e) {
				return e != null && e.length ? W(e, 1) : [];
			}
			function Ls(e) {
				return e != null && e.length ? W(e, h) : [];
			}
			function Rs(e, t) {
				return e != null && e.length ? (t = t === n ? 1 : Q(t), W(e, t)) : [];
			}
			function zs(e) {
				for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n;) {
					var i = e[t];
					oi(r, i[0], i[1]);
				}
				return r;
			}
			function Bs(e) {
				return e && e.length ? e[0] : n;
			}
			function Vs(e, t, n) {
				var r = e == null ? 0 : e.length;
				if (!r) return -1;
				var i = n == null ? 0 : Q(n);
				return i < 0 && (i = M(r + i, 0)), kn(e, t, i);
			}
			function Hs(e) {
				return e != null && e.length ? ga(e, 0, -1) : [];
			}
			var Us = K(function(e) {
				var t = R(e, Aa);
				return t.length && t[0] === e[0] ? ji(t) : [];
			}), Ws = K(function(e) {
				var t = qs(e), r = R(e, Aa);
				return t === qs(r) ? t = n : r.pop(), r.length && r[0] === e[0] ? ji(r, q(t, 2)) : [];
			}), Gs = K(function(e) {
				var t = qs(e), r = R(e, Aa);
				return t = typeof t == "function" ? t : n, t && r.pop(), r.length && r[0] === e[0] ? ji(r, n, t) : [];
			});
			function Ks(e, t) {
				return e == null ? "" : Wt.call(e, t);
			}
			function qs(e) {
				var t = e == null ? 0 : e.length;
				return t ? e[t - 1] : n;
			}
			function Js(e, t, r) {
				var i = e == null ? 0 : e.length;
				if (!i) return -1;
				var a = i;
				return r !== n && (a = Q(r), a = a < 0 ? M(i + a, 0) : F(a, i - 1)), t === t ? ar(e, t, a) : On(e, jn, a, !0);
			}
			function Ys(e, t) {
				return e && e.length ? ea(e, Q(t)) : n;
			}
			var Xs = K(Zs);
			function Zs(e, t) {
				return e && e.length && t && t.length ? aa(e, t) : e;
			}
			function Qs(e, t, n) {
				return e && e.length && t && t.length ? aa(e, t, q(n, 2)) : e;
			}
			function $s(e, t, r) {
				return e && e.length && t && t.length ? aa(e, t, n, r) : e;
			}
			var ec = Do(function(e, t) {
				var n = e == null ? 0 : e.length, r = si(e, t);
				return oa(e, R(t, function(e) {
					return Jo(e, n) ? +e : e;
				}).sort(Ha)), r;
			});
			function tc(e, t) {
				var n = [];
				if (!(e && e.length)) return n;
				var r = -1, i = [], a = e.length;
				for (t = q(t, 3); ++r < a;) {
					var o = e[r];
					t(o, r, e) && (n.push(o), i.push(r));
				}
				return oa(e, i), n;
			}
			function nc(e) {
				return e == null ? e : $t.call(e);
			}
			function rc(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (r && typeof r != "number" && Yo(e, t, r) ? (t = 0, r = i) : (t = t == null ? 0 : Q(t), r = r === n ? i : Q(r)), ga(e, t, r)) : [];
			}
			function ic(e, t) {
				return va(e, t);
			}
			function ac(e, t, n) {
				return ya(e, t, q(n, 2));
			}
			function oc(e, t) {
				var n = e == null ? 0 : e.length;
				if (n) {
					var r = va(e, t);
					if (r < n && Kl(e[r], t)) return r;
				}
				return -1;
			}
			function sc(e, t) {
				return va(e, t, !0);
			}
			function cc(e, t, n) {
				return ya(e, t, q(n, 2), !0);
			}
			function lc(e, t) {
				if (e != null && e.length) {
					var n = va(e, t, !0) - 1;
					if (Kl(e[n], t)) return n;
				}
				return -1;
			}
			function uc(e) {
				return e && e.length ? ba(e) : [];
			}
			function dc(e, t) {
				return e && e.length ? ba(e, q(t, 2)) : [];
			}
			function fc(e) {
				var t = e == null ? 0 : e.length;
				return t ? ga(e, 1, t) : [];
			}
			function pc(e, t, r) {
				return e && e.length ? (t = r || t === n ? 1 : Q(t), ga(e, 0, t < 0 ? 0 : t)) : [];
			}
			function mc(e, t, r) {
				var i = e == null ? 0 : e.length;
				return i ? (t = r || t === n ? 1 : Q(t), t = i - t, ga(e, t < 0 ? 0 : t, i)) : [];
			}
			function hc(e, t) {
				return e && e.length ? Ea(e, q(t, 3), !1, !0) : [];
			}
			function gc(e, t) {
				return e && e.length ? Ea(e, q(t, 3)) : [];
			}
			var _c = K(function(e) {
				return Ca(W(e, 1, Y, !0));
			}), vc = K(function(e) {
				var t = qs(e);
				return Y(t) && (t = n), Ca(W(e, 1, Y, !0), q(t, 2));
			}), yc = K(function(e) {
				var t = qs(e);
				return t = typeof t == "function" ? t : n, Ca(W(e, 1, Y, !0), n, t);
			});
			function bc(e) {
				return e && e.length ? Ca(e) : [];
			}
			function xc(e, t) {
				return e && e.length ? Ca(e, q(t, 2)) : [];
			}
			function Sc(e, t) {
				return t = typeof t == "function" ? t : n, e && e.length ? Ca(e, n, t) : [];
			}
			function Cc(e) {
				if (!(e && e.length)) return [];
				var t = 0;
				return e = _n(e, function(e) {
					if (Y(e)) return t = M(e.length, t), !0;
				}), Rn(t, function(t) {
					return R(e, Nn(t));
				});
			}
			function wc(e, t) {
				if (!(e && e.length)) return [];
				var r = Cc(e);
				return t == null ? r : R(r, function(e) {
					return fn(t, n, e);
				});
			}
			var Tc = K(function(e, t) {
				return Y(e) ? pi(e, t) : [];
			}), Ec = K(function(e) {
				return Oa(_n(e, Y));
			}), Dc = K(function(e) {
				var t = qs(e);
				return Y(t) && (t = n), Oa(_n(e, Y), q(t, 2));
			}), Oc = K(function(e) {
				var t = qs(e);
				return t = typeof t == "function" ? t : n, Oa(_n(e, Y), n, t);
			}), kc = K(Cc);
			function Ac(e, t) {
				return ka(e || [], t || [], ti);
			}
			function jc(e, t) {
				return ka(e || [], t || [], fa);
			}
			var Mc = K(function(e) {
				var t = e.length, r = t > 1 ? e[t - 1] : n;
				return r = typeof r == "function" ? (e.pop(), r) : n, wc(e, r);
			});
			function Nc(e) {
				var t = B(e);
				return t.__chain__ = !0, t;
			}
			function Pc(e, t) {
				return t(e), e;
			}
			function Fc(e, t) {
				return t(e);
			}
			var Ic = Do(function(e) {
				var t = e.length, r = t ? e[0] : 0, i = this.__wrapped__, a = function(t) {
					return si(t, e);
				};
				return t > 1 || this.__actions__.length || !(i instanceof H) || !Jo(r) ? this.thru(a) : (i = i.slice(r, +r + +!!t), i.__actions__.push({
					func: Fc,
					args: [a],
					thisArg: n
				}), new V(i, this.__chain__).thru(function(e) {
					return t && !e.length && e.push(n), e;
				}));
			});
			function Lc() {
				return Nc(this);
			}
			function Rc() {
				return new V(this.value(), this.__chain__);
			}
			function zc() {
				this.__values__ === n && (this.__values__ = Au(this.value()));
				var e = this.__index__ >= this.__values__.length;
				return {
					done: e,
					value: e ? n : this.__values__[this.__index__++]
				};
			}
			function Bc() {
				return this;
			}
			function Vc(e) {
				for (var t, r = this; r instanceof br;) {
					var i = Ss(r);
					i.__index__ = 0, i.__values__ = n, t ? a.__wrapped__ = i : t = i;
					var a = i;
					r = r.__wrapped__;
				}
				return a.__wrapped__ = e, t;
			}
			function Hc() {
				var e = this.__wrapped__;
				if (e instanceof H) {
					var t = e;
					return this.__actions__.length && (t = new H(this)), t = t.reverse(), t.__actions__.push({
						func: Fc,
						args: [nc],
						thisArg: n
					}), new V(t, this.__chain__);
				}
				return this.thru(nc);
			}
			function Uc() {
				return Da(this.__wrapped__, this.__actions__);
			}
			var Wc = Xa(function(e, t, n) {
				j.call(e, n) ? ++e[n] : oi(e, n, 1);
			});
			function Gc(e, t, r) {
				var i = J(e) ? gn : gi;
				return r && Yo(e, t, r) && (t = n), i(e, q(t, 3));
			}
			function Kc(e, t) {
				return (J(e) ? _n : yi)(e, q(t, 3));
			}
			var qc = ao(Ps), Jc = ao(Fs);
			function Yc(e, t) {
				return W(il(e, t), 1);
			}
			function Xc(e, t) {
				return W(il(e, t), h);
			}
			function Zc(e, t, r) {
				return r = r === n ? 1 : Q(r), W(il(e, t), r);
			}
			function Qc(e, t) {
				return (J(e) ? mn : mi)(e, q(t, 3));
			}
			function $c(e, t) {
				return (J(e) ? hn : hi)(e, q(t, 3));
			}
			var el = Xa(function(e, t, n) {
				j.call(e, n) ? e[n].push(t) : oi(e, n, [t]);
			});
			function tl(e, t, n, r) {
				e = Zl(e) ? e : Cd(e), n = n && !r ? Q(n) : 0;
				var i = e.length;
				return n < 0 && (n = M(i + n, 0)), Su(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && kn(e, t, n) > -1;
			}
			var nl = K(function(e, t, n) {
				var r = -1, i = typeof t == "function", a = Zl(e) ? D(e.length) : [];
				return mi(e, function(e) {
					a[++r] = i ? fn(t, e, n) : Ni(e, t, n);
				}), a;
			}), rl = Xa(function(e, t, n) {
				oi(e, n, t);
			});
			function il(e, t) {
				return (J(e) ? R : Yi)(e, q(t, 3));
			}
			function al(e, t, r, i) {
				return e == null ? [] : (J(t) || (t = t == null ? [] : [t]), r = i ? n : r, J(r) || (r = r == null ? [] : [r]), ta(e, t, r));
			}
			var ol = Xa(function(e, t, n) {
				e[+!n].push(t);
			}, function() {
				return [[], []];
			});
			function sl(e, t, n) {
				var r = J(e) ? xn : Fn, i = arguments.length < 3;
				return r(e, q(t, 4), n, i, mi);
			}
			function cl(e, t, n) {
				var r = J(e) ? Sn : Fn, i = arguments.length < 3;
				return r(e, q(t, 4), n, i, hi);
			}
			function ll(e, t) {
				return (J(e) ? _n : yi)(e, kl(q(t, 3)));
			}
			function ul(e) {
				return (J(e) ? Zr : ua)(e);
			}
			function dl(e, t, r) {
				return t = (r ? Yo(e, t, r) : t === n) ? 1 : Q(t), (J(e) ? Qr : da)(e, t);
			}
			function fl(e) {
				return (J(e) ? $r : ha)(e);
			}
			function pl(e) {
				if (e == null) return 0;
				if (Zl(e)) return Su(e) ? or(e) : e.length;
				var t = zo(e);
				return t == se || t == me ? e.size : Ki(e).length;
			}
			function ml(e, t, r) {
				var i = J(e) ? Cn : _a;
				return r && Yo(e, t, r) && (t = n), i(e, q(t, 3));
			}
			var hl = K(function(e, t) {
				if (e == null) return [];
				var n = t.length;
				return n > 1 && Yo(e, t[0], t[1]) ? t = [] : n > 2 && Yo(t[0], t[1], t[2]) && (t = [t[0]]), ta(e, W(t, 1), []);
			}), gl = Ft || function() {
				return I.Date.now();
			};
			function _l(e, t) {
				if (typeof t != "function") throw new dt(r);
				return e = Q(e), function() {
					if (--e < 1) return t.apply(this, arguments);
				};
			}
			function vl(e, t, r) {
				return t = r ? n : t, t = e && t == null ? e.length : t, bo(e, f, n, n, n, n, t);
			}
			function yl(e, t) {
				var i;
				if (typeof t != "function") throw new dt(r);
				return e = Q(e), function() {
					return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
				};
			}
			var bl = K(function(e, t, n) {
				var r = o;
				if (n.length) {
					var i = tr(n, Mo(bl));
					r |= u;
				}
				return bo(e, r, t, n, i);
			}), xl = K(function(e, t, n) {
				var r = o | s;
				if (n.length) {
					var i = tr(n, Mo(xl));
					r |= u;
				}
				return bo(t, r, e, n, i);
			});
			function Sl(e, t, r) {
				t = r ? n : t;
				var i = bo(e, c, n, n, n, n, n, t);
				return i.placeholder = Sl.placeholder, i;
			}
			function Cl(e, t, r) {
				t = r ? n : t;
				var i = bo(e, l, n, n, n, n, n, t);
				return i.placeholder = Cl.placeholder, i;
			}
			function wl(e, t, i) {
				var a, o, s, c, l, u, d = 0, f = !1, p = !1, m = !0;
				if (typeof e != "function") throw new dt(r);
				t = Nu(t) || 0, X(i) && (f = !!i.leading, p = "maxWait" in i, s = p ? M(Nu(i.maxWait) || 0, t) : s, m = "trailing" in i ? !!i.trailing : m);
				function h(t) {
					var r = a, i = o;
					return a = o = n, d = t, c = e.apply(i, r), c;
				}
				function g(e) {
					return d = e, l = ps(y, t), f ? h(e) : c;
				}
				function _(e) {
					var n = e - u, r = e - d, i = t - n;
					return p ? F(i, s - r) : i;
				}
				function v(e) {
					var r = e - u, i = e - d;
					return u === n || r >= t || r < 0 || p && i >= s;
				}
				function y() {
					var e = gl();
					if (v(e)) return b(e);
					l = ps(y, _(e));
				}
				function b(e) {
					return l = n, m && a ? h(e) : (a = o = n, c);
				}
				function ee() {
					l !== n && Fa(l), d = 0, a = u = o = l = n;
				}
				function x() {
					return l === n ? c : b(gl());
				}
				function S() {
					var e = gl(), r = v(e);
					if (a = arguments, o = this, u = e, r) {
						if (l === n) return g(u);
						if (p) return Fa(l), l = ps(y, t), h(u);
					}
					return l === n && (l = ps(y, t)), c;
				}
				return S.cancel = ee, S.flush = x, S;
			}
			var Tl = K(function(e, t) {
				return fi(e, 1, t);
			}), El = K(function(e, t, n) {
				return fi(e, Nu(t) || 0, n);
			});
			function Dl(e) {
				return bo(e, m);
			}
			function Ol(e, t) {
				if (typeof e != "function" || t != null && typeof t != "function") throw new dt(r);
				var n = function() {
					var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
					if (a.has(i)) return a.get(i);
					var o = e.apply(this, r);
					return n.cache = a.set(i, o) || a, o;
				};
				return n.cache = new (Ol.Cache || Fr)(), n;
			}
			Ol.Cache = Fr;
			function kl(e) {
				if (typeof e != "function") throw new dt(r);
				return function() {
					var t = arguments;
					switch (t.length) {
						case 0: return !e.call(this);
						case 1: return !e.call(this, t[0]);
						case 2: return !e.call(this, t[0], t[1]);
						case 3: return !e.call(this, t[0], t[1], t[2]);
					}
					return !e.apply(this, t);
				};
			}
			function Al(e) {
				return yl(2, e);
			}
			var jl = Na(function(e, t) {
				t = t.length == 1 && J(t[0]) ? R(t[0], z(q())) : R(W(t, 1), z(q()));
				var n = t.length;
				return K(function(r) {
					for (var i = -1, a = F(r.length, n); ++i < a;) r[i] = t[i].call(this, r[i]);
					return fn(e, this, r);
				});
			}), Ml = K(function(e, t) {
				return bo(e, u, n, t, tr(t, Mo(Ml)));
			}), Nl = K(function(e, t) {
				return bo(e, d, n, t, tr(t, Mo(Nl)));
			}), Pl = Do(function(e, t) {
				return bo(e, p, n, n, n, t);
			});
			function Fl(e, t) {
				if (typeof e != "function") throw new dt(r);
				return t = t === n ? t : Q(t), K(e, t);
			}
			function Il(e, t) {
				if (typeof e != "function") throw new dt(r);
				return t = t == null ? 0 : M(Q(t), 0), K(function(n) {
					var r = n[t], i = Pa(n, 0, t);
					return r && bn(i, r), fn(e, this, i);
				});
			}
			function Ll(e, t, n) {
				var i = !0, a = !0;
				if (typeof e != "function") throw new dt(r);
				return X(n) && (i = "leading" in n ? !!n.leading : i, a = "trailing" in n ? !!n.trailing : a), wl(e, t, {
					leading: i,
					maxWait: t,
					trailing: a
				});
			}
			function Rl(e) {
				return vl(e, 1);
			}
			function zl(e, t) {
				return Ml(ja(t), e);
			}
			function Bl() {
				if (!arguments.length) return [];
				var e = arguments[0];
				return J(e) ? e : [e];
			}
			function Vl(e) {
				return li(e, 4);
			}
			function Hl(e, t) {
				return t = typeof t == "function" ? t : n, li(e, 4, t);
			}
			function Ul(e) {
				return li(e, 5);
			}
			function Wl(e, t) {
				return t = typeof t == "function" ? t : n, li(e, 5, t);
			}
			function Gl(e, t) {
				return t == null || di(e, t, id(t));
			}
			function Kl(e, t) {
				return e === t || e !== e && t !== t;
			}
			var ql = ho(Di), Jl = ho(function(e, t) {
				return e >= t;
			}), Yl = Pi(function() {
				return arguments;
			}()) ? Pi : function(e) {
				return Z(e) && j.call(e, "callee") && !Ot.call(e, "callee");
			}, J = D.isArray, Xl = on ? z(on) : Fi;
			function Zl(e) {
				return e != null && lu(e.length) && !su(e);
			}
			function Y(e) {
				return Z(e) && Zl(e);
			}
			function Ql(e) {
				return e === !0 || e === !1 || Z(e) && Ei(e) == ne;
			}
			var $l = Bt || jf, eu = sn ? z(sn) : Ii;
			function tu(e) {
				return Z(e) && e.nodeType === 1 && !vu(e);
			}
			function nu(e) {
				if (e == null) return !0;
				if (Zl(e) && (J(e) || typeof e == "string" || typeof e.splice == "function" || $l(e) || wu(e) || Yl(e))) return !e.length;
				var t = zo(e);
				if (t == se || t == me) return !e.size;
				if (ts(e)) return !Ki(e).length;
				for (var n in e) if (j.call(e, n)) return !1;
				return !0;
			}
			function ru(e, t) {
				return Li(e, t);
			}
			function iu(e, t, r) {
				r = typeof r == "function" ? r : n;
				var i = r ? r(e, t) : n;
				return i === n ? Li(e, t, n, r) : !!i;
			}
			function au(e) {
				if (!Z(e)) return !1;
				var t = Ei(e);
				return t == ie || t == re || typeof e.message == "string" && typeof e.name == "string" && !vu(e);
			}
			function ou(e) {
				return typeof e == "number" && Ut(e);
			}
			function su(e) {
				if (!X(e)) return !1;
				var t = Ei(e);
				return t == ae || t == oe || t == te || t == fe;
			}
			function cu(e) {
				return typeof e == "number" && e == Q(e);
			}
			function lu(e) {
				return typeof e == "number" && e > -1 && e % 1 == 0 && e <= g;
			}
			function X(e) {
				var t = typeof e;
				return e != null && (t == "object" || t == "function");
			}
			function Z(e) {
				return typeof e == "object" && !!e;
			}
			var uu = cn ? z(cn) : zi;
			function du(e, t) {
				return e === t || Bi(e, t, Po(t));
			}
			function fu(e, t, r) {
				return r = typeof r == "function" ? r : n, Bi(e, t, Po(t), r);
			}
			function pu(e) {
				return _u(e) && e != +e;
			}
			function mu(e) {
				if (es(e)) throw new ot("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
				return Vi(e);
			}
			function hu(e) {
				return e === null;
			}
			function gu(e) {
				return e == null;
			}
			function _u(e) {
				return typeof e == "number" || Z(e) && Ei(e) == ce;
			}
			function vu(e) {
				if (!Z(e) || Ei(e) != ue) return !1;
				var t = Et(e);
				if (t === null) return !0;
				var n = j.call(t, "constructor") && t.constructor;
				return typeof n == "function" && n instanceof n && ht.call(n) == yt;
			}
			var yu = ln ? z(ln) : Hi;
			function bu(e) {
				return cu(e) && e >= -g && e <= g;
			}
			var xu = un ? z(un) : Ui;
			function Su(e) {
				return typeof e == "string" || !J(e) && Z(e) && Ei(e) == he;
			}
			function Cu(e) {
				return typeof e == "symbol" || Z(e) && Ei(e) == ge;
			}
			var wu = dn ? z(dn) : Wi;
			function Tu(e) {
				return e === n;
			}
			function Eu(e) {
				return Z(e) && zo(e) == ve;
			}
			function Du(e) {
				return Z(e) && Ei(e) == ye;
			}
			var Ou = ho(Ji), ku = ho(function(e, t) {
				return e <= t;
			});
			function Au(e) {
				if (!e) return [];
				if (Zl(e)) return Su(e) ? sr(e) : Ka(e);
				if (jt && e[jt]) return Qn(e[jt]());
				var t = zo(e);
				return (t == se ? $n : t == me ? nr : Cd)(e);
			}
			function ju(e) {
				return e ? (e = Nu(e), e === h || e === -Infinity ? (e < 0 ? -1 : 1) * _ : e === e ? e : 0) : e === 0 ? e : 0;
			}
			function Q(e) {
				var t = ju(e), n = t % 1;
				return t === t ? n ? t - n : t : 0;
			}
			function Mu(e) {
				return e ? ci(Q(e), 0, y) : 0;
			}
			function Nu(e) {
				if (typeof e == "number") return e;
				if (Cu(e)) return v;
				if (X(e)) {
					var t = typeof e.valueOf == "function" ? e.valueOf() : e;
					e = X(t) ? t + "" : t;
				}
				if (typeof e != "string") return e === 0 ? e : +e;
				e = Bn(e);
				var n = $e.test(e);
				return n || tt.test(e) ? Qt(e.slice(2), n ? 2 : 8) : Qe.test(e) ? v : +e;
			}
			function Pu(e) {
				return qa(e, ad(e));
			}
			function Fu(e) {
				return e ? ci(Q(e), -g, g) : e === 0 ? e : 0;
			}
			function $(e) {
				return e == null ? "" : Sa(e);
			}
			var Iu = Za(function(e, t) {
				if (ts(t) || Zl(t)) {
					qa(t, id(t), e);
					return;
				}
				for (var n in t) j.call(t, n) && ti(e, n, t[n]);
			}), Lu = Za(function(e, t) {
				qa(t, ad(t), e);
			}), Ru = Za(function(e, t, n, r) {
				qa(t, ad(t), e, r);
			}), zu = Za(function(e, t, n, r) {
				qa(t, id(t), e, r);
			}), Bu = Do(si);
			function Vu(e, t) {
				var n = yr(e);
				return t == null ? n : ii(n, t);
			}
			var Hu = K(function(e, t) {
				e = k(e);
				var r = -1, i = t.length, a = i > 2 ? t[2] : n;
				for (a && Yo(t[0], t[1], a) && (i = 1); ++r < i;) for (var o = t[r], s = ad(o), c = -1, l = s.length; ++c < l;) {
					var u = s[c], d = e[u];
					(d === n || Kl(d, A[u]) && !j.call(e, u)) && (e[u] = o[u]);
				}
				return e;
			}), Uu = K(function(e) {
				return e.push(n, So), fn(ld, n, e);
			});
			function Wu(e, t) {
				return Dn(e, q(t, 3), Si);
			}
			function Gu(e, t) {
				return Dn(e, q(t, 3), Ci);
			}
			function Ku(e, t) {
				return e == null ? e : bi(e, q(t, 3), ad);
			}
			function qu(e, t) {
				return e == null ? e : xi(e, q(t, 3), ad);
			}
			function Ju(e, t) {
				return e && Si(e, q(t, 3));
			}
			function Yu(e, t) {
				return e && Ci(e, q(t, 3));
			}
			function Xu(e) {
				return e == null ? [] : G(e, id(e));
			}
			function Zu(e) {
				return e == null ? [] : G(e, ad(e));
			}
			function Qu(e, t, r) {
				var i = e == null ? n : wi(e, t);
				return i === n ? r : i;
			}
			function $u(e, t) {
				return e != null && Ho(e, t, Oi);
			}
			function ed(e, t) {
				return e != null && Ho(e, t, ki);
			}
			var td = co(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = vt.call(t)), e[t] = n;
			}, lf(pf)), nd = co(function(e, t, n) {
				t != null && typeof t.toString != "function" && (t = vt.call(t)), j.call(e, t) ? e[t].push(n) : e[t] = [n];
			}, q), rd = K(Ni);
			function id(e) {
				return Zl(e) ? Xr(e) : Ki(e);
			}
			function ad(e) {
				return Zl(e) ? Xr(e, !0) : qi(e);
			}
			function od(e, t) {
				var n = {};
				return t = q(t, 3), Si(e, function(e, r, i) {
					oi(n, t(e, r, i), e);
				}), n;
			}
			function sd(e, t) {
				var n = {};
				return t = q(t, 3), Si(e, function(e, r, i) {
					oi(n, r, t(e, r, i));
				}), n;
			}
			var cd = Za(function(e, t, n) {
				Qi(e, t, n);
			}), ld = Za(function(e, t, n, r) {
				Qi(e, t, n, r);
			}), ud = Do(function(e, t) {
				var n = {};
				if (e == null) return n;
				var r = !1;
				t = R(t, function(t) {
					return t = Ma(t, e), r ||= t.length > 1, t;
				}), qa(e, ko(e), n), r && (n = li(n, 7, Co));
				for (var i = t.length; i--;) wa(n, t[i]);
				return n;
			});
			function dd(e, t) {
				return pd(e, kl(q(t)));
			}
			var fd = Do(function(e, t) {
				return e == null ? {} : na(e, t);
			});
			function pd(e, t) {
				if (e == null) return {};
				var n = R(ko(e), function(e) {
					return [e];
				});
				return t = q(t), ra(e, n, function(e, n) {
					return t(e, n[0]);
				});
			}
			function md(e, t, r) {
				t = Ma(t, e);
				var i = -1, a = t.length;
				for (a || (a = 1, e = n); ++i < a;) {
					var o = e == null ? n : e[ys(t[i])];
					o === n && (i = a, o = r), e = su(o) ? o.call(e) : o;
				}
				return e;
			}
			function hd(e, t, n) {
				return e == null ? e : fa(e, t, n);
			}
			function gd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : fa(e, t, r, i);
			}
			var _d = yo(id), vd = yo(ad);
			function yd(e, t, n) {
				var r = J(e), i = r || $l(e) || wu(e);
				if (t = q(t, 4), n == null) {
					var a = e && e.constructor;
					n = i ? r ? new a() : [] : X(e) && su(a) ? yr(Et(e)) : {};
				}
				return (i ? mn : Si)(e, function(e, r, i) {
					return t(n, e, r, i);
				}), n;
			}
			function bd(e, t) {
				return e == null || wa(e, t);
			}
			function xd(e, t, n) {
				return e == null ? e : Ta(e, t, ja(n));
			}
			function Sd(e, t, r, i) {
				return i = typeof i == "function" ? i : n, e == null ? e : Ta(e, t, ja(r), i);
			}
			function Cd(e) {
				return e == null ? [] : Vn(e, id(e));
			}
			function wd(e) {
				return e == null ? [] : Vn(e, ad(e));
			}
			function Td(e, t, r) {
				return r === n && (r = t, t = n), r !== n && (r = Nu(r), r = r === r ? r : 0), t !== n && (t = Nu(t), t = t === t ? t : 0), ci(Nu(e), t, r);
			}
			function Ed(e, t, r) {
				return t = ju(t), r === n ? (r = t, t = 0) : r = ju(r), e = Nu(e), Ai(e, t, r);
			}
			function Dd(e, t, r) {
				if (r && typeof r != "boolean" && Yo(e, t, r) && (t = r = n), r === n && (typeof t == "boolean" ? (r = t, t = n) : typeof e == "boolean" && (r = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = ju(e), t === n ? (t = e, e = 0) : t = ju(t)), e > t) {
					var i = e;
					e = t, t = i;
				}
				if (r || e % 1 || t % 1) {
					var a = Xt();
					return F(e + a * (t - e + Zt("1e-" + ((a + "").length - 1))), t);
				}
				return sa(e, t);
			}
			var Od = no(function(e, t, n) {
				return t = t.toLowerCase(), e + (n ? kd(t) : t);
			});
			function kd(e) {
				return nf($(e).toLowerCase());
			}
			function Ad(e) {
				return e = $(e), e && e.replace(rt, Kn).replace(Ht, "");
			}
			function jd(e, t, r) {
				e = $(e), t = Sa(t);
				var i = e.length;
				r = r === n ? i : ci(Q(r), 0, i);
				var a = r;
				return r -= t.length, r >= 0 && e.slice(r, a) == t;
			}
			function Md(e) {
				return e = $(e), e && Fe.test(e) ? e.replace(Ne, qn) : e;
			}
			function Nd(e) {
				return e = $(e), e && Ue.test(e) ? e.replace(He, "\\$&") : e;
			}
			var Pd = no(function(e, t, n) {
				return e + (n ? "-" : "") + t.toLowerCase();
			}), Fd = no(function(e, t, n) {
				return e + (n ? " " : "") + t.toLowerCase();
			}), Id = to("toLowerCase");
			function Ld(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? or(e) : 0;
				if (!t || r >= t) return e;
				var i = (t - r) / 2;
				return fo(Rt(i), n) + e + fo(Lt(i), n);
			}
			function Rd(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? or(e) : 0;
				return t && r < t ? e + fo(t - r, n) : e;
			}
			function zd(e, t, n) {
				e = $(e), t = Q(t);
				var r = t ? or(e) : 0;
				return t && r < t ? fo(t - r, n) + e : e;
			}
			function Bd(e, t, n) {
				return n || t == null ? t = 0 : t &&= +t, Yt($(e).replace(We, ""), t || 0);
			}
			function Vd(e, t, r) {
				return t = (r ? Yo(e, t, r) : t === n) ? 1 : Q(t), la($(e), t);
			}
			function Hd() {
				var e = arguments, t = $(e[0]);
				return e.length < 3 ? t : t.replace(e[1], e[2]);
			}
			var Ud = no(function(e, t, n) {
				return e + (n ? "_" : "") + t.toLowerCase();
			});
			function Wd(e, t, r) {
				return r && typeof r != "number" && Yo(e, t, r) && (t = r = n), r = r === n ? y : r >>> 0, r ? (e = $(e), e && (typeof t == "string" || t != null && !yu(t)) && (t = Sa(t), !t && Xn(e)) ? Pa(sr(e), 0, r) : e.split(t, r)) : [];
			}
			var Gd = no(function(e, t, n) {
				return e + (n ? " " : "") + nf(t);
			});
			function Kd(e, t, n) {
				return e = $(e), n = n == null ? 0 : ci(Q(n), 0, e.length), t = Sa(t), e.slice(n, n + t.length) == t;
			}
			function qd(e, t, r) {
				var i = B.templateSettings;
				r && Yo(e, t, r) && (t = n), e = $(e), t = zu({}, t, i, xo);
				var a = zu({}, t.imports, i.imports, xo), o = id(a), s = Vn(a, o);
				mn(o, function(e) {
					if (Ye.test(e)) throw new ot("Invalid `imports` option passed into `_.template`");
				});
				var c, l, u = 0, d = t.interpolate || it, f = "__p += '", p = lt((t.escape || it).source + "|" + d.source + "|" + (d === Re ? Xe : it).source + "|" + (t.evaluate || it).source + "|$", "g"), m = "//# sourceURL=" + (j.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++qt + "]") + "\n";
				e.replace(p, function(t, n, r, i, a, o) {
					return r ||= i, f += e.slice(u, o).replace(at, Jn), n && (c = !0, f += "' +\n__e(" + n + ") +\n'"), a && (l = !0, f += "';\n" + a + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), u = o + t.length, t;
				}), f += "';\n";
				var h = j.call(t, "variable") && t.variable;
				if (!h) f = "with (obj) {\n" + f + "\n}\n";
				else if (Ye.test(h)) throw new ot("Invalid `variable` option passed into `_.template`");
				f = (l ? f.replace(ke, "") : f).replace(Ae, "$1").replace(je, "$1;"), f = "function(" + (h || "obj") + ") {\n" + (h ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
				var g = af(function() {
					return st(o, m + "return " + f).apply(n, s);
				});
				if (g.source = f, au(g)) throw g;
				return g;
			}
			function Jd(e) {
				return $(e).toLowerCase();
			}
			function Yd(e) {
				return $(e).toUpperCase();
			}
			function Xd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return Bn(e);
				if (!e || !(t = Sa(t))) return e;
				var i = sr(e), a = sr(t);
				return Pa(i, Un(i, a), Wn(i, a) + 1).join("");
			}
			function Zd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return e.slice(0, cr(e) + 1);
				if (!e || !(t = Sa(t))) return e;
				var i = sr(e);
				return Pa(i, 0, Wn(i, sr(t)) + 1).join("");
			}
			function Qd(e, t, r) {
				if (e = $(e), e && (r || t === n)) return e.replace(We, "");
				if (!e || !(t = Sa(t))) return e;
				var i = sr(e);
				return Pa(i, Un(i, sr(t))).join("");
			}
			function $d(e, t) {
				var r = 30, i = "...";
				if (X(t)) {
					var a = "separator" in t ? t.separator : a;
					r = "length" in t ? Q(t.length) : r, i = "omission" in t ? Sa(t.omission) : i;
				}
				e = $(e);
				var o = e.length;
				if (Xn(e)) {
					var s = sr(e);
					o = s.length;
				}
				if (r >= o) return e;
				var c = r - or(i);
				if (c < 1) return i;
				var l = s ? Pa(s, 0, c).join("") : e.slice(0, c);
				if (a === n) return l + i;
				if (s && (c += l.length - c), yu(a)) {
					if (e.slice(c).search(a)) {
						var u, d = l;
						for (a.global || (a = lt(a.source, $(Ze.exec(a)) + "g")), a.lastIndex = 0; u = a.exec(d);) var f = u.index;
						l = l.slice(0, f === n ? c : f);
					}
				} else if (e.indexOf(Sa(a), c) != c) {
					var p = l.lastIndexOf(a);
					p > -1 && (l = l.slice(0, p));
				}
				return l + i;
			}
			function ef(e) {
				return e = $(e), e && Pe.test(e) ? e.replace(Me, lr) : e;
			}
			var tf = no(function(e, t, n) {
				return e + (n ? " " : "") + t.toUpperCase();
			}), nf = to("toUpperCase");
			function rf(e, t, r) {
				return e = $(e), t = r ? n : t, t === n ? Zn(e) ? fr(e) : En(e) : e.match(t) || [];
			}
			var af = K(function(e, t) {
				try {
					return fn(e, n, t);
				} catch (e) {
					return au(e) ? e : new ot(e);
				}
			}), of = Do(function(e, t) {
				return mn(t, function(t) {
					t = ys(t), oi(e, t, bl(e[t], e));
				}), e;
			});
			function sf(e) {
				var t = e == null ? 0 : e.length, n = q();
				return e = t ? R(e, function(e) {
					if (typeof e[1] != "function") throw new dt(r);
					return [n(e[0]), e[1]];
				}) : [], K(function(n) {
					for (var r = -1; ++r < t;) {
						var i = e[r];
						if (fn(i[0], this, n)) return fn(i[1], this, n);
					}
				});
			}
			function cf(e) {
				return ui(li(e, 1));
			}
			function lf(e) {
				return function() {
					return e;
				};
			}
			function uf(e, t) {
				return e == null || e !== e ? t : e;
			}
			var df = oo(), ff = oo(!0);
			function pf(e) {
				return e;
			}
			function mf(e) {
				return Gi(typeof e == "function" ? e : li(e, 1));
			}
			function hf(e) {
				return Xi(li(e, 1));
			}
			function gf(e, t) {
				return Zi(e, li(t, 1));
			}
			var _f = K(function(e, t) {
				return function(n) {
					return Ni(n, e, t);
				};
			}), vf = K(function(e, t) {
				return function(n) {
					return Ni(e, n, t);
				};
			});
			function yf(e, t, n) {
				var r = id(t), i = G(t, r);
				n == null && (!X(t) || !i.length && r.length) && (n = t, t = e, e = this, i = G(t, id(t)));
				var a = !(X(n) && "chain" in n) || !!n.chain, o = su(e);
				return mn(i, function(n) {
					var r = t[n];
					e[n] = r, o && (e.prototype[n] = function() {
						var t = this.__chain__;
						if (a || t) {
							var n = e(this.__wrapped__);
							return (n.__actions__ = Ka(this.__actions__)).push({
								func: r,
								args: arguments,
								thisArg: e
							}), n.__chain__ = t, n;
						}
						return r.apply(e, bn([this.value()], arguments));
					});
				}), e;
			}
			function bf() {
				return I._ === this && (I._ = bt), this;
			}
			function xf() {}
			function Sf(e) {
				return e = Q(e), K(function(t) {
					return ea(t, e);
				});
			}
			var Cf = uo(R), wf = uo(gn), Tf = uo(Cn);
			function Ef(e) {
				return Xo(e) ? Nn(ys(e)) : ia(e);
			}
			function Df(e) {
				return function(t) {
					return e == null ? n : wi(e, t);
				};
			}
			var Of = mo(), kf = mo(!0);
			function Af() {
				return [];
			}
			function jf() {
				return !1;
			}
			function Mf() {
				return {};
			}
			function Nf() {
				return "";
			}
			function Pf() {
				return !0;
			}
			function Ff(e, t) {
				if (e = Q(e), e < 1 || e > g) return [];
				var n = y, r = F(e, y);
				t = q(t), e -= y;
				for (var i = Rn(r, t); ++n < e;) t(n);
				return i;
			}
			function If(e) {
				return J(e) ? R(e, ys) : Cu(e) ? [e] : Ka(vs($(e)));
			}
			function Lf(e) {
				var t = ++gt;
				return $(e) + t;
			}
			var Rf = lo(function(e, t) {
				return e + t;
			}, 0), zf = _o("ceil"), Bf = lo(function(e, t) {
				return e / t;
			}, 1), Vf = _o("floor");
			function Hf(e) {
				return e && e.length ? _i(e, pf, Di) : n;
			}
			function Uf(e, t) {
				return e && e.length ? _i(e, q(t, 2), Di) : n;
			}
			function Wf(e) {
				return Mn(e, pf);
			}
			function Gf(e, t) {
				return Mn(e, q(t, 2));
			}
			function Kf(e) {
				return e && e.length ? _i(e, pf, Ji) : n;
			}
			function qf(e, t) {
				return e && e.length ? _i(e, q(t, 2), Ji) : n;
			}
			var Jf = lo(function(e, t) {
				return e * t;
			}, 1), Yf = _o("round"), Xf = lo(function(e, t) {
				return e - t;
			}, 0);
			function Zf(e) {
				return e && e.length ? Ln(e, pf) : 0;
			}
			function Qf(e, t) {
				return e && e.length ? Ln(e, q(t, 2)) : 0;
			}
			return B.after = _l, B.ary = vl, B.assign = Iu, B.assignIn = Lu, B.assignInWith = Ru, B.assignWith = zu, B.at = Bu, B.before = yl, B.bind = bl, B.bindAll = of, B.bindKey = xl, B.castArray = Bl, B.chain = Nc, B.chunk = Cs, B.compact = ws, B.concat = Ts, B.cond = sf, B.conforms = cf, B.constant = lf, B.countBy = Wc, B.create = Vu, B.curry = Sl, B.curryRight = Cl, B.debounce = wl, B.defaults = Hu, B.defaultsDeep = Uu, B.defer = Tl, B.delay = El, B.difference = Es, B.differenceBy = Ds, B.differenceWith = Os, B.drop = ks, B.dropRight = As, B.dropRightWhile = js, B.dropWhile = Ms, B.fill = Ns, B.filter = Kc, B.flatMap = Yc, B.flatMapDeep = Xc, B.flatMapDepth = Zc, B.flatten = Is, B.flattenDeep = Ls, B.flattenDepth = Rs, B.flip = Dl, B.flow = df, B.flowRight = ff, B.fromPairs = zs, B.functions = Xu, B.functionsIn = Zu, B.groupBy = el, B.initial = Hs, B.intersection = Us, B.intersectionBy = Ws, B.intersectionWith = Gs, B.invert = td, B.invertBy = nd, B.invokeMap = nl, B.iteratee = mf, B.keyBy = rl, B.keys = id, B.keysIn = ad, B.map = il, B.mapKeys = od, B.mapValues = sd, B.matches = hf, B.matchesProperty = gf, B.memoize = Ol, B.merge = cd, B.mergeWith = ld, B.method = _f, B.methodOf = vf, B.mixin = yf, B.negate = kl, B.nthArg = Sf, B.omit = ud, B.omitBy = dd, B.once = Al, B.orderBy = al, B.over = Cf, B.overArgs = jl, B.overEvery = wf, B.overSome = Tf, B.partial = Ml, B.partialRight = Nl, B.partition = ol, B.pick = fd, B.pickBy = pd, B.property = Ef, B.propertyOf = Df, B.pull = Xs, B.pullAll = Zs, B.pullAllBy = Qs, B.pullAllWith = $s, B.pullAt = ec, B.range = Of, B.rangeRight = kf, B.rearg = Pl, B.reject = ll, B.remove = tc, B.rest = Fl, B.reverse = nc, B.sampleSize = dl, B.set = hd, B.setWith = gd, B.shuffle = fl, B.slice = rc, B.sortBy = hl, B.sortedUniq = uc, B.sortedUniqBy = dc, B.split = Wd, B.spread = Il, B.tail = fc, B.take = pc, B.takeRight = mc, B.takeRightWhile = hc, B.takeWhile = gc, B.tap = Pc, B.throttle = Ll, B.thru = Fc, B.toArray = Au, B.toPairs = _d, B.toPairsIn = vd, B.toPath = If, B.toPlainObject = Pu, B.transform = yd, B.unary = Rl, B.union = _c, B.unionBy = vc, B.unionWith = yc, B.uniq = bc, B.uniqBy = xc, B.uniqWith = Sc, B.unset = bd, B.unzip = Cc, B.unzipWith = wc, B.update = xd, B.updateWith = Sd, B.values = Cd, B.valuesIn = wd, B.without = Tc, B.words = rf, B.wrap = zl, B.xor = Ec, B.xorBy = Dc, B.xorWith = Oc, B.zip = kc, B.zipObject = Ac, B.zipObjectDeep = jc, B.zipWith = Mc, B.entries = _d, B.entriesIn = vd, B.extend = Lu, B.extendWith = Ru, yf(B, B), B.add = Rf, B.attempt = af, B.camelCase = Od, B.capitalize = kd, B.ceil = zf, B.clamp = Td, B.clone = Vl, B.cloneDeep = Ul, B.cloneDeepWith = Wl, B.cloneWith = Hl, B.conformsTo = Gl, B.deburr = Ad, B.defaultTo = uf, B.divide = Bf, B.endsWith = jd, B.eq = Kl, B.escape = Md, B.escapeRegExp = Nd, B.every = Gc, B.find = qc, B.findIndex = Ps, B.findKey = Wu, B.findLast = Jc, B.findLastIndex = Fs, B.findLastKey = Gu, B.floor = Vf, B.forEach = Qc, B.forEachRight = $c, B.forIn = Ku, B.forInRight = qu, B.forOwn = Ju, B.forOwnRight = Yu, B.get = Qu, B.gt = ql, B.gte = Jl, B.has = $u, B.hasIn = ed, B.head = Bs, B.identity = pf, B.includes = tl, B.indexOf = Vs, B.inRange = Ed, B.invoke = rd, B.isArguments = Yl, B.isArray = J, B.isArrayBuffer = Xl, B.isArrayLike = Zl, B.isArrayLikeObject = Y, B.isBoolean = Ql, B.isBuffer = $l, B.isDate = eu, B.isElement = tu, B.isEmpty = nu, B.isEqual = ru, B.isEqualWith = iu, B.isError = au, B.isFinite = ou, B.isFunction = su, B.isInteger = cu, B.isLength = lu, B.isMap = uu, B.isMatch = du, B.isMatchWith = fu, B.isNaN = pu, B.isNative = mu, B.isNil = gu, B.isNull = hu, B.isNumber = _u, B.isObject = X, B.isObjectLike = Z, B.isPlainObject = vu, B.isRegExp = yu, B.isSafeInteger = bu, B.isSet = xu, B.isString = Su, B.isSymbol = Cu, B.isTypedArray = wu, B.isUndefined = Tu, B.isWeakMap = Eu, B.isWeakSet = Du, B.join = Ks, B.kebabCase = Pd, B.last = qs, B.lastIndexOf = Js, B.lowerCase = Fd, B.lowerFirst = Id, B.lt = Ou, B.lte = ku, B.max = Hf, B.maxBy = Uf, B.mean = Wf, B.meanBy = Gf, B.min = Kf, B.minBy = qf, B.stubArray = Af, B.stubFalse = jf, B.stubObject = Mf, B.stubString = Nf, B.stubTrue = Pf, B.multiply = Jf, B.nth = Ys, B.noConflict = bf, B.noop = xf, B.now = gl, B.pad = Ld, B.padEnd = Rd, B.padStart = zd, B.parseInt = Bd, B.random = Dd, B.reduce = sl, B.reduceRight = cl, B.repeat = Vd, B.replace = Hd, B.result = md, B.round = Yf, B.runInContext = e, B.sample = ul, B.size = pl, B.snakeCase = Ud, B.some = ml, B.sortedIndex = ic, B.sortedIndexBy = ac, B.sortedIndexOf = oc, B.sortedLastIndex = sc, B.sortedLastIndexBy = cc, B.sortedLastIndexOf = lc, B.startCase = Gd, B.startsWith = Kd, B.subtract = Xf, B.sum = Zf, B.sumBy = Qf, B.template = qd, B.times = Ff, B.toFinite = ju, B.toInteger = Q, B.toLength = Mu, B.toLower = Jd, B.toNumber = Nu, B.toSafeInteger = Fu, B.toString = $, B.toUpper = Yd, B.trim = Xd, B.trimEnd = Zd, B.trimStart = Qd, B.truncate = $d, B.unescape = ef, B.uniqueId = Lf, B.upperCase = tf, B.upperFirst = nf, B.each = Qc, B.eachRight = $c, B.first = Bs, yf(B, function() {
				var e = {};
				return Si(B, function(t, n) {
					j.call(B.prototype, n) || (e[n] = t);
				}), e;
			}(), { chain: !1 }), B.VERSION = "4.18.1", mn([
				"bind",
				"bindKey",
				"curry",
				"curryRight",
				"partial",
				"partialRight"
			], function(e) {
				B[e].placeholder = B;
			}), mn(["drop", "take"], function(e, t) {
				H.prototype[e] = function(r) {
					r = r === n ? 1 : M(Q(r), 0);
					var i = this.__filtered__ && !t ? new H(this) : this.clone();
					return i.__filtered__ ? i.__takeCount__ = F(r, i.__takeCount__) : i.__views__.push({
						size: F(r, y),
						type: e + (i.__dir__ < 0 ? "Right" : "")
					}), i;
				}, H.prototype[e + "Right"] = function(t) {
					return this.reverse()[e](t).reverse();
				};
			}), mn([
				"filter",
				"map",
				"takeWhile"
			], function(e, t) {
				var n = t + 1, r = n == 1 || n == 3;
				H.prototype[e] = function(e) {
					var t = this.clone();
					return t.__iteratees__.push({
						iteratee: q(e, 3),
						type: n
					}), t.__filtered__ = t.__filtered__ || r, t;
				};
			}), mn(["head", "last"], function(e, t) {
				var n = "take" + (t ? "Right" : "");
				H.prototype[e] = function() {
					return this[n](1).value()[0];
				};
			}), mn(["initial", "tail"], function(e, t) {
				var n = "drop" + (t ? "" : "Right");
				H.prototype[e] = function() {
					return this.__filtered__ ? new H(this) : this[n](1);
				};
			}), H.prototype.compact = function() {
				return this.filter(pf);
			}, H.prototype.find = function(e) {
				return this.filter(e).head();
			}, H.prototype.findLast = function(e) {
				return this.reverse().find(e);
			}, H.prototype.invokeMap = K(function(e, t) {
				return typeof e == "function" ? new H(this) : this.map(function(n) {
					return Ni(n, e, t);
				});
			}), H.prototype.reject = function(e) {
				return this.filter(kl(q(e)));
			}, H.prototype.slice = function(e, t) {
				e = Q(e);
				var r = this;
				return r.__filtered__ && (e > 0 || t < 0) ? new H(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== n && (t = Q(t), r = t < 0 ? r.dropRight(-t) : r.take(t - e)), r);
			}, H.prototype.takeRightWhile = function(e) {
				return this.reverse().takeWhile(e).reverse();
			}, H.prototype.toArray = function() {
				return this.take(y);
			}, Si(H.prototype, function(e, t) {
				var r = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), a = B[i ? "take" + (t == "last" ? "Right" : "") : t], o = i || /^find/.test(t);
				a && (B.prototype[t] = function() {
					var t = this.__wrapped__, s = i ? [1] : arguments, c = t instanceof H, l = s[0], u = c || J(t), d = function(e) {
						var t = a.apply(B, bn([e], s));
						return i && f ? t[0] : t;
					};
					u && r && typeof l == "function" && l.length != 1 && (c = u = !1);
					var f = this.__chain__, p = !!this.__actions__.length, m = o && !f, h = c && !p;
					if (!o && u) {
						t = h ? t : new H(this);
						var g = e.apply(t, s);
						return g.__actions__.push({
							func: Fc,
							args: [d],
							thisArg: n
						}), new V(g, f);
					}
					return m && h ? e.apply(this, s) : (g = this.thru(d), m ? i ? g.value()[0] : g.value() : g);
				});
			}), mn([
				"pop",
				"push",
				"shift",
				"sort",
				"splice",
				"unshift"
			], function(e) {
				var t = ft[e], n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(e);
				B.prototype[e] = function() {
					var e = arguments;
					if (r && !this.__chain__) {
						var i = this.value();
						return t.apply(J(i) ? i : [], e);
					}
					return this[n](function(n) {
						return t.apply(J(n) ? n : [], e);
					});
				};
			}), Si(H.prototype, function(e, t) {
				var n = B[t];
				if (n) {
					var r = n.name + "";
					j.call(Pn, r) || (Pn[r] = []), Pn[r].push({
						name: t,
						func: n
					});
				}
			}), Pn[so(n, s).name] = [{
				name: "wrapper",
				func: n
			}], H.prototype.clone = xr, H.prototype.reverse = Sr, H.prototype.value = Cr, B.prototype.at = Ic, B.prototype.chain = Lc, B.prototype.commit = Rc, B.prototype.next = zc, B.prototype.plant = Vc, B.prototype.reverse = Hc, B.prototype.toJSON = B.prototype.valueOf = B.prototype.value = Uc, B.prototype.first = B.prototype.head, jt && (B.prototype[jt] = Bc), B;
		})();
		typeof define == "function" && typeof define.amd == "object" && define.amd ? (I._ = pr, define(function() {
			return pr;
		})) : nn ? ((nn.exports = pr)._ = pr, tn._ = pr) : I._ = pr;
	}).call(e);
})))(), Dl = document.createElement("input"), Ol = class extends p {
	constructor() {
		super(), this.name = "teia-request", this.type = "dev", this._viewer = null, this._filterInput = null, this._fieldSelectionRulesInput = null, this._loadButton = null, this._availableTwins = {
			Master: /* @__PURE__ */ new Map(),
			Draft: /* @__PURE__ */ new Map()
		}, this._twinNameSelector = null, this._twinTypeSelector = null, this._twinIdLabel = null, this._availableModels = /* @__PURE__ */ new Map(), this._projectNameSelector = null, this._modelNameSelector = null, this._modelInfoLabels = [], this._params = {
			twin: {
				name: "",
				type: "Draft",
				id: 0,
				onlySetSource: !1,
				filter: !1,
				fields: !1,
				geometryType: "Original",
				axis: new A(0, 1, 0),
				endpoint: "objects",
				filter_types: "",
				field_selection_rules: ""
			},
			file: {
				projectName: "",
				name: "",
				modelId: 0,
				version: 0,
				projectId: 0
			},
			custom: {
				url: "",
				geometryType: "3D"
			},
			local: { geometryType: "3D" }
		}, this._folder = null, this._drawTwinTab = (e) => {
			this._twinNameSelector = e.addBinding(this._params.twin, "name", { options: [] }).on("change", this._onTwinNameSelectorChanged), this._twinTypeSelector = e.addBinding(this._params.twin, "type", { options: [] }).on("change", this._onTwinTypeSelectorChanged), this._twinIdLabel = e.addBinding(this._params.twin, "id", {
				readonly: !0,
				format: (e) => e.toFixed(0)
			}), e.addBinding(this._params.twin, "endpoint", { options: {
				objects: "objects",
				equipments: "equipments"
			} }), e.addBinding(this._params.twin, "geometryType", { options: {
				Original: "Original",
				"3D": "3D",
				"2D": "2D"
			} }), e.addBinding(this._params.twin, "axis", {
				label: "Projection axis",
				x: { step: .1 },
				y: { step: .1 },
				z: { step: .1 }
			}), e.addBinding(this._params.twin, "onlySetSource"), e.addBinding(this._params.twin, "filter").on("change", this._onFilterTwin), this._filterInput = e.addBinding(this._params.twin, "filter_types"), this._filterInput.hidden = !this._params.twin.filter, e.addBinding(this._params.twin, "fields").on("change", this._onFieldsTwin), this._fieldSelectionRulesInput = e.addBinding(this._params.twin, "field_selection_rules"), this._fieldSelectionRulesInput.hidden = !this._params.twin.fields, e.refresh();
		}, this._drawFileTab = (e) => {
			this._projectNameSelector = e.addBinding(this._params.file, "projectName", { options: [] }).on("change", this._updateModelNameSelector), this._modelNameSelector = e.addBinding(this._params.file, "name", { options: [] }).on("change", this._updateModelInfoLabels);
			let t = [
				"modelId",
				"version",
				"projectId"
			];
			this._modelInfoLabels = t.map((t) => e.addBinding(this._params.file, t, {
				readonly: !0,
				format: (e) => e.toFixed(0)
			}));
		}, this._drawLocalFileTab = (e) => {
			e.addBinding(this._params.local, "geometryType", { options: {
				"3D": "3D",
				"2D": "2D"
			} });
		}, this._drawCustomUrlTab = (e) => {
			e.addBinding(this._params.custom, "url"), e.addBinding(this._params.custom, "geometryType", { options: {
				"3D": "3D",
				"2D": "2D"
			} });
		}, this._onTabChanged = (e) => {
			switch (e.index) {
				case 0:
					this._loadCallback = this._loadTwin;
					break;
				case 1:
					this._loadCallback = this._loadFile;
					break;
				case 2:
					this._loadCallback = this._importLocalFile;
					break;
				case 3: this._loadCallback = this._loadCustomUrl;
			}
		}, this._onTwinNameSelectorChanged = () => {
			this._updateTwinTypeSelector();
		}, this._onTwinTypeSelectorChanged = () => {
			this._updateTwinIdLabel();
		}, this._updateTwinNameSelector = () => {
			E(this._twinNameSelector), this._twinNameSelector.options = Array.from(this._availableTwins.Draft.keys()).map((e) => ({
				text: e,
				value: e
			})), this._twinNameSelector.refresh(), this._updateTwinTypeSelector();
		}, this._updateTwinTypeSelector = () => {
			E(this._twinTypeSelector);
			let e = this._availableTwins.Master.has(this._params.twin.name), t = [{
				text: "Draft",
				value: "Draft"
			}];
			e && t.push({
				text: "Master",
				value: "Master"
			}), this._twinTypeSelector.options = t, this._twinTypeSelector.refresh(), this._updateTwinIdLabel();
		}, this._updateTwinIdLabel = () => {
			let e = this._availableTwins[this._params.twin.type].get(this._params.twin.name);
			E(e), this._params.twin.id = e?.id, this._twinIdLabel?.refresh();
		}, this._updateProjectNameSelector = () => {
			E(this._projectNameSelector);
			let e = Array.from(new Set(Array.from(this._availableModels.values(), kl))).sort((e, t) => e.localeCompare(t));
			this._projectNameSelector.options = e.map((e) => ({
				text: e,
				value: e
			})), e.includes(this._params.file.projectName) || (this._params.file.projectName = e[0] ?? ""), this._projectNameSelector.refresh(), this._updateModelNameSelector();
		}, this._updateModelNameSelector = () => {
			E(this._modelNameSelector);
			let e = Array.from(this._availableModels).filter(([, e]) => kl(e) === this._params.file.projectName).map(([e]) => e);
			this._modelNameSelector.options = e.map((e) => ({
				text: e,
				value: e
			})), e.includes(this._params.file.name) || (this._params.file.name = e[0] ?? ""), this._modelNameSelector.refresh(), this._updateModelInfoLabels();
		}, this._updateModelInfoLabels = () => {
			let e = this._availableModels.get(this._params.file.name);
			if (e) {
				Object.assign(this._params.file, {
					modelId: e.id,
					version: e.currentVersion,
					projectId: e.projectId
				});
				for (let e of this._modelInfoLabels) e.refresh();
			}
		}, this._viewerLoadingUpdated = () => {
			E(this._viewer), E(this._loadButton), this._viewer.sceneLoader.isRunning ? this._loadButton.title = "Stop loading" : this._loadButton.title = "Load";
		}, this._onLoadButtonClick = () => {
			E(this._viewer), this._viewer.sceneLoader.isRunning ? this._stopLoading() : this._loadCallback();
		}, this._onFieldsTwin = () => {
			E(this._fieldSelectionRulesInput), this._fieldSelectionRulesInput.hidden = !this._params.twin.fields;
		}, this._onFilterTwin = () => {
			E(this._filterInput), this._filterInput.hidden = !this._params.twin.filter;
		}, this._loadFile = () => {
			E(this._viewer);
			let { projectId: e, modelId: t, version: n } = this._params.file;
			new Zc(this._viewer, {
				projectId: e,
				modelId: t,
				version: n
			}).execute();
		}, this._loadTwin = () => {
			E(this._viewer);
			let e = {
				condition: "Or",
				rules: []
			};
			if (this._params.twin.filter) {
				let t = this._params.twin.filter_types;
				if (t !== "") {
					let n = t.split(";");
					for (let t of n) e.rules.push({
						type: "Type",
						operator: "Contains",
						value: t
					});
				}
			}
			let t = [];
			if (this._params.twin.fields) {
				let e = this._params.twin.field_selection_rules;
				if (e !== "") {
					let n = e.split(";");
					for (let e of n) t.push(JSON.parse(e));
				}
			}
			let n = this._availableTwins[this._params.twin.type].get(this._params.twin.name);
			E(n);
			let r = [{
				type: "TwinProject",
				operator: "EqualTo",
				value: String(n.id)
			}];
			e.rules.length > 0 && r.unshift(e);
			let i = {
				condition: "And",
				rules: r
			};
			new sl(this._viewer, n, {
				filter: i,
				fieldSelectionRules: t,
				onlySetSource: this._params.twin.onlySetSource,
				geometryType: this._params.twin.geometryType,
				axis: this._params.twin.axis,
				endpoint: this._params.twin.endpoint
			}).execute();
		}, this._importLocalFile = () => {
			Dl.multiple = !0, Dl.type = "file", Dl.accept = ".gltf, .glb", Dl.onchange = () => {
				E(this._viewer);
				let e = Dl.files;
				e && (new ee(this._viewer, e, { geometryType: this._params.local.geometryType }).execute(), Dl.value = "");
			}, Dl.click();
		}, this._loadCustomUrl = () => {
			E(this._viewer), new qc(this._viewer, this._params.custom.url, { geometryType: this._params.custom.geometryType }).execute();
		}, this._stopLoading = () => {
			E(this._viewer), new ye(this._viewer).execute();
		}, this._updateAvailableSources = () => {
			this._getAvailableTwins().catch((e) => {
				d.warn("Failed to get the available twins", e);
			}), this._getAvailableModels().catch((e) => {
				d.warn("Failed to get the available models", e);
			});
		}, this._getAvailableTwins = async () => {
			E(this._viewer);
			let e = this._viewer.getPlugin("Teia").twinApiClient;
			if (e.token == "") return;
			let t = On(e), n = await lc((e, n) => t.getTwinProjectList(e, n), 1, 1e3);
			for (let e of n) e.type == "Draft" ? this._availableTwins.Draft.set(e.projectName, e) : e.type == "Master" && this._availableTwins.Master.set(e.projectName, e);
			this._updateTwinNameSelector();
		}, this._getAvailableModels = async () => {
			E(this._viewer);
			let e = this._viewer.getPlugin("Teia").twinApiClient;
			if (e.token == "") return;
			let t = Vc(e), n = await lc((e, n) => t.getModels(e, n), 1, 1e3);
			this._availableModels.clear();
			for (let e of n) this._availableModels.set(`${e.name ?? "Unnamed"} #${e.id}`, e);
			this._updateProjectNameSelector();
		}, this._loadCallback = this._loadTwin;
	}
	setup(e, t) {
		this._viewer = e, this._viewer.signals.onLoadingFinished.connect(this._viewerLoadingUpdated), this._viewer.signals.onLoadingStarted.connect(this._viewerLoadingUpdated), this._folder = t.addFolder({
			title: "Loading",
			index: 1
		});
		let n = this._folder.addTab({ pages: [
			{ title: "Twin" },
			{ title: "File" },
			{ title: "Local File" },
			{ title: "Custom" }
		] });
		n.on("select", this._onTabChanged), this._drawTwinTab(n.pages[0]), this._drawFileTab(n.pages[1]), this._drawLocalFileTab(n.pages[2]), this._drawCustomUrlTab(n.pages[3]), this._loadButton = this._folder.addButton({ title: "Load" }).on("click", this._onLoadButtonClick), this._viewer.getPlugin("Teia").settings.api.token.onChange.connect(this._updateAvailableSources), this._updateAvailableSources();
	}
	dispose() {
		E(this._viewer), this._folder?.dispose(), this._viewer.signals.onLoadingFinished.disconnect(this._viewerLoadingUpdated), this._viewer.signals.onLoadingStarted.disconnect(this._viewerLoadingUpdated), this._viewer.getPlugin("Teia").settings.api.token.onChange.disconnect(this._updateAvailableSources);
	}
	toJSON() {
		return { ...this._params };
	}
	fromJSON(e) {
		(0, El.merge)(this._params, e);
	}
};
function kl(e) {
	return e.projectName ?? `Project #${e.projectId}`;
}
//#endregion
//#region src/TeiaPlugin/operators/ObjectTransformOperator.ts
var Al = class extends oe {
	constructor(...e) {
		super(...e), this.name = "ObjectTransformOperator", this.isObjectTransformOperator = !0;
	}
};
//#endregion
//#region src/TeiaPlugin/filters.ts
function jl(e, t) {
	let n = e, r = t.operator;
	return !(n.isBimMesh && !r.isObjectTransformOperator);
}
//#endregion
//#region src/TeiaPlugin/TeiaPluginSettings.ts
var Ml = () => ({
	api: {
		twinApiUrl: new be("", { canReset: !1 }),
		tiaApiUrl: new be("", { canReset: !1 }),
		token: new be("", {
			saveToLocalStorage: !1,
			canReset: !1
		})
	},
	objectsPerRequest: new w(1e3, {
		min: 500,
		max: 2e3,
		step: 100
	}),
	objectCountWarningLimit: new w(2e5, {
		min: 1e4,
		max: 5e5
	})
}), Nl = class extends xe {
	constructor(e, t) {
		super(e, "Teia", Ml, t), this.signals = {
			onTokenUpdated: new T(),
			onSourceChanged: new T(),
			onSettingsMapSaved: new T()
		}, this.queryClient = new kt({ defaultOptions: { queries: {
			refetchOnWindowFocus: !1,
			refetchOnMount: !0,
			gcTime: 5e3,
			staleTime: 5e3,
			retry: 2
		} } }), this._currentSource = null, this._setupViewport = () => {
			this.viewer.viewport?.interactionController.addTransformFilter(jl);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.interactionController.removeTransformFilter(jl);
		}, this._onSceneClear = () => {
			this.currentSource = null;
		}, this._onTwinApiUrlChange = (e) => {
			this.twinObjectHierarchyCache.clear(), this.twinApiClient.baseUrl = e;
		}, this._onTiaApiUrlChange = (e) => {
			this.tiaApiClient.baseUrl = e;
		}, this._onApiTokenChange = (e) => {
			this.twinObjectHierarchyCache.clear(), this.twinApiClient.token = e, this.tiaApiClient.token = e, this.signals.onTokenUpdated.emit();
		}, this.twinApiClient = new Bc(this.settings.api.twinApiUrl.value, this.settings.api.token.value), this.twinObjectHierarchyCache = new $c(this.twinApiClient), this.tiaApiClient = new Bc(this.settings.api.tiaApiUrl.value, this.settings.api.token.value);
	}
	set currentSource(e) {
		let t = e === null && this.currentSource === null;
		e && this.currentSource && (e.sourceType === jn.Twin && this.currentSource.sourceType === jn.Twin ? t = e.id === this.currentSource.id : e.sourceType === jn.File && this.currentSource.sourceType === jn.File && (t = e.modelId === this.currentSource.modelId && e.version === this.currentSource.version)), t || (this._currentSource = e, this.signals.onSourceChanged.emit());
	}
	get currentSource() {
		return this._currentSource;
	}
	onRegister() {
		this.viewer.signals.onSceneClear.connect(this._onSceneClear), this.settings.api.tiaApiUrl.onChange.connect(this._onTiaApiUrlChange), this.settings.api.twinApiUrl.onChange.connect(this._onTwinApiUrlChange), this.settings.api.token.onChange.connect(this._onApiTokenChange), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this._setupViewport();
	}
	onUnregister() {
		this.viewer.signals.onSceneClear.disconnect(this._onSceneClear), this.settings.api.tiaApiUrl.onChange.disconnect(this._onTiaApiUrlChange), this.settings.api.twinApiUrl.onChange.disconnect(this._onTwinApiUrlChange), this.settings.api.token.onChange.disconnect(this._onApiTokenChange), this.twinObjectHierarchyCache.clear(), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this._unsetupViewport();
	}
	*getGuidForTeiaObjects(e) {
		for (let t of e) "guid" in t ? yield t.guid : yield t.twinObjectGuid;
	}
	*getSceneObjectForTeiaObjects(e) {
		let t = this.getGuidForTeiaObjects(e);
		yield* this.viewer.scene.getObjectsByUUID(t);
	}
	*getVisibleSceneObjectForTeiaObjects(e) {
		let t = this.getSceneObjectForTeiaObjects(e);
		for (let e of t) e.visible && (yield e);
	}
	*getVisibleGuidsForTeiaObjects(e) {
		let t = this.getVisibleSceneObjectForTeiaObjects(e);
		for (let e of t) yield e.uuid;
	}
}, Pl = class extends ie {
	constructor(e = [], t = !1, n) {
		super(e, t), this.filter = n, this.isTeiaObjectSelection = !0;
	}
}, Fl = /* @__PURE__ */ new A(1, 1, 1), Il = /* @__PURE__ */ new A(), Ll = /* @__PURE__ */ new nt(), Rl = /* @__PURE__ */ new O(), zl = /* @__PURE__ */ new k(), Bl = /* @__PURE__ */ new je(), Vl = /* @__PURE__ */ new Me(1, 1, 1), Hl = /* @__PURE__ */ new Be(Vl, 70), Ul = new _t(Vl, { useSharedArrayBuffer: !0 }), Wl = _t.serialize(Ul, { cloneBuffers: !1 }), Gl = /* @__PURE__ */ new lt(1, 12, 12), Kl = /* @__PURE__ */ new Be(Gl, 70), ql = new _t(Gl, { useSharedArrayBuffer: !0 }), Jl = _t.serialize(ql, { cloneBuffers: !1 }), Yl = { selected: !0 }, J = class extends e {
	constructor(e, t, n, r = Yl) {
		super(e, r), this._objectSelection = t, this._shape = n, this.name = "AddZoneCommand", this._currentZone = null, this._currentGeometries = /* @__PURE__ */ new Map(), this._currentEdgeGeometries = /* @__PURE__ */ new Map();
	}
	async _do() {
		return this._currentZone = await super._do(), this.viewer.viewport?.transformController.attachObjects([this._currentZone]), this._currentZone;
	}
	async _createObject() {
		let e = this.viewer.getPlugin("Zone"), { geometries: t, edgeGeometries: n, serializedBVHs: r } = Zl(this._shape, this._objectSelection);
		Xl(this.viewer, this._shape, this._objectSelection, Rl);
		let i = 0, a = [];
		for (let o of t) {
			let t = e.getBatchedMesh(o), s = e.getBatchedEdgeGeometry(o), c = t.addGeometry(o), l = s.addGeometry(n[i]), u = Y(o, n[i], e.settings.color.value, c, l, t.uuid, s.uuid, r[i]), d = this.viewer.scene.bimMeshController.createMeshProxy(u);
			d.setMatrix(Rl), this._currentGeometries.set(d.meshProxy, t), d.edgesProxy && this._currentEdgeGeometries.set(d.edgesProxy, s), a.push(d), i++;
		}
		let o = this.viewer.scene.bimMeshController.createMesh({
			isSerializedObject3D: !0,
			name: `zone-${this._shape}-id`,
			uuid: Ye.generateUUID(),
			parentUuid: null,
			userData: { type: "CustomTeiaZone" },
			isMeshGroup: !1,
			isInMeshGroup: !1
		});
		for (let e of a) this.viewer.scene.bimMeshController.addSubMesh(o, e, "3D");
		return o;
	}
	async _undo() {
		super._undo(), this.viewer.viewport?.resetDefaultOperator(), this.viewer.viewport?.transformController.detachObjects();
	}
	async _clean() {
		this._currentZone;
	}
};
function Xl(e, t, n, r) {
	let i = n.getLastObject();
	switch (t) {
		case "cube":
			n.length > 0 ? (n.getBoundingBox(Bl), Bl.getCenter(Il), Fl.set(1, 1, 1), Bl.getSize(Fl), r.compose(Il, Ll, Fl)) : (e.scene.getBoundingSphere(zl), Fl.set(1, 1, 1), r.compose(zl.center, Ll, Fl));
			break;
		case "sphere":
			n.length > 0 ? (n.getBoundingSphere(zl), Fl.set(zl.radius, zl.radius, zl.radius), r.compose(zl.center, Ll, Fl)) : (e.scene.getBoundingSphere(zl), Fl.set(1, 1, 1), r.compose(zl.center, Ll, Fl));
			break;
		default: i?.isBimMesh && i.getMatrix(r);
	}
}
function Zl(e, t) {
	let n = [], r = [], i = [], a = t.getLastObject();
	switch (e) {
		case "sphere":
			n.push(Gl), r.push(Kl), i.push(Jl);
			break;
		case "object":
			if (a?.isBimMesh) for (let e of a.meshes) {
				let t = e;
				if (t.isSceneMeshProxy && t.edgesProxy) {
					let e = new Ne();
					n.push(e), t.meshProxy.getDeepGeometry(e);
					let a = t.edgesProxy?.geometry;
					r.push(a);
					let o = new _t(e), s = _t.serialize(o, { cloneBuffers: !1 });
					i.push(s);
				}
			}
			break;
		default: n.push(Vl), r.push(Hl), i.push(Wl);
	}
	return {
		geometries: n,
		edgeGeometries: r,
		serializedBVHs: i
	};
}
function Y(e, t, n, r, i, a, o, s) {
	return {
		isSerializedBatchedMeshProxy: !0,
		isInMeshGroup: !1,
		mesh: {
			material: {
				transparent: !0,
				roughness: 1,
				color: new Ie(n),
				metalness: 0,
				emissive: 0,
				opacity: .4
			},
			srcGeometryUuid: e.uuid,
			proxyId: r,
			batchedGeometryUuid: a,
			serializedBVH: s
		},
		edges: {
			srcGeometryUuid: t.uuid,
			proxyId: i,
			batchedGeometryUuid: o
		}
	};
}
//#endregion
//#region src/ZonePlugin/operators/ZoneOperator.tsx
var Ql = class extends Al {
	constructor(e, t) {
		super(e), this._lastCommandInHistory = t, this.name = "ZoneOperator", this.isZoneOperator = !0, this.needsValidation = !0, this.validate = () => {
			new c(this._viewport.viewer).execute(), this._viewport.resetDefaultOperator(), this._viewport.transformController.detachObjects();
		};
	}
	cancel() {
		for (let e of Array.from(this._viewport.viewer.commandHistory.undoHistory).reverse()) if (e.undo({ addToRedoHistory: !1 }), e === this._lastCommandInHistory) break;
		this._viewport.viewer.commandHistory.clearRedoHistory(), this._viewport.resetDefaultOperator(), this._viewport.transformController.detachObjects();
	}
};
//#endregion
//#region src/ZonePlugin/contextMenu/ZonePluginContextMenuBuilder.tsx
function $l(e) {
	let { viewer: t, hitObject: n } = e, r = !1;
	for (let e of t.scene.bimMeshController.getAllObjects()) if (e.userData.type === "CustomTeiaZone") {
		r = !0;
		break;
	}
	if (t.viewport?.operator.name !== "ZoneOperator" && !r) return [];
	let i = {
		type: "group",
		text: "Zones",
		items: []
	};
	return n?.userData.type === "CustomTeiaZone" && i.items.push({
		type: "action",
		text: gt("teiaviewer:teia.context_menu.remove_zone.text"),
		action: () => {
			new f(t, n).execute();
		}
	}), i.items.push({
		type: "action",
		text: gt("teiaviewer:teia.context_menu.remove_all_zones.text"),
		action: () => {
			let e = [];
			for (let n of t.scene.bimMeshController.getAllObjects()) n.userData.type === "CustomTeiaZone" && e.push(new f(t, n));
			let n = new m(t, e);
			n.isUndoable = !0, n.execute();
		},
		disabled: !r
	}), [i];
}
//#endregion
//#region src/ZonePlugin/utils/ZoneFilters.ts
function eu(e, t) {
	return !t.operator.isZoneOperator || e.userData.type === "CustomTeiaZone";
}
var tu = { TransformZoneFilter: eu }, nu = xe.Create("ZonePlugin", () => ({ color: new l("#ff0000") })), ru = class extends nu {
	constructor(...e) {
		super(...e), this._zoneGeometries = [], this._zoneEdgeGeometries = [], this.getBatchedMesh = (e) => {
			let n;
			for (let t of this._zoneGeometries) if (t.canInsertGeometry(e)) {
				n = t;
				break;
			}
			if (!n) {
				let r = 1e5, i = 1e5;
				e.attributes.position.count > r && (r = e.attributes.position.count), e.index && e.index.count > i && (i = e.index.count), n = new t({
					useIndex: !0,
					useNormals: !0,
					maxGeometryCount: 1e4,
					maxIndexCount: i,
					maxVertexCount: r
				}), this._zoneGeometries.push(n), this.viewer.scene.bimMeshController.addBatchedMeshContainer(n);
			}
			return n;
		}, this.getBatchedEdgeGeometry = (e) => {
			let t;
			for (let n of this._zoneEdgeGeometries) if (n.canInsertGeometry(e)) {
				t = n;
				break;
			}
			if (!t) {
				let n = 1e5;
				e.attributes.position.count > n && (n = e.attributes.position.count), t = new r({
					useIndex: !1,
					useNormals: !1,
					maxGeometryCount: 1e4,
					maxVertexCount: n
				}), this.viewer.scene.bimMeshController.addBatchedEdgesContainer(t), this._zoneEdgeGeometries.push(t);
			}
			return t;
		}, this._setupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.add($l), this.viewer.viewport?.interactionController.addTransformFilter(tu.TransformZoneFilter);
		}, this._unsetupViewport = () => {
			this.viewer.viewport?.contextMenuController.builders.delete($l), this.viewer.viewport?.interactionController.removeTransformFilter(tu.TransformZoneFilter);
		}, this._onSceneClear = () => {
			this._zoneGeometries.clear(), this._zoneEdgeGeometries.clear();
		};
	}
	dependencies() {
		return ["Teia"];
	}
	onRegister() {
		this.viewer.signals.onSceneClear.connect(this._onSceneClear), this.viewer.signals.onViewportAdded.connect(this._setupViewport), this._setupViewport();
	}
	onUnregister() {
		this.viewer.signals.onSceneClear.disconnect(this._onSceneClear), this.viewer.signals.onViewportAdded.disconnect(this._setupViewport), this._unsetupViewport();
	}
};
//#endregion
export { ki as AddFloodFillSeedCommand, Zt as AddFloorPlanCommand, Oi as AddGuidePathCommand, ur as AddMeasureLineAnchorCommand, dr as AddMeasureLineCommand, Mi as AddNavigationEdgeCommand, hc as AddProjectionCommand, Ni as AddSequentialNavigationNodeCommand, J as AddZoneCommand, Lt as AnnotationPositionList, Bc as ApiClient, _r as CONE_HEIGHT, Pi as CalculateNavigationRouteCommand, Fi as ClearNavigationRoutePointsCommand, Ii as CreateNavigationGraphCommand, la as DEFAULT_GUIDE_PATH_OPTIONS, hr as DEFAULT_MEASURELINE_COLOR, mr as DEFAULT_SELECTED_COLOR, No as DefaultFloodFillOptions, Eo as DefaultNavigationMeshOptions, gs as DefaultVoxelizationOptions, Li as DeleteConnectedNavigationGraphCommand, Ai as DeleteFloodFillSeedCommand, fr as DeleteMeasureLineCommand, Ri as DeleteNavigationEdgeCommand, zi as DeleteNavigationGraphCommand, Bi as DeleteNavigationNodeCommand, Vi as DeleteNavigationRoutePointCommand, yl as Environment, Vo as FloodFillController, q as FloodFillSeedOperator, jo as FloodFillSeedSceneObject, Pt as FloorPlanExportFormats, It as FloorPlanExportStatus, Mt as FloorPlanLineType, Dn as FloorPlanPlugin, Nt as FloorPlanTransparentFillColor, oa as GenerateNavigationGraphCommand, ca as GuidePath, gr as HOVER_MEASURELINE_COLOR, An as InitMapCommand, qc as LoadCustomUrlCommand, Zc as LoadFileCommand, sl as LoadTwinCommand, Ia as MERGE_PROJECTION_DISTANCE, Wn as MapContainer, er as MapPlugin, Vn as MapShape, Hn as MapType, wr as MeasureLine, Rr as MeasureLineAnchor, Hr as MeasureLineAnchorLine, li as MeasureLineController, hi as MeasureLineFilters, ti as MeasureLineGlobalSprite, _i as MeasureLinePlugin, vi as MeasureLineRaycastSelectOperator, Qr as MeasureLineSprite, Di as MeasureLinesOperator, Hi as MergeNavigationNodesCommand, Vc as ModelApi, Ui as MoveNavigationNodeCommand, ss as NAVIGATION_ROUTE_END_COLOR, os as NAVIGATION_ROUTE_START_COLOR, ro as NAVIGATION_TOOL_HEIGHT_OFFSET, Yi as NavigationGraph, Ua as NavigationGraphController, na as NavigationGraphGenerationController, Oo as NavigationGraphOperator, vo as NavigationGraphSceneController, Ea as NavigationGraphSceneObject, La as NavigationGraphValidator, rs as NavigationRoutingController, Ao as NavigationRoutingOperator, ds as NavigationRoutingSceneController, ba as NavigationRoutingSceneObject, Al as ObjectTransformOperator, ya as PathController, cc as PathPlugin, Ft as PlanStatusList, pc as ProjectionExportFormats, dc as ProjectionLineType, zc as ProjectionPlugin, fc as ProjectionStatusList, Wi as ReverseNavigationEdgeCommand, Gi as RevertNavigationGraphCommand, vr as SPRITE_DEFAULT_COLOR, br as SPRITE_GREEN_COLOR, Wr as SPRITE_HEIGHT, B as SPRITE_HOVER_COLOR, yr as SPRITE_RED_COLOR, Ur as SPRITE_WIDTH, tr as SaveInfoMapCommand, Qt as SceneFloorPlan, gc as SceneProjection, jt as SearchApi, nr as SetMapCenterCommand, ir as SetMapElevationCommand, ar as SetMapOpacityCommand, or as SetMapRotationCommand, sr as SetMapShapeCommand, cr as SetMapSizeCommand, lr as SetMapTypeCommand, Jn as SetMapVisibilityCommand, Ki as SetNavigationEdgeDirectionCommand, qi as SetNavigationElementAccessibilityCommand, sa as SetNavigationRoutePointCommand, Nn as SetupInitialMapCenterCommand, Yn as ShowMapShortcut, V as SpriteType, xl as TeiaAuthController, Tl as TeiaAuthDeveloperTool, Kc as TeiaLoadCommand, Pl as TeiaObjectSelection, Nl as TeiaPlugin, Ml as TeiaPluginSettingsCtor, Ol as TeiaRequestDeveloperTool, il as TeiaSearchConditionList, rl as TeiaSearchGroupOperatorList, al as TeiaSearchOperatorList, jn as TeiaSourceType, Hc as TiaSearchFilterApi, Gc as TwinDocDataApi, Rt as TwinFloorPlanApi, Bt as TwinObjectApi, zt as TwinObjectDataFamilyList, On as TwinProjectApi, mc as TwinProjectionApi, nc as VoxelDebugController, bs as VoxelGrid, hs as VoxelState, Us as VoxelizationController, Ql as ZoneOperator, ru as ZonePlugin, Is as alignBounds, uc as applyFuncToAllPages, Ho as areFloodFillOptionsEqual, ma as buildPointMaterials, fa as buildRoundedPathPoints, ra as createNavigationGraph, Ci as defaultSort, Ba as deserializeNavigationGraph, lc as fetchAllPages, Wo as findNavigationRoute, Mo as isFloodFillSeedObject, Da as isNavigationGraphObject, xa as isNavigationRoutingObject, ol as mergeTeiaSearchFilters, K as resolveGuidePathOptions, za as serializeNavigationGraph, $o as shareConnectedComponent, Qo as simplifyNavigationRoute, pa as validateGuidePathPoints, Fs as validateVoxelizationOptions };

//# sourceMappingURL=exports.js.map